import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react/types/types';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/client/react/components';
import * as ApolloReactHoc from '@apollo/client/react/hoc';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  jsonb: any;
  timestamp: any;
  timestamptz: any;
  tsvector: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "accounts" */
export type Accounts = {
  __typename?: 'accounts';
  /** An array relationship */
  addresses: Array<Addresses>;
  /** An aggregate relationship */
  addresses_aggregate: Addresses_Aggregate;
  created_at: Scalars['timestamptz'];
  display_name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  email_verified: Scalars['Boolean'];
  id: Scalars['uuid'];
  password: Scalars['String'];
  phone_number?: Maybe<Scalars['String']>;
  /** An object relationship */
  primary_address?: Maybe<Addresses>;
  primary_address_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate;
  role: Roles_Enum;
  stripe_customer_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "accounts" */
export type AccountsAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsRefresh_TokensArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
};


/** columns and relationships of "accounts" */
export type AccountsRefresh_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
};

/** aggregated selection of "accounts" */
export type Accounts_Aggregate = {
  __typename?: 'accounts_aggregate';
  aggregate?: Maybe<Accounts_Aggregate_Fields>;
  nodes: Array<Accounts>;
};

/** aggregate fields of "accounts" */
export type Accounts_Aggregate_Fields = {
  __typename?: 'accounts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Accounts_Max_Fields>;
  min?: Maybe<Accounts_Min_Fields>;
};


/** aggregate fields of "accounts" */
export type Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accounts" */
export type Accounts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Accounts_Max_Order_By>;
  min?: InputMaybe<Accounts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "accounts" */
export type Accounts_Arr_Rel_Insert_Input = {
  data: Array<Accounts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "accounts". All fields are combined with a logical 'AND'. */
export type Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Bool_Exp>>;
  addresses?: InputMaybe<Addresses_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  email_verified?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  primary_address?: InputMaybe<Addresses_Bool_Exp>;
  primary_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  refresh_tokens?: InputMaybe<Refresh_Tokens_Bool_Exp>;
  role?: InputMaybe<Roles_Enum_Comparison_Exp>;
  stripe_customer_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounts" */
export enum Accounts_Constraint {
  /** unique or primary key constraint */
  AccountsEmailKey = 'accounts_email_key',
  /** unique or primary key constraint */
  AccountsIdKey = 'accounts_id_key',
  /** unique or primary key constraint */
  AccountsPkey = 'accounts_pkey'
}

/** input type for inserting data into table "accounts" */
export type Accounts_Insert_Input = {
  addresses?: InputMaybe<Addresses_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  password?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  primary_address?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  primary_address_id?: InputMaybe<Scalars['uuid']>;
  refresh_tokens?: InputMaybe<Refresh_Tokens_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Roles_Enum>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Accounts_Max_Fields = {
  __typename?: 'accounts_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  primary_address_id?: Maybe<Scalars['uuid']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "accounts" */
export type Accounts_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  primary_address_id?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Accounts_Min_Fields = {
  __typename?: 'accounts_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  primary_address_id?: Maybe<Scalars['uuid']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "accounts" */
export type Accounts_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  primary_address_id?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "accounts" */
export type Accounts_Mutation_Response = {
  __typename?: 'accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts>;
};

/** input type for inserting object relation for remote table "accounts" */
export type Accounts_Obj_Rel_Insert_Input = {
  data: Accounts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_On_Conflict>;
};

/** on_conflict condition type for table "accounts" */
export type Accounts_On_Conflict = {
  constraint: Accounts_Constraint;
  update_columns?: Array<Accounts_Update_Column>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts". */
export type Accounts_Order_By = {
  addresses_aggregate?: InputMaybe<Addresses_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_verified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  primary_address?: InputMaybe<Addresses_Order_By>;
  primary_address_id?: InputMaybe<Order_By>;
  refresh_tokens_aggregate?: InputMaybe<Refresh_Tokens_Aggregate_Order_By>;
  role?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounts */
export type Accounts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "accounts" */
export enum Accounts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Id = 'id',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PrimaryAddressId = 'primary_address_id',
  /** column name */
  Role = 'role',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "accounts" */
export type Accounts_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  password?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  primary_address_id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Roles_Enum>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "accounts" */
export enum Accounts_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Id = 'id',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PrimaryAddressId = 'primary_address_id',
  /** column name */
  Role = 'role',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "addresses" */
export type Addresses = {
  __typename?: 'addresses';
  /** An object relationship */
  account?: Maybe<Accounts>;
  account_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  accounts: Array<Accounts>;
  /** An aggregate relationship */
  accounts_aggregate: Accounts_Aggregate;
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  contact_email: Scalars['String'];
  /** depracated */
  contact_number?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  country?: Maybe<Countries>;
  country_code?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  line_1?: Maybe<Scalars['String']>;
  line_2?: Maybe<Scalars['String']>;
  line_3?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  phone_number?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};


/** columns and relationships of "addresses" */
export type AddressesAccountsArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


/** columns and relationships of "addresses" */
export type AddressesAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


/** columns and relationships of "addresses" */
export type AddressesOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "addresses" */
export type AddressesOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};

/** aggregated selection of "addresses" */
export type Addresses_Aggregate = {
  __typename?: 'addresses_aggregate';
  aggregate?: Maybe<Addresses_Aggregate_Fields>;
  nodes: Array<Addresses>;
};

/** aggregate fields of "addresses" */
export type Addresses_Aggregate_Fields = {
  __typename?: 'addresses_aggregate_fields';
  avg?: Maybe<Addresses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Addresses_Max_Fields>;
  min?: Maybe<Addresses_Min_Fields>;
  stddev?: Maybe<Addresses_Stddev_Fields>;
  stddev_pop?: Maybe<Addresses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Addresses_Stddev_Samp_Fields>;
  sum?: Maybe<Addresses_Sum_Fields>;
  var_pop?: Maybe<Addresses_Var_Pop_Fields>;
  var_samp?: Maybe<Addresses_Var_Samp_Fields>;
  variance?: Maybe<Addresses_Variance_Fields>;
};


/** aggregate fields of "addresses" */
export type Addresses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Addresses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "addresses" */
export type Addresses_Aggregate_Order_By = {
  avg?: InputMaybe<Addresses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Addresses_Max_Order_By>;
  min?: InputMaybe<Addresses_Min_Order_By>;
  stddev?: InputMaybe<Addresses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Addresses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Addresses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Addresses_Sum_Order_By>;
  var_pop?: InputMaybe<Addresses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Addresses_Var_Samp_Order_By>;
  variance?: InputMaybe<Addresses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "addresses" */
export type Addresses_Arr_Rel_Insert_Input = {
  data: Array<Addresses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Addresses_On_Conflict>;
};

/** aggregate avg on columns */
export type Addresses_Avg_Fields = {
  __typename?: 'addresses_avg_fields';
  /** depracated */
  contact_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "addresses" */
export type Addresses_Avg_Order_By = {
  /** depracated */
  contact_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Addresses_Bool_Exp>>;
  _not?: InputMaybe<Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Addresses_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  accounts?: InputMaybe<Accounts_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_number?: InputMaybe<Bigint_Comparison_Exp>;
  country?: InputMaybe<Countries_Bool_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  line_1?: InputMaybe<String_Comparison_Exp>;
  line_2?: InputMaybe<String_Comparison_Exp>;
  line_3?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  orders?: InputMaybe<Orders_Bool_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "addresses" */
export enum Addresses_Constraint {
  /** unique or primary key constraint */
  AddressesPkey = 'addresses_pkey'
}

/** input type for incrementing numeric columns in table "addresses" */
export type Addresses_Inc_Input = {
  /** depracated */
  contact_number?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "addresses" */
export type Addresses_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']>;
  accounts?: InputMaybe<Accounts_Arr_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  /** depracated */
  contact_number?: InputMaybe<Scalars['bigint']>;
  country?: InputMaybe<Countries_Obj_Rel_Insert_Input>;
  country_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  line_1?: InputMaybe<Scalars['String']>;
  line_2?: InputMaybe<Scalars['String']>;
  line_3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<Orders_Arr_Rel_Insert_Input>;
  phone_number?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Addresses_Max_Fields = {
  __typename?: 'addresses_max_fields';
  account_id?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  /** depracated */
  contact_number?: Maybe<Scalars['bigint']>;
  country_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  line_1?: Maybe<Scalars['String']>;
  line_2?: Maybe<Scalars['String']>;
  line_3?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "addresses" */
export type Addresses_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  /** depracated */
  contact_number?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_1?: InputMaybe<Order_By>;
  line_2?: InputMaybe<Order_By>;
  line_3?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Addresses_Min_Fields = {
  __typename?: 'addresses_min_fields';
  account_id?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  /** depracated */
  contact_number?: Maybe<Scalars['bigint']>;
  country_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  line_1?: Maybe<Scalars['String']>;
  line_2?: Maybe<Scalars['String']>;
  line_3?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "addresses" */
export type Addresses_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  /** depracated */
  contact_number?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_1?: InputMaybe<Order_By>;
  line_2?: InputMaybe<Order_By>;
  line_3?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "addresses" */
export type Addresses_Mutation_Response = {
  __typename?: 'addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Addresses>;
};

/** input type for inserting object relation for remote table "addresses" */
export type Addresses_Obj_Rel_Insert_Input = {
  data: Addresses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Addresses_On_Conflict>;
};

/** on_conflict condition type for table "addresses" */
export type Addresses_On_Conflict = {
  constraint: Addresses_Constraint;
  update_columns?: Array<Addresses_Update_Column>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "addresses". */
export type Addresses_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  accounts_aggregate?: InputMaybe<Accounts_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_number?: InputMaybe<Order_By>;
  country?: InputMaybe<Countries_Order_By>;
  country_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_1?: InputMaybe<Order_By>;
  line_2?: InputMaybe<Order_By>;
  line_3?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  phone_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
};

/** primary key columns input for table: addresses */
export type Addresses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "addresses" */
export enum Addresses_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  City = 'city',
  /** column name */
  Code = 'code',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactNumber = 'contact_number',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Id = 'id',
  /** column name */
  Line_1 = 'line_1',
  /** column name */
  Line_2 = 'line_2',
  /** column name */
  Line_3 = 'line_3',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Region = 'region'
}

/** input type for updating data in table "addresses" */
export type Addresses_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  /** depracated */
  contact_number?: InputMaybe<Scalars['bigint']>;
  country_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  line_1?: InputMaybe<Scalars['String']>;
  line_2?: InputMaybe<Scalars['String']>;
  line_3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Addresses_Stddev_Fields = {
  __typename?: 'addresses_stddev_fields';
  /** depracated */
  contact_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "addresses" */
export type Addresses_Stddev_Order_By = {
  /** depracated */
  contact_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Addresses_Stddev_Pop_Fields = {
  __typename?: 'addresses_stddev_pop_fields';
  /** depracated */
  contact_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "addresses" */
export type Addresses_Stddev_Pop_Order_By = {
  /** depracated */
  contact_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Addresses_Stddev_Samp_Fields = {
  __typename?: 'addresses_stddev_samp_fields';
  /** depracated */
  contact_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "addresses" */
export type Addresses_Stddev_Samp_Order_By = {
  /** depracated */
  contact_number?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Addresses_Sum_Fields = {
  __typename?: 'addresses_sum_fields';
  /** depracated */
  contact_number?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "addresses" */
export type Addresses_Sum_Order_By = {
  /** depracated */
  contact_number?: InputMaybe<Order_By>;
};

/** update columns of table "addresses" */
export enum Addresses_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  City = 'city',
  /** column name */
  Code = 'code',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactNumber = 'contact_number',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Id = 'id',
  /** column name */
  Line_1 = 'line_1',
  /** column name */
  Line_2 = 'line_2',
  /** column name */
  Line_3 = 'line_3',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Region = 'region'
}

/** aggregate var_pop on columns */
export type Addresses_Var_Pop_Fields = {
  __typename?: 'addresses_var_pop_fields';
  /** depracated */
  contact_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "addresses" */
export type Addresses_Var_Pop_Order_By = {
  /** depracated */
  contact_number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Addresses_Var_Samp_Fields = {
  __typename?: 'addresses_var_samp_fields';
  /** depracated */
  contact_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "addresses" */
export type Addresses_Var_Samp_Order_By = {
  /** depracated */
  contact_number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Addresses_Variance_Fields = {
  __typename?: 'addresses_variance_fields';
  /** depracated */
  contact_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "addresses" */
export type Addresses_Variance_Order_By = {
  /** depracated */
  contact_number?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "book_discount" */
export type Book_Discount = {
  __typename?: 'book_discount';
  /** An object relationship */
  book: Books;
  book_isbn: Scalars['bigint'];
  /** An object relationship */
  discount: Discounts;
  discount_id: Scalars['String'];
};

/** aggregated selection of "book_discount" */
export type Book_Discount_Aggregate = {
  __typename?: 'book_discount_aggregate';
  aggregate?: Maybe<Book_Discount_Aggregate_Fields>;
  nodes: Array<Book_Discount>;
};

/** aggregate fields of "book_discount" */
export type Book_Discount_Aggregate_Fields = {
  __typename?: 'book_discount_aggregate_fields';
  avg?: Maybe<Book_Discount_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Book_Discount_Max_Fields>;
  min?: Maybe<Book_Discount_Min_Fields>;
  stddev?: Maybe<Book_Discount_Stddev_Fields>;
  stddev_pop?: Maybe<Book_Discount_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Book_Discount_Stddev_Samp_Fields>;
  sum?: Maybe<Book_Discount_Sum_Fields>;
  var_pop?: Maybe<Book_Discount_Var_Pop_Fields>;
  var_samp?: Maybe<Book_Discount_Var_Samp_Fields>;
  variance?: Maybe<Book_Discount_Variance_Fields>;
};


/** aggregate fields of "book_discount" */
export type Book_Discount_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Book_Discount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "book_discount" */
export type Book_Discount_Aggregate_Order_By = {
  avg?: InputMaybe<Book_Discount_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Book_Discount_Max_Order_By>;
  min?: InputMaybe<Book_Discount_Min_Order_By>;
  stddev?: InputMaybe<Book_Discount_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Book_Discount_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Book_Discount_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Book_Discount_Sum_Order_By>;
  var_pop?: InputMaybe<Book_Discount_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Book_Discount_Var_Samp_Order_By>;
  variance?: InputMaybe<Book_Discount_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "book_discount" */
export type Book_Discount_Arr_Rel_Insert_Input = {
  data: Array<Book_Discount_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Book_Discount_On_Conflict>;
};

/** aggregate avg on columns */
export type Book_Discount_Avg_Fields = {
  __typename?: 'book_discount_avg_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "book_discount" */
export type Book_Discount_Avg_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "book_discount". All fields are combined with a logical 'AND'. */
export type Book_Discount_Bool_Exp = {
  _and?: InputMaybe<Array<Book_Discount_Bool_Exp>>;
  _not?: InputMaybe<Book_Discount_Bool_Exp>;
  _or?: InputMaybe<Array<Book_Discount_Bool_Exp>>;
  book?: InputMaybe<Books_Bool_Exp>;
  book_isbn?: InputMaybe<Bigint_Comparison_Exp>;
  discount?: InputMaybe<Discounts_Bool_Exp>;
  discount_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "book_discount" */
export enum Book_Discount_Constraint {
  /** unique or primary key constraint */
  BookDiscountPkey = 'book_discount_pkey'
}

/** input type for incrementing numeric columns in table "book_discount" */
export type Book_Discount_Inc_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "book_discount" */
export type Book_Discount_Insert_Input = {
  book?: InputMaybe<Books_Obj_Rel_Insert_Input>;
  book_isbn?: InputMaybe<Scalars['bigint']>;
  discount?: InputMaybe<Discounts_Obj_Rel_Insert_Input>;
  discount_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Book_Discount_Max_Fields = {
  __typename?: 'book_discount_max_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  discount_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "book_discount" */
export type Book_Discount_Max_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Book_Discount_Min_Fields = {
  __typename?: 'book_discount_min_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  discount_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "book_discount" */
export type Book_Discount_Min_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "book_discount" */
export type Book_Discount_Mutation_Response = {
  __typename?: 'book_discount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Book_Discount>;
};

/** on_conflict condition type for table "book_discount" */
export type Book_Discount_On_Conflict = {
  constraint: Book_Discount_Constraint;
  update_columns?: Array<Book_Discount_Update_Column>;
  where?: InputMaybe<Book_Discount_Bool_Exp>;
};

/** Ordering options when selecting data from "book_discount". */
export type Book_Discount_Order_By = {
  book?: InputMaybe<Books_Order_By>;
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Discounts_Order_By>;
  discount_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: book_discount */
export type Book_Discount_Pk_Columns_Input = {
  book_isbn: Scalars['bigint'];
  discount_id: Scalars['String'];
};

/** select columns of table "book_discount" */
export enum Book_Discount_Select_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  DiscountId = 'discount_id'
}

/** input type for updating data in table "book_discount" */
export type Book_Discount_Set_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  discount_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Book_Discount_Stddev_Fields = {
  __typename?: 'book_discount_stddev_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "book_discount" */
export type Book_Discount_Stddev_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Book_Discount_Stddev_Pop_Fields = {
  __typename?: 'book_discount_stddev_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "book_discount" */
export type Book_Discount_Stddev_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Book_Discount_Stddev_Samp_Fields = {
  __typename?: 'book_discount_stddev_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "book_discount" */
export type Book_Discount_Stddev_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Book_Discount_Sum_Fields = {
  __typename?: 'book_discount_sum_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "book_discount" */
export type Book_Discount_Sum_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** update columns of table "book_discount" */
export enum Book_Discount_Update_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  DiscountId = 'discount_id'
}

/** aggregate var_pop on columns */
export type Book_Discount_Var_Pop_Fields = {
  __typename?: 'book_discount_var_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "book_discount" */
export type Book_Discount_Var_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Book_Discount_Var_Samp_Fields = {
  __typename?: 'book_discount_var_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "book_discount" */
export type Book_Discount_Var_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Book_Discount_Variance_Fields = {
  __typename?: 'book_discount_variance_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "book_discount" */
export type Book_Discount_Variance_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** columns and relationships of "books" */
export type Books = {
  __typename?: 'books';
  attributes?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  /** An array relationship */
  category_books: Array<Category_Book>;
  /** An aggregate relationship */
  category_books_aggregate: Category_Book_Aggregate;
  /** An array relationship */
  children_category_books: Array<Children_Category_Books>;
  /** An aggregate relationship */
  children_category_books_aggregate: Children_Category_Books_Aggregate;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  discount_value?: Maybe<Scalars['Int']>;
  /** An array relationship */
  event_books: Array<Event_Book>;
  /** An aggregate relationship */
  event_books_aggregate: Event_Book_Aggregate;
  image?: Maybe<Scalars['String']>;
  is_discounted: Scalars['Boolean'];
  is_unlisted: Scalars['Boolean'];
  isbn: Scalars['bigint'];
  /** An array relationship */
  order_books: Array<Order_Book>;
  /** An aggregate relationship */
  order_books_aggregate: Order_Book_Aggregate;
  /** An array relationship */
  post_books: Array<Post_Book>;
  /** An aggregate relationship */
  post_books_aggregate: Post_Book_Aggregate;
  price?: Maybe<Scalars['Int']>;
  stock?: Maybe<Scalars['Int']>;
  /** An array relationship */
  tag_books: Array<Tag_Book>;
  /** An aggregate relationship */
  tag_books_aggregate: Tag_Book_Aggregate;
  title: Scalars['String'];
  track_stock: Scalars['Boolean'];
  ts_vector?: Maybe<Scalars['tsvector']>;
};


/** columns and relationships of "books" */
export type BooksCategory_BooksArgs = {
  distinct_on?: InputMaybe<Array<Category_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Book_Order_By>>;
  where?: InputMaybe<Category_Book_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksCategory_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Book_Order_By>>;
  where?: InputMaybe<Category_Book_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksChildren_Category_BooksArgs = {
  distinct_on?: InputMaybe<Array<Children_Category_Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Children_Category_Books_Order_By>>;
  where?: InputMaybe<Children_Category_Books_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksChildren_Category_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Children_Category_Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Children_Category_Books_Order_By>>;
  where?: InputMaybe<Children_Category_Books_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksEvent_BooksArgs = {
  distinct_on?: InputMaybe<Array<Event_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Book_Order_By>>;
  where?: InputMaybe<Event_Book_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksEvent_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Book_Order_By>>;
  where?: InputMaybe<Event_Book_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksOrder_BooksArgs = {
  distinct_on?: InputMaybe<Array<Order_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Book_Order_By>>;
  where?: InputMaybe<Order_Book_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksOrder_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Book_Order_By>>;
  where?: InputMaybe<Order_Book_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksPost_BooksArgs = {
  distinct_on?: InputMaybe<Array<Post_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Book_Order_By>>;
  where?: InputMaybe<Post_Book_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksPost_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Post_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Book_Order_By>>;
  where?: InputMaybe<Post_Book_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksTag_BooksArgs = {
  distinct_on?: InputMaybe<Array<Tag_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Book_Order_By>>;
  where?: InputMaybe<Tag_Book_Bool_Exp>;
};


/** columns and relationships of "books" */
export type BooksTag_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Book_Order_By>>;
  where?: InputMaybe<Tag_Book_Bool_Exp>;
};

/** aggregated selection of "books" */
export type Books_Aggregate = {
  __typename?: 'books_aggregate';
  aggregate?: Maybe<Books_Aggregate_Fields>;
  nodes: Array<Books>;
};

/** aggregate fields of "books" */
export type Books_Aggregate_Fields = {
  __typename?: 'books_aggregate_fields';
  avg?: Maybe<Books_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Books_Max_Fields>;
  min?: Maybe<Books_Min_Fields>;
  stddev?: Maybe<Books_Stddev_Fields>;
  stddev_pop?: Maybe<Books_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Books_Stddev_Samp_Fields>;
  sum?: Maybe<Books_Sum_Fields>;
  var_pop?: Maybe<Books_Var_Pop_Fields>;
  var_samp?: Maybe<Books_Var_Samp_Fields>;
  variance?: Maybe<Books_Variance_Fields>;
};


/** aggregate fields of "books" */
export type Books_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Books_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Books_Avg_Fields = {
  __typename?: 'books_avg_fields';
  discount_value?: Maybe<Scalars['Float']>;
  isbn?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "books". All fields are combined with a logical 'AND'. */
export type Books_Bool_Exp = {
  _and?: InputMaybe<Array<Books_Bool_Exp>>;
  _not?: InputMaybe<Books_Bool_Exp>;
  _or?: InputMaybe<Array<Books_Bool_Exp>>;
  attributes?: InputMaybe<String_Comparison_Exp>;
  author?: InputMaybe<String_Comparison_Exp>;
  category_books?: InputMaybe<Category_Book_Bool_Exp>;
  children_category_books?: InputMaybe<Children_Category_Books_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discount_value?: InputMaybe<Int_Comparison_Exp>;
  event_books?: InputMaybe<Event_Book_Bool_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  is_discounted?: InputMaybe<Boolean_Comparison_Exp>;
  is_unlisted?: InputMaybe<Boolean_Comparison_Exp>;
  isbn?: InputMaybe<Bigint_Comparison_Exp>;
  order_books?: InputMaybe<Order_Book_Bool_Exp>;
  post_books?: InputMaybe<Post_Book_Bool_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  stock?: InputMaybe<Int_Comparison_Exp>;
  tag_books?: InputMaybe<Tag_Book_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  track_stock?: InputMaybe<Boolean_Comparison_Exp>;
  ts_vector?: InputMaybe<Tsvector_Comparison_Exp>;
};

/** unique or primary key constraints on table "books" */
export enum Books_Constraint {
  /** unique or primary key constraint */
  BooksPkey = 'books_pkey',
  /** unique or primary key constraint */
  ProductsIsbnKey = 'products_isbn_key'
}

/** input type for incrementing numeric columns in table "books" */
export type Books_Inc_Input = {
  discount_value?: InputMaybe<Scalars['Int']>;
  isbn?: InputMaybe<Scalars['bigint']>;
  price?: InputMaybe<Scalars['Int']>;
  stock?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "books" */
export type Books_Insert_Input = {
  attributes?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Scalars['String']>;
  category_books?: InputMaybe<Category_Book_Arr_Rel_Insert_Input>;
  children_category_books?: InputMaybe<Children_Category_Books_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discount_value?: InputMaybe<Scalars['Int']>;
  event_books?: InputMaybe<Event_Book_Arr_Rel_Insert_Input>;
  image?: InputMaybe<Scalars['String']>;
  is_discounted?: InputMaybe<Scalars['Boolean']>;
  is_unlisted?: InputMaybe<Scalars['Boolean']>;
  isbn?: InputMaybe<Scalars['bigint']>;
  order_books?: InputMaybe<Order_Book_Arr_Rel_Insert_Input>;
  post_books?: InputMaybe<Post_Book_Arr_Rel_Insert_Input>;
  price?: InputMaybe<Scalars['Int']>;
  stock?: InputMaybe<Scalars['Int']>;
  tag_books?: InputMaybe<Tag_Book_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  track_stock?: InputMaybe<Scalars['Boolean']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
};

/** aggregate max on columns */
export type Books_Max_Fields = {
  __typename?: 'books_max_fields';
  attributes?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  discount_value?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['bigint']>;
  price?: Maybe<Scalars['Int']>;
  stock?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Books_Min_Fields = {
  __typename?: 'books_min_fields';
  attributes?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  discount_value?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['bigint']>;
  price?: Maybe<Scalars['Int']>;
  stock?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "books" */
export type Books_Mutation_Response = {
  __typename?: 'books_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Books>;
};

/** input type for inserting object relation for remote table "books" */
export type Books_Obj_Rel_Insert_Input = {
  data: Books_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Books_On_Conflict>;
};

/** on_conflict condition type for table "books" */
export type Books_On_Conflict = {
  constraint: Books_Constraint;
  update_columns?: Array<Books_Update_Column>;
  where?: InputMaybe<Books_Bool_Exp>;
};

/** Ordering options when selecting data from "books". */
export type Books_Order_By = {
  attributes?: InputMaybe<Order_By>;
  author?: InputMaybe<Order_By>;
  category_books_aggregate?: InputMaybe<Category_Book_Aggregate_Order_By>;
  children_category_books_aggregate?: InputMaybe<Children_Category_Books_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_value?: InputMaybe<Order_By>;
  event_books_aggregate?: InputMaybe<Event_Book_Aggregate_Order_By>;
  image?: InputMaybe<Order_By>;
  is_discounted?: InputMaybe<Order_By>;
  is_unlisted?: InputMaybe<Order_By>;
  isbn?: InputMaybe<Order_By>;
  order_books_aggregate?: InputMaybe<Order_Book_Aggregate_Order_By>;
  post_books_aggregate?: InputMaybe<Post_Book_Aggregate_Order_By>;
  price?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  tag_books_aggregate?: InputMaybe<Tag_Book_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  track_stock?: InputMaybe<Order_By>;
  ts_vector?: InputMaybe<Order_By>;
};

/** primary key columns input for table: books */
export type Books_Pk_Columns_Input = {
  isbn: Scalars['bigint'];
};

/** select columns of table "books" */
export enum Books_Select_Column {
  /** column name */
  Attributes = 'attributes',
  /** column name */
  Author = 'author',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountValue = 'discount_value',
  /** column name */
  Image = 'image',
  /** column name */
  IsDiscounted = 'is_discounted',
  /** column name */
  IsUnlisted = 'is_unlisted',
  /** column name */
  Isbn = 'isbn',
  /** column name */
  Price = 'price',
  /** column name */
  Stock = 'stock',
  /** column name */
  Title = 'title',
  /** column name */
  TrackStock = 'track_stock',
  /** column name */
  TsVector = 'ts_vector'
}

/** input type for updating data in table "books" */
export type Books_Set_Input = {
  attributes?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discount_value?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  is_discounted?: InputMaybe<Scalars['Boolean']>;
  is_unlisted?: InputMaybe<Scalars['Boolean']>;
  isbn?: InputMaybe<Scalars['bigint']>;
  price?: InputMaybe<Scalars['Int']>;
  stock?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  track_stock?: InputMaybe<Scalars['Boolean']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
};

/** aggregate stddev on columns */
export type Books_Stddev_Fields = {
  __typename?: 'books_stddev_fields';
  discount_value?: Maybe<Scalars['Float']>;
  isbn?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Books_Stddev_Pop_Fields = {
  __typename?: 'books_stddev_pop_fields';
  discount_value?: Maybe<Scalars['Float']>;
  isbn?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Books_Stddev_Samp_Fields = {
  __typename?: 'books_stddev_samp_fields';
  discount_value?: Maybe<Scalars['Float']>;
  isbn?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Books_Sum_Fields = {
  __typename?: 'books_sum_fields';
  discount_value?: Maybe<Scalars['Int']>;
  isbn?: Maybe<Scalars['bigint']>;
  price?: Maybe<Scalars['Int']>;
  stock?: Maybe<Scalars['Int']>;
};

/** update columns of table "books" */
export enum Books_Update_Column {
  /** column name */
  Attributes = 'attributes',
  /** column name */
  Author = 'author',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountValue = 'discount_value',
  /** column name */
  Image = 'image',
  /** column name */
  IsDiscounted = 'is_discounted',
  /** column name */
  IsUnlisted = 'is_unlisted',
  /** column name */
  Isbn = 'isbn',
  /** column name */
  Price = 'price',
  /** column name */
  Stock = 'stock',
  /** column name */
  Title = 'title',
  /** column name */
  TrackStock = 'track_stock',
  /** column name */
  TsVector = 'ts_vector'
}

/** aggregate var_pop on columns */
export type Books_Var_Pop_Fields = {
  __typename?: 'books_var_pop_fields';
  discount_value?: Maybe<Scalars['Float']>;
  isbn?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Books_Var_Samp_Fields = {
  __typename?: 'books_var_samp_fields';
  discount_value?: Maybe<Scalars['Float']>;
  isbn?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Books_Variance_Fields = {
  __typename?: 'books_variance_fields';
  discount_value?: Maybe<Scalars['Float']>;
  isbn?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "booksellers" */
export type Booksellers = {
  __typename?: 'booksellers';
  about?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  posts: Array<Posts>;
  /** An aggregate relationship */
  posts_aggregate: Posts_Aggregate;
  video_url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "booksellers" */
export type BooksellersPostsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


/** columns and relationships of "booksellers" */
export type BooksellersPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};

/** aggregated selection of "booksellers" */
export type Booksellers_Aggregate = {
  __typename?: 'booksellers_aggregate';
  aggregate?: Maybe<Booksellers_Aggregate_Fields>;
  nodes: Array<Booksellers>;
};

/** aggregate fields of "booksellers" */
export type Booksellers_Aggregate_Fields = {
  __typename?: 'booksellers_aggregate_fields';
  avg?: Maybe<Booksellers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Booksellers_Max_Fields>;
  min?: Maybe<Booksellers_Min_Fields>;
  stddev?: Maybe<Booksellers_Stddev_Fields>;
  stddev_pop?: Maybe<Booksellers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Booksellers_Stddev_Samp_Fields>;
  sum?: Maybe<Booksellers_Sum_Fields>;
  var_pop?: Maybe<Booksellers_Var_Pop_Fields>;
  var_samp?: Maybe<Booksellers_Var_Samp_Fields>;
  variance?: Maybe<Booksellers_Variance_Fields>;
};


/** aggregate fields of "booksellers" */
export type Booksellers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Booksellers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Booksellers_Avg_Fields = {
  __typename?: 'booksellers_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "booksellers". All fields are combined with a logical 'AND'. */
export type Booksellers_Bool_Exp = {
  _and?: InputMaybe<Array<Booksellers_Bool_Exp>>;
  _not?: InputMaybe<Booksellers_Bool_Exp>;
  _or?: InputMaybe<Array<Booksellers_Bool_Exp>>;
  about?: InputMaybe<String_Comparison_Exp>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  posts?: InputMaybe<Posts_Bool_Exp>;
  video_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "booksellers" */
export enum Booksellers_Constraint {
  /** unique or primary key constraint */
  BooksellersIdKey = 'booksellers_id_key',
  /** unique or primary key constraint */
  BooksellersPkey = 'booksellers_pkey'
}

/** input type for incrementing numeric columns in table "booksellers" */
export type Booksellers_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "booksellers" */
export type Booksellers_Insert_Input = {
  about?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  posts?: InputMaybe<Posts_Arr_Rel_Insert_Input>;
  video_url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Booksellers_Max_Fields = {
  __typename?: 'booksellers_max_fields';
  about?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  video_url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Booksellers_Min_Fields = {
  __typename?: 'booksellers_min_fields';
  about?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  video_url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booksellers" */
export type Booksellers_Mutation_Response = {
  __typename?: 'booksellers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Booksellers>;
};

/** input type for inserting object relation for remote table "booksellers" */
export type Booksellers_Obj_Rel_Insert_Input = {
  data: Booksellers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Booksellers_On_Conflict>;
};

/** on_conflict condition type for table "booksellers" */
export type Booksellers_On_Conflict = {
  constraint: Booksellers_Constraint;
  update_columns?: Array<Booksellers_Update_Column>;
  where?: InputMaybe<Booksellers_Bool_Exp>;
};

/** Ordering options when selecting data from "booksellers". */
export type Booksellers_Order_By = {
  about?: InputMaybe<Order_By>;
  avatar?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  posts_aggregate?: InputMaybe<Posts_Aggregate_Order_By>;
  video_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: booksellers */
export type Booksellers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "booksellers" */
export enum Booksellers_Select_Column {
  /** column name */
  About = 'about',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  VideoUrl = 'video_url'
}

/** input type for updating data in table "booksellers" */
export type Booksellers_Set_Input = {
  about?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  video_url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Booksellers_Stddev_Fields = {
  __typename?: 'booksellers_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Booksellers_Stddev_Pop_Fields = {
  __typename?: 'booksellers_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Booksellers_Stddev_Samp_Fields = {
  __typename?: 'booksellers_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Booksellers_Sum_Fields = {
  __typename?: 'booksellers_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "booksellers" */
export enum Booksellers_Update_Column {
  /** column name */
  About = 'about',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  VideoUrl = 'video_url'
}

/** aggregate var_pop on columns */
export type Booksellers_Var_Pop_Fields = {
  __typename?: 'booksellers_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Booksellers_Var_Samp_Fields = {
  __typename?: 'booksellers_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Booksellers_Variance_Fields = {
  __typename?: 'booksellers_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'categories';
  /** An array relationship */
  category_books: Array<Category_Book>;
  /** An aggregate relationship */
  category_books_aggregate: Category_Book_Aggregate;
  /** An array relationship */
  category_events: Array<Category_Event>;
  /** An aggregate relationship */
  category_events_aggregate: Category_Event_Aggregate;
  /** An array relationship */
  category_posts: Array<Category_Post>;
  /** An aggregate relationship */
  category_posts_aggregate: Category_Post_Aggregate;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};


/** columns and relationships of "categories" */
export type CategoriesCategory_BooksArgs = {
  distinct_on?: InputMaybe<Array<Category_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Book_Order_By>>;
  where?: InputMaybe<Category_Book_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesCategory_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Book_Order_By>>;
  where?: InputMaybe<Category_Book_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesCategory_EventsArgs = {
  distinct_on?: InputMaybe<Array<Category_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Event_Order_By>>;
  where?: InputMaybe<Category_Event_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesCategory_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Event_Order_By>>;
  where?: InputMaybe<Category_Event_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesCategory_PostsArgs = {
  distinct_on?: InputMaybe<Array<Category_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Post_Order_By>>;
  where?: InputMaybe<Category_Post_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesCategory_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Post_Order_By>>;
  where?: InputMaybe<Category_Post_Bool_Exp>;
};

/** aggregated selection of "categories" */
export type Categories_Aggregate = {
  __typename?: 'categories_aggregate';
  aggregate?: Maybe<Categories_Aggregate_Fields>;
  nodes: Array<Categories>;
};

/** aggregate fields of "categories" */
export type Categories_Aggregate_Fields = {
  __typename?: 'categories_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Categories_Max_Fields>;
  min?: Maybe<Categories_Min_Fields>;
};


/** aggregate fields of "categories" */
export type Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Categories_Bool_Exp>>;
  _not?: InputMaybe<Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Categories_Bool_Exp>>;
  category_books?: InputMaybe<Category_Book_Bool_Exp>;
  category_events?: InputMaybe<Category_Event_Bool_Exp>;
  category_posts?: InputMaybe<Category_Post_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "categories" */
export enum Categories_Constraint {
  /** unique or primary key constraint */
  CategoriesPkey = 'categories_pkey',
  /** unique or primary key constraint */
  CategoriesSlugKey = 'categories_slug_key'
}

/** input type for inserting data into table "categories" */
export type Categories_Insert_Input = {
  category_books?: InputMaybe<Category_Book_Arr_Rel_Insert_Input>;
  category_events?: InputMaybe<Category_Event_Arr_Rel_Insert_Input>;
  category_posts?: InputMaybe<Category_Post_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Categories_Max_Fields = {
  __typename?: 'categories_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Categories_Min_Fields = {
  __typename?: 'categories_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "categories" */
export type Categories_Mutation_Response = {
  __typename?: 'categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Categories>;
};

/** input type for inserting object relation for remote table "categories" */
export type Categories_Obj_Rel_Insert_Input = {
  data: Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};

/** on_conflict condition type for table "categories" */
export type Categories_On_Conflict = {
  constraint: Categories_Constraint;
  update_columns?: Array<Categories_Update_Column>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "categories". */
export type Categories_Order_By = {
  category_books_aggregate?: InputMaybe<Category_Book_Aggregate_Order_By>;
  category_events_aggregate?: InputMaybe<Category_Event_Aggregate_Order_By>;
  category_posts_aggregate?: InputMaybe<Category_Post_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: categories */
export type Categories_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "categories" */
export enum Categories_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "categories" */
export type Categories_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** update columns of table "categories" */
export enum Categories_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** columns and relationships of "category_book" */
export type Category_Book = {
  __typename?: 'category_book';
  /** An object relationship */
  book: Books;
  book_isbn: Scalars['bigint'];
  /** An object relationship */
  category: Categories;
  category_name: Scalars['String'];
  rank_order?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "category_book" */
export type Category_Book_Aggregate = {
  __typename?: 'category_book_aggregate';
  aggregate?: Maybe<Category_Book_Aggregate_Fields>;
  nodes: Array<Category_Book>;
};

/** aggregate fields of "category_book" */
export type Category_Book_Aggregate_Fields = {
  __typename?: 'category_book_aggregate_fields';
  avg?: Maybe<Category_Book_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Category_Book_Max_Fields>;
  min?: Maybe<Category_Book_Min_Fields>;
  stddev?: Maybe<Category_Book_Stddev_Fields>;
  stddev_pop?: Maybe<Category_Book_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Category_Book_Stddev_Samp_Fields>;
  sum?: Maybe<Category_Book_Sum_Fields>;
  var_pop?: Maybe<Category_Book_Var_Pop_Fields>;
  var_samp?: Maybe<Category_Book_Var_Samp_Fields>;
  variance?: Maybe<Category_Book_Variance_Fields>;
};


/** aggregate fields of "category_book" */
export type Category_Book_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Category_Book_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "category_book" */
export type Category_Book_Aggregate_Order_By = {
  avg?: InputMaybe<Category_Book_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Category_Book_Max_Order_By>;
  min?: InputMaybe<Category_Book_Min_Order_By>;
  stddev?: InputMaybe<Category_Book_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Category_Book_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Category_Book_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Category_Book_Sum_Order_By>;
  var_pop?: InputMaybe<Category_Book_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Category_Book_Var_Samp_Order_By>;
  variance?: InputMaybe<Category_Book_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "category_book" */
export type Category_Book_Arr_Rel_Insert_Input = {
  data: Array<Category_Book_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_Book_On_Conflict>;
};

/** aggregate avg on columns */
export type Category_Book_Avg_Fields = {
  __typename?: 'category_book_avg_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "category_book" */
export type Category_Book_Avg_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "category_book". All fields are combined with a logical 'AND'. */
export type Category_Book_Bool_Exp = {
  _and?: InputMaybe<Array<Category_Book_Bool_Exp>>;
  _not?: InputMaybe<Category_Book_Bool_Exp>;
  _or?: InputMaybe<Array<Category_Book_Bool_Exp>>;
  book?: InputMaybe<Books_Bool_Exp>;
  book_isbn?: InputMaybe<Bigint_Comparison_Exp>;
  category?: InputMaybe<Categories_Bool_Exp>;
  category_name?: InputMaybe<String_Comparison_Exp>;
  rank_order?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "category_book" */
export enum Category_Book_Constraint {
  /** unique or primary key constraint */
  CategoryBookPkey = 'category_book_pkey'
}

/** input type for incrementing numeric columns in table "category_book" */
export type Category_Book_Inc_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  rank_order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "category_book" */
export type Category_Book_Insert_Input = {
  book?: InputMaybe<Books_Obj_Rel_Insert_Input>;
  book_isbn?: InputMaybe<Scalars['bigint']>;
  category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  category_name?: InputMaybe<Scalars['String']>;
  rank_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Category_Book_Max_Fields = {
  __typename?: 'category_book_max_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  category_name?: Maybe<Scalars['String']>;
  rank_order?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "category_book" */
export type Category_Book_Max_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  category_name?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Category_Book_Min_Fields = {
  __typename?: 'category_book_min_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  category_name?: Maybe<Scalars['String']>;
  rank_order?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "category_book" */
export type Category_Book_Min_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  category_name?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "category_book" */
export type Category_Book_Mutation_Response = {
  __typename?: 'category_book_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Category_Book>;
};

/** on_conflict condition type for table "category_book" */
export type Category_Book_On_Conflict = {
  constraint: Category_Book_Constraint;
  update_columns?: Array<Category_Book_Update_Column>;
  where?: InputMaybe<Category_Book_Bool_Exp>;
};

/** Ordering options when selecting data from "category_book". */
export type Category_Book_Order_By = {
  book?: InputMaybe<Books_Order_By>;
  book_isbn?: InputMaybe<Order_By>;
  category?: InputMaybe<Categories_Order_By>;
  category_name?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** primary key columns input for table: category_book */
export type Category_Book_Pk_Columns_Input = {
  book_isbn: Scalars['bigint'];
  category_name: Scalars['String'];
};

/** select columns of table "category_book" */
export enum Category_Book_Select_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  CategoryName = 'category_name',
  /** column name */
  RankOrder = 'rank_order'
}

/** input type for updating data in table "category_book" */
export type Category_Book_Set_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  category_name?: InputMaybe<Scalars['String']>;
  rank_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Category_Book_Stddev_Fields = {
  __typename?: 'category_book_stddev_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "category_book" */
export type Category_Book_Stddev_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Category_Book_Stddev_Pop_Fields = {
  __typename?: 'category_book_stddev_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "category_book" */
export type Category_Book_Stddev_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Category_Book_Stddev_Samp_Fields = {
  __typename?: 'category_book_stddev_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "category_book" */
export type Category_Book_Stddev_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Category_Book_Sum_Fields = {
  __typename?: 'category_book_sum_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  rank_order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "category_book" */
export type Category_Book_Sum_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** update columns of table "category_book" */
export enum Category_Book_Update_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  CategoryName = 'category_name',
  /** column name */
  RankOrder = 'rank_order'
}

/** aggregate var_pop on columns */
export type Category_Book_Var_Pop_Fields = {
  __typename?: 'category_book_var_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "category_book" */
export type Category_Book_Var_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Category_Book_Var_Samp_Fields = {
  __typename?: 'category_book_var_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "category_book" */
export type Category_Book_Var_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Category_Book_Variance_Fields = {
  __typename?: 'category_book_variance_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "category_book" */
export type Category_Book_Variance_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "category_event" */
export type Category_Event = {
  __typename?: 'category_event';
  /** An object relationship */
  category: Categories;
  category_name: Scalars['String'];
  /** An object relationship */
  event: Events;
  event_id: Scalars['uuid'];
};

/** aggregated selection of "category_event" */
export type Category_Event_Aggregate = {
  __typename?: 'category_event_aggregate';
  aggregate?: Maybe<Category_Event_Aggregate_Fields>;
  nodes: Array<Category_Event>;
};

/** aggregate fields of "category_event" */
export type Category_Event_Aggregate_Fields = {
  __typename?: 'category_event_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Category_Event_Max_Fields>;
  min?: Maybe<Category_Event_Min_Fields>;
};


/** aggregate fields of "category_event" */
export type Category_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Category_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "category_event" */
export type Category_Event_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Category_Event_Max_Order_By>;
  min?: InputMaybe<Category_Event_Min_Order_By>;
};

/** input type for inserting array relation for remote table "category_event" */
export type Category_Event_Arr_Rel_Insert_Input = {
  data: Array<Category_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_Event_On_Conflict>;
};

/** Boolean expression to filter rows from the table "category_event". All fields are combined with a logical 'AND'. */
export type Category_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Category_Event_Bool_Exp>>;
  _not?: InputMaybe<Category_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Category_Event_Bool_Exp>>;
  category?: InputMaybe<Categories_Bool_Exp>;
  category_name?: InputMaybe<String_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "category_event" */
export enum Category_Event_Constraint {
  /** unique or primary key constraint */
  CategoryEventPkey = 'category_event_pkey'
}

/** input type for inserting data into table "category_event" */
export type Category_Event_Insert_Input = {
  category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  category_name?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Category_Event_Max_Fields = {
  __typename?: 'category_event_max_fields';
  category_name?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "category_event" */
export type Category_Event_Max_Order_By = {
  category_name?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Category_Event_Min_Fields = {
  __typename?: 'category_event_min_fields';
  category_name?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "category_event" */
export type Category_Event_Min_Order_By = {
  category_name?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "category_event" */
export type Category_Event_Mutation_Response = {
  __typename?: 'category_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Category_Event>;
};

/** on_conflict condition type for table "category_event" */
export type Category_Event_On_Conflict = {
  constraint: Category_Event_Constraint;
  update_columns?: Array<Category_Event_Update_Column>;
  where?: InputMaybe<Category_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "category_event". */
export type Category_Event_Order_By = {
  category?: InputMaybe<Categories_Order_By>;
  category_name?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: category_event */
export type Category_Event_Pk_Columns_Input = {
  category_name: Scalars['String'];
  event_id: Scalars['uuid'];
};

/** select columns of table "category_event" */
export enum Category_Event_Select_Column {
  /** column name */
  CategoryName = 'category_name',
  /** column name */
  EventId = 'event_id'
}

/** input type for updating data in table "category_event" */
export type Category_Event_Set_Input = {
  category_name?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "category_event" */
export enum Category_Event_Update_Column {
  /** column name */
  CategoryName = 'category_name',
  /** column name */
  EventId = 'event_id'
}

/** columns and relationships of "category_post" */
export type Category_Post = {
  __typename?: 'category_post';
  /** An object relationship */
  category: Categories;
  category_name: Scalars['String'];
  /** An object relationship */
  post: Posts;
  post_id: Scalars['uuid'];
};

/** aggregated selection of "category_post" */
export type Category_Post_Aggregate = {
  __typename?: 'category_post_aggregate';
  aggregate?: Maybe<Category_Post_Aggregate_Fields>;
  nodes: Array<Category_Post>;
};

/** aggregate fields of "category_post" */
export type Category_Post_Aggregate_Fields = {
  __typename?: 'category_post_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Category_Post_Max_Fields>;
  min?: Maybe<Category_Post_Min_Fields>;
};


/** aggregate fields of "category_post" */
export type Category_Post_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Category_Post_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "category_post" */
export type Category_Post_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Category_Post_Max_Order_By>;
  min?: InputMaybe<Category_Post_Min_Order_By>;
};

/** input type for inserting array relation for remote table "category_post" */
export type Category_Post_Arr_Rel_Insert_Input = {
  data: Array<Category_Post_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Category_Post_On_Conflict>;
};

/** Boolean expression to filter rows from the table "category_post". All fields are combined with a logical 'AND'. */
export type Category_Post_Bool_Exp = {
  _and?: InputMaybe<Array<Category_Post_Bool_Exp>>;
  _not?: InputMaybe<Category_Post_Bool_Exp>;
  _or?: InputMaybe<Array<Category_Post_Bool_Exp>>;
  category?: InputMaybe<Categories_Bool_Exp>;
  category_name?: InputMaybe<String_Comparison_Exp>;
  post?: InputMaybe<Posts_Bool_Exp>;
  post_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "category_post" */
export enum Category_Post_Constraint {
  /** unique or primary key constraint */
  CategoryPostPkey = 'category_post_pkey'
}

/** input type for inserting data into table "category_post" */
export type Category_Post_Insert_Input = {
  category?: InputMaybe<Categories_Obj_Rel_Insert_Input>;
  category_name?: InputMaybe<Scalars['String']>;
  post?: InputMaybe<Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Category_Post_Max_Fields = {
  __typename?: 'category_post_max_fields';
  category_name?: Maybe<Scalars['String']>;
  post_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "category_post" */
export type Category_Post_Max_Order_By = {
  category_name?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Category_Post_Min_Fields = {
  __typename?: 'category_post_min_fields';
  category_name?: Maybe<Scalars['String']>;
  post_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "category_post" */
export type Category_Post_Min_Order_By = {
  category_name?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "category_post" */
export type Category_Post_Mutation_Response = {
  __typename?: 'category_post_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Category_Post>;
};

/** on_conflict condition type for table "category_post" */
export type Category_Post_On_Conflict = {
  constraint: Category_Post_Constraint;
  update_columns?: Array<Category_Post_Update_Column>;
  where?: InputMaybe<Category_Post_Bool_Exp>;
};

/** Ordering options when selecting data from "category_post". */
export type Category_Post_Order_By = {
  category?: InputMaybe<Categories_Order_By>;
  category_name?: InputMaybe<Order_By>;
  post?: InputMaybe<Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: category_post */
export type Category_Post_Pk_Columns_Input = {
  category_name: Scalars['String'];
  post_id: Scalars['uuid'];
};

/** select columns of table "category_post" */
export enum Category_Post_Select_Column {
  /** column name */
  CategoryName = 'category_name',
  /** column name */
  PostId = 'post_id'
}

/** input type for updating data in table "category_post" */
export type Category_Post_Set_Input = {
  category_name?: InputMaybe<Scalars['String']>;
  post_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "category_post" */
export enum Category_Post_Update_Column {
  /** column name */
  CategoryName = 'category_name',
  /** column name */
  PostId = 'post_id'
}

/** columns and relationships of "children_categories" */
export type Children_Categories = {
  __typename?: 'children_categories';
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** aggregated selection of "children_categories" */
export type Children_Categories_Aggregate = {
  __typename?: 'children_categories_aggregate';
  aggregate?: Maybe<Children_Categories_Aggregate_Fields>;
  nodes: Array<Children_Categories>;
};

/** aggregate fields of "children_categories" */
export type Children_Categories_Aggregate_Fields = {
  __typename?: 'children_categories_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Children_Categories_Max_Fields>;
  min?: Maybe<Children_Categories_Min_Fields>;
};


/** aggregate fields of "children_categories" */
export type Children_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Children_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "children_categories". All fields are combined with a logical 'AND'. */
export type Children_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Children_Categories_Bool_Exp>>;
  _not?: InputMaybe<Children_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Children_Categories_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "children_categories" */
export enum Children_Categories_Constraint {
  /** unique or primary key constraint */
  ChildrenCategoriesNameKey = 'children_categories_name_key',
  /** unique or primary key constraint */
  ChildrenCategoriesPkey = 'children_categories_pkey'
}

/** input type for inserting data into table "children_categories" */
export type Children_Categories_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Children_Categories_Max_Fields = {
  __typename?: 'children_categories_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Children_Categories_Min_Fields = {
  __typename?: 'children_categories_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "children_categories" */
export type Children_Categories_Mutation_Response = {
  __typename?: 'children_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Children_Categories>;
};

/** on_conflict condition type for table "children_categories" */
export type Children_Categories_On_Conflict = {
  constraint: Children_Categories_Constraint;
  update_columns?: Array<Children_Categories_Update_Column>;
  where?: InputMaybe<Children_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "children_categories". */
export type Children_Categories_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: children_categories */
export type Children_Categories_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "children_categories" */
export enum Children_Categories_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "children_categories" */
export type Children_Categories_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "children_categories" */
export enum Children_Categories_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** columns and relationships of "children_category_books" */
export type Children_Category_Books = {
  __typename?: 'children_category_books';
  book_isbn: Scalars['bigint'];
  category_id: Scalars['uuid'];
};

/** aggregated selection of "children_category_books" */
export type Children_Category_Books_Aggregate = {
  __typename?: 'children_category_books_aggregate';
  aggregate?: Maybe<Children_Category_Books_Aggregate_Fields>;
  nodes: Array<Children_Category_Books>;
};

/** aggregate fields of "children_category_books" */
export type Children_Category_Books_Aggregate_Fields = {
  __typename?: 'children_category_books_aggregate_fields';
  avg?: Maybe<Children_Category_Books_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Children_Category_Books_Max_Fields>;
  min?: Maybe<Children_Category_Books_Min_Fields>;
  stddev?: Maybe<Children_Category_Books_Stddev_Fields>;
  stddev_pop?: Maybe<Children_Category_Books_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Children_Category_Books_Stddev_Samp_Fields>;
  sum?: Maybe<Children_Category_Books_Sum_Fields>;
  var_pop?: Maybe<Children_Category_Books_Var_Pop_Fields>;
  var_samp?: Maybe<Children_Category_Books_Var_Samp_Fields>;
  variance?: Maybe<Children_Category_Books_Variance_Fields>;
};


/** aggregate fields of "children_category_books" */
export type Children_Category_Books_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Children_Category_Books_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "children_category_books" */
export type Children_Category_Books_Aggregate_Order_By = {
  avg?: InputMaybe<Children_Category_Books_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Children_Category_Books_Max_Order_By>;
  min?: InputMaybe<Children_Category_Books_Min_Order_By>;
  stddev?: InputMaybe<Children_Category_Books_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Children_Category_Books_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Children_Category_Books_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Children_Category_Books_Sum_Order_By>;
  var_pop?: InputMaybe<Children_Category_Books_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Children_Category_Books_Var_Samp_Order_By>;
  variance?: InputMaybe<Children_Category_Books_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "children_category_books" */
export type Children_Category_Books_Arr_Rel_Insert_Input = {
  data: Array<Children_Category_Books_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Children_Category_Books_On_Conflict>;
};

/** aggregate avg on columns */
export type Children_Category_Books_Avg_Fields = {
  __typename?: 'children_category_books_avg_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "children_category_books" */
export type Children_Category_Books_Avg_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "children_category_books". All fields are combined with a logical 'AND'. */
export type Children_Category_Books_Bool_Exp = {
  _and?: InputMaybe<Array<Children_Category_Books_Bool_Exp>>;
  _not?: InputMaybe<Children_Category_Books_Bool_Exp>;
  _or?: InputMaybe<Array<Children_Category_Books_Bool_Exp>>;
  book_isbn?: InputMaybe<Bigint_Comparison_Exp>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "children_category_books" */
export enum Children_Category_Books_Constraint {
  /** unique or primary key constraint */
  ChildrenCategoryBooksPkey = 'children_category_books_pkey'
}

/** input type for incrementing numeric columns in table "children_category_books" */
export type Children_Category_Books_Inc_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "children_category_books" */
export type Children_Category_Books_Insert_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  category_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Children_Category_Books_Max_Fields = {
  __typename?: 'children_category_books_max_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  category_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "children_category_books" */
export type Children_Category_Books_Max_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Children_Category_Books_Min_Fields = {
  __typename?: 'children_category_books_min_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  category_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "children_category_books" */
export type Children_Category_Books_Min_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "children_category_books" */
export type Children_Category_Books_Mutation_Response = {
  __typename?: 'children_category_books_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Children_Category_Books>;
};

/** on_conflict condition type for table "children_category_books" */
export type Children_Category_Books_On_Conflict = {
  constraint: Children_Category_Books_Constraint;
  update_columns?: Array<Children_Category_Books_Update_Column>;
  where?: InputMaybe<Children_Category_Books_Bool_Exp>;
};

/** Ordering options when selecting data from "children_category_books". */
export type Children_Category_Books_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: children_category_books */
export type Children_Category_Books_Pk_Columns_Input = {
  book_isbn: Scalars['bigint'];
  category_id: Scalars['uuid'];
};

/** select columns of table "children_category_books" */
export enum Children_Category_Books_Select_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  CategoryId = 'category_id'
}

/** input type for updating data in table "children_category_books" */
export type Children_Category_Books_Set_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  category_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Children_Category_Books_Stddev_Fields = {
  __typename?: 'children_category_books_stddev_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "children_category_books" */
export type Children_Category_Books_Stddev_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Children_Category_Books_Stddev_Pop_Fields = {
  __typename?: 'children_category_books_stddev_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "children_category_books" */
export type Children_Category_Books_Stddev_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Children_Category_Books_Stddev_Samp_Fields = {
  __typename?: 'children_category_books_stddev_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "children_category_books" */
export type Children_Category_Books_Stddev_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Children_Category_Books_Sum_Fields = {
  __typename?: 'children_category_books_sum_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "children_category_books" */
export type Children_Category_Books_Sum_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** update columns of table "children_category_books" */
export enum Children_Category_Books_Update_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  CategoryId = 'category_id'
}

/** aggregate var_pop on columns */
export type Children_Category_Books_Var_Pop_Fields = {
  __typename?: 'children_category_books_var_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "children_category_books" */
export type Children_Category_Books_Var_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Children_Category_Books_Var_Samp_Fields = {
  __typename?: 'children_category_books_var_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "children_category_books" */
export type Children_Category_Books_Var_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Children_Category_Books_Variance_Fields = {
  __typename?: 'children_category_books_variance_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "children_category_books" */
export type Children_Category_Books_Variance_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** columns and relationships of "contents" */
export type Contents = {
  __typename?: 'contents';
  content?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
};


/** columns and relationships of "contents" */
export type ContentsContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "contents" */
export type Contents_Aggregate = {
  __typename?: 'contents_aggregate';
  aggregate?: Maybe<Contents_Aggregate_Fields>;
  nodes: Array<Contents>;
};

/** aggregate fields of "contents" */
export type Contents_Aggregate_Fields = {
  __typename?: 'contents_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Contents_Max_Fields>;
  min?: Maybe<Contents_Min_Fields>;
};


/** aggregate fields of "contents" */
export type Contents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Contents_Append_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "contents". All fields are combined with a logical 'AND'. */
export type Contents_Bool_Exp = {
  _and?: InputMaybe<Array<Contents_Bool_Exp>>;
  _not?: InputMaybe<Contents_Bool_Exp>;
  _or?: InputMaybe<Array<Contents_Bool_Exp>>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "contents" */
export enum Contents_Constraint {
  /** unique or primary key constraint */
  ContentsPkey = 'contents_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Contents_Delete_At_Path_Input = {
  content?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Contents_Delete_Elem_Input = {
  content?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Contents_Delete_Key_Input = {
  content?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "contents" */
export type Contents_Insert_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Contents_Max_Fields = {
  __typename?: 'contents_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Contents_Min_Fields = {
  __typename?: 'contents_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "contents" */
export type Contents_Mutation_Response = {
  __typename?: 'contents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contents>;
};

/** on_conflict condition type for table "contents" */
export type Contents_On_Conflict = {
  constraint: Contents_Constraint;
  update_columns?: Array<Contents_Update_Column>;
  where?: InputMaybe<Contents_Bool_Exp>;
};

/** Ordering options when selecting data from "contents". */
export type Contents_Order_By = {
  content?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contents */
export type Contents_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Contents_Prepend_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "contents" */
export enum Contents_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "contents" */
export type Contents_Set_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "contents" */
export enum Contents_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Name = 'name'
}

/** columns and relationships of "countries" */
export type Countries = {
  __typename?: 'countries';
  code: Scalars['String'];
  name: Scalars['String'];
  region: Scalars['String'];
  /** An object relationship */
  region_data: Regions;
  /** An array relationship */
  shipping_options: Array<Shipping_Options>;
  /** An aggregate relationship */
  shipping_options_aggregate: Shipping_Options_Aggregate;
};


/** columns and relationships of "countries" */
export type CountriesShipping_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Shipping_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipping_Options_Order_By>>;
  where?: InputMaybe<Shipping_Options_Bool_Exp>;
};


/** columns and relationships of "countries" */
export type CountriesShipping_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shipping_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipping_Options_Order_By>>;
  where?: InputMaybe<Shipping_Options_Bool_Exp>;
};

/** aggregated selection of "countries" */
export type Countries_Aggregate = {
  __typename?: 'countries_aggregate';
  aggregate?: Maybe<Countries_Aggregate_Fields>;
  nodes: Array<Countries>;
};

/** aggregate fields of "countries" */
export type Countries_Aggregate_Fields = {
  __typename?: 'countries_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Countries_Max_Fields>;
  min?: Maybe<Countries_Min_Fields>;
};


/** aggregate fields of "countries" */
export type Countries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Countries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "countries" */
export type Countries_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Countries_Max_Order_By>;
  min?: InputMaybe<Countries_Min_Order_By>;
};

/** input type for inserting array relation for remote table "countries" */
export type Countries_Arr_Rel_Insert_Input = {
  data: Array<Countries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Countries_On_Conflict>;
};

/** Boolean expression to filter rows from the table "countries". All fields are combined with a logical 'AND'. */
export type Countries_Bool_Exp = {
  _and?: InputMaybe<Array<Countries_Bool_Exp>>;
  _not?: InputMaybe<Countries_Bool_Exp>;
  _or?: InputMaybe<Array<Countries_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  region_data?: InputMaybe<Regions_Bool_Exp>;
  shipping_options?: InputMaybe<Shipping_Options_Bool_Exp>;
};

/** unique or primary key constraints on table "countries" */
export enum Countries_Constraint {
  /** unique or primary key constraint */
  CountriesNameKey = 'countries_name_key',
  /** unique or primary key constraint */
  CountriesPkey = 'countries_pkey'
}

/** input type for inserting data into table "countries" */
export type Countries_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  region_data?: InputMaybe<Regions_Obj_Rel_Insert_Input>;
  shipping_options?: InputMaybe<Shipping_Options_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Countries_Max_Fields = {
  __typename?: 'countries_max_fields';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "countries" */
export type Countries_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Countries_Min_Fields = {
  __typename?: 'countries_min_fields';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "countries" */
export type Countries_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "countries" */
export type Countries_Mutation_Response = {
  __typename?: 'countries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Countries>;
};

/** input type for inserting object relation for remote table "countries" */
export type Countries_Obj_Rel_Insert_Input = {
  data: Countries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Countries_On_Conflict>;
};

/** on_conflict condition type for table "countries" */
export type Countries_On_Conflict = {
  constraint: Countries_Constraint;
  update_columns?: Array<Countries_Update_Column>;
  where?: InputMaybe<Countries_Bool_Exp>;
};

/** Ordering options when selecting data from "countries". */
export type Countries_Order_By = {
  code?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  region_data?: InputMaybe<Regions_Order_By>;
  shipping_options_aggregate?: InputMaybe<Shipping_Options_Aggregate_Order_By>;
};

/** primary key columns input for table: countries */
export type Countries_Pk_Columns_Input = {
  code: Scalars['String'];
};

/** select columns of table "countries" */
export enum Countries_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Name = 'name',
  /** column name */
  Region = 'region'
}

/** input type for updating data in table "countries" */
export type Countries_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

/** update columns of table "countries" */
export enum Countries_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Name = 'name',
  /** column name */
  Region = 'region'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "discount_type" */
export type Discount_Type = {
  __typename?: 'discount_type';
  name: Scalars['String'];
};

/** aggregated selection of "discount_type" */
export type Discount_Type_Aggregate = {
  __typename?: 'discount_type_aggregate';
  aggregate?: Maybe<Discount_Type_Aggregate_Fields>;
  nodes: Array<Discount_Type>;
};

/** aggregate fields of "discount_type" */
export type Discount_Type_Aggregate_Fields = {
  __typename?: 'discount_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Discount_Type_Max_Fields>;
  min?: Maybe<Discount_Type_Min_Fields>;
};


/** aggregate fields of "discount_type" */
export type Discount_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Discount_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "discount_type". All fields are combined with a logical 'AND'. */
export type Discount_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Discount_Type_Bool_Exp>>;
  _not?: InputMaybe<Discount_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Discount_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "discount_type" */
export enum Discount_Type_Constraint {
  /** unique or primary key constraint */
  DiscountTypePkey = 'discount_type_pkey'
}

export enum Discount_Type_Enum {
  Book = 'book'
}

/** Boolean expression to compare columns of type "discount_type_enum". All fields are combined with logical 'AND'. */
export type Discount_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Discount_Type_Enum>;
  _in?: InputMaybe<Array<Discount_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Discount_Type_Enum>;
  _nin?: InputMaybe<Array<Discount_Type_Enum>>;
};

/** input type for inserting data into table "discount_type" */
export type Discount_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Discount_Type_Max_Fields = {
  __typename?: 'discount_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Discount_Type_Min_Fields = {
  __typename?: 'discount_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "discount_type" */
export type Discount_Type_Mutation_Response = {
  __typename?: 'discount_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Discount_Type>;
};

/** on_conflict condition type for table "discount_type" */
export type Discount_Type_On_Conflict = {
  constraint: Discount_Type_Constraint;
  update_columns?: Array<Discount_Type_Update_Column>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "discount_type". */
export type Discount_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: discount_type */
export type Discount_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "discount_type" */
export enum Discount_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "discount_type" */
export type Discount_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "discount_type" */
export enum Discount_Type_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "discounts" */
export type Discounts = {
  __typename?: 'discounts';
  code: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_value: Scalars['Int'];
  /** An array relationship */
  discounted_books: Array<Book_Discount>;
  /** An aggregate relationship */
  discounted_books_aggregate: Book_Discount_Aggregate;
  is_active: Scalars['Boolean'];
  is_fixed_amount: Scalars['Boolean'];
  limit_uses?: Maybe<Scalars['Int']>;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  total_uses: Scalars['Int'];
  type: Discount_Type_Enum;
};


/** columns and relationships of "discounts" */
export type DiscountsDiscounted_BooksArgs = {
  distinct_on?: InputMaybe<Array<Book_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Book_Discount_Order_By>>;
  where?: InputMaybe<Book_Discount_Bool_Exp>;
};


/** columns and relationships of "discounts" */
export type DiscountsDiscounted_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Book_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Book_Discount_Order_By>>;
  where?: InputMaybe<Book_Discount_Bool_Exp>;
};


/** columns and relationships of "discounts" */
export type DiscountsOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "discounts" */
export type DiscountsOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};

/** aggregated selection of "discounts" */
export type Discounts_Aggregate = {
  __typename?: 'discounts_aggregate';
  aggregate?: Maybe<Discounts_Aggregate_Fields>;
  nodes: Array<Discounts>;
};

/** aggregate fields of "discounts" */
export type Discounts_Aggregate_Fields = {
  __typename?: 'discounts_aggregate_fields';
  avg?: Maybe<Discounts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Discounts_Max_Fields>;
  min?: Maybe<Discounts_Min_Fields>;
  stddev?: Maybe<Discounts_Stddev_Fields>;
  stddev_pop?: Maybe<Discounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Discounts_Stddev_Samp_Fields>;
  sum?: Maybe<Discounts_Sum_Fields>;
  var_pop?: Maybe<Discounts_Var_Pop_Fields>;
  var_samp?: Maybe<Discounts_Var_Samp_Fields>;
  variance?: Maybe<Discounts_Variance_Fields>;
};


/** aggregate fields of "discounts" */
export type Discounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Discounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Discounts_Avg_Fields = {
  __typename?: 'discounts_avg_fields';
  discount_value?: Maybe<Scalars['Float']>;
  limit_uses?: Maybe<Scalars['Float']>;
  total_uses?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "discounts". All fields are combined with a logical 'AND'. */
export type Discounts_Bool_Exp = {
  _and?: InputMaybe<Array<Discounts_Bool_Exp>>;
  _not?: InputMaybe<Discounts_Bool_Exp>;
  _or?: InputMaybe<Array<Discounts_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discount_value?: InputMaybe<Int_Comparison_Exp>;
  discounted_books?: InputMaybe<Book_Discount_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_fixed_amount?: InputMaybe<Boolean_Comparison_Exp>;
  limit_uses?: InputMaybe<Int_Comparison_Exp>;
  orders?: InputMaybe<Orders_Bool_Exp>;
  total_uses?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Discount_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "discounts" */
export enum Discounts_Constraint {
  /** unique or primary key constraint */
  DiscountsPkey = 'discounts_pkey'
}

/** input type for incrementing numeric columns in table "discounts" */
export type Discounts_Inc_Input = {
  discount_value?: InputMaybe<Scalars['Int']>;
  limit_uses?: InputMaybe<Scalars['Int']>;
  total_uses?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "discounts" */
export type Discounts_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_value?: InputMaybe<Scalars['Int']>;
  discounted_books?: InputMaybe<Book_Discount_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_fixed_amount?: InputMaybe<Scalars['Boolean']>;
  limit_uses?: InputMaybe<Scalars['Int']>;
  orders?: InputMaybe<Orders_Arr_Rel_Insert_Input>;
  total_uses?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Discount_Type_Enum>;
};

/** aggregate max on columns */
export type Discounts_Max_Fields = {
  __typename?: 'discounts_max_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_value?: Maybe<Scalars['Int']>;
  limit_uses?: Maybe<Scalars['Int']>;
  total_uses?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Discounts_Min_Fields = {
  __typename?: 'discounts_min_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_value?: Maybe<Scalars['Int']>;
  limit_uses?: Maybe<Scalars['Int']>;
  total_uses?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "discounts" */
export type Discounts_Mutation_Response = {
  __typename?: 'discounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Discounts>;
};

/** input type for inserting object relation for remote table "discounts" */
export type Discounts_Obj_Rel_Insert_Input = {
  data: Discounts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Discounts_On_Conflict>;
};

/** on_conflict condition type for table "discounts" */
export type Discounts_On_Conflict = {
  constraint: Discounts_Constraint;
  update_columns?: Array<Discounts_Update_Column>;
  where?: InputMaybe<Discounts_Bool_Exp>;
};

/** Ordering options when selecting data from "discounts". */
export type Discounts_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount_value?: InputMaybe<Order_By>;
  discounted_books_aggregate?: InputMaybe<Book_Discount_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_fixed_amount?: InputMaybe<Order_By>;
  limit_uses?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  total_uses?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: discounts */
export type Discounts_Pk_Columns_Input = {
  code: Scalars['String'];
};

/** select columns of table "discounts" */
export enum Discounts_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountValue = 'discount_value',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsFixedAmount = 'is_fixed_amount',
  /** column name */
  LimitUses = 'limit_uses',
  /** column name */
  TotalUses = 'total_uses',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "discounts" */
export type Discounts_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_value?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_fixed_amount?: InputMaybe<Scalars['Boolean']>;
  limit_uses?: InputMaybe<Scalars['Int']>;
  total_uses?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Discount_Type_Enum>;
};

/** aggregate stddev on columns */
export type Discounts_Stddev_Fields = {
  __typename?: 'discounts_stddev_fields';
  discount_value?: Maybe<Scalars['Float']>;
  limit_uses?: Maybe<Scalars['Float']>;
  total_uses?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Discounts_Stddev_Pop_Fields = {
  __typename?: 'discounts_stddev_pop_fields';
  discount_value?: Maybe<Scalars['Float']>;
  limit_uses?: Maybe<Scalars['Float']>;
  total_uses?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Discounts_Stddev_Samp_Fields = {
  __typename?: 'discounts_stddev_samp_fields';
  discount_value?: Maybe<Scalars['Float']>;
  limit_uses?: Maybe<Scalars['Float']>;
  total_uses?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Discounts_Sum_Fields = {
  __typename?: 'discounts_sum_fields';
  discount_value?: Maybe<Scalars['Int']>;
  limit_uses?: Maybe<Scalars['Int']>;
  total_uses?: Maybe<Scalars['Int']>;
};

/** update columns of table "discounts" */
export enum Discounts_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountValue = 'discount_value',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsFixedAmount = 'is_fixed_amount',
  /** column name */
  LimitUses = 'limit_uses',
  /** column name */
  TotalUses = 'total_uses',
  /** column name */
  Type = 'type'
}

/** aggregate var_pop on columns */
export type Discounts_Var_Pop_Fields = {
  __typename?: 'discounts_var_pop_fields';
  discount_value?: Maybe<Scalars['Float']>;
  limit_uses?: Maybe<Scalars['Float']>;
  total_uses?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Discounts_Var_Samp_Fields = {
  __typename?: 'discounts_var_samp_fields';
  discount_value?: Maybe<Scalars['Float']>;
  limit_uses?: Maybe<Scalars['Float']>;
  total_uses?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Discounts_Variance_Fields = {
  __typename?: 'discounts_variance_fields';
  discount_value?: Maybe<Scalars['Float']>;
  limit_uses?: Maybe<Scalars['Float']>;
  total_uses?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "empty_searches" */
export type Empty_Searches = {
  __typename?: 'empty_searches';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  string: Scalars['String'];
};

/** aggregated selection of "empty_searches" */
export type Empty_Searches_Aggregate = {
  __typename?: 'empty_searches_aggregate';
  aggregate?: Maybe<Empty_Searches_Aggregate_Fields>;
  nodes: Array<Empty_Searches>;
};

/** aggregate fields of "empty_searches" */
export type Empty_Searches_Aggregate_Fields = {
  __typename?: 'empty_searches_aggregate_fields';
  avg?: Maybe<Empty_Searches_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Empty_Searches_Max_Fields>;
  min?: Maybe<Empty_Searches_Min_Fields>;
  stddev?: Maybe<Empty_Searches_Stddev_Fields>;
  stddev_pop?: Maybe<Empty_Searches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Empty_Searches_Stddev_Samp_Fields>;
  sum?: Maybe<Empty_Searches_Sum_Fields>;
  var_pop?: Maybe<Empty_Searches_Var_Pop_Fields>;
  var_samp?: Maybe<Empty_Searches_Var_Samp_Fields>;
  variance?: Maybe<Empty_Searches_Variance_Fields>;
};


/** aggregate fields of "empty_searches" */
export type Empty_Searches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Empty_Searches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Empty_Searches_Avg_Fields = {
  __typename?: 'empty_searches_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "empty_searches". All fields are combined with a logical 'AND'. */
export type Empty_Searches_Bool_Exp = {
  _and?: InputMaybe<Array<Empty_Searches_Bool_Exp>>;
  _not?: InputMaybe<Empty_Searches_Bool_Exp>;
  _or?: InputMaybe<Array<Empty_Searches_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  string?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "empty_searches" */
export enum Empty_Searches_Constraint {
  /** unique or primary key constraint */
  NoResultsPkey = 'no_results_pkey'
}

/** input type for incrementing numeric columns in table "empty_searches" */
export type Empty_Searches_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "empty_searches" */
export type Empty_Searches_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  string?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Empty_Searches_Max_Fields = {
  __typename?: 'empty_searches_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  string?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Empty_Searches_Min_Fields = {
  __typename?: 'empty_searches_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  string?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "empty_searches" */
export type Empty_Searches_Mutation_Response = {
  __typename?: 'empty_searches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Empty_Searches>;
};

/** on_conflict condition type for table "empty_searches" */
export type Empty_Searches_On_Conflict = {
  constraint: Empty_Searches_Constraint;
  update_columns?: Array<Empty_Searches_Update_Column>;
  where?: InputMaybe<Empty_Searches_Bool_Exp>;
};

/** Ordering options when selecting data from "empty_searches". */
export type Empty_Searches_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  string?: InputMaybe<Order_By>;
};

/** primary key columns input for table: empty_searches */
export type Empty_Searches_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "empty_searches" */
export enum Empty_Searches_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  String = 'string'
}

/** input type for updating data in table "empty_searches" */
export type Empty_Searches_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  string?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Empty_Searches_Stddev_Fields = {
  __typename?: 'empty_searches_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Empty_Searches_Stddev_Pop_Fields = {
  __typename?: 'empty_searches_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Empty_Searches_Stddev_Samp_Fields = {
  __typename?: 'empty_searches_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Empty_Searches_Sum_Fields = {
  __typename?: 'empty_searches_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "empty_searches" */
export enum Empty_Searches_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  String = 'string'
}

/** aggregate var_pop on columns */
export type Empty_Searches_Var_Pop_Fields = {
  __typename?: 'empty_searches_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Empty_Searches_Var_Samp_Fields = {
  __typename?: 'empty_searches_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Empty_Searches_Variance_Fields = {
  __typename?: 'empty_searches_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "event_book" */
export type Event_Book = {
  __typename?: 'event_book';
  /** An object relationship */
  book: Books;
  book_isbn: Scalars['bigint'];
  /** An object relationship */
  event: Events;
  event_id: Scalars['uuid'];
};

/** aggregated selection of "event_book" */
export type Event_Book_Aggregate = {
  __typename?: 'event_book_aggregate';
  aggregate?: Maybe<Event_Book_Aggregate_Fields>;
  nodes: Array<Event_Book>;
};

/** aggregate fields of "event_book" */
export type Event_Book_Aggregate_Fields = {
  __typename?: 'event_book_aggregate_fields';
  avg?: Maybe<Event_Book_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Event_Book_Max_Fields>;
  min?: Maybe<Event_Book_Min_Fields>;
  stddev?: Maybe<Event_Book_Stddev_Fields>;
  stddev_pop?: Maybe<Event_Book_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Event_Book_Stddev_Samp_Fields>;
  sum?: Maybe<Event_Book_Sum_Fields>;
  var_pop?: Maybe<Event_Book_Var_Pop_Fields>;
  var_samp?: Maybe<Event_Book_Var_Samp_Fields>;
  variance?: Maybe<Event_Book_Variance_Fields>;
};


/** aggregate fields of "event_book" */
export type Event_Book_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Book_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_book" */
export type Event_Book_Aggregate_Order_By = {
  avg?: InputMaybe<Event_Book_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Event_Book_Max_Order_By>;
  min?: InputMaybe<Event_Book_Min_Order_By>;
  stddev?: InputMaybe<Event_Book_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Event_Book_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Event_Book_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Event_Book_Sum_Order_By>;
  var_pop?: InputMaybe<Event_Book_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Event_Book_Var_Samp_Order_By>;
  variance?: InputMaybe<Event_Book_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "event_book" */
export type Event_Book_Arr_Rel_Insert_Input = {
  data: Array<Event_Book_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_Book_On_Conflict>;
};

/** aggregate avg on columns */
export type Event_Book_Avg_Fields = {
  __typename?: 'event_book_avg_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_book" */
export type Event_Book_Avg_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "event_book". All fields are combined with a logical 'AND'. */
export type Event_Book_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Book_Bool_Exp>>;
  _not?: InputMaybe<Event_Book_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Book_Bool_Exp>>;
  book?: InputMaybe<Books_Bool_Exp>;
  book_isbn?: InputMaybe<Bigint_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "event_book" */
export enum Event_Book_Constraint {
  /** unique or primary key constraint */
  EventBookPkey = 'event_book_pkey'
}

/** input type for incrementing numeric columns in table "event_book" */
export type Event_Book_Inc_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "event_book" */
export type Event_Book_Insert_Input = {
  book?: InputMaybe<Books_Obj_Rel_Insert_Input>;
  book_isbn?: InputMaybe<Scalars['bigint']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Event_Book_Max_Fields = {
  __typename?: 'event_book_max_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  event_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_book" */
export type Event_Book_Max_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Event_Book_Min_Fields = {
  __typename?: 'event_book_min_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  event_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_book" */
export type Event_Book_Min_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "event_book" */
export type Event_Book_Mutation_Response = {
  __typename?: 'event_book_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_Book>;
};

/** on_conflict condition type for table "event_book" */
export type Event_Book_On_Conflict = {
  constraint: Event_Book_Constraint;
  update_columns?: Array<Event_Book_Update_Column>;
  where?: InputMaybe<Event_Book_Bool_Exp>;
};

/** Ordering options when selecting data from "event_book". */
export type Event_Book_Order_By = {
  book?: InputMaybe<Books_Order_By>;
  book_isbn?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: event_book */
export type Event_Book_Pk_Columns_Input = {
  book_isbn: Scalars['bigint'];
  event_id: Scalars['uuid'];
};

/** select columns of table "event_book" */
export enum Event_Book_Select_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  EventId = 'event_id'
}

/** input type for updating data in table "event_book" */
export type Event_Book_Set_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  event_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Event_Book_Stddev_Fields = {
  __typename?: 'event_book_stddev_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_book" */
export type Event_Book_Stddev_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Event_Book_Stddev_Pop_Fields = {
  __typename?: 'event_book_stddev_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_book" */
export type Event_Book_Stddev_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Event_Book_Stddev_Samp_Fields = {
  __typename?: 'event_book_stddev_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_book" */
export type Event_Book_Stddev_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Event_Book_Sum_Fields = {
  __typename?: 'event_book_sum_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_book" */
export type Event_Book_Sum_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** update columns of table "event_book" */
export enum Event_Book_Update_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  EventId = 'event_id'
}

/** aggregate var_pop on columns */
export type Event_Book_Var_Pop_Fields = {
  __typename?: 'event_book_var_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_book" */
export type Event_Book_Var_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Event_Book_Var_Samp_Fields = {
  __typename?: 'event_book_var_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_book" */
export type Event_Book_Var_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Event_Book_Variance_Fields = {
  __typename?: 'event_book_variance_fields';
  book_isbn?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_book" */
export type Event_Book_Variance_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
};

/** columns and relationships of "event_comment" */
export type Event_Comment = {
  __typename?: 'event_comment';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['uuid'];
  comment: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id: Scalars['uuid'];
  id: Scalars['bigint'];
  is_question: Scalars['Boolean'];
  /** An object relationship */
  public_account?: Maybe<Public_Account_Details>;
};

/** aggregated selection of "event_comment" */
export type Event_Comment_Aggregate = {
  __typename?: 'event_comment_aggregate';
  aggregate?: Maybe<Event_Comment_Aggregate_Fields>;
  nodes: Array<Event_Comment>;
};

/** aggregate fields of "event_comment" */
export type Event_Comment_Aggregate_Fields = {
  __typename?: 'event_comment_aggregate_fields';
  avg?: Maybe<Event_Comment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Event_Comment_Max_Fields>;
  min?: Maybe<Event_Comment_Min_Fields>;
  stddev?: Maybe<Event_Comment_Stddev_Fields>;
  stddev_pop?: Maybe<Event_Comment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Event_Comment_Stddev_Samp_Fields>;
  sum?: Maybe<Event_Comment_Sum_Fields>;
  var_pop?: Maybe<Event_Comment_Var_Pop_Fields>;
  var_samp?: Maybe<Event_Comment_Var_Samp_Fields>;
  variance?: Maybe<Event_Comment_Variance_Fields>;
};


/** aggregate fields of "event_comment" */
export type Event_Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Event_Comment_Avg_Fields = {
  __typename?: 'event_comment_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event_comment". All fields are combined with a logical 'AND'. */
export type Event_Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Comment_Bool_Exp>>;
  _not?: InputMaybe<Event_Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Comment_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_question?: InputMaybe<Boolean_Comparison_Exp>;
  public_account?: InputMaybe<Public_Account_Details_Bool_Exp>;
};

/** unique or primary key constraints on table "event_comment" */
export enum Event_Comment_Constraint {
  /** unique or primary key constraint */
  EventCommentPkey = 'event_comment_pkey'
}

/** input type for incrementing numeric columns in table "event_comment" */
export type Event_Comment_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "event_comment" */
export type Event_Comment_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_question?: InputMaybe<Scalars['Boolean']>;
  public_account?: InputMaybe<Public_Account_Details_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Event_Comment_Max_Fields = {
  __typename?: 'event_comment_max_fields';
  account_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Event_Comment_Min_Fields = {
  __typename?: 'event_comment_min_fields';
  account_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "event_comment" */
export type Event_Comment_Mutation_Response = {
  __typename?: 'event_comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_Comment>;
};

/** on_conflict condition type for table "event_comment" */
export type Event_Comment_On_Conflict = {
  constraint: Event_Comment_Constraint;
  update_columns?: Array<Event_Comment_Update_Column>;
  where?: InputMaybe<Event_Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "event_comment". */
export type Event_Comment_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_question?: InputMaybe<Order_By>;
  public_account?: InputMaybe<Public_Account_Details_Order_By>;
};

/** primary key columns input for table: event_comment */
export type Event_Comment_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "event_comment" */
export enum Event_Comment_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsQuestion = 'is_question'
}

/** input type for updating data in table "event_comment" */
export type Event_Comment_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_question?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Event_Comment_Stddev_Fields = {
  __typename?: 'event_comment_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Event_Comment_Stddev_Pop_Fields = {
  __typename?: 'event_comment_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Event_Comment_Stddev_Samp_Fields = {
  __typename?: 'event_comment_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Event_Comment_Sum_Fields = {
  __typename?: 'event_comment_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "event_comment" */
export enum Event_Comment_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsQuestion = 'is_question'
}

/** aggregate var_pop on columns */
export type Event_Comment_Var_Pop_Fields = {
  __typename?: 'event_comment_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Event_Comment_Var_Samp_Fields = {
  __typename?: 'event_comment_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Event_Comment_Variance_Fields = {
  __typename?: 'event_comment_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "event_tickets" */
export type Event_Tickets = {
  __typename?: 'event_tickets';
  /** An object relationship */
  address: Addresses;
  address_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  event: Events;
  event_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_attending: Scalars['Boolean'];
  is_free_attendee: Scalars['Boolean'];
  is_online_viewer: Scalars['Boolean'];
  /** An object relationship */
  order?: Maybe<Orders>;
  /** An object relationship */
  order_book?: Maybe<Order_Book>;
  order_book_id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  voucher?: Maybe<Vouchers>;
  voucher_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "event_tickets" */
export type Event_Tickets_Aggregate = {
  __typename?: 'event_tickets_aggregate';
  aggregate?: Maybe<Event_Tickets_Aggregate_Fields>;
  nodes: Array<Event_Tickets>;
};

/** aggregate fields of "event_tickets" */
export type Event_Tickets_Aggregate_Fields = {
  __typename?: 'event_tickets_aggregate_fields';
  avg?: Maybe<Event_Tickets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Event_Tickets_Max_Fields>;
  min?: Maybe<Event_Tickets_Min_Fields>;
  stddev?: Maybe<Event_Tickets_Stddev_Fields>;
  stddev_pop?: Maybe<Event_Tickets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Event_Tickets_Stddev_Samp_Fields>;
  sum?: Maybe<Event_Tickets_Sum_Fields>;
  var_pop?: Maybe<Event_Tickets_Var_Pop_Fields>;
  var_samp?: Maybe<Event_Tickets_Var_Samp_Fields>;
  variance?: Maybe<Event_Tickets_Variance_Fields>;
};


/** aggregate fields of "event_tickets" */
export type Event_Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_tickets" */
export type Event_Tickets_Aggregate_Order_By = {
  avg?: InputMaybe<Event_Tickets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Event_Tickets_Max_Order_By>;
  min?: InputMaybe<Event_Tickets_Min_Order_By>;
  stddev?: InputMaybe<Event_Tickets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Event_Tickets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Event_Tickets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Event_Tickets_Sum_Order_By>;
  var_pop?: InputMaybe<Event_Tickets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Event_Tickets_Var_Samp_Order_By>;
  variance?: InputMaybe<Event_Tickets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "event_tickets" */
export type Event_Tickets_Arr_Rel_Insert_Input = {
  data: Array<Event_Tickets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_Tickets_On_Conflict>;
};

/** aggregate avg on columns */
export type Event_Tickets_Avg_Fields = {
  __typename?: 'event_tickets_avg_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_tickets" */
export type Event_Tickets_Avg_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "event_tickets". All fields are combined with a logical 'AND'. */
export type Event_Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Tickets_Bool_Exp>>;
  _not?: InputMaybe<Event_Tickets_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Tickets_Bool_Exp>>;
  address?: InputMaybe<Addresses_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_attending?: InputMaybe<Boolean_Comparison_Exp>;
  is_free_attendee?: InputMaybe<Boolean_Comparison_Exp>;
  is_online_viewer?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_book?: InputMaybe<Order_Book_Bool_Exp>;
  order_book_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  voucher?: InputMaybe<Vouchers_Bool_Exp>;
  voucher_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "event_tickets" */
export enum Event_Tickets_Constraint {
  /** unique or primary key constraint */
  EventTicketsIdKey = 'event_tickets_id_key',
  /** unique or primary key constraint */
  EventTicketsPkey = 'event_tickets_pkey'
}

/** input type for incrementing numeric columns in table "event_tickets" */
export type Event_Tickets_Inc_Input = {
  order_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "event_tickets" */
export type Event_Tickets_Insert_Input = {
  address?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_attending?: InputMaybe<Scalars['Boolean']>;
  is_free_attendee?: InputMaybe<Scalars['Boolean']>;
  is_online_viewer?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_book?: InputMaybe<Order_Book_Obj_Rel_Insert_Input>;
  order_book_id?: InputMaybe<Scalars['uuid']>;
  order_id?: InputMaybe<Scalars['Int']>;
  voucher?: InputMaybe<Vouchers_Obj_Rel_Insert_Input>;
  voucher_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Event_Tickets_Max_Fields = {
  __typename?: 'event_tickets_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order_book_id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  voucher_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "event_tickets" */
export type Event_Tickets_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_book_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Event_Tickets_Min_Fields = {
  __typename?: 'event_tickets_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order_book_id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  voucher_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "event_tickets" */
export type Event_Tickets_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_book_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "event_tickets" */
export type Event_Tickets_Mutation_Response = {
  __typename?: 'event_tickets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_Tickets>;
};

/** on_conflict condition type for table "event_tickets" */
export type Event_Tickets_On_Conflict = {
  constraint: Event_Tickets_Constraint;
  update_columns?: Array<Event_Tickets_Update_Column>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};

/** Ordering options when selecting data from "event_tickets". */
export type Event_Tickets_Order_By = {
  address?: InputMaybe<Addresses_Order_By>;
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_attending?: InputMaybe<Order_By>;
  is_free_attendee?: InputMaybe<Order_By>;
  is_online_viewer?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_book?: InputMaybe<Order_Book_Order_By>;
  order_book_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  voucher?: InputMaybe<Vouchers_Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: event_tickets */
export type Event_Tickets_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "event_tickets" */
export enum Event_Tickets_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttending = 'is_attending',
  /** column name */
  IsFreeAttendee = 'is_free_attendee',
  /** column name */
  IsOnlineViewer = 'is_online_viewer',
  /** column name */
  OrderBookId = 'order_book_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  VoucherId = 'voucher_id'
}

/** input type for updating data in table "event_tickets" */
export type Event_Tickets_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_attending?: InputMaybe<Scalars['Boolean']>;
  is_free_attendee?: InputMaybe<Scalars['Boolean']>;
  is_online_viewer?: InputMaybe<Scalars['Boolean']>;
  order_book_id?: InputMaybe<Scalars['uuid']>;
  order_id?: InputMaybe<Scalars['Int']>;
  voucher_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Event_Tickets_Stddev_Fields = {
  __typename?: 'event_tickets_stddev_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_tickets" */
export type Event_Tickets_Stddev_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Event_Tickets_Stddev_Pop_Fields = {
  __typename?: 'event_tickets_stddev_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_tickets" */
export type Event_Tickets_Stddev_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Event_Tickets_Stddev_Samp_Fields = {
  __typename?: 'event_tickets_stddev_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_tickets" */
export type Event_Tickets_Stddev_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Event_Tickets_Sum_Fields = {
  __typename?: 'event_tickets_sum_fields';
  order_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "event_tickets" */
export type Event_Tickets_Sum_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** update columns of table "event_tickets" */
export enum Event_Tickets_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsAttending = 'is_attending',
  /** column name */
  IsFreeAttendee = 'is_free_attendee',
  /** column name */
  IsOnlineViewer = 'is_online_viewer',
  /** column name */
  OrderBookId = 'order_book_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  VoucherId = 'voucher_id'
}

/** aggregate var_pop on columns */
export type Event_Tickets_Var_Pop_Fields = {
  __typename?: 'event_tickets_var_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_tickets" */
export type Event_Tickets_Var_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Event_Tickets_Var_Samp_Fields = {
  __typename?: 'event_tickets_var_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_tickets" */
export type Event_Tickets_Var_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Event_Tickets_Variance_Fields = {
  __typename?: 'event_tickets_variance_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_tickets" */
export type Event_Tickets_Variance_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'events';
  /** An array relationship */
  attendees: Array<Event_Tickets>;
  /** An aggregate relationship */
  attendees_aggregate: Event_Tickets_Aggregate;
  /** An array relationship */
  category_events: Array<Category_Event>;
  /** An aggregate relationship */
  category_events_aggregate: Category_Event_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  enable_comments: Scalars['Boolean'];
  end_time: Scalars['timestamp'];
  /** An array relationship */
  event_books: Array<Event_Book>;
  /** An aggregate relationship */
  event_books_aggregate: Event_Book_Aggregate;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** An object relationship */
  festival?: Maybe<Events>;
  festival_id?: Maybe<Scalars['uuid']>;
  free_seats?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  image?: Maybe<Scalars['String']>;
  is_book_club: Scalars['Boolean'];
  is_cancelled: Scalars['Boolean'];
  is_festival: Scalars['Boolean'];
  is_in_person_only?: Maybe<Scalars['Boolean']>;
  is_online_only: Scalars['Boolean'];
  location?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  seats?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  speakers?: Maybe<Scalars['String']>;
  start_time: Scalars['timestamp'];
  title: Scalars['String'];
  ts_vector?: Maybe<Scalars['tsvector']>;
  video?: Maybe<Scalars['String']>;
  video_conf_location?: Maybe<Scalars['String']>;
};


/** columns and relationships of "events" */
export type EventsAttendeesArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsAttendees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsCategory_EventsArgs = {
  distinct_on?: InputMaybe<Array<Category_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Event_Order_By>>;
  where?: InputMaybe<Category_Event_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsCategory_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Event_Order_By>>;
  where?: InputMaybe<Category_Event_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEvent_BooksArgs = {
  distinct_on?: InputMaybe<Array<Event_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Book_Order_By>>;
  where?: InputMaybe<Event_Book_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEvent_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Book_Order_By>>;
  where?: InputMaybe<Event_Book_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** aggregated selection of "events" */
export type Events_Aggregate = {
  __typename?: 'events_aggregate';
  aggregate?: Maybe<Events_Aggregate_Fields>;
  nodes: Array<Events>;
};

/** aggregate fields of "events" */
export type Events_Aggregate_Fields = {
  __typename?: 'events_aggregate_fields';
  avg?: Maybe<Events_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Events_Max_Fields>;
  min?: Maybe<Events_Min_Fields>;
  stddev?: Maybe<Events_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Sum_Fields>;
  var_pop?: Maybe<Events_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Var_Samp_Fields>;
  variance?: Maybe<Events_Variance_Fields>;
};


/** aggregate fields of "events" */
export type Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "events" */
export type Events_Aggregate_Order_By = {
  avg?: InputMaybe<Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Events_Max_Order_By>;
  min?: InputMaybe<Events_Min_Order_By>;
  stddev?: InputMaybe<Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Events_Sum_Order_By>;
  var_pop?: InputMaybe<Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Events_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "events" */
export type Events_Arr_Rel_Insert_Input = {
  data: Array<Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Events_Avg_Fields = {
  __typename?: 'events_avg_fields';
  free_seats?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  seats?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "events" */
export type Events_Avg_Order_By = {
  free_seats?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Bool_Exp>>;
  _not?: InputMaybe<Events_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Bool_Exp>>;
  attendees?: InputMaybe<Event_Tickets_Bool_Exp>;
  category_events?: InputMaybe<Category_Event_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  enable_comments?: InputMaybe<Boolean_Comparison_Exp>;
  end_time?: InputMaybe<Timestamp_Comparison_Exp>;
  event_books?: InputMaybe<Event_Book_Bool_Exp>;
  events?: InputMaybe<Events_Bool_Exp>;
  festival?: InputMaybe<Events_Bool_Exp>;
  festival_id?: InputMaybe<Uuid_Comparison_Exp>;
  free_seats?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  is_book_club?: InputMaybe<Boolean_Comparison_Exp>;
  is_cancelled?: InputMaybe<Boolean_Comparison_Exp>;
  is_festival?: InputMaybe<Boolean_Comparison_Exp>;
  is_in_person_only?: InputMaybe<Boolean_Comparison_Exp>;
  is_online_only?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  seats?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  speakers?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Timestamp_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  ts_vector?: InputMaybe<Tsvector_Comparison_Exp>;
  video?: InputMaybe<String_Comparison_Exp>;
  video_conf_location?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "events" */
export enum Events_Constraint {
  /** unique or primary key constraint */
  EventsPkey = 'events_pkey',
  /** unique or primary key constraint */
  EventsSlugKey = 'events_slug_key'
}

/** input type for incrementing numeric columns in table "events" */
export type Events_Inc_Input = {
  free_seats?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  seats?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "events" */
export type Events_Insert_Input = {
  attendees?: InputMaybe<Event_Tickets_Arr_Rel_Insert_Input>;
  category_events?: InputMaybe<Category_Event_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enable_comments?: InputMaybe<Scalars['Boolean']>;
  end_time?: InputMaybe<Scalars['timestamp']>;
  event_books?: InputMaybe<Event_Book_Arr_Rel_Insert_Input>;
  events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  festival?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  festival_id?: InputMaybe<Scalars['uuid']>;
  free_seats?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  image?: InputMaybe<Scalars['String']>;
  is_book_club?: InputMaybe<Scalars['Boolean']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  is_festival?: InputMaybe<Scalars['Boolean']>;
  is_in_person_only?: InputMaybe<Scalars['Boolean']>;
  is_online_only?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  seats?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  speakers?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamp']>;
  title?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
  video?: InputMaybe<Scalars['String']>;
  video_conf_location?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Events_Max_Fields = {
  __typename?: 'events_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['timestamp']>;
  festival_id?: Maybe<Scalars['uuid']>;
  free_seats?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  image?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  seats?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  speakers?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamp']>;
  title?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  video_conf_location?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "events" */
export type Events_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  festival_id?: InputMaybe<Order_By>;
  free_seats?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  speakers?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  video?: InputMaybe<Order_By>;
  video_conf_location?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Events_Min_Fields = {
  __typename?: 'events_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['timestamp']>;
  festival_id?: Maybe<Scalars['uuid']>;
  free_seats?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  image?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  seats?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  speakers?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamp']>;
  title?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  video_conf_location?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "events" */
export type Events_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  festival_id?: InputMaybe<Order_By>;
  free_seats?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  speakers?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  video?: InputMaybe<Order_By>;
  video_conf_location?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "events" */
export type Events_Mutation_Response = {
  __typename?: 'events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Events>;
};

/** input type for inserting object relation for remote table "events" */
export type Events_Obj_Rel_Insert_Input = {
  data: Events_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_Conflict>;
};

/** on_conflict condition type for table "events" */
export type Events_On_Conflict = {
  constraint: Events_Constraint;
  update_columns?: Array<Events_Update_Column>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** Ordering options when selecting data from "events". */
export type Events_Order_By = {
  attendees_aggregate?: InputMaybe<Event_Tickets_Aggregate_Order_By>;
  category_events_aggregate?: InputMaybe<Category_Event_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  enable_comments?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  event_books_aggregate?: InputMaybe<Event_Book_Aggregate_Order_By>;
  events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  festival?: InputMaybe<Events_Order_By>;
  festival_id?: InputMaybe<Order_By>;
  free_seats?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  is_book_club?: InputMaybe<Order_By>;
  is_cancelled?: InputMaybe<Order_By>;
  is_festival?: InputMaybe<Order_By>;
  is_in_person_only?: InputMaybe<Order_By>;
  is_online_only?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  speakers?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  ts_vector?: InputMaybe<Order_By>;
  video?: InputMaybe<Order_By>;
  video_conf_location?: InputMaybe<Order_By>;
};

/** primary key columns input for table: events */
export type Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "events" */
export enum Events_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EnableComments = 'enable_comments',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  FestivalId = 'festival_id',
  /** column name */
  FreeSeats = 'free_seats',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsBookClub = 'is_book_club',
  /** column name */
  IsCancelled = 'is_cancelled',
  /** column name */
  IsFestival = 'is_festival',
  /** column name */
  IsInPersonOnly = 'is_in_person_only',
  /** column name */
  IsOnlineOnly = 'is_online_only',
  /** column name */
  Location = 'location',
  /** column name */
  Notes = 'notes',
  /** column name */
  Price = 'price',
  /** column name */
  Seats = 'seats',
  /** column name */
  Slug = 'slug',
  /** column name */
  Speakers = 'speakers',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Title = 'title',
  /** column name */
  TsVector = 'ts_vector',
  /** column name */
  Video = 'video',
  /** column name */
  VideoConfLocation = 'video_conf_location'
}

/** input type for updating data in table "events" */
export type Events_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enable_comments?: InputMaybe<Scalars['Boolean']>;
  end_time?: InputMaybe<Scalars['timestamp']>;
  festival_id?: InputMaybe<Scalars['uuid']>;
  free_seats?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  image?: InputMaybe<Scalars['String']>;
  is_book_club?: InputMaybe<Scalars['Boolean']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  is_festival?: InputMaybe<Scalars['Boolean']>;
  is_in_person_only?: InputMaybe<Scalars['Boolean']>;
  is_online_only?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  seats?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  speakers?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamp']>;
  title?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
  video?: InputMaybe<Scalars['String']>;
  video_conf_location?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Events_Stddev_Fields = {
  __typename?: 'events_stddev_fields';
  free_seats?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  seats?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "events" */
export type Events_Stddev_Order_By = {
  free_seats?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Events_Stddev_Pop_Fields = {
  __typename?: 'events_stddev_pop_fields';
  free_seats?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  seats?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "events" */
export type Events_Stddev_Pop_Order_By = {
  free_seats?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Events_Stddev_Samp_Fields = {
  __typename?: 'events_stddev_samp_fields';
  free_seats?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  seats?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "events" */
export type Events_Stddev_Samp_Order_By = {
  free_seats?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Events_Sum_Fields = {
  __typename?: 'events_sum_fields';
  free_seats?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  seats?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "events" */
export type Events_Sum_Order_By = {
  free_seats?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
};

/** update columns of table "events" */
export enum Events_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EnableComments = 'enable_comments',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  FestivalId = 'festival_id',
  /** column name */
  FreeSeats = 'free_seats',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsBookClub = 'is_book_club',
  /** column name */
  IsCancelled = 'is_cancelled',
  /** column name */
  IsFestival = 'is_festival',
  /** column name */
  IsInPersonOnly = 'is_in_person_only',
  /** column name */
  IsOnlineOnly = 'is_online_only',
  /** column name */
  Location = 'location',
  /** column name */
  Notes = 'notes',
  /** column name */
  Price = 'price',
  /** column name */
  Seats = 'seats',
  /** column name */
  Slug = 'slug',
  /** column name */
  Speakers = 'speakers',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Title = 'title',
  /** column name */
  TsVector = 'ts_vector',
  /** column name */
  Video = 'video',
  /** column name */
  VideoConfLocation = 'video_conf_location'
}

/** aggregate var_pop on columns */
export type Events_Var_Pop_Fields = {
  __typename?: 'events_var_pop_fields';
  free_seats?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  seats?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "events" */
export type Events_Var_Pop_Order_By = {
  free_seats?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Events_Var_Samp_Fields = {
  __typename?: 'events_var_samp_fields';
  free_seats?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  seats?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "events" */
export type Events_Var_Samp_Order_By = {
  free_seats?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Events_Variance_Fields = {
  __typename?: 'events_variance_fields';
  free_seats?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  seats?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "events" */
export type Events_Variance_Order_By = {
  free_seats?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  seats?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "accounts" */
  delete_accounts?: Maybe<Accounts_Mutation_Response>;
  /** delete single row from the table: "accounts" */
  delete_accounts_by_pk?: Maybe<Accounts>;
  /** delete data from the table: "addresses" */
  delete_addresses?: Maybe<Addresses_Mutation_Response>;
  /** delete single row from the table: "addresses" */
  delete_addresses_by_pk?: Maybe<Addresses>;
  /** delete data from the table: "book_discount" */
  delete_book_discount?: Maybe<Book_Discount_Mutation_Response>;
  /** delete single row from the table: "book_discount" */
  delete_book_discount_by_pk?: Maybe<Book_Discount>;
  /** delete data from the table: "books" */
  delete_books?: Maybe<Books_Mutation_Response>;
  /** delete single row from the table: "books" */
  delete_books_by_pk?: Maybe<Books>;
  /** delete data from the table: "booksellers" */
  delete_booksellers?: Maybe<Booksellers_Mutation_Response>;
  /** delete single row from the table: "booksellers" */
  delete_booksellers_by_pk?: Maybe<Booksellers>;
  /** delete data from the table: "categories" */
  delete_categories?: Maybe<Categories_Mutation_Response>;
  /** delete single row from the table: "categories" */
  delete_categories_by_pk?: Maybe<Categories>;
  /** delete data from the table: "category_book" */
  delete_category_book?: Maybe<Category_Book_Mutation_Response>;
  /** delete single row from the table: "category_book" */
  delete_category_book_by_pk?: Maybe<Category_Book>;
  /** delete data from the table: "category_event" */
  delete_category_event?: Maybe<Category_Event_Mutation_Response>;
  /** delete single row from the table: "category_event" */
  delete_category_event_by_pk?: Maybe<Category_Event>;
  /** delete data from the table: "category_post" */
  delete_category_post?: Maybe<Category_Post_Mutation_Response>;
  /** delete single row from the table: "category_post" */
  delete_category_post_by_pk?: Maybe<Category_Post>;
  /** delete data from the table: "children_categories" */
  delete_children_categories?: Maybe<Children_Categories_Mutation_Response>;
  /** delete single row from the table: "children_categories" */
  delete_children_categories_by_pk?: Maybe<Children_Categories>;
  /** delete data from the table: "children_category_books" */
  delete_children_category_books?: Maybe<Children_Category_Books_Mutation_Response>;
  /** delete single row from the table: "children_category_books" */
  delete_children_category_books_by_pk?: Maybe<Children_Category_Books>;
  /** delete data from the table: "contents" */
  delete_contents?: Maybe<Contents_Mutation_Response>;
  /** delete single row from the table: "contents" */
  delete_contents_by_pk?: Maybe<Contents>;
  /** delete data from the table: "countries" */
  delete_countries?: Maybe<Countries_Mutation_Response>;
  /** delete single row from the table: "countries" */
  delete_countries_by_pk?: Maybe<Countries>;
  /** delete data from the table: "discount_type" */
  delete_discount_type?: Maybe<Discount_Type_Mutation_Response>;
  /** delete single row from the table: "discount_type" */
  delete_discount_type_by_pk?: Maybe<Discount_Type>;
  /** delete data from the table: "discounts" */
  delete_discounts?: Maybe<Discounts_Mutation_Response>;
  /** delete single row from the table: "discounts" */
  delete_discounts_by_pk?: Maybe<Discounts>;
  /** delete data from the table: "empty_searches" */
  delete_empty_searches?: Maybe<Empty_Searches_Mutation_Response>;
  /** delete single row from the table: "empty_searches" */
  delete_empty_searches_by_pk?: Maybe<Empty_Searches>;
  /** delete data from the table: "event_book" */
  delete_event_book?: Maybe<Event_Book_Mutation_Response>;
  /** delete single row from the table: "event_book" */
  delete_event_book_by_pk?: Maybe<Event_Book>;
  /** delete data from the table: "event_comment" */
  delete_event_comment?: Maybe<Event_Comment_Mutation_Response>;
  /** delete single row from the table: "event_comment" */
  delete_event_comment_by_pk?: Maybe<Event_Comment>;
  /** delete data from the table: "event_tickets" */
  delete_event_tickets?: Maybe<Event_Tickets_Mutation_Response>;
  /** delete single row from the table: "event_tickets" */
  delete_event_tickets_by_pk?: Maybe<Event_Tickets>;
  /** delete data from the table: "events" */
  delete_events?: Maybe<Events_Mutation_Response>;
  /** delete single row from the table: "events" */
  delete_events_by_pk?: Maybe<Events>;
  /** delete data from the table: "order_book" */
  delete_order_book?: Maybe<Order_Book_Mutation_Response>;
  /** delete single row from the table: "order_book" */
  delete_order_book_by_pk?: Maybe<Order_Book>;
  /** delete data from the table: "order_item_status" */
  delete_order_item_status?: Maybe<Order_Item_Status_Mutation_Response>;
  /** delete single row from the table: "order_item_status" */
  delete_order_item_status_by_pk?: Maybe<Order_Item_Status>;
  /** delete data from the table: "order_product" */
  delete_order_product?: Maybe<Order_Product_Mutation_Response>;
  /** delete single row from the table: "order_product" */
  delete_order_product_by_pk?: Maybe<Order_Product>;
  /** delete data from the table: "order_status" */
  delete_order_status?: Maybe<Order_Status_Mutation_Response>;
  /** delete single row from the table: "order_status" */
  delete_order_status_by_pk?: Maybe<Order_Status>;
  /** delete data from the table: "order_subscription_object" */
  delete_order_subscription_object?: Maybe<Order_Subscription_Object_Mutation_Response>;
  /** delete single row from the table: "order_subscription_object" */
  delete_order_subscription_object_by_pk?: Maybe<Order_Subscription_Object>;
  /** delete data from the table: "order_subscription_price" */
  delete_order_subscription_price?: Maybe<Order_Subscription_Price_Mutation_Response>;
  /** delete single row from the table: "order_subscription_price" */
  delete_order_subscription_price_by_pk?: Maybe<Order_Subscription_Price>;
  /** delete data from the table: "order_voucher" */
  delete_order_voucher?: Maybe<Order_Voucher_Mutation_Response>;
  /** delete single row from the table: "order_voucher" */
  delete_order_voucher_by_pk?: Maybe<Order_Voucher>;
  /** delete data from the table: "orders" */
  delete_orders?: Maybe<Orders_Mutation_Response>;
  /** delete single row from the table: "orders" */
  delete_orders_by_pk?: Maybe<Orders>;
  /** delete data from the table: "pages" */
  delete_pages?: Maybe<Pages_Mutation_Response>;
  /** delete single row from the table: "pages" */
  delete_pages_by_pk?: Maybe<Pages>;
  /** delete data from the table: "pif_donations" */
  delete_pif_donations?: Maybe<Pif_Donations_Mutation_Response>;
  /** delete single row from the table: "pif_donations" */
  delete_pif_donations_by_pk?: Maybe<Pif_Donations>;
  /** delete data from the table: "post_book" */
  delete_post_book?: Maybe<Post_Book_Mutation_Response>;
  /** delete single row from the table: "post_book" */
  delete_post_book_by_pk?: Maybe<Post_Book>;
  /** delete data from the table: "posts" */
  delete_posts?: Maybe<Posts_Mutation_Response>;
  /** delete single row from the table: "posts" */
  delete_posts_by_pk?: Maybe<Posts>;
  /** delete data from the table: "products" */
  delete_products?: Maybe<Products_Mutation_Response>;
  /** delete single row from the table: "products" */
  delete_products_by_pk?: Maybe<Products>;
  /** delete data from the table: "public_account_details" */
  delete_public_account_details?: Maybe<Public_Account_Details_Mutation_Response>;
  /** delete data from the table: "refresh_tokens" */
  delete_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>;
  /** delete single row from the table: "refresh_tokens" */
  delete_refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** delete data from the table: "refunds" */
  delete_refunds?: Maybe<Refunds_Mutation_Response>;
  /** delete single row from the table: "refunds" */
  delete_refunds_by_pk?: Maybe<Refunds>;
  /** delete data from the table: "regions" */
  delete_regions?: Maybe<Regions_Mutation_Response>;
  /** delete single row from the table: "regions" */
  delete_regions_by_pk?: Maybe<Regions>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "shipping_options" */
  delete_shipping_options?: Maybe<Shipping_Options_Mutation_Response>;
  /** delete single row from the table: "shipping_options" */
  delete_shipping_options_by_pk?: Maybe<Shipping_Options>;
  /** delete data from the table: "subscription_dispatch" */
  delete_subscription_dispatch?: Maybe<Subscription_Dispatch_Mutation_Response>;
  /** delete single row from the table: "subscription_dispatch" */
  delete_subscription_dispatch_by_pk?: Maybe<Subscription_Dispatch>;
  /** delete data from the table: "subscription_dispatch_subscription_object" */
  delete_subscription_dispatch_subscription_object?: Maybe<Subscription_Dispatch_Subscription_Object_Mutation_Response>;
  /** delete single row from the table: "subscription_dispatch_subscription_object" */
  delete_subscription_dispatch_subscription_object_by_pk?: Maybe<Subscription_Dispatch_Subscription_Object>;
  /** delete data from the table: "subscription_draft_object" */
  delete_subscription_draft_object?: Maybe<Subscription_Draft_Object_Mutation_Response>;
  /** delete single row from the table: "subscription_draft_object" */
  delete_subscription_draft_object_by_pk?: Maybe<Subscription_Draft_Object>;
  /** delete data from the table: "subscription_object" */
  delete_subscription_object?: Maybe<Subscription_Object_Mutation_Response>;
  /** delete single row from the table: "subscription_object" */
  delete_subscription_object_by_pk?: Maybe<Subscription_Object>;
  /** delete data from the table: "subscription_object_credit" */
  delete_subscription_object_credit?: Maybe<Subscription_Object_Credit_Mutation_Response>;
  /** delete single row from the table: "subscription_object_credit" */
  delete_subscription_object_credit_by_pk?: Maybe<Subscription_Object_Credit>;
  /** delete data from the table: "subscription_price" */
  delete_subscription_price?: Maybe<Subscription_Price_Mutation_Response>;
  /** delete single row from the table: "subscription_price" */
  delete_subscription_price_by_pk?: Maybe<Subscription_Price>;
  /** delete data from the table: "subscriptions" */
  delete_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** delete single row from the table: "subscriptions" */
  delete_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** delete data from the table: "tag_book" */
  delete_tag_book?: Maybe<Tag_Book_Mutation_Response>;
  /** delete single row from the table: "tag_book" */
  delete_tag_book_by_pk?: Maybe<Tag_Book>;
  /** delete data from the table: "tags" */
  delete_tags?: Maybe<Tags_Mutation_Response>;
  /** delete single row from the table: "tags" */
  delete_tags_by_pk?: Maybe<Tags>;
  /** delete data from the table: "unstructured_data" */
  delete_unstructured_data?: Maybe<Unstructured_Data_Mutation_Response>;
  /** delete single row from the table: "unstructured_data" */
  delete_unstructured_data_by_pk?: Maybe<Unstructured_Data>;
  /** delete data from the table: "vouchers" */
  delete_vouchers?: Maybe<Vouchers_Mutation_Response>;
  /** delete single row from the table: "vouchers" */
  delete_vouchers_by_pk?: Maybe<Vouchers>;
  /** insert data into the table: "accounts" */
  insert_accounts?: Maybe<Accounts_Mutation_Response>;
  /** insert a single row into the table: "accounts" */
  insert_accounts_one?: Maybe<Accounts>;
  /** insert data into the table: "addresses" */
  insert_addresses?: Maybe<Addresses_Mutation_Response>;
  /** insert a single row into the table: "addresses" */
  insert_addresses_one?: Maybe<Addresses>;
  /** insert data into the table: "book_discount" */
  insert_book_discount?: Maybe<Book_Discount_Mutation_Response>;
  /** insert a single row into the table: "book_discount" */
  insert_book_discount_one?: Maybe<Book_Discount>;
  /** insert data into the table: "books" */
  insert_books?: Maybe<Books_Mutation_Response>;
  /** insert a single row into the table: "books" */
  insert_books_one?: Maybe<Books>;
  /** insert data into the table: "booksellers" */
  insert_booksellers?: Maybe<Booksellers_Mutation_Response>;
  /** insert a single row into the table: "booksellers" */
  insert_booksellers_one?: Maybe<Booksellers>;
  /** insert data into the table: "categories" */
  insert_categories?: Maybe<Categories_Mutation_Response>;
  /** insert a single row into the table: "categories" */
  insert_categories_one?: Maybe<Categories>;
  /** insert data into the table: "category_book" */
  insert_category_book?: Maybe<Category_Book_Mutation_Response>;
  /** insert a single row into the table: "category_book" */
  insert_category_book_one?: Maybe<Category_Book>;
  /** insert data into the table: "category_event" */
  insert_category_event?: Maybe<Category_Event_Mutation_Response>;
  /** insert a single row into the table: "category_event" */
  insert_category_event_one?: Maybe<Category_Event>;
  /** insert data into the table: "category_post" */
  insert_category_post?: Maybe<Category_Post_Mutation_Response>;
  /** insert a single row into the table: "category_post" */
  insert_category_post_one?: Maybe<Category_Post>;
  /** insert data into the table: "children_categories" */
  insert_children_categories?: Maybe<Children_Categories_Mutation_Response>;
  /** insert a single row into the table: "children_categories" */
  insert_children_categories_one?: Maybe<Children_Categories>;
  /** insert data into the table: "children_category_books" */
  insert_children_category_books?: Maybe<Children_Category_Books_Mutation_Response>;
  /** insert a single row into the table: "children_category_books" */
  insert_children_category_books_one?: Maybe<Children_Category_Books>;
  /** insert data into the table: "contents" */
  insert_contents?: Maybe<Contents_Mutation_Response>;
  /** insert a single row into the table: "contents" */
  insert_contents_one?: Maybe<Contents>;
  /** insert data into the table: "countries" */
  insert_countries?: Maybe<Countries_Mutation_Response>;
  /** insert a single row into the table: "countries" */
  insert_countries_one?: Maybe<Countries>;
  /** insert data into the table: "discount_type" */
  insert_discount_type?: Maybe<Discount_Type_Mutation_Response>;
  /** insert a single row into the table: "discount_type" */
  insert_discount_type_one?: Maybe<Discount_Type>;
  /** insert data into the table: "discounts" */
  insert_discounts?: Maybe<Discounts_Mutation_Response>;
  /** insert a single row into the table: "discounts" */
  insert_discounts_one?: Maybe<Discounts>;
  /** insert data into the table: "empty_searches" */
  insert_empty_searches?: Maybe<Empty_Searches_Mutation_Response>;
  /** insert a single row into the table: "empty_searches" */
  insert_empty_searches_one?: Maybe<Empty_Searches>;
  /** insert data into the table: "event_book" */
  insert_event_book?: Maybe<Event_Book_Mutation_Response>;
  /** insert a single row into the table: "event_book" */
  insert_event_book_one?: Maybe<Event_Book>;
  /** insert data into the table: "event_comment" */
  insert_event_comment?: Maybe<Event_Comment_Mutation_Response>;
  /** insert a single row into the table: "event_comment" */
  insert_event_comment_one?: Maybe<Event_Comment>;
  /** insert data into the table: "event_tickets" */
  insert_event_tickets?: Maybe<Event_Tickets_Mutation_Response>;
  /** insert a single row into the table: "event_tickets" */
  insert_event_tickets_one?: Maybe<Event_Tickets>;
  /** insert data into the table: "events" */
  insert_events?: Maybe<Events_Mutation_Response>;
  /** insert a single row into the table: "events" */
  insert_events_one?: Maybe<Events>;
  /** insert data into the table: "order_book" */
  insert_order_book?: Maybe<Order_Book_Mutation_Response>;
  /** insert a single row into the table: "order_book" */
  insert_order_book_one?: Maybe<Order_Book>;
  /** insert data into the table: "order_item_status" */
  insert_order_item_status?: Maybe<Order_Item_Status_Mutation_Response>;
  /** insert a single row into the table: "order_item_status" */
  insert_order_item_status_one?: Maybe<Order_Item_Status>;
  /** insert data into the table: "order_product" */
  insert_order_product?: Maybe<Order_Product_Mutation_Response>;
  /** insert a single row into the table: "order_product" */
  insert_order_product_one?: Maybe<Order_Product>;
  /** insert data into the table: "order_status" */
  insert_order_status?: Maybe<Order_Status_Mutation_Response>;
  /** insert a single row into the table: "order_status" */
  insert_order_status_one?: Maybe<Order_Status>;
  /** insert data into the table: "order_subscription_object" */
  insert_order_subscription_object?: Maybe<Order_Subscription_Object_Mutation_Response>;
  /** insert a single row into the table: "order_subscription_object" */
  insert_order_subscription_object_one?: Maybe<Order_Subscription_Object>;
  /** insert data into the table: "order_subscription_price" */
  insert_order_subscription_price?: Maybe<Order_Subscription_Price_Mutation_Response>;
  /** insert a single row into the table: "order_subscription_price" */
  insert_order_subscription_price_one?: Maybe<Order_Subscription_Price>;
  /** insert data into the table: "order_voucher" */
  insert_order_voucher?: Maybe<Order_Voucher_Mutation_Response>;
  /** insert a single row into the table: "order_voucher" */
  insert_order_voucher_one?: Maybe<Order_Voucher>;
  /** insert data into the table: "orders" */
  insert_orders?: Maybe<Orders_Mutation_Response>;
  /** insert a single row into the table: "orders" */
  insert_orders_one?: Maybe<Orders>;
  /** insert data into the table: "pages" */
  insert_pages?: Maybe<Pages_Mutation_Response>;
  /** insert a single row into the table: "pages" */
  insert_pages_one?: Maybe<Pages>;
  /** insert data into the table: "pif_donations" */
  insert_pif_donations?: Maybe<Pif_Donations_Mutation_Response>;
  /** insert a single row into the table: "pif_donations" */
  insert_pif_donations_one?: Maybe<Pif_Donations>;
  /** insert data into the table: "post_book" */
  insert_post_book?: Maybe<Post_Book_Mutation_Response>;
  /** insert a single row into the table: "post_book" */
  insert_post_book_one?: Maybe<Post_Book>;
  /** insert data into the table: "posts" */
  insert_posts?: Maybe<Posts_Mutation_Response>;
  /** insert a single row into the table: "posts" */
  insert_posts_one?: Maybe<Posts>;
  /** insert data into the table: "products" */
  insert_products?: Maybe<Products_Mutation_Response>;
  /** insert a single row into the table: "products" */
  insert_products_one?: Maybe<Products>;
  /** insert data into the table: "public_account_details" */
  insert_public_account_details?: Maybe<Public_Account_Details_Mutation_Response>;
  /** insert a single row into the table: "public_account_details" */
  insert_public_account_details_one?: Maybe<Public_Account_Details>;
  /** insert data into the table: "refresh_tokens" */
  insert_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>;
  /** insert a single row into the table: "refresh_tokens" */
  insert_refresh_tokens_one?: Maybe<Refresh_Tokens>;
  /** insert data into the table: "refunds" */
  insert_refunds?: Maybe<Refunds_Mutation_Response>;
  /** insert a single row into the table: "refunds" */
  insert_refunds_one?: Maybe<Refunds>;
  /** insert data into the table: "regions" */
  insert_regions?: Maybe<Regions_Mutation_Response>;
  /** insert a single row into the table: "regions" */
  insert_regions_one?: Maybe<Regions>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "shipping_options" */
  insert_shipping_options?: Maybe<Shipping_Options_Mutation_Response>;
  /** insert a single row into the table: "shipping_options" */
  insert_shipping_options_one?: Maybe<Shipping_Options>;
  /** insert data into the table: "subscription_dispatch" */
  insert_subscription_dispatch?: Maybe<Subscription_Dispatch_Mutation_Response>;
  /** insert a single row into the table: "subscription_dispatch" */
  insert_subscription_dispatch_one?: Maybe<Subscription_Dispatch>;
  /** insert data into the table: "subscription_dispatch_subscription_object" */
  insert_subscription_dispatch_subscription_object?: Maybe<Subscription_Dispatch_Subscription_Object_Mutation_Response>;
  /** insert a single row into the table: "subscription_dispatch_subscription_object" */
  insert_subscription_dispatch_subscription_object_one?: Maybe<Subscription_Dispatch_Subscription_Object>;
  /** insert data into the table: "subscription_draft_object" */
  insert_subscription_draft_object?: Maybe<Subscription_Draft_Object_Mutation_Response>;
  /** insert a single row into the table: "subscription_draft_object" */
  insert_subscription_draft_object_one?: Maybe<Subscription_Draft_Object>;
  /** insert data into the table: "subscription_object" */
  insert_subscription_object?: Maybe<Subscription_Object_Mutation_Response>;
  /** insert data into the table: "subscription_object_credit" */
  insert_subscription_object_credit?: Maybe<Subscription_Object_Credit_Mutation_Response>;
  /** insert a single row into the table: "subscription_object_credit" */
  insert_subscription_object_credit_one?: Maybe<Subscription_Object_Credit>;
  /** insert a single row into the table: "subscription_object" */
  insert_subscription_object_one?: Maybe<Subscription_Object>;
  /** insert data into the table: "subscription_price" */
  insert_subscription_price?: Maybe<Subscription_Price_Mutation_Response>;
  /** insert a single row into the table: "subscription_price" */
  insert_subscription_price_one?: Maybe<Subscription_Price>;
  /** insert data into the table: "subscriptions" */
  insert_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "subscriptions" */
  insert_subscriptions_one?: Maybe<Subscriptions>;
  /** insert data into the table: "tag_book" */
  insert_tag_book?: Maybe<Tag_Book_Mutation_Response>;
  /** insert a single row into the table: "tag_book" */
  insert_tag_book_one?: Maybe<Tag_Book>;
  /** insert data into the table: "tags" */
  insert_tags?: Maybe<Tags_Mutation_Response>;
  /** insert a single row into the table: "tags" */
  insert_tags_one?: Maybe<Tags>;
  /** insert data into the table: "unstructured_data" */
  insert_unstructured_data?: Maybe<Unstructured_Data_Mutation_Response>;
  /** insert a single row into the table: "unstructured_data" */
  insert_unstructured_data_one?: Maybe<Unstructured_Data>;
  /** insert data into the table: "vouchers" */
  insert_vouchers?: Maybe<Vouchers_Mutation_Response>;
  /** insert a single row into the table: "vouchers" */
  insert_vouchers_one?: Maybe<Vouchers>;
  /** update data of the table: "accounts" */
  update_accounts?: Maybe<Accounts_Mutation_Response>;
  /** update single row of the table: "accounts" */
  update_accounts_by_pk?: Maybe<Accounts>;
  /** update data of the table: "addresses" */
  update_addresses?: Maybe<Addresses_Mutation_Response>;
  /** update single row of the table: "addresses" */
  update_addresses_by_pk?: Maybe<Addresses>;
  /** update data of the table: "book_discount" */
  update_book_discount?: Maybe<Book_Discount_Mutation_Response>;
  /** update single row of the table: "book_discount" */
  update_book_discount_by_pk?: Maybe<Book_Discount>;
  /** update data of the table: "books" */
  update_books?: Maybe<Books_Mutation_Response>;
  /** update single row of the table: "books" */
  update_books_by_pk?: Maybe<Books>;
  /** update data of the table: "booksellers" */
  update_booksellers?: Maybe<Booksellers_Mutation_Response>;
  /** update single row of the table: "booksellers" */
  update_booksellers_by_pk?: Maybe<Booksellers>;
  /** update data of the table: "categories" */
  update_categories?: Maybe<Categories_Mutation_Response>;
  /** update single row of the table: "categories" */
  update_categories_by_pk?: Maybe<Categories>;
  /** update data of the table: "category_book" */
  update_category_book?: Maybe<Category_Book_Mutation_Response>;
  /** update single row of the table: "category_book" */
  update_category_book_by_pk?: Maybe<Category_Book>;
  /** update data of the table: "category_event" */
  update_category_event?: Maybe<Category_Event_Mutation_Response>;
  /** update single row of the table: "category_event" */
  update_category_event_by_pk?: Maybe<Category_Event>;
  /** update data of the table: "category_post" */
  update_category_post?: Maybe<Category_Post_Mutation_Response>;
  /** update single row of the table: "category_post" */
  update_category_post_by_pk?: Maybe<Category_Post>;
  /** update data of the table: "children_categories" */
  update_children_categories?: Maybe<Children_Categories_Mutation_Response>;
  /** update single row of the table: "children_categories" */
  update_children_categories_by_pk?: Maybe<Children_Categories>;
  /** update data of the table: "children_category_books" */
  update_children_category_books?: Maybe<Children_Category_Books_Mutation_Response>;
  /** update single row of the table: "children_category_books" */
  update_children_category_books_by_pk?: Maybe<Children_Category_Books>;
  /** update data of the table: "contents" */
  update_contents?: Maybe<Contents_Mutation_Response>;
  /** update single row of the table: "contents" */
  update_contents_by_pk?: Maybe<Contents>;
  /** update data of the table: "countries" */
  update_countries?: Maybe<Countries_Mutation_Response>;
  /** update single row of the table: "countries" */
  update_countries_by_pk?: Maybe<Countries>;
  /** update data of the table: "discount_type" */
  update_discount_type?: Maybe<Discount_Type_Mutation_Response>;
  /** update single row of the table: "discount_type" */
  update_discount_type_by_pk?: Maybe<Discount_Type>;
  /** update data of the table: "discounts" */
  update_discounts?: Maybe<Discounts_Mutation_Response>;
  /** update single row of the table: "discounts" */
  update_discounts_by_pk?: Maybe<Discounts>;
  /** update data of the table: "empty_searches" */
  update_empty_searches?: Maybe<Empty_Searches_Mutation_Response>;
  /** update single row of the table: "empty_searches" */
  update_empty_searches_by_pk?: Maybe<Empty_Searches>;
  /** update data of the table: "event_book" */
  update_event_book?: Maybe<Event_Book_Mutation_Response>;
  /** update single row of the table: "event_book" */
  update_event_book_by_pk?: Maybe<Event_Book>;
  /** update data of the table: "event_comment" */
  update_event_comment?: Maybe<Event_Comment_Mutation_Response>;
  /** update single row of the table: "event_comment" */
  update_event_comment_by_pk?: Maybe<Event_Comment>;
  /** update data of the table: "event_tickets" */
  update_event_tickets?: Maybe<Event_Tickets_Mutation_Response>;
  /** update single row of the table: "event_tickets" */
  update_event_tickets_by_pk?: Maybe<Event_Tickets>;
  /** update data of the table: "events" */
  update_events?: Maybe<Events_Mutation_Response>;
  /** update single row of the table: "events" */
  update_events_by_pk?: Maybe<Events>;
  /** update data of the table: "order_book" */
  update_order_book?: Maybe<Order_Book_Mutation_Response>;
  /** update single row of the table: "order_book" */
  update_order_book_by_pk?: Maybe<Order_Book>;
  /** update data of the table: "order_item_status" */
  update_order_item_status?: Maybe<Order_Item_Status_Mutation_Response>;
  /** update single row of the table: "order_item_status" */
  update_order_item_status_by_pk?: Maybe<Order_Item_Status>;
  /** update data of the table: "order_product" */
  update_order_product?: Maybe<Order_Product_Mutation_Response>;
  /** update single row of the table: "order_product" */
  update_order_product_by_pk?: Maybe<Order_Product>;
  /** update data of the table: "order_status" */
  update_order_status?: Maybe<Order_Status_Mutation_Response>;
  /** update single row of the table: "order_status" */
  update_order_status_by_pk?: Maybe<Order_Status>;
  /** update data of the table: "order_subscription_object" */
  update_order_subscription_object?: Maybe<Order_Subscription_Object_Mutation_Response>;
  /** update single row of the table: "order_subscription_object" */
  update_order_subscription_object_by_pk?: Maybe<Order_Subscription_Object>;
  /** update data of the table: "order_subscription_price" */
  update_order_subscription_price?: Maybe<Order_Subscription_Price_Mutation_Response>;
  /** update single row of the table: "order_subscription_price" */
  update_order_subscription_price_by_pk?: Maybe<Order_Subscription_Price>;
  /** update data of the table: "order_voucher" */
  update_order_voucher?: Maybe<Order_Voucher_Mutation_Response>;
  /** update single row of the table: "order_voucher" */
  update_order_voucher_by_pk?: Maybe<Order_Voucher>;
  /** update data of the table: "orders" */
  update_orders?: Maybe<Orders_Mutation_Response>;
  /** update single row of the table: "orders" */
  update_orders_by_pk?: Maybe<Orders>;
  /** update data of the table: "pages" */
  update_pages?: Maybe<Pages_Mutation_Response>;
  /** update single row of the table: "pages" */
  update_pages_by_pk?: Maybe<Pages>;
  /** update data of the table: "pif_donations" */
  update_pif_donations?: Maybe<Pif_Donations_Mutation_Response>;
  /** update single row of the table: "pif_donations" */
  update_pif_donations_by_pk?: Maybe<Pif_Donations>;
  /** update data of the table: "post_book" */
  update_post_book?: Maybe<Post_Book_Mutation_Response>;
  /** update single row of the table: "post_book" */
  update_post_book_by_pk?: Maybe<Post_Book>;
  /** update data of the table: "posts" */
  update_posts?: Maybe<Posts_Mutation_Response>;
  /** update single row of the table: "posts" */
  update_posts_by_pk?: Maybe<Posts>;
  /** update data of the table: "products" */
  update_products?: Maybe<Products_Mutation_Response>;
  /** update single row of the table: "products" */
  update_products_by_pk?: Maybe<Products>;
  /** update data of the table: "public_account_details" */
  update_public_account_details?: Maybe<Public_Account_Details_Mutation_Response>;
  /** update data of the table: "refresh_tokens" */
  update_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>;
  /** update single row of the table: "refresh_tokens" */
  update_refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** update data of the table: "refunds" */
  update_refunds?: Maybe<Refunds_Mutation_Response>;
  /** update single row of the table: "refunds" */
  update_refunds_by_pk?: Maybe<Refunds>;
  /** update data of the table: "regions" */
  update_regions?: Maybe<Regions_Mutation_Response>;
  /** update single row of the table: "regions" */
  update_regions_by_pk?: Maybe<Regions>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update data of the table: "shipping_options" */
  update_shipping_options?: Maybe<Shipping_Options_Mutation_Response>;
  /** update single row of the table: "shipping_options" */
  update_shipping_options_by_pk?: Maybe<Shipping_Options>;
  /** update data of the table: "subscription_dispatch" */
  update_subscription_dispatch?: Maybe<Subscription_Dispatch_Mutation_Response>;
  /** update single row of the table: "subscription_dispatch" */
  update_subscription_dispatch_by_pk?: Maybe<Subscription_Dispatch>;
  /** update data of the table: "subscription_dispatch_subscription_object" */
  update_subscription_dispatch_subscription_object?: Maybe<Subscription_Dispatch_Subscription_Object_Mutation_Response>;
  /** update single row of the table: "subscription_dispatch_subscription_object" */
  update_subscription_dispatch_subscription_object_by_pk?: Maybe<Subscription_Dispatch_Subscription_Object>;
  /** update data of the table: "subscription_draft_object" */
  update_subscription_draft_object?: Maybe<Subscription_Draft_Object_Mutation_Response>;
  /** update single row of the table: "subscription_draft_object" */
  update_subscription_draft_object_by_pk?: Maybe<Subscription_Draft_Object>;
  /** update data of the table: "subscription_object" */
  update_subscription_object?: Maybe<Subscription_Object_Mutation_Response>;
  /** update single row of the table: "subscription_object" */
  update_subscription_object_by_pk?: Maybe<Subscription_Object>;
  /** update data of the table: "subscription_object_credit" */
  update_subscription_object_credit?: Maybe<Subscription_Object_Credit_Mutation_Response>;
  /** update single row of the table: "subscription_object_credit" */
  update_subscription_object_credit_by_pk?: Maybe<Subscription_Object_Credit>;
  /** update data of the table: "subscription_price" */
  update_subscription_price?: Maybe<Subscription_Price_Mutation_Response>;
  /** update single row of the table: "subscription_price" */
  update_subscription_price_by_pk?: Maybe<Subscription_Price>;
  /** update data of the table: "subscriptions" */
  update_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** update single row of the table: "subscriptions" */
  update_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** update data of the table: "tag_book" */
  update_tag_book?: Maybe<Tag_Book_Mutation_Response>;
  /** update single row of the table: "tag_book" */
  update_tag_book_by_pk?: Maybe<Tag_Book>;
  /** update data of the table: "tags" */
  update_tags?: Maybe<Tags_Mutation_Response>;
  /** update single row of the table: "tags" */
  update_tags_by_pk?: Maybe<Tags>;
  /** update data of the table: "unstructured_data" */
  update_unstructured_data?: Maybe<Unstructured_Data_Mutation_Response>;
  /** update single row of the table: "unstructured_data" */
  update_unstructured_data_by_pk?: Maybe<Unstructured_Data>;
  /** update data of the table: "vouchers" */
  update_vouchers?: Maybe<Vouchers_Mutation_Response>;
  /** update single row of the table: "vouchers" */
  update_vouchers_by_pk?: Maybe<Vouchers>;
};


/** mutation root */
export type Mutation_RootDelete_AccountsArgs = {
  where: Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accounts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_AddressesArgs = {
  where: Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Addresses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Book_DiscountArgs = {
  where: Book_Discount_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Book_Discount_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  discount_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_BooksArgs = {
  where: Books_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Books_By_PkArgs = {
  isbn: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_BooksellersArgs = {
  where: Booksellers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Booksellers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CategoriesArgs = {
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Categories_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Category_BookArgs = {
  where: Category_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Category_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  category_name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Category_EventArgs = {
  where: Category_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Category_Event_By_PkArgs = {
  category_name: Scalars['String'];
  event_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Category_PostArgs = {
  where: Category_Post_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Category_Post_By_PkArgs = {
  category_name: Scalars['String'];
  post_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Children_CategoriesArgs = {
  where: Children_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Children_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Children_Category_BooksArgs = {
  where: Children_Category_Books_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Children_Category_Books_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  category_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ContentsArgs = {
  where: Contents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contents_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_CountriesArgs = {
  where: Countries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Countries_By_PkArgs = {
  code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Discount_TypeArgs = {
  where: Discount_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discount_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_DiscountsArgs = {
  where: Discounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discounts_By_PkArgs = {
  code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Empty_SearchesArgs = {
  where: Empty_Searches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Empty_Searches_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Event_BookArgs = {
  where: Event_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  event_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Event_CommentArgs = {
  where: Event_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_Comment_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Event_TicketsArgs = {
  where: Event_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_Tickets_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventsArgs = {
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Order_BookArgs = {
  where: Order_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  order_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Order_Item_StatusArgs = {
  where: Order_Item_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Item_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Order_ProductArgs = {
  where: Order_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Product_By_PkArgs = {
  order_id: Scalars['Int'];
  product_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Order_StatusArgs = {
  where: Order_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Order_Subscription_ObjectArgs = {
  where: Order_Subscription_Object_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Subscription_Object_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Order_Subscription_PriceArgs = {
  where: Order_Subscription_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Subscription_Price_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Order_VoucherArgs = {
  where: Order_Voucher_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Voucher_By_PkArgs = {
  order_id: Scalars['Int'];
  voucher_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_OrdersArgs = {
  where: Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Orders_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PagesArgs = {
  where: Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pages_By_PkArgs = {
  title: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Pif_DonationsArgs = {
  where: Pif_Donations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pif_Donations_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Post_BookArgs = {
  where: Post_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Post_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  post_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PostsArgs = {
  where: Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProductsArgs = {
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Public_Account_DetailsArgs = {
  where: Public_Account_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refresh_TokensArgs = {
  where: Refresh_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refresh_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RefundsArgs = {
  where: Refunds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refunds_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RegionsArgs = {
  where: Regions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Regions_By_PkArgs = {
  code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Shipping_OptionsArgs = {
  where: Shipping_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shipping_Options_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_DispatchArgs = {
  where: Subscription_Dispatch_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Dispatch_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Dispatch_Subscription_ObjectArgs = {
  where: Subscription_Dispatch_Subscription_Object_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Dispatch_Subscription_Object_By_PkArgs = {
  dispatch_id: Scalars['uuid'];
  object_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Draft_ObjectArgs = {
  where: Subscription_Draft_Object_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Draft_Object_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_ObjectArgs = {
  where: Subscription_Object_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Object_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Object_CreditArgs = {
  where: Subscription_Object_Credit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Object_Credit_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_PriceArgs = {
  where: Subscription_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Price_By_PkArgs = {
  id: Scalars['uuid'];
  sub_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SubscriptionsArgs = {
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tag_BookArgs = {
  where: Tag_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  tag_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TagsArgs = {
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Unstructured_DataArgs = {
  where: Unstructured_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unstructured_Data_By_PkArgs = {
  title: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_VouchersArgs = {
  where: Vouchers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vouchers_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_AccountsArgs = {
  objects: Array<Accounts_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_OneArgs = {
  object: Accounts_Insert_Input;
  on_conflict?: InputMaybe<Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AddressesArgs = {
  objects: Array<Addresses_Insert_Input>;
  on_conflict?: InputMaybe<Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Addresses_OneArgs = {
  object: Addresses_Insert_Input;
  on_conflict?: InputMaybe<Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Book_DiscountArgs = {
  objects: Array<Book_Discount_Insert_Input>;
  on_conflict?: InputMaybe<Book_Discount_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Book_Discount_OneArgs = {
  object: Book_Discount_Insert_Input;
  on_conflict?: InputMaybe<Book_Discount_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BooksArgs = {
  objects: Array<Books_Insert_Input>;
  on_conflict?: InputMaybe<Books_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Books_OneArgs = {
  object: Books_Insert_Input;
  on_conflict?: InputMaybe<Books_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BooksellersArgs = {
  objects: Array<Booksellers_Insert_Input>;
  on_conflict?: InputMaybe<Booksellers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Booksellers_OneArgs = {
  object: Booksellers_Insert_Input;
  on_conflict?: InputMaybe<Booksellers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CategoriesArgs = {
  objects: Array<Categories_Insert_Input>;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Categories_OneArgs = {
  object: Categories_Insert_Input;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_BookArgs = {
  objects: Array<Category_Book_Insert_Input>;
  on_conflict?: InputMaybe<Category_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_Book_OneArgs = {
  object: Category_Book_Insert_Input;
  on_conflict?: InputMaybe<Category_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_EventArgs = {
  objects: Array<Category_Event_Insert_Input>;
  on_conflict?: InputMaybe<Category_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_Event_OneArgs = {
  object: Category_Event_Insert_Input;
  on_conflict?: InputMaybe<Category_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_PostArgs = {
  objects: Array<Category_Post_Insert_Input>;
  on_conflict?: InputMaybe<Category_Post_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Category_Post_OneArgs = {
  object: Category_Post_Insert_Input;
  on_conflict?: InputMaybe<Category_Post_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Children_CategoriesArgs = {
  objects: Array<Children_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Children_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Children_Categories_OneArgs = {
  object: Children_Categories_Insert_Input;
  on_conflict?: InputMaybe<Children_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Children_Category_BooksArgs = {
  objects: Array<Children_Category_Books_Insert_Input>;
  on_conflict?: InputMaybe<Children_Category_Books_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Children_Category_Books_OneArgs = {
  object: Children_Category_Books_Insert_Input;
  on_conflict?: InputMaybe<Children_Category_Books_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContentsArgs = {
  objects: Array<Contents_Insert_Input>;
  on_conflict?: InputMaybe<Contents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contents_OneArgs = {
  object: Contents_Insert_Input;
  on_conflict?: InputMaybe<Contents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountriesArgs = {
  objects: Array<Countries_Insert_Input>;
  on_conflict?: InputMaybe<Countries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Countries_OneArgs = {
  object: Countries_Insert_Input;
  on_conflict?: InputMaybe<Countries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_TypeArgs = {
  objects: Array<Discount_Type_Insert_Input>;
  on_conflict?: InputMaybe<Discount_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_Type_OneArgs = {
  object: Discount_Type_Insert_Input;
  on_conflict?: InputMaybe<Discount_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DiscountsArgs = {
  objects: Array<Discounts_Insert_Input>;
  on_conflict?: InputMaybe<Discounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discounts_OneArgs = {
  object: Discounts_Insert_Input;
  on_conflict?: InputMaybe<Discounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Empty_SearchesArgs = {
  objects: Array<Empty_Searches_Insert_Input>;
  on_conflict?: InputMaybe<Empty_Searches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Empty_Searches_OneArgs = {
  object: Empty_Searches_Insert_Input;
  on_conflict?: InputMaybe<Empty_Searches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_BookArgs = {
  objects: Array<Event_Book_Insert_Input>;
  on_conflict?: InputMaybe<Event_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Book_OneArgs = {
  object: Event_Book_Insert_Input;
  on_conflict?: InputMaybe<Event_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_CommentArgs = {
  objects: Array<Event_Comment_Insert_Input>;
  on_conflict?: InputMaybe<Event_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Comment_OneArgs = {
  object: Event_Comment_Insert_Input;
  on_conflict?: InputMaybe<Event_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_TicketsArgs = {
  objects: Array<Event_Tickets_Insert_Input>;
  on_conflict?: InputMaybe<Event_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Tickets_OneArgs = {
  object: Event_Tickets_Insert_Input;
  on_conflict?: InputMaybe<Event_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventsArgs = {
  objects: Array<Events_Insert_Input>;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Events_OneArgs = {
  object: Events_Insert_Input;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_BookArgs = {
  objects: Array<Order_Book_Insert_Input>;
  on_conflict?: InputMaybe<Order_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Book_OneArgs = {
  object: Order_Book_Insert_Input;
  on_conflict?: InputMaybe<Order_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Item_StatusArgs = {
  objects: Array<Order_Item_Status_Insert_Input>;
  on_conflict?: InputMaybe<Order_Item_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Item_Status_OneArgs = {
  object: Order_Item_Status_Insert_Input;
  on_conflict?: InputMaybe<Order_Item_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_ProductArgs = {
  objects: Array<Order_Product_Insert_Input>;
  on_conflict?: InputMaybe<Order_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Product_OneArgs = {
  object: Order_Product_Insert_Input;
  on_conflict?: InputMaybe<Order_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_StatusArgs = {
  objects: Array<Order_Status_Insert_Input>;
  on_conflict?: InputMaybe<Order_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Status_OneArgs = {
  object: Order_Status_Insert_Input;
  on_conflict?: InputMaybe<Order_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Subscription_ObjectArgs = {
  objects: Array<Order_Subscription_Object_Insert_Input>;
  on_conflict?: InputMaybe<Order_Subscription_Object_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Subscription_Object_OneArgs = {
  object: Order_Subscription_Object_Insert_Input;
  on_conflict?: InputMaybe<Order_Subscription_Object_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Subscription_PriceArgs = {
  objects: Array<Order_Subscription_Price_Insert_Input>;
  on_conflict?: InputMaybe<Order_Subscription_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Subscription_Price_OneArgs = {
  object: Order_Subscription_Price_Insert_Input;
  on_conflict?: InputMaybe<Order_Subscription_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_VoucherArgs = {
  objects: Array<Order_Voucher_Insert_Input>;
  on_conflict?: InputMaybe<Order_Voucher_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Voucher_OneArgs = {
  object: Order_Voucher_Insert_Input;
  on_conflict?: InputMaybe<Order_Voucher_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrdersArgs = {
  objects: Array<Orders_Insert_Input>;
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Orders_OneArgs = {
  object: Orders_Insert_Input;
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PagesArgs = {
  objects: Array<Pages_Insert_Input>;
  on_conflict?: InputMaybe<Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pages_OneArgs = {
  object: Pages_Insert_Input;
  on_conflict?: InputMaybe<Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pif_DonationsArgs = {
  objects: Array<Pif_Donations_Insert_Input>;
  on_conflict?: InputMaybe<Pif_Donations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pif_Donations_OneArgs = {
  object: Pif_Donations_Insert_Input;
  on_conflict?: InputMaybe<Pif_Donations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Post_BookArgs = {
  objects: Array<Post_Book_Insert_Input>;
  on_conflict?: InputMaybe<Post_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Post_Book_OneArgs = {
  object: Post_Book_Insert_Input;
  on_conflict?: InputMaybe<Post_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PostsArgs = {
  objects: Array<Posts_Insert_Input>;
  on_conflict?: InputMaybe<Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posts_OneArgs = {
  object: Posts_Insert_Input;
  on_conflict?: InputMaybe<Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductsArgs = {
  objects: Array<Products_Insert_Input>;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_OneArgs = {
  object: Products_Insert_Input;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Public_Account_DetailsArgs = {
  objects: Array<Public_Account_Details_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Public_Account_Details_OneArgs = {
  object: Public_Account_Details_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Refresh_TokensArgs = {
  objects: Array<Refresh_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Refresh_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refresh_Tokens_OneArgs = {
  object: Refresh_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Refresh_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RefundsArgs = {
  objects: Array<Refunds_Insert_Input>;
  on_conflict?: InputMaybe<Refunds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refunds_OneArgs = {
  object: Refunds_Insert_Input;
  on_conflict?: InputMaybe<Refunds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RegionsArgs = {
  objects: Array<Regions_Insert_Input>;
  on_conflict?: InputMaybe<Regions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Regions_OneArgs = {
  object: Regions_Insert_Input;
  on_conflict?: InputMaybe<Regions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shipping_OptionsArgs = {
  objects: Array<Shipping_Options_Insert_Input>;
  on_conflict?: InputMaybe<Shipping_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shipping_Options_OneArgs = {
  object: Shipping_Options_Insert_Input;
  on_conflict?: InputMaybe<Shipping_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_DispatchArgs = {
  objects: Array<Subscription_Dispatch_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Dispatch_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Dispatch_OneArgs = {
  object: Subscription_Dispatch_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Dispatch_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Dispatch_Subscription_ObjectArgs = {
  objects: Array<Subscription_Dispatch_Subscription_Object_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Dispatch_Subscription_Object_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Dispatch_Subscription_Object_OneArgs = {
  object: Subscription_Dispatch_Subscription_Object_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Dispatch_Subscription_Object_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Draft_ObjectArgs = {
  objects: Array<Subscription_Draft_Object_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Draft_Object_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Draft_Object_OneArgs = {
  object: Subscription_Draft_Object_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Draft_Object_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_ObjectArgs = {
  objects: Array<Subscription_Object_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Object_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Object_CreditArgs = {
  objects: Array<Subscription_Object_Credit_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Object_Credit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Object_Credit_OneArgs = {
  object: Subscription_Object_Credit_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Object_Credit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Object_OneArgs = {
  object: Subscription_Object_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Object_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_PriceArgs = {
  objects: Array<Subscription_Price_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Price_OneArgs = {
  object: Subscription_Price_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubscriptionsArgs = {
  objects: Array<Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_OneArgs = {
  object: Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_BookArgs = {
  objects: Array<Tag_Book_Insert_Input>;
  on_conflict?: InputMaybe<Tag_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Book_OneArgs = {
  object: Tag_Book_Insert_Input;
  on_conflict?: InputMaybe<Tag_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagsArgs = {
  objects: Array<Tags_Insert_Input>;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tags_OneArgs = {
  object: Tags_Insert_Input;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unstructured_DataArgs = {
  objects: Array<Unstructured_Data_Insert_Input>;
  on_conflict?: InputMaybe<Unstructured_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unstructured_Data_OneArgs = {
  object: Unstructured_Data_Insert_Input;
  on_conflict?: InputMaybe<Unstructured_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VouchersArgs = {
  objects: Array<Vouchers_Insert_Input>;
  on_conflict?: InputMaybe<Vouchers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vouchers_OneArgs = {
  object: Vouchers_Insert_Input;
  on_conflict?: InputMaybe<Vouchers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountsArgs = {
  _set?: InputMaybe<Accounts_Set_Input>;
  where: Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_By_PkArgs = {
  _set?: InputMaybe<Accounts_Set_Input>;
  pk_columns: Accounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AddressesArgs = {
  _inc?: InputMaybe<Addresses_Inc_Input>;
  _set?: InputMaybe<Addresses_Set_Input>;
  where: Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Addresses_By_PkArgs = {
  _inc?: InputMaybe<Addresses_Inc_Input>;
  _set?: InputMaybe<Addresses_Set_Input>;
  pk_columns: Addresses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Book_DiscountArgs = {
  _inc?: InputMaybe<Book_Discount_Inc_Input>;
  _set?: InputMaybe<Book_Discount_Set_Input>;
  where: Book_Discount_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Book_Discount_By_PkArgs = {
  _inc?: InputMaybe<Book_Discount_Inc_Input>;
  _set?: InputMaybe<Book_Discount_Set_Input>;
  pk_columns: Book_Discount_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BooksArgs = {
  _inc?: InputMaybe<Books_Inc_Input>;
  _set?: InputMaybe<Books_Set_Input>;
  where: Books_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Books_By_PkArgs = {
  _inc?: InputMaybe<Books_Inc_Input>;
  _set?: InputMaybe<Books_Set_Input>;
  pk_columns: Books_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BooksellersArgs = {
  _inc?: InputMaybe<Booksellers_Inc_Input>;
  _set?: InputMaybe<Booksellers_Set_Input>;
  where: Booksellers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Booksellers_By_PkArgs = {
  _inc?: InputMaybe<Booksellers_Inc_Input>;
  _set?: InputMaybe<Booksellers_Set_Input>;
  pk_columns: Booksellers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CategoriesArgs = {
  _set?: InputMaybe<Categories_Set_Input>;
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Categories_By_PkArgs = {
  _set?: InputMaybe<Categories_Set_Input>;
  pk_columns: Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Category_BookArgs = {
  _inc?: InputMaybe<Category_Book_Inc_Input>;
  _set?: InputMaybe<Category_Book_Set_Input>;
  where: Category_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Category_Book_By_PkArgs = {
  _inc?: InputMaybe<Category_Book_Inc_Input>;
  _set?: InputMaybe<Category_Book_Set_Input>;
  pk_columns: Category_Book_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Category_EventArgs = {
  _set?: InputMaybe<Category_Event_Set_Input>;
  where: Category_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Category_Event_By_PkArgs = {
  _set?: InputMaybe<Category_Event_Set_Input>;
  pk_columns: Category_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Category_PostArgs = {
  _set?: InputMaybe<Category_Post_Set_Input>;
  where: Category_Post_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Category_Post_By_PkArgs = {
  _set?: InputMaybe<Category_Post_Set_Input>;
  pk_columns: Category_Post_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Children_CategoriesArgs = {
  _set?: InputMaybe<Children_Categories_Set_Input>;
  where: Children_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Children_Categories_By_PkArgs = {
  _set?: InputMaybe<Children_Categories_Set_Input>;
  pk_columns: Children_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Children_Category_BooksArgs = {
  _inc?: InputMaybe<Children_Category_Books_Inc_Input>;
  _set?: InputMaybe<Children_Category_Books_Set_Input>;
  where: Children_Category_Books_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Children_Category_Books_By_PkArgs = {
  _inc?: InputMaybe<Children_Category_Books_Inc_Input>;
  _set?: InputMaybe<Children_Category_Books_Set_Input>;
  pk_columns: Children_Category_Books_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ContentsArgs = {
  _append?: InputMaybe<Contents_Append_Input>;
  _delete_at_path?: InputMaybe<Contents_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Contents_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Contents_Delete_Key_Input>;
  _prepend?: InputMaybe<Contents_Prepend_Input>;
  _set?: InputMaybe<Contents_Set_Input>;
  where: Contents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contents_By_PkArgs = {
  _append?: InputMaybe<Contents_Append_Input>;
  _delete_at_path?: InputMaybe<Contents_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Contents_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Contents_Delete_Key_Input>;
  _prepend?: InputMaybe<Contents_Prepend_Input>;
  _set?: InputMaybe<Contents_Set_Input>;
  pk_columns: Contents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CountriesArgs = {
  _set?: InputMaybe<Countries_Set_Input>;
  where: Countries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Countries_By_PkArgs = {
  _set?: InputMaybe<Countries_Set_Input>;
  pk_columns: Countries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_TypeArgs = {
  _set?: InputMaybe<Discount_Type_Set_Input>;
  where: Discount_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Type_By_PkArgs = {
  _set?: InputMaybe<Discount_Type_Set_Input>;
  pk_columns: Discount_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DiscountsArgs = {
  _inc?: InputMaybe<Discounts_Inc_Input>;
  _set?: InputMaybe<Discounts_Set_Input>;
  where: Discounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discounts_By_PkArgs = {
  _inc?: InputMaybe<Discounts_Inc_Input>;
  _set?: InputMaybe<Discounts_Set_Input>;
  pk_columns: Discounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Empty_SearchesArgs = {
  _inc?: InputMaybe<Empty_Searches_Inc_Input>;
  _set?: InputMaybe<Empty_Searches_Set_Input>;
  where: Empty_Searches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Empty_Searches_By_PkArgs = {
  _inc?: InputMaybe<Empty_Searches_Inc_Input>;
  _set?: InputMaybe<Empty_Searches_Set_Input>;
  pk_columns: Empty_Searches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_BookArgs = {
  _inc?: InputMaybe<Event_Book_Inc_Input>;
  _set?: InputMaybe<Event_Book_Set_Input>;
  where: Event_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Book_By_PkArgs = {
  _inc?: InputMaybe<Event_Book_Inc_Input>;
  _set?: InputMaybe<Event_Book_Set_Input>;
  pk_columns: Event_Book_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_CommentArgs = {
  _inc?: InputMaybe<Event_Comment_Inc_Input>;
  _set?: InputMaybe<Event_Comment_Set_Input>;
  where: Event_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Comment_By_PkArgs = {
  _inc?: InputMaybe<Event_Comment_Inc_Input>;
  _set?: InputMaybe<Event_Comment_Set_Input>;
  pk_columns: Event_Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_TicketsArgs = {
  _inc?: InputMaybe<Event_Tickets_Inc_Input>;
  _set?: InputMaybe<Event_Tickets_Set_Input>;
  where: Event_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Tickets_By_PkArgs = {
  _inc?: InputMaybe<Event_Tickets_Inc_Input>;
  _set?: InputMaybe<Event_Tickets_Set_Input>;
  pk_columns: Event_Tickets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventsArgs = {
  _inc?: InputMaybe<Events_Inc_Input>;
  _set?: InputMaybe<Events_Set_Input>;
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Events_By_PkArgs = {
  _inc?: InputMaybe<Events_Inc_Input>;
  _set?: InputMaybe<Events_Set_Input>;
  pk_columns: Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_BookArgs = {
  _inc?: InputMaybe<Order_Book_Inc_Input>;
  _set?: InputMaybe<Order_Book_Set_Input>;
  where: Order_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Book_By_PkArgs = {
  _inc?: InputMaybe<Order_Book_Inc_Input>;
  _set?: InputMaybe<Order_Book_Set_Input>;
  pk_columns: Order_Book_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Item_StatusArgs = {
  _set?: InputMaybe<Order_Item_Status_Set_Input>;
  where: Order_Item_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Item_Status_By_PkArgs = {
  _set?: InputMaybe<Order_Item_Status_Set_Input>;
  pk_columns: Order_Item_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_ProductArgs = {
  _inc?: InputMaybe<Order_Product_Inc_Input>;
  _set?: InputMaybe<Order_Product_Set_Input>;
  where: Order_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Product_By_PkArgs = {
  _inc?: InputMaybe<Order_Product_Inc_Input>;
  _set?: InputMaybe<Order_Product_Set_Input>;
  pk_columns: Order_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_StatusArgs = {
  _set?: InputMaybe<Order_Status_Set_Input>;
  where: Order_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Status_By_PkArgs = {
  _set?: InputMaybe<Order_Status_Set_Input>;
  pk_columns: Order_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Subscription_ObjectArgs = {
  _inc?: InputMaybe<Order_Subscription_Object_Inc_Input>;
  _set?: InputMaybe<Order_Subscription_Object_Set_Input>;
  where: Order_Subscription_Object_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Subscription_Object_By_PkArgs = {
  _inc?: InputMaybe<Order_Subscription_Object_Inc_Input>;
  _set?: InputMaybe<Order_Subscription_Object_Set_Input>;
  pk_columns: Order_Subscription_Object_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Subscription_PriceArgs = {
  _inc?: InputMaybe<Order_Subscription_Price_Inc_Input>;
  _set?: InputMaybe<Order_Subscription_Price_Set_Input>;
  where: Order_Subscription_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Subscription_Price_By_PkArgs = {
  _inc?: InputMaybe<Order_Subscription_Price_Inc_Input>;
  _set?: InputMaybe<Order_Subscription_Price_Set_Input>;
  pk_columns: Order_Subscription_Price_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_VoucherArgs = {
  _inc?: InputMaybe<Order_Voucher_Inc_Input>;
  _set?: InputMaybe<Order_Voucher_Set_Input>;
  where: Order_Voucher_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Voucher_By_PkArgs = {
  _inc?: InputMaybe<Order_Voucher_Inc_Input>;
  _set?: InputMaybe<Order_Voucher_Set_Input>;
  pk_columns: Order_Voucher_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_OrdersArgs = {
  _inc?: InputMaybe<Orders_Inc_Input>;
  _set?: InputMaybe<Orders_Set_Input>;
  where: Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Orders_By_PkArgs = {
  _inc?: InputMaybe<Orders_Inc_Input>;
  _set?: InputMaybe<Orders_Set_Input>;
  pk_columns: Orders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PagesArgs = {
  _append?: InputMaybe<Pages_Append_Input>;
  _delete_at_path?: InputMaybe<Pages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pages_Delete_Key_Input>;
  _prepend?: InputMaybe<Pages_Prepend_Input>;
  _set?: InputMaybe<Pages_Set_Input>;
  where: Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pages_By_PkArgs = {
  _append?: InputMaybe<Pages_Append_Input>;
  _delete_at_path?: InputMaybe<Pages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pages_Delete_Key_Input>;
  _prepend?: InputMaybe<Pages_Prepend_Input>;
  _set?: InputMaybe<Pages_Set_Input>;
  pk_columns: Pages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pif_DonationsArgs = {
  _inc?: InputMaybe<Pif_Donations_Inc_Input>;
  _set?: InputMaybe<Pif_Donations_Set_Input>;
  where: Pif_Donations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pif_Donations_By_PkArgs = {
  _inc?: InputMaybe<Pif_Donations_Inc_Input>;
  _set?: InputMaybe<Pif_Donations_Set_Input>;
  pk_columns: Pif_Donations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Post_BookArgs = {
  _inc?: InputMaybe<Post_Book_Inc_Input>;
  _set?: InputMaybe<Post_Book_Set_Input>;
  where: Post_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Post_Book_By_PkArgs = {
  _inc?: InputMaybe<Post_Book_Inc_Input>;
  _set?: InputMaybe<Post_Book_Set_Input>;
  pk_columns: Post_Book_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PostsArgs = {
  _inc?: InputMaybe<Posts_Inc_Input>;
  _set?: InputMaybe<Posts_Set_Input>;
  where: Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posts_By_PkArgs = {
  _inc?: InputMaybe<Posts_Inc_Input>;
  _set?: InputMaybe<Posts_Set_Input>;
  pk_columns: Posts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProductsArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_By_PkArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  pk_columns: Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Public_Account_DetailsArgs = {
  _set?: InputMaybe<Public_Account_Details_Set_Input>;
  where: Public_Account_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_TokensArgs = {
  _set?: InputMaybe<Refresh_Tokens_Set_Input>;
  where: Refresh_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Tokens_By_PkArgs = {
  _set?: InputMaybe<Refresh_Tokens_Set_Input>;
  pk_columns: Refresh_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RefundsArgs = {
  _inc?: InputMaybe<Refunds_Inc_Input>;
  _set?: InputMaybe<Refunds_Set_Input>;
  where: Refunds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refunds_By_PkArgs = {
  _inc?: InputMaybe<Refunds_Inc_Input>;
  _set?: InputMaybe<Refunds_Set_Input>;
  pk_columns: Refunds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RegionsArgs = {
  _set?: InputMaybe<Regions_Set_Input>;
  where: Regions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Regions_By_PkArgs = {
  _set?: InputMaybe<Regions_Set_Input>;
  pk_columns: Regions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _set?: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _set?: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shipping_OptionsArgs = {
  _inc?: InputMaybe<Shipping_Options_Inc_Input>;
  _set?: InputMaybe<Shipping_Options_Set_Input>;
  where: Shipping_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shipping_Options_By_PkArgs = {
  _inc?: InputMaybe<Shipping_Options_Inc_Input>;
  _set?: InputMaybe<Shipping_Options_Set_Input>;
  pk_columns: Shipping_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_DispatchArgs = {
  _set?: InputMaybe<Subscription_Dispatch_Set_Input>;
  where: Subscription_Dispatch_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Dispatch_By_PkArgs = {
  _set?: InputMaybe<Subscription_Dispatch_Set_Input>;
  pk_columns: Subscription_Dispatch_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Dispatch_Subscription_ObjectArgs = {
  _set?: InputMaybe<Subscription_Dispatch_Subscription_Object_Set_Input>;
  where: Subscription_Dispatch_Subscription_Object_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Dispatch_Subscription_Object_By_PkArgs = {
  _set?: InputMaybe<Subscription_Dispatch_Subscription_Object_Set_Input>;
  pk_columns: Subscription_Dispatch_Subscription_Object_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Draft_ObjectArgs = {
  _inc?: InputMaybe<Subscription_Draft_Object_Inc_Input>;
  _set?: InputMaybe<Subscription_Draft_Object_Set_Input>;
  where: Subscription_Draft_Object_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Draft_Object_By_PkArgs = {
  _inc?: InputMaybe<Subscription_Draft_Object_Inc_Input>;
  _set?: InputMaybe<Subscription_Draft_Object_Set_Input>;
  pk_columns: Subscription_Draft_Object_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_ObjectArgs = {
  _inc?: InputMaybe<Subscription_Object_Inc_Input>;
  _set?: InputMaybe<Subscription_Object_Set_Input>;
  where: Subscription_Object_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Object_By_PkArgs = {
  _inc?: InputMaybe<Subscription_Object_Inc_Input>;
  _set?: InputMaybe<Subscription_Object_Set_Input>;
  pk_columns: Subscription_Object_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Object_CreditArgs = {
  _set?: InputMaybe<Subscription_Object_Credit_Set_Input>;
  where: Subscription_Object_Credit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Object_Credit_By_PkArgs = {
  _set?: InputMaybe<Subscription_Object_Credit_Set_Input>;
  pk_columns: Subscription_Object_Credit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_PriceArgs = {
  _inc?: InputMaybe<Subscription_Price_Inc_Input>;
  _set?: InputMaybe<Subscription_Price_Set_Input>;
  where: Subscription_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Price_By_PkArgs = {
  _inc?: InputMaybe<Subscription_Price_Inc_Input>;
  _set?: InputMaybe<Subscription_Price_Set_Input>;
  pk_columns: Subscription_Price_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SubscriptionsArgs = {
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Set_Input>;
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Set_Input>;
  pk_columns: Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_BookArgs = {
  _inc?: InputMaybe<Tag_Book_Inc_Input>;
  _set?: InputMaybe<Tag_Book_Set_Input>;
  where: Tag_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Book_By_PkArgs = {
  _inc?: InputMaybe<Tag_Book_Inc_Input>;
  _set?: InputMaybe<Tag_Book_Set_Input>;
  pk_columns: Tag_Book_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TagsArgs = {
  _inc?: InputMaybe<Tags_Inc_Input>;
  _set?: InputMaybe<Tags_Set_Input>;
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_By_PkArgs = {
  _inc?: InputMaybe<Tags_Inc_Input>;
  _set?: InputMaybe<Tags_Set_Input>;
  pk_columns: Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unstructured_DataArgs = {
  _append?: InputMaybe<Unstructured_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Unstructured_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Unstructured_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Unstructured_Data_Delete_Key_Input>;
  _prepend?: InputMaybe<Unstructured_Data_Prepend_Input>;
  _set?: InputMaybe<Unstructured_Data_Set_Input>;
  where: Unstructured_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unstructured_Data_By_PkArgs = {
  _append?: InputMaybe<Unstructured_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Unstructured_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Unstructured_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Unstructured_Data_Delete_Key_Input>;
  _prepend?: InputMaybe<Unstructured_Data_Prepend_Input>;
  _set?: InputMaybe<Unstructured_Data_Set_Input>;
  pk_columns: Unstructured_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_VouchersArgs = {
  _inc?: InputMaybe<Vouchers_Inc_Input>;
  _set?: InputMaybe<Vouchers_Set_Input>;
  where: Vouchers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vouchers_By_PkArgs = {
  _inc?: InputMaybe<Vouchers_Inc_Input>;
  _set?: InputMaybe<Vouchers_Set_Input>;
  pk_columns: Vouchers_Pk_Columns_Input;
};

/** columns and relationships of "order_book" */
export type Order_Book = {
  __typename?: 'order_book';
  /** An object relationship */
  book: Books;
  book_isbn: Scalars['bigint'];
  discount: Scalars['Int'];
  /** An array relationship */
  event_tickets: Array<Event_Tickets>;
  /** An aggregate relationship */
  event_tickets_aggregate: Event_Tickets_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  order: Orders;
  order_id: Scalars['Int'];
  price: Scalars['Int'];
  quantity: Scalars['Int'];
  status: Order_Item_Status_Enum;
};


/** columns and relationships of "order_book" */
export type Order_BookEvent_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


/** columns and relationships of "order_book" */
export type Order_BookEvent_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};

/** aggregated selection of "order_book" */
export type Order_Book_Aggregate = {
  __typename?: 'order_book_aggregate';
  aggregate?: Maybe<Order_Book_Aggregate_Fields>;
  nodes: Array<Order_Book>;
};

/** aggregate fields of "order_book" */
export type Order_Book_Aggregate_Fields = {
  __typename?: 'order_book_aggregate_fields';
  avg?: Maybe<Order_Book_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Book_Max_Fields>;
  min?: Maybe<Order_Book_Min_Fields>;
  stddev?: Maybe<Order_Book_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Book_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Book_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Book_Sum_Fields>;
  var_pop?: Maybe<Order_Book_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Book_Var_Samp_Fields>;
  variance?: Maybe<Order_Book_Variance_Fields>;
};


/** aggregate fields of "order_book" */
export type Order_Book_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Book_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_book" */
export type Order_Book_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Book_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Book_Max_Order_By>;
  min?: InputMaybe<Order_Book_Min_Order_By>;
  stddev?: InputMaybe<Order_Book_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Book_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Book_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Book_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Book_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Book_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Book_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_book" */
export type Order_Book_Arr_Rel_Insert_Input = {
  data: Array<Order_Book_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Book_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Book_Avg_Fields = {
  __typename?: 'order_book_avg_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_book" */
export type Order_Book_Avg_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_book". All fields are combined with a logical 'AND'. */
export type Order_Book_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Book_Bool_Exp>>;
  _not?: InputMaybe<Order_Book_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Book_Bool_Exp>>;
  book?: InputMaybe<Books_Bool_Exp>;
  book_isbn?: InputMaybe<Bigint_Comparison_Exp>;
  discount?: InputMaybe<Int_Comparison_Exp>;
  event_tickets?: InputMaybe<Event_Tickets_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Order_Item_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_book" */
export enum Order_Book_Constraint {
  /** unique or primary key constraint */
  OrderBookIdKey = 'order_book_id_key',
  /** unique or primary key constraint */
  OrderBookPkey = 'order_book_pkey'
}

/** input type for incrementing numeric columns in table "order_book" */
export type Order_Book_Inc_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  discount?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "order_book" */
export type Order_Book_Insert_Input = {
  book?: InputMaybe<Books_Obj_Rel_Insert_Input>;
  book_isbn?: InputMaybe<Scalars['bigint']>;
  discount?: InputMaybe<Scalars['Int']>;
  event_tickets?: InputMaybe<Event_Tickets_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Order_Item_Status_Enum>;
};

/** aggregate max on columns */
export type Order_Book_Max_Fields = {
  __typename?: 'order_book_max_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  discount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "order_book" */
export type Order_Book_Max_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Book_Min_Fields = {
  __typename?: 'order_book_min_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  discount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "order_book" */
export type Order_Book_Min_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_book" */
export type Order_Book_Mutation_Response = {
  __typename?: 'order_book_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Book>;
};

/** input type for inserting object relation for remote table "order_book" */
export type Order_Book_Obj_Rel_Insert_Input = {
  data: Order_Book_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Book_On_Conflict>;
};

/** on_conflict condition type for table "order_book" */
export type Order_Book_On_Conflict = {
  constraint: Order_Book_Constraint;
  update_columns?: Array<Order_Book_Update_Column>;
  where?: InputMaybe<Order_Book_Bool_Exp>;
};

/** Ordering options when selecting data from "order_book". */
export type Order_Book_Order_By = {
  book?: InputMaybe<Books_Order_By>;
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  event_tickets_aggregate?: InputMaybe<Event_Tickets_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_book */
export type Order_Book_Pk_Columns_Input = {
  book_isbn: Scalars['bigint'];
  order_id: Scalars['Int'];
};

/** select columns of table "order_book" */
export enum Order_Book_Select_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  Discount = 'discount',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Price = 'price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "order_book" */
export type Order_Book_Set_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  discount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  order_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Order_Item_Status_Enum>;
};

/** aggregate stddev on columns */
export type Order_Book_Stddev_Fields = {
  __typename?: 'order_book_stddev_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_book" */
export type Order_Book_Stddev_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Book_Stddev_Pop_Fields = {
  __typename?: 'order_book_stddev_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_book" */
export type Order_Book_Stddev_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Book_Stddev_Samp_Fields = {
  __typename?: 'order_book_stddev_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_book" */
export type Order_Book_Stddev_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Order_Book_Sum_Fields = {
  __typename?: 'order_book_sum_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  discount?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_book" */
export type Order_Book_Sum_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "order_book" */
export enum Order_Book_Update_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  Discount = 'discount',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Price = 'price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Status = 'status'
}

/** aggregate var_pop on columns */
export type Order_Book_Var_Pop_Fields = {
  __typename?: 'order_book_var_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_book" */
export type Order_Book_Var_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Book_Var_Samp_Fields = {
  __typename?: 'order_book_var_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_book" */
export type Order_Book_Var_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Book_Variance_Fields = {
  __typename?: 'order_book_variance_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_book" */
export type Order_Book_Variance_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "order_item_status" */
export type Order_Item_Status = {
  __typename?: 'order_item_status';
  status: Scalars['String'];
};

/** aggregated selection of "order_item_status" */
export type Order_Item_Status_Aggregate = {
  __typename?: 'order_item_status_aggregate';
  aggregate?: Maybe<Order_Item_Status_Aggregate_Fields>;
  nodes: Array<Order_Item_Status>;
};

/** aggregate fields of "order_item_status" */
export type Order_Item_Status_Aggregate_Fields = {
  __typename?: 'order_item_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Order_Item_Status_Max_Fields>;
  min?: Maybe<Order_Item_Status_Min_Fields>;
};


/** aggregate fields of "order_item_status" */
export type Order_Item_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Item_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "order_item_status". All fields are combined with a logical 'AND'. */
export type Order_Item_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Item_Status_Bool_Exp>>;
  _not?: InputMaybe<Order_Item_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Item_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_item_status" */
export enum Order_Item_Status_Constraint {
  /** unique or primary key constraint */
  OrderItemStatusPkey = 'order_item_status_pkey'
}

export enum Order_Item_Status_Enum {
  Cancelled = 'cancelled',
  Fulfilled = 'fulfilled',
  OnOrder = 'on_order',
  Picked = 'picked',
  PreOrdered = 'pre_ordered',
  Unactioned = 'unactioned'
}

/** Boolean expression to compare columns of type "order_item_status_enum". All fields are combined with logical 'AND'. */
export type Order_Item_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Order_Item_Status_Enum>;
  _in?: InputMaybe<Array<Order_Item_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Order_Item_Status_Enum>;
  _nin?: InputMaybe<Array<Order_Item_Status_Enum>>;
};

/** input type for inserting data into table "order_item_status" */
export type Order_Item_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Order_Item_Status_Max_Fields = {
  __typename?: 'order_item_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Order_Item_Status_Min_Fields = {
  __typename?: 'order_item_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "order_item_status" */
export type Order_Item_Status_Mutation_Response = {
  __typename?: 'order_item_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Item_Status>;
};

/** on_conflict condition type for table "order_item_status" */
export type Order_Item_Status_On_Conflict = {
  constraint: Order_Item_Status_Constraint;
  update_columns?: Array<Order_Item_Status_Update_Column>;
  where?: InputMaybe<Order_Item_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "order_item_status". */
export type Order_Item_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_item_status */
export type Order_Item_Status_Pk_Columns_Input = {
  status: Scalars['String'];
};

/** select columns of table "order_item_status" */
export enum Order_Item_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "order_item_status" */
export type Order_Item_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "order_item_status" */
export enum Order_Item_Status_Update_Column {
  /** column name */
  Status = 'status'
}

/** columns and relationships of "order_product" */
export type Order_Product = {
  __typename?: 'order_product';
  active_sub: Scalars['Boolean'];
  discount: Scalars['Int'];
  /** An object relationship */
  order: Orders;
  order_id: Scalars['Int'];
  price: Scalars['Int'];
  /** An object relationship */
  product: Products;
  product_id: Scalars['uuid'];
  quantity: Scalars['Int'];
  status: Order_Item_Status_Enum;
};

/** aggregated selection of "order_product" */
export type Order_Product_Aggregate = {
  __typename?: 'order_product_aggregate';
  aggregate?: Maybe<Order_Product_Aggregate_Fields>;
  nodes: Array<Order_Product>;
};

/** aggregate fields of "order_product" */
export type Order_Product_Aggregate_Fields = {
  __typename?: 'order_product_aggregate_fields';
  avg?: Maybe<Order_Product_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Product_Max_Fields>;
  min?: Maybe<Order_Product_Min_Fields>;
  stddev?: Maybe<Order_Product_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Product_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Product_Sum_Fields>;
  var_pop?: Maybe<Order_Product_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Product_Var_Samp_Fields>;
  variance?: Maybe<Order_Product_Variance_Fields>;
};


/** aggregate fields of "order_product" */
export type Order_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_product" */
export type Order_Product_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Product_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Product_Max_Order_By>;
  min?: InputMaybe<Order_Product_Min_Order_By>;
  stddev?: InputMaybe<Order_Product_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Product_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Product_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Product_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Product_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Product_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Product_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_product" */
export type Order_Product_Arr_Rel_Insert_Input = {
  data: Array<Order_Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Product_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Product_Avg_Fields = {
  __typename?: 'order_product_avg_fields';
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_product" */
export type Order_Product_Avg_Order_By = {
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_product". All fields are combined with a logical 'AND'. */
export type Order_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Product_Bool_Exp>>;
  _not?: InputMaybe<Order_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Product_Bool_Exp>>;
  active_sub?: InputMaybe<Boolean_Comparison_Exp>;
  discount?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Order_Item_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_product" */
export enum Order_Product_Constraint {
  /** unique or primary key constraint */
  OrderProductsPkey = 'order_products_pkey'
}

/** input type for incrementing numeric columns in table "order_product" */
export type Order_Product_Inc_Input = {
  discount?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "order_product" */
export type Order_Product_Insert_Input = {
  active_sub?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Order_Item_Status_Enum>;
};

/** aggregate max on columns */
export type Order_Product_Max_Fields = {
  __typename?: 'order_product_max_fields';
  discount?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "order_product" */
export type Order_Product_Max_Order_By = {
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Product_Min_Fields = {
  __typename?: 'order_product_min_fields';
  discount?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "order_product" */
export type Order_Product_Min_Order_By = {
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_product" */
export type Order_Product_Mutation_Response = {
  __typename?: 'order_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Product>;
};

/** on_conflict condition type for table "order_product" */
export type Order_Product_On_Conflict = {
  constraint: Order_Product_Constraint;
  update_columns?: Array<Order_Product_Update_Column>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "order_product". */
export type Order_Product_Order_By = {
  active_sub?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_product */
export type Order_Product_Pk_Columns_Input = {
  order_id: Scalars['Int'];
  product_id: Scalars['uuid'];
};

/** select columns of table "order_product" */
export enum Order_Product_Select_Column {
  /** column name */
  ActiveSub = 'active_sub',
  /** column name */
  Discount = 'discount',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "order_product" */
export type Order_Product_Set_Input = {
  active_sub?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Order_Item_Status_Enum>;
};

/** aggregate stddev on columns */
export type Order_Product_Stddev_Fields = {
  __typename?: 'order_product_stddev_fields';
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_product" */
export type Order_Product_Stddev_Order_By = {
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Product_Stddev_Pop_Fields = {
  __typename?: 'order_product_stddev_pop_fields';
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_product" */
export type Order_Product_Stddev_Pop_Order_By = {
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Product_Stddev_Samp_Fields = {
  __typename?: 'order_product_stddev_samp_fields';
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_product" */
export type Order_Product_Stddev_Samp_Order_By = {
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Order_Product_Sum_Fields = {
  __typename?: 'order_product_sum_fields';
  discount?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_product" */
export type Order_Product_Sum_Order_By = {
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "order_product" */
export enum Order_Product_Update_Column {
  /** column name */
  ActiveSub = 'active_sub',
  /** column name */
  Discount = 'discount',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Status = 'status'
}

/** aggregate var_pop on columns */
export type Order_Product_Var_Pop_Fields = {
  __typename?: 'order_product_var_pop_fields';
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_product" */
export type Order_Product_Var_Pop_Order_By = {
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Product_Var_Samp_Fields = {
  __typename?: 'order_product_var_samp_fields';
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_product" */
export type Order_Product_Var_Samp_Order_By = {
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Product_Variance_Fields = {
  __typename?: 'order_product_variance_fields';
  discount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_product" */
export type Order_Product_Variance_Order_By = {
  discount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_status" */
export type Order_Status = {
  __typename?: 'order_status';
  status: Scalars['String'];
};

/** aggregated selection of "order_status" */
export type Order_Status_Aggregate = {
  __typename?: 'order_status_aggregate';
  aggregate?: Maybe<Order_Status_Aggregate_Fields>;
  nodes: Array<Order_Status>;
};

/** aggregate fields of "order_status" */
export type Order_Status_Aggregate_Fields = {
  __typename?: 'order_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Order_Status_Max_Fields>;
  min?: Maybe<Order_Status_Min_Fields>;
};


/** aggregate fields of "order_status" */
export type Order_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "order_status". All fields are combined with a logical 'AND'. */
export type Order_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Status_Bool_Exp>>;
  _not?: InputMaybe<Order_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_status" */
export enum Order_Status_Constraint {
  /** unique or primary key constraint */
  OrderStatusPkey = 'order_status_pkey'
}

export enum Order_Status_Enum {
  Cancelled = 'cancelled',
  Draft = 'draft',
  Fulfilled = 'fulfilled',
  InvoiceSent = 'invoice_sent',
  New = 'new',
  PartiallyFufilled = 'partially_fufilled',
  PreOrder = 'pre_order',
  Processing = 'processing',
  Refunded = 'refunded'
}

/** Boolean expression to compare columns of type "order_status_enum". All fields are combined with logical 'AND'. */
export type Order_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Order_Status_Enum>;
  _in?: InputMaybe<Array<Order_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Order_Status_Enum>;
  _nin?: InputMaybe<Array<Order_Status_Enum>>;
};

/** input type for inserting data into table "order_status" */
export type Order_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Order_Status_Max_Fields = {
  __typename?: 'order_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Order_Status_Min_Fields = {
  __typename?: 'order_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "order_status" */
export type Order_Status_Mutation_Response = {
  __typename?: 'order_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Status>;
};

/** on_conflict condition type for table "order_status" */
export type Order_Status_On_Conflict = {
  constraint: Order_Status_Constraint;
  update_columns?: Array<Order_Status_Update_Column>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "order_status". */
export type Order_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_status */
export type Order_Status_Pk_Columns_Input = {
  status: Scalars['String'];
};

/** select columns of table "order_status" */
export enum Order_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "order_status" */
export type Order_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "order_status" */
export enum Order_Status_Update_Column {
  /** column name */
  Status = 'status'
}

/** columns and relationships of "order_subscription_object" */
export type Order_Subscription_Object = {
  __typename?: 'order_subscription_object';
  created_at: Scalars['timestamptz'];
  draft_subscription_object_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  order: Orders;
  order_id: Scalars['Int'];
  /** An object relationship */
  subscription_draft_object: Subscription_Draft_Object;
  /** An object relationship */
  subscription_object?: Maybe<Subscription_Object>;
  subscription_object_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "order_subscription_object" */
export type Order_Subscription_Object_Aggregate = {
  __typename?: 'order_subscription_object_aggregate';
  aggregate?: Maybe<Order_Subscription_Object_Aggregate_Fields>;
  nodes: Array<Order_Subscription_Object>;
};

/** aggregate fields of "order_subscription_object" */
export type Order_Subscription_Object_Aggregate_Fields = {
  __typename?: 'order_subscription_object_aggregate_fields';
  avg?: Maybe<Order_Subscription_Object_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Subscription_Object_Max_Fields>;
  min?: Maybe<Order_Subscription_Object_Min_Fields>;
  stddev?: Maybe<Order_Subscription_Object_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Subscription_Object_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Subscription_Object_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Subscription_Object_Sum_Fields>;
  var_pop?: Maybe<Order_Subscription_Object_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Subscription_Object_Var_Samp_Fields>;
  variance?: Maybe<Order_Subscription_Object_Variance_Fields>;
};


/** aggregate fields of "order_subscription_object" */
export type Order_Subscription_Object_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_subscription_object" */
export type Order_Subscription_Object_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Subscription_Object_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Subscription_Object_Max_Order_By>;
  min?: InputMaybe<Order_Subscription_Object_Min_Order_By>;
  stddev?: InputMaybe<Order_Subscription_Object_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Subscription_Object_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Subscription_Object_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Subscription_Object_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Subscription_Object_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Subscription_Object_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Subscription_Object_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_subscription_object" */
export type Order_Subscription_Object_Arr_Rel_Insert_Input = {
  data: Array<Order_Subscription_Object_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Subscription_Object_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Subscription_Object_Avg_Fields = {
  __typename?: 'order_subscription_object_avg_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_subscription_object" */
export type Order_Subscription_Object_Avg_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_subscription_object". All fields are combined with a logical 'AND'. */
export type Order_Subscription_Object_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Subscription_Object_Bool_Exp>>;
  _not?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Subscription_Object_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  draft_subscription_object_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  subscription_draft_object?: InputMaybe<Subscription_Draft_Object_Bool_Exp>;
  subscription_object?: InputMaybe<Subscription_Object_Bool_Exp>;
  subscription_object_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_subscription_object" */
export enum Order_Subscription_Object_Constraint {
  /** unique or primary key constraint */
  OrderSubscriptionObjectPkey = 'order_subscription_object_pkey'
}

/** input type for incrementing numeric columns in table "order_subscription_object" */
export type Order_Subscription_Object_Inc_Input = {
  order_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "order_subscription_object" */
export type Order_Subscription_Object_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  draft_subscription_object_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  subscription_draft_object?: InputMaybe<Subscription_Draft_Object_Obj_Rel_Insert_Input>;
  subscription_object?: InputMaybe<Subscription_Object_Obj_Rel_Insert_Input>;
  subscription_object_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Order_Subscription_Object_Max_Fields = {
  __typename?: 'order_subscription_object_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  draft_subscription_object_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  subscription_object_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "order_subscription_object" */
export type Order_Subscription_Object_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  draft_subscription_object_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  subscription_object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Subscription_Object_Min_Fields = {
  __typename?: 'order_subscription_object_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  draft_subscription_object_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  subscription_object_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "order_subscription_object" */
export type Order_Subscription_Object_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  draft_subscription_object_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  subscription_object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_subscription_object" */
export type Order_Subscription_Object_Mutation_Response = {
  __typename?: 'order_subscription_object_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Subscription_Object>;
};

/** on_conflict condition type for table "order_subscription_object" */
export type Order_Subscription_Object_On_Conflict = {
  constraint: Order_Subscription_Object_Constraint;
  update_columns?: Array<Order_Subscription_Object_Update_Column>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};

/** Ordering options when selecting data from "order_subscription_object". */
export type Order_Subscription_Object_Order_By = {
  created_at?: InputMaybe<Order_By>;
  draft_subscription_object_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  subscription_draft_object?: InputMaybe<Subscription_Draft_Object_Order_By>;
  subscription_object?: InputMaybe<Subscription_Object_Order_By>;
  subscription_object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_subscription_object */
export type Order_Subscription_Object_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "order_subscription_object" */
export enum Order_Subscription_Object_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DraftSubscriptionObjectId = 'draft_subscription_object_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  SubscriptionObjectId = 'subscription_object_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "order_subscription_object" */
export type Order_Subscription_Object_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  draft_subscription_object_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order_id?: InputMaybe<Scalars['Int']>;
  subscription_object_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Order_Subscription_Object_Stddev_Fields = {
  __typename?: 'order_subscription_object_stddev_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_subscription_object" */
export type Order_Subscription_Object_Stddev_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Subscription_Object_Stddev_Pop_Fields = {
  __typename?: 'order_subscription_object_stddev_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_subscription_object" */
export type Order_Subscription_Object_Stddev_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Subscription_Object_Stddev_Samp_Fields = {
  __typename?: 'order_subscription_object_stddev_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_subscription_object" */
export type Order_Subscription_Object_Stddev_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Order_Subscription_Object_Sum_Fields = {
  __typename?: 'order_subscription_object_sum_fields';
  order_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_subscription_object" */
export type Order_Subscription_Object_Sum_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** update columns of table "order_subscription_object" */
export enum Order_Subscription_Object_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DraftSubscriptionObjectId = 'draft_subscription_object_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  SubscriptionObjectId = 'subscription_object_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Order_Subscription_Object_Var_Pop_Fields = {
  __typename?: 'order_subscription_object_var_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_subscription_object" */
export type Order_Subscription_Object_Var_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Subscription_Object_Var_Samp_Fields = {
  __typename?: 'order_subscription_object_var_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_subscription_object" */
export type Order_Subscription_Object_Var_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Subscription_Object_Variance_Fields = {
  __typename?: 'order_subscription_object_variance_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_subscription_object" */
export type Order_Subscription_Object_Variance_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_subscription_price" */
export type Order_Subscription_Price = {
  __typename?: 'order_subscription_price';
  /** An object relationship */
  address?: Maybe<Addresses>;
  address_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  date_activated?: Maybe<Scalars['timestamp']>;
  fulfilled: Scalars['Boolean'];
  id: Scalars['uuid'];
  last_dispatched_date?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  /** An object relationship */
  order: Orders;
  order_id: Scalars['Int'];
  password: Scalars['String'];
  recipient: Scalars['String'];
  short_id: Scalars['String'];
  sub_activated: Scalars['Boolean'];
  sub_price_id: Scalars['uuid'];
  subscription_object_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  subscription_price: Subscription_Price;
  total_dispatched: Scalars['Int'];
};

/** aggregated selection of "order_subscription_price" */
export type Order_Subscription_Price_Aggregate = {
  __typename?: 'order_subscription_price_aggregate';
  aggregate?: Maybe<Order_Subscription_Price_Aggregate_Fields>;
  nodes: Array<Order_Subscription_Price>;
};

/** aggregate fields of "order_subscription_price" */
export type Order_Subscription_Price_Aggregate_Fields = {
  __typename?: 'order_subscription_price_aggregate_fields';
  avg?: Maybe<Order_Subscription_Price_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Subscription_Price_Max_Fields>;
  min?: Maybe<Order_Subscription_Price_Min_Fields>;
  stddev?: Maybe<Order_Subscription_Price_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Subscription_Price_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Subscription_Price_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Subscription_Price_Sum_Fields>;
  var_pop?: Maybe<Order_Subscription_Price_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Subscription_Price_Var_Samp_Fields>;
  variance?: Maybe<Order_Subscription_Price_Variance_Fields>;
};


/** aggregate fields of "order_subscription_price" */
export type Order_Subscription_Price_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Subscription_Price_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_subscription_price" */
export type Order_Subscription_Price_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Subscription_Price_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Subscription_Price_Max_Order_By>;
  min?: InputMaybe<Order_Subscription_Price_Min_Order_By>;
  stddev?: InputMaybe<Order_Subscription_Price_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Subscription_Price_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Subscription_Price_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Subscription_Price_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Subscription_Price_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Subscription_Price_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Subscription_Price_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_subscription_price" */
export type Order_Subscription_Price_Arr_Rel_Insert_Input = {
  data: Array<Order_Subscription_Price_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Subscription_Price_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Subscription_Price_Avg_Fields = {
  __typename?: 'order_subscription_price_avg_fields';
  order_id?: Maybe<Scalars['Float']>;
  total_dispatched?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_subscription_price" */
export type Order_Subscription_Price_Avg_Order_By = {
  order_id?: InputMaybe<Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_subscription_price". All fields are combined with a logical 'AND'. */
export type Order_Subscription_Price_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Subscription_Price_Bool_Exp>>;
  _not?: InputMaybe<Order_Subscription_Price_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Subscription_Price_Bool_Exp>>;
  address?: InputMaybe<Addresses_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_activated?: InputMaybe<Timestamp_Comparison_Exp>;
  fulfilled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_dispatched_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  recipient?: InputMaybe<String_Comparison_Exp>;
  short_id?: InputMaybe<String_Comparison_Exp>;
  sub_activated?: InputMaybe<Boolean_Comparison_Exp>;
  sub_price_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscription_object_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscription_price?: InputMaybe<Subscription_Price_Bool_Exp>;
  total_dispatched?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_subscription_price" */
export enum Order_Subscription_Price_Constraint {
  /** unique or primary key constraint */
  OrderSubscriptionPriceIdKey = 'order_subscription_price_id_key',
  /** unique or primary key constraint */
  OrderSubscriptionPricePkey = 'order_subscription_price_pkey',
  /** unique or primary key constraint */
  OrderSubscriptionPriceShortIdKey = 'order_subscription_price_short_id_key'
}

/** input type for incrementing numeric columns in table "order_subscription_price" */
export type Order_Subscription_Price_Inc_Input = {
  order_id?: InputMaybe<Scalars['Int']>;
  total_dispatched?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "order_subscription_price" */
export type Order_Subscription_Price_Insert_Input = {
  address?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_activated?: InputMaybe<Scalars['timestamp']>;
  fulfilled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_dispatched_date?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
  short_id?: InputMaybe<Scalars['String']>;
  sub_activated?: InputMaybe<Scalars['Boolean']>;
  sub_price_id?: InputMaybe<Scalars['uuid']>;
  subscription_object_id?: InputMaybe<Scalars['uuid']>;
  subscription_price?: InputMaybe<Subscription_Price_Obj_Rel_Insert_Input>;
  total_dispatched?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Order_Subscription_Price_Max_Fields = {
  __typename?: 'order_subscription_price_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_activated?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  last_dispatched_date?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
  short_id?: Maybe<Scalars['String']>;
  sub_price_id?: Maybe<Scalars['uuid']>;
  subscription_object_id?: Maybe<Scalars['uuid']>;
  total_dispatched?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "order_subscription_price" */
export type Order_Subscription_Price_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_activated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_dispatched_date?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  sub_price_id?: InputMaybe<Order_By>;
  subscription_object_id?: InputMaybe<Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Subscription_Price_Min_Fields = {
  __typename?: 'order_subscription_price_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_activated?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  last_dispatched_date?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
  short_id?: Maybe<Scalars['String']>;
  sub_price_id?: Maybe<Scalars['uuid']>;
  subscription_object_id?: Maybe<Scalars['uuid']>;
  total_dispatched?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "order_subscription_price" */
export type Order_Subscription_Price_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_activated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_dispatched_date?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  sub_price_id?: InputMaybe<Order_By>;
  subscription_object_id?: InputMaybe<Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_subscription_price" */
export type Order_Subscription_Price_Mutation_Response = {
  __typename?: 'order_subscription_price_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Subscription_Price>;
};

/** on_conflict condition type for table "order_subscription_price" */
export type Order_Subscription_Price_On_Conflict = {
  constraint: Order_Subscription_Price_Constraint;
  update_columns?: Array<Order_Subscription_Price_Update_Column>;
  where?: InputMaybe<Order_Subscription_Price_Bool_Exp>;
};

/** Ordering options when selecting data from "order_subscription_price". */
export type Order_Subscription_Price_Order_By = {
  address?: InputMaybe<Addresses_Order_By>;
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_activated?: InputMaybe<Order_By>;
  fulfilled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_dispatched_date?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  sub_activated?: InputMaybe<Order_By>;
  sub_price_id?: InputMaybe<Order_By>;
  subscription_object_id?: InputMaybe<Order_By>;
  subscription_price?: InputMaybe<Subscription_Price_Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_subscription_price */
export type Order_Subscription_Price_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "order_subscription_price" */
export enum Order_Subscription_Price_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateActivated = 'date_activated',
  /** column name */
  Fulfilled = 'fulfilled',
  /** column name */
  Id = 'id',
  /** column name */
  LastDispatchedDate = 'last_dispatched_date',
  /** column name */
  Message = 'message',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Password = 'password',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  ShortId = 'short_id',
  /** column name */
  SubActivated = 'sub_activated',
  /** column name */
  SubPriceId = 'sub_price_id',
  /** column name */
  SubscriptionObjectId = 'subscription_object_id',
  /** column name */
  TotalDispatched = 'total_dispatched'
}

/** input type for updating data in table "order_subscription_price" */
export type Order_Subscription_Price_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_activated?: InputMaybe<Scalars['timestamp']>;
  fulfilled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_dispatched_date?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
  short_id?: InputMaybe<Scalars['String']>;
  sub_activated?: InputMaybe<Scalars['Boolean']>;
  sub_price_id?: InputMaybe<Scalars['uuid']>;
  subscription_object_id?: InputMaybe<Scalars['uuid']>;
  total_dispatched?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Order_Subscription_Price_Stddev_Fields = {
  __typename?: 'order_subscription_price_stddev_fields';
  order_id?: Maybe<Scalars['Float']>;
  total_dispatched?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_subscription_price" */
export type Order_Subscription_Price_Stddev_Order_By = {
  order_id?: InputMaybe<Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Subscription_Price_Stddev_Pop_Fields = {
  __typename?: 'order_subscription_price_stddev_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
  total_dispatched?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_subscription_price" */
export type Order_Subscription_Price_Stddev_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Subscription_Price_Stddev_Samp_Fields = {
  __typename?: 'order_subscription_price_stddev_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
  total_dispatched?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_subscription_price" */
export type Order_Subscription_Price_Stddev_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Order_Subscription_Price_Sum_Fields = {
  __typename?: 'order_subscription_price_sum_fields';
  order_id?: Maybe<Scalars['Int']>;
  total_dispatched?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_subscription_price" */
export type Order_Subscription_Price_Sum_Order_By = {
  order_id?: InputMaybe<Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** update columns of table "order_subscription_price" */
export enum Order_Subscription_Price_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateActivated = 'date_activated',
  /** column name */
  Fulfilled = 'fulfilled',
  /** column name */
  Id = 'id',
  /** column name */
  LastDispatchedDate = 'last_dispatched_date',
  /** column name */
  Message = 'message',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Password = 'password',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  ShortId = 'short_id',
  /** column name */
  SubActivated = 'sub_activated',
  /** column name */
  SubPriceId = 'sub_price_id',
  /** column name */
  SubscriptionObjectId = 'subscription_object_id',
  /** column name */
  TotalDispatched = 'total_dispatched'
}

/** aggregate var_pop on columns */
export type Order_Subscription_Price_Var_Pop_Fields = {
  __typename?: 'order_subscription_price_var_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
  total_dispatched?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_subscription_price" */
export type Order_Subscription_Price_Var_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Subscription_Price_Var_Samp_Fields = {
  __typename?: 'order_subscription_price_var_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
  total_dispatched?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_subscription_price" */
export type Order_Subscription_Price_Var_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Subscription_Price_Variance_Fields = {
  __typename?: 'order_subscription_price_variance_fields';
  order_id?: Maybe<Scalars['Float']>;
  total_dispatched?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_subscription_price" */
export type Order_Subscription_Price_Variance_Order_By = {
  order_id?: InputMaybe<Order_By>;
  total_dispatched?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_voucher" */
export type Order_Voucher = {
  __typename?: 'order_voucher';
  amount_discounted: Scalars['Int'];
  /** An object relationship */
  order: Orders;
  order_id: Scalars['Int'];
  /** An object relationship */
  voucher: Vouchers;
  voucher_id: Scalars['String'];
};

/** aggregated selection of "order_voucher" */
export type Order_Voucher_Aggregate = {
  __typename?: 'order_voucher_aggregate';
  aggregate?: Maybe<Order_Voucher_Aggregate_Fields>;
  nodes: Array<Order_Voucher>;
};

/** aggregate fields of "order_voucher" */
export type Order_Voucher_Aggregate_Fields = {
  __typename?: 'order_voucher_aggregate_fields';
  avg?: Maybe<Order_Voucher_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Voucher_Max_Fields>;
  min?: Maybe<Order_Voucher_Min_Fields>;
  stddev?: Maybe<Order_Voucher_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Voucher_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Voucher_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Voucher_Sum_Fields>;
  var_pop?: Maybe<Order_Voucher_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Voucher_Var_Samp_Fields>;
  variance?: Maybe<Order_Voucher_Variance_Fields>;
};


/** aggregate fields of "order_voucher" */
export type Order_Voucher_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Voucher_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_voucher" */
export type Order_Voucher_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Voucher_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Voucher_Max_Order_By>;
  min?: InputMaybe<Order_Voucher_Min_Order_By>;
  stddev?: InputMaybe<Order_Voucher_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Voucher_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Voucher_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Voucher_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Voucher_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Voucher_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Voucher_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_voucher" */
export type Order_Voucher_Arr_Rel_Insert_Input = {
  data: Array<Order_Voucher_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Voucher_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Voucher_Avg_Fields = {
  __typename?: 'order_voucher_avg_fields';
  amount_discounted?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_voucher" */
export type Order_Voucher_Avg_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_voucher". All fields are combined with a logical 'AND'. */
export type Order_Voucher_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Voucher_Bool_Exp>>;
  _not?: InputMaybe<Order_Voucher_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Voucher_Bool_Exp>>;
  amount_discounted?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  voucher?: InputMaybe<Vouchers_Bool_Exp>;
  voucher_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_voucher" */
export enum Order_Voucher_Constraint {
  /** unique or primary key constraint */
  OrderVoucherPkey = 'order_voucher_pkey'
}

/** input type for incrementing numeric columns in table "order_voucher" */
export type Order_Voucher_Inc_Input = {
  amount_discounted?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "order_voucher" */
export type Order_Voucher_Insert_Input = {
  amount_discounted?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  voucher?: InputMaybe<Vouchers_Obj_Rel_Insert_Input>;
  voucher_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Order_Voucher_Max_Fields = {
  __typename?: 'order_voucher_max_fields';
  amount_discounted?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  voucher_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "order_voucher" */
export type Order_Voucher_Max_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Voucher_Min_Fields = {
  __typename?: 'order_voucher_min_fields';
  amount_discounted?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  voucher_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "order_voucher" */
export type Order_Voucher_Min_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_voucher" */
export type Order_Voucher_Mutation_Response = {
  __typename?: 'order_voucher_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Voucher>;
};

/** on_conflict condition type for table "order_voucher" */
export type Order_Voucher_On_Conflict = {
  constraint: Order_Voucher_Constraint;
  update_columns?: Array<Order_Voucher_Update_Column>;
  where?: InputMaybe<Order_Voucher_Bool_Exp>;
};

/** Ordering options when selecting data from "order_voucher". */
export type Order_Voucher_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  voucher?: InputMaybe<Vouchers_Order_By>;
  voucher_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_voucher */
export type Order_Voucher_Pk_Columns_Input = {
  order_id: Scalars['Int'];
  voucher_id: Scalars['String'];
};

/** select columns of table "order_voucher" */
export enum Order_Voucher_Select_Column {
  /** column name */
  AmountDiscounted = 'amount_discounted',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  VoucherId = 'voucher_id'
}

/** input type for updating data in table "order_voucher" */
export type Order_Voucher_Set_Input = {
  amount_discounted?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  voucher_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Order_Voucher_Stddev_Fields = {
  __typename?: 'order_voucher_stddev_fields';
  amount_discounted?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_voucher" */
export type Order_Voucher_Stddev_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Voucher_Stddev_Pop_Fields = {
  __typename?: 'order_voucher_stddev_pop_fields';
  amount_discounted?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_voucher" */
export type Order_Voucher_Stddev_Pop_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Voucher_Stddev_Samp_Fields = {
  __typename?: 'order_voucher_stddev_samp_fields';
  amount_discounted?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_voucher" */
export type Order_Voucher_Stddev_Samp_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Order_Voucher_Sum_Fields = {
  __typename?: 'order_voucher_sum_fields';
  amount_discounted?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_voucher" */
export type Order_Voucher_Sum_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** update columns of table "order_voucher" */
export enum Order_Voucher_Update_Column {
  /** column name */
  AmountDiscounted = 'amount_discounted',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  VoucherId = 'voucher_id'
}

/** aggregate var_pop on columns */
export type Order_Voucher_Var_Pop_Fields = {
  __typename?: 'order_voucher_var_pop_fields';
  amount_discounted?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_voucher" */
export type Order_Voucher_Var_Pop_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Voucher_Var_Samp_Fields = {
  __typename?: 'order_voucher_var_samp_fields';
  amount_discounted?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_voucher" */
export type Order_Voucher_Var_Samp_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Voucher_Variance_Fields = {
  __typename?: 'order_voucher_variance_fields';
  amount_discounted?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_voucher" */
export type Order_Voucher_Variance_Order_By = {
  amount_discounted?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "orders" */
export type Orders = {
  __typename?: 'orders';
  /** An object relationship */
  account?: Maybe<Accounts>;
  account_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  address: Addresses;
  address_id: Scalars['uuid'];
  custom_line_price?: Maybe<Scalars['Int']>;
  custom_line_status?: Maybe<Order_Item_Status_Enum>;
  custom_line_title?: Maybe<Scalars['String']>;
  custom_shipping_price?: Maybe<Scalars['Int']>;
  custom_shipping_title?: Maybe<Scalars['String']>;
  customer_note?: Maybe<Scalars['String']>;
  date_created: Scalars['timestamptz'];
  date_fulfilled?: Maybe<Scalars['timestamptz']>;
  date_ready?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  discount?: Maybe<Discounts>;
  discount_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  event_tickets: Array<Event_Tickets>;
  /** An aggregate relationship */
  event_tickets_aggregate: Event_Tickets_Aggregate;
  gift_wrap: Scalars['Boolean'];
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  /** An array relationship */
  order_books: Array<Order_Book>;
  /** An aggregate relationship */
  order_books_aggregate: Order_Book_Aggregate;
  /** An array relationship */
  order_products: Array<Order_Product>;
  /** An aggregate relationship */
  order_products_aggregate: Order_Product_Aggregate;
  /** An array relationship */
  order_subscription_objects: Array<Order_Subscription_Object>;
  /** An aggregate relationship */
  order_subscription_objects_aggregate: Order_Subscription_Object_Aggregate;
  /** An array relationship */
  order_vouchers_for_discount: Array<Order_Voucher>;
  /** An aggregate relationship */
  order_vouchers_for_discount_aggregate: Order_Voucher_Aggregate;
  pick_up: Scalars['Boolean'];
  /** An array relationship */
  pif_donations: Array<Pif_Donations>;
  /** An aggregate relationship */
  pif_donations_aggregate: Pif_Donations_Aggregate;
  /** An array relationship */
  refunds: Array<Refunds>;
  /** An aggregate relationship */
  refunds_aggregate: Refunds_Aggregate;
  /** An object relationship */
  shipping_option?: Maybe<Shipping_Options>;
  shipping_option_id?: Maybe<Scalars['uuid']>;
  status: Order_Status_Enum;
  stripe_payment_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  subscription_objects: Array<Subscription_Object>;
  /** An aggregate relationship */
  subscription_objects_aggregate: Subscription_Object_Aggregate;
  /** An array relationship */
  vouchers: Array<Vouchers>;
  /** An aggregate relationship */
  vouchers_aggregate: Vouchers_Aggregate;
  wrapping: Scalars['Int'];
};


/** columns and relationships of "orders" */
export type OrdersEvent_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersEvent_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_BooksArgs = {
  distinct_on?: InputMaybe<Array<Order_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Book_Order_By>>;
  where?: InputMaybe<Order_Book_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Book_Order_By>>;
  where?: InputMaybe<Order_Book_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Subscription_ObjectsArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Object_Order_By>>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Subscription_Objects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Object_Order_By>>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Vouchers_For_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Order_Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Voucher_Order_By>>;
  where?: InputMaybe<Order_Voucher_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Vouchers_For_Discount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Voucher_Order_By>>;
  where?: InputMaybe<Order_Voucher_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersPif_DonationsArgs = {
  distinct_on?: InputMaybe<Array<Pif_Donations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pif_Donations_Order_By>>;
  where?: InputMaybe<Pif_Donations_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersPif_Donations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pif_Donations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pif_Donations_Order_By>>;
  where?: InputMaybe<Pif_Donations_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersRefundsArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersRefunds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersSubscription_ObjectsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersSubscription_Objects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersVouchersArgs = {
  distinct_on?: InputMaybe<Array<Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vouchers_Order_By>>;
  where?: InputMaybe<Vouchers_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersVouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vouchers_Order_By>>;
  where?: InputMaybe<Vouchers_Bool_Exp>;
};

/** aggregated selection of "orders" */
export type Orders_Aggregate = {
  __typename?: 'orders_aggregate';
  aggregate?: Maybe<Orders_Aggregate_Fields>;
  nodes: Array<Orders>;
};

/** aggregate fields of "orders" */
export type Orders_Aggregate_Fields = {
  __typename?: 'orders_aggregate_fields';
  avg?: Maybe<Orders_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Orders_Max_Fields>;
  min?: Maybe<Orders_Min_Fields>;
  stddev?: Maybe<Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Orders_Sum_Fields>;
  var_pop?: Maybe<Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Orders_Var_Samp_Fields>;
  variance?: Maybe<Orders_Variance_Fields>;
};


/** aggregate fields of "orders" */
export type Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "orders" */
export type Orders_Aggregate_Order_By = {
  avg?: InputMaybe<Orders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Orders_Max_Order_By>;
  min?: InputMaybe<Orders_Min_Order_By>;
  stddev?: InputMaybe<Orders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Orders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Orders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Orders_Sum_Order_By>;
  var_pop?: InputMaybe<Orders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Orders_Var_Samp_Order_By>;
  variance?: InputMaybe<Orders_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "orders" */
export type Orders_Arr_Rel_Insert_Input = {
  data: Array<Orders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};

/** aggregate avg on columns */
export type Orders_Avg_Fields = {
  __typename?: 'orders_avg_fields';
  custom_line_price?: Maybe<Scalars['Float']>;
  custom_shipping_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  wrapping?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "orders" */
export type Orders_Avg_Order_By = {
  custom_line_price?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "orders". All fields are combined with a logical 'AND'. */
export type Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Orders_Bool_Exp>>;
  _not?: InputMaybe<Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Orders_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  address?: InputMaybe<Addresses_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  custom_line_price?: InputMaybe<Int_Comparison_Exp>;
  custom_line_status?: InputMaybe<Order_Item_Status_Enum_Comparison_Exp>;
  custom_line_title?: InputMaybe<String_Comparison_Exp>;
  custom_shipping_price?: InputMaybe<Int_Comparison_Exp>;
  custom_shipping_title?: InputMaybe<String_Comparison_Exp>;
  customer_note?: InputMaybe<String_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_fulfilled?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_ready?: InputMaybe<Timestamptz_Comparison_Exp>;
  discount?: InputMaybe<Discounts_Bool_Exp>;
  discount_code?: InputMaybe<String_Comparison_Exp>;
  event_tickets?: InputMaybe<Event_Tickets_Bool_Exp>;
  gift_wrap?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  order_books?: InputMaybe<Order_Book_Bool_Exp>;
  order_products?: InputMaybe<Order_Product_Bool_Exp>;
  order_subscription_objects?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
  order_vouchers_for_discount?: InputMaybe<Order_Voucher_Bool_Exp>;
  pick_up?: InputMaybe<Boolean_Comparison_Exp>;
  pif_donations?: InputMaybe<Pif_Donations_Bool_Exp>;
  refunds?: InputMaybe<Refunds_Bool_Exp>;
  shipping_option?: InputMaybe<Shipping_Options_Bool_Exp>;
  shipping_option_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Order_Status_Enum_Comparison_Exp>;
  stripe_payment_id?: InputMaybe<String_Comparison_Exp>;
  subscription_objects?: InputMaybe<Subscription_Object_Bool_Exp>;
  vouchers?: InputMaybe<Vouchers_Bool_Exp>;
  wrapping?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "orders" */
export enum Orders_Constraint {
  /** unique or primary key constraint */
  OrdersPkey = 'orders_pkey'
}

/** input type for incrementing numeric columns in table "orders" */
export type Orders_Inc_Input = {
  custom_line_price?: InputMaybe<Scalars['Int']>;
  custom_shipping_price?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  wrapping?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "orders" */
export type Orders_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']>;
  address?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['uuid']>;
  custom_line_price?: InputMaybe<Scalars['Int']>;
  custom_line_status?: InputMaybe<Order_Item_Status_Enum>;
  custom_line_title?: InputMaybe<Scalars['String']>;
  custom_shipping_price?: InputMaybe<Scalars['Int']>;
  custom_shipping_title?: InputMaybe<Scalars['String']>;
  customer_note?: InputMaybe<Scalars['String']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_fulfilled?: InputMaybe<Scalars['timestamptz']>;
  date_ready?: InputMaybe<Scalars['timestamptz']>;
  discount?: InputMaybe<Discounts_Obj_Rel_Insert_Input>;
  discount_code?: InputMaybe<Scalars['String']>;
  event_tickets?: InputMaybe<Event_Tickets_Arr_Rel_Insert_Input>;
  gift_wrap?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  order_books?: InputMaybe<Order_Book_Arr_Rel_Insert_Input>;
  order_products?: InputMaybe<Order_Product_Arr_Rel_Insert_Input>;
  order_subscription_objects?: InputMaybe<Order_Subscription_Object_Arr_Rel_Insert_Input>;
  order_vouchers_for_discount?: InputMaybe<Order_Voucher_Arr_Rel_Insert_Input>;
  pick_up?: InputMaybe<Scalars['Boolean']>;
  pif_donations?: InputMaybe<Pif_Donations_Arr_Rel_Insert_Input>;
  refunds?: InputMaybe<Refunds_Arr_Rel_Insert_Input>;
  shipping_option?: InputMaybe<Shipping_Options_Obj_Rel_Insert_Input>;
  shipping_option_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Order_Status_Enum>;
  stripe_payment_id?: InputMaybe<Scalars['String']>;
  subscription_objects?: InputMaybe<Subscription_Object_Arr_Rel_Insert_Input>;
  vouchers?: InputMaybe<Vouchers_Arr_Rel_Insert_Input>;
  wrapping?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Orders_Max_Fields = {
  __typename?: 'orders_max_fields';
  account_id?: Maybe<Scalars['uuid']>;
  address_id?: Maybe<Scalars['uuid']>;
  custom_line_price?: Maybe<Scalars['Int']>;
  custom_line_title?: Maybe<Scalars['String']>;
  custom_shipping_price?: Maybe<Scalars['Int']>;
  custom_shipping_title?: Maybe<Scalars['String']>;
  customer_note?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_fulfilled?: Maybe<Scalars['timestamptz']>;
  date_ready?: Maybe<Scalars['timestamptz']>;
  discount_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  shipping_option_id?: Maybe<Scalars['uuid']>;
  stripe_payment_id?: Maybe<Scalars['String']>;
  wrapping?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "orders" */
export type Orders_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  custom_line_price?: InputMaybe<Order_By>;
  custom_line_title?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  custom_shipping_title?: InputMaybe<Order_By>;
  customer_note?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_fulfilled?: InputMaybe<Order_By>;
  date_ready?: InputMaybe<Order_By>;
  discount_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  shipping_option_id?: InputMaybe<Order_By>;
  stripe_payment_id?: InputMaybe<Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Orders_Min_Fields = {
  __typename?: 'orders_min_fields';
  account_id?: Maybe<Scalars['uuid']>;
  address_id?: Maybe<Scalars['uuid']>;
  custom_line_price?: Maybe<Scalars['Int']>;
  custom_line_title?: Maybe<Scalars['String']>;
  custom_shipping_price?: Maybe<Scalars['Int']>;
  custom_shipping_title?: Maybe<Scalars['String']>;
  customer_note?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_fulfilled?: Maybe<Scalars['timestamptz']>;
  date_ready?: Maybe<Scalars['timestamptz']>;
  discount_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  shipping_option_id?: Maybe<Scalars['uuid']>;
  stripe_payment_id?: Maybe<Scalars['String']>;
  wrapping?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "orders" */
export type Orders_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  custom_line_price?: InputMaybe<Order_By>;
  custom_line_title?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  custom_shipping_title?: InputMaybe<Order_By>;
  customer_note?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_fulfilled?: InputMaybe<Order_By>;
  date_ready?: InputMaybe<Order_By>;
  discount_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  shipping_option_id?: InputMaybe<Order_By>;
  stripe_payment_id?: InputMaybe<Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "orders" */
export type Orders_Mutation_Response = {
  __typename?: 'orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Orders>;
};

/** input type for inserting object relation for remote table "orders" */
export type Orders_Obj_Rel_Insert_Input = {
  data: Orders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};

/** on_conflict condition type for table "orders" */
export type Orders_On_Conflict = {
  constraint: Orders_Constraint;
  update_columns?: Array<Orders_Update_Column>;
  where?: InputMaybe<Orders_Bool_Exp>;
};

/** Ordering options when selecting data from "orders". */
export type Orders_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  address?: InputMaybe<Addresses_Order_By>;
  address_id?: InputMaybe<Order_By>;
  custom_line_price?: InputMaybe<Order_By>;
  custom_line_status?: InputMaybe<Order_By>;
  custom_line_title?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  custom_shipping_title?: InputMaybe<Order_By>;
  customer_note?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_fulfilled?: InputMaybe<Order_By>;
  date_ready?: InputMaybe<Order_By>;
  discount?: InputMaybe<Discounts_Order_By>;
  discount_code?: InputMaybe<Order_By>;
  event_tickets_aggregate?: InputMaybe<Event_Tickets_Aggregate_Order_By>;
  gift_wrap?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  order_books_aggregate?: InputMaybe<Order_Book_Aggregate_Order_By>;
  order_products_aggregate?: InputMaybe<Order_Product_Aggregate_Order_By>;
  order_subscription_objects_aggregate?: InputMaybe<Order_Subscription_Object_Aggregate_Order_By>;
  order_vouchers_for_discount_aggregate?: InputMaybe<Order_Voucher_Aggregate_Order_By>;
  pick_up?: InputMaybe<Order_By>;
  pif_donations_aggregate?: InputMaybe<Pif_Donations_Aggregate_Order_By>;
  refunds_aggregate?: InputMaybe<Refunds_Aggregate_Order_By>;
  shipping_option?: InputMaybe<Shipping_Options_Order_By>;
  shipping_option_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_payment_id?: InputMaybe<Order_By>;
  subscription_objects_aggregate?: InputMaybe<Subscription_Object_Aggregate_Order_By>;
  vouchers_aggregate?: InputMaybe<Vouchers_Aggregate_Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** primary key columns input for table: orders */
export type Orders_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "orders" */
export enum Orders_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CustomLinePrice = 'custom_line_price',
  /** column name */
  CustomLineStatus = 'custom_line_status',
  /** column name */
  CustomLineTitle = 'custom_line_title',
  /** column name */
  CustomShippingPrice = 'custom_shipping_price',
  /** column name */
  CustomShippingTitle = 'custom_shipping_title',
  /** column name */
  CustomerNote = 'customer_note',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateFulfilled = 'date_fulfilled',
  /** column name */
  DateReady = 'date_ready',
  /** column name */
  DiscountCode = 'discount_code',
  /** column name */
  GiftWrap = 'gift_wrap',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PickUp = 'pick_up',
  /** column name */
  ShippingOptionId = 'shipping_option_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripePaymentId = 'stripe_payment_id',
  /** column name */
  Wrapping = 'wrapping'
}

/** input type for updating data in table "orders" */
export type Orders_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  address_id?: InputMaybe<Scalars['uuid']>;
  custom_line_price?: InputMaybe<Scalars['Int']>;
  custom_line_status?: InputMaybe<Order_Item_Status_Enum>;
  custom_line_title?: InputMaybe<Scalars['String']>;
  custom_shipping_price?: InputMaybe<Scalars['Int']>;
  custom_shipping_title?: InputMaybe<Scalars['String']>;
  customer_note?: InputMaybe<Scalars['String']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_fulfilled?: InputMaybe<Scalars['timestamptz']>;
  date_ready?: InputMaybe<Scalars['timestamptz']>;
  discount_code?: InputMaybe<Scalars['String']>;
  gift_wrap?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  pick_up?: InputMaybe<Scalars['Boolean']>;
  shipping_option_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Order_Status_Enum>;
  stripe_payment_id?: InputMaybe<Scalars['String']>;
  wrapping?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Orders_Stddev_Fields = {
  __typename?: 'orders_stddev_fields';
  custom_line_price?: Maybe<Scalars['Float']>;
  custom_shipping_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  wrapping?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "orders" */
export type Orders_Stddev_Order_By = {
  custom_line_price?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Orders_Stddev_Pop_Fields = {
  __typename?: 'orders_stddev_pop_fields';
  custom_line_price?: Maybe<Scalars['Float']>;
  custom_shipping_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  wrapping?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "orders" */
export type Orders_Stddev_Pop_Order_By = {
  custom_line_price?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Orders_Stddev_Samp_Fields = {
  __typename?: 'orders_stddev_samp_fields';
  custom_line_price?: Maybe<Scalars['Float']>;
  custom_shipping_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  wrapping?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "orders" */
export type Orders_Stddev_Samp_Order_By = {
  custom_line_price?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Orders_Sum_Fields = {
  __typename?: 'orders_sum_fields';
  custom_line_price?: Maybe<Scalars['Int']>;
  custom_shipping_price?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  wrapping?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "orders" */
export type Orders_Sum_Order_By = {
  custom_line_price?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** update columns of table "orders" */
export enum Orders_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CustomLinePrice = 'custom_line_price',
  /** column name */
  CustomLineStatus = 'custom_line_status',
  /** column name */
  CustomLineTitle = 'custom_line_title',
  /** column name */
  CustomShippingPrice = 'custom_shipping_price',
  /** column name */
  CustomShippingTitle = 'custom_shipping_title',
  /** column name */
  CustomerNote = 'customer_note',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateFulfilled = 'date_fulfilled',
  /** column name */
  DateReady = 'date_ready',
  /** column name */
  DiscountCode = 'discount_code',
  /** column name */
  GiftWrap = 'gift_wrap',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PickUp = 'pick_up',
  /** column name */
  ShippingOptionId = 'shipping_option_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripePaymentId = 'stripe_payment_id',
  /** column name */
  Wrapping = 'wrapping'
}

/** aggregate var_pop on columns */
export type Orders_Var_Pop_Fields = {
  __typename?: 'orders_var_pop_fields';
  custom_line_price?: Maybe<Scalars['Float']>;
  custom_shipping_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  wrapping?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "orders" */
export type Orders_Var_Pop_Order_By = {
  custom_line_price?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Orders_Var_Samp_Fields = {
  __typename?: 'orders_var_samp_fields';
  custom_line_price?: Maybe<Scalars['Float']>;
  custom_shipping_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  wrapping?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "orders" */
export type Orders_Var_Samp_Order_By = {
  custom_line_price?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Orders_Variance_Fields = {
  __typename?: 'orders_variance_fields';
  custom_line_price?: Maybe<Scalars['Float']>;
  custom_shipping_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  wrapping?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "orders" */
export type Orders_Variance_Order_By = {
  custom_line_price?: InputMaybe<Order_By>;
  custom_shipping_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wrapping?: InputMaybe<Order_By>;
};

/** columns and relationships of "pages" */
export type Pages = {
  __typename?: 'pages';
  content: Scalars['jsonb'];
  title: Scalars['String'];
};


/** columns and relationships of "pages" */
export type PagesContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "pages" */
export type Pages_Aggregate = {
  __typename?: 'pages_aggregate';
  aggregate?: Maybe<Pages_Aggregate_Fields>;
  nodes: Array<Pages>;
};

/** aggregate fields of "pages" */
export type Pages_Aggregate_Fields = {
  __typename?: 'pages_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Pages_Max_Fields>;
  min?: Maybe<Pages_Min_Fields>;
};


/** aggregate fields of "pages" */
export type Pages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Pages_Append_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "pages". All fields are combined with a logical 'AND'. */
export type Pages_Bool_Exp = {
  _and?: InputMaybe<Array<Pages_Bool_Exp>>;
  _not?: InputMaybe<Pages_Bool_Exp>;
  _or?: InputMaybe<Array<Pages_Bool_Exp>>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pages" */
export enum Pages_Constraint {
  /** unique or primary key constraint */
  PagesPkey = 'pages_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Pages_Delete_At_Path_Input = {
  content?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Pages_Delete_Elem_Input = {
  content?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Pages_Delete_Key_Input = {
  content?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "pages" */
export type Pages_Insert_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Pages_Max_Fields = {
  __typename?: 'pages_max_fields';
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Pages_Min_Fields = {
  __typename?: 'pages_min_fields';
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "pages" */
export type Pages_Mutation_Response = {
  __typename?: 'pages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pages>;
};

/** on_conflict condition type for table "pages" */
export type Pages_On_Conflict = {
  constraint: Pages_Constraint;
  update_columns?: Array<Pages_Update_Column>;
  where?: InputMaybe<Pages_Bool_Exp>;
};

/** Ordering options when selecting data from "pages". */
export type Pages_Order_By = {
  content?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pages */
export type Pages_Pk_Columns_Input = {
  title: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Pages_Prepend_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "pages" */
export enum Pages_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "pages" */
export type Pages_Set_Input = {
  content?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
};

/** update columns of table "pages" */
export enum Pages_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Title = 'title'
}

/** columns and relationships of "pif_donations" */
export type Pif_Donations = {
  __typename?: 'pif_donations';
  amount: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  order?: Maybe<Orders>;
  order_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "pif_donations" */
export type Pif_Donations_Aggregate = {
  __typename?: 'pif_donations_aggregate';
  aggregate?: Maybe<Pif_Donations_Aggregate_Fields>;
  nodes: Array<Pif_Donations>;
};

/** aggregate fields of "pif_donations" */
export type Pif_Donations_Aggregate_Fields = {
  __typename?: 'pif_donations_aggregate_fields';
  avg?: Maybe<Pif_Donations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pif_Donations_Max_Fields>;
  min?: Maybe<Pif_Donations_Min_Fields>;
  stddev?: Maybe<Pif_Donations_Stddev_Fields>;
  stddev_pop?: Maybe<Pif_Donations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pif_Donations_Stddev_Samp_Fields>;
  sum?: Maybe<Pif_Donations_Sum_Fields>;
  var_pop?: Maybe<Pif_Donations_Var_Pop_Fields>;
  var_samp?: Maybe<Pif_Donations_Var_Samp_Fields>;
  variance?: Maybe<Pif_Donations_Variance_Fields>;
};


/** aggregate fields of "pif_donations" */
export type Pif_Donations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pif_Donations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pif_donations" */
export type Pif_Donations_Aggregate_Order_By = {
  avg?: InputMaybe<Pif_Donations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pif_Donations_Max_Order_By>;
  min?: InputMaybe<Pif_Donations_Min_Order_By>;
  stddev?: InputMaybe<Pif_Donations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pif_Donations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pif_Donations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pif_Donations_Sum_Order_By>;
  var_pop?: InputMaybe<Pif_Donations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pif_Donations_Var_Samp_Order_By>;
  variance?: InputMaybe<Pif_Donations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pif_donations" */
export type Pif_Donations_Arr_Rel_Insert_Input = {
  data: Array<Pif_Donations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pif_Donations_On_Conflict>;
};

/** aggregate avg on columns */
export type Pif_Donations_Avg_Fields = {
  __typename?: 'pif_donations_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pif_donations" */
export type Pif_Donations_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pif_donations". All fields are combined with a logical 'AND'. */
export type Pif_Donations_Bool_Exp = {
  _and?: InputMaybe<Array<Pif_Donations_Bool_Exp>>;
  _not?: InputMaybe<Pif_Donations_Bool_Exp>;
  _or?: InputMaybe<Array<Pif_Donations_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "pif_donations" */
export enum Pif_Donations_Constraint {
  /** unique or primary key constraint */
  PifDonationsPkey = 'pif_donations_pkey'
}

/** input type for incrementing numeric columns in table "pif_donations" */
export type Pif_Donations_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pif_donations" */
export type Pif_Donations_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Pif_Donations_Max_Fields = {
  __typename?: 'pif_donations_max_fields';
  amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "pif_donations" */
export type Pif_Donations_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pif_Donations_Min_Fields = {
  __typename?: 'pif_donations_min_fields';
  amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "pif_donations" */
export type Pif_Donations_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pif_donations" */
export type Pif_Donations_Mutation_Response = {
  __typename?: 'pif_donations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pif_Donations>;
};

/** on_conflict condition type for table "pif_donations" */
export type Pif_Donations_On_Conflict = {
  constraint: Pif_Donations_Constraint;
  update_columns?: Array<Pif_Donations_Update_Column>;
  where?: InputMaybe<Pif_Donations_Bool_Exp>;
};

/** Ordering options when selecting data from "pif_donations". */
export type Pif_Donations_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pif_donations */
export type Pif_Donations_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "pif_donations" */
export enum Pif_Donations_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id'
}

/** input type for updating data in table "pif_donations" */
export type Pif_Donations_Set_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Pif_Donations_Stddev_Fields = {
  __typename?: 'pif_donations_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pif_donations" */
export type Pif_Donations_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pif_Donations_Stddev_Pop_Fields = {
  __typename?: 'pif_donations_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pif_donations" */
export type Pif_Donations_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pif_Donations_Stddev_Samp_Fields = {
  __typename?: 'pif_donations_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pif_donations" */
export type Pif_Donations_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pif_Donations_Sum_Fields = {
  __typename?: 'pif_donations_sum_fields';
  amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pif_donations" */
export type Pif_Donations_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** update columns of table "pif_donations" */
export enum Pif_Donations_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id'
}

/** aggregate var_pop on columns */
export type Pif_Donations_Var_Pop_Fields = {
  __typename?: 'pif_donations_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pif_donations" */
export type Pif_Donations_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pif_Donations_Var_Samp_Fields = {
  __typename?: 'pif_donations_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pif_donations" */
export type Pif_Donations_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pif_Donations_Variance_Fields = {
  __typename?: 'pif_donations_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pif_donations" */
export type Pif_Donations_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "post_book" */
export type Post_Book = {
  __typename?: 'post_book';
  /** An object relationship */
  book: Books;
  book_isbn: Scalars['bigint'];
  /** An object relationship */
  post: Posts;
  post_id: Scalars['uuid'];
  rank_order?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "post_book" */
export type Post_Book_Aggregate = {
  __typename?: 'post_book_aggregate';
  aggregate?: Maybe<Post_Book_Aggregate_Fields>;
  nodes: Array<Post_Book>;
};

/** aggregate fields of "post_book" */
export type Post_Book_Aggregate_Fields = {
  __typename?: 'post_book_aggregate_fields';
  avg?: Maybe<Post_Book_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Post_Book_Max_Fields>;
  min?: Maybe<Post_Book_Min_Fields>;
  stddev?: Maybe<Post_Book_Stddev_Fields>;
  stddev_pop?: Maybe<Post_Book_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Post_Book_Stddev_Samp_Fields>;
  sum?: Maybe<Post_Book_Sum_Fields>;
  var_pop?: Maybe<Post_Book_Var_Pop_Fields>;
  var_samp?: Maybe<Post_Book_Var_Samp_Fields>;
  variance?: Maybe<Post_Book_Variance_Fields>;
};


/** aggregate fields of "post_book" */
export type Post_Book_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Post_Book_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "post_book" */
export type Post_Book_Aggregate_Order_By = {
  avg?: InputMaybe<Post_Book_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Post_Book_Max_Order_By>;
  min?: InputMaybe<Post_Book_Min_Order_By>;
  stddev?: InputMaybe<Post_Book_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Post_Book_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Post_Book_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Post_Book_Sum_Order_By>;
  var_pop?: InputMaybe<Post_Book_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Post_Book_Var_Samp_Order_By>;
  variance?: InputMaybe<Post_Book_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "post_book" */
export type Post_Book_Arr_Rel_Insert_Input = {
  data: Array<Post_Book_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Post_Book_On_Conflict>;
};

/** aggregate avg on columns */
export type Post_Book_Avg_Fields = {
  __typename?: 'post_book_avg_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "post_book" */
export type Post_Book_Avg_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "post_book". All fields are combined with a logical 'AND'. */
export type Post_Book_Bool_Exp = {
  _and?: InputMaybe<Array<Post_Book_Bool_Exp>>;
  _not?: InputMaybe<Post_Book_Bool_Exp>;
  _or?: InputMaybe<Array<Post_Book_Bool_Exp>>;
  book?: InputMaybe<Books_Bool_Exp>;
  book_isbn?: InputMaybe<Bigint_Comparison_Exp>;
  post?: InputMaybe<Posts_Bool_Exp>;
  post_id?: InputMaybe<Uuid_Comparison_Exp>;
  rank_order?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "post_book" */
export enum Post_Book_Constraint {
  /** unique or primary key constraint */
  PostBookPkey = 'post_book_pkey'
}

/** input type for incrementing numeric columns in table "post_book" */
export type Post_Book_Inc_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  rank_order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "post_book" */
export type Post_Book_Insert_Input = {
  book?: InputMaybe<Books_Obj_Rel_Insert_Input>;
  book_isbn?: InputMaybe<Scalars['bigint']>;
  post?: InputMaybe<Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['uuid']>;
  rank_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Post_Book_Max_Fields = {
  __typename?: 'post_book_max_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  post_id?: Maybe<Scalars['uuid']>;
  rank_order?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "post_book" */
export type Post_Book_Max_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Post_Book_Min_Fields = {
  __typename?: 'post_book_min_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  post_id?: Maybe<Scalars['uuid']>;
  rank_order?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "post_book" */
export type Post_Book_Min_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "post_book" */
export type Post_Book_Mutation_Response = {
  __typename?: 'post_book_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Post_Book>;
};

/** on_conflict condition type for table "post_book" */
export type Post_Book_On_Conflict = {
  constraint: Post_Book_Constraint;
  update_columns?: Array<Post_Book_Update_Column>;
  where?: InputMaybe<Post_Book_Bool_Exp>;
};

/** Ordering options when selecting data from "post_book". */
export type Post_Book_Order_By = {
  book?: InputMaybe<Books_Order_By>;
  book_isbn?: InputMaybe<Order_By>;
  post?: InputMaybe<Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** primary key columns input for table: post_book */
export type Post_Book_Pk_Columns_Input = {
  book_isbn: Scalars['bigint'];
  post_id: Scalars['uuid'];
};

/** select columns of table "post_book" */
export enum Post_Book_Select_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  PostId = 'post_id',
  /** column name */
  RankOrder = 'rank_order'
}

/** input type for updating data in table "post_book" */
export type Post_Book_Set_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  post_id?: InputMaybe<Scalars['uuid']>;
  rank_order?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Post_Book_Stddev_Fields = {
  __typename?: 'post_book_stddev_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "post_book" */
export type Post_Book_Stddev_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Post_Book_Stddev_Pop_Fields = {
  __typename?: 'post_book_stddev_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "post_book" */
export type Post_Book_Stddev_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Post_Book_Stddev_Samp_Fields = {
  __typename?: 'post_book_stddev_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "post_book" */
export type Post_Book_Stddev_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Post_Book_Sum_Fields = {
  __typename?: 'post_book_sum_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  rank_order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "post_book" */
export type Post_Book_Sum_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** update columns of table "post_book" */
export enum Post_Book_Update_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  PostId = 'post_id',
  /** column name */
  RankOrder = 'rank_order'
}

/** aggregate var_pop on columns */
export type Post_Book_Var_Pop_Fields = {
  __typename?: 'post_book_var_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "post_book" */
export type Post_Book_Var_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Post_Book_Var_Samp_Fields = {
  __typename?: 'post_book_var_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "post_book" */
export type Post_Book_Var_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Post_Book_Variance_Fields = {
  __typename?: 'post_book_variance_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  rank_order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "post_book" */
export type Post_Book_Variance_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  rank_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "posts" */
export type Posts = {
  __typename?: 'posts';
  /** An object relationship */
  author: Booksellers;
  author_id: Scalars['Int'];
  /** An array relationship */
  category_posts: Array<Category_Post>;
  /** An aggregate relationship */
  category_posts_aggregate: Category_Post_Aggregate;
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  image?: Maybe<Scalars['String']>;
  /** An array relationship */
  post_books: Array<Post_Book>;
  /** An aggregate relationship */
  post_books_aggregate: Post_Book_Aggregate;
  slug: Scalars['String'];
  title: Scalars['String'];
  ts_vector?: Maybe<Scalars['tsvector']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "posts" */
export type PostsCategory_PostsArgs = {
  distinct_on?: InputMaybe<Array<Category_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Post_Order_By>>;
  where?: InputMaybe<Category_Post_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsCategory_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Post_Order_By>>;
  where?: InputMaybe<Category_Post_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPost_BooksArgs = {
  distinct_on?: InputMaybe<Array<Post_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Book_Order_By>>;
  where?: InputMaybe<Post_Book_Bool_Exp>;
};


/** columns and relationships of "posts" */
export type PostsPost_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Post_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Book_Order_By>>;
  where?: InputMaybe<Post_Book_Bool_Exp>;
};

/** aggregated selection of "posts" */
export type Posts_Aggregate = {
  __typename?: 'posts_aggregate';
  aggregate?: Maybe<Posts_Aggregate_Fields>;
  nodes: Array<Posts>;
};

/** aggregate fields of "posts" */
export type Posts_Aggregate_Fields = {
  __typename?: 'posts_aggregate_fields';
  avg?: Maybe<Posts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Posts_Max_Fields>;
  min?: Maybe<Posts_Min_Fields>;
  stddev?: Maybe<Posts_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Sum_Fields>;
  var_pop?: Maybe<Posts_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Var_Samp_Fields>;
  variance?: Maybe<Posts_Variance_Fields>;
};


/** aggregate fields of "posts" */
export type Posts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "posts" */
export type Posts_Aggregate_Order_By = {
  avg?: InputMaybe<Posts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posts_Max_Order_By>;
  min?: InputMaybe<Posts_Min_Order_By>;
  stddev?: InputMaybe<Posts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Posts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Posts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Posts_Sum_Order_By>;
  var_pop?: InputMaybe<Posts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Posts_Var_Samp_Order_By>;
  variance?: InputMaybe<Posts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "posts" */
export type Posts_Arr_Rel_Insert_Input = {
  data: Array<Posts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_On_Conflict>;
};

/** aggregate avg on columns */
export type Posts_Avg_Fields = {
  __typename?: 'posts_avg_fields';
  author_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "posts" */
export type Posts_Avg_Order_By = {
  author_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posts". All fields are combined with a logical 'AND'. */
export type Posts_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Bool_Exp>>;
  _not?: InputMaybe<Posts_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Bool_Exp>>;
  author?: InputMaybe<Booksellers_Bool_Exp>;
  author_id?: InputMaybe<Int_Comparison_Exp>;
  category_posts?: InputMaybe<Category_Post_Bool_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  post_books?: InputMaybe<Post_Book_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  ts_vector?: InputMaybe<Tsvector_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "posts" */
export enum Posts_Constraint {
  /** unique or primary key constraint */
  PostsPkey = 'posts_pkey',
  /** unique or primary key constraint */
  PostsSlugKey = 'posts_slug_key'
}

/** input type for incrementing numeric columns in table "posts" */
export type Posts_Inc_Input = {
  author_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "posts" */
export type Posts_Insert_Input = {
  author?: InputMaybe<Booksellers_Obj_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['Int']>;
  category_posts?: InputMaybe<Category_Post_Arr_Rel_Insert_Input>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  image?: InputMaybe<Scalars['String']>;
  post_books?: InputMaybe<Post_Book_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Posts_Max_Fields = {
  __typename?: 'posts_max_fields';
  author_id?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  image?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "posts" */
export type Posts_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posts_Min_Fields = {
  __typename?: 'posts_min_fields';
  author_id?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  image?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "posts" */
export type Posts_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posts" */
export type Posts_Mutation_Response = {
  __typename?: 'posts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Posts>;
};

/** input type for inserting object relation for remote table "posts" */
export type Posts_Obj_Rel_Insert_Input = {
  data: Posts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Posts_On_Conflict>;
};

/** on_conflict condition type for table "posts" */
export type Posts_On_Conflict = {
  constraint: Posts_Constraint;
  update_columns?: Array<Posts_Update_Column>;
  where?: InputMaybe<Posts_Bool_Exp>;
};

/** Ordering options when selecting data from "posts". */
export type Posts_Order_By = {
  author?: InputMaybe<Booksellers_Order_By>;
  author_id?: InputMaybe<Order_By>;
  category_posts_aggregate?: InputMaybe<Category_Post_Aggregate_Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  post_books_aggregate?: InputMaybe<Post_Book_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  ts_vector?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posts */
export type Posts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "posts" */
export enum Posts_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  TsVector = 'ts_vector',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "posts" */
export type Posts_Set_Input = {
  author_id?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  image?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Posts_Stddev_Fields = {
  __typename?: 'posts_stddev_fields';
  author_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "posts" */
export type Posts_Stddev_Order_By = {
  author_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posts_Stddev_Pop_Fields = {
  __typename?: 'posts_stddev_pop_fields';
  author_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "posts" */
export type Posts_Stddev_Pop_Order_By = {
  author_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posts_Stddev_Samp_Fields = {
  __typename?: 'posts_stddev_samp_fields';
  author_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "posts" */
export type Posts_Stddev_Samp_Order_By = {
  author_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Posts_Sum_Fields = {
  __typename?: 'posts_sum_fields';
  author_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "posts" */
export type Posts_Sum_Order_By = {
  author_id?: InputMaybe<Order_By>;
};

/** update columns of table "posts" */
export enum Posts_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  TsVector = 'ts_vector',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Posts_Var_Pop_Fields = {
  __typename?: 'posts_var_pop_fields';
  author_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "posts" */
export type Posts_Var_Pop_Order_By = {
  author_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posts_Var_Samp_Fields = {
  __typename?: 'posts_var_samp_fields';
  author_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "posts" */
export type Posts_Var_Samp_Order_By = {
  author_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Posts_Variance_Fields = {
  __typename?: 'posts_variance_fields';
  author_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "posts" */
export type Posts_Variance_Order_By = {
  author_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "products" */
export type Products = {
  __typename?: 'products';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  discount_value?: Maybe<Scalars['Int']>;
  duration_length?: Maybe<Scalars['Int']>;
  duration_length_type?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  image?: Maybe<Scalars['String']>;
  is_deleted: Scalars['Boolean'];
  is_discounted: Scalars['Boolean'];
  is_sub: Scalars['Boolean'];
  price: Scalars['Int'];
  slug: Scalars['String'];
  stock?: Maybe<Scalars['Int']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  sub_interval?: Maybe<Scalars['Int']>;
  sub_interval_type?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  ts_vector?: Maybe<Scalars['tsvector']>;
};

/** aggregated selection of "products" */
export type Products_Aggregate = {
  __typename?: 'products_aggregate';
  aggregate?: Maybe<Products_Aggregate_Fields>;
  nodes: Array<Products>;
};

/** aggregate fields of "products" */
export type Products_Aggregate_Fields = {
  __typename?: 'products_aggregate_fields';
  avg?: Maybe<Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Products_Max_Fields>;
  min?: Maybe<Products_Min_Fields>;
  stddev?: Maybe<Products_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Sum_Fields>;
  var_pop?: Maybe<Products_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Var_Samp_Fields>;
  variance?: Maybe<Products_Variance_Fields>;
};


/** aggregate fields of "products" */
export type Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Products_Avg_Fields = {
  __typename?: 'products_avg_fields';
  discount_value?: Maybe<Scalars['Float']>;
  duration_length?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  sub_interval?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type Products_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Bool_Exp>>;
  _not?: InputMaybe<Products_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discount_value?: InputMaybe<Int_Comparison_Exp>;
  duration_length?: InputMaybe<Int_Comparison_Exp>;
  duration_length_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_discounted?: InputMaybe<Boolean_Comparison_Exp>;
  is_sub?: InputMaybe<Boolean_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  stock?: InputMaybe<Int_Comparison_Exp>;
  stripe_price_id?: InputMaybe<String_Comparison_Exp>;
  sub_interval?: InputMaybe<Int_Comparison_Exp>;
  sub_interval_type?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  ts_vector?: InputMaybe<Tsvector_Comparison_Exp>;
};

/** unique or primary key constraints on table "products" */
export enum Products_Constraint {
  /** unique or primary key constraint */
  ProductsPkey1 = 'products_pkey1',
  /** unique or primary key constraint */
  ProductsSlugKey = 'products_slug_key'
}

/** input type for incrementing numeric columns in table "products" */
export type Products_Inc_Input = {
  discount_value?: InputMaybe<Scalars['Int']>;
  duration_length?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  stock?: InputMaybe<Scalars['Int']>;
  sub_interval?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "products" */
export type Products_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discount_value?: InputMaybe<Scalars['Int']>;
  duration_length?: InputMaybe<Scalars['Int']>;
  duration_length_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_discounted?: InputMaybe<Scalars['Boolean']>;
  is_sub?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['Int']>;
  stripe_price_id?: InputMaybe<Scalars['String']>;
  sub_interval?: InputMaybe<Scalars['Int']>;
  sub_interval_type?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
};

/** aggregate max on columns */
export type Products_Max_Fields = {
  __typename?: 'products_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  discount_value?: Maybe<Scalars['Int']>;
  duration_length?: Maybe<Scalars['Int']>;
  duration_length_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['Int']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  sub_interval?: Maybe<Scalars['Int']>;
  sub_interval_type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Products_Min_Fields = {
  __typename?: 'products_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  discount_value?: Maybe<Scalars['Int']>;
  duration_length?: Maybe<Scalars['Int']>;
  duration_length_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['Int']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  sub_interval?: Maybe<Scalars['Int']>;
  sub_interval_type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "products" */
export type Products_Mutation_Response = {
  __typename?: 'products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products>;
};

/** input type for inserting object relation for remote table "products" */
export type Products_Obj_Rel_Insert_Input = {
  data: Products_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_On_Conflict>;
};

/** on_conflict condition type for table "products" */
export type Products_On_Conflict = {
  constraint: Products_Constraint;
  update_columns?: Array<Products_Update_Column>;
  where?: InputMaybe<Products_Bool_Exp>;
};

/** Ordering options when selecting data from "products". */
export type Products_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_value?: InputMaybe<Order_By>;
  duration_length?: InputMaybe<Order_By>;
  duration_length_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_discounted?: InputMaybe<Order_By>;
  is_sub?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  stripe_price_id?: InputMaybe<Order_By>;
  sub_interval?: InputMaybe<Order_By>;
  sub_interval_type?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  ts_vector?: InputMaybe<Order_By>;
};

/** primary key columns input for table: products */
export type Products_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "products" */
export enum Products_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountValue = 'discount_value',
  /** column name */
  DurationLength = 'duration_length',
  /** column name */
  DurationLengthType = 'duration_length_type',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDiscounted = 'is_discounted',
  /** column name */
  IsSub = 'is_sub',
  /** column name */
  Price = 'price',
  /** column name */
  Slug = 'slug',
  /** column name */
  Stock = 'stock',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  SubInterval = 'sub_interval',
  /** column name */
  SubIntervalType = 'sub_interval_type',
  /** column name */
  Title = 'title',
  /** column name */
  TsVector = 'ts_vector'
}

/** input type for updating data in table "products" */
export type Products_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discount_value?: InputMaybe<Scalars['Int']>;
  duration_length?: InputMaybe<Scalars['Int']>;
  duration_length_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_discounted?: InputMaybe<Scalars['Boolean']>;
  is_sub?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['Int']>;
  stripe_price_id?: InputMaybe<Scalars['String']>;
  sub_interval?: InputMaybe<Scalars['Int']>;
  sub_interval_type?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
};

/** aggregate stddev on columns */
export type Products_Stddev_Fields = {
  __typename?: 'products_stddev_fields';
  discount_value?: Maybe<Scalars['Float']>;
  duration_length?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  sub_interval?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Products_Stddev_Pop_Fields = {
  __typename?: 'products_stddev_pop_fields';
  discount_value?: Maybe<Scalars['Float']>;
  duration_length?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  sub_interval?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Products_Stddev_Samp_Fields = {
  __typename?: 'products_stddev_samp_fields';
  discount_value?: Maybe<Scalars['Float']>;
  duration_length?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  sub_interval?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Products_Sum_Fields = {
  __typename?: 'products_sum_fields';
  discount_value?: Maybe<Scalars['Int']>;
  duration_length?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  stock?: Maybe<Scalars['Int']>;
  sub_interval?: Maybe<Scalars['Int']>;
};

/** update columns of table "products" */
export enum Products_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountValue = 'discount_value',
  /** column name */
  DurationLength = 'duration_length',
  /** column name */
  DurationLengthType = 'duration_length_type',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDiscounted = 'is_discounted',
  /** column name */
  IsSub = 'is_sub',
  /** column name */
  Price = 'price',
  /** column name */
  Slug = 'slug',
  /** column name */
  Stock = 'stock',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  SubInterval = 'sub_interval',
  /** column name */
  SubIntervalType = 'sub_interval_type',
  /** column name */
  Title = 'title',
  /** column name */
  TsVector = 'ts_vector'
}

/** aggregate var_pop on columns */
export type Products_Var_Pop_Fields = {
  __typename?: 'products_var_pop_fields';
  discount_value?: Maybe<Scalars['Float']>;
  duration_length?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  sub_interval?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Products_Var_Samp_Fields = {
  __typename?: 'products_var_samp_fields';
  discount_value?: Maybe<Scalars['Float']>;
  duration_length?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  sub_interval?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Products_Variance_Fields = {
  __typename?: 'products_variance_fields';
  discount_value?: Maybe<Scalars['Float']>;
  duration_length?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  sub_interval?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "public_account_details" */
export type Public_Account_Details = {
  __typename?: 'public_account_details';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "public_account_details" */
export type Public_Account_Details_Aggregate = {
  __typename?: 'public_account_details_aggregate';
  aggregate?: Maybe<Public_Account_Details_Aggregate_Fields>;
  nodes: Array<Public_Account_Details>;
};

/** aggregate fields of "public_account_details" */
export type Public_Account_Details_Aggregate_Fields = {
  __typename?: 'public_account_details_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Public_Account_Details_Max_Fields>;
  min?: Maybe<Public_Account_Details_Min_Fields>;
};


/** aggregate fields of "public_account_details" */
export type Public_Account_Details_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Public_Account_Details_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "public_account_details". All fields are combined with a logical 'AND'. */
export type Public_Account_Details_Bool_Exp = {
  _and?: InputMaybe<Array<Public_Account_Details_Bool_Exp>>;
  _not?: InputMaybe<Public_Account_Details_Bool_Exp>;
  _or?: InputMaybe<Array<Public_Account_Details_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "public_account_details" */
export type Public_Account_Details_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Public_Account_Details_Max_Fields = {
  __typename?: 'public_account_details_max_fields';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Public_Account_Details_Min_Fields = {
  __typename?: 'public_account_details_min_fields';
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "public_account_details" */
export type Public_Account_Details_Mutation_Response = {
  __typename?: 'public_account_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Public_Account_Details>;
};

/** input type for inserting object relation for remote table "public_account_details" */
export type Public_Account_Details_Obj_Rel_Insert_Input = {
  data: Public_Account_Details_Insert_Input;
};

/** Ordering options when selecting data from "public_account_details". */
export type Public_Account_Details_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "public_account_details" */
export enum Public_Account_Details_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "public_account_details" */
export type Public_Account_Details_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** An array relationship */
  accounts: Array<Accounts>;
  /** An aggregate relationship */
  accounts_aggregate: Accounts_Aggregate;
  /** fetch data from the table: "accounts" using primary key columns */
  accounts_by_pk?: Maybe<Accounts>;
  /** An array relationship */
  addresses: Array<Addresses>;
  /** An aggregate relationship */
  addresses_aggregate: Addresses_Aggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** fetch data from the table: "book_discount" */
  book_discount: Array<Book_Discount>;
  /** fetch aggregated fields from the table: "book_discount" */
  book_discount_aggregate: Book_Discount_Aggregate;
  /** fetch data from the table: "book_discount" using primary key columns */
  book_discount_by_pk?: Maybe<Book_Discount>;
  /** fetch data from the table: "books" */
  books: Array<Books>;
  /** fetch aggregated fields from the table: "books" */
  books_aggregate: Books_Aggregate;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: Maybe<Books>;
  /** fetch data from the table: "booksellers" */
  booksellers: Array<Booksellers>;
  /** fetch aggregated fields from the table: "booksellers" */
  booksellers_aggregate: Booksellers_Aggregate;
  /** fetch data from the table: "booksellers" using primary key columns */
  booksellers_by_pk?: Maybe<Booksellers>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch aggregated fields from the table: "categories" */
  categories_aggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** fetch data from the table: "category_book" */
  category_book: Array<Category_Book>;
  /** fetch aggregated fields from the table: "category_book" */
  category_book_aggregate: Category_Book_Aggregate;
  /** fetch data from the table: "category_book" using primary key columns */
  category_book_by_pk?: Maybe<Category_Book>;
  /** fetch data from the table: "category_event" */
  category_event: Array<Category_Event>;
  /** fetch aggregated fields from the table: "category_event" */
  category_event_aggregate: Category_Event_Aggregate;
  /** fetch data from the table: "category_event" using primary key columns */
  category_event_by_pk?: Maybe<Category_Event>;
  /** fetch data from the table: "category_post" */
  category_post: Array<Category_Post>;
  /** fetch aggregated fields from the table: "category_post" */
  category_post_aggregate: Category_Post_Aggregate;
  /** fetch data from the table: "category_post" using primary key columns */
  category_post_by_pk?: Maybe<Category_Post>;
  /** fetch data from the table: "children_categories" */
  children_categories: Array<Children_Categories>;
  /** fetch aggregated fields from the table: "children_categories" */
  children_categories_aggregate: Children_Categories_Aggregate;
  /** fetch data from the table: "children_categories" using primary key columns */
  children_categories_by_pk?: Maybe<Children_Categories>;
  /** An array relationship */
  children_category_books: Array<Children_Category_Books>;
  /** An aggregate relationship */
  children_category_books_aggregate: Children_Category_Books_Aggregate;
  /** fetch data from the table: "children_category_books" using primary key columns */
  children_category_books_by_pk?: Maybe<Children_Category_Books>;
  /** fetch data from the table: "contents" */
  contents: Array<Contents>;
  /** fetch aggregated fields from the table: "contents" */
  contents_aggregate: Contents_Aggregate;
  /** fetch data from the table: "contents" using primary key columns */
  contents_by_pk?: Maybe<Contents>;
  /** An array relationship */
  countries: Array<Countries>;
  /** An aggregate relationship */
  countries_aggregate: Countries_Aggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** fetch data from the table: "discount_type" */
  discount_type: Array<Discount_Type>;
  /** fetch aggregated fields from the table: "discount_type" */
  discount_type_aggregate: Discount_Type_Aggregate;
  /** fetch data from the table: "discount_type" using primary key columns */
  discount_type_by_pk?: Maybe<Discount_Type>;
  /** fetch data from the table: "discounts" */
  discounts: Array<Discounts>;
  /** fetch aggregated fields from the table: "discounts" */
  discounts_aggregate: Discounts_Aggregate;
  /** fetch data from the table: "discounts" using primary key columns */
  discounts_by_pk?: Maybe<Discounts>;
  /** fetch data from the table: "empty_searches" */
  empty_searches: Array<Empty_Searches>;
  /** fetch aggregated fields from the table: "empty_searches" */
  empty_searches_aggregate: Empty_Searches_Aggregate;
  /** fetch data from the table: "empty_searches" using primary key columns */
  empty_searches_by_pk?: Maybe<Empty_Searches>;
  /** fetch data from the table: "event_book" */
  event_book: Array<Event_Book>;
  /** fetch aggregated fields from the table: "event_book" */
  event_book_aggregate: Event_Book_Aggregate;
  /** fetch data from the table: "event_book" using primary key columns */
  event_book_by_pk?: Maybe<Event_Book>;
  /** fetch data from the table: "event_comment" */
  event_comment: Array<Event_Comment>;
  /** fetch aggregated fields from the table: "event_comment" */
  event_comment_aggregate: Event_Comment_Aggregate;
  /** fetch data from the table: "event_comment" using primary key columns */
  event_comment_by_pk?: Maybe<Event_Comment>;
  /** An array relationship */
  event_tickets: Array<Event_Tickets>;
  /** An aggregate relationship */
  event_tickets_aggregate: Event_Tickets_Aggregate;
  /** fetch data from the table: "event_tickets" using primary key columns */
  event_tickets_by_pk?: Maybe<Event_Tickets>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** fetch data from the table: "order_book" */
  order_book: Array<Order_Book>;
  /** fetch aggregated fields from the table: "order_book" */
  order_book_aggregate: Order_Book_Aggregate;
  /** fetch data from the table: "order_book" using primary key columns */
  order_book_by_pk?: Maybe<Order_Book>;
  /** fetch data from the table: "order_item_status" */
  order_item_status: Array<Order_Item_Status>;
  /** fetch aggregated fields from the table: "order_item_status" */
  order_item_status_aggregate: Order_Item_Status_Aggregate;
  /** fetch data from the table: "order_item_status" using primary key columns */
  order_item_status_by_pk?: Maybe<Order_Item_Status>;
  /** fetch data from the table: "order_product" */
  order_product: Array<Order_Product>;
  /** fetch aggregated fields from the table: "order_product" */
  order_product_aggregate: Order_Product_Aggregate;
  /** fetch data from the table: "order_product" using primary key columns */
  order_product_by_pk?: Maybe<Order_Product>;
  /** fetch data from the table: "order_status" */
  order_status: Array<Order_Status>;
  /** fetch aggregated fields from the table: "order_status" */
  order_status_aggregate: Order_Status_Aggregate;
  /** fetch data from the table: "order_status" using primary key columns */
  order_status_by_pk?: Maybe<Order_Status>;
  /** fetch data from the table: "order_subscription_object" */
  order_subscription_object: Array<Order_Subscription_Object>;
  /** fetch aggregated fields from the table: "order_subscription_object" */
  order_subscription_object_aggregate: Order_Subscription_Object_Aggregate;
  /** fetch data from the table: "order_subscription_object" using primary key columns */
  order_subscription_object_by_pk?: Maybe<Order_Subscription_Object>;
  /** fetch data from the table: "order_subscription_price" */
  order_subscription_price: Array<Order_Subscription_Price>;
  /** fetch aggregated fields from the table: "order_subscription_price" */
  order_subscription_price_aggregate: Order_Subscription_Price_Aggregate;
  /** fetch data from the table: "order_subscription_price" using primary key columns */
  order_subscription_price_by_pk?: Maybe<Order_Subscription_Price>;
  /** fetch data from the table: "order_voucher" */
  order_voucher: Array<Order_Voucher>;
  /** fetch aggregated fields from the table: "order_voucher" */
  order_voucher_aggregate: Order_Voucher_Aggregate;
  /** fetch data from the table: "order_voucher" using primary key columns */
  order_voucher_by_pk?: Maybe<Order_Voucher>;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk?: Maybe<Orders>;
  /** fetch data from the table: "pages" */
  pages: Array<Pages>;
  /** fetch aggregated fields from the table: "pages" */
  pages_aggregate: Pages_Aggregate;
  /** fetch data from the table: "pages" using primary key columns */
  pages_by_pk?: Maybe<Pages>;
  /** An array relationship */
  pif_donations: Array<Pif_Donations>;
  /** An aggregate relationship */
  pif_donations_aggregate: Pif_Donations_Aggregate;
  /** fetch data from the table: "pif_donations" using primary key columns */
  pif_donations_by_pk?: Maybe<Pif_Donations>;
  /** fetch data from the table: "post_book" */
  post_book: Array<Post_Book>;
  /** fetch aggregated fields from the table: "post_book" */
  post_book_aggregate: Post_Book_Aggregate;
  /** fetch data from the table: "post_book" using primary key columns */
  post_book_by_pk?: Maybe<Post_Book>;
  /** An array relationship */
  posts: Array<Posts>;
  /** An aggregate relationship */
  posts_aggregate: Posts_Aggregate;
  /** fetch data from the table: "posts" using primary key columns */
  posts_by_pk?: Maybe<Posts>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table: "public_account_details" */
  public_account_details: Array<Public_Account_Details>;
  /** fetch aggregated fields from the table: "public_account_details" */
  public_account_details_aggregate: Public_Account_Details_Aggregate;
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate;
  /** fetch data from the table: "refresh_tokens" using primary key columns */
  refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** An array relationship */
  refunds: Array<Refunds>;
  /** An aggregate relationship */
  refunds_aggregate: Refunds_Aggregate;
  /** fetch data from the table: "refunds" using primary key columns */
  refunds_by_pk?: Maybe<Refunds>;
  /** fetch data from the table: "regions" */
  regions: Array<Regions>;
  /** fetch aggregated fields from the table: "regions" */
  regions_aggregate: Regions_Aggregate;
  /** fetch data from the table: "regions" using primary key columns */
  regions_by_pk?: Maybe<Regions>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** execute function "search_books" which returns "books" */
  search_books: Array<Books>;
  /** execute function "search_books" and query aggregates on result of table type "books" */
  search_books_aggregate: Books_Aggregate;
  /** execute function "search_events" which returns "events" */
  search_events: Array<Events>;
  /** execute function "search_events" and query aggregates on result of table type "events" */
  search_events_aggregate: Events_Aggregate;
  /** execute function "search_posts" which returns "posts" */
  search_posts: Array<Posts>;
  /** execute function "search_posts" and query aggregates on result of table type "posts" */
  search_posts_aggregate: Posts_Aggregate;
  /** execute function "search_products" which returns "products" */
  search_products: Array<Products>;
  /** execute function "search_products" and query aggregates on result of table type "products" */
  search_products_aggregate: Products_Aggregate;
  /** execute function "search_subscriptions" which returns "subscriptions" */
  search_subscriptions: Array<Subscriptions>;
  /** execute function "search_subscriptions" and query aggregates on result of table type "subscriptions" */
  search_subscriptions_aggregate: Subscriptions_Aggregate;
  /** An array relationship */
  shipping_options: Array<Shipping_Options>;
  /** An aggregate relationship */
  shipping_options_aggregate: Shipping_Options_Aggregate;
  /** fetch data from the table: "shipping_options" using primary key columns */
  shipping_options_by_pk?: Maybe<Shipping_Options>;
  /** fetch data from the table: "subscription_dispatch" */
  subscription_dispatch: Array<Subscription_Dispatch>;
  /** fetch aggregated fields from the table: "subscription_dispatch" */
  subscription_dispatch_aggregate: Subscription_Dispatch_Aggregate;
  /** fetch data from the table: "subscription_dispatch" using primary key columns */
  subscription_dispatch_by_pk?: Maybe<Subscription_Dispatch>;
  /** fetch data from the table: "subscription_dispatch_subscription_object" */
  subscription_dispatch_subscription_object: Array<Subscription_Dispatch_Subscription_Object>;
  /** fetch aggregated fields from the table: "subscription_dispatch_subscription_object" */
  subscription_dispatch_subscription_object_aggregate: Subscription_Dispatch_Subscription_Object_Aggregate;
  /** fetch data from the table: "subscription_dispatch_subscription_object" using primary key columns */
  subscription_dispatch_subscription_object_by_pk?: Maybe<Subscription_Dispatch_Subscription_Object>;
  /** fetch data from the table: "subscription_draft_object" */
  subscription_draft_object: Array<Subscription_Draft_Object>;
  /** fetch aggregated fields from the table: "subscription_draft_object" */
  subscription_draft_object_aggregate: Subscription_Draft_Object_Aggregate;
  /** fetch data from the table: "subscription_draft_object" using primary key columns */
  subscription_draft_object_by_pk?: Maybe<Subscription_Draft_Object>;
  /** fetch data from the table: "subscription_object" */
  subscription_object: Array<Subscription_Object>;
  /** fetch aggregated fields from the table: "subscription_object" */
  subscription_object_aggregate: Subscription_Object_Aggregate;
  /** fetch data from the table: "subscription_object" using primary key columns */
  subscription_object_by_pk?: Maybe<Subscription_Object>;
  /** fetch data from the table: "subscription_object_credit" */
  subscription_object_credit: Array<Subscription_Object_Credit>;
  /** fetch aggregated fields from the table: "subscription_object_credit" */
  subscription_object_credit_aggregate: Subscription_Object_Credit_Aggregate;
  /** fetch data from the table: "subscription_object_credit" using primary key columns */
  subscription_object_credit_by_pk?: Maybe<Subscription_Object_Credit>;
  /** fetch data from the table: "subscription_price" */
  subscription_price: Array<Subscription_Price>;
  /** fetch aggregated fields from the table: "subscription_price" */
  subscription_price_aggregate: Subscription_Price_Aggregate;
  /** fetch data from the table: "subscription_price" using primary key columns */
  subscription_price_by_pk?: Maybe<Subscription_Price>;
  /** fetch data from the table: "subscriptions" */
  subscriptions: Array<Subscriptions>;
  /** fetch aggregated fields from the table: "subscriptions" */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table: "tag_book" */
  tag_book: Array<Tag_Book>;
  /** fetch aggregated fields from the table: "tag_book" */
  tag_book_aggregate: Tag_Book_Aggregate;
  /** fetch data from the table: "tag_book" using primary key columns */
  tag_book_by_pk?: Maybe<Tag_Book>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** fetch data from the table: "unstructured_data" */
  unstructured_data: Array<Unstructured_Data>;
  /** fetch aggregated fields from the table: "unstructured_data" */
  unstructured_data_aggregate: Unstructured_Data_Aggregate;
  /** fetch data from the table: "unstructured_data" using primary key columns */
  unstructured_data_by_pk?: Maybe<Unstructured_Data>;
  /** An array relationship */
  vouchers: Array<Vouchers>;
  /** An aggregate relationship */
  vouchers_aggregate: Vouchers_Aggregate;
  /** fetch data from the table: "vouchers" using primary key columns */
  vouchers_by_pk?: Maybe<Vouchers>;
};


export type Query_RootAccountsArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


export type Query_RootAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


export type Query_RootAccounts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootAddresses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBook_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Book_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Book_Discount_Order_By>>;
  where?: InputMaybe<Book_Discount_Bool_Exp>;
};


export type Query_RootBook_Discount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Book_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Book_Discount_Order_By>>;
  where?: InputMaybe<Book_Discount_Bool_Exp>;
};


export type Query_RootBook_Discount_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  discount_id: Scalars['String'];
};


export type Query_RootBooksArgs = {
  distinct_on?: InputMaybe<Array<Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Books_Order_By>>;
  where?: InputMaybe<Books_Bool_Exp>;
};


export type Query_RootBooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Books_Order_By>>;
  where?: InputMaybe<Books_Bool_Exp>;
};


export type Query_RootBooks_By_PkArgs = {
  isbn: Scalars['bigint'];
};


export type Query_RootBooksellersArgs = {
  distinct_on?: InputMaybe<Array<Booksellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booksellers_Order_By>>;
  where?: InputMaybe<Booksellers_Bool_Exp>;
};


export type Query_RootBooksellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booksellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booksellers_Order_By>>;
  where?: InputMaybe<Booksellers_Bool_Exp>;
};


export type Query_RootBooksellers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Query_RootCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Query_RootCategories_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCategory_BookArgs = {
  distinct_on?: InputMaybe<Array<Category_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Book_Order_By>>;
  where?: InputMaybe<Category_Book_Bool_Exp>;
};


export type Query_RootCategory_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Book_Order_By>>;
  where?: InputMaybe<Category_Book_Bool_Exp>;
};


export type Query_RootCategory_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  category_name: Scalars['String'];
};


export type Query_RootCategory_EventArgs = {
  distinct_on?: InputMaybe<Array<Category_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Event_Order_By>>;
  where?: InputMaybe<Category_Event_Bool_Exp>;
};


export type Query_RootCategory_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Event_Order_By>>;
  where?: InputMaybe<Category_Event_Bool_Exp>;
};


export type Query_RootCategory_Event_By_PkArgs = {
  category_name: Scalars['String'];
  event_id: Scalars['uuid'];
};


export type Query_RootCategory_PostArgs = {
  distinct_on?: InputMaybe<Array<Category_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Post_Order_By>>;
  where?: InputMaybe<Category_Post_Bool_Exp>;
};


export type Query_RootCategory_Post_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Post_Order_By>>;
  where?: InputMaybe<Category_Post_Bool_Exp>;
};


export type Query_RootCategory_Post_By_PkArgs = {
  category_name: Scalars['String'];
  post_id: Scalars['uuid'];
};


export type Query_RootChildren_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Children_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Children_Categories_Order_By>>;
  where?: InputMaybe<Children_Categories_Bool_Exp>;
};


export type Query_RootChildren_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Children_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Children_Categories_Order_By>>;
  where?: InputMaybe<Children_Categories_Bool_Exp>;
};


export type Query_RootChildren_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChildren_Category_BooksArgs = {
  distinct_on?: InputMaybe<Array<Children_Category_Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Children_Category_Books_Order_By>>;
  where?: InputMaybe<Children_Category_Books_Bool_Exp>;
};


export type Query_RootChildren_Category_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Children_Category_Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Children_Category_Books_Order_By>>;
  where?: InputMaybe<Children_Category_Books_Bool_Exp>;
};


export type Query_RootChildren_Category_Books_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  category_id: Scalars['uuid'];
};


export type Query_RootContentsArgs = {
  distinct_on?: InputMaybe<Array<Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contents_Order_By>>;
  where?: InputMaybe<Contents_Bool_Exp>;
};


export type Query_RootContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contents_Order_By>>;
  where?: InputMaybe<Contents_Bool_Exp>;
};


export type Query_RootContents_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Query_RootCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Query_RootCountries_By_PkArgs = {
  code: Scalars['String'];
};


export type Query_RootDiscount_TypeArgs = {
  distinct_on?: InputMaybe<Array<Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Type_Order_By>>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};


export type Query_RootDiscount_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Type_Order_By>>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};


export type Query_RootDiscount_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDiscountsArgs = {
  distinct_on?: InputMaybe<Array<Discounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discounts_Order_By>>;
  where?: InputMaybe<Discounts_Bool_Exp>;
};


export type Query_RootDiscounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discounts_Order_By>>;
  where?: InputMaybe<Discounts_Bool_Exp>;
};


export type Query_RootDiscounts_By_PkArgs = {
  code: Scalars['String'];
};


export type Query_RootEmpty_SearchesArgs = {
  distinct_on?: InputMaybe<Array<Empty_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Empty_Searches_Order_By>>;
  where?: InputMaybe<Empty_Searches_Bool_Exp>;
};


export type Query_RootEmpty_Searches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Empty_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Empty_Searches_Order_By>>;
  where?: InputMaybe<Empty_Searches_Bool_Exp>;
};


export type Query_RootEmpty_Searches_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootEvent_BookArgs = {
  distinct_on?: InputMaybe<Array<Event_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Book_Order_By>>;
  where?: InputMaybe<Event_Book_Bool_Exp>;
};


export type Query_RootEvent_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Book_Order_By>>;
  where?: InputMaybe<Event_Book_Bool_Exp>;
};


export type Query_RootEvent_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  event_id: Scalars['uuid'];
};


export type Query_RootEvent_CommentArgs = {
  distinct_on?: InputMaybe<Array<Event_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Comment_Order_By>>;
  where?: InputMaybe<Event_Comment_Bool_Exp>;
};


export type Query_RootEvent_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Comment_Order_By>>;
  where?: InputMaybe<Event_Comment_Bool_Exp>;
};


export type Query_RootEvent_Comment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootEvent_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


export type Query_RootEvent_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


export type Query_RootEvent_Tickets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrder_BookArgs = {
  distinct_on?: InputMaybe<Array<Order_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Book_Order_By>>;
  where?: InputMaybe<Order_Book_Bool_Exp>;
};


export type Query_RootOrder_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Book_Order_By>>;
  where?: InputMaybe<Order_Book_Bool_Exp>;
};


export type Query_RootOrder_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  order_id: Scalars['Int'];
};


export type Query_RootOrder_Item_StatusArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Status_Order_By>>;
  where?: InputMaybe<Order_Item_Status_Bool_Exp>;
};


export type Query_RootOrder_Item_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Status_Order_By>>;
  where?: InputMaybe<Order_Item_Status_Bool_Exp>;
};


export type Query_RootOrder_Item_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootOrder_ProductArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


export type Query_RootOrder_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


export type Query_RootOrder_Product_By_PkArgs = {
  order_id: Scalars['Int'];
  product_id: Scalars['uuid'];
};


export type Query_RootOrder_StatusArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Order_By>>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};


export type Query_RootOrder_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Order_By>>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};


export type Query_RootOrder_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootOrder_Subscription_ObjectArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Object_Order_By>>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};


export type Query_RootOrder_Subscription_Object_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Object_Order_By>>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};


export type Query_RootOrder_Subscription_Object_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrder_Subscription_PriceArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Price_Order_By>>;
  where?: InputMaybe<Order_Subscription_Price_Bool_Exp>;
};


export type Query_RootOrder_Subscription_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Price_Order_By>>;
  where?: InputMaybe<Order_Subscription_Price_Bool_Exp>;
};


export type Query_RootOrder_Subscription_Price_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrder_VoucherArgs = {
  distinct_on?: InputMaybe<Array<Order_Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Voucher_Order_By>>;
  where?: InputMaybe<Order_Voucher_Bool_Exp>;
};


export type Query_RootOrder_Voucher_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Voucher_Order_By>>;
  where?: InputMaybe<Order_Voucher_Bool_Exp>;
};


export type Query_RootOrder_Voucher_By_PkArgs = {
  order_id: Scalars['Int'];
  voucher_id: Scalars['String'];
};


export type Query_RootOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPagesArgs = {
  distinct_on?: InputMaybe<Array<Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_Order_By>>;
  where?: InputMaybe<Pages_Bool_Exp>;
};


export type Query_RootPages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_Order_By>>;
  where?: InputMaybe<Pages_Bool_Exp>;
};


export type Query_RootPages_By_PkArgs = {
  title: Scalars['String'];
};


export type Query_RootPif_DonationsArgs = {
  distinct_on?: InputMaybe<Array<Pif_Donations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pif_Donations_Order_By>>;
  where?: InputMaybe<Pif_Donations_Bool_Exp>;
};


export type Query_RootPif_Donations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pif_Donations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pif_Donations_Order_By>>;
  where?: InputMaybe<Pif_Donations_Bool_Exp>;
};


export type Query_RootPif_Donations_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPost_BookArgs = {
  distinct_on?: InputMaybe<Array<Post_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Book_Order_By>>;
  where?: InputMaybe<Post_Book_Bool_Exp>;
};


export type Query_RootPost_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Post_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Book_Order_By>>;
  where?: InputMaybe<Post_Book_Bool_Exp>;
};


export type Query_RootPost_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  post_id: Scalars['uuid'];
};


export type Query_RootPostsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootPosts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPublic_Account_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Public_Account_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Public_Account_Details_Order_By>>;
  where?: InputMaybe<Public_Account_Details_Bool_Exp>;
};


export type Query_RootPublic_Account_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Public_Account_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Public_Account_Details_Order_By>>;
  where?: InputMaybe<Public_Account_Details_Bool_Exp>;
};


export type Query_RootRefresh_TokensArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
};


export type Query_RootRefresh_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
};


export type Query_RootRefresh_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRefundsArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


export type Query_RootRefunds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


export type Query_RootRefunds_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRegionsArgs = {
  distinct_on?: InputMaybe<Array<Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Regions_Order_By>>;
  where?: InputMaybe<Regions_Bool_Exp>;
};


export type Query_RootRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Regions_Order_By>>;
  where?: InputMaybe<Regions_Bool_Exp>;
};


export type Query_RootRegions_By_PkArgs = {
  code: Scalars['String'];
};


export type Query_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootSearch_BooksArgs = {
  args: Search_Books_Args;
  distinct_on?: InputMaybe<Array<Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Books_Order_By>>;
  where?: InputMaybe<Books_Bool_Exp>;
};


export type Query_RootSearch_Books_AggregateArgs = {
  args: Search_Books_Args;
  distinct_on?: InputMaybe<Array<Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Books_Order_By>>;
  where?: InputMaybe<Books_Bool_Exp>;
};


export type Query_RootSearch_EventsArgs = {
  args: Search_Events_Args;
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootSearch_Events_AggregateArgs = {
  args: Search_Events_Args;
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootSearch_PostsArgs = {
  args: Search_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootSearch_Posts_AggregateArgs = {
  args: Search_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootSearch_ProductsArgs = {
  args: Search_Products_Args;
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootSearch_Products_AggregateArgs = {
  args: Search_Products_Args;
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootSearch_SubscriptionsArgs = {
  args: Search_Subscriptions_Args;
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSearch_Subscriptions_AggregateArgs = {
  args: Search_Subscriptions_Args;
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootShipping_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Shipping_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipping_Options_Order_By>>;
  where?: InputMaybe<Shipping_Options_Bool_Exp>;
};


export type Query_RootShipping_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shipping_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipping_Options_Order_By>>;
  where?: InputMaybe<Shipping_Options_Bool_Exp>;
};


export type Query_RootShipping_Options_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscription_DispatchArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Bool_Exp>;
};


export type Query_RootSubscription_Dispatch_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Bool_Exp>;
};


export type Query_RootSubscription_Dispatch_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscription_Dispatch_Subscription_ObjectArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
};


export type Query_RootSubscription_Dispatch_Subscription_Object_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
};


export type Query_RootSubscription_Dispatch_Subscription_Object_By_PkArgs = {
  dispatch_id: Scalars['uuid'];
  object_id: Scalars['uuid'];
};


export type Query_RootSubscription_Draft_ObjectArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Draft_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Draft_Object_Order_By>>;
  where?: InputMaybe<Subscription_Draft_Object_Bool_Exp>;
};


export type Query_RootSubscription_Draft_Object_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Draft_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Draft_Object_Order_By>>;
  where?: InputMaybe<Subscription_Draft_Object_Bool_Exp>;
};


export type Query_RootSubscription_Draft_Object_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscription_ObjectArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Object_Bool_Exp>;
};


export type Query_RootSubscription_Object_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Object_Bool_Exp>;
};


export type Query_RootSubscription_Object_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscription_Object_CreditArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Credit_Order_By>>;
  where?: InputMaybe<Subscription_Object_Credit_Bool_Exp>;
};


export type Query_RootSubscription_Object_Credit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Credit_Order_By>>;
  where?: InputMaybe<Subscription_Object_Credit_Bool_Exp>;
};


export type Query_RootSubscription_Object_Credit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscription_PriceArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Price_Order_By>>;
  where?: InputMaybe<Subscription_Price_Bool_Exp>;
};


export type Query_RootSubscription_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Price_Order_By>>;
  where?: InputMaybe<Subscription_Price_Bool_Exp>;
};


export type Query_RootSubscription_Price_By_PkArgs = {
  id: Scalars['uuid'];
  sub_id: Scalars['uuid'];
};


export type Query_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTag_BookArgs = {
  distinct_on?: InputMaybe<Array<Tag_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Book_Order_By>>;
  where?: InputMaybe<Tag_Book_Bool_Exp>;
};


export type Query_RootTag_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Book_Order_By>>;
  where?: InputMaybe<Tag_Book_Bool_Exp>;
};


export type Query_RootTag_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  tag_id: Scalars['Int'];
};


export type Query_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUnstructured_DataArgs = {
  distinct_on?: InputMaybe<Array<Unstructured_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unstructured_Data_Order_By>>;
  where?: InputMaybe<Unstructured_Data_Bool_Exp>;
};


export type Query_RootUnstructured_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unstructured_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unstructured_Data_Order_By>>;
  where?: InputMaybe<Unstructured_Data_Bool_Exp>;
};


export type Query_RootUnstructured_Data_By_PkArgs = {
  title: Scalars['String'];
};


export type Query_RootVouchersArgs = {
  distinct_on?: InputMaybe<Array<Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vouchers_Order_By>>;
  where?: InputMaybe<Vouchers_Bool_Exp>;
};


export type Query_RootVouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vouchers_Order_By>>;
  where?: InputMaybe<Vouchers_Bool_Exp>;
};


export type Query_RootVouchers_By_PkArgs = {
  id: Scalars['String'];
};

/** columns and relationships of "refresh_tokens" */
export type Refresh_Tokens = {
  __typename?: 'refresh_tokens';
  /** An object relationship */
  account: Accounts;
  account_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  expires_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
};

/** aggregated selection of "refresh_tokens" */
export type Refresh_Tokens_Aggregate = {
  __typename?: 'refresh_tokens_aggregate';
  aggregate?: Maybe<Refresh_Tokens_Aggregate_Fields>;
  nodes: Array<Refresh_Tokens>;
};

/** aggregate fields of "refresh_tokens" */
export type Refresh_Tokens_Aggregate_Fields = {
  __typename?: 'refresh_tokens_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Refresh_Tokens_Max_Fields>;
  min?: Maybe<Refresh_Tokens_Min_Fields>;
};


/** aggregate fields of "refresh_tokens" */
export type Refresh_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "refresh_tokens" */
export type Refresh_Tokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Refresh_Tokens_Max_Order_By>;
  min?: InputMaybe<Refresh_Tokens_Min_Order_By>;
};

/** input type for inserting array relation for remote table "refresh_tokens" */
export type Refresh_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Refresh_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Refresh_Tokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "refresh_tokens". All fields are combined with a logical 'AND'. */
export type Refresh_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Refresh_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Refresh_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Refresh_Tokens_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "refresh_tokens" */
export enum Refresh_Tokens_Constraint {
  /** unique or primary key constraint */
  RefreshTokensPkey = 'refresh_tokens_pkey'
}

/** input type for inserting data into table "refresh_tokens" */
export type Refresh_Tokens_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Refresh_Tokens_Max_Fields = {
  __typename?: 'refresh_tokens_max_fields';
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Refresh_Tokens_Min_Fields = {
  __typename?: 'refresh_tokens_min_fields';
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "refresh_tokens" */
export type Refresh_Tokens_Mutation_Response = {
  __typename?: 'refresh_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Refresh_Tokens>;
};

/** on_conflict condition type for table "refresh_tokens" */
export type Refresh_Tokens_On_Conflict = {
  constraint: Refresh_Tokens_Constraint;
  update_columns?: Array<Refresh_Tokens_Update_Column>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "refresh_tokens". */
export type Refresh_Tokens_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: refresh_tokens */
export type Refresh_Tokens_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "refresh_tokens" */
export enum Refresh_Tokens_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "refresh_tokens" */
export type Refresh_Tokens_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "refresh_tokens" */
export enum Refresh_Tokens_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id'
}

/** columns and relationships of "refunds" */
export type Refunds = {
  __typename?: 'refunds';
  amount: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  order: Orders;
  order_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "refunds" */
export type Refunds_Aggregate = {
  __typename?: 'refunds_aggregate';
  aggregate?: Maybe<Refunds_Aggregate_Fields>;
  nodes: Array<Refunds>;
};

/** aggregate fields of "refunds" */
export type Refunds_Aggregate_Fields = {
  __typename?: 'refunds_aggregate_fields';
  avg?: Maybe<Refunds_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Refunds_Max_Fields>;
  min?: Maybe<Refunds_Min_Fields>;
  stddev?: Maybe<Refunds_Stddev_Fields>;
  stddev_pop?: Maybe<Refunds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Refunds_Stddev_Samp_Fields>;
  sum?: Maybe<Refunds_Sum_Fields>;
  var_pop?: Maybe<Refunds_Var_Pop_Fields>;
  var_samp?: Maybe<Refunds_Var_Samp_Fields>;
  variance?: Maybe<Refunds_Variance_Fields>;
};


/** aggregate fields of "refunds" */
export type Refunds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refunds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "refunds" */
export type Refunds_Aggregate_Order_By = {
  avg?: InputMaybe<Refunds_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Refunds_Max_Order_By>;
  min?: InputMaybe<Refunds_Min_Order_By>;
  stddev?: InputMaybe<Refunds_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Refunds_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Refunds_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Refunds_Sum_Order_By>;
  var_pop?: InputMaybe<Refunds_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Refunds_Var_Samp_Order_By>;
  variance?: InputMaybe<Refunds_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "refunds" */
export type Refunds_Arr_Rel_Insert_Input = {
  data: Array<Refunds_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Refunds_On_Conflict>;
};

/** aggregate avg on columns */
export type Refunds_Avg_Fields = {
  __typename?: 'refunds_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "refunds" */
export type Refunds_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "refunds". All fields are combined with a logical 'AND'. */
export type Refunds_Bool_Exp = {
  _and?: InputMaybe<Array<Refunds_Bool_Exp>>;
  _not?: InputMaybe<Refunds_Bool_Exp>;
  _or?: InputMaybe<Array<Refunds_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "refunds" */
export enum Refunds_Constraint {
  /** unique or primary key constraint */
  RefundsPkey = 'refunds_pkey'
}

/** input type for incrementing numeric columns in table "refunds" */
export type Refunds_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "refunds" */
export type Refunds_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Refunds_Max_Fields = {
  __typename?: 'refunds_max_fields';
  amount?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "refunds" */
export type Refunds_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Refunds_Min_Fields = {
  __typename?: 'refunds_min_fields';
  amount?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "refunds" */
export type Refunds_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "refunds" */
export type Refunds_Mutation_Response = {
  __typename?: 'refunds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Refunds>;
};

/** on_conflict condition type for table "refunds" */
export type Refunds_On_Conflict = {
  constraint: Refunds_Constraint;
  update_columns?: Array<Refunds_Update_Column>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};

/** Ordering options when selecting data from "refunds". */
export type Refunds_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: refunds */
export type Refunds_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "refunds" */
export enum Refunds_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "refunds" */
export type Refunds_Set_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  order_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Refunds_Stddev_Fields = {
  __typename?: 'refunds_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "refunds" */
export type Refunds_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Refunds_Stddev_Pop_Fields = {
  __typename?: 'refunds_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "refunds" */
export type Refunds_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Refunds_Stddev_Samp_Fields = {
  __typename?: 'refunds_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "refunds" */
export type Refunds_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Refunds_Sum_Fields = {
  __typename?: 'refunds_sum_fields';
  amount?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "refunds" */
export type Refunds_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** update columns of table "refunds" */
export enum Refunds_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Refunds_Var_Pop_Fields = {
  __typename?: 'refunds_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "refunds" */
export type Refunds_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Refunds_Var_Samp_Fields = {
  __typename?: 'refunds_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "refunds" */
export type Refunds_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Refunds_Variance_Fields = {
  __typename?: 'refunds_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "refunds" */
export type Refunds_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "regions" */
export type Regions = {
  __typename?: 'regions';
  code: Scalars['String'];
  /** An array relationship */
  countries: Array<Countries>;
  /** An aggregate relationship */
  countries_aggregate: Countries_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  shipping_options: Array<Shipping_Options>;
  /** An aggregate relationship */
  shipping_options_aggregate: Shipping_Options_Aggregate;
};


/** columns and relationships of "regions" */
export type RegionsCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


/** columns and relationships of "regions" */
export type RegionsCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


/** columns and relationships of "regions" */
export type RegionsShipping_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Shipping_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipping_Options_Order_By>>;
  where?: InputMaybe<Shipping_Options_Bool_Exp>;
};


/** columns and relationships of "regions" */
export type RegionsShipping_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shipping_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipping_Options_Order_By>>;
  where?: InputMaybe<Shipping_Options_Bool_Exp>;
};

/** aggregated selection of "regions" */
export type Regions_Aggregate = {
  __typename?: 'regions_aggregate';
  aggregate?: Maybe<Regions_Aggregate_Fields>;
  nodes: Array<Regions>;
};

/** aggregate fields of "regions" */
export type Regions_Aggregate_Fields = {
  __typename?: 'regions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Regions_Max_Fields>;
  min?: Maybe<Regions_Min_Fields>;
};


/** aggregate fields of "regions" */
export type Regions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Regions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "regions". All fields are combined with a logical 'AND'. */
export type Regions_Bool_Exp = {
  _and?: InputMaybe<Array<Regions_Bool_Exp>>;
  _not?: InputMaybe<Regions_Bool_Exp>;
  _or?: InputMaybe<Array<Regions_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  countries?: InputMaybe<Countries_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  shipping_options?: InputMaybe<Shipping_Options_Bool_Exp>;
};

/** unique or primary key constraints on table "regions" */
export enum Regions_Constraint {
  /** unique or primary key constraint */
  RegionsNameKey = 'regions_name_key',
  /** unique or primary key constraint */
  RegionsPkey = 'regions_pkey'
}

/** input type for inserting data into table "regions" */
export type Regions_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Countries_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  shipping_options?: InputMaybe<Shipping_Options_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Regions_Max_Fields = {
  __typename?: 'regions_max_fields';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Regions_Min_Fields = {
  __typename?: 'regions_min_fields';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "regions" */
export type Regions_Mutation_Response = {
  __typename?: 'regions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Regions>;
};

/** input type for inserting object relation for remote table "regions" */
export type Regions_Obj_Rel_Insert_Input = {
  data: Regions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Regions_On_Conflict>;
};

/** on_conflict condition type for table "regions" */
export type Regions_On_Conflict = {
  constraint: Regions_Constraint;
  update_columns?: Array<Regions_Update_Column>;
  where?: InputMaybe<Regions_Bool_Exp>;
};

/** Ordering options when selecting data from "regions". */
export type Regions_Order_By = {
  code?: InputMaybe<Order_By>;
  countries_aggregate?: InputMaybe<Countries_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  shipping_options_aggregate?: InputMaybe<Shipping_Options_Aggregate_Order_By>;
};

/** primary key columns input for table: regions */
export type Regions_Pk_Columns_Input = {
  code: Scalars['String'];
};

/** select columns of table "regions" */
export enum Regions_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "regions" */
export type Regions_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "regions" */
export enum Regions_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Name = 'name'
}

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  description: Scalars['String'];
  type: Scalars['String'];
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint */
  RolesPkey = 'roles_pkey',
  /** unique or primary key constraint */
  RolesTypeKey = 'roles_type_key'
}

export enum Roles_Enum {
  /** Full access priveledges */
  Bookseller = 'bookseller',
  /** Basic account role with minimum priviledges */
  Reader = 'reader'
}

/** Boolean expression to compare columns of type "roles_enum". All fields are combined with logical 'AND'. */
export type Roles_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Roles_Enum>;
  _in?: InputMaybe<Array<Roles_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Roles_Enum>;
  _nin?: InputMaybe<Array<Roles_Enum>>;
};

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  description?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

export type Search_Books_Args = {
  search?: InputMaybe<Scalars['String']>;
};

export type Search_Events_Args = {
  search?: InputMaybe<Scalars['String']>;
};

export type Search_Posts_Args = {
  search?: InputMaybe<Scalars['String']>;
};

export type Search_Products_Args = {
  search?: InputMaybe<Scalars['String']>;
};

export type Search_Subscriptions_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "shipping_options" */
export type Shipping_Options = {
  __typename?: 'shipping_options';
  country?: Maybe<Scalars['String']>;
  /** An object relationship */
  countryByCountry?: Maybe<Countries>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  from: Scalars['Int'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  price: Scalars['Int'];
  region?: Maybe<Scalars['String']>;
  /** An object relationship */
  regionByRegion?: Maybe<Regions>;
  to?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "shipping_options" */
export type Shipping_OptionsOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "shipping_options" */
export type Shipping_OptionsOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};

/** aggregated selection of "shipping_options" */
export type Shipping_Options_Aggregate = {
  __typename?: 'shipping_options_aggregate';
  aggregate?: Maybe<Shipping_Options_Aggregate_Fields>;
  nodes: Array<Shipping_Options>;
};

/** aggregate fields of "shipping_options" */
export type Shipping_Options_Aggregate_Fields = {
  __typename?: 'shipping_options_aggregate_fields';
  avg?: Maybe<Shipping_Options_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shipping_Options_Max_Fields>;
  min?: Maybe<Shipping_Options_Min_Fields>;
  stddev?: Maybe<Shipping_Options_Stddev_Fields>;
  stddev_pop?: Maybe<Shipping_Options_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shipping_Options_Stddev_Samp_Fields>;
  sum?: Maybe<Shipping_Options_Sum_Fields>;
  var_pop?: Maybe<Shipping_Options_Var_Pop_Fields>;
  var_samp?: Maybe<Shipping_Options_Var_Samp_Fields>;
  variance?: Maybe<Shipping_Options_Variance_Fields>;
};


/** aggregate fields of "shipping_options" */
export type Shipping_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shipping_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shipping_options" */
export type Shipping_Options_Aggregate_Order_By = {
  avg?: InputMaybe<Shipping_Options_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shipping_Options_Max_Order_By>;
  min?: InputMaybe<Shipping_Options_Min_Order_By>;
  stddev?: InputMaybe<Shipping_Options_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Shipping_Options_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Shipping_Options_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Shipping_Options_Sum_Order_By>;
  var_pop?: InputMaybe<Shipping_Options_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Shipping_Options_Var_Samp_Order_By>;
  variance?: InputMaybe<Shipping_Options_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shipping_options" */
export type Shipping_Options_Arr_Rel_Insert_Input = {
  data: Array<Shipping_Options_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shipping_Options_On_Conflict>;
};

/** aggregate avg on columns */
export type Shipping_Options_Avg_Fields = {
  __typename?: 'shipping_options_avg_fields';
  from?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shipping_options" */
export type Shipping_Options_Avg_Order_By = {
  from?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shipping_options". All fields are combined with a logical 'AND'. */
export type Shipping_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Shipping_Options_Bool_Exp>>;
  _not?: InputMaybe<Shipping_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Shipping_Options_Bool_Exp>>;
  country?: InputMaybe<String_Comparison_Exp>;
  countryByCountry?: InputMaybe<Countries_Bool_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  from?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  orders?: InputMaybe<Orders_Bool_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  regionByRegion?: InputMaybe<Regions_Bool_Exp>;
  to?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "shipping_options" */
export enum Shipping_Options_Constraint {
  /** unique or primary key constraint */
  ShippingOptionsPkey = 'shipping_options_pkey'
}

/** input type for incrementing numeric columns in table "shipping_options" */
export type Shipping_Options_Inc_Input = {
  from?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shipping_options" */
export type Shipping_Options_Insert_Input = {
  country?: InputMaybe<Scalars['String']>;
  countryByCountry?: InputMaybe<Countries_Obj_Rel_Insert_Input>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<Orders_Arr_Rel_Insert_Input>;
  price?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  regionByRegion?: InputMaybe<Regions_Obj_Rel_Insert_Input>;
  to?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Shipping_Options_Max_Fields = {
  __typename?: 'shipping_options_max_fields';
  country?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  region?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "shipping_options" */
export type Shipping_Options_Max_Order_By = {
  country?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shipping_Options_Min_Fields = {
  __typename?: 'shipping_options_min_fields';
  country?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  region?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "shipping_options" */
export type Shipping_Options_Min_Order_By = {
  country?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shipping_options" */
export type Shipping_Options_Mutation_Response = {
  __typename?: 'shipping_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shipping_Options>;
};

/** input type for inserting object relation for remote table "shipping_options" */
export type Shipping_Options_Obj_Rel_Insert_Input = {
  data: Shipping_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shipping_Options_On_Conflict>;
};

/** on_conflict condition type for table "shipping_options" */
export type Shipping_Options_On_Conflict = {
  constraint: Shipping_Options_Constraint;
  update_columns?: Array<Shipping_Options_Update_Column>;
  where?: InputMaybe<Shipping_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "shipping_options". */
export type Shipping_Options_Order_By = {
  country?: InputMaybe<Order_By>;
  countryByCountry?: InputMaybe<Countries_Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  price?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  regionByRegion?: InputMaybe<Regions_Order_By>;
  to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shipping_options */
export type Shipping_Options_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "shipping_options" */
export enum Shipping_Options_Select_Column {
  /** column name */
  Country = 'country',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  Region = 'region',
  /** column name */
  To = 'to'
}

/** input type for updating data in table "shipping_options" */
export type Shipping_Options_Set_Input = {
  country?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Shipping_Options_Stddev_Fields = {
  __typename?: 'shipping_options_stddev_fields';
  from?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shipping_options" */
export type Shipping_Options_Stddev_Order_By = {
  from?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Shipping_Options_Stddev_Pop_Fields = {
  __typename?: 'shipping_options_stddev_pop_fields';
  from?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shipping_options" */
export type Shipping_Options_Stddev_Pop_Order_By = {
  from?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Shipping_Options_Stddev_Samp_Fields = {
  __typename?: 'shipping_options_stddev_samp_fields';
  from?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shipping_options" */
export type Shipping_Options_Stddev_Samp_Order_By = {
  from?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Shipping_Options_Sum_Fields = {
  __typename?: 'shipping_options_sum_fields';
  from?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "shipping_options" */
export type Shipping_Options_Sum_Order_By = {
  from?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** update columns of table "shipping_options" */
export enum Shipping_Options_Update_Column {
  /** column name */
  Country = 'country',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  Region = 'region',
  /** column name */
  To = 'to'
}

/** aggregate var_pop on columns */
export type Shipping_Options_Var_Pop_Fields = {
  __typename?: 'shipping_options_var_pop_fields';
  from?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shipping_options" */
export type Shipping_Options_Var_Pop_Order_By = {
  from?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Shipping_Options_Var_Samp_Fields = {
  __typename?: 'shipping_options_var_samp_fields';
  from?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shipping_options" */
export type Shipping_Options_Var_Samp_Order_By = {
  from?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Shipping_Options_Variance_Fields = {
  __typename?: 'shipping_options_variance_fields';
  from?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shipping_options" */
export type Shipping_Options_Variance_Order_By = {
  from?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** columns and relationships of "subscription_dispatch" */
export type Subscription_Dispatch = {
  __typename?: 'subscription_dispatch';
  created_at: Scalars['timestamptz'];
  has_dispatched_digital: Scalars['Boolean'];
  id: Scalars['uuid'];
  note: Scalars['String'];
  /** An object relationship */
  subscription: Subscriptions;
  subscription_id: Scalars['uuid'];
  /** An array relationship */
  subscription_objects: Array<Subscription_Dispatch_Subscription_Object>;
  /** An aggregate relationship */
  subscription_objects_aggregate: Subscription_Dispatch_Subscription_Object_Aggregate;
};


/** columns and relationships of "subscription_dispatch" */
export type Subscription_DispatchSubscription_ObjectsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "subscription_dispatch" */
export type Subscription_DispatchSubscription_Objects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
};

/** aggregated selection of "subscription_dispatch" */
export type Subscription_Dispatch_Aggregate = {
  __typename?: 'subscription_dispatch_aggregate';
  aggregate?: Maybe<Subscription_Dispatch_Aggregate_Fields>;
  nodes: Array<Subscription_Dispatch>;
};

/** aggregate fields of "subscription_dispatch" */
export type Subscription_Dispatch_Aggregate_Fields = {
  __typename?: 'subscription_dispatch_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Subscription_Dispatch_Max_Fields>;
  min?: Maybe<Subscription_Dispatch_Min_Fields>;
};


/** aggregate fields of "subscription_dispatch" */
export type Subscription_Dispatch_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Dispatch_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subscription_dispatch" */
export type Subscription_Dispatch_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Dispatch_Max_Order_By>;
  min?: InputMaybe<Subscription_Dispatch_Min_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_dispatch" */
export type Subscription_Dispatch_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Dispatch_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Dispatch_On_Conflict>;
};

/** Boolean expression to filter rows from the table "subscription_dispatch". All fields are combined with a logical 'AND'. */
export type Subscription_Dispatch_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Dispatch_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Dispatch_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Dispatch_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  has_dispatched_digital?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscription_objects?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
};

/** unique or primary key constraints on table "subscription_dispatch" */
export enum Subscription_Dispatch_Constraint {
  /** unique or primary key constraint */
  SubscriptionDispatchPkey = 'subscription_dispatch_pkey'
}

/** input type for inserting data into table "subscription_dispatch" */
export type Subscription_Dispatch_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  has_dispatched_digital?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['uuid']>;
  subscription_objects?: InputMaybe<Subscription_Dispatch_Subscription_Object_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Subscription_Dispatch_Max_Fields = {
  __typename?: 'subscription_dispatch_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "subscription_dispatch" */
export type Subscription_Dispatch_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Dispatch_Min_Fields = {
  __typename?: 'subscription_dispatch_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "subscription_dispatch" */
export type Subscription_Dispatch_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscription_dispatch" */
export type Subscription_Dispatch_Mutation_Response = {
  __typename?: 'subscription_dispatch_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Dispatch>;
};

/** input type for inserting object relation for remote table "subscription_dispatch" */
export type Subscription_Dispatch_Obj_Rel_Insert_Input = {
  data: Subscription_Dispatch_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Dispatch_On_Conflict>;
};

/** on_conflict condition type for table "subscription_dispatch" */
export type Subscription_Dispatch_On_Conflict = {
  constraint: Subscription_Dispatch_Constraint;
  update_columns?: Array<Subscription_Dispatch_Update_Column>;
  where?: InputMaybe<Subscription_Dispatch_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_dispatch". */
export type Subscription_Dispatch_Order_By = {
  created_at?: InputMaybe<Order_By>;
  has_dispatched_digital?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  subscription_objects_aggregate?: InputMaybe<Subscription_Dispatch_Subscription_Object_Aggregate_Order_By>;
};

/** primary key columns input for table: subscription_dispatch */
export type Subscription_Dispatch_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "subscription_dispatch" */
export enum Subscription_Dispatch_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasDispatchedDigital = 'has_dispatched_digital',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  SubscriptionId = 'subscription_id'
}

/** input type for updating data in table "subscription_dispatch" */
export type Subscription_Dispatch_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  has_dispatched_digital?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  subscription_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object = {
  __typename?: 'subscription_dispatch_subscription_object';
  created_at: Scalars['timestamptz'];
  dispatch_id: Scalars['uuid'];
  object_id: Scalars['uuid'];
  /** An object relationship */
  subscription_dispatch: Subscription_Dispatch;
  /** An object relationship */
  subscription_object: Subscription_Object;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_Aggregate = {
  __typename?: 'subscription_dispatch_subscription_object_aggregate';
  aggregate?: Maybe<Subscription_Dispatch_Subscription_Object_Aggregate_Fields>;
  nodes: Array<Subscription_Dispatch_Subscription_Object>;
};

/** aggregate fields of "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_Aggregate_Fields = {
  __typename?: 'subscription_dispatch_subscription_object_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Subscription_Dispatch_Subscription_Object_Max_Fields>;
  min?: Maybe<Subscription_Dispatch_Subscription_Object_Min_Fields>;
};


/** aggregate fields of "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Dispatch_Subscription_Object_Max_Order_By>;
  min?: InputMaybe<Subscription_Dispatch_Subscription_Object_Min_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Dispatch_Subscription_Object_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Dispatch_Subscription_Object_On_Conflict>;
};

/** Boolean expression to filter rows from the table "subscription_dispatch_subscription_object". All fields are combined with a logical 'AND'. */
export type Subscription_Dispatch_Subscription_Object_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dispatch_id?: InputMaybe<Uuid_Comparison_Exp>;
  object_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscription_dispatch?: InputMaybe<Subscription_Dispatch_Bool_Exp>;
  subscription_object?: InputMaybe<Subscription_Object_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_dispatch_subscription_object" */
export enum Subscription_Dispatch_Subscription_Object_Constraint {
  /** unique or primary key constraint */
  SubscriptionDispatchSubscriptionObjectPkey = 'subscription_dispatch_subscription_object_pkey'
}

/** input type for inserting data into table "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dispatch_id?: InputMaybe<Scalars['uuid']>;
  object_id?: InputMaybe<Scalars['uuid']>;
  subscription_dispatch?: InputMaybe<Subscription_Dispatch_Obj_Rel_Insert_Input>;
  subscription_object?: InputMaybe<Subscription_Object_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Subscription_Dispatch_Subscription_Object_Max_Fields = {
  __typename?: 'subscription_dispatch_subscription_object_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dispatch_id?: Maybe<Scalars['uuid']>;
  object_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dispatch_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Dispatch_Subscription_Object_Min_Fields = {
  __typename?: 'subscription_dispatch_subscription_object_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dispatch_id?: Maybe<Scalars['uuid']>;
  object_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dispatch_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_Mutation_Response = {
  __typename?: 'subscription_dispatch_subscription_object_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Dispatch_Subscription_Object>;
};

/** on_conflict condition type for table "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_On_Conflict = {
  constraint: Subscription_Dispatch_Subscription_Object_Constraint;
  update_columns?: Array<Subscription_Dispatch_Subscription_Object_Update_Column>;
  where?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_dispatch_subscription_object". */
export type Subscription_Dispatch_Subscription_Object_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dispatch_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  subscription_dispatch?: InputMaybe<Subscription_Dispatch_Order_By>;
  subscription_object?: InputMaybe<Subscription_Object_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_dispatch_subscription_object */
export type Subscription_Dispatch_Subscription_Object_Pk_Columns_Input = {
  dispatch_id: Scalars['uuid'];
  object_id: Scalars['uuid'];
};

/** select columns of table "subscription_dispatch_subscription_object" */
export enum Subscription_Dispatch_Subscription_Object_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DispatchId = 'dispatch_id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscription_dispatch_subscription_object" */
export type Subscription_Dispatch_Subscription_Object_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dispatch_id?: InputMaybe<Scalars['uuid']>;
  object_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "subscription_dispatch_subscription_object" */
export enum Subscription_Dispatch_Subscription_Object_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DispatchId = 'dispatch_id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** update columns of table "subscription_dispatch" */
export enum Subscription_Dispatch_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HasDispatchedDigital = 'has_dispatched_digital',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  SubscriptionId = 'subscription_id'
}

/** columns and relationships of "subscription_draft_object" */
export type Subscription_Draft_Object = {
  __typename?: 'subscription_draft_object';
  account_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  address?: Maybe<Addresses>;
  address_id?: Maybe<Scalars['uuid']>;
  credits?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  message?: Maybe<Scalars['String']>;
  /** An array relationship */
  order_subscription_objects: Array<Order_Subscription_Object>;
  /** An aggregate relationship */
  order_subscription_objects_aggregate: Order_Subscription_Object_Aggregate;
  recipient: Scalars['String'];
  /** An object relationship */
  subscription: Subscriptions;
  subscription_id: Scalars['uuid'];
  /** An object relationship */
  subscription_object?: Maybe<Subscription_Object>;
};


/** columns and relationships of "subscription_draft_object" */
export type Subscription_Draft_ObjectOrder_Subscription_ObjectsArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Object_Order_By>>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "subscription_draft_object" */
export type Subscription_Draft_ObjectOrder_Subscription_Objects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Object_Order_By>>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};

/** aggregated selection of "subscription_draft_object" */
export type Subscription_Draft_Object_Aggregate = {
  __typename?: 'subscription_draft_object_aggregate';
  aggregate?: Maybe<Subscription_Draft_Object_Aggregate_Fields>;
  nodes: Array<Subscription_Draft_Object>;
};

/** aggregate fields of "subscription_draft_object" */
export type Subscription_Draft_Object_Aggregate_Fields = {
  __typename?: 'subscription_draft_object_aggregate_fields';
  avg?: Maybe<Subscription_Draft_Object_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscription_Draft_Object_Max_Fields>;
  min?: Maybe<Subscription_Draft_Object_Min_Fields>;
  stddev?: Maybe<Subscription_Draft_Object_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Draft_Object_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Draft_Object_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Draft_Object_Sum_Fields>;
  var_pop?: Maybe<Subscription_Draft_Object_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Draft_Object_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Draft_Object_Variance_Fields>;
};


/** aggregate fields of "subscription_draft_object" */
export type Subscription_Draft_Object_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Draft_Object_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Subscription_Draft_Object_Avg_Fields = {
  __typename?: 'subscription_draft_object_avg_fields';
  credits?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "subscription_draft_object". All fields are combined with a logical 'AND'. */
export type Subscription_Draft_Object_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Draft_Object_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Draft_Object_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Draft_Object_Bool_Exp>>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  address?: InputMaybe<Addresses_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  credits?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  order_subscription_objects?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
  recipient?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscription_object?: InputMaybe<Subscription_Object_Bool_Exp>;
};

/** unique or primary key constraints on table "subscription_draft_object" */
export enum Subscription_Draft_Object_Constraint {
  /** unique or primary key constraint */
  SubscriptionDraftObjectPkey = 'subscription_draft_object_pkey'
}

/** input type for incrementing numeric columns in table "subscription_draft_object" */
export type Subscription_Draft_Object_Inc_Input = {
  credits?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription_draft_object" */
export type Subscription_Draft_Object_Insert_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  address?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['uuid']>;
  credits?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  order_subscription_objects?: InputMaybe<Order_Subscription_Object_Arr_Rel_Insert_Input>;
  recipient?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['uuid']>;
  subscription_object?: InputMaybe<Subscription_Object_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Subscription_Draft_Object_Max_Fields = {
  __typename?: 'subscription_draft_object_max_fields';
  account_id?: Maybe<Scalars['uuid']>;
  address_id?: Maybe<Scalars['uuid']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Subscription_Draft_Object_Min_Fields = {
  __typename?: 'subscription_draft_object_min_fields';
  account_id?: Maybe<Scalars['uuid']>;
  address_id?: Maybe<Scalars['uuid']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "subscription_draft_object" */
export type Subscription_Draft_Object_Mutation_Response = {
  __typename?: 'subscription_draft_object_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Draft_Object>;
};

/** input type for inserting object relation for remote table "subscription_draft_object" */
export type Subscription_Draft_Object_Obj_Rel_Insert_Input = {
  data: Subscription_Draft_Object_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Draft_Object_On_Conflict>;
};

/** on_conflict condition type for table "subscription_draft_object" */
export type Subscription_Draft_Object_On_Conflict = {
  constraint: Subscription_Draft_Object_Constraint;
  update_columns?: Array<Subscription_Draft_Object_Update_Column>;
  where?: InputMaybe<Subscription_Draft_Object_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_draft_object". */
export type Subscription_Draft_Object_Order_By = {
  account_id?: InputMaybe<Order_By>;
  address?: InputMaybe<Addresses_Order_By>;
  address_id?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  order_subscription_objects_aggregate?: InputMaybe<Order_Subscription_Object_Aggregate_Order_By>;
  recipient?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  subscription_object?: InputMaybe<Subscription_Object_Order_By>;
};

/** primary key columns input for table: subscription_draft_object */
export type Subscription_Draft_Object_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "subscription_draft_object" */
export enum Subscription_Draft_Object_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Credits = 'credits',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  SubscriptionId = 'subscription_id'
}

/** input type for updating data in table "subscription_draft_object" */
export type Subscription_Draft_Object_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  address_id?: InputMaybe<Scalars['uuid']>;
  credits?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
  subscription_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Subscription_Draft_Object_Stddev_Fields = {
  __typename?: 'subscription_draft_object_stddev_fields';
  credits?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Draft_Object_Stddev_Pop_Fields = {
  __typename?: 'subscription_draft_object_stddev_pop_fields';
  credits?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Draft_Object_Stddev_Samp_Fields = {
  __typename?: 'subscription_draft_object_stddev_samp_fields';
  credits?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Subscription_Draft_Object_Sum_Fields = {
  __typename?: 'subscription_draft_object_sum_fields';
  credits?: Maybe<Scalars['Int']>;
};

/** update columns of table "subscription_draft_object" */
export enum Subscription_Draft_Object_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Credits = 'credits',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  SubscriptionId = 'subscription_id'
}

/** aggregate var_pop on columns */
export type Subscription_Draft_Object_Var_Pop_Fields = {
  __typename?: 'subscription_draft_object_var_pop_fields';
  credits?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Subscription_Draft_Object_Var_Samp_Fields = {
  __typename?: 'subscription_draft_object_var_samp_fields';
  credits?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Subscription_Draft_Object_Variance_Fields = {
  __typename?: 'subscription_draft_object_variance_fields';
  credits?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "subscription_object" */
export type Subscription_Object = {
  __typename?: 'subscription_object';
  /** An object relationship */
  account?: Maybe<Accounts>;
  account_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  address?: Maybe<Addresses>;
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  credits: Array<Subscription_Object_Credit>;
  /** An aggregate relationship */
  credits_aggregate: Subscription_Object_Credit_Aggregate;
  date_activated?: Maybe<Scalars['date']>;
  /** An array relationship */
  dispatches: Array<Subscription_Dispatch_Subscription_Object>;
  /** An aggregate relationship */
  dispatches_aggregate: Subscription_Dispatch_Subscription_Object_Aggregate;
  draft_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  /** An object relationship */
  order?: Maybe<Orders>;
  order_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  order_subscription_objects: Array<Order_Subscription_Object>;
  /** An aggregate relationship */
  order_subscription_objects_aggregate: Order_Subscription_Object_Aggregate;
  password: Scalars['String'];
  recipient: Scalars['String'];
  remaining_credits?: Maybe<Scalars['bigint']>;
  short_id: Scalars['String'];
  stripe_sub_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  subscription: Subscriptions;
  /** An object relationship */
  subscription_draft_object?: Maybe<Subscription_Draft_Object>;
  subscription_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "subscription_object" */
export type Subscription_ObjectCreditsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Credit_Order_By>>;
  where?: InputMaybe<Subscription_Object_Credit_Bool_Exp>;
};


/** columns and relationships of "subscription_object" */
export type Subscription_ObjectCredits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Credit_Order_By>>;
  where?: InputMaybe<Subscription_Object_Credit_Bool_Exp>;
};


/** columns and relationships of "subscription_object" */
export type Subscription_ObjectDispatchesArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "subscription_object" */
export type Subscription_ObjectDispatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "subscription_object" */
export type Subscription_ObjectOrder_Subscription_ObjectsArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Object_Order_By>>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "subscription_object" */
export type Subscription_ObjectOrder_Subscription_Objects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Object_Order_By>>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};

/** aggregated selection of "subscription_object" */
export type Subscription_Object_Aggregate = {
  __typename?: 'subscription_object_aggregate';
  aggregate?: Maybe<Subscription_Object_Aggregate_Fields>;
  nodes: Array<Subscription_Object>;
};

/** aggregate fields of "subscription_object" */
export type Subscription_Object_Aggregate_Fields = {
  __typename?: 'subscription_object_aggregate_fields';
  avg?: Maybe<Subscription_Object_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscription_Object_Max_Fields>;
  min?: Maybe<Subscription_Object_Min_Fields>;
  stddev?: Maybe<Subscription_Object_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Object_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Object_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Object_Sum_Fields>;
  var_pop?: Maybe<Subscription_Object_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Object_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Object_Variance_Fields>;
};


/** aggregate fields of "subscription_object" */
export type Subscription_Object_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Object_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subscription_object" */
export type Subscription_Object_Aggregate_Order_By = {
  avg?: InputMaybe<Subscription_Object_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Object_Max_Order_By>;
  min?: InputMaybe<Subscription_Object_Min_Order_By>;
  stddev?: InputMaybe<Subscription_Object_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscription_Object_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscription_Object_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscription_Object_Sum_Order_By>;
  var_pop?: InputMaybe<Subscription_Object_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscription_Object_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscription_Object_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_object" */
export type Subscription_Object_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Object_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Object_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscription_Object_Avg_Fields = {
  __typename?: 'subscription_object_avg_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "subscription_object" */
export type Subscription_Object_Avg_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscription_object". All fields are combined with a logical 'AND'. */
export type Subscription_Object_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Object_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Object_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Object_Bool_Exp>>;
  account?: InputMaybe<Accounts_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  address?: InputMaybe<Addresses_Bool_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credits?: InputMaybe<Subscription_Object_Credit_Bool_Exp>;
  date_activated?: InputMaybe<Date_Comparison_Exp>;
  dispatches?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
  draft_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  order_subscription_objects?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  recipient?: InputMaybe<String_Comparison_Exp>;
  remaining_credits?: InputMaybe<Bigint_Comparison_Exp>;
  short_id?: InputMaybe<String_Comparison_Exp>;
  stripe_sub_id?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscription_draft_object?: InputMaybe<Subscription_Draft_Object_Bool_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_object" */
export enum Subscription_Object_Constraint {
  /** unique or primary key constraint */
  SubscriptionObjectPkey = 'subscription_object_pkey',
  /** unique or primary key constraint */
  SubscriptionObjectShortIdKey = 'subscription_object_short_id_key'
}

/** columns and relationships of "subscription_object_credit" */
export type Subscription_Object_Credit = {
  __typename?: 'subscription_object_credit';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  subscription_object_id: Scalars['uuid'];
};

/** aggregated selection of "subscription_object_credit" */
export type Subscription_Object_Credit_Aggregate = {
  __typename?: 'subscription_object_credit_aggregate';
  aggregate?: Maybe<Subscription_Object_Credit_Aggregate_Fields>;
  nodes: Array<Subscription_Object_Credit>;
};

/** aggregate fields of "subscription_object_credit" */
export type Subscription_Object_Credit_Aggregate_Fields = {
  __typename?: 'subscription_object_credit_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Subscription_Object_Credit_Max_Fields>;
  min?: Maybe<Subscription_Object_Credit_Min_Fields>;
};


/** aggregate fields of "subscription_object_credit" */
export type Subscription_Object_Credit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Object_Credit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subscription_object_credit" */
export type Subscription_Object_Credit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Object_Credit_Max_Order_By>;
  min?: InputMaybe<Subscription_Object_Credit_Min_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_object_credit" */
export type Subscription_Object_Credit_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Object_Credit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Object_Credit_On_Conflict>;
};

/** Boolean expression to filter rows from the table "subscription_object_credit". All fields are combined with a logical 'AND'. */
export type Subscription_Object_Credit_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Object_Credit_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Object_Credit_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Object_Credit_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  subscription_object_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_object_credit" */
export enum Subscription_Object_Credit_Constraint {
  /** unique or primary key constraint */
  SubscriptionObjectCreditPkey = 'subscription_object_credit_pkey'
}

/** input type for inserting data into table "subscription_object_credit" */
export type Subscription_Object_Credit_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  subscription_object_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Subscription_Object_Credit_Max_Fields = {
  __typename?: 'subscription_object_credit_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  subscription_object_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "subscription_object_credit" */
export type Subscription_Object_Credit_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_object_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Object_Credit_Min_Fields = {
  __typename?: 'subscription_object_credit_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  subscription_object_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "subscription_object_credit" */
export type Subscription_Object_Credit_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_object_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscription_object_credit" */
export type Subscription_Object_Credit_Mutation_Response = {
  __typename?: 'subscription_object_credit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Object_Credit>;
};

/** on_conflict condition type for table "subscription_object_credit" */
export type Subscription_Object_Credit_On_Conflict = {
  constraint: Subscription_Object_Credit_Constraint;
  update_columns?: Array<Subscription_Object_Credit_Update_Column>;
  where?: InputMaybe<Subscription_Object_Credit_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_object_credit". */
export type Subscription_Object_Credit_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscription_object_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_object_credit */
export type Subscription_Object_Credit_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "subscription_object_credit" */
export enum Subscription_Object_Credit_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionObjectId = 'subscription_object_id'
}

/** input type for updating data in table "subscription_object_credit" */
export type Subscription_Object_Credit_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  subscription_object_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "subscription_object_credit" */
export enum Subscription_Object_Credit_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionObjectId = 'subscription_object_id'
}

/** input type for incrementing numeric columns in table "subscription_object" */
export type Subscription_Object_Inc_Input = {
  order_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription_object" */
export type Subscription_Object_Insert_Input = {
  account?: InputMaybe<Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']>;
  address?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credits?: InputMaybe<Subscription_Object_Credit_Arr_Rel_Insert_Input>;
  date_activated?: InputMaybe<Scalars['date']>;
  dispatches?: InputMaybe<Subscription_Dispatch_Subscription_Object_Arr_Rel_Insert_Input>;
  draft_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  order_subscription_objects?: InputMaybe<Order_Subscription_Object_Arr_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
  short_id?: InputMaybe<Scalars['String']>;
  stripe_sub_id?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscription_draft_object?: InputMaybe<Subscription_Draft_Object_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Subscription_Object_Max_Fields = {
  __typename?: 'subscription_object_max_fields';
  account_id?: Maybe<Scalars['uuid']>;
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_activated?: Maybe<Scalars['date']>;
  draft_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
  short_id?: Maybe<Scalars['String']>;
  stripe_sub_id?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "subscription_object" */
export type Subscription_Object_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_activated?: InputMaybe<Order_By>;
  draft_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  stripe_sub_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Object_Min_Fields = {
  __typename?: 'subscription_object_min_fields';
  account_id?: Maybe<Scalars['uuid']>;
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_activated?: Maybe<Scalars['date']>;
  draft_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['String']>;
  short_id?: Maybe<Scalars['String']>;
  stripe_sub_id?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "subscription_object" */
export type Subscription_Object_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_activated?: InputMaybe<Order_By>;
  draft_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  stripe_sub_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscription_object" */
export type Subscription_Object_Mutation_Response = {
  __typename?: 'subscription_object_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Object>;
};

/** input type for inserting object relation for remote table "subscription_object" */
export type Subscription_Object_Obj_Rel_Insert_Input = {
  data: Subscription_Object_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Object_On_Conflict>;
};

/** on_conflict condition type for table "subscription_object" */
export type Subscription_Object_On_Conflict = {
  constraint: Subscription_Object_Constraint;
  update_columns?: Array<Subscription_Object_Update_Column>;
  where?: InputMaybe<Subscription_Object_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_object". */
export type Subscription_Object_Order_By = {
  account?: InputMaybe<Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  address?: InputMaybe<Addresses_Order_By>;
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credits_aggregate?: InputMaybe<Subscription_Object_Credit_Aggregate_Order_By>;
  date_activated?: InputMaybe<Order_By>;
  dispatches_aggregate?: InputMaybe<Subscription_Dispatch_Subscription_Object_Aggregate_Order_By>;
  draft_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  order_subscription_objects_aggregate?: InputMaybe<Order_Subscription_Object_Aggregate_Order_By>;
  password?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  remaining_credits?: InputMaybe<Order_By>;
  short_id?: InputMaybe<Order_By>;
  stripe_sub_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscription_draft_object?: InputMaybe<Subscription_Draft_Object_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_object */
export type Subscription_Object_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "subscription_object" */
export enum Subscription_Object_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateActivated = 'date_activated',
  /** column name */
  DraftId = 'draft_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Message = 'message',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Password = 'password',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  ShortId = 'short_id',
  /** column name */
  StripeSubId = 'stripe_sub_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscription_object" */
export type Subscription_Object_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_activated?: InputMaybe<Scalars['date']>;
  draft_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
  short_id?: InputMaybe<Scalars['String']>;
  stripe_sub_id?: InputMaybe<Scalars['String']>;
  subscription_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Subscription_Object_Stddev_Fields = {
  __typename?: 'subscription_object_stddev_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "subscription_object" */
export type Subscription_Object_Stddev_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Object_Stddev_Pop_Fields = {
  __typename?: 'subscription_object_stddev_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "subscription_object" */
export type Subscription_Object_Stddev_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Object_Stddev_Samp_Fields = {
  __typename?: 'subscription_object_stddev_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "subscription_object" */
export type Subscription_Object_Stddev_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Subscription_Object_Sum_Fields = {
  __typename?: 'subscription_object_sum_fields';
  order_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subscription_object" */
export type Subscription_Object_Sum_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** update columns of table "subscription_object" */
export enum Subscription_Object_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateActivated = 'date_activated',
  /** column name */
  DraftId = 'draft_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Message = 'message',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Password = 'password',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  ShortId = 'short_id',
  /** column name */
  StripeSubId = 'stripe_sub_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Subscription_Object_Var_Pop_Fields = {
  __typename?: 'subscription_object_var_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "subscription_object" */
export type Subscription_Object_Var_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscription_Object_Var_Samp_Fields = {
  __typename?: 'subscription_object_var_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "subscription_object" */
export type Subscription_Object_Var_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscription_Object_Variance_Fields = {
  __typename?: 'subscription_object_variance_fields';
  order_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "subscription_object" */
export type Subscription_Object_Variance_Order_By = {
  order_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "subscription_price" */
export type Subscription_Price = {
  __typename?: 'subscription_price';
  duration: Scalars['Int'];
  id: Scalars['uuid'];
  is_deleted: Scalars['Boolean'];
  /** An array relationship */
  order_subscription_prices: Array<Order_Subscription_Price>;
  /** An aggregate relationship */
  order_subscription_prices_aggregate: Order_Subscription_Price_Aggregate;
  price: Scalars['Int'];
  sub_id: Scalars['uuid'];
  /** An object relationship */
  subscription: Subscriptions;
  title: Scalars['String'];
};


/** columns and relationships of "subscription_price" */
export type Subscription_PriceOrder_Subscription_PricesArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Price_Order_By>>;
  where?: InputMaybe<Order_Subscription_Price_Bool_Exp>;
};


/** columns and relationships of "subscription_price" */
export type Subscription_PriceOrder_Subscription_Prices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Price_Order_By>>;
  where?: InputMaybe<Order_Subscription_Price_Bool_Exp>;
};

/** aggregated selection of "subscription_price" */
export type Subscription_Price_Aggregate = {
  __typename?: 'subscription_price_aggregate';
  aggregate?: Maybe<Subscription_Price_Aggregate_Fields>;
  nodes: Array<Subscription_Price>;
};

/** aggregate fields of "subscription_price" */
export type Subscription_Price_Aggregate_Fields = {
  __typename?: 'subscription_price_aggregate_fields';
  avg?: Maybe<Subscription_Price_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscription_Price_Max_Fields>;
  min?: Maybe<Subscription_Price_Min_Fields>;
  stddev?: Maybe<Subscription_Price_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Price_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Price_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Price_Sum_Fields>;
  var_pop?: Maybe<Subscription_Price_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Price_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Price_Variance_Fields>;
};


/** aggregate fields of "subscription_price" */
export type Subscription_Price_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Price_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subscription_price" */
export type Subscription_Price_Aggregate_Order_By = {
  avg?: InputMaybe<Subscription_Price_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Price_Max_Order_By>;
  min?: InputMaybe<Subscription_Price_Min_Order_By>;
  stddev?: InputMaybe<Subscription_Price_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscription_Price_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscription_Price_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscription_Price_Sum_Order_By>;
  var_pop?: InputMaybe<Subscription_Price_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscription_Price_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscription_Price_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_price" */
export type Subscription_Price_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Price_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Price_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscription_Price_Avg_Fields = {
  __typename?: 'subscription_price_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "subscription_price" */
export type Subscription_Price_Avg_Order_By = {
  duration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscription_price". All fields are combined with a logical 'AND'. */
export type Subscription_Price_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Price_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Price_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Price_Bool_Exp>>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  order_subscription_prices?: InputMaybe<Order_Subscription_Price_Bool_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  sub_id?: InputMaybe<Uuid_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_price" */
export enum Subscription_Price_Constraint {
  /** unique or primary key constraint */
  SubscriptionPriceIdKey = 'subscription_price_id_key',
  /** unique or primary key constraint */
  SubscriptionPricePkey = 'subscription_price_pkey'
}

/** input type for incrementing numeric columns in table "subscription_price" */
export type Subscription_Price_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription_price" */
export type Subscription_Price_Insert_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  order_subscription_prices?: InputMaybe<Order_Subscription_Price_Arr_Rel_Insert_Input>;
  price?: InputMaybe<Scalars['Int']>;
  sub_id?: InputMaybe<Scalars['uuid']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Subscription_Price_Max_Fields = {
  __typename?: 'subscription_price_max_fields';
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Int']>;
  sub_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "subscription_price" */
export type Subscription_Price_Max_Order_By = {
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sub_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Price_Min_Fields = {
  __typename?: 'subscription_price_min_fields';
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Int']>;
  sub_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "subscription_price" */
export type Subscription_Price_Min_Order_By = {
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sub_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscription_price" */
export type Subscription_Price_Mutation_Response = {
  __typename?: 'subscription_price_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Price>;
};

/** input type for inserting object relation for remote table "subscription_price" */
export type Subscription_Price_Obj_Rel_Insert_Input = {
  data: Subscription_Price_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_Price_On_Conflict>;
};

/** on_conflict condition type for table "subscription_price" */
export type Subscription_Price_On_Conflict = {
  constraint: Subscription_Price_Constraint;
  update_columns?: Array<Subscription_Price_Update_Column>;
  where?: InputMaybe<Subscription_Price_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_price". */
export type Subscription_Price_Order_By = {
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  order_subscription_prices_aggregate?: InputMaybe<Order_Subscription_Price_Aggregate_Order_By>;
  price?: InputMaybe<Order_By>;
  sub_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_price */
export type Subscription_Price_Pk_Columns_Input = {
  id: Scalars['uuid'];
  sub_id: Scalars['uuid'];
};

/** select columns of table "subscription_price" */
export enum Subscription_Price_Select_Column {
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Price = 'price',
  /** column name */
  SubId = 'sub_id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "subscription_price" */
export type Subscription_Price_Set_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  sub_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Subscription_Price_Stddev_Fields = {
  __typename?: 'subscription_price_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "subscription_price" */
export type Subscription_Price_Stddev_Order_By = {
  duration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Price_Stddev_Pop_Fields = {
  __typename?: 'subscription_price_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "subscription_price" */
export type Subscription_Price_Stddev_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Price_Stddev_Samp_Fields = {
  __typename?: 'subscription_price_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "subscription_price" */
export type Subscription_Price_Stddev_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Subscription_Price_Sum_Fields = {
  __typename?: 'subscription_price_sum_fields';
  duration?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subscription_price" */
export type Subscription_Price_Sum_Order_By = {
  duration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** update columns of table "subscription_price" */
export enum Subscription_Price_Update_Column {
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Price = 'price',
  /** column name */
  SubId = 'sub_id',
  /** column name */
  Title = 'title'
}

/** aggregate var_pop on columns */
export type Subscription_Price_Var_Pop_Fields = {
  __typename?: 'subscription_price_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "subscription_price" */
export type Subscription_Price_Var_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscription_Price_Var_Samp_Fields = {
  __typename?: 'subscription_price_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "subscription_price" */
export type Subscription_Price_Var_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscription_Price_Variance_Fields = {
  __typename?: 'subscription_price_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "subscription_price" */
export type Subscription_Price_Variance_Order_By = {
  duration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** An array relationship */
  accounts: Array<Accounts>;
  /** An aggregate relationship */
  accounts_aggregate: Accounts_Aggregate;
  /** fetch data from the table: "accounts" using primary key columns */
  accounts_by_pk?: Maybe<Accounts>;
  /** An array relationship */
  addresses: Array<Addresses>;
  /** An aggregate relationship */
  addresses_aggregate: Addresses_Aggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** fetch data from the table: "book_discount" */
  book_discount: Array<Book_Discount>;
  /** fetch aggregated fields from the table: "book_discount" */
  book_discount_aggregate: Book_Discount_Aggregate;
  /** fetch data from the table: "book_discount" using primary key columns */
  book_discount_by_pk?: Maybe<Book_Discount>;
  /** fetch data from the table: "books" */
  books: Array<Books>;
  /** fetch aggregated fields from the table: "books" */
  books_aggregate: Books_Aggregate;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: Maybe<Books>;
  /** fetch data from the table: "booksellers" */
  booksellers: Array<Booksellers>;
  /** fetch aggregated fields from the table: "booksellers" */
  booksellers_aggregate: Booksellers_Aggregate;
  /** fetch data from the table: "booksellers" using primary key columns */
  booksellers_by_pk?: Maybe<Booksellers>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch aggregated fields from the table: "categories" */
  categories_aggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** fetch data from the table: "category_book" */
  category_book: Array<Category_Book>;
  /** fetch aggregated fields from the table: "category_book" */
  category_book_aggregate: Category_Book_Aggregate;
  /** fetch data from the table: "category_book" using primary key columns */
  category_book_by_pk?: Maybe<Category_Book>;
  /** fetch data from the table: "category_event" */
  category_event: Array<Category_Event>;
  /** fetch aggregated fields from the table: "category_event" */
  category_event_aggregate: Category_Event_Aggregate;
  /** fetch data from the table: "category_event" using primary key columns */
  category_event_by_pk?: Maybe<Category_Event>;
  /** fetch data from the table: "category_post" */
  category_post: Array<Category_Post>;
  /** fetch aggregated fields from the table: "category_post" */
  category_post_aggregate: Category_Post_Aggregate;
  /** fetch data from the table: "category_post" using primary key columns */
  category_post_by_pk?: Maybe<Category_Post>;
  /** fetch data from the table: "children_categories" */
  children_categories: Array<Children_Categories>;
  /** fetch aggregated fields from the table: "children_categories" */
  children_categories_aggregate: Children_Categories_Aggregate;
  /** fetch data from the table: "children_categories" using primary key columns */
  children_categories_by_pk?: Maybe<Children_Categories>;
  /** An array relationship */
  children_category_books: Array<Children_Category_Books>;
  /** An aggregate relationship */
  children_category_books_aggregate: Children_Category_Books_Aggregate;
  /** fetch data from the table: "children_category_books" using primary key columns */
  children_category_books_by_pk?: Maybe<Children_Category_Books>;
  /** fetch data from the table: "contents" */
  contents: Array<Contents>;
  /** fetch aggregated fields from the table: "contents" */
  contents_aggregate: Contents_Aggregate;
  /** fetch data from the table: "contents" using primary key columns */
  contents_by_pk?: Maybe<Contents>;
  /** An array relationship */
  countries: Array<Countries>;
  /** An aggregate relationship */
  countries_aggregate: Countries_Aggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** fetch data from the table: "discount_type" */
  discount_type: Array<Discount_Type>;
  /** fetch aggregated fields from the table: "discount_type" */
  discount_type_aggregate: Discount_Type_Aggregate;
  /** fetch data from the table: "discount_type" using primary key columns */
  discount_type_by_pk?: Maybe<Discount_Type>;
  /** fetch data from the table: "discounts" */
  discounts: Array<Discounts>;
  /** fetch aggregated fields from the table: "discounts" */
  discounts_aggregate: Discounts_Aggregate;
  /** fetch data from the table: "discounts" using primary key columns */
  discounts_by_pk?: Maybe<Discounts>;
  /** fetch data from the table: "empty_searches" */
  empty_searches: Array<Empty_Searches>;
  /** fetch aggregated fields from the table: "empty_searches" */
  empty_searches_aggregate: Empty_Searches_Aggregate;
  /** fetch data from the table: "empty_searches" using primary key columns */
  empty_searches_by_pk?: Maybe<Empty_Searches>;
  /** fetch data from the table: "event_book" */
  event_book: Array<Event_Book>;
  /** fetch aggregated fields from the table: "event_book" */
  event_book_aggregate: Event_Book_Aggregate;
  /** fetch data from the table: "event_book" using primary key columns */
  event_book_by_pk?: Maybe<Event_Book>;
  /** fetch data from the table: "event_comment" */
  event_comment: Array<Event_Comment>;
  /** fetch aggregated fields from the table: "event_comment" */
  event_comment_aggregate: Event_Comment_Aggregate;
  /** fetch data from the table: "event_comment" using primary key columns */
  event_comment_by_pk?: Maybe<Event_Comment>;
  /** An array relationship */
  event_tickets: Array<Event_Tickets>;
  /** An aggregate relationship */
  event_tickets_aggregate: Event_Tickets_Aggregate;
  /** fetch data from the table: "event_tickets" using primary key columns */
  event_tickets_by_pk?: Maybe<Event_Tickets>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** fetch data from the table: "order_book" */
  order_book: Array<Order_Book>;
  /** fetch aggregated fields from the table: "order_book" */
  order_book_aggregate: Order_Book_Aggregate;
  /** fetch data from the table: "order_book" using primary key columns */
  order_book_by_pk?: Maybe<Order_Book>;
  /** fetch data from the table: "order_item_status" */
  order_item_status: Array<Order_Item_Status>;
  /** fetch aggregated fields from the table: "order_item_status" */
  order_item_status_aggregate: Order_Item_Status_Aggregate;
  /** fetch data from the table: "order_item_status" using primary key columns */
  order_item_status_by_pk?: Maybe<Order_Item_Status>;
  /** fetch data from the table: "order_product" */
  order_product: Array<Order_Product>;
  /** fetch aggregated fields from the table: "order_product" */
  order_product_aggregate: Order_Product_Aggregate;
  /** fetch data from the table: "order_product" using primary key columns */
  order_product_by_pk?: Maybe<Order_Product>;
  /** fetch data from the table: "order_status" */
  order_status: Array<Order_Status>;
  /** fetch aggregated fields from the table: "order_status" */
  order_status_aggregate: Order_Status_Aggregate;
  /** fetch data from the table: "order_status" using primary key columns */
  order_status_by_pk?: Maybe<Order_Status>;
  /** fetch data from the table: "order_subscription_object" */
  order_subscription_object: Array<Order_Subscription_Object>;
  /** fetch aggregated fields from the table: "order_subscription_object" */
  order_subscription_object_aggregate: Order_Subscription_Object_Aggregate;
  /** fetch data from the table: "order_subscription_object" using primary key columns */
  order_subscription_object_by_pk?: Maybe<Order_Subscription_Object>;
  /** fetch data from the table: "order_subscription_price" */
  order_subscription_price: Array<Order_Subscription_Price>;
  /** fetch aggregated fields from the table: "order_subscription_price" */
  order_subscription_price_aggregate: Order_Subscription_Price_Aggregate;
  /** fetch data from the table: "order_subscription_price" using primary key columns */
  order_subscription_price_by_pk?: Maybe<Order_Subscription_Price>;
  /** fetch data from the table: "order_voucher" */
  order_voucher: Array<Order_Voucher>;
  /** fetch aggregated fields from the table: "order_voucher" */
  order_voucher_aggregate: Order_Voucher_Aggregate;
  /** fetch data from the table: "order_voucher" using primary key columns */
  order_voucher_by_pk?: Maybe<Order_Voucher>;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk?: Maybe<Orders>;
  /** fetch data from the table: "pages" */
  pages: Array<Pages>;
  /** fetch aggregated fields from the table: "pages" */
  pages_aggregate: Pages_Aggregate;
  /** fetch data from the table: "pages" using primary key columns */
  pages_by_pk?: Maybe<Pages>;
  /** An array relationship */
  pif_donations: Array<Pif_Donations>;
  /** An aggregate relationship */
  pif_donations_aggregate: Pif_Donations_Aggregate;
  /** fetch data from the table: "pif_donations" using primary key columns */
  pif_donations_by_pk?: Maybe<Pif_Donations>;
  /** fetch data from the table: "post_book" */
  post_book: Array<Post_Book>;
  /** fetch aggregated fields from the table: "post_book" */
  post_book_aggregate: Post_Book_Aggregate;
  /** fetch data from the table: "post_book" using primary key columns */
  post_book_by_pk?: Maybe<Post_Book>;
  /** An array relationship */
  posts: Array<Posts>;
  /** An aggregate relationship */
  posts_aggregate: Posts_Aggregate;
  /** fetch data from the table: "posts" using primary key columns */
  posts_by_pk?: Maybe<Posts>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table: "public_account_details" */
  public_account_details: Array<Public_Account_Details>;
  /** fetch aggregated fields from the table: "public_account_details" */
  public_account_details_aggregate: Public_Account_Details_Aggregate;
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate;
  /** fetch data from the table: "refresh_tokens" using primary key columns */
  refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** An array relationship */
  refunds: Array<Refunds>;
  /** An aggregate relationship */
  refunds_aggregate: Refunds_Aggregate;
  /** fetch data from the table: "refunds" using primary key columns */
  refunds_by_pk?: Maybe<Refunds>;
  /** fetch data from the table: "regions" */
  regions: Array<Regions>;
  /** fetch aggregated fields from the table: "regions" */
  regions_aggregate: Regions_Aggregate;
  /** fetch data from the table: "regions" using primary key columns */
  regions_by_pk?: Maybe<Regions>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** execute function "search_books" which returns "books" */
  search_books: Array<Books>;
  /** execute function "search_books" and query aggregates on result of table type "books" */
  search_books_aggregate: Books_Aggregate;
  /** execute function "search_events" which returns "events" */
  search_events: Array<Events>;
  /** execute function "search_events" and query aggregates on result of table type "events" */
  search_events_aggregate: Events_Aggregate;
  /** execute function "search_posts" which returns "posts" */
  search_posts: Array<Posts>;
  /** execute function "search_posts" and query aggregates on result of table type "posts" */
  search_posts_aggregate: Posts_Aggregate;
  /** execute function "search_products" which returns "products" */
  search_products: Array<Products>;
  /** execute function "search_products" and query aggregates on result of table type "products" */
  search_products_aggregate: Products_Aggregate;
  /** execute function "search_subscriptions" which returns "subscriptions" */
  search_subscriptions: Array<Subscriptions>;
  /** execute function "search_subscriptions" and query aggregates on result of table type "subscriptions" */
  search_subscriptions_aggregate: Subscriptions_Aggregate;
  /** An array relationship */
  shipping_options: Array<Shipping_Options>;
  /** An aggregate relationship */
  shipping_options_aggregate: Shipping_Options_Aggregate;
  /** fetch data from the table: "shipping_options" using primary key columns */
  shipping_options_by_pk?: Maybe<Shipping_Options>;
  /** fetch data from the table: "subscription_dispatch" */
  subscription_dispatch: Array<Subscription_Dispatch>;
  /** fetch aggregated fields from the table: "subscription_dispatch" */
  subscription_dispatch_aggregate: Subscription_Dispatch_Aggregate;
  /** fetch data from the table: "subscription_dispatch" using primary key columns */
  subscription_dispatch_by_pk?: Maybe<Subscription_Dispatch>;
  /** fetch data from the table: "subscription_dispatch_subscription_object" */
  subscription_dispatch_subscription_object: Array<Subscription_Dispatch_Subscription_Object>;
  /** fetch aggregated fields from the table: "subscription_dispatch_subscription_object" */
  subscription_dispatch_subscription_object_aggregate: Subscription_Dispatch_Subscription_Object_Aggregate;
  /** fetch data from the table: "subscription_dispatch_subscription_object" using primary key columns */
  subscription_dispatch_subscription_object_by_pk?: Maybe<Subscription_Dispatch_Subscription_Object>;
  /** fetch data from the table: "subscription_draft_object" */
  subscription_draft_object: Array<Subscription_Draft_Object>;
  /** fetch aggregated fields from the table: "subscription_draft_object" */
  subscription_draft_object_aggregate: Subscription_Draft_Object_Aggregate;
  /** fetch data from the table: "subscription_draft_object" using primary key columns */
  subscription_draft_object_by_pk?: Maybe<Subscription_Draft_Object>;
  /** fetch data from the table: "subscription_object" */
  subscription_object: Array<Subscription_Object>;
  /** fetch aggregated fields from the table: "subscription_object" */
  subscription_object_aggregate: Subscription_Object_Aggregate;
  /** fetch data from the table: "subscription_object" using primary key columns */
  subscription_object_by_pk?: Maybe<Subscription_Object>;
  /** fetch data from the table: "subscription_object_credit" */
  subscription_object_credit: Array<Subscription_Object_Credit>;
  /** fetch aggregated fields from the table: "subscription_object_credit" */
  subscription_object_credit_aggregate: Subscription_Object_Credit_Aggregate;
  /** fetch data from the table: "subscription_object_credit" using primary key columns */
  subscription_object_credit_by_pk?: Maybe<Subscription_Object_Credit>;
  /** fetch data from the table: "subscription_price" */
  subscription_price: Array<Subscription_Price>;
  /** fetch aggregated fields from the table: "subscription_price" */
  subscription_price_aggregate: Subscription_Price_Aggregate;
  /** fetch data from the table: "subscription_price" using primary key columns */
  subscription_price_by_pk?: Maybe<Subscription_Price>;
  /** fetch data from the table: "subscriptions" */
  subscriptions: Array<Subscriptions>;
  /** fetch aggregated fields from the table: "subscriptions" */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table: "tag_book" */
  tag_book: Array<Tag_Book>;
  /** fetch aggregated fields from the table: "tag_book" */
  tag_book_aggregate: Tag_Book_Aggregate;
  /** fetch data from the table: "tag_book" using primary key columns */
  tag_book_by_pk?: Maybe<Tag_Book>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** fetch data from the table: "unstructured_data" */
  unstructured_data: Array<Unstructured_Data>;
  /** fetch aggregated fields from the table: "unstructured_data" */
  unstructured_data_aggregate: Unstructured_Data_Aggregate;
  /** fetch data from the table: "unstructured_data" using primary key columns */
  unstructured_data_by_pk?: Maybe<Unstructured_Data>;
  /** An array relationship */
  vouchers: Array<Vouchers>;
  /** An aggregate relationship */
  vouchers_aggregate: Vouchers_Aggregate;
  /** fetch data from the table: "vouchers" using primary key columns */
  vouchers_by_pk?: Maybe<Vouchers>;
};


export type Subscription_RootAccountsArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


export type Subscription_RootAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Order_By>>;
  where?: InputMaybe<Accounts_Bool_Exp>;
};


export type Subscription_RootAccounts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBook_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Book_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Book_Discount_Order_By>>;
  where?: InputMaybe<Book_Discount_Bool_Exp>;
};


export type Subscription_RootBook_Discount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Book_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Book_Discount_Order_By>>;
  where?: InputMaybe<Book_Discount_Bool_Exp>;
};


export type Subscription_RootBook_Discount_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  discount_id: Scalars['String'];
};


export type Subscription_RootBooksArgs = {
  distinct_on?: InputMaybe<Array<Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Books_Order_By>>;
  where?: InputMaybe<Books_Bool_Exp>;
};


export type Subscription_RootBooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Books_Order_By>>;
  where?: InputMaybe<Books_Bool_Exp>;
};


export type Subscription_RootBooks_By_PkArgs = {
  isbn: Scalars['bigint'];
};


export type Subscription_RootBooksellersArgs = {
  distinct_on?: InputMaybe<Array<Booksellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booksellers_Order_By>>;
  where?: InputMaybe<Booksellers_Bool_Exp>;
};


export type Subscription_RootBooksellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booksellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booksellers_Order_By>>;
  where?: InputMaybe<Booksellers_Bool_Exp>;
};


export type Subscription_RootBooksellers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootCategories_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCategory_BookArgs = {
  distinct_on?: InputMaybe<Array<Category_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Book_Order_By>>;
  where?: InputMaybe<Category_Book_Bool_Exp>;
};


export type Subscription_RootCategory_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Book_Order_By>>;
  where?: InputMaybe<Category_Book_Bool_Exp>;
};


export type Subscription_RootCategory_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  category_name: Scalars['String'];
};


export type Subscription_RootCategory_EventArgs = {
  distinct_on?: InputMaybe<Array<Category_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Event_Order_By>>;
  where?: InputMaybe<Category_Event_Bool_Exp>;
};


export type Subscription_RootCategory_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Event_Order_By>>;
  where?: InputMaybe<Category_Event_Bool_Exp>;
};


export type Subscription_RootCategory_Event_By_PkArgs = {
  category_name: Scalars['String'];
  event_id: Scalars['uuid'];
};


export type Subscription_RootCategory_PostArgs = {
  distinct_on?: InputMaybe<Array<Category_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Post_Order_By>>;
  where?: InputMaybe<Category_Post_Bool_Exp>;
};


export type Subscription_RootCategory_Post_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Category_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Category_Post_Order_By>>;
  where?: InputMaybe<Category_Post_Bool_Exp>;
};


export type Subscription_RootCategory_Post_By_PkArgs = {
  category_name: Scalars['String'];
  post_id: Scalars['uuid'];
};


export type Subscription_RootChildren_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Children_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Children_Categories_Order_By>>;
  where?: InputMaybe<Children_Categories_Bool_Exp>;
};


export type Subscription_RootChildren_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Children_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Children_Categories_Order_By>>;
  where?: InputMaybe<Children_Categories_Bool_Exp>;
};


export type Subscription_RootChildren_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootChildren_Category_BooksArgs = {
  distinct_on?: InputMaybe<Array<Children_Category_Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Children_Category_Books_Order_By>>;
  where?: InputMaybe<Children_Category_Books_Bool_Exp>;
};


export type Subscription_RootChildren_Category_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Children_Category_Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Children_Category_Books_Order_By>>;
  where?: InputMaybe<Children_Category_Books_Bool_Exp>;
};


export type Subscription_RootChildren_Category_Books_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  category_id: Scalars['uuid'];
};


export type Subscription_RootContentsArgs = {
  distinct_on?: InputMaybe<Array<Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contents_Order_By>>;
  where?: InputMaybe<Contents_Bool_Exp>;
};


export type Subscription_RootContents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contents_Order_By>>;
  where?: InputMaybe<Contents_Bool_Exp>;
};


export type Subscription_RootContents_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountries_By_PkArgs = {
  code: Scalars['String'];
};


export type Subscription_RootDiscount_TypeArgs = {
  distinct_on?: InputMaybe<Array<Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Type_Order_By>>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};


export type Subscription_RootDiscount_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Type_Order_By>>;
  where?: InputMaybe<Discount_Type_Bool_Exp>;
};


export type Subscription_RootDiscount_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDiscountsArgs = {
  distinct_on?: InputMaybe<Array<Discounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discounts_Order_By>>;
  where?: InputMaybe<Discounts_Bool_Exp>;
};


export type Subscription_RootDiscounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discounts_Order_By>>;
  where?: InputMaybe<Discounts_Bool_Exp>;
};


export type Subscription_RootDiscounts_By_PkArgs = {
  code: Scalars['String'];
};


export type Subscription_RootEmpty_SearchesArgs = {
  distinct_on?: InputMaybe<Array<Empty_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Empty_Searches_Order_By>>;
  where?: InputMaybe<Empty_Searches_Bool_Exp>;
};


export type Subscription_RootEmpty_Searches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Empty_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Empty_Searches_Order_By>>;
  where?: InputMaybe<Empty_Searches_Bool_Exp>;
};


export type Subscription_RootEmpty_Searches_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootEvent_BookArgs = {
  distinct_on?: InputMaybe<Array<Event_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Book_Order_By>>;
  where?: InputMaybe<Event_Book_Bool_Exp>;
};


export type Subscription_RootEvent_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Book_Order_By>>;
  where?: InputMaybe<Event_Book_Bool_Exp>;
};


export type Subscription_RootEvent_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  event_id: Scalars['uuid'];
};


export type Subscription_RootEvent_CommentArgs = {
  distinct_on?: InputMaybe<Array<Event_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Comment_Order_By>>;
  where?: InputMaybe<Event_Comment_Bool_Exp>;
};


export type Subscription_RootEvent_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Comment_Order_By>>;
  where?: InputMaybe<Event_Comment_Bool_Exp>;
};


export type Subscription_RootEvent_Comment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootEvent_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


export type Subscription_RootEvent_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


export type Subscription_RootEvent_Tickets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrder_BookArgs = {
  distinct_on?: InputMaybe<Array<Order_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Book_Order_By>>;
  where?: InputMaybe<Order_Book_Bool_Exp>;
};


export type Subscription_RootOrder_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Book_Order_By>>;
  where?: InputMaybe<Order_Book_Bool_Exp>;
};


export type Subscription_RootOrder_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  order_id: Scalars['Int'];
};


export type Subscription_RootOrder_Item_StatusArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Status_Order_By>>;
  where?: InputMaybe<Order_Item_Status_Bool_Exp>;
};


export type Subscription_RootOrder_Item_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Status_Order_By>>;
  where?: InputMaybe<Order_Item_Status_Bool_Exp>;
};


export type Subscription_RootOrder_Item_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootOrder_ProductArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


export type Subscription_RootOrder_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


export type Subscription_RootOrder_Product_By_PkArgs = {
  order_id: Scalars['Int'];
  product_id: Scalars['uuid'];
};


export type Subscription_RootOrder_StatusArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Order_By>>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};


export type Subscription_RootOrder_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Order_By>>;
  where?: InputMaybe<Order_Status_Bool_Exp>;
};


export type Subscription_RootOrder_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootOrder_Subscription_ObjectArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Object_Order_By>>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};


export type Subscription_RootOrder_Subscription_Object_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Object_Order_By>>;
  where?: InputMaybe<Order_Subscription_Object_Bool_Exp>;
};


export type Subscription_RootOrder_Subscription_Object_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrder_Subscription_PriceArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Price_Order_By>>;
  where?: InputMaybe<Order_Subscription_Price_Bool_Exp>;
};


export type Subscription_RootOrder_Subscription_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Subscription_Price_Order_By>>;
  where?: InputMaybe<Order_Subscription_Price_Bool_Exp>;
};


export type Subscription_RootOrder_Subscription_Price_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrder_VoucherArgs = {
  distinct_on?: InputMaybe<Array<Order_Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Voucher_Order_By>>;
  where?: InputMaybe<Order_Voucher_Bool_Exp>;
};


export type Subscription_RootOrder_Voucher_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Voucher_Order_By>>;
  where?: InputMaybe<Order_Voucher_Bool_Exp>;
};


export type Subscription_RootOrder_Voucher_By_PkArgs = {
  order_id: Scalars['Int'];
  voucher_id: Scalars['String'];
};


export type Subscription_RootOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPagesArgs = {
  distinct_on?: InputMaybe<Array<Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_Order_By>>;
  where?: InputMaybe<Pages_Bool_Exp>;
};


export type Subscription_RootPages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_Order_By>>;
  where?: InputMaybe<Pages_Bool_Exp>;
};


export type Subscription_RootPages_By_PkArgs = {
  title: Scalars['String'];
};


export type Subscription_RootPif_DonationsArgs = {
  distinct_on?: InputMaybe<Array<Pif_Donations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pif_Donations_Order_By>>;
  where?: InputMaybe<Pif_Donations_Bool_Exp>;
};


export type Subscription_RootPif_Donations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pif_Donations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pif_Donations_Order_By>>;
  where?: InputMaybe<Pif_Donations_Bool_Exp>;
};


export type Subscription_RootPif_Donations_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPost_BookArgs = {
  distinct_on?: InputMaybe<Array<Post_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Book_Order_By>>;
  where?: InputMaybe<Post_Book_Bool_Exp>;
};


export type Subscription_RootPost_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Post_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Book_Order_By>>;
  where?: InputMaybe<Post_Book_Bool_Exp>;
};


export type Subscription_RootPost_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  post_id: Scalars['uuid'];
};


export type Subscription_RootPostsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootPosts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPublic_Account_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Public_Account_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Public_Account_Details_Order_By>>;
  where?: InputMaybe<Public_Account_Details_Bool_Exp>;
};


export type Subscription_RootPublic_Account_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Public_Account_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Public_Account_Details_Order_By>>;
  where?: InputMaybe<Public_Account_Details_Bool_Exp>;
};


export type Subscription_RootRefresh_TokensArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
};


export type Subscription_RootRefresh_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>;
};


export type Subscription_RootRefresh_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRefundsArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


export type Subscription_RootRefunds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


export type Subscription_RootRefunds_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRegionsArgs = {
  distinct_on?: InputMaybe<Array<Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Regions_Order_By>>;
  where?: InputMaybe<Regions_Bool_Exp>;
};


export type Subscription_RootRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Regions_Order_By>>;
  where?: InputMaybe<Regions_Bool_Exp>;
};


export type Subscription_RootRegions_By_PkArgs = {
  code: Scalars['String'];
};


export type Subscription_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootSearch_BooksArgs = {
  args: Search_Books_Args;
  distinct_on?: InputMaybe<Array<Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Books_Order_By>>;
  where?: InputMaybe<Books_Bool_Exp>;
};


export type Subscription_RootSearch_Books_AggregateArgs = {
  args: Search_Books_Args;
  distinct_on?: InputMaybe<Array<Books_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Books_Order_By>>;
  where?: InputMaybe<Books_Bool_Exp>;
};


export type Subscription_RootSearch_EventsArgs = {
  args: Search_Events_Args;
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootSearch_Events_AggregateArgs = {
  args: Search_Events_Args;
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootSearch_PostsArgs = {
  args: Search_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootSearch_Posts_AggregateArgs = {
  args: Search_Posts_Args;
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootSearch_ProductsArgs = {
  args: Search_Products_Args;
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootSearch_Products_AggregateArgs = {
  args: Search_Products_Args;
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootSearch_SubscriptionsArgs = {
  args: Search_Subscriptions_Args;
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSearch_Subscriptions_AggregateArgs = {
  args: Search_Subscriptions_Args;
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootShipping_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Shipping_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipping_Options_Order_By>>;
  where?: InputMaybe<Shipping_Options_Bool_Exp>;
};


export type Subscription_RootShipping_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shipping_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipping_Options_Order_By>>;
  where?: InputMaybe<Shipping_Options_Bool_Exp>;
};


export type Subscription_RootShipping_Options_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubscription_DispatchArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Bool_Exp>;
};


export type Subscription_RootSubscription_Dispatch_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Bool_Exp>;
};


export type Subscription_RootSubscription_Dispatch_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubscription_Dispatch_Subscription_ObjectArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
};


export type Subscription_RootSubscription_Dispatch_Subscription_Object_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Subscription_Object_Bool_Exp>;
};


export type Subscription_RootSubscription_Dispatch_Subscription_Object_By_PkArgs = {
  dispatch_id: Scalars['uuid'];
  object_id: Scalars['uuid'];
};


export type Subscription_RootSubscription_Draft_ObjectArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Draft_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Draft_Object_Order_By>>;
  where?: InputMaybe<Subscription_Draft_Object_Bool_Exp>;
};


export type Subscription_RootSubscription_Draft_Object_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Draft_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Draft_Object_Order_By>>;
  where?: InputMaybe<Subscription_Draft_Object_Bool_Exp>;
};


export type Subscription_RootSubscription_Draft_Object_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubscription_ObjectArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Object_Bool_Exp>;
};


export type Subscription_RootSubscription_Object_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Object_Bool_Exp>;
};


export type Subscription_RootSubscription_Object_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubscription_Object_CreditArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Credit_Order_By>>;
  where?: InputMaybe<Subscription_Object_Credit_Bool_Exp>;
};


export type Subscription_RootSubscription_Object_Credit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Credit_Order_By>>;
  where?: InputMaybe<Subscription_Object_Credit_Bool_Exp>;
};


export type Subscription_RootSubscription_Object_Credit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubscription_PriceArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Price_Order_By>>;
  where?: InputMaybe<Subscription_Price_Bool_Exp>;
};


export type Subscription_RootSubscription_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Price_Order_By>>;
  where?: InputMaybe<Subscription_Price_Bool_Exp>;
};


export type Subscription_RootSubscription_Price_By_PkArgs = {
  id: Scalars['uuid'];
  sub_id: Scalars['uuid'];
};


export type Subscription_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTag_BookArgs = {
  distinct_on?: InputMaybe<Array<Tag_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Book_Order_By>>;
  where?: InputMaybe<Tag_Book_Bool_Exp>;
};


export type Subscription_RootTag_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Book_Order_By>>;
  where?: InputMaybe<Tag_Book_Bool_Exp>;
};


export type Subscription_RootTag_Book_By_PkArgs = {
  book_isbn: Scalars['bigint'];
  tag_id: Scalars['Int'];
};


export type Subscription_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUnstructured_DataArgs = {
  distinct_on?: InputMaybe<Array<Unstructured_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unstructured_Data_Order_By>>;
  where?: InputMaybe<Unstructured_Data_Bool_Exp>;
};


export type Subscription_RootUnstructured_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unstructured_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unstructured_Data_Order_By>>;
  where?: InputMaybe<Unstructured_Data_Bool_Exp>;
};


export type Subscription_RootUnstructured_Data_By_PkArgs = {
  title: Scalars['String'];
};


export type Subscription_RootVouchersArgs = {
  distinct_on?: InputMaybe<Array<Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vouchers_Order_By>>;
  where?: InputMaybe<Vouchers_Bool_Exp>;
};


export type Subscription_RootVouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vouchers_Order_By>>;
  where?: InputMaybe<Vouchers_Bool_Exp>;
};


export type Subscription_RootVouchers_By_PkArgs = {
  id: Scalars['String'];
};

/** columns and relationships of "subscriptions" */
export type Subscriptions = {
  __typename?: 'subscriptions';
  description: Scalars['String'];
  id: Scalars['uuid'];
  image: Scalars['String'];
  is_active: Scalars['Boolean'];
  note: Scalars['String'];
  price: Scalars['Int'];
  slug: Scalars['String'];
  /** An array relationship */
  subscription_dispatches: Array<Subscription_Dispatch>;
  /** An aggregate relationship */
  subscription_dispatches_aggregate: Subscription_Dispatch_Aggregate;
  /** An array relationship */
  subscription_objects: Array<Subscription_Object>;
  /** An aggregate relationship */
  subscription_objects_aggregate: Subscription_Object_Aggregate;
  /** An array relationship */
  subscription_prices: Array<Subscription_Price>;
  /** An aggregate relationship */
  subscription_prices_aggregate: Subscription_Price_Aggregate;
  title: Scalars['String'];
  ts_vector?: Maybe<Scalars['tsvector']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsSubscription_DispatchesArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsSubscription_Dispatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Dispatch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Dispatch_Order_By>>;
  where?: InputMaybe<Subscription_Dispatch_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsSubscription_ObjectsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsSubscription_Objects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Object_Order_By>>;
  where?: InputMaybe<Subscription_Object_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsSubscription_PricesArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Price_Order_By>>;
  where?: InputMaybe<Subscription_Price_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsSubscription_Prices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Price_Order_By>>;
  where?: InputMaybe<Subscription_Price_Bool_Exp>;
};

export type Subscriptions_Aggregate = {
  __typename?: 'subscriptions_aggregate';
  aggregate?: Maybe<Subscriptions_Aggregate_Fields>;
  nodes: Array<Subscriptions>;
};

/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_Fields = {
  __typename?: 'subscriptions_aggregate_fields';
  avg?: Maybe<Subscriptions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscriptions_Max_Fields>;
  min?: Maybe<Subscriptions_Min_Fields>;
  stddev?: Maybe<Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Variance_Fields>;
};


/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Subscriptions_Avg_Fields = {
  __typename?: 'subscriptions_avg_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "subscriptions". All fields are combined with a logical 'AND'. */
export type Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  subscription_dispatches?: InputMaybe<Subscription_Dispatch_Bool_Exp>;
  subscription_objects?: InputMaybe<Subscription_Object_Bool_Exp>;
  subscription_prices?: InputMaybe<Subscription_Price_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  ts_vector?: InputMaybe<Tsvector_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions" */
export enum Subscriptions_Constraint {
  /** unique or primary key constraint */
  SubscriptionsPkey = 'subscriptions_pkey',
  /** unique or primary key constraint */
  SubscriptionsSlugKey = 'subscriptions_slug_key'
}

/** input type for incrementing numeric columns in table "subscriptions" */
export type Subscriptions_Inc_Input = {
  price?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscriptions" */
export type Subscriptions_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  subscription_dispatches?: InputMaybe<Subscription_Dispatch_Arr_Rel_Insert_Input>;
  subscription_objects?: InputMaybe<Subscription_Object_Arr_Rel_Insert_Input>;
  subscription_prices?: InputMaybe<Subscription_Price_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
};

/** aggregate max on columns */
export type Subscriptions_Max_Fields = {
  __typename?: 'subscriptions_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Subscriptions_Min_Fields = {
  __typename?: 'subscriptions_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "subscriptions" */
export type Subscriptions_Mutation_Response = {
  __typename?: 'subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions>;
};

/** input type for inserting object relation for remote table "subscriptions" */
export type Subscriptions_Obj_Rel_Insert_Input = {
  data: Subscriptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};

/** on_conflict condition type for table "subscriptions" */
export type Subscriptions_On_Conflict = {
  constraint: Subscriptions_Constraint;
  update_columns?: Array<Subscriptions_Update_Column>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions". */
export type Subscriptions_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  subscription_dispatches_aggregate?: InputMaybe<Subscription_Dispatch_Aggregate_Order_By>;
  subscription_objects_aggregate?: InputMaybe<Subscription_Object_Aggregate_Order_By>;
  subscription_prices_aggregate?: InputMaybe<Subscription_Price_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  ts_vector?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions */
export type Subscriptions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "subscriptions" */
export enum Subscriptions_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Note = 'note',
  /** column name */
  Price = 'price',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  TsVector = 'ts_vector'
}

/** input type for updating data in table "subscriptions" */
export type Subscriptions_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  ts_vector?: InputMaybe<Scalars['tsvector']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Stddev_Fields = {
  __typename?: 'subscriptions_stddev_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Subscriptions_Sum_Fields = {
  __typename?: 'subscriptions_sum_fields';
  price?: Maybe<Scalars['Int']>;
};

/** update columns of table "subscriptions" */
export enum Subscriptions_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Note = 'note',
  /** column name */
  Price = 'price',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  TsVector = 'ts_vector'
}

/** aggregate var_pop on columns */
export type Subscriptions_Var_Pop_Fields = {
  __typename?: 'subscriptions_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Var_Samp_Fields = {
  __typename?: 'subscriptions_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Subscriptions_Variance_Fields = {
  __typename?: 'subscriptions_variance_fields';
  price?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "tag_book" */
export type Tag_Book = {
  __typename?: 'tag_book';
  /** An object relationship */
  book: Books;
  book_isbn: Scalars['bigint'];
  /** An object relationship */
  tag: Tags;
  tag_id: Scalars['Int'];
};

/** aggregated selection of "tag_book" */
export type Tag_Book_Aggregate = {
  __typename?: 'tag_book_aggregate';
  aggregate?: Maybe<Tag_Book_Aggregate_Fields>;
  nodes: Array<Tag_Book>;
};

/** aggregate fields of "tag_book" */
export type Tag_Book_Aggregate_Fields = {
  __typename?: 'tag_book_aggregate_fields';
  avg?: Maybe<Tag_Book_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tag_Book_Max_Fields>;
  min?: Maybe<Tag_Book_Min_Fields>;
  stddev?: Maybe<Tag_Book_Stddev_Fields>;
  stddev_pop?: Maybe<Tag_Book_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tag_Book_Stddev_Samp_Fields>;
  sum?: Maybe<Tag_Book_Sum_Fields>;
  var_pop?: Maybe<Tag_Book_Var_Pop_Fields>;
  var_samp?: Maybe<Tag_Book_Var_Samp_Fields>;
  variance?: Maybe<Tag_Book_Variance_Fields>;
};


/** aggregate fields of "tag_book" */
export type Tag_Book_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Book_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tag_book" */
export type Tag_Book_Aggregate_Order_By = {
  avg?: InputMaybe<Tag_Book_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tag_Book_Max_Order_By>;
  min?: InputMaybe<Tag_Book_Min_Order_By>;
  stddev?: InputMaybe<Tag_Book_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tag_Book_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tag_Book_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tag_Book_Sum_Order_By>;
  var_pop?: InputMaybe<Tag_Book_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tag_Book_Var_Samp_Order_By>;
  variance?: InputMaybe<Tag_Book_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tag_book" */
export type Tag_Book_Arr_Rel_Insert_Input = {
  data: Array<Tag_Book_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Book_On_Conflict>;
};

/** aggregate avg on columns */
export type Tag_Book_Avg_Fields = {
  __typename?: 'tag_book_avg_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tag_book" */
export type Tag_Book_Avg_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tag_book". All fields are combined with a logical 'AND'. */
export type Tag_Book_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Book_Bool_Exp>>;
  _not?: InputMaybe<Tag_Book_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Book_Bool_Exp>>;
  book?: InputMaybe<Books_Bool_Exp>;
  book_isbn?: InputMaybe<Bigint_Comparison_Exp>;
  tag?: InputMaybe<Tags_Bool_Exp>;
  tag_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "tag_book" */
export enum Tag_Book_Constraint {
  /** unique or primary key constraint */
  TagBookPkey = 'tag_book_pkey'
}

/** input type for incrementing numeric columns in table "tag_book" */
export type Tag_Book_Inc_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  tag_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tag_book" */
export type Tag_Book_Insert_Input = {
  book?: InputMaybe<Books_Obj_Rel_Insert_Input>;
  book_isbn?: InputMaybe<Scalars['bigint']>;
  tag?: InputMaybe<Tags_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Tag_Book_Max_Fields = {
  __typename?: 'tag_book_max_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  tag_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "tag_book" */
export type Tag_Book_Max_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tag_Book_Min_Fields = {
  __typename?: 'tag_book_min_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  tag_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "tag_book" */
export type Tag_Book_Min_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tag_book" */
export type Tag_Book_Mutation_Response = {
  __typename?: 'tag_book_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Book>;
};

/** on_conflict condition type for table "tag_book" */
export type Tag_Book_On_Conflict = {
  constraint: Tag_Book_Constraint;
  update_columns?: Array<Tag_Book_Update_Column>;
  where?: InputMaybe<Tag_Book_Bool_Exp>;
};

/** Ordering options when selecting data from "tag_book". */
export type Tag_Book_Order_By = {
  book?: InputMaybe<Books_Order_By>;
  book_isbn?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tags_Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tag_book */
export type Tag_Book_Pk_Columns_Input = {
  book_isbn: Scalars['bigint'];
  tag_id: Scalars['Int'];
};

/** select columns of table "tag_book" */
export enum Tag_Book_Select_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  TagId = 'tag_id'
}

/** input type for updating data in table "tag_book" */
export type Tag_Book_Set_Input = {
  book_isbn?: InputMaybe<Scalars['bigint']>;
  tag_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Tag_Book_Stddev_Fields = {
  __typename?: 'tag_book_stddev_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tag_book" */
export type Tag_Book_Stddev_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tag_Book_Stddev_Pop_Fields = {
  __typename?: 'tag_book_stddev_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tag_book" */
export type Tag_Book_Stddev_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tag_Book_Stddev_Samp_Fields = {
  __typename?: 'tag_book_stddev_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tag_book" */
export type Tag_Book_Stddev_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Tag_Book_Sum_Fields = {
  __typename?: 'tag_book_sum_fields';
  book_isbn?: Maybe<Scalars['bigint']>;
  tag_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "tag_book" */
export type Tag_Book_Sum_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** update columns of table "tag_book" */
export enum Tag_Book_Update_Column {
  /** column name */
  BookIsbn = 'book_isbn',
  /** column name */
  TagId = 'tag_id'
}

/** aggregate var_pop on columns */
export type Tag_Book_Var_Pop_Fields = {
  __typename?: 'tag_book_var_pop_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tag_book" */
export type Tag_Book_Var_Pop_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tag_Book_Var_Samp_Fields = {
  __typename?: 'tag_book_var_samp_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tag_book" */
export type Tag_Book_Var_Samp_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tag_Book_Variance_Fields = {
  __typename?: 'tag_book_variance_fields';
  book_isbn?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tag_book" */
export type Tag_Book_Variance_Order_By = {
  book_isbn?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "tags" */
export type Tags = {
  __typename?: 'tags';
  id: Scalars['Int'];
  /** An array relationship */
  tag_books: Array<Tag_Book>;
  /** An aggregate relationship */
  tag_books_aggregate: Tag_Book_Aggregate;
  text: Scalars['String'];
};


/** columns and relationships of "tags" */
export type TagsTag_BooksArgs = {
  distinct_on?: InputMaybe<Array<Tag_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Book_Order_By>>;
  where?: InputMaybe<Tag_Book_Bool_Exp>;
};


/** columns and relationships of "tags" */
export type TagsTag_Books_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Book_Order_By>>;
  where?: InputMaybe<Tag_Book_Bool_Exp>;
};

/** aggregated selection of "tags" */
export type Tags_Aggregate = {
  __typename?: 'tags_aggregate';
  aggregate?: Maybe<Tags_Aggregate_Fields>;
  nodes: Array<Tags>;
};

/** aggregate fields of "tags" */
export type Tags_Aggregate_Fields = {
  __typename?: 'tags_aggregate_fields';
  avg?: Maybe<Tags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tags_Max_Fields>;
  min?: Maybe<Tags_Min_Fields>;
  stddev?: Maybe<Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Tags_Sum_Fields>;
  var_pop?: Maybe<Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Tags_Var_Samp_Fields>;
  variance?: Maybe<Tags_Variance_Fields>;
};


/** aggregate fields of "tags" */
export type Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Tags_Avg_Fields = {
  __typename?: 'tags_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Tags_Bool_Exp>>;
  _not?: InputMaybe<Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Tags_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tag_books?: InputMaybe<Tag_Book_Bool_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tags" */
export enum Tags_Constraint {
  /** unique or primary key constraint */
  TagsPkey = 'tags_pkey',
  /** unique or primary key constraint */
  TagsTextKey = 'tags_text_key'
}

/** input type for incrementing numeric columns in table "tags" */
export type Tags_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tags" */
export type Tags_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  tag_books?: InputMaybe<Tag_Book_Arr_Rel_Insert_Input>;
  text?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tags_Max_Fields = {
  __typename?: 'tags_max_fields';
  id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tags_Min_Fields = {
  __typename?: 'tags_min_fields';
  id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "tags" */
export type Tags_Mutation_Response = {
  __typename?: 'tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tags>;
};

/** input type for inserting object relation for remote table "tags" */
export type Tags_Obj_Rel_Insert_Input = {
  data: Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** on_conflict condition type for table "tags" */
export type Tags_On_Conflict = {
  constraint: Tags_Constraint;
  update_columns?: Array<Tags_Update_Column>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "tags". */
export type Tags_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_books_aggregate?: InputMaybe<Tag_Book_Aggregate_Order_By>;
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tags */
export type Tags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "tags" */
export enum Tags_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "tags" */
export type Tags_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Tags_Stddev_Fields = {
  __typename?: 'tags_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Tags_Stddev_Pop_Fields = {
  __typename?: 'tags_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Tags_Stddev_Samp_Fields = {
  __typename?: 'tags_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Tags_Sum_Fields = {
  __typename?: 'tags_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "tags" */
export enum Tags_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Text = 'text'
}

/** aggregate var_pop on columns */
export type Tags_Var_Pop_Fields = {
  __typename?: 'tags_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Tags_Var_Samp_Fields = {
  __typename?: 'tags_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Tags_Variance_Fields = {
  __typename?: 'tags_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "tsvector". All fields are combined with logical 'AND'. */
export type Tsvector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tsvector']>;
  _gt?: InputMaybe<Scalars['tsvector']>;
  _gte?: InputMaybe<Scalars['tsvector']>;
  _in?: InputMaybe<Array<Scalars['tsvector']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tsvector']>;
  _lte?: InputMaybe<Scalars['tsvector']>;
  _neq?: InputMaybe<Scalars['tsvector']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']>>;
};

/** columns and relationships of "unstructured_data" */
export type Unstructured_Data = {
  __typename?: 'unstructured_data';
  data: Scalars['jsonb'];
  title: Scalars['String'];
};


/** columns and relationships of "unstructured_data" */
export type Unstructured_DataDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "unstructured_data" */
export type Unstructured_Data_Aggregate = {
  __typename?: 'unstructured_data_aggregate';
  aggregate?: Maybe<Unstructured_Data_Aggregate_Fields>;
  nodes: Array<Unstructured_Data>;
};

/** aggregate fields of "unstructured_data" */
export type Unstructured_Data_Aggregate_Fields = {
  __typename?: 'unstructured_data_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Unstructured_Data_Max_Fields>;
  min?: Maybe<Unstructured_Data_Min_Fields>;
};


/** aggregate fields of "unstructured_data" */
export type Unstructured_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unstructured_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Unstructured_Data_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "unstructured_data". All fields are combined with a logical 'AND'. */
export type Unstructured_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Unstructured_Data_Bool_Exp>>;
  _not?: InputMaybe<Unstructured_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Unstructured_Data_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "unstructured_data" */
export enum Unstructured_Data_Constraint {
  /** unique or primary key constraint */
  UnstructuredDataPkey = 'unstructured_data_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Unstructured_Data_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Unstructured_Data_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Unstructured_Data_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "unstructured_data" */
export type Unstructured_Data_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Unstructured_Data_Max_Fields = {
  __typename?: 'unstructured_data_max_fields';
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Unstructured_Data_Min_Fields = {
  __typename?: 'unstructured_data_min_fields';
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "unstructured_data" */
export type Unstructured_Data_Mutation_Response = {
  __typename?: 'unstructured_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unstructured_Data>;
};

/** on_conflict condition type for table "unstructured_data" */
export type Unstructured_Data_On_Conflict = {
  constraint: Unstructured_Data_Constraint;
  update_columns?: Array<Unstructured_Data_Update_Column>;
  where?: InputMaybe<Unstructured_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "unstructured_data". */
export type Unstructured_Data_Order_By = {
  data?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unstructured_data */
export type Unstructured_Data_Pk_Columns_Input = {
  title: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Unstructured_Data_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "unstructured_data" */
export enum Unstructured_Data_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "unstructured_data" */
export type Unstructured_Data_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
};

/** update columns of table "unstructured_data" */
export enum Unstructured_Data_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Title = 'title'
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "vouchers" */
export type Vouchers = {
  __typename?: 'vouchers';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  event_tickets: Array<Event_Tickets>;
  /** An aggregate relationship */
  event_tickets_aggregate: Event_Tickets_Aggregate;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['String'];
  initial_amount: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  /** An object relationship */
  order?: Maybe<Orders>;
  order_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  order_vouchers: Array<Order_Voucher>;
  /** An aggregate relationship */
  order_vouchers_aggregate: Order_Voucher_Aggregate;
  recipient?: Maybe<Scalars['String']>;
  remaining_amount?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "vouchers" */
export type VouchersEvent_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


/** columns and relationships of "vouchers" */
export type VouchersEvent_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Tickets_Order_By>>;
  where?: InputMaybe<Event_Tickets_Bool_Exp>;
};


/** columns and relationships of "vouchers" */
export type VouchersOrder_VouchersArgs = {
  distinct_on?: InputMaybe<Array<Order_Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Voucher_Order_By>>;
  where?: InputMaybe<Order_Voucher_Bool_Exp>;
};


/** columns and relationships of "vouchers" */
export type VouchersOrder_Vouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Voucher_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Voucher_Order_By>>;
  where?: InputMaybe<Order_Voucher_Bool_Exp>;
};

/** aggregated selection of "vouchers" */
export type Vouchers_Aggregate = {
  __typename?: 'vouchers_aggregate';
  aggregate?: Maybe<Vouchers_Aggregate_Fields>;
  nodes: Array<Vouchers>;
};

/** aggregate fields of "vouchers" */
export type Vouchers_Aggregate_Fields = {
  __typename?: 'vouchers_aggregate_fields';
  avg?: Maybe<Vouchers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Vouchers_Max_Fields>;
  min?: Maybe<Vouchers_Min_Fields>;
  stddev?: Maybe<Vouchers_Stddev_Fields>;
  stddev_pop?: Maybe<Vouchers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vouchers_Stddev_Samp_Fields>;
  sum?: Maybe<Vouchers_Sum_Fields>;
  var_pop?: Maybe<Vouchers_Var_Pop_Fields>;
  var_samp?: Maybe<Vouchers_Var_Samp_Fields>;
  variance?: Maybe<Vouchers_Variance_Fields>;
};


/** aggregate fields of "vouchers" */
export type Vouchers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vouchers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vouchers" */
export type Vouchers_Aggregate_Order_By = {
  avg?: InputMaybe<Vouchers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vouchers_Max_Order_By>;
  min?: InputMaybe<Vouchers_Min_Order_By>;
  stddev?: InputMaybe<Vouchers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vouchers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vouchers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vouchers_Sum_Order_By>;
  var_pop?: InputMaybe<Vouchers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vouchers_Var_Samp_Order_By>;
  variance?: InputMaybe<Vouchers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vouchers" */
export type Vouchers_Arr_Rel_Insert_Input = {
  data: Array<Vouchers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vouchers_On_Conflict>;
};

/** aggregate avg on columns */
export type Vouchers_Avg_Fields = {
  __typename?: 'vouchers_avg_fields';
  initial_amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vouchers" */
export type Vouchers_Avg_Order_By = {
  initial_amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vouchers". All fields are combined with a logical 'AND'. */
export type Vouchers_Bool_Exp = {
  _and?: InputMaybe<Array<Vouchers_Bool_Exp>>;
  _not?: InputMaybe<Vouchers_Bool_Exp>;
  _or?: InputMaybe<Array<Vouchers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_tickets?: InputMaybe<Event_Tickets_Bool_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  initial_amount?: InputMaybe<Int_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Bigint_Comparison_Exp>;
  order_vouchers?: InputMaybe<Order_Voucher_Bool_Exp>;
  recipient?: InputMaybe<String_Comparison_Exp>;
  remaining_amount?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "vouchers" */
export enum Vouchers_Constraint {
  /** unique or primary key constraint */
  VouchersPkey = 'vouchers_pkey'
}

/** input type for incrementing numeric columns in table "vouchers" */
export type Vouchers_Inc_Input = {
  initial_amount?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['bigint']>;
  remaining_amount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vouchers" */
export type Vouchers_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_tickets?: InputMaybe<Event_Tickets_Arr_Rel_Insert_Input>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  initial_amount?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['bigint']>;
  order_vouchers?: InputMaybe<Order_Voucher_Arr_Rel_Insert_Input>;
  recipient?: InputMaybe<Scalars['String']>;
  remaining_amount?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Vouchers_Max_Fields = {
  __typename?: 'vouchers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  initial_amount?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['bigint']>;
  recipient?: Maybe<Scalars['String']>;
  remaining_amount?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "vouchers" */
export type Vouchers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_amount?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vouchers_Min_Fields = {
  __typename?: 'vouchers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  initial_amount?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['bigint']>;
  recipient?: Maybe<Scalars['String']>;
  remaining_amount?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "vouchers" */
export type Vouchers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_amount?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  recipient?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vouchers" */
export type Vouchers_Mutation_Response = {
  __typename?: 'vouchers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Vouchers>;
};

/** input type for inserting object relation for remote table "vouchers" */
export type Vouchers_Obj_Rel_Insert_Input = {
  data: Vouchers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vouchers_On_Conflict>;
};

/** on_conflict condition type for table "vouchers" */
export type Vouchers_On_Conflict = {
  constraint: Vouchers_Constraint;
  update_columns?: Array<Vouchers_Update_Column>;
  where?: InputMaybe<Vouchers_Bool_Exp>;
};

/** Ordering options when selecting data from "vouchers". */
export type Vouchers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_tickets_aggregate?: InputMaybe<Event_Tickets_Aggregate_Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_amount?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  order_vouchers_aggregate?: InputMaybe<Order_Voucher_Aggregate_Order_By>;
  recipient?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vouchers */
export type Vouchers_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "vouchers" */
export enum Vouchers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  InitialAmount = 'initial_amount',
  /** column name */
  Message = 'message',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  RemainingAmount = 'remaining_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "vouchers" */
export type Vouchers_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  initial_amount?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['bigint']>;
  recipient?: InputMaybe<Scalars['String']>;
  remaining_amount?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Vouchers_Stddev_Fields = {
  __typename?: 'vouchers_stddev_fields';
  initial_amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vouchers" */
export type Vouchers_Stddev_Order_By = {
  initial_amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vouchers_Stddev_Pop_Fields = {
  __typename?: 'vouchers_stddev_pop_fields';
  initial_amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vouchers" */
export type Vouchers_Stddev_Pop_Order_By = {
  initial_amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vouchers_Stddev_Samp_Fields = {
  __typename?: 'vouchers_stddev_samp_fields';
  initial_amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vouchers" */
export type Vouchers_Stddev_Samp_Order_By = {
  initial_amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Vouchers_Sum_Fields = {
  __typename?: 'vouchers_sum_fields';
  initial_amount?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['bigint']>;
  remaining_amount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vouchers" */
export type Vouchers_Sum_Order_By = {
  initial_amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
};

/** update columns of table "vouchers" */
export enum Vouchers_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  InitialAmount = 'initial_amount',
  /** column name */
  Message = 'message',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  RemainingAmount = 'remaining_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Vouchers_Var_Pop_Fields = {
  __typename?: 'vouchers_var_pop_fields';
  initial_amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vouchers" */
export type Vouchers_Var_Pop_Order_By = {
  initial_amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vouchers_Var_Samp_Fields = {
  __typename?: 'vouchers_var_samp_fields';
  initial_amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vouchers" */
export type Vouchers_Var_Samp_Order_By = {
  initial_amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vouchers_Variance_Fields = {
  __typename?: 'vouchers_variance_fields';
  initial_amount?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vouchers" */
export type Vouchers_Variance_Order_By = {
  initial_amount?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
};

export type CreateDispatchEventMutationVariables = Exact<{
  data: Subscription_Dispatch_Insert_Input;
}>;


export type CreateDispatchEventMutation = { __typename?: 'mutation_root', insert_subscription_dispatch_one?: { __typename?: 'subscription_dispatch', id: any } | null };

export type FulfillDigitalContentMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type FulfillDigitalContentMutation = { __typename?: 'mutation_root', update_subscription_dispatch_by_pk?: { __typename?: 'subscription_dispatch', id: any, has_dispatched_digital: boolean } | null };

export type GetActiveSubsForNewDispatchEventQueryVariables = Exact<{
  subId: Scalars['uuid'];
}>;


export type GetActiveSubsForNewDispatchEventQuery = { __typename?: 'query_root', subscriptions_by_pk?: { __typename?: 'subscriptions', id: any, title: string, slug: string, subscription_objects: Array<{ __typename?: 'subscription_object', id: any, remaining_credits?: any | null, recipient: string, dispatches: Array<{ __typename?: 'subscription_dispatch_subscription_object', dispatch_id: any, created_at: any }>, address?: { __typename?: 'addresses', name: string, contact_email: string, phone_number?: string | null, line_1?: string | null, line_2?: string | null, line_3?: string | null, city?: string | null, region?: string | null, code?: string | null, country_code?: string | null } | null }> } | null };

export type GetDispatchEventQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetDispatchEventQuery = { __typename?: 'query_root', subscription_dispatch_by_pk?: { __typename?: 'subscription_dispatch', id: any, subscription_id: any, has_dispatched_digital: boolean, created_at: any, subscription: { __typename?: 'subscriptions', title: string }, subscription_objects: Array<{ __typename?: 'subscription_dispatch_subscription_object', created_at: any, subscription_object: { __typename?: 'subscription_object', id: any, recipient: string, remaining_credits?: any | null, address?: { __typename?: 'addresses', name: string, contact_email: string, phone_number?: string | null, line_1?: string | null, line_2?: string | null, line_3?: string | null, city?: string | null, region?: string | null, code?: string | null, country_code?: string | null } | null } }> } | null };

export type SaveNoteForDispatchEventMutationVariables = Exact<{
  dId: Scalars['uuid'];
  note: Scalars['String'];
}>;


export type SaveNoteForDispatchEventMutation = { __typename?: 'mutation_root', update_subscription_dispatch_by_pk?: { __typename?: 'subscription_dispatch', id: any, note: string } | null };

export type GetSubscriptionObjectForCmsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetSubscriptionObjectForCmsQuery = { __typename?: 'query_root', subscription_object_by_pk?: { __typename?: 'subscription_object', id: any, recipient: string, remaining_credits?: any | null, stripe_sub_id?: string | null, created_at?: any | null, password: string, short_id: string, is_active: boolean, subscription: { __typename?: 'subscriptions', id: any, title: string }, address?: { __typename?: 'addresses', name: string, contact_email: string, phone_number?: string | null, line_1?: string | null, line_2?: string | null, line_3?: string | null, city?: string | null, region?: string | null, code?: string | null, country_code?: string | null } | null, dispatches: Array<{ __typename?: 'subscription_dispatch_subscription_object', subscription_dispatch: { __typename?: 'subscription_dispatch', id: any, created_at: any } }>, credits_aggregate: { __typename?: 'subscription_object_credit_aggregate', aggregate?: { __typename?: 'subscription_object_credit_aggregate_fields', count: number } | null } } | null };

export type GetEmptySearchesQueryVariables = Exact<{
  date?: InputMaybe<Scalars['timestamptz']>;
}>;


export type GetEmptySearchesQuery = { __typename?: 'query_root', empty_searches: Array<{ __typename?: 'empty_searches', id: any, string: string }> };

export type GetJarAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJarAmountQuery = { __typename?: 'query_root', pif_donations_aggregate: { __typename?: 'pif_donations_aggregate', aggregate?: { __typename?: 'pif_donations_aggregate_fields', sum?: { __typename?: 'pif_donations_sum_fields', amount?: number | null } | null } | null } };

export type WithdrawFromJarMutationVariables = Exact<{
  amount?: InputMaybe<Scalars['Int']>;
}>;


export type WithdrawFromJarMutation = { __typename?: 'mutation_root', insert_pif_donations_one?: { __typename?: 'pif_donations', id: number } | null };

export type GetTotalOrdersQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['timestamptz']>;
}>;


export type GetTotalOrdersQuery = { __typename?: 'query_root', orders_aggregate: { __typename?: 'orders_aggregate', aggregate?: { __typename?: 'orders_aggregate_fields', count: number } | null }, order_book_aggregate: { __typename?: 'order_book_aggregate', aggregate?: { __typename?: 'order_book_aggregate_fields', sum?: { __typename?: 'order_book_sum_fields', quantity?: number | null } | null } | null } };

export type RemoveAttendeeMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type RemoveAttendeeMutation = { __typename?: 'mutation_root', update_event_tickets_by_pk?: { __typename?: 'event_tickets', id: any, is_attending: boolean } | null };

export type ManuallyAddAttendeeMutationVariables = Exact<{
  data: Event_Tickets_Insert_Input;
}>;


export type ManuallyAddAttendeeMutation = { __typename?: 'mutation_root', insert_event_tickets_one?: { __typename?: 'event_tickets', id: any } | null };

export type RedeemAllVouchersMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type RedeemAllVouchersMutation = { __typename?: 'mutation_root', update_vouchers?: { __typename?: 'vouchers_mutation_response', affected_rows: number } | null };

export type GetAllBooksellersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBooksellersQuery = { __typename?: 'query_root', booksellers: Array<{ __typename?: 'booksellers', id: number, name: string, avatar?: string | null, video_url?: string | null }> };

export type UpdateBooksellerMutationVariables = Exact<{
  data?: InputMaybe<Booksellers_Set_Input>;
  id: Scalars['Int'];
}>;


export type UpdateBooksellerMutation = { __typename?: 'mutation_root', update_booksellers_by_pk?: { __typename?: 'booksellers', id: number, avatar?: string | null, name: string, video_url?: string | null } | null };

export type RemoveBooksellerMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveBooksellerMutation = { __typename?: 'mutation_root', delete_booksellers_by_pk?: { __typename?: 'booksellers', id: number } | null };

export type NewBooksellerMutationVariables = Exact<{
  data: Booksellers_Insert_Input;
}>;


export type NewBooksellerMutation = { __typename?: 'mutation_root', insert_booksellers_one?: { __typename?: 'booksellers', id: number } | null };

export type GetAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAlertsQuery = { __typename?: 'query_root', unstructured_data_by_pk?: { __typename?: 'unstructured_data', data: any, title: string } | null };

export type AddAlertMutationVariables = Exact<{
  data?: InputMaybe<Scalars['jsonb']>;
}>;


export type AddAlertMutation = { __typename?: 'mutation_root', update_unstructured_data_by_pk?: { __typename?: 'unstructured_data', data: any } | null };

export type GetShopDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopDetailsQuery = { __typename?: 'query_root', unstructured_data: Array<{ __typename?: 'unstructured_data', title: string, data: any }>, booksellers: Array<{ __typename?: 'booksellers', id: number, name: string, about?: string | null }> };

export type UpdateUnstructuredDataMutationVariables = Exact<{
  title: Scalars['String'];
  data?: InputMaybe<Scalars['jsonb']>;
}>;


export type UpdateUnstructuredDataMutation = { __typename?: 'mutation_root', update_unstructured_data_by_pk?: { __typename?: 'unstructured_data', title: string } | null };

export type GetWrapppingPriceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWrapppingPriceQuery = { __typename?: 'query_root', unstructured_data_by_pk?: { __typename?: 'unstructured_data', title: string, data: any } | null };

export type SetWrappingPriceMutationVariables = Exact<{
  data?: InputMaybe<Scalars['jsonb']>;
}>;


export type SetWrappingPriceMutation = { __typename?: 'mutation_root', update_unstructured_data_by_pk?: { __typename?: 'unstructured_data', title: string, data: any } | null };

export type GetUnstructuredDataQueryVariables = Exact<{
  title: Scalars['String'];
}>;


export type GetUnstructuredDataQuery = { __typename?: 'query_root', unstructured_data_by_pk?: { __typename?: 'unstructured_data', title: string, data: any } | null };

export type GetShippingBlockDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShippingBlockDataQuery = { __typename?: 'query_root', countries: Array<{ __typename?: 'countries', name: string, code: string, shipping_options: Array<{ __typename: 'shipping_options', id: any, name: string, price: number, from: number, to?: number | null, description?: string | null }> }>, regions: Array<{ __typename?: 'regions', name: string, code: string, shipping_options: Array<{ __typename?: 'shipping_options', id: any, name: string, price: number, from: number, to?: number | null, description?: string | null }> }> };

export type GetAllCountriesAndRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCountriesAndRegionsQuery = { __typename?: 'query_root', regions: Array<{ __typename?: 'regions', name: string, code: string }>, countries: Array<{ __typename?: 'countries', name: string, code: string }> };

export type SaveNewShippingOptionMutationVariables = Exact<{
  shippingOption: Shipping_Options_Insert_Input;
}>;


export type SaveNewShippingOptionMutation = { __typename?: 'mutation_root', insert_shipping_options_one?: { __typename: 'shipping_options', id: any, description?: string | null, from: number, to?: number | null, price: number, region?: string | null, country?: string | null } | null };

export type DeleteShippingOptionMutationVariables = Exact<{
  id: Scalars['uuid'];
  today: Scalars['timestamptz'];
}>;


export type DeleteShippingOptionMutation = { __typename?: 'mutation_root', update_shipping_options_by_pk?: { __typename?: 'shipping_options', id: any } | null };

export type AdminAddSubPriceMutationVariables = Exact<{
  sub: Subscription_Price_Insert_Input;
}>;


export type AdminAddSubPriceMutation = { __typename?: 'mutation_root', insert_subscription_price_one?: { __typename?: 'subscription_price', id: any } | null };

export type AdminCreateSubMutationVariables = Exact<{
  sub: Subscriptions_Insert_Input;
}>;


export type AdminCreateSubMutation = { __typename?: 'mutation_root', insert_subscriptions_one?: { __typename?: 'subscriptions', id: any } | null };

export type AdminDeleteSubPriceMutationVariables = Exact<{
  subId: Scalars['uuid'];
  priceId: Scalars['uuid'];
}>;


export type AdminDeleteSubPriceMutation = { __typename?: 'mutation_root', update_subscription_price_by_pk?: { __typename?: 'subscription_price', id: any } | null };

export type AdminGetAllSubsQueryVariables = Exact<{
  conditions?: InputMaybe<Subscriptions_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type AdminGetAllSubsQuery = { __typename?: 'query_root', subscriptions: Array<{ __typename?: 'subscriptions', id: any, title: string, is_active: boolean, subscription_objects_aggregate: { __typename?: 'subscription_object_aggregate', aggregate?: { __typename?: 'subscription_object_aggregate_fields', count: number } | null } }>, subscriptions_aggregate: { __typename?: 'subscriptions_aggregate', aggregate?: { __typename?: 'subscriptions_aggregate_fields', count: number } | null } };

export type AdminGetSubQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type AdminGetSubQuery = { __typename?: 'query_root', subscriptions_by_pk?: { __typename?: 'subscriptions', id: any, title: string, description: string, image: string, slug: string, is_active: boolean, price: number, note: string } | null };

export type AdminGetSubPricesQueryVariables = Exact<{
  subId: Scalars['uuid'];
}>;


export type AdminGetSubPricesQuery = { __typename?: 'query_root', subscription_price: Array<{ __typename?: 'subscription_price', id: any, title: string, duration: number, price: number, sub_id: any, order_subscription_prices: Array<{ __typename?: 'order_subscription_price', sub_price_id: any, order_id: number, total_dispatched: number, last_dispatched_date?: any | null, subscription_price: { __typename?: 'subscription_price', id: any, duration: number }, address?: { __typename?: 'addresses', name: string, contact_email: string, phone_number?: string | null, line_1?: string | null, line_2?: string | null, line_3?: string | null, region?: string | null, city?: string | null, country_code?: string | null, code?: string | null } | null }> }> };

export type AdminUpdateSubMutationVariables = Exact<{
  id: Scalars['uuid'];
  sub?: InputMaybe<Subscriptions_Set_Input>;
}>;


export type AdminUpdateSubMutation = { __typename?: 'mutation_root', update_subscriptions_by_pk?: { __typename?: 'subscriptions', id: any } | null };

export type AdminUpdateSubPriceMutationVariables = Exact<{
  subId: Scalars['uuid'];
  priceId: Scalars['uuid'];
  sub?: InputMaybe<Subscription_Price_Set_Input>;
}>;


export type AdminUpdateSubPriceMutation = { __typename?: 'mutation_root', update_subscription_price_by_pk?: { __typename?: 'subscription_price', id: any } | null };

export type GetSubscriptionDispatchEventsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetSubscriptionDispatchEventsQuery = { __typename?: 'query_root', subscription_dispatch: Array<{ __typename?: 'subscription_dispatch', created_at: any, id: any, subscription_objects_aggregate: { __typename?: 'subscription_dispatch_subscription_object_aggregate', aggregate?: { __typename?: 'subscription_dispatch_subscription_object_aggregate_fields', count: number } | null } }> };

export type AddNewSubscriberMutationVariables = Exact<{
  data: Subscription_Object_Insert_Input;
}>;


export type AddNewSubscriberMutation = { __typename?: 'mutation_root', insert_subscription_object_one?: { __typename?: 'subscription_object', id: any } | null };

export type GetSubscriberStatsQueryVariables = Exact<{
  subId: Scalars['uuid'];
}>;


export type GetSubscriberStatsQuery = { __typename?: 'query_root', subscriptions_by_pk?: { __typename?: 'subscriptions', subscription_dispatches_aggregate: { __typename?: 'subscription_dispatch_aggregate', aggregate?: { __typename?: 'subscription_dispatch_aggregate_fields', count: number } | null }, allTimeTotal: { __typename?: 'subscription_object_aggregate', aggregate?: { __typename?: 'subscription_object_aggregate_fields', count: number } | null }, activeTotal: { __typename?: 'subscription_object_aggregate', aggregate?: { __typename?: 'subscription_object_aggregate_fields', count: number } | null }, subscription_objects: Array<{ __typename?: 'subscription_object', id: any, recipient: string, remaining_credits?: any | null, is_active: boolean, address?: { __typename?: 'addresses', name: string, contact_email: string, phone_number?: string | null, line_1?: string | null, line_2?: string | null, line_3?: string | null, city?: string | null, region?: string | null, code?: string | null } | null, dispatches_aggregate: { __typename?: 'subscription_dispatch_subscription_object_aggregate', aggregate?: { __typename?: 'subscription_dispatch_subscription_object_aggregate_fields', count: number } | null }, dispatches: Array<{ __typename?: 'subscription_dispatch_subscription_object', subscription_dispatch: { __typename?: 'subscription_dispatch', id: any, created_at: any } }> }> } | null };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTagMutation = { __typename?: 'mutation_root', delete_tags_by_pk?: { __typename?: 'tags', id: number } | null };

export type EditTagNameMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
}>;


export type EditTagNameMutation = { __typename?: 'mutation_root', update_tags_by_pk?: { __typename?: 'tags', id: number } | null };

export type GetVoucherReportQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['timestamptz']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
}>;


export type GetVoucherReportQuery = { __typename?: 'query_root', vouchers: Array<{ __typename?: 'vouchers', initial_amount: number, created_at?: any | null }> };

export type GetAddressForAccountQueryVariables = Exact<{
  uuid: Scalars['uuid'];
}>;


export type GetAddressForAccountQuery = { __typename?: 'query_root', accounts_by_pk?: { __typename?: 'accounts', id: any, primary_address?: { __typename?: 'addresses', id: any, line_1?: string | null, line_2?: string | null, line_3?: string | null, region?: string | null, city?: string | null, code?: string | null, account_id?: any | null, phone_number?: string | null, contact_email: string, name: string, country?: { __typename?: 'countries', code: string, name: string } | null } | null, addresses: Array<{ __typename?: 'addresses', id: any, line_1?: string | null, line_2?: string | null, line_3?: string | null, region?: string | null, phone_number?: string | null, city?: string | null, code?: string | null, account_id?: any | null, contact_email: string, name: string, country?: { __typename?: 'countries', code: string, name: string } | null }> } | null };

export type BookCardDataFragment = { __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } };

export type GetTagsForCategoryQueryVariables = Exact<{
  name?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetTagsForCategoryQuery = { __typename?: 'query_root', tags_aggregate: { __typename?: 'tags_aggregate', aggregate?: { __typename?: 'tags_aggregate_fields', count: number } | null, nodes: Array<{ __typename?: 'tags', id: number, text: string, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } }> } };

export type GetBookCardDataQueryVariables = Exact<{
  isbn: Scalars['bigint'];
}>;


export type GetBookCardDataQuery = { __typename?: 'query_root', books_by_pk?: { __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } } | null };

export type EventCardDataFragment = { __typename?: 'events', start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteCommentMutation = { __typename?: 'mutation_root', delete_event_comment_by_pk?: { __typename?: 'event_comment', id: any } | null };

export type MarkCommentAsQuestionMutationVariables = Exact<{
  id: Scalars['bigint'];
  isQuestion?: InputMaybe<Scalars['Boolean']>;
}>;


export type MarkCommentAsQuestionMutation = { __typename?: 'mutation_root', update_event_comment_by_pk?: { __typename?: 'event_comment', id: any, comment: string, is_question: boolean, public_account?: { __typename?: 'public_account_details', id?: any | null, display_name?: string | null } | null } | null };

export type GetEventCommentsQueryVariables = Exact<{
  eventId: Scalars['uuid'];
}>;


export type GetEventCommentsQuery = { __typename?: 'query_root', event_comment: Array<{ __typename?: 'event_comment', id: any, comment: string, is_question: boolean, public_account?: { __typename?: 'public_account_details', id?: any | null, display_name?: string | null } | null }> };

export type InsertCommentMutationVariables = Exact<{
  comment: Scalars['String'];
  eventId: Scalars['uuid'];
}>;


export type InsertCommentMutation = { __typename?: 'mutation_root', insert_event_comment_one?: { __typename?: 'event_comment', id: any, comment: string, is_question: boolean, public_account?: { __typename?: 'public_account_details', id?: any | null, display_name?: string | null } | null } | null };

export type ToggleEventCommentsMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  commentsEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type ToggleEventCommentsMutation = { __typename?: 'mutation_root', update_events_by_pk?: { __typename?: 'events', id: any, enable_comments: boolean } | null };

export type SearchBooksForSelectorQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchBooksForSelectorQuery = { __typename?: 'query_root', search_books: Array<{ __typename?: 'books', title: string, isbn: any, author?: string | null, price?: number | null }> };

export type GetAuthorsForSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthorsForSelectorQuery = { __typename?: 'query_root', booksellers: Array<{ __typename?: 'booksellers', id: number, name: string }> };

export type SearchCategoriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchCategoriesQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'categories', name: string }> };

export type GetPossibleShippingDestinationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPossibleShippingDestinationsQuery = { __typename?: 'query_root', regions: Array<{ __typename: 'regions', code: string, name: string, countries: Array<{ __typename: 'countries', code: string, name: string }> }> };

export type SearchEventsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', slug: string, title: string, id: any, start_time: any }> };

export type SearchFestivalsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchFestivalsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', title: string, id: any, start_time: any }> };

export type SearchPostsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchPostsQuery = { __typename?: 'query_root', posts: Array<{ __typename?: 'posts', slug: string, title: string, id: any }> };

export type SearchProductsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchProductsQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'products', id: any, title: string, price: number }> };

export type GetShippingOptionsForCountryQueryVariables = Exact<{
  country: Scalars['String'];
  shippableItems: Scalars['Int'];
}>;


export type GetShippingOptionsForCountryQuery = { __typename?: 'query_root', shipping_options: Array<{ __typename?: 'shipping_options', id: any, name: string, description?: string | null, region?: string | null, country?: string | null, price: number }> };

export type SearchTagsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchTagsQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'tags', id: number, text: string }> };

export type AddTagMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
}>;


export type AddTagMutation = { __typename?: 'mutation_root', insert_tags_one?: { __typename?: 'tags', text: string, id: number } | null };

export type ToggleActivateSubscriptionMutationVariables = Exact<{
  id: Scalars['uuid'];
  date?: InputMaybe<Scalars['date']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type ToggleActivateSubscriptionMutation = { __typename?: 'mutation_root', update_subscription_object_by_pk?: { __typename?: 'subscription_object', id: any } | null };

export type CreateAddressForSubMutationVariables = Exact<{
  address: Addresses_Insert_Input;
}>;


export type CreateAddressForSubMutation = { __typename?: 'mutation_root', insert_addresses_one?: { __typename?: 'addresses', id: any, name: string, line_1?: string | null, line_2?: string | null, line_3?: string | null, region?: string | null, city?: string | null, code?: string | null, country_code?: string | null, phone_number?: string | null, contact_email: string } | null };

export type GetAddressForSubManagementQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAddressForSubManagementQuery = { __typename?: 'query_root', subscription_object_by_pk?: { __typename?: 'subscription_object', address?: { __typename?: 'addresses', id: any, name: string, line_1?: string | null, line_2?: string | null, line_3?: string | null, region?: string | null, city?: string | null, code?: string | null, country_code?: string | null, phone_number?: string | null, contact_email: string } | null } | null };

export type GetSubForManagementPageQueryVariables = Exact<{
  id: Scalars['String'];
  password: Scalars['String'];
}>;


export type GetSubForManagementPageQuery = { __typename?: 'query_root', subscription_object: Array<{ __typename?: 'subscription_object', id: any, is_active: boolean, recipient: string, remaining_credits?: any | null, date_activated?: any | null, message?: string | null, stripe_sub_id?: string | null, dispatches: Array<{ __typename?: 'subscription_dispatch_subscription_object', created_at: any }>, subscription: { __typename?: 'subscriptions', id: any, title: string, description: string, price: number } }>, unstructured_data_by_pk?: { __typename?: 'unstructured_data', data: any } | null };

export type InsertAddressForSubManagementMutationVariables = Exact<{
  id: Scalars['uuid'];
  address_id: Scalars['uuid'];
}>;


export type InsertAddressForSubManagementMutation = { __typename?: 'mutation_root', update_subscription_object_by_pk?: { __typename?: 'subscription_object', id: any, address_id?: any | null } | null };

export type UpdateAddressForSubManagementMutationVariables = Exact<{
  address_id: Scalars['uuid'];
  addressObject?: InputMaybe<Addresses_Set_Input>;
}>;


export type UpdateAddressForSubManagementMutation = { __typename?: 'mutation_root', update_addresses_by_pk?: { __typename?: 'addresses', id: any, name: string, line_1?: string | null, line_2?: string | null, line_3?: string | null, region?: string | null, city?: string | null, code?: string | null, country_code?: string | null, phone_number?: string | null, contact_email: string } | null };

export type PostCardDataFragment = { __typename?: 'posts', id: any, slug: string, type: string, title: string, image?: string | null, post_books: Array<{ __typename?: 'post_book', book: { __typename?: 'books', image?: string | null } }> };

export type ProductCardDataFragment = { __typename?: 'products', id: any, image?: string | null, price: number, title: string, slug: string, stock?: number | null, is_discounted: boolean, discount_value?: number | null };

export type GetAllProductsForShopQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductsForShopQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'products', id: any, image?: string | null, price: number, title: string, slug: string, stock?: number | null, is_discounted: boolean, discount_value?: number | null }> };

export type GetAllSubsForShopQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSubsForShopQuery = { __typename?: 'query_root', subscriptions: Array<{ __typename?: 'subscriptions', id: any, slug: string, title: string, image: string }> };

export type GetPifAndVoucherQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPifAndVoucherQuery = { __typename?: 'query_root', pif?: { __typename?: 'unstructured_data', data: any } | null, vouchers?: { __typename?: 'unstructured_data', data: any } | null };

export type GetSubscriptionQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetSubscriptionQuery = { __typename?: 'query_root', subscriptions: Array<{ __typename?: 'subscriptions', id: any, slug: string, title: string, description: string, image: string, price: number }>, unstructured_data_by_pk?: { __typename?: 'unstructured_data', data: any } | null };

export type SubCardDataFragment = { __typename?: 'subscriptions', id: any, slug: string, title: string, image: string };

export type GetBooksellersAndPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBooksellersAndPostsQuery = { __typename?: 'query_root', booksellers: Array<{ __typename?: 'booksellers', id: number, name: string, avatar?: string | null, video_url?: string | null, about?: string | null, posts: Array<{ __typename?: 'posts', id: any, slug: string, type: string, title: string, image?: string | null, post_books: Array<{ __typename?: 'post_book', book: { __typename?: 'books', image?: string | null } }> }> }> };

export type GetAccountDetailsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAccountDetailsQuery = { __typename?: 'query_root', accounts_by_pk?: { __typename?: 'accounts', email: string, display_name?: string | null, phone_number?: string | null, addresses: Array<{ __typename?: 'addresses', id: any, name: string, contact_email: string, phone_number?: string | null, line_1?: string | null, line_2?: string | null, line_3?: string | null, region?: string | null, city?: string | null, code?: string | null, country?: { __typename?: 'countries', code: string, name: string } | null }>, primary_address?: { __typename?: 'addresses', id: any } | null } | null };

export type UpdateEmailMutationVariables = Exact<{
  id: Scalars['uuid'];
  email: Scalars['String'];
}>;


export type UpdateEmailMutation = { __typename?: 'mutation_root', update_accounts_by_pk?: { __typename?: 'accounts', id: any } | null };

export type UpdateDisplayNameMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
}>;


export type UpdateDisplayNameMutation = { __typename?: 'mutation_root', update_accounts_by_pk?: { __typename?: 'accounts', id: any } | null };

export type UpdatePrimaryAddressMutationVariables = Exact<{
  id: Scalars['uuid'];
  primaryAddress: Scalars['uuid'];
}>;


export type UpdatePrimaryAddressMutation = { __typename?: 'mutation_root', update_accounts_by_pk?: { __typename?: 'accounts', id: any } | null };

export type AddNewAddressMutationVariables = Exact<{
  address: Addresses_Insert_Input;
}>;


export type AddNewAddressMutation = { __typename?: 'mutation_root', insert_addresses_one?: { __typename?: 'addresses', id: any } | null };

export type UnlinkAddressMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UnlinkAddressMutation = { __typename?: 'mutation_root', update_addresses_by_pk?: { __typename?: 'addresses', id: any } | null };

export type GetBookQueryVariables = Exact<{
  isbn: Scalars['bigint'];
}>;


export type GetBookQuery = { __typename?: 'query_root', books_by_pk?: { __typename?: 'books', isbn: any, title: string, author?: string | null, description?: string | null, price?: number | null, stock?: number | null, track_stock: boolean, image?: string | null, attributes?: string | null, discount_value?: number | null, is_discounted: boolean, is_unlisted: boolean, category_books: Array<{ __typename?: 'category_book', category: { __typename?: 'categories', name: string, slug?: string | null } }>, tag_books: Array<{ __typename?: 'tag_book', tag: { __typename?: 'tags', id: number, text: string } }> } | null };

export type UpdateBookMutationVariables = Exact<{
  isbn: Scalars['bigint'];
  data: Books_Set_Input;
  tags: Array<Tag_Book_Insert_Input> | Tag_Book_Insert_Input;
  categories: Array<Category_Book_Insert_Input> | Category_Book_Insert_Input;
}>;


export type UpdateBookMutation = { __typename?: 'mutation_root', update_books_by_pk?: { __typename?: 'books', isbn: any } | null, delete_tag_book?: { __typename?: 'tag_book_mutation_response', affected_rows: number } | null, insert_tag_book?: { __typename?: 'tag_book_mutation_response', affected_rows: number } | null, delete_category_book?: { __typename?: 'category_book_mutation_response', affected_rows: number } | null, insert_category_book?: { __typename?: 'category_book_mutation_response', affected_rows: number } | null };

export type UnlistBookMutationVariables = Exact<{
  isbn: Scalars['bigint'];
  unlist?: InputMaybe<Scalars['Boolean']>;
}>;


export type UnlistBookMutation = { __typename?: 'mutation_root', update_books_by_pk?: { __typename?: 'books', isbn: any } | null };

export type GetAllBooksForAdminPanelQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Books_Order_By> | Books_Order_By>;
  conditions?: InputMaybe<Books_Bool_Exp>;
}>;


export type GetAllBooksForAdminPanelQuery = { __typename?: 'query_root', books_aggregate: { __typename?: 'books_aggregate', aggregate?: { __typename?: 'books_aggregate_fields', count: number } | null }, books: Array<{ __typename?: 'books', isbn: any, title: string, author?: string | null, stock?: number | null, price?: number | null, created_at: any, is_unlisted: boolean, track_stock: boolean }> };

export type InsertNewBookMutationVariables = Exact<{
  data: Books_Insert_Input;
}>;


export type InsertNewBookMutation = { __typename?: 'mutation_root', insert_books_one?: { __typename?: 'books', isbn: any } | null };

export type GetCategoryForAdminQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetCategoryForAdminQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'categories', name: string, description?: string | null, slug?: string | null, category_books: Array<{ __typename?: 'category_book', book: { __typename?: 'books', title: string, isbn: any, author?: string | null } }>, rankedBooks: Array<{ __typename?: 'category_book', book: { __typename?: 'books', title: string, isbn: any, author?: string | null } }> }> };

export type UpdateCategoryMutationVariables = Exact<{
  data?: InputMaybe<Categories_Set_Input>;
  name: Scalars['String'];
}>;


export type UpdateCategoryMutation = { __typename?: 'mutation_root', update_categories_by_pk?: { __typename?: 'categories', name: string } | null };

export type UpdateCategoryBooksMutationVariables = Exact<{
  books: Array<Category_Book_Insert_Input> | Category_Book_Insert_Input;
  name: Scalars['String'];
}>;


export type UpdateCategoryBooksMutation = { __typename?: 'mutation_root', delete_category_book?: { __typename?: 'category_book_mutation_response', affected_rows: number } | null, insert_category_book?: { __typename?: 'category_book_mutation_response', affected_rows: number } | null };

export type CmsGetAllCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CmsGetAllCategoriesQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'categories', name: string, slug?: string | null, category_books_aggregate: { __typename?: 'category_book_aggregate', aggregate?: { __typename?: 'category_book_aggregate_fields', count: number } | null } }> };

export type GetDiscountDetailsQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetDiscountDetailsQuery = { __typename?: 'query_root', discounts_by_pk?: { __typename?: 'discounts', code: string, discount_value: number, created_at?: any | null, is_active: boolean, is_fixed_amount: boolean, limit_uses?: number | null, total_uses: number, discounted_books: Array<{ __typename?: 'book_discount', book: { __typename?: 'books', isbn: any, title: string, author?: string | null } }> } | null };

export type UpdateDiscountDetailsMutationVariables = Exact<{
  code: Scalars['String'];
  data?: InputMaybe<Discounts_Set_Input>;
  books: Array<Book_Discount_Insert_Input> | Book_Discount_Insert_Input;
}>;


export type UpdateDiscountDetailsMutation = { __typename?: 'mutation_root', update_discounts_by_pk?: { __typename?: 'discounts', code: string } | null, delete_book_discount?: { __typename?: 'book_discount_mutation_response', affected_rows: number } | null, insert_book_discount?: { __typename?: 'book_discount_mutation_response', affected_rows: number } | null };

export type GetDiscountCodesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  conditions?: InputMaybe<Discounts_Bool_Exp>;
}>;


export type GetDiscountCodesQuery = { __typename?: 'query_root', discounts_aggregate: { __typename?: 'discounts_aggregate', aggregate?: { __typename?: 'discounts_aggregate_fields', count: number } | null }, discounts: Array<{ __typename?: 'discounts', code: string, discount_value: number, is_fixed_amount: boolean, created_at?: any | null, is_active: boolean, orders_aggregate: { __typename?: 'orders_aggregate', aggregate?: { __typename?: 'orders_aggregate_fields', count: number } | null } }> };

export type ToggleCodeEnabledMutationVariables = Exact<{
  code: Scalars['String'];
  isActive: Scalars['Boolean'];
}>;


export type ToggleCodeEnabledMutation = { __typename?: 'mutation_root', update_discounts_by_pk?: { __typename?: 'discounts', code: string } | null };

export type CreateNewDiscountMutationVariables = Exact<{
  data: Discounts_Insert_Input;
}>;


export type CreateNewDiscountMutation = { __typename?: 'mutation_root', insert_discounts_one?: { __typename?: 'discounts', code: string } | null };

export type GetEventForAdminQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetEventForAdminQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', title: string, id: any, slug: string, notes?: string | null, description?: string | null, start_time: any, end_time: any, speakers?: string | null, image?: string | null, video?: string | null, location?: string | null, video_conf_location?: string | null, is_cancelled: boolean, price?: number | null, seats?: number | null, free_seats?: number | null, is_festival: boolean, is_online_only: boolean, is_in_person_only?: boolean | null, is_book_club: boolean, event_books: Array<{ __typename?: 'event_book', book: { __typename?: 'books', title: string, isbn: any, author?: string | null } }>, category_events: Array<{ __typename?: 'category_event', category: { __typename?: 'categories', name: string } }>, festival?: { __typename?: 'events', id: any, title: string, start_time: any } | null, attendees: Array<{ __typename?: 'event_tickets', id: any, is_online_viewer: boolean, is_free_attendee: boolean, address: { __typename?: 'addresses', name: string, contact_email: string }, voucher?: { __typename?: 'vouchers', remaining_amount?: number | null, id: string } | null, order_book?: { __typename?: 'order_book', id: any } | null }> }>, event_tickets: Array<{ __typename?: 'event_tickets', is_free_attendee: boolean, is_online_viewer: boolean, order_book_id?: any | null, voucher_id?: string | null }> };

export type UpdateEventMutationVariables = Exact<{
  data?: InputMaybe<Events_Set_Input>;
  id: Scalars['uuid'];
  books: Array<Event_Book_Insert_Input> | Event_Book_Insert_Input;
  categories: Array<Category_Event_Insert_Input> | Category_Event_Insert_Input;
}>;


export type UpdateEventMutation = { __typename?: 'mutation_root', update_events_by_pk?: { __typename?: 'events', slug: string } | null, delete_event_book?: { __typename?: 'event_book_mutation_response', affected_rows: number } | null, insert_event_book?: { __typename?: 'event_book_mutation_response', affected_rows: number } | null, delete_category_event?: { __typename?: 'category_event_mutation_response', affected_rows: number } | null, insert_category_event?: { __typename?: 'category_event_mutation_response', affected_rows: number } | null };

export type UpdateEventCancelledMutationVariables = Exact<{
  cancelled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
}>;


export type UpdateEventCancelledMutation = { __typename?: 'mutation_root', update_events_by_pk?: { __typename?: 'events', id: any } | null };

export type UpdateEventNoteMutationVariables = Exact<{
  eventId: Scalars['uuid'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type UpdateEventNoteMutation = { __typename?: 'mutation_root', update_events_by_pk?: { __typename?: 'events', id: any, notes?: string | null } | null };

export type GetEventsForAdminPanelQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  conditions?: InputMaybe<Events_Bool_Exp>;
}>;


export type GetEventsForAdminPanelQuery = { __typename?: 'query_root', events_aggregate: { __typename?: 'events_aggregate', aggregate?: { __typename?: 'events_aggregate_fields', count: number } | null }, events: Array<{ __typename?: 'events', id: any, start_time: any, end_time: any, title: string, slug: string, is_festival: boolean, festival_id?: any | null, is_book_club: boolean, attendees_aggregate: { __typename?: 'event_tickets_aggregate', aggregate?: { __typename?: 'event_tickets_aggregate_fields', count: number } | null } }> };

export type InsertNewEventMutationVariables = Exact<{
  data: Events_Insert_Input;
}>;


export type InsertNewEventMutation = { __typename?: 'mutation_root', insert_events_one?: { __typename?: 'events', slug: string } | null };

export type GetOrderForAdminQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetOrderForAdminQuery = { __typename?: 'query_root', orders_by_pk?: { __typename?: 'orders', id: number, status: Order_Status_Enum, wrapping: number, pick_up: boolean, date_created: any, date_ready?: any | null, date_fulfilled?: any | null, notes?: string | null, stripe_payment_id?: string | null, custom_line_price?: number | null, custom_line_title?: string | null, custom_line_status?: Order_Item_Status_Enum | null, custom_shipping_price?: number | null, customer_note?: string | null, refunds: Array<{ __typename?: 'refunds', id: any, amount: number, created_at: any }>, address: { __typename?: 'addresses', id: any, name: string, contact_email: string, phone_number?: string | null, line_1?: string | null, line_2?: string | null, line_3?: string | null, region?: string | null, city?: string | null, code?: string | null, country?: { __typename?: 'countries', name: string } | null }, shipping_option?: { __typename?: 'shipping_options', id: any, name: string, description?: string | null, price: number } | null, order_books: Array<{ __typename?: 'order_book', price: number, quantity: number, discount: number, status: Order_Item_Status_Enum, book: { __typename?: 'books', image?: string | null, isbn: any, title: string, author?: string | null }, event_tickets: Array<{ __typename?: 'event_tickets', event: { __typename?: 'events', title: string } }> }>, order_products: Array<{ __typename?: 'order_product', price: number, quantity: number, discount: number, status: Order_Item_Status_Enum, product: { __typename?: 'products', image?: string | null, id: any, title: string } }>, subscription_objects: Array<{ __typename?: 'subscription_object', id: any, recipient: string, subscription: { __typename?: 'subscriptions', id: any, title: string, price: number }, subscription_draft_object?: { __typename?: 'subscription_draft_object', id: any, credits?: number | null } | null }>, vouchers: Array<{ __typename?: 'vouchers', id: string, initial_amount: number }>, pif_donations: Array<{ __typename?: 'pif_donations', amount: number, id: number }>, order_vouchers_for_discount: Array<{ __typename?: 'order_voucher', voucher_id: string, amount_discounted: number }>, discount?: { __typename?: 'discounts', code: string, is_fixed_amount: boolean, discount_value: number, discounted_books: Array<{ __typename?: 'book_discount', book_isbn: any }> } | null, refunds_aggregate: { __typename?: 'refunds_aggregate', aggregate?: { __typename?: 'refunds_aggregate_fields', sum?: { __typename?: 'refunds_sum_fields', amount?: number | null } | null } | null } } | null };

export type UpdateOrderBookStatusMutationVariables = Exact<{
  isbn: Scalars['bigint'];
  orderId: Scalars['Int'];
  status?: InputMaybe<Order_Item_Status_Enum>;
  orderStatus?: InputMaybe<Order_Status_Enum>;
}>;


export type UpdateOrderBookStatusMutation = { __typename?: 'mutation_root', update_order_book_by_pk?: { __typename?: 'order_book', order_id: number, book_isbn: any } | null, update_orders_by_pk?: { __typename?: 'orders', id: number } | null };

export type UpdateOrderProductStatusMutationVariables = Exact<{
  prodId: Scalars['uuid'];
  orderId: Scalars['Int'];
  status?: InputMaybe<Order_Item_Status_Enum>;
  orderStatus?: InputMaybe<Order_Status_Enum>;
}>;


export type UpdateOrderProductStatusMutation = { __typename?: 'mutation_root', update_order_product_by_pk?: { __typename?: 'order_product', order_id: number, product_id: any } | null, update_orders_by_pk?: { __typename?: 'orders', id: number } | null };

export type UpdateOrderCustomItemStatusMutationVariables = Exact<{
  orderId: Scalars['Int'];
  status?: InputMaybe<Order_Item_Status_Enum>;
  orderStatus?: InputMaybe<Order_Status_Enum>;
}>;


export type UpdateOrderCustomItemStatusMutation = { __typename?: 'mutation_root', update_orders_by_pk?: { __typename?: 'orders', id: number } | null };

export type UpdateOrderStatusMutationVariables = Exact<{
  orderId: Scalars['Int'];
  orderStatus?: InputMaybe<Order_Status_Enum>;
  itemStatus?: InputMaybe<Order_Item_Status_Enum>;
  prodIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  isbns?: InputMaybe<Array<Scalars['bigint']> | Scalars['bigint']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrderStatusMutation = { __typename?: 'mutation_root', update_orders_by_pk?: { __typename?: 'orders', id: number } | null, update_order_product?: { __typename?: 'order_product_mutation_response', affected_rows: number } | null, update_order_book?: { __typename?: 'order_book_mutation_response', affected_rows: number } | null };

export type UpdateOrderNoteMutationVariables = Exact<{
  orderId: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrderNoteMutation = { __typename?: 'mutation_root', update_orders_by_pk?: { __typename?: 'orders', id: number, notes?: string | null } | null };

export type GetOrdersForAdminPanelQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  conditions?: InputMaybe<Orders_Bool_Exp>;
  orderBy?: InputMaybe<Array<Orders_Order_By> | Orders_Order_By>;
}>;


export type GetOrdersForAdminPanelQuery = { __typename?: 'query_root', orders_aggregate: { __typename?: 'orders_aggregate', aggregate?: { __typename?: 'orders_aggregate_fields', count: number } | null }, orders: Array<{ __typename?: 'orders', id: number, date_created: any, status: Order_Status_Enum, custom_line_price?: number | null, shipping_option?: { __typename?: 'shipping_options', name: string, price: number } | null, address: { __typename?: 'addresses', name: string }, order_books_aggregate: { __typename?: 'order_book_aggregate', aggregate?: { __typename?: 'order_book_aggregate_fields', count: number } | null }, order_books: Array<{ __typename?: 'order_book', price: number, discount: number, quantity: number, book_isbn: any }>, subscription_objects: Array<{ __typename?: 'subscription_object', id: any, subscription: { __typename?: 'subscriptions', id: any, price: number }, subscription_draft_object?: { __typename?: 'subscription_draft_object', credits?: number | null } | null }>, order_products: Array<{ __typename?: 'order_product', price: number, discount: number, quantity: number }>, vouchers: Array<{ __typename?: 'vouchers', initial_amount: number }>, pif_donations: Array<{ __typename?: 'pif_donations', amount: number }>, discount?: { __typename?: 'discounts', discount_value: number, is_fixed_amount: boolean, discounted_books: Array<{ __typename?: 'book_discount', book_isbn: any }> } | null, subscription_objects_aggregate: { __typename?: 'subscription_object_aggregate', aggregate?: { __typename?: 'subscription_object_aggregate_fields', count: number } | null }, order_vouchers_for_discount: Array<{ __typename?: 'order_voucher', voucher_id: string, amount_discounted: number }>, order_products_aggregate: { __typename?: 'order_product_aggregate', aggregate?: { __typename?: 'order_product_aggregate_fields', count: number } | null } }> };

export type GetPageContentQueryVariables = Exact<{
  title: Scalars['String'];
}>;


export type GetPageContentQuery = { __typename?: 'query_root', pages_by_pk?: { __typename?: 'pages', title: string, content: any } | null };

export type UpdatePageMutationVariables = Exact<{
  title: Scalars['String'];
  content?: InputMaybe<Scalars['jsonb']>;
}>;


export type UpdatePageMutation = { __typename?: 'mutation_root', update_pages_by_pk?: { __typename?: 'pages', title: string, content: any } | null };

export type GetAllPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPagesQuery = { __typename?: 'query_root', pages: Array<{ __typename?: 'pages', title: string }> };

export type GetPostForAdminQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetPostForAdminQuery = { __typename?: 'query_root', posts: Array<{ __typename?: 'posts', id: any, title: string, created_at: any, slug: string, image?: string | null, content: string, type: string, author: { __typename?: 'booksellers', id: number, name: string }, category_posts: Array<{ __typename?: 'category_post', category: { __typename?: 'categories', name: string, slug?: string | null } }>, post_books: Array<{ __typename?: 'post_book', book: { __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } } }> }> };

export type UpdatePostMutationVariables = Exact<{
  data: Posts_Set_Input;
  id: Scalars['uuid'];
  categories: Array<Category_Post_Insert_Input> | Category_Post_Insert_Input;
  books: Array<Post_Book_Insert_Input> | Post_Book_Insert_Input;
}>;


export type UpdatePostMutation = { __typename?: 'mutation_root', update_posts_by_pk?: { __typename?: 'posts', id: any } | null, delete_category_post?: { __typename?: 'category_post_mutation_response', affected_rows: number } | null, delete_post_book?: { __typename?: 'post_book_mutation_response', affected_rows: number } | null, insert_category_post?: { __typename?: 'category_post_mutation_response', affected_rows: number } | null, insert_post_book?: { __typename?: 'post_book_mutation_response', affected_rows: number } | null };

export type DeletePostMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeletePostMutation = { __typename?: 'mutation_root', delete_posts_by_pk?: { __typename?: 'posts', id: any } | null };

export type GetPostsForAdminPanelQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPostsForAdminPanelQuery = { __typename?: 'query_root', posts_aggregate: { __typename?: 'posts_aggregate', aggregate?: { __typename?: 'posts_aggregate_fields', count: number } | null }, posts: Array<{ __typename?: 'posts', id: any, title: string, type: string, slug: string, created_at: any, author: { __typename?: 'booksellers', name: string } }> };

export type SavePostMutationVariables = Exact<{
  data: Posts_Insert_Input;
}>;


export type SavePostMutation = { __typename?: 'mutation_root', insert_posts_one?: { __typename?: 'posts', slug: string } | null };

export type GetProductForAdminQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetProductForAdminQuery = { __typename?: 'query_root', products_by_pk?: { __typename?: 'products', id: any, title: string, slug: string, description?: string | null, image?: string | null, stock?: number | null, price: number, duration_length?: number | null, duration_length_type?: string | null, is_discounted: boolean, is_deleted: boolean, discount_value?: number | null } | null };

export type UpdateProductMutationVariables = Exact<{
  data: Products_Set_Input;
  id: Scalars['uuid'];
}>;


export type UpdateProductMutation = { __typename?: 'mutation_root', update_products_by_pk?: { __typename?: 'products', id: any } | null };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['uuid'];
  shouldUnlist: Scalars['Boolean'];
}>;


export type DeleteProductMutation = { __typename?: 'mutation_root', update_products_by_pk?: { __typename?: 'products', id: any } | null };

export type GetAllProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  conditions?: InputMaybe<Products_Bool_Exp>;
}>;


export type GetAllProductsQuery = { __typename?: 'query_root', products_aggregate: { __typename?: 'products_aggregate', aggregate?: { __typename?: 'products_aggregate_fields', count: number } | null }, products: Array<{ __typename?: 'products', id: any, title: string, price: number, stock?: number | null }> };

export type InsertNewProductMutationVariables = Exact<{
  data: Products_Insert_Input;
}>;


export type InsertNewProductMutation = { __typename?: 'mutation_root', insert_products_one?: { __typename?: 'products', title: string, id: any, price: number } | null };

export type GetTagsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Tags_Order_By> | Tags_Order_By>;
}>;


export type GetTagsQuery = { __typename?: 'query_root', tags_aggregate: { __typename?: 'tags_aggregate', aggregate?: { __typename?: 'tags_aggregate_fields', count: number } | null }, tags: Array<{ __typename?: 'tags', id: number, text: string, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } }> };

export type GetVoucherQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetVoucherQuery = { __typename?: 'query_root', vouchers_by_pk?: { __typename?: 'vouchers', created_at?: any | null, id: string, recipient?: string | null, initial_amount: number, remaining_amount?: number | null, updated_at?: any | null, order_id?: any | null, event_tickets: Array<{ __typename?: 'event_tickets', is_online_viewer: boolean, event: { __typename?: 'events', title: string, slug: string } }> } | null };

export type UpdateVoucherMutationVariables = Exact<{
  data: Vouchers_Set_Input;
  id: Scalars['String'];
}>;


export type UpdateVoucherMutation = { __typename?: 'mutation_root', update_vouchers_by_pk?: { __typename?: 'vouchers', id: string } | null };

export type GetVouchersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  conditions: Vouchers_Bool_Exp;
}>;


export type GetVouchersQuery = { __typename?: 'query_root', vouchers_aggregate: { __typename?: 'vouchers_aggregate', aggregate?: { __typename?: 'vouchers_aggregate_fields', count: number } | null }, vouchers: Array<{ __typename?: 'vouchers', id: string, recipient?: string | null, initial_amount: number, remaining_amount?: number | null, created_at?: any | null }> };

export type InsertNewVoucherMutationVariables = Exact<{
  data: Vouchers_Insert_Input;
}>;


export type InsertNewVoucherMutation = { __typename?: 'mutation_root', insert_vouchers_one?: { __typename?: 'vouchers', id: string } | null };

export type ChangePasswordMutationVariables = Exact<{
  id: Scalars['uuid'];
  password: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'mutation_root', update_accounts_by_pk?: { __typename?: 'accounts', id: any } | null };

export type VerifyPasswordQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type VerifyPasswordQuery = { __typename?: 'query_root', accounts_by_pk?: { __typename?: 'accounts', password: string } | null };

export type GetExistingRefreshTokenQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetExistingRefreshTokenQuery = { __typename?: 'query_root', refresh_tokens_by_pk?: { __typename?: 'refresh_tokens', id: any, expires_at: any, account: { __typename?: 'accounts', id: any, email: string, display_name?: string | null, role: Roles_Enum } } | null };

export type ReplaceExistingRefreshTokenMutationVariables = Exact<{
  oldToken: Scalars['uuid'];
  accountId: Scalars['uuid'];
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type ReplaceExistingRefreshTokenMutation = { __typename?: 'mutation_root', delete_refresh_tokens_by_pk?: { __typename?: 'refresh_tokens', id: any } | null, insert_refresh_tokens_one?: { __typename?: 'refresh_tokens', id: any, expires_at: any } | null };

export type GetAccountWithPasswordQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type GetAccountWithPasswordQuery = { __typename?: 'query_root', accounts: Array<{ __typename?: 'accounts', id: any, password: string, display_name?: string | null, role: Roles_Enum, email: string, email_verified: boolean }> };

export type NewRefreshTokenMutationVariables = Exact<{
  id: Scalars['uuid'];
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type NewRefreshTokenMutation = { __typename?: 'mutation_root', insert_refresh_tokens_one?: { __typename?: 'refresh_tokens', id: any, expires_at: any } | null };

export type CreateAccountMutationVariables = Exact<{
  password: Scalars['String'];
  email: Scalars['String'];
  display_name: Scalars['String'];
}>;


export type CreateAccountMutation = { __typename?: 'mutation_root', insert_accounts_one?: { __typename?: 'accounts', id: any, display_name?: string | null, email: string, role: Roles_Enum } | null };

export type GetPreflightPasswordQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreflightPasswordQuery = { __typename?: 'query_root', unstructured_data_by_pk?: { __typename?: 'unstructured_data', password: any } | null };

export type GetRemainingTicketsQueryVariables = Exact<{
  event_id: Scalars['uuid'];
}>;


export type GetRemainingTicketsQuery = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', seats?: number | null, free_seats?: number | null, total_attendees: { __typename?: 'event_tickets_aggregate', aggregate?: { __typename?: 'event_tickets_aggregate_fields', count: number } | null }, free_attendees: { __typename?: 'event_tickets_aggregate', aggregate?: { __typename?: 'event_tickets_aggregate_fields', count: number } | null } } | null };

export type InsertManualOrderMutationVariables = Exact<{
  data: Orders_Insert_Input;
}>;


export type InsertManualOrderMutation = { __typename?: 'mutation_root', insert_orders_one?: { __typename?: 'orders', id: number, status: Order_Status_Enum, custom_line_price?: number | null, custom_line_title?: string | null, custom_line_status?: Order_Item_Status_Enum | null, custom_shipping_price?: number | null, custom_shipping_title?: string | null, address: { __typename?: 'addresses', name: string, contact_email: string, country?: { __typename?: 'countries', name: string } | null }, shipping_option?: { __typename?: 'shipping_options', name: string, price: number, country?: string | null } | null, order_books: Array<{ __typename?: 'order_book', price: number, discount: number, quantity: number, book: { __typename?: 'books', isbn: any, title: string, author?: string | null } }>, order_products: Array<{ __typename?: 'order_product', price: number, discount: number, quantity: number, product: { __typename?: 'products', id: any, title: string } }>, vouchers: Array<{ __typename?: 'vouchers', id: string, initial_amount: number, recipient?: string | null }>, pif_donations: Array<{ __typename?: 'pif_donations', amount: number }> } | null };

export type MarkOrderInvoiceSentMutationVariables = Exact<{
  id: Scalars['Int'];
  invoice: Scalars['String'];
}>;


export type MarkOrderInvoiceSentMutation = { __typename?: 'mutation_root', update_orders_by_pk?: { __typename?: 'orders', id: number, status: Order_Status_Enum } | null };

export type InsertRefundMutationVariables = Exact<{
  orderId: Scalars['Int'];
  amount: Scalars['Int'];
  status?: InputMaybe<Order_Status_Enum>;
}>;


export type InsertRefundMutation = { __typename?: 'mutation_root', insert_refunds_one?: { __typename?: 'refunds', id: any } | null, update_orders_by_pk?: { __typename?: 'orders', id: number } | null };

export type SubscriptionCheckoutGetSubQueryVariables = Exact<{
  subId: Scalars['uuid'];
}>;


export type SubscriptionCheckoutGetSubQuery = { __typename?: 'query_root', subscriptions_by_pk?: { __typename?: 'subscriptions', id: any, description: string, title: string, price: number } | null };

export type CreateDraftSubscriptionObjectMutationVariables = Exact<{
  data: Subscription_Draft_Object_Insert_Input;
}>;


export type CreateDraftSubscriptionObjectMutation = { __typename?: 'mutation_root', insert_subscription_draft_object_one?: { __typename?: 'subscription_draft_object', id: any } | null };

export type GetSubscriptionObjectActiveStatusQueryVariables = Exact<{
  sub_obj_id: Scalars['uuid'];
}>;


export type GetSubscriptionObjectActiveStatusQuery = { __typename?: 'query_root', subscription_object_by_pk?: { __typename?: 'subscription_object', id: any, stripe_sub_id?: string | null, is_active: boolean } | null };

export type BatchInsertBooksMutationVariables = Exact<{
  books: Array<Books_Insert_Input> | Books_Insert_Input;
}>;


export type BatchInsertBooksMutation = { __typename?: 'mutation_root', insert_books?: { __typename?: 'books_mutation_response', affected_rows: number } | null };

export type GetDiscountQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetDiscountQuery = { __typename?: 'query_root', discounts_by_pk?: { __typename?: 'discounts', code: string, discount_value: number, is_active: boolean, is_fixed_amount: boolean, limit_uses?: number | null, orders_aggregate: { __typename?: 'orders_aggregate', aggregate?: { __typename?: 'orders_aggregate_fields', count: number } | null }, discounted_books: Array<{ __typename?: 'book_discount', book_isbn: any }> } | null };

export type ValidateVoucherQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ValidateVoucherQuery = { __typename?: 'query_root', vouchers_by_pk?: { __typename?: 'vouchers', id: string, initial_amount: number, remaining_amount?: number | null, order?: { __typename?: 'orders', status: Order_Status_Enum } | null, event_tickets: Array<{ __typename?: 'event_tickets', event: { __typename?: 'events', event_books: Array<{ __typename?: 'event_book', book: { __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } } }> } }> } | null };

export type GetBookBasedReccomendationsQueryVariables = Exact<{
  isbn: Scalars['bigint'];
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  offset: Scalars['Int'];
}>;


export type GetBookBasedReccomendationsQuery = { __typename?: 'query_root', books_by_pk?: { __typename?: 'books', is_unlisted: boolean, price?: number | null, post_books: Array<{ __typename?: 'post_book', post: { __typename?: 'posts', id: any, slug: string, type: string, title: string, image?: string | null, post_books: Array<{ __typename?: 'post_book', book: { __typename?: 'books', image?: string | null } }> } }> } | null, books: Array<{ __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } }>, event_book: Array<{ __typename?: 'event_book', event: { __typename?: 'events', start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null } }> };

export type GetAllCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCategoriesQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'categories', name: string, slug?: string | null }> };

export type GetBrowsePageContentQueryVariables = Exact<{
  today?: InputMaybe<Scalars['timestamp']>;
  categorySlug?: InputMaybe<String_Comparison_Exp>;
  tagFilters: Books_Bool_Exp;
  booksOrderBy?: InputMaybe<Array<Books_Order_By> | Books_Order_By>;
  bookLimit?: InputMaybe<Scalars['Int']>;
  postLimit?: InputMaybe<Scalars['Int']>;
  eventLimit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetBrowsePageContentQuery = { __typename?: 'query_root', pages_by_pk?: { __typename?: 'pages', content: any } | null, categories: Array<{ __typename?: 'categories', description?: string | null }>, books: Array<{ __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } }>, books_aggregate: { __typename?: 'books_aggregate', aggregate?: { __typename?: 'books_aggregate_fields', count: number } | null }, events: Array<{ __typename?: 'events', start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null }>, events_aggregate: { __typename?: 'events_aggregate', aggregate?: { __typename?: 'events_aggregate_fields', count: number } | null }, posts: Array<{ __typename?: 'posts', id: any, slug: string, type: string, title: string, image?: string | null, post_books: Array<{ __typename?: 'post_book', book: { __typename?: 'books', image?: string | null } }> }>, posts_aggregate: { __typename?: 'posts_aggregate', aggregate?: { __typename?: 'posts_aggregate_fields', count: number } | null } };

export type GetEventQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetEventQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', title: string, slug: string, id: any, video?: string | null, start_time: any, end_time: any, location?: string | null, speakers?: string | null, seats?: number | null, price?: number | null, is_festival: boolean, is_online_only: boolean, is_in_person_only?: boolean | null, is_book_club: boolean, image?: string | null, free_seats?: number | null, enable_comments: boolean, description?: string | null, category_events: Array<{ __typename?: 'category_event', category: { __typename?: 'categories', name: string } }>, event_books: Array<{ __typename?: 'event_book', book: { __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } } }>, festival?: { __typename?: 'events', description?: string | null, start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null } | null, events: Array<{ __typename?: 'events', start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null }> }> };

export type GetEventConfLocationQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventConfLocationQuery = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', id: any, video_conf_location?: string | null } | null };

export type GetAllUpcomingEventsQueryVariables = Exact<{
  today?: InputMaybe<Scalars['timestamp']>;
}>;


export type GetAllUpcomingEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', end_time: any, is_festival: boolean, start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null, event_books: Array<{ __typename?: 'event_book', book: { __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } } }>, events: Array<{ __typename?: 'events', slug: string, title: string }>, festival?: { __typename?: 'events', end_time: any, is_festival: boolean, start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null, event_books: Array<{ __typename?: 'event_book', book: { __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } } }>, events: Array<{ __typename?: 'events', slug: string, title: string }> } | null }> };

export type GetPastEventsQueryVariables = Exact<{
  today?: InputMaybe<Scalars['timestamp']>;
}>;


export type GetPastEventsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null }> };

export type GetPreflightDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreflightDataQuery = { __typename?: 'query_root', unstructured_data_by_pk?: { __typename?: 'unstructured_data', jitsiLink: any, videoStream: any } | null };

export type UpdatePreflightDataMutationVariables = Exact<{
  data?: InputMaybe<Scalars['jsonb']>;
}>;


export type UpdatePreflightDataMutation = { __typename?: 'mutation_root', deleteJitsi?: { __typename?: 'unstructured_data', data: any } | null, deleteVideo?: { __typename?: 'unstructured_data', data: any } | null, update_unstructured_data_by_pk?: { __typename?: 'unstructured_data', data: any } | null };

export type HomePageContentQueryVariables = Exact<{
  books?: InputMaybe<Array<Scalars['bigint']> | Scalars['bigint']>;
  now?: InputMaybe<Scalars['timestamp']>;
  posts?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  events?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type HomePageContentQuery = { __typename?: 'query_root', books: Array<{ __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } }>, posts: Array<{ __typename?: 'posts', id: any, slug: string, type: string, title: string, image?: string | null, post_books: Array<{ __typename?: 'post_book', book: { __typename?: 'books', image?: string | null } }> }>, upcomingEvents: Array<{ __typename?: 'events', start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null }>, pastEvents: Array<{ __typename?: 'events', start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null }> };

export type GetPostQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetPostQuery = { __typename?: 'query_root', posts: Array<{ __typename?: 'posts', id: any, title: string, created_at: any, slug: string, image?: string | null, content: string, type: string, author: { __typename?: 'booksellers', id: number, name: string }, category_posts: Array<{ __typename?: 'category_post', category: { __typename?: 'categories', name: string, slug?: string | null } }>, post_books: Array<{ __typename?: 'post_book', book: { __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } } }> }> };

export type GetFiveRecentPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFiveRecentPostsQuery = { __typename?: 'query_root', posts: Array<{ __typename?: 'posts', slug: string, title: string, type: string, created_at: any, author: { __typename?: 'booksellers', name: string } }> };

export type GetLinkedBooksQueryVariables = Exact<{
  isbns: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type GetLinkedBooksQuery = { __typename?: 'query_root', books: Array<{ __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } }> };

export type GetAllArticlesQueryVariables = Exact<{
  filters?: InputMaybe<Posts_Bool_Exp>;
  offset: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllArticlesQuery = { __typename?: 'query_root', posts: Array<{ __typename?: 'posts', id: any, slug: string, type: string, title: string, image?: string | null, post_books: Array<{ __typename?: 'post_book', book: { __typename?: 'books', image?: string | null } }> }>, posts_aggregate: { __typename?: 'posts_aggregate', aggregate?: { __typename?: 'posts_aggregate_fields', count: number } | null } };

export type SiteSearchQueryVariables = Exact<{
  search: Scalars['String'];
  bookLimit: Scalars['Int'];
  postLimit: Scalars['Int'];
  eventLimit: Scalars['Int'];
  productLimit: Scalars['Int'];
  subLimit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type SiteSearchQuery = { __typename?: 'query_root', search_books_aggregate: { __typename?: 'books_aggregate', aggregate?: { __typename?: 'books_aggregate_fields', count: number } | null }, search_books: Array<{ __typename?: 'books', isbn: any, author?: string | null, title: string, price?: number | null, discount_value?: number | null, is_discounted: boolean, image?: string | null, stock?: number | null, track_stock: boolean, tag_books_aggregate: { __typename?: 'tag_book_aggregate', aggregate?: { __typename?: 'tag_book_aggregate_fields', count: number } | null } }>, search_posts_aggregate: { __typename?: 'posts_aggregate', aggregate?: { __typename?: 'posts_aggregate_fields', count: number } | null }, search_posts: Array<{ __typename?: 'posts', id: any, slug: string, type: string, title: string, image?: string | null, post_books: Array<{ __typename?: 'post_book', book: { __typename?: 'books', image?: string | null } }> }>, search_events_aggregate: { __typename?: 'events_aggregate', aggregate?: { __typename?: 'events_aggregate_fields', count: number } | null }, search_events: Array<{ __typename?: 'events', start_time: any, slug: string, id: any, title: string, speakers?: string | null, image?: string | null }>, search_products_aggregate: { __typename?: 'products_aggregate', aggregate?: { __typename?: 'products_aggregate_fields', count: number } | null }, search_products: Array<{ __typename?: 'products', id: any, image?: string | null, price: number, title: string, slug: string, stock?: number | null, is_discounted: boolean, discount_value?: number | null }>, search_subscriptions_aggregate: { __typename?: 'subscriptions_aggregate', aggregate?: { __typename?: 'subscriptions_aggregate_fields', count: number } | null }, search_subscriptions: Array<{ __typename?: 'subscriptions', id: any, slug: string, title: string, image: string }> };

export type LogNoResultSearchMutationVariables = Exact<{
  text: Scalars['String'];
}>;


export type LogNoResultSearchMutation = { __typename?: 'mutation_root', insert_empty_searches_one?: { __typename?: 'empty_searches', id: any } | null };

export type GetProductQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetProductQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'products', description?: string | null, id: any, image?: string | null, price: number, title: string, slug: string, stock?: number | null, is_discounted: boolean, discount_value?: number | null }> };

export type AddCreditToSubObjectMutationVariables = Exact<{
  subObjectId: Scalars['uuid'];
}>;


export type AddCreditToSubObjectMutation = { __typename?: 'mutation_root', insert_subscription_object_credit_one?: { __typename?: 'subscription_object_credit', id: any } | null };

export type CreateDraftSubObjectsMutationVariables = Exact<{
  objects: Array<Subscription_Draft_Object_Insert_Input> | Subscription_Draft_Object_Insert_Input;
}>;


export type CreateDraftSubObjectsMutation = { __typename?: 'mutation_root', insert_subscription_draft_object?: { __typename?: 'subscription_draft_object_mutation_response', returning: Array<{ __typename?: 'subscription_draft_object', credits?: number | null, id: any, recipient: string, subscription: { __typename?: 'subscriptions', id: any, price: number, title: string } }> } | null };

export type CreateSubscriptionObjectMutationVariables = Exact<{
  data: Subscription_Object_Insert_Input;
}>;


export type CreateSubscriptionObjectMutation = { __typename?: 'mutation_root', insert_subscription_object_one?: { __typename?: 'subscription_object', id: any, account_id?: any | null, address_id?: any | null, subscription_id: any, short_id: string, password: string, recipient: string, subscription: { __typename?: 'subscriptions', title: string, price: number } } | null };

export type GetDraftSubscriptionObjectQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetDraftSubscriptionObjectQuery = { __typename?: 'query_root', subscription_draft_object_by_pk?: { __typename?: 'subscription_draft_object', id: any, account_id?: any | null, address_id?: any | null, subscription_id: any, recipient: string, address?: { __typename?: 'addresses', name: string, contact_email: string } | null } | null };

export type GetOrderForIdempotencyCheckQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetOrderForIdempotencyCheckQuery = { __typename?: 'query_root', orders_by_pk?: { __typename?: 'orders', id: number, status: Order_Status_Enum, stripe_payment_id?: string | null, custom_line_title?: string | null, order_books_aggregate: { __typename?: 'order_book_aggregate', aggregate?: { __typename?: 'order_book_aggregate_fields', count: number } | null }, order_products_aggregate: { __typename?: 'order_product_aggregate', aggregate?: { __typename?: 'order_product_aggregate_fields', count: number } | null } } | null };

export type GetSubscriptionObjectByStripeSubIdQueryVariables = Exact<{
  stripeSubId: Scalars['String'];
}>;


export type GetSubscriptionObjectByStripeSubIdQuery = { __typename?: 'query_root', subscription_object: Array<{ __typename?: 'subscription_object', id: any }> };

export type UpdateAccountStripeCustomerIdMutationVariables = Exact<{
  stripe_customer_id: Scalars['String'];
  id: Scalars['uuid'];
}>;


export type UpdateAccountStripeCustomerIdMutation = { __typename?: 'mutation_root', update_accounts_by_pk?: { __typename?: 'accounts', id: any } | null };

export type UpdateOrderStatusAndStripeIdMutationVariables = Exact<{
  id: Scalars['Int'];
  status?: InputMaybe<Order_Status_Enum>;
  stripe_payment_id?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrderStatusAndStripeIdMutation = { __typename?: 'mutation_root', update_orders_by_pk?: { __typename?: 'orders', id: number, account_id?: any | null, custom_line_price?: number | null, custom_line_title?: string | null, wrapping: number, address: { __typename?: 'addresses', contact_email: string, name: string, account_id?: any | null }, shipping_option?: { __typename?: 'shipping_options', name: string, price: number } | null, pif_donations: Array<{ __typename?: 'pif_donations', amount: number }>, order_books: Array<{ __typename?: 'order_book', book_isbn: any, quantity: number, price: number, discount: number, event_tickets: Array<{ __typename?: 'event_tickets', is_free_attendee: boolean, is_online_viewer: boolean, order_book_id?: any | null, address: { __typename?: 'addresses', contact_email: string, name: string }, event: { __typename?: 'events', title: string, start_time: any, location?: string | null, image?: string | null, slug: string, is_book_club: boolean, event_books: Array<{ __typename?: 'event_book', book: { __typename?: 'books', title: string, author?: string | null, isbn: any } }> } }>, book: { __typename?: 'books', title: string, author?: string | null, stock?: number | null } }>, order_products: Array<{ __typename?: 'order_product', price: number, quantity: number, discount: number, product: { __typename?: 'products', title: string } }>, order_subscription_objects: Array<{ __typename?: 'order_subscription_object', id: any, subscription_object?: { __typename?: 'subscription_object', password: string, short_id: string, id: any } | null, subscription_draft_object: { __typename?: 'subscription_draft_object', id: any, credits?: number | null, recipient: string, subscription_id: any, message?: string | null, subscription_object?: { __typename?: 'subscription_object', password: string, short_id: string, id: any } | null, subscription: { __typename?: 'subscriptions', title: string, price: number } } }>, vouchers: Array<{ __typename?: 'vouchers', id: string, recipient?: string | null, initial_amount: number, message?: string | null, event_tickets: Array<{ __typename?: 'event_tickets', is_free_attendee: boolean, is_online_viewer: boolean, order_book_id?: any | null, address: { __typename?: 'addresses', contact_email: string, name: string }, voucher?: { __typename?: 'vouchers', id: string, initial_amount: number } | null, event: { __typename?: 'events', is_book_club: boolean, title: string, start_time: any, location?: string | null, image?: string | null, slug: string, event_books: Array<{ __typename?: 'event_book', book: { __typename?: 'books', title: string, author?: string | null, isbn: any } }> } }> }>, order_vouchers_for_discount: Array<{ __typename?: 'order_voucher', amount_discounted: number, voucher_id: string, voucher: { __typename?: 'vouchers', remaining_amount?: number | null } }>, event_tickets: Array<{ __typename?: 'event_tickets', id: any, is_online_viewer: boolean, is_free_attendee: boolean, address: { __typename?: 'addresses', contact_email: string, name: string }, event: { __typename?: 'events', id: any, title: string, start_time: any, image?: string | null, is_book_club: boolean, slug: string, event_books: Array<{ __typename?: 'event_book', book: { __typename?: 'books', isbn: any, author?: string | null, title: string } }> } }> } | null };

export type UpdateStockMutationVariables = Exact<{
  isbn: Scalars['bigint'];
  stockChange?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateStockMutation = { __typename?: 'mutation_root', update_books_by_pk?: { __typename?: 'books', isbn: any } | null };

export type InsertNewAddressMutationVariables = Exact<{
  data: Addresses_Insert_Input;
}>;


export type InsertNewAddressMutation = { __typename?: 'mutation_root', insert_addresses_one?: { __typename?: 'addresses', id: any, name: string, contact_email: string } | null };

export type CreateNewOrderMutationVariables = Exact<{
  data: Orders_Insert_Input;
}>;


export type CreateNewOrderMutation = { __typename?: 'mutation_root', insert_orders_one?: { __typename?: 'orders', id: number, pick_up: boolean, wrapping: number, custom_line_title?: string | null, gift_wrap: boolean, shipping_option?: { __typename?: 'shipping_options', id: any, price: number, name: string, country?: string | null, region?: string | null } | null, order_books: Array<{ __typename?: 'order_book', price: number, discount: number, quantity: number, book: { __typename?: 'books', isbn: any, title: string }, event_tickets: Array<{ __typename?: 'event_tickets', event: { __typename?: 'events', title: string } }> }>, order_products: Array<{ __typename?: 'order_product', order_id: number, product_id: any, price: number, discount: number, quantity: number, product: { __typename?: 'products', id: any, title: string } }>, order_subscription_objects: Array<{ __typename?: 'order_subscription_object', id: any, subscription_draft_object: { __typename?: 'subscription_draft_object', id: any, credits?: number | null, recipient: string, message?: string | null, subscription: { __typename?: 'subscriptions', id: any, price: number, title: string } } }>, vouchers: Array<{ __typename?: 'vouchers', initial_amount: number, event_tickets: Array<{ __typename?: 'event_tickets', event: { __typename?: 'events', title: string } }> }>, pif_donations: Array<{ __typename?: 'pif_donations', amount: number }>, order_vouchers_for_discount: Array<{ __typename?: 'order_voucher', amount_discounted: number, voucher_id: string }>, address: { __typename?: 'addresses', id: any, account?: { __typename?: 'accounts', id: any, stripe_customer_id?: string | null } | null }, order_books_aggregate: { __typename?: 'order_book_aggregate', aggregate?: { __typename?: 'order_book_aggregate_fields', count: number } | null }, order_products_aggregate: { __typename?: 'order_product_aggregate', aggregate?: { __typename?: 'order_product_aggregate_fields', count: number } | null }, order_subscription_objects_aggregate: { __typename?: 'order_subscription_object_aggregate', aggregate?: { __typename?: 'order_subscription_object_aggregate_fields', count: number } | null }, discount?: { __typename?: 'discounts', is_fixed_amount: boolean, discount_value: number, discounted_books: Array<{ __typename?: 'book_discount', book_isbn: any }> } | null } | null };

export type ValidateAddressQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ValidateAddressQuery = { __typename?: 'query_root', addresses_by_pk?: { __typename?: 'addresses', id: any, name: string, contact_email: string, account?: { __typename?: 'accounts', id: any, stripe_customer_id?: string | null } | null } | null };

export type ValidateBasketQueryVariables = Exact<{
  isbns?: InputMaybe<Array<Scalars['bigint']> | Scalars['bigint']>;
  addressId: Scalars['uuid'];
  productIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  eventIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  shippingId: Scalars['uuid'];
  vouchers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  discountCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type ValidateBasketQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'products', id: any, title: string, price: number, stock?: number | null, is_discounted: boolean, discount_value?: number | null }>, subscriptions: Array<{ __typename?: 'subscriptions', id: any, price: number, is_active: boolean }>, books: Array<{ __typename?: 'books', isbn: any, title: string, author?: string | null, price?: number | null, is_discounted: boolean, discount_value?: number | null, stock?: number | null, is_unlisted: boolean, track_stock: boolean }>, addresses_by_pk?: { __typename?: 'addresses', id: any, contact_email: string } | null, shipping_options_by_pk?: { __typename?: 'shipping_options', id: any, name: string, price: number, from: number, to?: number | null, country?: string | null, region?: string | null } | null, events: Array<{ __typename?: 'events', id: any, title: string, seats?: number | null, free_seats?: number | null, price?: number | null, event_books: Array<{ __typename?: 'event_book', book: { __typename?: 'books', isbn: any, price?: number | null, is_discounted: boolean, discount_value?: number | null, stock?: number | null } }>, free_attendees: { __typename?: 'event_tickets_aggregate', aggregate?: { __typename?: 'event_tickets_aggregate_fields', count: number } | null }, online_attendees: { __typename?: 'event_tickets_aggregate', aggregate?: { __typename?: 'event_tickets_aggregate_fields', count: number } | null }, paid_attendees: { __typename?: 'event_tickets_aggregate', aggregate?: { __typename?: 'event_tickets_aggregate_fields', count: number } | null } }>, vouchers: Array<{ __typename?: 'vouchers', id: string, remaining_amount?: number | null }>, discounts: Array<{ __typename?: 'discounts', code: string, is_active: boolean, limit_uses?: number | null, is_fixed_amount: boolean, discount_value: number, discounted_books: Array<{ __typename?: 'book_discount', book_isbn: any }>, orders_aggregate: { __typename?: 'orders_aggregate', aggregate?: { __typename?: 'orders_aggregate_fields', count: number } | null } }> };

export type GetAllEventTicketsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAllEventTicketsQuery = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', title: string, speakers?: string | null, image?: string | null, start_time: any, end_time: any, slug: string, location?: string | null, event_books: Array<{ __typename?: 'event_book', book: { __typename?: 'books', title: string, author?: string | null, isbn: any } }>, attendees: Array<{ __typename?: 'event_tickets', is_free_attendee: boolean, is_online_viewer: boolean, order_book_id?: any | null, voucher_id?: string | null, address: { __typename?: 'addresses', contact_email: string, name: string } }> } | null };

export const BookCardDataFragmentDoc = gql`
    fragment BookCardData on books {
  isbn
  author
  title
  price
  discount_value
  is_discounted
  image
  stock
  track_stock
  tag_books_aggregate(where: {tag: {text: {_ilike: "%pre-order%"}}}) {
    aggregate {
      count
    }
  }
}
    `;
export const EventCardDataFragmentDoc = gql`
    fragment EventCardData on events {
  start_time
  slug
  id
  title
  speakers
  image
}
    `;
export const PostCardDataFragmentDoc = gql`
    fragment PostCardData on posts {
  id
  slug
  type
  title
  post_books(where: {book: {is_unlisted: {_eq: false}}}) {
    book {
      image
    }
  }
  image
}
    `;
export const ProductCardDataFragmentDoc = gql`
    fragment ProductCardData on products {
  id
  image
  price
  title
  slug
  stock
  is_discounted
  discount_value
}
    `;
export const SubCardDataFragmentDoc = gql`
    fragment SubCardData on subscriptions {
  id
  slug
  title
  image
}
    `;
export const CreateDispatchEventDocument = gql`
    mutation CreateDispatchEvent($data: subscription_dispatch_insert_input!) {
  insert_subscription_dispatch_one(object: $data) {
    id
  }
}
    `;
export type CreateDispatchEventMutationFn = ApolloReactCommon.MutationFunction<CreateDispatchEventMutation, CreateDispatchEventMutationVariables>;
export type CreateDispatchEventComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDispatchEventMutation, CreateDispatchEventMutationVariables>, 'mutation'>;

    export const CreateDispatchEventComponent = (props: CreateDispatchEventComponentProps) => (
      <ApolloReactComponents.Mutation<CreateDispatchEventMutation, CreateDispatchEventMutationVariables> mutation={CreateDispatchEventDocument} {...props} />
    );
    
export type CreateDispatchEventProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateDispatchEventMutation, CreateDispatchEventMutationVariables>
    } & TChildProps;
export function withCreateDispatchEvent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateDispatchEventMutation,
  CreateDispatchEventMutationVariables,
  CreateDispatchEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateDispatchEventMutation, CreateDispatchEventMutationVariables, CreateDispatchEventProps<TChildProps, TDataName>>(CreateDispatchEventDocument, {
      alias: 'createDispatchEvent',
      ...operationOptions
    });
};

/**
 * __useCreateDispatchEventMutation__
 *
 * To run a mutation, you first call `useCreateDispatchEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDispatchEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDispatchEventMutation, { data, loading, error }] = useCreateDispatchEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDispatchEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDispatchEventMutation, CreateDispatchEventMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDispatchEventMutation, CreateDispatchEventMutationVariables>(CreateDispatchEventDocument, baseOptions);
      }
export type CreateDispatchEventMutationHookResult = ReturnType<typeof useCreateDispatchEventMutation>;
export type CreateDispatchEventMutationResult = ApolloReactCommon.MutationResult<CreateDispatchEventMutation>;
export type CreateDispatchEventMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDispatchEventMutation, CreateDispatchEventMutationVariables>;
export const FulfillDigitalContentDocument = gql`
    mutation FulfillDigitalContent($id: uuid!) {
  update_subscription_dispatch_by_pk(
    pk_columns: {id: $id}
    _set: {has_dispatched_digital: true}
  ) {
    id
    has_dispatched_digital
  }
}
    `;
export type FulfillDigitalContentMutationFn = ApolloReactCommon.MutationFunction<FulfillDigitalContentMutation, FulfillDigitalContentMutationVariables>;
export type FulfillDigitalContentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<FulfillDigitalContentMutation, FulfillDigitalContentMutationVariables>, 'mutation'>;

    export const FulfillDigitalContentComponent = (props: FulfillDigitalContentComponentProps) => (
      <ApolloReactComponents.Mutation<FulfillDigitalContentMutation, FulfillDigitalContentMutationVariables> mutation={FulfillDigitalContentDocument} {...props} />
    );
    
export type FulfillDigitalContentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<FulfillDigitalContentMutation, FulfillDigitalContentMutationVariables>
    } & TChildProps;
export function withFulfillDigitalContent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FulfillDigitalContentMutation,
  FulfillDigitalContentMutationVariables,
  FulfillDigitalContentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, FulfillDigitalContentMutation, FulfillDigitalContentMutationVariables, FulfillDigitalContentProps<TChildProps, TDataName>>(FulfillDigitalContentDocument, {
      alias: 'fulfillDigitalContent',
      ...operationOptions
    });
};

/**
 * __useFulfillDigitalContentMutation__
 *
 * To run a mutation, you first call `useFulfillDigitalContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFulfillDigitalContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fulfillDigitalContentMutation, { data, loading, error }] = useFulfillDigitalContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFulfillDigitalContentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FulfillDigitalContentMutation, FulfillDigitalContentMutationVariables>) {
        return ApolloReactHooks.useMutation<FulfillDigitalContentMutation, FulfillDigitalContentMutationVariables>(FulfillDigitalContentDocument, baseOptions);
      }
export type FulfillDigitalContentMutationHookResult = ReturnType<typeof useFulfillDigitalContentMutation>;
export type FulfillDigitalContentMutationResult = ApolloReactCommon.MutationResult<FulfillDigitalContentMutation>;
export type FulfillDigitalContentMutationOptions = ApolloReactCommon.BaseMutationOptions<FulfillDigitalContentMutation, FulfillDigitalContentMutationVariables>;
export const GetActiveSubsForNewDispatchEventDocument = gql`
    query GetActiveSubsForNewDispatchEvent($subId: uuid!) {
  subscriptions_by_pk(id: $subId) {
    id
    title
    slug
    subscription_objects(
      where: {is_active: {_eq: true}, remaining_credits: {_gt: 0}}
      order_by: {dispatches_aggregate: {max: {created_at: desc}}}
    ) {
      id
      remaining_credits
      recipient
      dispatches(limit: 1, order_by: {created_at: desc}) {
        dispatch_id
        created_at
      }
      address {
        name
        contact_email
        phone_number
        line_1
        line_2
        line_3
        city
        region
        code
        country_code
      }
    }
  }
}
    `;
export type GetActiveSubsForNewDispatchEventComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetActiveSubsForNewDispatchEventQuery, GetActiveSubsForNewDispatchEventQueryVariables>, 'query'> & ({ variables: GetActiveSubsForNewDispatchEventQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetActiveSubsForNewDispatchEventComponent = (props: GetActiveSubsForNewDispatchEventComponentProps) => (
      <ApolloReactComponents.Query<GetActiveSubsForNewDispatchEventQuery, GetActiveSubsForNewDispatchEventQueryVariables> query={GetActiveSubsForNewDispatchEventDocument} {...props} />
    );
    
export type GetActiveSubsForNewDispatchEventProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetActiveSubsForNewDispatchEventQuery, GetActiveSubsForNewDispatchEventQueryVariables>
    } & TChildProps;
export function withGetActiveSubsForNewDispatchEvent<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetActiveSubsForNewDispatchEventQuery,
  GetActiveSubsForNewDispatchEventQueryVariables,
  GetActiveSubsForNewDispatchEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetActiveSubsForNewDispatchEventQuery, GetActiveSubsForNewDispatchEventQueryVariables, GetActiveSubsForNewDispatchEventProps<TChildProps, TDataName>>(GetActiveSubsForNewDispatchEventDocument, {
      alias: 'getActiveSubsForNewDispatchEvent',
      ...operationOptions
    });
};

/**
 * __useGetActiveSubsForNewDispatchEventQuery__
 *
 * To run a query within a React component, call `useGetActiveSubsForNewDispatchEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveSubsForNewDispatchEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveSubsForNewDispatchEventQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useGetActiveSubsForNewDispatchEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetActiveSubsForNewDispatchEventQuery, GetActiveSubsForNewDispatchEventQueryVariables>) {
        return ApolloReactHooks.useQuery<GetActiveSubsForNewDispatchEventQuery, GetActiveSubsForNewDispatchEventQueryVariables>(GetActiveSubsForNewDispatchEventDocument, baseOptions);
      }
export function useGetActiveSubsForNewDispatchEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActiveSubsForNewDispatchEventQuery, GetActiveSubsForNewDispatchEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetActiveSubsForNewDispatchEventQuery, GetActiveSubsForNewDispatchEventQueryVariables>(GetActiveSubsForNewDispatchEventDocument, baseOptions);
        }
export type GetActiveSubsForNewDispatchEventQueryHookResult = ReturnType<typeof useGetActiveSubsForNewDispatchEventQuery>;
export type GetActiveSubsForNewDispatchEventLazyQueryHookResult = ReturnType<typeof useGetActiveSubsForNewDispatchEventLazyQuery>;
export type GetActiveSubsForNewDispatchEventQueryResult = ApolloReactCommon.QueryResult<GetActiveSubsForNewDispatchEventQuery, GetActiveSubsForNewDispatchEventQueryVariables>;
export const GetDispatchEventDocument = gql`
    query GetDispatchEvent($id: uuid!) {
  subscription_dispatch_by_pk(id: $id) {
    id
    subscription_id
    has_dispatched_digital
    subscription {
      title
    }
    created_at
    subscription_objects {
      created_at
      subscription_object {
        id
        recipient
        remaining_credits
        address {
          name
          contact_email
          phone_number
          line_1
          line_2
          line_3
          city
          region
          code
          country_code
        }
      }
    }
  }
}
    `;
export type GetDispatchEventComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDispatchEventQuery, GetDispatchEventQueryVariables>, 'query'> & ({ variables: GetDispatchEventQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDispatchEventComponent = (props: GetDispatchEventComponentProps) => (
      <ApolloReactComponents.Query<GetDispatchEventQuery, GetDispatchEventQueryVariables> query={GetDispatchEventDocument} {...props} />
    );
    
export type GetDispatchEventProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDispatchEventQuery, GetDispatchEventQueryVariables>
    } & TChildProps;
export function withGetDispatchEvent<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDispatchEventQuery,
  GetDispatchEventQueryVariables,
  GetDispatchEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDispatchEventQuery, GetDispatchEventQueryVariables, GetDispatchEventProps<TChildProps, TDataName>>(GetDispatchEventDocument, {
      alias: 'getDispatchEvent',
      ...operationOptions
    });
};

/**
 * __useGetDispatchEventQuery__
 *
 * To run a query within a React component, call `useGetDispatchEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispatchEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispatchEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDispatchEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDispatchEventQuery, GetDispatchEventQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDispatchEventQuery, GetDispatchEventQueryVariables>(GetDispatchEventDocument, baseOptions);
      }
export function useGetDispatchEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDispatchEventQuery, GetDispatchEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDispatchEventQuery, GetDispatchEventQueryVariables>(GetDispatchEventDocument, baseOptions);
        }
export type GetDispatchEventQueryHookResult = ReturnType<typeof useGetDispatchEventQuery>;
export type GetDispatchEventLazyQueryHookResult = ReturnType<typeof useGetDispatchEventLazyQuery>;
export type GetDispatchEventQueryResult = ApolloReactCommon.QueryResult<GetDispatchEventQuery, GetDispatchEventQueryVariables>;
export const SaveNoteForDispatchEventDocument = gql`
    mutation SaveNoteForDispatchEvent($dId: uuid!, $note: String!) {
  update_subscription_dispatch_by_pk(pk_columns: {id: $dId}, _set: {note: $note}) {
    id
    note
  }
}
    `;
export type SaveNoteForDispatchEventMutationFn = ApolloReactCommon.MutationFunction<SaveNoteForDispatchEventMutation, SaveNoteForDispatchEventMutationVariables>;
export type SaveNoteForDispatchEventComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveNoteForDispatchEventMutation, SaveNoteForDispatchEventMutationVariables>, 'mutation'>;

    export const SaveNoteForDispatchEventComponent = (props: SaveNoteForDispatchEventComponentProps) => (
      <ApolloReactComponents.Mutation<SaveNoteForDispatchEventMutation, SaveNoteForDispatchEventMutationVariables> mutation={SaveNoteForDispatchEventDocument} {...props} />
    );
    
export type SaveNoteForDispatchEventProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SaveNoteForDispatchEventMutation, SaveNoteForDispatchEventMutationVariables>
    } & TChildProps;
export function withSaveNoteForDispatchEvent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SaveNoteForDispatchEventMutation,
  SaveNoteForDispatchEventMutationVariables,
  SaveNoteForDispatchEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SaveNoteForDispatchEventMutation, SaveNoteForDispatchEventMutationVariables, SaveNoteForDispatchEventProps<TChildProps, TDataName>>(SaveNoteForDispatchEventDocument, {
      alias: 'saveNoteForDispatchEvent',
      ...operationOptions
    });
};

/**
 * __useSaveNoteForDispatchEventMutation__
 *
 * To run a mutation, you first call `useSaveNoteForDispatchEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNoteForDispatchEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNoteForDispatchEventMutation, { data, loading, error }] = useSaveNoteForDispatchEventMutation({
 *   variables: {
 *      dId: // value for 'dId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSaveNoteForDispatchEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveNoteForDispatchEventMutation, SaveNoteForDispatchEventMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveNoteForDispatchEventMutation, SaveNoteForDispatchEventMutationVariables>(SaveNoteForDispatchEventDocument, baseOptions);
      }
export type SaveNoteForDispatchEventMutationHookResult = ReturnType<typeof useSaveNoteForDispatchEventMutation>;
export type SaveNoteForDispatchEventMutationResult = ApolloReactCommon.MutationResult<SaveNoteForDispatchEventMutation>;
export type SaveNoteForDispatchEventMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveNoteForDispatchEventMutation, SaveNoteForDispatchEventMutationVariables>;
export const GetSubscriptionObjectForCmsDocument = gql`
    query GetSubscriptionObjectForCms($id: uuid!) {
  subscription_object_by_pk(id: $id) {
    id
    recipient
    remaining_credits
    stripe_sub_id
    created_at
    password
    short_id
    is_active
    subscription {
      id
      title
    }
    address {
      name
      contact_email
      phone_number
      line_1
      line_2
      line_3
      city
      region
      code
      country_code
    }
    dispatches(order_by: {created_at: desc}) {
      subscription_dispatch {
        id
        created_at
      }
    }
    credits_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;
export type GetSubscriptionObjectForCmsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubscriptionObjectForCmsQuery, GetSubscriptionObjectForCmsQueryVariables>, 'query'> & ({ variables: GetSubscriptionObjectForCmsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubscriptionObjectForCmsComponent = (props: GetSubscriptionObjectForCmsComponentProps) => (
      <ApolloReactComponents.Query<GetSubscriptionObjectForCmsQuery, GetSubscriptionObjectForCmsQueryVariables> query={GetSubscriptionObjectForCmsDocument} {...props} />
    );
    
export type GetSubscriptionObjectForCmsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubscriptionObjectForCmsQuery, GetSubscriptionObjectForCmsQueryVariables>
    } & TChildProps;
export function withGetSubscriptionObjectForCms<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubscriptionObjectForCmsQuery,
  GetSubscriptionObjectForCmsQueryVariables,
  GetSubscriptionObjectForCmsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubscriptionObjectForCmsQuery, GetSubscriptionObjectForCmsQueryVariables, GetSubscriptionObjectForCmsProps<TChildProps, TDataName>>(GetSubscriptionObjectForCmsDocument, {
      alias: 'getSubscriptionObjectForCms',
      ...operationOptions
    });
};

/**
 * __useGetSubscriptionObjectForCmsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionObjectForCmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionObjectForCmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionObjectForCmsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionObjectForCmsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubscriptionObjectForCmsQuery, GetSubscriptionObjectForCmsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubscriptionObjectForCmsQuery, GetSubscriptionObjectForCmsQueryVariables>(GetSubscriptionObjectForCmsDocument, baseOptions);
      }
export function useGetSubscriptionObjectForCmsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubscriptionObjectForCmsQuery, GetSubscriptionObjectForCmsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubscriptionObjectForCmsQuery, GetSubscriptionObjectForCmsQueryVariables>(GetSubscriptionObjectForCmsDocument, baseOptions);
        }
export type GetSubscriptionObjectForCmsQueryHookResult = ReturnType<typeof useGetSubscriptionObjectForCmsQuery>;
export type GetSubscriptionObjectForCmsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionObjectForCmsLazyQuery>;
export type GetSubscriptionObjectForCmsQueryResult = ApolloReactCommon.QueryResult<GetSubscriptionObjectForCmsQuery, GetSubscriptionObjectForCmsQueryVariables>;
export const GetEmptySearchesDocument = gql`
    query GetEmptySearches($date: timestamptz) {
  empty_searches(
    order_by: {created_at: desc}
    limit: 50
    where: {created_at: {_gte: $date}}
  ) {
    id
    string
  }
}
    `;
export type GetEmptySearchesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetEmptySearchesQuery, GetEmptySearchesQueryVariables>, 'query'>;

    export const GetEmptySearchesComponent = (props: GetEmptySearchesComponentProps) => (
      <ApolloReactComponents.Query<GetEmptySearchesQuery, GetEmptySearchesQueryVariables> query={GetEmptySearchesDocument} {...props} />
    );
    
export type GetEmptySearchesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEmptySearchesQuery, GetEmptySearchesQueryVariables>
    } & TChildProps;
export function withGetEmptySearches<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEmptySearchesQuery,
  GetEmptySearchesQueryVariables,
  GetEmptySearchesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEmptySearchesQuery, GetEmptySearchesQueryVariables, GetEmptySearchesProps<TChildProps, TDataName>>(GetEmptySearchesDocument, {
      alias: 'getEmptySearches',
      ...operationOptions
    });
};

/**
 * __useGetEmptySearchesQuery__
 *
 * To run a query within a React component, call `useGetEmptySearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmptySearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmptySearchesQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetEmptySearchesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEmptySearchesQuery, GetEmptySearchesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEmptySearchesQuery, GetEmptySearchesQueryVariables>(GetEmptySearchesDocument, baseOptions);
      }
export function useGetEmptySearchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmptySearchesQuery, GetEmptySearchesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEmptySearchesQuery, GetEmptySearchesQueryVariables>(GetEmptySearchesDocument, baseOptions);
        }
export type GetEmptySearchesQueryHookResult = ReturnType<typeof useGetEmptySearchesQuery>;
export type GetEmptySearchesLazyQueryHookResult = ReturnType<typeof useGetEmptySearchesLazyQuery>;
export type GetEmptySearchesQueryResult = ApolloReactCommon.QueryResult<GetEmptySearchesQuery, GetEmptySearchesQueryVariables>;
export const GetJarAmountDocument = gql`
    query GetJarAmount {
  pif_donations_aggregate(
    where: {_or: [{order: {status: {_nin: [cancelled, draft, refunded]}}}, {order_id: {_is_null: true}}]}
  ) {
    aggregate {
      sum {
        amount
      }
    }
  }
}
    `;
export type GetJarAmountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetJarAmountQuery, GetJarAmountQueryVariables>, 'query'>;

    export const GetJarAmountComponent = (props: GetJarAmountComponentProps) => (
      <ApolloReactComponents.Query<GetJarAmountQuery, GetJarAmountQueryVariables> query={GetJarAmountDocument} {...props} />
    );
    
export type GetJarAmountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetJarAmountQuery, GetJarAmountQueryVariables>
    } & TChildProps;
export function withGetJarAmount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetJarAmountQuery,
  GetJarAmountQueryVariables,
  GetJarAmountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetJarAmountQuery, GetJarAmountQueryVariables, GetJarAmountProps<TChildProps, TDataName>>(GetJarAmountDocument, {
      alias: 'getJarAmount',
      ...operationOptions
    });
};

/**
 * __useGetJarAmountQuery__
 *
 * To run a query within a React component, call `useGetJarAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJarAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJarAmountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJarAmountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetJarAmountQuery, GetJarAmountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetJarAmountQuery, GetJarAmountQueryVariables>(GetJarAmountDocument, baseOptions);
      }
export function useGetJarAmountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetJarAmountQuery, GetJarAmountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetJarAmountQuery, GetJarAmountQueryVariables>(GetJarAmountDocument, baseOptions);
        }
export type GetJarAmountQueryHookResult = ReturnType<typeof useGetJarAmountQuery>;
export type GetJarAmountLazyQueryHookResult = ReturnType<typeof useGetJarAmountLazyQuery>;
export type GetJarAmountQueryResult = ApolloReactCommon.QueryResult<GetJarAmountQuery, GetJarAmountQueryVariables>;
export const WithdrawFromJarDocument = gql`
    mutation WithdrawFromJar($amount: Int) {
  insert_pif_donations_one(object: {amount: $amount}) {
    id
  }
}
    `;
export type WithdrawFromJarMutationFn = ApolloReactCommon.MutationFunction<WithdrawFromJarMutation, WithdrawFromJarMutationVariables>;
export type WithdrawFromJarComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<WithdrawFromJarMutation, WithdrawFromJarMutationVariables>, 'mutation'>;

    export const WithdrawFromJarComponent = (props: WithdrawFromJarComponentProps) => (
      <ApolloReactComponents.Mutation<WithdrawFromJarMutation, WithdrawFromJarMutationVariables> mutation={WithdrawFromJarDocument} {...props} />
    );
    
export type WithdrawFromJarProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<WithdrawFromJarMutation, WithdrawFromJarMutationVariables>
    } & TChildProps;
export function withWithdrawFromJar<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  WithdrawFromJarMutation,
  WithdrawFromJarMutationVariables,
  WithdrawFromJarProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, WithdrawFromJarMutation, WithdrawFromJarMutationVariables, WithdrawFromJarProps<TChildProps, TDataName>>(WithdrawFromJarDocument, {
      alias: 'withdrawFromJar',
      ...operationOptions
    });
};

/**
 * __useWithdrawFromJarMutation__
 *
 * To run a mutation, you first call `useWithdrawFromJarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawFromJarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawFromJarMutation, { data, loading, error }] = useWithdrawFromJarMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useWithdrawFromJarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WithdrawFromJarMutation, WithdrawFromJarMutationVariables>) {
        return ApolloReactHooks.useMutation<WithdrawFromJarMutation, WithdrawFromJarMutationVariables>(WithdrawFromJarDocument, baseOptions);
      }
export type WithdrawFromJarMutationHookResult = ReturnType<typeof useWithdrawFromJarMutation>;
export type WithdrawFromJarMutationResult = ApolloReactCommon.MutationResult<WithdrawFromJarMutation>;
export type WithdrawFromJarMutationOptions = ApolloReactCommon.BaseMutationOptions<WithdrawFromJarMutation, WithdrawFromJarMutationVariables>;
export const GetTotalOrdersDocument = gql`
    query GetTotalOrders($fromDate: timestamptz = "2021-4-5") {
  orders_aggregate(where: {date_created: {_gte: $fromDate}}) {
    aggregate {
      count
    }
  }
  order_book_aggregate(where: {order: {date_created: {_gte: $fromDate}}}) {
    aggregate {
      sum {
        quantity
      }
    }
  }
}
    `;
export type GetTotalOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTotalOrdersQuery, GetTotalOrdersQueryVariables>, 'query'>;

    export const GetTotalOrdersComponent = (props: GetTotalOrdersComponentProps) => (
      <ApolloReactComponents.Query<GetTotalOrdersQuery, GetTotalOrdersQueryVariables> query={GetTotalOrdersDocument} {...props} />
    );
    
export type GetTotalOrdersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTotalOrdersQuery, GetTotalOrdersQueryVariables>
    } & TChildProps;
export function withGetTotalOrders<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTotalOrdersQuery,
  GetTotalOrdersQueryVariables,
  GetTotalOrdersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTotalOrdersQuery, GetTotalOrdersQueryVariables, GetTotalOrdersProps<TChildProps, TDataName>>(GetTotalOrdersDocument, {
      alias: 'getTotalOrders',
      ...operationOptions
    });
};

/**
 * __useGetTotalOrdersQuery__
 *
 * To run a query within a React component, call `useGetTotalOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalOrdersQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useGetTotalOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTotalOrdersQuery, GetTotalOrdersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTotalOrdersQuery, GetTotalOrdersQueryVariables>(GetTotalOrdersDocument, baseOptions);
      }
export function useGetTotalOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTotalOrdersQuery, GetTotalOrdersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTotalOrdersQuery, GetTotalOrdersQueryVariables>(GetTotalOrdersDocument, baseOptions);
        }
export type GetTotalOrdersQueryHookResult = ReturnType<typeof useGetTotalOrdersQuery>;
export type GetTotalOrdersLazyQueryHookResult = ReturnType<typeof useGetTotalOrdersLazyQuery>;
export type GetTotalOrdersQueryResult = ApolloReactCommon.QueryResult<GetTotalOrdersQuery, GetTotalOrdersQueryVariables>;
export const RemoveAttendeeDocument = gql`
    mutation RemoveAttendee($id: uuid!) {
  update_event_tickets_by_pk(pk_columns: {id: $id}, _set: {is_attending: false}) {
    id
    is_attending
  }
}
    `;
export type RemoveAttendeeMutationFn = ApolloReactCommon.MutationFunction<RemoveAttendeeMutation, RemoveAttendeeMutationVariables>;
export type RemoveAttendeeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveAttendeeMutation, RemoveAttendeeMutationVariables>, 'mutation'>;

    export const RemoveAttendeeComponent = (props: RemoveAttendeeComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveAttendeeMutation, RemoveAttendeeMutationVariables> mutation={RemoveAttendeeDocument} {...props} />
    );
    
export type RemoveAttendeeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveAttendeeMutation, RemoveAttendeeMutationVariables>
    } & TChildProps;
export function withRemoveAttendee<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveAttendeeMutation,
  RemoveAttendeeMutationVariables,
  RemoveAttendeeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveAttendeeMutation, RemoveAttendeeMutationVariables, RemoveAttendeeProps<TChildProps, TDataName>>(RemoveAttendeeDocument, {
      alias: 'removeAttendee',
      ...operationOptions
    });
};

/**
 * __useRemoveAttendeeMutation__
 *
 * To run a mutation, you first call `useRemoveAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttendeeMutation, { data, loading, error }] = useRemoveAttendeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAttendeeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAttendeeMutation, RemoveAttendeeMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveAttendeeMutation, RemoveAttendeeMutationVariables>(RemoveAttendeeDocument, baseOptions);
      }
export type RemoveAttendeeMutationHookResult = ReturnType<typeof useRemoveAttendeeMutation>;
export type RemoveAttendeeMutationResult = ApolloReactCommon.MutationResult<RemoveAttendeeMutation>;
export type RemoveAttendeeMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveAttendeeMutation, RemoveAttendeeMutationVariables>;
export const ManuallyAddAttendeeDocument = gql`
    mutation ManuallyAddAttendee($data: event_tickets_insert_input!) {
  insert_event_tickets_one(object: $data) {
    id
  }
}
    `;
export type ManuallyAddAttendeeMutationFn = ApolloReactCommon.MutationFunction<ManuallyAddAttendeeMutation, ManuallyAddAttendeeMutationVariables>;
export type ManuallyAddAttendeeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ManuallyAddAttendeeMutation, ManuallyAddAttendeeMutationVariables>, 'mutation'>;

    export const ManuallyAddAttendeeComponent = (props: ManuallyAddAttendeeComponentProps) => (
      <ApolloReactComponents.Mutation<ManuallyAddAttendeeMutation, ManuallyAddAttendeeMutationVariables> mutation={ManuallyAddAttendeeDocument} {...props} />
    );
    
export type ManuallyAddAttendeeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ManuallyAddAttendeeMutation, ManuallyAddAttendeeMutationVariables>
    } & TChildProps;
export function withManuallyAddAttendee<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ManuallyAddAttendeeMutation,
  ManuallyAddAttendeeMutationVariables,
  ManuallyAddAttendeeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ManuallyAddAttendeeMutation, ManuallyAddAttendeeMutationVariables, ManuallyAddAttendeeProps<TChildProps, TDataName>>(ManuallyAddAttendeeDocument, {
      alias: 'manuallyAddAttendee',
      ...operationOptions
    });
};

/**
 * __useManuallyAddAttendeeMutation__
 *
 * To run a mutation, you first call `useManuallyAddAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManuallyAddAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manuallyAddAttendeeMutation, { data, loading, error }] = useManuallyAddAttendeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useManuallyAddAttendeeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ManuallyAddAttendeeMutation, ManuallyAddAttendeeMutationVariables>) {
        return ApolloReactHooks.useMutation<ManuallyAddAttendeeMutation, ManuallyAddAttendeeMutationVariables>(ManuallyAddAttendeeDocument, baseOptions);
      }
export type ManuallyAddAttendeeMutationHookResult = ReturnType<typeof useManuallyAddAttendeeMutation>;
export type ManuallyAddAttendeeMutationResult = ApolloReactCommon.MutationResult<ManuallyAddAttendeeMutation>;
export type ManuallyAddAttendeeMutationOptions = ApolloReactCommon.BaseMutationOptions<ManuallyAddAttendeeMutation, ManuallyAddAttendeeMutationVariables>;
export const RedeemAllVouchersDocument = gql`
    mutation RedeemAllVouchers($ids: [String!]) {
  update_vouchers(where: {id: {_in: $ids}}, _set: {remaining_amount: 0}) {
    affected_rows
  }
}
    `;
export type RedeemAllVouchersMutationFn = ApolloReactCommon.MutationFunction<RedeemAllVouchersMutation, RedeemAllVouchersMutationVariables>;
export type RedeemAllVouchersComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RedeemAllVouchersMutation, RedeemAllVouchersMutationVariables>, 'mutation'>;

    export const RedeemAllVouchersComponent = (props: RedeemAllVouchersComponentProps) => (
      <ApolloReactComponents.Mutation<RedeemAllVouchersMutation, RedeemAllVouchersMutationVariables> mutation={RedeemAllVouchersDocument} {...props} />
    );
    
export type RedeemAllVouchersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RedeemAllVouchersMutation, RedeemAllVouchersMutationVariables>
    } & TChildProps;
export function withRedeemAllVouchers<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RedeemAllVouchersMutation,
  RedeemAllVouchersMutationVariables,
  RedeemAllVouchersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RedeemAllVouchersMutation, RedeemAllVouchersMutationVariables, RedeemAllVouchersProps<TChildProps, TDataName>>(RedeemAllVouchersDocument, {
      alias: 'redeemAllVouchers',
      ...operationOptions
    });
};

/**
 * __useRedeemAllVouchersMutation__
 *
 * To run a mutation, you first call `useRedeemAllVouchersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemAllVouchersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemAllVouchersMutation, { data, loading, error }] = useRedeemAllVouchersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRedeemAllVouchersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RedeemAllVouchersMutation, RedeemAllVouchersMutationVariables>) {
        return ApolloReactHooks.useMutation<RedeemAllVouchersMutation, RedeemAllVouchersMutationVariables>(RedeemAllVouchersDocument, baseOptions);
      }
export type RedeemAllVouchersMutationHookResult = ReturnType<typeof useRedeemAllVouchersMutation>;
export type RedeemAllVouchersMutationResult = ApolloReactCommon.MutationResult<RedeemAllVouchersMutation>;
export type RedeemAllVouchersMutationOptions = ApolloReactCommon.BaseMutationOptions<RedeemAllVouchersMutation, RedeemAllVouchersMutationVariables>;
export const GetAllBooksellersDocument = gql`
    query GetAllBooksellers {
  booksellers(order_by: {id: asc}) {
    id
    name
    avatar
    video_url
  }
}
    `;
export type GetAllBooksellersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllBooksellersQuery, GetAllBooksellersQueryVariables>, 'query'>;

    export const GetAllBooksellersComponent = (props: GetAllBooksellersComponentProps) => (
      <ApolloReactComponents.Query<GetAllBooksellersQuery, GetAllBooksellersQueryVariables> query={GetAllBooksellersDocument} {...props} />
    );
    
export type GetAllBooksellersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllBooksellersQuery, GetAllBooksellersQueryVariables>
    } & TChildProps;
export function withGetAllBooksellers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllBooksellersQuery,
  GetAllBooksellersQueryVariables,
  GetAllBooksellersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllBooksellersQuery, GetAllBooksellersQueryVariables, GetAllBooksellersProps<TChildProps, TDataName>>(GetAllBooksellersDocument, {
      alias: 'getAllBooksellers',
      ...operationOptions
    });
};

/**
 * __useGetAllBooksellersQuery__
 *
 * To run a query within a React component, call `useGetAllBooksellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBooksellersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBooksellersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllBooksellersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllBooksellersQuery, GetAllBooksellersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllBooksellersQuery, GetAllBooksellersQueryVariables>(GetAllBooksellersDocument, baseOptions);
      }
export function useGetAllBooksellersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllBooksellersQuery, GetAllBooksellersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllBooksellersQuery, GetAllBooksellersQueryVariables>(GetAllBooksellersDocument, baseOptions);
        }
export type GetAllBooksellersQueryHookResult = ReturnType<typeof useGetAllBooksellersQuery>;
export type GetAllBooksellersLazyQueryHookResult = ReturnType<typeof useGetAllBooksellersLazyQuery>;
export type GetAllBooksellersQueryResult = ApolloReactCommon.QueryResult<GetAllBooksellersQuery, GetAllBooksellersQueryVariables>;
export const UpdateBooksellerDocument = gql`
    mutation UpdateBookseller($data: booksellers_set_input, $id: Int!) {
  update_booksellers_by_pk(pk_columns: {id: $id}, _set: $data) {
    id
    avatar
    name
    video_url
  }
}
    `;
export type UpdateBooksellerMutationFn = ApolloReactCommon.MutationFunction<UpdateBooksellerMutation, UpdateBooksellerMutationVariables>;
export type UpdateBooksellerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateBooksellerMutation, UpdateBooksellerMutationVariables>, 'mutation'>;

    export const UpdateBooksellerComponent = (props: UpdateBooksellerComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateBooksellerMutation, UpdateBooksellerMutationVariables> mutation={UpdateBooksellerDocument} {...props} />
    );
    
export type UpdateBooksellerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateBooksellerMutation, UpdateBooksellerMutationVariables>
    } & TChildProps;
export function withUpdateBookseller<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateBooksellerMutation,
  UpdateBooksellerMutationVariables,
  UpdateBooksellerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateBooksellerMutation, UpdateBooksellerMutationVariables, UpdateBooksellerProps<TChildProps, TDataName>>(UpdateBooksellerDocument, {
      alias: 'updateBookseller',
      ...operationOptions
    });
};

/**
 * __useUpdateBooksellerMutation__
 *
 * To run a mutation, you first call `useUpdateBooksellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBooksellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBooksellerMutation, { data, loading, error }] = useUpdateBooksellerMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateBooksellerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBooksellerMutation, UpdateBooksellerMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBooksellerMutation, UpdateBooksellerMutationVariables>(UpdateBooksellerDocument, baseOptions);
      }
export type UpdateBooksellerMutationHookResult = ReturnType<typeof useUpdateBooksellerMutation>;
export type UpdateBooksellerMutationResult = ApolloReactCommon.MutationResult<UpdateBooksellerMutation>;
export type UpdateBooksellerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBooksellerMutation, UpdateBooksellerMutationVariables>;
export const RemoveBooksellerDocument = gql`
    mutation RemoveBookseller($id: Int!) {
  delete_booksellers_by_pk(id: $id) {
    id
  }
}
    `;
export type RemoveBooksellerMutationFn = ApolloReactCommon.MutationFunction<RemoveBooksellerMutation, RemoveBooksellerMutationVariables>;
export type RemoveBooksellerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveBooksellerMutation, RemoveBooksellerMutationVariables>, 'mutation'>;

    export const RemoveBooksellerComponent = (props: RemoveBooksellerComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveBooksellerMutation, RemoveBooksellerMutationVariables> mutation={RemoveBooksellerDocument} {...props} />
    );
    
export type RemoveBooksellerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveBooksellerMutation, RemoveBooksellerMutationVariables>
    } & TChildProps;
export function withRemoveBookseller<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveBooksellerMutation,
  RemoveBooksellerMutationVariables,
  RemoveBooksellerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveBooksellerMutation, RemoveBooksellerMutationVariables, RemoveBooksellerProps<TChildProps, TDataName>>(RemoveBooksellerDocument, {
      alias: 'removeBookseller',
      ...operationOptions
    });
};

/**
 * __useRemoveBooksellerMutation__
 *
 * To run a mutation, you first call `useRemoveBooksellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBooksellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBooksellerMutation, { data, loading, error }] = useRemoveBooksellerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveBooksellerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveBooksellerMutation, RemoveBooksellerMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveBooksellerMutation, RemoveBooksellerMutationVariables>(RemoveBooksellerDocument, baseOptions);
      }
export type RemoveBooksellerMutationHookResult = ReturnType<typeof useRemoveBooksellerMutation>;
export type RemoveBooksellerMutationResult = ApolloReactCommon.MutationResult<RemoveBooksellerMutation>;
export type RemoveBooksellerMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveBooksellerMutation, RemoveBooksellerMutationVariables>;
export const NewBooksellerDocument = gql`
    mutation NewBookseller($data: booksellers_insert_input!) {
  insert_booksellers_one(object: $data) {
    id
  }
}
    `;
export type NewBooksellerMutationFn = ApolloReactCommon.MutationFunction<NewBooksellerMutation, NewBooksellerMutationVariables>;
export type NewBooksellerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<NewBooksellerMutation, NewBooksellerMutationVariables>, 'mutation'>;

    export const NewBooksellerComponent = (props: NewBooksellerComponentProps) => (
      <ApolloReactComponents.Mutation<NewBooksellerMutation, NewBooksellerMutationVariables> mutation={NewBooksellerDocument} {...props} />
    );
    
export type NewBooksellerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<NewBooksellerMutation, NewBooksellerMutationVariables>
    } & TChildProps;
export function withNewBookseller<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NewBooksellerMutation,
  NewBooksellerMutationVariables,
  NewBooksellerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, NewBooksellerMutation, NewBooksellerMutationVariables, NewBooksellerProps<TChildProps, TDataName>>(NewBooksellerDocument, {
      alias: 'newBookseller',
      ...operationOptions
    });
};

/**
 * __useNewBooksellerMutation__
 *
 * To run a mutation, you first call `useNewBooksellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewBooksellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newBooksellerMutation, { data, loading, error }] = useNewBooksellerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNewBooksellerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NewBooksellerMutation, NewBooksellerMutationVariables>) {
        return ApolloReactHooks.useMutation<NewBooksellerMutation, NewBooksellerMutationVariables>(NewBooksellerDocument, baseOptions);
      }
export type NewBooksellerMutationHookResult = ReturnType<typeof useNewBooksellerMutation>;
export type NewBooksellerMutationResult = ApolloReactCommon.MutationResult<NewBooksellerMutation>;
export type NewBooksellerMutationOptions = ApolloReactCommon.BaseMutationOptions<NewBooksellerMutation, NewBooksellerMutationVariables>;
export const GetAlertsDocument = gql`
    query GetAlerts {
  unstructured_data_by_pk(title: "alert") {
    data
    title
  }
}
    `;
export type GetAlertsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAlertsQuery, GetAlertsQueryVariables>, 'query'>;

    export const GetAlertsComponent = (props: GetAlertsComponentProps) => (
      <ApolloReactComponents.Query<GetAlertsQuery, GetAlertsQueryVariables> query={GetAlertsDocument} {...props} />
    );
    
export type GetAlertsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAlertsQuery, GetAlertsQueryVariables>
    } & TChildProps;
export function withGetAlerts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAlertsQuery,
  GetAlertsQueryVariables,
  GetAlertsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAlertsQuery, GetAlertsQueryVariables, GetAlertsProps<TChildProps, TDataName>>(GetAlertsDocument, {
      alias: 'getAlerts',
      ...operationOptions
    });
};

/**
 * __useGetAlertsQuery__
 *
 * To run a query within a React component, call `useGetAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAlertsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAlertsQuery, GetAlertsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAlertsQuery, GetAlertsQueryVariables>(GetAlertsDocument, baseOptions);
      }
export function useGetAlertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAlertsQuery, GetAlertsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAlertsQuery, GetAlertsQueryVariables>(GetAlertsDocument, baseOptions);
        }
export type GetAlertsQueryHookResult = ReturnType<typeof useGetAlertsQuery>;
export type GetAlertsLazyQueryHookResult = ReturnType<typeof useGetAlertsLazyQuery>;
export type GetAlertsQueryResult = ApolloReactCommon.QueryResult<GetAlertsQuery, GetAlertsQueryVariables>;
export const AddAlertDocument = gql`
    mutation AddAlert($data: jsonb) {
  update_unstructured_data_by_pk(
    pk_columns: {title: "alert"}
    _set: {data: $data}
  ) {
    data
  }
}
    `;
export type AddAlertMutationFn = ApolloReactCommon.MutationFunction<AddAlertMutation, AddAlertMutationVariables>;
export type AddAlertComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddAlertMutation, AddAlertMutationVariables>, 'mutation'>;

    export const AddAlertComponent = (props: AddAlertComponentProps) => (
      <ApolloReactComponents.Mutation<AddAlertMutation, AddAlertMutationVariables> mutation={AddAlertDocument} {...props} />
    );
    
export type AddAlertProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddAlertMutation, AddAlertMutationVariables>
    } & TChildProps;
export function withAddAlert<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddAlertMutation,
  AddAlertMutationVariables,
  AddAlertProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddAlertMutation, AddAlertMutationVariables, AddAlertProps<TChildProps, TDataName>>(AddAlertDocument, {
      alias: 'addAlert',
      ...operationOptions
    });
};

/**
 * __useAddAlertMutation__
 *
 * To run a mutation, you first call `useAddAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAlertMutation, { data, loading, error }] = useAddAlertMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAlertMutation, AddAlertMutationVariables>) {
        return ApolloReactHooks.useMutation<AddAlertMutation, AddAlertMutationVariables>(AddAlertDocument, baseOptions);
      }
export type AddAlertMutationHookResult = ReturnType<typeof useAddAlertMutation>;
export type AddAlertMutationResult = ApolloReactCommon.MutationResult<AddAlertMutation>;
export type AddAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<AddAlertMutation, AddAlertMutationVariables>;
export const GetShopDetailsDocument = gql`
    query GetShopDetails {
  unstructured_data(where: {title: {_in: ["address", "opening_hours"]}}) {
    title
    data
  }
  booksellers {
    id
    name
    about
  }
}
    `;
export type GetShopDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShopDetailsQuery, GetShopDetailsQueryVariables>, 'query'>;

    export const GetShopDetailsComponent = (props: GetShopDetailsComponentProps) => (
      <ApolloReactComponents.Query<GetShopDetailsQuery, GetShopDetailsQueryVariables> query={GetShopDetailsDocument} {...props} />
    );
    
export type GetShopDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetShopDetailsQuery, GetShopDetailsQueryVariables>
    } & TChildProps;
export function withGetShopDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetShopDetailsQuery,
  GetShopDetailsQueryVariables,
  GetShopDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetShopDetailsQuery, GetShopDetailsQueryVariables, GetShopDetailsProps<TChildProps, TDataName>>(GetShopDetailsDocument, {
      alias: 'getShopDetails',
      ...operationOptions
    });
};

/**
 * __useGetShopDetailsQuery__
 *
 * To run a query within a React component, call `useGetShopDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShopDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetShopDetailsQuery, GetShopDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetShopDetailsQuery, GetShopDetailsQueryVariables>(GetShopDetailsDocument, baseOptions);
      }
export function useGetShopDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShopDetailsQuery, GetShopDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetShopDetailsQuery, GetShopDetailsQueryVariables>(GetShopDetailsDocument, baseOptions);
        }
export type GetShopDetailsQueryHookResult = ReturnType<typeof useGetShopDetailsQuery>;
export type GetShopDetailsLazyQueryHookResult = ReturnType<typeof useGetShopDetailsLazyQuery>;
export type GetShopDetailsQueryResult = ApolloReactCommon.QueryResult<GetShopDetailsQuery, GetShopDetailsQueryVariables>;
export const UpdateUnstructuredDataDocument = gql`
    mutation UpdateUnstructuredData($title: String!, $data: jsonb) {
  update_unstructured_data_by_pk(pk_columns: {title: $title}, _set: {data: $data}) {
    title
  }
}
    `;
export type UpdateUnstructuredDataMutationFn = ApolloReactCommon.MutationFunction<UpdateUnstructuredDataMutation, UpdateUnstructuredDataMutationVariables>;
export type UpdateUnstructuredDataComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUnstructuredDataMutation, UpdateUnstructuredDataMutationVariables>, 'mutation'>;

    export const UpdateUnstructuredDataComponent = (props: UpdateUnstructuredDataComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUnstructuredDataMutation, UpdateUnstructuredDataMutationVariables> mutation={UpdateUnstructuredDataDocument} {...props} />
    );
    
export type UpdateUnstructuredDataProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateUnstructuredDataMutation, UpdateUnstructuredDataMutationVariables>
    } & TChildProps;
export function withUpdateUnstructuredData<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUnstructuredDataMutation,
  UpdateUnstructuredDataMutationVariables,
  UpdateUnstructuredDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUnstructuredDataMutation, UpdateUnstructuredDataMutationVariables, UpdateUnstructuredDataProps<TChildProps, TDataName>>(UpdateUnstructuredDataDocument, {
      alias: 'updateUnstructuredData',
      ...operationOptions
    });
};

/**
 * __useUpdateUnstructuredDataMutation__
 *
 * To run a mutation, you first call `useUpdateUnstructuredDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnstructuredDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnstructuredDataMutation, { data, loading, error }] = useUpdateUnstructuredDataMutation({
 *   variables: {
 *      title: // value for 'title'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUnstructuredDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUnstructuredDataMutation, UpdateUnstructuredDataMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUnstructuredDataMutation, UpdateUnstructuredDataMutationVariables>(UpdateUnstructuredDataDocument, baseOptions);
      }
export type UpdateUnstructuredDataMutationHookResult = ReturnType<typeof useUpdateUnstructuredDataMutation>;
export type UpdateUnstructuredDataMutationResult = ApolloReactCommon.MutationResult<UpdateUnstructuredDataMutation>;
export type UpdateUnstructuredDataMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUnstructuredDataMutation, UpdateUnstructuredDataMutationVariables>;
export const GetWrapppingPriceDocument = gql`
    query GetWrapppingPrice {
  unstructured_data_by_pk(title: "wrapping") {
    title
    data
  }
}
    `;
export type GetWrapppingPriceComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetWrapppingPriceQuery, GetWrapppingPriceQueryVariables>, 'query'>;

    export const GetWrapppingPriceComponent = (props: GetWrapppingPriceComponentProps) => (
      <ApolloReactComponents.Query<GetWrapppingPriceQuery, GetWrapppingPriceQueryVariables> query={GetWrapppingPriceDocument} {...props} />
    );
    
export type GetWrapppingPriceProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetWrapppingPriceQuery, GetWrapppingPriceQueryVariables>
    } & TChildProps;
export function withGetWrapppingPrice<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetWrapppingPriceQuery,
  GetWrapppingPriceQueryVariables,
  GetWrapppingPriceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetWrapppingPriceQuery, GetWrapppingPriceQueryVariables, GetWrapppingPriceProps<TChildProps, TDataName>>(GetWrapppingPriceDocument, {
      alias: 'getWrapppingPrice',
      ...operationOptions
    });
};

/**
 * __useGetWrapppingPriceQuery__
 *
 * To run a query within a React component, call `useGetWrapppingPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWrapppingPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWrapppingPriceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWrapppingPriceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWrapppingPriceQuery, GetWrapppingPriceQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWrapppingPriceQuery, GetWrapppingPriceQueryVariables>(GetWrapppingPriceDocument, baseOptions);
      }
export function useGetWrapppingPriceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWrapppingPriceQuery, GetWrapppingPriceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWrapppingPriceQuery, GetWrapppingPriceQueryVariables>(GetWrapppingPriceDocument, baseOptions);
        }
export type GetWrapppingPriceQueryHookResult = ReturnType<typeof useGetWrapppingPriceQuery>;
export type GetWrapppingPriceLazyQueryHookResult = ReturnType<typeof useGetWrapppingPriceLazyQuery>;
export type GetWrapppingPriceQueryResult = ApolloReactCommon.QueryResult<GetWrapppingPriceQuery, GetWrapppingPriceQueryVariables>;
export const SetWrappingPriceDocument = gql`
    mutation SetWrappingPrice($data: jsonb) {
  update_unstructured_data_by_pk(
    pk_columns: {title: "wrapping"}
    _set: {data: $data}
  ) {
    title
    data
  }
}
    `;
export type SetWrappingPriceMutationFn = ApolloReactCommon.MutationFunction<SetWrappingPriceMutation, SetWrappingPriceMutationVariables>;
export type SetWrappingPriceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetWrappingPriceMutation, SetWrappingPriceMutationVariables>, 'mutation'>;

    export const SetWrappingPriceComponent = (props: SetWrappingPriceComponentProps) => (
      <ApolloReactComponents.Mutation<SetWrappingPriceMutation, SetWrappingPriceMutationVariables> mutation={SetWrappingPriceDocument} {...props} />
    );
    
export type SetWrappingPriceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SetWrappingPriceMutation, SetWrappingPriceMutationVariables>
    } & TChildProps;
export function withSetWrappingPrice<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetWrappingPriceMutation,
  SetWrappingPriceMutationVariables,
  SetWrappingPriceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SetWrappingPriceMutation, SetWrappingPriceMutationVariables, SetWrappingPriceProps<TChildProps, TDataName>>(SetWrappingPriceDocument, {
      alias: 'setWrappingPrice',
      ...operationOptions
    });
};

/**
 * __useSetWrappingPriceMutation__
 *
 * To run a mutation, you first call `useSetWrappingPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWrappingPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWrappingPriceMutation, { data, loading, error }] = useSetWrappingPriceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetWrappingPriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetWrappingPriceMutation, SetWrappingPriceMutationVariables>) {
        return ApolloReactHooks.useMutation<SetWrappingPriceMutation, SetWrappingPriceMutationVariables>(SetWrappingPriceDocument, baseOptions);
      }
export type SetWrappingPriceMutationHookResult = ReturnType<typeof useSetWrappingPriceMutation>;
export type SetWrappingPriceMutationResult = ApolloReactCommon.MutationResult<SetWrappingPriceMutation>;
export type SetWrappingPriceMutationOptions = ApolloReactCommon.BaseMutationOptions<SetWrappingPriceMutation, SetWrappingPriceMutationVariables>;
export const GetUnstructuredDataDocument = gql`
    query GetUnstructuredData($title: String!) {
  unstructured_data_by_pk(title: $title) {
    title
    data
  }
}
    `;
export type GetUnstructuredDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUnstructuredDataQuery, GetUnstructuredDataQueryVariables>, 'query'> & ({ variables: GetUnstructuredDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUnstructuredDataComponent = (props: GetUnstructuredDataComponentProps) => (
      <ApolloReactComponents.Query<GetUnstructuredDataQuery, GetUnstructuredDataQueryVariables> query={GetUnstructuredDataDocument} {...props} />
    );
    
export type GetUnstructuredDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUnstructuredDataQuery, GetUnstructuredDataQueryVariables>
    } & TChildProps;
export function withGetUnstructuredData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUnstructuredDataQuery,
  GetUnstructuredDataQueryVariables,
  GetUnstructuredDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUnstructuredDataQuery, GetUnstructuredDataQueryVariables, GetUnstructuredDataProps<TChildProps, TDataName>>(GetUnstructuredDataDocument, {
      alias: 'getUnstructuredData',
      ...operationOptions
    });
};

/**
 * __useGetUnstructuredDataQuery__
 *
 * To run a query within a React component, call `useGetUnstructuredDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnstructuredDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnstructuredDataQuery({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useGetUnstructuredDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUnstructuredDataQuery, GetUnstructuredDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUnstructuredDataQuery, GetUnstructuredDataQueryVariables>(GetUnstructuredDataDocument, baseOptions);
      }
export function useGetUnstructuredDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnstructuredDataQuery, GetUnstructuredDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUnstructuredDataQuery, GetUnstructuredDataQueryVariables>(GetUnstructuredDataDocument, baseOptions);
        }
export type GetUnstructuredDataQueryHookResult = ReturnType<typeof useGetUnstructuredDataQuery>;
export type GetUnstructuredDataLazyQueryHookResult = ReturnType<typeof useGetUnstructuredDataLazyQuery>;
export type GetUnstructuredDataQueryResult = ApolloReactCommon.QueryResult<GetUnstructuredDataQuery, GetUnstructuredDataQueryVariables>;
export const GetShippingBlockDataDocument = gql`
    query GetShippingBlockData {
  countries(
    where: {shipping_options: {id: {_is_null: false}, deleted_at: {_is_null: true}}}
    order_by: {code: asc}
  ) {
    name
    code
    shipping_options(where: {deleted_at: {_is_null: true}}, order_by: {from: asc}) {
      __typename
      id
      name
      price
      from
      to
      description
    }
  }
  regions(
    where: {shipping_options: {id: {_is_null: false}, deleted_at: {_is_null: true}}}
    order_by: {code: asc}
  ) {
    name
    code
    shipping_options(where: {deleted_at: {_is_null: true}}, order_by: {from: asc}) {
      id
      name
      price
      from
      to
      description
    }
  }
}
    `;
export type GetShippingBlockDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShippingBlockDataQuery, GetShippingBlockDataQueryVariables>, 'query'>;

    export const GetShippingBlockDataComponent = (props: GetShippingBlockDataComponentProps) => (
      <ApolloReactComponents.Query<GetShippingBlockDataQuery, GetShippingBlockDataQueryVariables> query={GetShippingBlockDataDocument} {...props} />
    );
    
export type GetShippingBlockDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetShippingBlockDataQuery, GetShippingBlockDataQueryVariables>
    } & TChildProps;
export function withGetShippingBlockData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetShippingBlockDataQuery,
  GetShippingBlockDataQueryVariables,
  GetShippingBlockDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetShippingBlockDataQuery, GetShippingBlockDataQueryVariables, GetShippingBlockDataProps<TChildProps, TDataName>>(GetShippingBlockDataDocument, {
      alias: 'getShippingBlockData',
      ...operationOptions
    });
};

/**
 * __useGetShippingBlockDataQuery__
 *
 * To run a query within a React component, call `useGetShippingBlockDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingBlockDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingBlockDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShippingBlockDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetShippingBlockDataQuery, GetShippingBlockDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetShippingBlockDataQuery, GetShippingBlockDataQueryVariables>(GetShippingBlockDataDocument, baseOptions);
      }
export function useGetShippingBlockDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShippingBlockDataQuery, GetShippingBlockDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetShippingBlockDataQuery, GetShippingBlockDataQueryVariables>(GetShippingBlockDataDocument, baseOptions);
        }
export type GetShippingBlockDataQueryHookResult = ReturnType<typeof useGetShippingBlockDataQuery>;
export type GetShippingBlockDataLazyQueryHookResult = ReturnType<typeof useGetShippingBlockDataLazyQuery>;
export type GetShippingBlockDataQueryResult = ApolloReactCommon.QueryResult<GetShippingBlockDataQuery, GetShippingBlockDataQueryVariables>;
export const GetAllCountriesAndRegionsDocument = gql`
    query getAllCountriesAndRegions {
  regions {
    name
    code
  }
  countries {
    name
    code
  }
}
    `;
export type GetAllCountriesAndRegionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllCountriesAndRegionsQuery, GetAllCountriesAndRegionsQueryVariables>, 'query'>;

    export const GetAllCountriesAndRegionsComponent = (props: GetAllCountriesAndRegionsComponentProps) => (
      <ApolloReactComponents.Query<GetAllCountriesAndRegionsQuery, GetAllCountriesAndRegionsQueryVariables> query={GetAllCountriesAndRegionsDocument} {...props} />
    );
    
export type GetAllCountriesAndRegionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllCountriesAndRegionsQuery, GetAllCountriesAndRegionsQueryVariables>
    } & TChildProps;
export function withGetAllCountriesAndRegions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllCountriesAndRegionsQuery,
  GetAllCountriesAndRegionsQueryVariables,
  GetAllCountriesAndRegionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllCountriesAndRegionsQuery, GetAllCountriesAndRegionsQueryVariables, GetAllCountriesAndRegionsProps<TChildProps, TDataName>>(GetAllCountriesAndRegionsDocument, {
      alias: 'getAllCountriesAndRegions',
      ...operationOptions
    });
};

/**
 * __useGetAllCountriesAndRegionsQuery__
 *
 * To run a query within a React component, call `useGetAllCountriesAndRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountriesAndRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountriesAndRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCountriesAndRegionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllCountriesAndRegionsQuery, GetAllCountriesAndRegionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllCountriesAndRegionsQuery, GetAllCountriesAndRegionsQueryVariables>(GetAllCountriesAndRegionsDocument, baseOptions);
      }
export function useGetAllCountriesAndRegionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllCountriesAndRegionsQuery, GetAllCountriesAndRegionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllCountriesAndRegionsQuery, GetAllCountriesAndRegionsQueryVariables>(GetAllCountriesAndRegionsDocument, baseOptions);
        }
export type GetAllCountriesAndRegionsQueryHookResult = ReturnType<typeof useGetAllCountriesAndRegionsQuery>;
export type GetAllCountriesAndRegionsLazyQueryHookResult = ReturnType<typeof useGetAllCountriesAndRegionsLazyQuery>;
export type GetAllCountriesAndRegionsQueryResult = ApolloReactCommon.QueryResult<GetAllCountriesAndRegionsQuery, GetAllCountriesAndRegionsQueryVariables>;
export const SaveNewShippingOptionDocument = gql`
    mutation SaveNewShippingOption($shippingOption: shipping_options_insert_input!) {
  insert_shipping_options_one(object: $shippingOption) {
    __typename
    id
    description
    from
    to
    price
    region
    country
  }
}
    `;
export type SaveNewShippingOptionMutationFn = ApolloReactCommon.MutationFunction<SaveNewShippingOptionMutation, SaveNewShippingOptionMutationVariables>;
export type SaveNewShippingOptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveNewShippingOptionMutation, SaveNewShippingOptionMutationVariables>, 'mutation'>;

    export const SaveNewShippingOptionComponent = (props: SaveNewShippingOptionComponentProps) => (
      <ApolloReactComponents.Mutation<SaveNewShippingOptionMutation, SaveNewShippingOptionMutationVariables> mutation={SaveNewShippingOptionDocument} {...props} />
    );
    
export type SaveNewShippingOptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SaveNewShippingOptionMutation, SaveNewShippingOptionMutationVariables>
    } & TChildProps;
export function withSaveNewShippingOption<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SaveNewShippingOptionMutation,
  SaveNewShippingOptionMutationVariables,
  SaveNewShippingOptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SaveNewShippingOptionMutation, SaveNewShippingOptionMutationVariables, SaveNewShippingOptionProps<TChildProps, TDataName>>(SaveNewShippingOptionDocument, {
      alias: 'saveNewShippingOption',
      ...operationOptions
    });
};

/**
 * __useSaveNewShippingOptionMutation__
 *
 * To run a mutation, you first call `useSaveNewShippingOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNewShippingOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNewShippingOptionMutation, { data, loading, error }] = useSaveNewShippingOptionMutation({
 *   variables: {
 *      shippingOption: // value for 'shippingOption'
 *   },
 * });
 */
export function useSaveNewShippingOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveNewShippingOptionMutation, SaveNewShippingOptionMutationVariables>) {
        return ApolloReactHooks.useMutation<SaveNewShippingOptionMutation, SaveNewShippingOptionMutationVariables>(SaveNewShippingOptionDocument, baseOptions);
      }
export type SaveNewShippingOptionMutationHookResult = ReturnType<typeof useSaveNewShippingOptionMutation>;
export type SaveNewShippingOptionMutationResult = ApolloReactCommon.MutationResult<SaveNewShippingOptionMutation>;
export type SaveNewShippingOptionMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveNewShippingOptionMutation, SaveNewShippingOptionMutationVariables>;
export const DeleteShippingOptionDocument = gql`
    mutation deleteShippingOption($id: uuid!, $today: timestamptz!) {
  update_shipping_options_by_pk(pk_columns: {id: $id}, _set: {deleted_at: $today}) {
    id
  }
}
    `;
export type DeleteShippingOptionMutationFn = ApolloReactCommon.MutationFunction<DeleteShippingOptionMutation, DeleteShippingOptionMutationVariables>;
export type DeleteShippingOptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteShippingOptionMutation, DeleteShippingOptionMutationVariables>, 'mutation'>;

    export const DeleteShippingOptionComponent = (props: DeleteShippingOptionComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteShippingOptionMutation, DeleteShippingOptionMutationVariables> mutation={DeleteShippingOptionDocument} {...props} />
    );
    
export type DeleteShippingOptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteShippingOptionMutation, DeleteShippingOptionMutationVariables>
    } & TChildProps;
export function withDeleteShippingOption<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteShippingOptionMutation,
  DeleteShippingOptionMutationVariables,
  DeleteShippingOptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteShippingOptionMutation, DeleteShippingOptionMutationVariables, DeleteShippingOptionProps<TChildProps, TDataName>>(DeleteShippingOptionDocument, {
      alias: 'deleteShippingOption',
      ...operationOptions
    });
};

/**
 * __useDeleteShippingOptionMutation__
 *
 * To run a mutation, you first call `useDeleteShippingOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShippingOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShippingOptionMutation, { data, loading, error }] = useDeleteShippingOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      today: // value for 'today'
 *   },
 * });
 */
export function useDeleteShippingOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteShippingOptionMutation, DeleteShippingOptionMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteShippingOptionMutation, DeleteShippingOptionMutationVariables>(DeleteShippingOptionDocument, baseOptions);
      }
export type DeleteShippingOptionMutationHookResult = ReturnType<typeof useDeleteShippingOptionMutation>;
export type DeleteShippingOptionMutationResult = ApolloReactCommon.MutationResult<DeleteShippingOptionMutation>;
export type DeleteShippingOptionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteShippingOptionMutation, DeleteShippingOptionMutationVariables>;
export const AdminAddSubPriceDocument = gql`
    mutation AdminAddSubPrice($sub: subscription_price_insert_input!) {
  insert_subscription_price_one(object: $sub) {
    id
  }
}
    `;
export type AdminAddSubPriceMutationFn = ApolloReactCommon.MutationFunction<AdminAddSubPriceMutation, AdminAddSubPriceMutationVariables>;
export type AdminAddSubPriceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminAddSubPriceMutation, AdminAddSubPriceMutationVariables>, 'mutation'>;

    export const AdminAddSubPriceComponent = (props: AdminAddSubPriceComponentProps) => (
      <ApolloReactComponents.Mutation<AdminAddSubPriceMutation, AdminAddSubPriceMutationVariables> mutation={AdminAddSubPriceDocument} {...props} />
    );
    
export type AdminAddSubPriceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AdminAddSubPriceMutation, AdminAddSubPriceMutationVariables>
    } & TChildProps;
export function withAdminAddSubPrice<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AdminAddSubPriceMutation,
  AdminAddSubPriceMutationVariables,
  AdminAddSubPriceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AdminAddSubPriceMutation, AdminAddSubPriceMutationVariables, AdminAddSubPriceProps<TChildProps, TDataName>>(AdminAddSubPriceDocument, {
      alias: 'adminAddSubPrice',
      ...operationOptions
    });
};

/**
 * __useAdminAddSubPriceMutation__
 *
 * To run a mutation, you first call `useAdminAddSubPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddSubPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddSubPriceMutation, { data, loading, error }] = useAdminAddSubPriceMutation({
 *   variables: {
 *      sub: // value for 'sub'
 *   },
 * });
 */
export function useAdminAddSubPriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminAddSubPriceMutation, AdminAddSubPriceMutationVariables>) {
        return ApolloReactHooks.useMutation<AdminAddSubPriceMutation, AdminAddSubPriceMutationVariables>(AdminAddSubPriceDocument, baseOptions);
      }
export type AdminAddSubPriceMutationHookResult = ReturnType<typeof useAdminAddSubPriceMutation>;
export type AdminAddSubPriceMutationResult = ApolloReactCommon.MutationResult<AdminAddSubPriceMutation>;
export type AdminAddSubPriceMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminAddSubPriceMutation, AdminAddSubPriceMutationVariables>;
export const AdminCreateSubDocument = gql`
    mutation AdminCreateSub($sub: subscriptions_insert_input!) {
  insert_subscriptions_one(object: $sub) {
    id
  }
}
    `;
export type AdminCreateSubMutationFn = ApolloReactCommon.MutationFunction<AdminCreateSubMutation, AdminCreateSubMutationVariables>;
export type AdminCreateSubComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminCreateSubMutation, AdminCreateSubMutationVariables>, 'mutation'>;

    export const AdminCreateSubComponent = (props: AdminCreateSubComponentProps) => (
      <ApolloReactComponents.Mutation<AdminCreateSubMutation, AdminCreateSubMutationVariables> mutation={AdminCreateSubDocument} {...props} />
    );
    
export type AdminCreateSubProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AdminCreateSubMutation, AdminCreateSubMutationVariables>
    } & TChildProps;
export function withAdminCreateSub<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AdminCreateSubMutation,
  AdminCreateSubMutationVariables,
  AdminCreateSubProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AdminCreateSubMutation, AdminCreateSubMutationVariables, AdminCreateSubProps<TChildProps, TDataName>>(AdminCreateSubDocument, {
      alias: 'adminCreateSub',
      ...operationOptions
    });
};

/**
 * __useAdminCreateSubMutation__
 *
 * To run a mutation, you first call `useAdminCreateSubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateSubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateSubMutation, { data, loading, error }] = useAdminCreateSubMutation({
 *   variables: {
 *      sub: // value for 'sub'
 *   },
 * });
 */
export function useAdminCreateSubMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateSubMutation, AdminCreateSubMutationVariables>) {
        return ApolloReactHooks.useMutation<AdminCreateSubMutation, AdminCreateSubMutationVariables>(AdminCreateSubDocument, baseOptions);
      }
export type AdminCreateSubMutationHookResult = ReturnType<typeof useAdminCreateSubMutation>;
export type AdminCreateSubMutationResult = ApolloReactCommon.MutationResult<AdminCreateSubMutation>;
export type AdminCreateSubMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminCreateSubMutation, AdminCreateSubMutationVariables>;
export const AdminDeleteSubPriceDocument = gql`
    mutation AdminDeleteSubPrice($subId: uuid!, $priceId: uuid!) {
  update_subscription_price_by_pk(
    pk_columns: {id: $priceId, sub_id: $subId}
    _set: {is_deleted: true}
  ) {
    id
  }
}
    `;
export type AdminDeleteSubPriceMutationFn = ApolloReactCommon.MutationFunction<AdminDeleteSubPriceMutation, AdminDeleteSubPriceMutationVariables>;
export type AdminDeleteSubPriceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminDeleteSubPriceMutation, AdminDeleteSubPriceMutationVariables>, 'mutation'>;

    export const AdminDeleteSubPriceComponent = (props: AdminDeleteSubPriceComponentProps) => (
      <ApolloReactComponents.Mutation<AdminDeleteSubPriceMutation, AdminDeleteSubPriceMutationVariables> mutation={AdminDeleteSubPriceDocument} {...props} />
    );
    
export type AdminDeleteSubPriceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AdminDeleteSubPriceMutation, AdminDeleteSubPriceMutationVariables>
    } & TChildProps;
export function withAdminDeleteSubPrice<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AdminDeleteSubPriceMutation,
  AdminDeleteSubPriceMutationVariables,
  AdminDeleteSubPriceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AdminDeleteSubPriceMutation, AdminDeleteSubPriceMutationVariables, AdminDeleteSubPriceProps<TChildProps, TDataName>>(AdminDeleteSubPriceDocument, {
      alias: 'adminDeleteSubPrice',
      ...operationOptions
    });
};

/**
 * __useAdminDeleteSubPriceMutation__
 *
 * To run a mutation, you first call `useAdminDeleteSubPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteSubPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteSubPriceMutation, { data, loading, error }] = useAdminDeleteSubPriceMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useAdminDeleteSubPriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteSubPriceMutation, AdminDeleteSubPriceMutationVariables>) {
        return ApolloReactHooks.useMutation<AdminDeleteSubPriceMutation, AdminDeleteSubPriceMutationVariables>(AdminDeleteSubPriceDocument, baseOptions);
      }
export type AdminDeleteSubPriceMutationHookResult = ReturnType<typeof useAdminDeleteSubPriceMutation>;
export type AdminDeleteSubPriceMutationResult = ApolloReactCommon.MutationResult<AdminDeleteSubPriceMutation>;
export type AdminDeleteSubPriceMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminDeleteSubPriceMutation, AdminDeleteSubPriceMutationVariables>;
export const AdminGetAllSubsDocument = gql`
    query AdminGetAllSubs($conditions: subscriptions_bool_exp, $limit: Int, $offset: Int) {
  subscriptions(where: $conditions, limit: $limit, offset: $offset) {
    id
    title
    is_active
    subscription_objects_aggregate(where: {is_active: {_eq: true}}) {
      aggregate {
        count
      }
    }
  }
  subscriptions_aggregate(where: $conditions) {
    aggregate {
      count
    }
  }
}
    `;
export type AdminGetAllSubsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminGetAllSubsQuery, AdminGetAllSubsQueryVariables>, 'query'>;

    export const AdminGetAllSubsComponent = (props: AdminGetAllSubsComponentProps) => (
      <ApolloReactComponents.Query<AdminGetAllSubsQuery, AdminGetAllSubsQueryVariables> query={AdminGetAllSubsDocument} {...props} />
    );
    
export type AdminGetAllSubsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AdminGetAllSubsQuery, AdminGetAllSubsQueryVariables>
    } & TChildProps;
export function withAdminGetAllSubs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AdminGetAllSubsQuery,
  AdminGetAllSubsQueryVariables,
  AdminGetAllSubsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AdminGetAllSubsQuery, AdminGetAllSubsQueryVariables, AdminGetAllSubsProps<TChildProps, TDataName>>(AdminGetAllSubsDocument, {
      alias: 'adminGetAllSubs',
      ...operationOptions
    });
};

/**
 * __useAdminGetAllSubsQuery__
 *
 * To run a query within a React component, call `useAdminGetAllSubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetAllSubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetAllSubsQuery({
 *   variables: {
 *      conditions: // value for 'conditions'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminGetAllSubsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminGetAllSubsQuery, AdminGetAllSubsQueryVariables>) {
        return ApolloReactHooks.useQuery<AdminGetAllSubsQuery, AdminGetAllSubsQueryVariables>(AdminGetAllSubsDocument, baseOptions);
      }
export function useAdminGetAllSubsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminGetAllSubsQuery, AdminGetAllSubsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AdminGetAllSubsQuery, AdminGetAllSubsQueryVariables>(AdminGetAllSubsDocument, baseOptions);
        }
export type AdminGetAllSubsQueryHookResult = ReturnType<typeof useAdminGetAllSubsQuery>;
export type AdminGetAllSubsLazyQueryHookResult = ReturnType<typeof useAdminGetAllSubsLazyQuery>;
export type AdminGetAllSubsQueryResult = ApolloReactCommon.QueryResult<AdminGetAllSubsQuery, AdminGetAllSubsQueryVariables>;
export const AdminGetSubDocument = gql`
    query AdminGetSub($id: uuid!) {
  subscriptions_by_pk(id: $id) {
    id
    title
    description
    image
    slug
    is_active
    price
    note
  }
}
    `;
export type AdminGetSubComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminGetSubQuery, AdminGetSubQueryVariables>, 'query'> & ({ variables: AdminGetSubQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AdminGetSubComponent = (props: AdminGetSubComponentProps) => (
      <ApolloReactComponents.Query<AdminGetSubQuery, AdminGetSubQueryVariables> query={AdminGetSubDocument} {...props} />
    );
    
export type AdminGetSubProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AdminGetSubQuery, AdminGetSubQueryVariables>
    } & TChildProps;
export function withAdminGetSub<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AdminGetSubQuery,
  AdminGetSubQueryVariables,
  AdminGetSubProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AdminGetSubQuery, AdminGetSubQueryVariables, AdminGetSubProps<TChildProps, TDataName>>(AdminGetSubDocument, {
      alias: 'adminGetSub',
      ...operationOptions
    });
};

/**
 * __useAdminGetSubQuery__
 *
 * To run a query within a React component, call `useAdminGetSubQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetSubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetSubQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetSubQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminGetSubQuery, AdminGetSubQueryVariables>) {
        return ApolloReactHooks.useQuery<AdminGetSubQuery, AdminGetSubQueryVariables>(AdminGetSubDocument, baseOptions);
      }
export function useAdminGetSubLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminGetSubQuery, AdminGetSubQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AdminGetSubQuery, AdminGetSubQueryVariables>(AdminGetSubDocument, baseOptions);
        }
export type AdminGetSubQueryHookResult = ReturnType<typeof useAdminGetSubQuery>;
export type AdminGetSubLazyQueryHookResult = ReturnType<typeof useAdminGetSubLazyQuery>;
export type AdminGetSubQueryResult = ApolloReactCommon.QueryResult<AdminGetSubQuery, AdminGetSubQueryVariables>;
export const AdminGetSubPricesDocument = gql`
    query AdminGetSubPrices($subId: uuid!) {
  subscription_price(
    where: {_and: [{sub_id: {_eq: $subId}}, {is_deleted: {_eq: false}}]}
    order_by: {duration: asc}
  ) {
    id
    title
    duration
    price
    sub_id
    order_subscription_prices(
      where: {_and: [{sub_activated: {_eq: true}}, {fulfilled: {_eq: false}}]}
    ) {
      sub_price_id
      order_id
      total_dispatched
      last_dispatched_date
      subscription_price {
        id
        duration
      }
      address {
        name
        contact_email
        phone_number
        line_1
        line_2
        line_3
        region
        city
        country_code
        code
      }
    }
  }
}
    `;
export type AdminGetSubPricesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminGetSubPricesQuery, AdminGetSubPricesQueryVariables>, 'query'> & ({ variables: AdminGetSubPricesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AdminGetSubPricesComponent = (props: AdminGetSubPricesComponentProps) => (
      <ApolloReactComponents.Query<AdminGetSubPricesQuery, AdminGetSubPricesQueryVariables> query={AdminGetSubPricesDocument} {...props} />
    );
    
export type AdminGetSubPricesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AdminGetSubPricesQuery, AdminGetSubPricesQueryVariables>
    } & TChildProps;
export function withAdminGetSubPrices<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AdminGetSubPricesQuery,
  AdminGetSubPricesQueryVariables,
  AdminGetSubPricesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AdminGetSubPricesQuery, AdminGetSubPricesQueryVariables, AdminGetSubPricesProps<TChildProps, TDataName>>(AdminGetSubPricesDocument, {
      alias: 'adminGetSubPrices',
      ...operationOptions
    });
};

/**
 * __useAdminGetSubPricesQuery__
 *
 * To run a query within a React component, call `useAdminGetSubPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetSubPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetSubPricesQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useAdminGetSubPricesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminGetSubPricesQuery, AdminGetSubPricesQueryVariables>) {
        return ApolloReactHooks.useQuery<AdminGetSubPricesQuery, AdminGetSubPricesQueryVariables>(AdminGetSubPricesDocument, baseOptions);
      }
export function useAdminGetSubPricesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminGetSubPricesQuery, AdminGetSubPricesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AdminGetSubPricesQuery, AdminGetSubPricesQueryVariables>(AdminGetSubPricesDocument, baseOptions);
        }
export type AdminGetSubPricesQueryHookResult = ReturnType<typeof useAdminGetSubPricesQuery>;
export type AdminGetSubPricesLazyQueryHookResult = ReturnType<typeof useAdminGetSubPricesLazyQuery>;
export type AdminGetSubPricesQueryResult = ApolloReactCommon.QueryResult<AdminGetSubPricesQuery, AdminGetSubPricesQueryVariables>;
export const AdminUpdateSubDocument = gql`
    mutation AdminUpdateSub($id: uuid!, $sub: subscriptions_set_input) {
  update_subscriptions_by_pk(pk_columns: {id: $id}, _set: $sub) {
    id
  }
}
    `;
export type AdminUpdateSubMutationFn = ApolloReactCommon.MutationFunction<AdminUpdateSubMutation, AdminUpdateSubMutationVariables>;
export type AdminUpdateSubComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminUpdateSubMutation, AdminUpdateSubMutationVariables>, 'mutation'>;

    export const AdminUpdateSubComponent = (props: AdminUpdateSubComponentProps) => (
      <ApolloReactComponents.Mutation<AdminUpdateSubMutation, AdminUpdateSubMutationVariables> mutation={AdminUpdateSubDocument} {...props} />
    );
    
export type AdminUpdateSubProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AdminUpdateSubMutation, AdminUpdateSubMutationVariables>
    } & TChildProps;
export function withAdminUpdateSub<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AdminUpdateSubMutation,
  AdminUpdateSubMutationVariables,
  AdminUpdateSubProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AdminUpdateSubMutation, AdminUpdateSubMutationVariables, AdminUpdateSubProps<TChildProps, TDataName>>(AdminUpdateSubDocument, {
      alias: 'adminUpdateSub',
      ...operationOptions
    });
};

/**
 * __useAdminUpdateSubMutation__
 *
 * To run a mutation, you first call `useAdminUpdateSubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSubMutation, { data, loading, error }] = useAdminUpdateSubMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sub: // value for 'sub'
 *   },
 * });
 */
export function useAdminUpdateSubMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateSubMutation, AdminUpdateSubMutationVariables>) {
        return ApolloReactHooks.useMutation<AdminUpdateSubMutation, AdminUpdateSubMutationVariables>(AdminUpdateSubDocument, baseOptions);
      }
export type AdminUpdateSubMutationHookResult = ReturnType<typeof useAdminUpdateSubMutation>;
export type AdminUpdateSubMutationResult = ApolloReactCommon.MutationResult<AdminUpdateSubMutation>;
export type AdminUpdateSubMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminUpdateSubMutation, AdminUpdateSubMutationVariables>;
export const AdminUpdateSubPriceDocument = gql`
    mutation AdminUpdateSubPrice($subId: uuid!, $priceId: uuid!, $sub: subscription_price_set_input) {
  update_subscription_price_by_pk(
    pk_columns: {id: $priceId, sub_id: $subId}
    _set: $sub
  ) {
    id
  }
}
    `;
export type AdminUpdateSubPriceMutationFn = ApolloReactCommon.MutationFunction<AdminUpdateSubPriceMutation, AdminUpdateSubPriceMutationVariables>;
export type AdminUpdateSubPriceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminUpdateSubPriceMutation, AdminUpdateSubPriceMutationVariables>, 'mutation'>;

    export const AdminUpdateSubPriceComponent = (props: AdminUpdateSubPriceComponentProps) => (
      <ApolloReactComponents.Mutation<AdminUpdateSubPriceMutation, AdminUpdateSubPriceMutationVariables> mutation={AdminUpdateSubPriceDocument} {...props} />
    );
    
export type AdminUpdateSubPriceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AdminUpdateSubPriceMutation, AdminUpdateSubPriceMutationVariables>
    } & TChildProps;
export function withAdminUpdateSubPrice<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AdminUpdateSubPriceMutation,
  AdminUpdateSubPriceMutationVariables,
  AdminUpdateSubPriceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AdminUpdateSubPriceMutation, AdminUpdateSubPriceMutationVariables, AdminUpdateSubPriceProps<TChildProps, TDataName>>(AdminUpdateSubPriceDocument, {
      alias: 'adminUpdateSubPrice',
      ...operationOptions
    });
};

/**
 * __useAdminUpdateSubPriceMutation__
 *
 * To run a mutation, you first call `useAdminUpdateSubPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSubPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSubPriceMutation, { data, loading, error }] = useAdminUpdateSubPriceMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *      priceId: // value for 'priceId'
 *      sub: // value for 'sub'
 *   },
 * });
 */
export function useAdminUpdateSubPriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateSubPriceMutation, AdminUpdateSubPriceMutationVariables>) {
        return ApolloReactHooks.useMutation<AdminUpdateSubPriceMutation, AdminUpdateSubPriceMutationVariables>(AdminUpdateSubPriceDocument, baseOptions);
      }
export type AdminUpdateSubPriceMutationHookResult = ReturnType<typeof useAdminUpdateSubPriceMutation>;
export type AdminUpdateSubPriceMutationResult = ApolloReactCommon.MutationResult<AdminUpdateSubPriceMutation>;
export type AdminUpdateSubPriceMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminUpdateSubPriceMutation, AdminUpdateSubPriceMutationVariables>;
export const GetSubscriptionDispatchEventsDocument = gql`
    query GetSubscriptionDispatchEvents($id: uuid!) {
  subscription_dispatch(where: {subscription_id: {_eq: $id}}) {
    created_at
    id
    subscription_objects_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;
export type GetSubscriptionDispatchEventsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubscriptionDispatchEventsQuery, GetSubscriptionDispatchEventsQueryVariables>, 'query'> & ({ variables: GetSubscriptionDispatchEventsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubscriptionDispatchEventsComponent = (props: GetSubscriptionDispatchEventsComponentProps) => (
      <ApolloReactComponents.Query<GetSubscriptionDispatchEventsQuery, GetSubscriptionDispatchEventsQueryVariables> query={GetSubscriptionDispatchEventsDocument} {...props} />
    );
    
export type GetSubscriptionDispatchEventsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubscriptionDispatchEventsQuery, GetSubscriptionDispatchEventsQueryVariables>
    } & TChildProps;
export function withGetSubscriptionDispatchEvents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubscriptionDispatchEventsQuery,
  GetSubscriptionDispatchEventsQueryVariables,
  GetSubscriptionDispatchEventsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubscriptionDispatchEventsQuery, GetSubscriptionDispatchEventsQueryVariables, GetSubscriptionDispatchEventsProps<TChildProps, TDataName>>(GetSubscriptionDispatchEventsDocument, {
      alias: 'getSubscriptionDispatchEvents',
      ...operationOptions
    });
};

/**
 * __useGetSubscriptionDispatchEventsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionDispatchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionDispatchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionDispatchEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionDispatchEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubscriptionDispatchEventsQuery, GetSubscriptionDispatchEventsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubscriptionDispatchEventsQuery, GetSubscriptionDispatchEventsQueryVariables>(GetSubscriptionDispatchEventsDocument, baseOptions);
      }
export function useGetSubscriptionDispatchEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubscriptionDispatchEventsQuery, GetSubscriptionDispatchEventsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubscriptionDispatchEventsQuery, GetSubscriptionDispatchEventsQueryVariables>(GetSubscriptionDispatchEventsDocument, baseOptions);
        }
export type GetSubscriptionDispatchEventsQueryHookResult = ReturnType<typeof useGetSubscriptionDispatchEventsQuery>;
export type GetSubscriptionDispatchEventsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionDispatchEventsLazyQuery>;
export type GetSubscriptionDispatchEventsQueryResult = ApolloReactCommon.QueryResult<GetSubscriptionDispatchEventsQuery, GetSubscriptionDispatchEventsQueryVariables>;
export const AddNewSubscriberDocument = gql`
    mutation AddNewSubscriber($data: subscription_object_insert_input!) {
  insert_subscription_object_one(object: $data) {
    id
  }
}
    `;
export type AddNewSubscriberMutationFn = ApolloReactCommon.MutationFunction<AddNewSubscriberMutation, AddNewSubscriberMutationVariables>;
export type AddNewSubscriberComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddNewSubscriberMutation, AddNewSubscriberMutationVariables>, 'mutation'>;

    export const AddNewSubscriberComponent = (props: AddNewSubscriberComponentProps) => (
      <ApolloReactComponents.Mutation<AddNewSubscriberMutation, AddNewSubscriberMutationVariables> mutation={AddNewSubscriberDocument} {...props} />
    );
    
export type AddNewSubscriberProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddNewSubscriberMutation, AddNewSubscriberMutationVariables>
    } & TChildProps;
export function withAddNewSubscriber<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddNewSubscriberMutation,
  AddNewSubscriberMutationVariables,
  AddNewSubscriberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddNewSubscriberMutation, AddNewSubscriberMutationVariables, AddNewSubscriberProps<TChildProps, TDataName>>(AddNewSubscriberDocument, {
      alias: 'addNewSubscriber',
      ...operationOptions
    });
};

/**
 * __useAddNewSubscriberMutation__
 *
 * To run a mutation, you first call `useAddNewSubscriberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewSubscriberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewSubscriberMutation, { data, loading, error }] = useAddNewSubscriberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddNewSubscriberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNewSubscriberMutation, AddNewSubscriberMutationVariables>) {
        return ApolloReactHooks.useMutation<AddNewSubscriberMutation, AddNewSubscriberMutationVariables>(AddNewSubscriberDocument, baseOptions);
      }
export type AddNewSubscriberMutationHookResult = ReturnType<typeof useAddNewSubscriberMutation>;
export type AddNewSubscriberMutationResult = ApolloReactCommon.MutationResult<AddNewSubscriberMutation>;
export type AddNewSubscriberMutationOptions = ApolloReactCommon.BaseMutationOptions<AddNewSubscriberMutation, AddNewSubscriberMutationVariables>;
export const GetSubscriberStatsDocument = gql`
    query GetSubscriberStats($subId: uuid!) {
  subscriptions_by_pk(id: $subId) {
    subscription_dispatches_aggregate {
      aggregate {
        count
      }
    }
    allTimeTotal: subscription_objects_aggregate {
      aggregate {
        count
      }
    }
    activeTotal: subscription_objects_aggregate(where: {is_active: {_eq: true}}) {
      aggregate {
        count
      }
    }
    subscription_objects(order_by: [{is_active: desc}, {remaining_credits: desc}]) {
      id
      recipient
      remaining_credits
      is_active
      address {
        name
        contact_email
        phone_number
        line_1
        line_2
        line_3
        city
        region
        code
      }
      dispatches_aggregate {
        aggregate {
          count
        }
      }
      dispatches {
        subscription_dispatch {
          id
          created_at
        }
      }
    }
  }
}
    `;
export type GetSubscriberStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubscriberStatsQuery, GetSubscriberStatsQueryVariables>, 'query'> & ({ variables: GetSubscriberStatsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubscriberStatsComponent = (props: GetSubscriberStatsComponentProps) => (
      <ApolloReactComponents.Query<GetSubscriberStatsQuery, GetSubscriberStatsQueryVariables> query={GetSubscriberStatsDocument} {...props} />
    );
    
export type GetSubscriberStatsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubscriberStatsQuery, GetSubscriberStatsQueryVariables>
    } & TChildProps;
export function withGetSubscriberStats<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubscriberStatsQuery,
  GetSubscriberStatsQueryVariables,
  GetSubscriberStatsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubscriberStatsQuery, GetSubscriberStatsQueryVariables, GetSubscriberStatsProps<TChildProps, TDataName>>(GetSubscriberStatsDocument, {
      alias: 'getSubscriberStats',
      ...operationOptions
    });
};

/**
 * __useGetSubscriberStatsQuery__
 *
 * To run a query within a React component, call `useGetSubscriberStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriberStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriberStatsQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useGetSubscriberStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubscriberStatsQuery, GetSubscriberStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubscriberStatsQuery, GetSubscriberStatsQueryVariables>(GetSubscriberStatsDocument, baseOptions);
      }
export function useGetSubscriberStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubscriberStatsQuery, GetSubscriberStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubscriberStatsQuery, GetSubscriberStatsQueryVariables>(GetSubscriberStatsDocument, baseOptions);
        }
export type GetSubscriberStatsQueryHookResult = ReturnType<typeof useGetSubscriberStatsQuery>;
export type GetSubscriberStatsLazyQueryHookResult = ReturnType<typeof useGetSubscriberStatsLazyQuery>;
export type GetSubscriberStatsQueryResult = ApolloReactCommon.QueryResult<GetSubscriberStatsQuery, GetSubscriberStatsQueryVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: Int!) {
  delete_tags_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteTagMutationFn = ApolloReactCommon.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;
export type DeleteTagComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteTagMutation, DeleteTagMutationVariables>, 'mutation'>;

    export const DeleteTagComponent = (props: DeleteTagComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteTagMutation, DeleteTagMutationVariables> mutation={DeleteTagDocument} {...props} />
    );
    
export type DeleteTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>
    } & TChildProps;
export function withDeleteTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteTagMutation,
  DeleteTagMutationVariables,
  DeleteTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteTagMutation, DeleteTagMutationVariables, DeleteTagProps<TChildProps, TDataName>>(DeleteTagDocument, {
      alias: 'deleteTag',
      ...operationOptions
    });
};

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, baseOptions);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = ApolloReactCommon.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const EditTagNameDocument = gql`
    mutation EditTagName($id: Int!, $name: String!) {
  update_tags_by_pk(pk_columns: {id: $id}, _set: {text: $name}) {
    id
  }
}
    `;
export type EditTagNameMutationFn = ApolloReactCommon.MutationFunction<EditTagNameMutation, EditTagNameMutationVariables>;
export type EditTagNameComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EditTagNameMutation, EditTagNameMutationVariables>, 'mutation'>;

    export const EditTagNameComponent = (props: EditTagNameComponentProps) => (
      <ApolloReactComponents.Mutation<EditTagNameMutation, EditTagNameMutationVariables> mutation={EditTagNameDocument} {...props} />
    );
    
export type EditTagNameProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<EditTagNameMutation, EditTagNameMutationVariables>
    } & TChildProps;
export function withEditTagName<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditTagNameMutation,
  EditTagNameMutationVariables,
  EditTagNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EditTagNameMutation, EditTagNameMutationVariables, EditTagNameProps<TChildProps, TDataName>>(EditTagNameDocument, {
      alias: 'editTagName',
      ...operationOptions
    });
};

/**
 * __useEditTagNameMutation__
 *
 * To run a mutation, you first call `useEditTagNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTagNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTagNameMutation, { data, loading, error }] = useEditTagNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditTagNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditTagNameMutation, EditTagNameMutationVariables>) {
        return ApolloReactHooks.useMutation<EditTagNameMutation, EditTagNameMutationVariables>(EditTagNameDocument, baseOptions);
      }
export type EditTagNameMutationHookResult = ReturnType<typeof useEditTagNameMutation>;
export type EditTagNameMutationResult = ApolloReactCommon.MutationResult<EditTagNameMutation>;
export type EditTagNameMutationOptions = ApolloReactCommon.BaseMutationOptions<EditTagNameMutation, EditTagNameMutationVariables>;
export const GetVoucherReportDocument = gql`
    query GetVoucherReport($startDate: timestamptz, $endDate: timestamptz) {
  vouchers(
    where: {_and: [{_or: [{order_id: {_is_null: true}}, {_and: [{order_id: {_is_null: false}}, {order: {status: {_nin: [cancelled, draft]}}}]}]}, {created_at: {_gte: $startDate}}, {created_at: {_lt: $endDate}}]}
    order_by: {created_at: asc}
  ) {
    initial_amount
    created_at
  }
}
    `;
export type GetVoucherReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetVoucherReportQuery, GetVoucherReportQueryVariables>, 'query'>;

    export const GetVoucherReportComponent = (props: GetVoucherReportComponentProps) => (
      <ApolloReactComponents.Query<GetVoucherReportQuery, GetVoucherReportQueryVariables> query={GetVoucherReportDocument} {...props} />
    );
    
export type GetVoucherReportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetVoucherReportQuery, GetVoucherReportQueryVariables>
    } & TChildProps;
export function withGetVoucherReport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetVoucherReportQuery,
  GetVoucherReportQueryVariables,
  GetVoucherReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetVoucherReportQuery, GetVoucherReportQueryVariables, GetVoucherReportProps<TChildProps, TDataName>>(GetVoucherReportDocument, {
      alias: 'getVoucherReport',
      ...operationOptions
    });
};

/**
 * __useGetVoucherReportQuery__
 *
 * To run a query within a React component, call `useGetVoucherReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoucherReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoucherReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetVoucherReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVoucherReportQuery, GetVoucherReportQueryVariables>) {
        return ApolloReactHooks.useQuery<GetVoucherReportQuery, GetVoucherReportQueryVariables>(GetVoucherReportDocument, baseOptions);
      }
export function useGetVoucherReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVoucherReportQuery, GetVoucherReportQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetVoucherReportQuery, GetVoucherReportQueryVariables>(GetVoucherReportDocument, baseOptions);
        }
export type GetVoucherReportQueryHookResult = ReturnType<typeof useGetVoucherReportQuery>;
export type GetVoucherReportLazyQueryHookResult = ReturnType<typeof useGetVoucherReportLazyQuery>;
export type GetVoucherReportQueryResult = ApolloReactCommon.QueryResult<GetVoucherReportQuery, GetVoucherReportQueryVariables>;
export const GetAddressForAccountDocument = gql`
    query GetAddressForAccount($uuid: uuid!) {
  accounts_by_pk(id: $uuid) {
    id
    primary_address {
      id
      line_1
      line_2
      line_3
      region
      city
      code
      account_id
      phone_number
      country {
        code
        name
      }
      contact_email
      name
    }
    addresses {
      id
      line_1
      line_2
      line_3
      region
      phone_number
      city
      code
      account_id
      country {
        code
        name
      }
      contact_email
      name
    }
  }
}
    `;
export type GetAddressForAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAddressForAccountQuery, GetAddressForAccountQueryVariables>, 'query'> & ({ variables: GetAddressForAccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAddressForAccountComponent = (props: GetAddressForAccountComponentProps) => (
      <ApolloReactComponents.Query<GetAddressForAccountQuery, GetAddressForAccountQueryVariables> query={GetAddressForAccountDocument} {...props} />
    );
    
export type GetAddressForAccountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAddressForAccountQuery, GetAddressForAccountQueryVariables>
    } & TChildProps;
export function withGetAddressForAccount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAddressForAccountQuery,
  GetAddressForAccountQueryVariables,
  GetAddressForAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAddressForAccountQuery, GetAddressForAccountQueryVariables, GetAddressForAccountProps<TChildProps, TDataName>>(GetAddressForAccountDocument, {
      alias: 'getAddressForAccount',
      ...operationOptions
    });
};

/**
 * __useGetAddressForAccountQuery__
 *
 * To run a query within a React component, call `useGetAddressForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressForAccountQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetAddressForAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAddressForAccountQuery, GetAddressForAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAddressForAccountQuery, GetAddressForAccountQueryVariables>(GetAddressForAccountDocument, baseOptions);
      }
export function useGetAddressForAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAddressForAccountQuery, GetAddressForAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAddressForAccountQuery, GetAddressForAccountQueryVariables>(GetAddressForAccountDocument, baseOptions);
        }
export type GetAddressForAccountQueryHookResult = ReturnType<typeof useGetAddressForAccountQuery>;
export type GetAddressForAccountLazyQueryHookResult = ReturnType<typeof useGetAddressForAccountLazyQuery>;
export type GetAddressForAccountQueryResult = ApolloReactCommon.QueryResult<GetAddressForAccountQuery, GetAddressForAccountQueryVariables>;
export const GetTagsForCategoryDocument = gql`
    query GetTagsForCategory($name: [String!]) {
  tags_aggregate(
    where: {tag_books: {book: {category_books: {category_name: {_in: $name}}}}}
  ) {
    aggregate {
      count
    }
    nodes {
      tag_books_aggregate(
        where: {book: {category_books: {category_name: {_in: $name}}}}
      ) {
        aggregate {
          count
        }
      }
      id
      text
    }
  }
}
    `;
export type GetTagsForCategoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTagsForCategoryQuery, GetTagsForCategoryQueryVariables>, 'query'>;

    export const GetTagsForCategoryComponent = (props: GetTagsForCategoryComponentProps) => (
      <ApolloReactComponents.Query<GetTagsForCategoryQuery, GetTagsForCategoryQueryVariables> query={GetTagsForCategoryDocument} {...props} />
    );
    
export type GetTagsForCategoryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTagsForCategoryQuery, GetTagsForCategoryQueryVariables>
    } & TChildProps;
export function withGetTagsForCategory<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTagsForCategoryQuery,
  GetTagsForCategoryQueryVariables,
  GetTagsForCategoryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTagsForCategoryQuery, GetTagsForCategoryQueryVariables, GetTagsForCategoryProps<TChildProps, TDataName>>(GetTagsForCategoryDocument, {
      alias: 'getTagsForCategory',
      ...operationOptions
    });
};

/**
 * __useGetTagsForCategoryQuery__
 *
 * To run a query within a React component, call `useGetTagsForCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsForCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsForCategoryQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetTagsForCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTagsForCategoryQuery, GetTagsForCategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTagsForCategoryQuery, GetTagsForCategoryQueryVariables>(GetTagsForCategoryDocument, baseOptions);
      }
export function useGetTagsForCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTagsForCategoryQuery, GetTagsForCategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTagsForCategoryQuery, GetTagsForCategoryQueryVariables>(GetTagsForCategoryDocument, baseOptions);
        }
export type GetTagsForCategoryQueryHookResult = ReturnType<typeof useGetTagsForCategoryQuery>;
export type GetTagsForCategoryLazyQueryHookResult = ReturnType<typeof useGetTagsForCategoryLazyQuery>;
export type GetTagsForCategoryQueryResult = ApolloReactCommon.QueryResult<GetTagsForCategoryQuery, GetTagsForCategoryQueryVariables>;
export const GetBookCardDataDocument = gql`
    query GetBookCardData($isbn: bigint!) {
  books_by_pk(isbn: $isbn) {
    ...BookCardData
  }
}
    ${BookCardDataFragmentDoc}`;
export type GetBookCardDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBookCardDataQuery, GetBookCardDataQueryVariables>, 'query'> & ({ variables: GetBookCardDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetBookCardDataComponent = (props: GetBookCardDataComponentProps) => (
      <ApolloReactComponents.Query<GetBookCardDataQuery, GetBookCardDataQueryVariables> query={GetBookCardDataDocument} {...props} />
    );
    
export type GetBookCardDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBookCardDataQuery, GetBookCardDataQueryVariables>
    } & TChildProps;
export function withGetBookCardData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBookCardDataQuery,
  GetBookCardDataQueryVariables,
  GetBookCardDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBookCardDataQuery, GetBookCardDataQueryVariables, GetBookCardDataProps<TChildProps, TDataName>>(GetBookCardDataDocument, {
      alias: 'getBookCardData',
      ...operationOptions
    });
};

/**
 * __useGetBookCardDataQuery__
 *
 * To run a query within a React component, call `useGetBookCardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookCardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookCardDataQuery({
 *   variables: {
 *      isbn: // value for 'isbn'
 *   },
 * });
 */
export function useGetBookCardDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookCardDataQuery, GetBookCardDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookCardDataQuery, GetBookCardDataQueryVariables>(GetBookCardDataDocument, baseOptions);
      }
export function useGetBookCardDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookCardDataQuery, GetBookCardDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookCardDataQuery, GetBookCardDataQueryVariables>(GetBookCardDataDocument, baseOptions);
        }
export type GetBookCardDataQueryHookResult = ReturnType<typeof useGetBookCardDataQuery>;
export type GetBookCardDataLazyQueryHookResult = ReturnType<typeof useGetBookCardDataLazyQuery>;
export type GetBookCardDataQueryResult = ApolloReactCommon.QueryResult<GetBookCardDataQuery, GetBookCardDataQueryVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($id: bigint!) {
  delete_event_comment_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteCommentMutationFn = ApolloReactCommon.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;
export type DeleteCommentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteCommentMutation, DeleteCommentMutationVariables>, 'mutation'>;

    export const DeleteCommentComponent = (props: DeleteCommentComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteCommentMutation, DeleteCommentMutationVariables> mutation={DeleteCommentDocument} {...props} />
    );
    
export type DeleteCommentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>
    } & TChildProps;
export function withDeleteComment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteCommentMutation,
  DeleteCommentMutationVariables,
  DeleteCommentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteCommentMutation, DeleteCommentMutationVariables, DeleteCommentProps<TChildProps, TDataName>>(DeleteCommentDocument, {
      alias: 'deleteComment',
      ...operationOptions
    });
};

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, baseOptions);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = ApolloReactCommon.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const MarkCommentAsQuestionDocument = gql`
    mutation MarkCommentAsQuestion($id: bigint!, $isQuestion: Boolean) {
  update_event_comment_by_pk(
    pk_columns: {id: $id}
    _set: {is_question: $isQuestion}
  ) {
    id
    comment
    is_question
    public_account {
      id
      display_name
    }
  }
}
    `;
export type MarkCommentAsQuestionMutationFn = ApolloReactCommon.MutationFunction<MarkCommentAsQuestionMutation, MarkCommentAsQuestionMutationVariables>;
export type MarkCommentAsQuestionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MarkCommentAsQuestionMutation, MarkCommentAsQuestionMutationVariables>, 'mutation'>;

    export const MarkCommentAsQuestionComponent = (props: MarkCommentAsQuestionComponentProps) => (
      <ApolloReactComponents.Mutation<MarkCommentAsQuestionMutation, MarkCommentAsQuestionMutationVariables> mutation={MarkCommentAsQuestionDocument} {...props} />
    );
    
export type MarkCommentAsQuestionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MarkCommentAsQuestionMutation, MarkCommentAsQuestionMutationVariables>
    } & TChildProps;
export function withMarkCommentAsQuestion<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MarkCommentAsQuestionMutation,
  MarkCommentAsQuestionMutationVariables,
  MarkCommentAsQuestionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MarkCommentAsQuestionMutation, MarkCommentAsQuestionMutationVariables, MarkCommentAsQuestionProps<TChildProps, TDataName>>(MarkCommentAsQuestionDocument, {
      alias: 'markCommentAsQuestion',
      ...operationOptions
    });
};

/**
 * __useMarkCommentAsQuestionMutation__
 *
 * To run a mutation, you first call `useMarkCommentAsQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommentAsQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCommentAsQuestionMutation, { data, loading, error }] = useMarkCommentAsQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isQuestion: // value for 'isQuestion'
 *   },
 * });
 */
export function useMarkCommentAsQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkCommentAsQuestionMutation, MarkCommentAsQuestionMutationVariables>) {
        return ApolloReactHooks.useMutation<MarkCommentAsQuestionMutation, MarkCommentAsQuestionMutationVariables>(MarkCommentAsQuestionDocument, baseOptions);
      }
export type MarkCommentAsQuestionMutationHookResult = ReturnType<typeof useMarkCommentAsQuestionMutation>;
export type MarkCommentAsQuestionMutationResult = ApolloReactCommon.MutationResult<MarkCommentAsQuestionMutation>;
export type MarkCommentAsQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkCommentAsQuestionMutation, MarkCommentAsQuestionMutationVariables>;
export const GetEventCommentsDocument = gql`
    query GetEventComments($eventId: uuid!) {
  event_comment(where: {event_id: {_eq: $eventId}}, order_by: {created_at: asc}) {
    id
    comment
    is_question
    public_account {
      id
      display_name
    }
  }
}
    `;
export type GetEventCommentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetEventCommentsQuery, GetEventCommentsQueryVariables>, 'query'> & ({ variables: GetEventCommentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetEventCommentsComponent = (props: GetEventCommentsComponentProps) => (
      <ApolloReactComponents.Query<GetEventCommentsQuery, GetEventCommentsQueryVariables> query={GetEventCommentsDocument} {...props} />
    );
    
export type GetEventCommentsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventCommentsQuery, GetEventCommentsQueryVariables>
    } & TChildProps;
export function withGetEventComments<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventCommentsQuery,
  GetEventCommentsQueryVariables,
  GetEventCommentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventCommentsQuery, GetEventCommentsQueryVariables, GetEventCommentsProps<TChildProps, TDataName>>(GetEventCommentsDocument, {
      alias: 'getEventComments',
      ...operationOptions
    });
};

/**
 * __useGetEventCommentsQuery__
 *
 * To run a query within a React component, call `useGetEventCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventCommentsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventCommentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventCommentsQuery, GetEventCommentsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventCommentsQuery, GetEventCommentsQueryVariables>(GetEventCommentsDocument, baseOptions);
      }
export function useGetEventCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventCommentsQuery, GetEventCommentsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventCommentsQuery, GetEventCommentsQueryVariables>(GetEventCommentsDocument, baseOptions);
        }
export type GetEventCommentsQueryHookResult = ReturnType<typeof useGetEventCommentsQuery>;
export type GetEventCommentsLazyQueryHookResult = ReturnType<typeof useGetEventCommentsLazyQuery>;
export type GetEventCommentsQueryResult = ApolloReactCommon.QueryResult<GetEventCommentsQuery, GetEventCommentsQueryVariables>;
export const InsertCommentDocument = gql`
    mutation InsertComment($comment: String!, $eventId: uuid!) {
  insert_event_comment_one(object: {comment: $comment, event_id: $eventId}) {
    id
    comment
    is_question
    public_account {
      id
      display_name
    }
  }
}
    `;
export type InsertCommentMutationFn = ApolloReactCommon.MutationFunction<InsertCommentMutation, InsertCommentMutationVariables>;
export type InsertCommentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertCommentMutation, InsertCommentMutationVariables>, 'mutation'>;

    export const InsertCommentComponent = (props: InsertCommentComponentProps) => (
      <ApolloReactComponents.Mutation<InsertCommentMutation, InsertCommentMutationVariables> mutation={InsertCommentDocument} {...props} />
    );
    
export type InsertCommentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertCommentMutation, InsertCommentMutationVariables>
    } & TChildProps;
export function withInsertComment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertCommentMutation,
  InsertCommentMutationVariables,
  InsertCommentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertCommentMutation, InsertCommentMutationVariables, InsertCommentProps<TChildProps, TDataName>>(InsertCommentDocument, {
      alias: 'insertComment',
      ...operationOptions
    });
};

/**
 * __useInsertCommentMutation__
 *
 * To run a mutation, you first call `useInsertCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCommentMutation, { data, loading, error }] = useInsertCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useInsertCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertCommentMutation, InsertCommentMutationVariables>) {
        return ApolloReactHooks.useMutation<InsertCommentMutation, InsertCommentMutationVariables>(InsertCommentDocument, baseOptions);
      }
export type InsertCommentMutationHookResult = ReturnType<typeof useInsertCommentMutation>;
export type InsertCommentMutationResult = ApolloReactCommon.MutationResult<InsertCommentMutation>;
export type InsertCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertCommentMutation, InsertCommentMutationVariables>;
export const ToggleEventCommentsDocument = gql`
    mutation ToggleEventComments($eventId: uuid!, $commentsEnabled: Boolean) {
  update_events_by_pk(
    pk_columns: {id: $eventId}
    _set: {enable_comments: $commentsEnabled}
  ) {
    id
    enable_comments
  }
}
    `;
export type ToggleEventCommentsMutationFn = ApolloReactCommon.MutationFunction<ToggleEventCommentsMutation, ToggleEventCommentsMutationVariables>;
export type ToggleEventCommentsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ToggleEventCommentsMutation, ToggleEventCommentsMutationVariables>, 'mutation'>;

    export const ToggleEventCommentsComponent = (props: ToggleEventCommentsComponentProps) => (
      <ApolloReactComponents.Mutation<ToggleEventCommentsMutation, ToggleEventCommentsMutationVariables> mutation={ToggleEventCommentsDocument} {...props} />
    );
    
export type ToggleEventCommentsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ToggleEventCommentsMutation, ToggleEventCommentsMutationVariables>
    } & TChildProps;
export function withToggleEventComments<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ToggleEventCommentsMutation,
  ToggleEventCommentsMutationVariables,
  ToggleEventCommentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ToggleEventCommentsMutation, ToggleEventCommentsMutationVariables, ToggleEventCommentsProps<TChildProps, TDataName>>(ToggleEventCommentsDocument, {
      alias: 'toggleEventComments',
      ...operationOptions
    });
};

/**
 * __useToggleEventCommentsMutation__
 *
 * To run a mutation, you first call `useToggleEventCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleEventCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleEventCommentsMutation, { data, loading, error }] = useToggleEventCommentsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      commentsEnabled: // value for 'commentsEnabled'
 *   },
 * });
 */
export function useToggleEventCommentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleEventCommentsMutation, ToggleEventCommentsMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleEventCommentsMutation, ToggleEventCommentsMutationVariables>(ToggleEventCommentsDocument, baseOptions);
      }
export type ToggleEventCommentsMutationHookResult = ReturnType<typeof useToggleEventCommentsMutation>;
export type ToggleEventCommentsMutationResult = ApolloReactCommon.MutationResult<ToggleEventCommentsMutation>;
export type ToggleEventCommentsMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleEventCommentsMutation, ToggleEventCommentsMutationVariables>;
export const SearchBooksForSelectorDocument = gql`
    query SearchBooksForSelector($search: String) {
  search_books(args: {search: $search}) {
    title
    isbn
    author
    price
  }
}
    `;
export type SearchBooksForSelectorComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchBooksForSelectorQuery, SearchBooksForSelectorQueryVariables>, 'query'>;

    export const SearchBooksForSelectorComponent = (props: SearchBooksForSelectorComponentProps) => (
      <ApolloReactComponents.Query<SearchBooksForSelectorQuery, SearchBooksForSelectorQueryVariables> query={SearchBooksForSelectorDocument} {...props} />
    );
    
export type SearchBooksForSelectorProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchBooksForSelectorQuery, SearchBooksForSelectorQueryVariables>
    } & TChildProps;
export function withSearchBooksForSelector<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchBooksForSelectorQuery,
  SearchBooksForSelectorQueryVariables,
  SearchBooksForSelectorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchBooksForSelectorQuery, SearchBooksForSelectorQueryVariables, SearchBooksForSelectorProps<TChildProps, TDataName>>(SearchBooksForSelectorDocument, {
      alias: 'searchBooksForSelector',
      ...operationOptions
    });
};

/**
 * __useSearchBooksForSelectorQuery__
 *
 * To run a query within a React component, call `useSearchBooksForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBooksForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBooksForSelectorQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchBooksForSelectorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchBooksForSelectorQuery, SearchBooksForSelectorQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchBooksForSelectorQuery, SearchBooksForSelectorQueryVariables>(SearchBooksForSelectorDocument, baseOptions);
      }
export function useSearchBooksForSelectorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchBooksForSelectorQuery, SearchBooksForSelectorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchBooksForSelectorQuery, SearchBooksForSelectorQueryVariables>(SearchBooksForSelectorDocument, baseOptions);
        }
export type SearchBooksForSelectorQueryHookResult = ReturnType<typeof useSearchBooksForSelectorQuery>;
export type SearchBooksForSelectorLazyQueryHookResult = ReturnType<typeof useSearchBooksForSelectorLazyQuery>;
export type SearchBooksForSelectorQueryResult = ApolloReactCommon.QueryResult<SearchBooksForSelectorQuery, SearchBooksForSelectorQueryVariables>;
export const GetAuthorsForSelectorDocument = gql`
    query GetAuthorsForSelector {
  booksellers {
    id
    name
  }
}
    `;
export type GetAuthorsForSelectorComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAuthorsForSelectorQuery, GetAuthorsForSelectorQueryVariables>, 'query'>;

    export const GetAuthorsForSelectorComponent = (props: GetAuthorsForSelectorComponentProps) => (
      <ApolloReactComponents.Query<GetAuthorsForSelectorQuery, GetAuthorsForSelectorQueryVariables> query={GetAuthorsForSelectorDocument} {...props} />
    );
    
export type GetAuthorsForSelectorProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAuthorsForSelectorQuery, GetAuthorsForSelectorQueryVariables>
    } & TChildProps;
export function withGetAuthorsForSelector<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAuthorsForSelectorQuery,
  GetAuthorsForSelectorQueryVariables,
  GetAuthorsForSelectorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAuthorsForSelectorQuery, GetAuthorsForSelectorQueryVariables, GetAuthorsForSelectorProps<TChildProps, TDataName>>(GetAuthorsForSelectorDocument, {
      alias: 'getAuthorsForSelector',
      ...operationOptions
    });
};

/**
 * __useGetAuthorsForSelectorQuery__
 *
 * To run a query within a React component, call `useGetAuthorsForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorsForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorsForSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthorsForSelectorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAuthorsForSelectorQuery, GetAuthorsForSelectorQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAuthorsForSelectorQuery, GetAuthorsForSelectorQueryVariables>(GetAuthorsForSelectorDocument, baseOptions);
      }
export function useGetAuthorsForSelectorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAuthorsForSelectorQuery, GetAuthorsForSelectorQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAuthorsForSelectorQuery, GetAuthorsForSelectorQueryVariables>(GetAuthorsForSelectorDocument, baseOptions);
        }
export type GetAuthorsForSelectorQueryHookResult = ReturnType<typeof useGetAuthorsForSelectorQuery>;
export type GetAuthorsForSelectorLazyQueryHookResult = ReturnType<typeof useGetAuthorsForSelectorLazyQuery>;
export type GetAuthorsForSelectorQueryResult = ApolloReactCommon.QueryResult<GetAuthorsForSelectorQuery, GetAuthorsForSelectorQueryVariables>;
export const SearchCategoriesDocument = gql`
    query SearchCategories($search: String) {
  categories(where: {name: {_ilike: $search}}) {
    name
  }
}
    `;
export type SearchCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchCategoriesQuery, SearchCategoriesQueryVariables>, 'query'>;

    export const SearchCategoriesComponent = (props: SearchCategoriesComponentProps) => (
      <ApolloReactComponents.Query<SearchCategoriesQuery, SearchCategoriesQueryVariables> query={SearchCategoriesDocument} {...props} />
    );
    
export type SearchCategoriesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchCategoriesQuery, SearchCategoriesQueryVariables>
    } & TChildProps;
export function withSearchCategories<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchCategoriesQuery,
  SearchCategoriesQueryVariables,
  SearchCategoriesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchCategoriesQuery, SearchCategoriesQueryVariables, SearchCategoriesProps<TChildProps, TDataName>>(SearchCategoriesDocument, {
      alias: 'searchCategories',
      ...operationOptions
    });
};

/**
 * __useSearchCategoriesQuery__
 *
 * To run a query within a React component, call `useSearchCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCategoriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchCategoriesQuery, SearchCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchCategoriesQuery, SearchCategoriesQueryVariables>(SearchCategoriesDocument, baseOptions);
      }
export function useSearchCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCategoriesQuery, SearchCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchCategoriesQuery, SearchCategoriesQueryVariables>(SearchCategoriesDocument, baseOptions);
        }
export type SearchCategoriesQueryHookResult = ReturnType<typeof useSearchCategoriesQuery>;
export type SearchCategoriesLazyQueryHookResult = ReturnType<typeof useSearchCategoriesLazyQuery>;
export type SearchCategoriesQueryResult = ApolloReactCommon.QueryResult<SearchCategoriesQuery, SearchCategoriesQueryVariables>;
export const GetPossibleShippingDestinationsDocument = gql`
    query GetPossibleShippingDestinations {
  regions(
    where: {_or: [{shipping_options: {deleted_at: {_is_null: true}}}, {countries: {shipping_options: {deleted_at: {_is_null: true}}}}]}
  ) {
    __typename
    code
    name
    countries(
      where: {_or: [{region_data: {shipping_options: {deleted_at: {_is_null: true}}}}, {shipping_options: {deleted_at: {_is_null: true}}}]}
    ) {
      __typename
      code
      name
    }
  }
}
    `;
export type GetPossibleShippingDestinationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPossibleShippingDestinationsQuery, GetPossibleShippingDestinationsQueryVariables>, 'query'>;

    export const GetPossibleShippingDestinationsComponent = (props: GetPossibleShippingDestinationsComponentProps) => (
      <ApolloReactComponents.Query<GetPossibleShippingDestinationsQuery, GetPossibleShippingDestinationsQueryVariables> query={GetPossibleShippingDestinationsDocument} {...props} />
    );
    
export type GetPossibleShippingDestinationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPossibleShippingDestinationsQuery, GetPossibleShippingDestinationsQueryVariables>
    } & TChildProps;
export function withGetPossibleShippingDestinations<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPossibleShippingDestinationsQuery,
  GetPossibleShippingDestinationsQueryVariables,
  GetPossibleShippingDestinationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPossibleShippingDestinationsQuery, GetPossibleShippingDestinationsQueryVariables, GetPossibleShippingDestinationsProps<TChildProps, TDataName>>(GetPossibleShippingDestinationsDocument, {
      alias: 'getPossibleShippingDestinations',
      ...operationOptions
    });
};

/**
 * __useGetPossibleShippingDestinationsQuery__
 *
 * To run a query within a React component, call `useGetPossibleShippingDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPossibleShippingDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPossibleShippingDestinationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPossibleShippingDestinationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPossibleShippingDestinationsQuery, GetPossibleShippingDestinationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPossibleShippingDestinationsQuery, GetPossibleShippingDestinationsQueryVariables>(GetPossibleShippingDestinationsDocument, baseOptions);
      }
export function useGetPossibleShippingDestinationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPossibleShippingDestinationsQuery, GetPossibleShippingDestinationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPossibleShippingDestinationsQuery, GetPossibleShippingDestinationsQueryVariables>(GetPossibleShippingDestinationsDocument, baseOptions);
        }
export type GetPossibleShippingDestinationsQueryHookResult = ReturnType<typeof useGetPossibleShippingDestinationsQuery>;
export type GetPossibleShippingDestinationsLazyQueryHookResult = ReturnType<typeof useGetPossibleShippingDestinationsLazyQuery>;
export type GetPossibleShippingDestinationsQueryResult = ApolloReactCommon.QueryResult<GetPossibleShippingDestinationsQuery, GetPossibleShippingDestinationsQueryVariables>;
export const SearchEventsDocument = gql`
    query SearchEvents($search: String) {
  events(where: {_and: [{title: {_ilike: $search}}]}) {
    slug
    title
    id
    start_time
  }
}
    `;
export type SearchEventsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchEventsQuery, SearchEventsQueryVariables>, 'query'>;

    export const SearchEventsComponent = (props: SearchEventsComponentProps) => (
      <ApolloReactComponents.Query<SearchEventsQuery, SearchEventsQueryVariables> query={SearchEventsDocument} {...props} />
    );
    
export type SearchEventsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchEventsQuery, SearchEventsQueryVariables>
    } & TChildProps;
export function withSearchEvents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchEventsQuery,
  SearchEventsQueryVariables,
  SearchEventsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchEventsQuery, SearchEventsQueryVariables, SearchEventsProps<TChildProps, TDataName>>(SearchEventsDocument, {
      alias: 'searchEvents',
      ...operationOptions
    });
};

/**
 * __useSearchEventsQuery__
 *
 * To run a query within a React component, call `useSearchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEventsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchEventsQuery, SearchEventsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchEventsQuery, SearchEventsQueryVariables>(SearchEventsDocument, baseOptions);
      }
export function useSearchEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchEventsQuery, SearchEventsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchEventsQuery, SearchEventsQueryVariables>(SearchEventsDocument, baseOptions);
        }
export type SearchEventsQueryHookResult = ReturnType<typeof useSearchEventsQuery>;
export type SearchEventsLazyQueryHookResult = ReturnType<typeof useSearchEventsLazyQuery>;
export type SearchEventsQueryResult = ApolloReactCommon.QueryResult<SearchEventsQuery, SearchEventsQueryVariables>;
export const SearchFestivalsDocument = gql`
    query SearchFestivals($search: String) {
  events(where: {_and: [{title: {_ilike: $search}}, {is_festival: {_eq: true}}]}) {
    title
    id
    start_time
  }
}
    `;
export type SearchFestivalsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchFestivalsQuery, SearchFestivalsQueryVariables>, 'query'>;

    export const SearchFestivalsComponent = (props: SearchFestivalsComponentProps) => (
      <ApolloReactComponents.Query<SearchFestivalsQuery, SearchFestivalsQueryVariables> query={SearchFestivalsDocument} {...props} />
    );
    
export type SearchFestivalsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchFestivalsQuery, SearchFestivalsQueryVariables>
    } & TChildProps;
export function withSearchFestivals<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchFestivalsQuery,
  SearchFestivalsQueryVariables,
  SearchFestivalsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchFestivalsQuery, SearchFestivalsQueryVariables, SearchFestivalsProps<TChildProps, TDataName>>(SearchFestivalsDocument, {
      alias: 'searchFestivals',
      ...operationOptions
    });
};

/**
 * __useSearchFestivalsQuery__
 *
 * To run a query within a React component, call `useSearchFestivalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFestivalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFestivalsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchFestivalsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchFestivalsQuery, SearchFestivalsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchFestivalsQuery, SearchFestivalsQueryVariables>(SearchFestivalsDocument, baseOptions);
      }
export function useSearchFestivalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchFestivalsQuery, SearchFestivalsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchFestivalsQuery, SearchFestivalsQueryVariables>(SearchFestivalsDocument, baseOptions);
        }
export type SearchFestivalsQueryHookResult = ReturnType<typeof useSearchFestivalsQuery>;
export type SearchFestivalsLazyQueryHookResult = ReturnType<typeof useSearchFestivalsLazyQuery>;
export type SearchFestivalsQueryResult = ApolloReactCommon.QueryResult<SearchFestivalsQuery, SearchFestivalsQueryVariables>;
export const SearchPostsDocument = gql`
    query SearchPosts($search: String) {
  posts(where: {_and: [{title: {_ilike: $search}}]}) {
    slug
    title
    id
  }
}
    `;
export type SearchPostsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchPostsQuery, SearchPostsQueryVariables>, 'query'>;

    export const SearchPostsComponent = (props: SearchPostsComponentProps) => (
      <ApolloReactComponents.Query<SearchPostsQuery, SearchPostsQueryVariables> query={SearchPostsDocument} {...props} />
    );
    
export type SearchPostsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchPostsQuery, SearchPostsQueryVariables>
    } & TChildProps;
export function withSearchPosts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchPostsQuery,
  SearchPostsQueryVariables,
  SearchPostsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchPostsQuery, SearchPostsQueryVariables, SearchPostsProps<TChildProps, TDataName>>(SearchPostsDocument, {
      alias: 'searchPosts',
      ...operationOptions
    });
};

/**
 * __useSearchPostsQuery__
 *
 * To run a query within a React component, call `useSearchPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPostsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchPostsQuery, SearchPostsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchPostsQuery, SearchPostsQueryVariables>(SearchPostsDocument, baseOptions);
      }
export function useSearchPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchPostsQuery, SearchPostsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchPostsQuery, SearchPostsQueryVariables>(SearchPostsDocument, baseOptions);
        }
export type SearchPostsQueryHookResult = ReturnType<typeof useSearchPostsQuery>;
export type SearchPostsLazyQueryHookResult = ReturnType<typeof useSearchPostsLazyQuery>;
export type SearchPostsQueryResult = ApolloReactCommon.QueryResult<SearchPostsQuery, SearchPostsQueryVariables>;
export const SearchProductsDocument = gql`
    query SearchProducts($search: String) {
  products(where: {_and: [{title: {_ilike: $search}}, {is_sub: {_eq: false}}]}) {
    id
    title
    price
  }
}
    `;
export type SearchProductsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchProductsQuery, SearchProductsQueryVariables>, 'query'>;

    export const SearchProductsComponent = (props: SearchProductsComponentProps) => (
      <ApolloReactComponents.Query<SearchProductsQuery, SearchProductsQueryVariables> query={SearchProductsDocument} {...props} />
    );
    
export type SearchProductsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchProductsQuery, SearchProductsQueryVariables>
    } & TChildProps;
export function withSearchProducts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchProductsQuery,
  SearchProductsQueryVariables,
  SearchProductsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchProductsQuery, SearchProductsQueryVariables, SearchProductsProps<TChildProps, TDataName>>(SearchProductsDocument, {
      alias: 'searchProducts',
      ...operationOptions
    });
};

/**
 * __useSearchProductsQuery__
 *
 * To run a query within a React component, call `useSearchProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProductsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchProductsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchProductsQuery, SearchProductsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchProductsQuery, SearchProductsQueryVariables>(SearchProductsDocument, baseOptions);
      }
export function useSearchProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchProductsQuery, SearchProductsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchProductsQuery, SearchProductsQueryVariables>(SearchProductsDocument, baseOptions);
        }
export type SearchProductsQueryHookResult = ReturnType<typeof useSearchProductsQuery>;
export type SearchProductsLazyQueryHookResult = ReturnType<typeof useSearchProductsLazyQuery>;
export type SearchProductsQueryResult = ApolloReactCommon.QueryResult<SearchProductsQuery, SearchProductsQueryVariables>;
export const GetShippingOptionsForCountryDocument = gql`
    query GetShippingOptionsForCountry($country: String!, $shippableItems: Int!) {
  shipping_options(
    order_by: {price: asc}
    where: {_and: [{_or: [{country: {_eq: $country}}, {regionByRegion: {countries: {code: {_eq: $country}}}}]}, {from: {_lte: $shippableItems}}, {_or: [{to: {_gte: $shippableItems}}, {to: {_is_null: true}}]}]}
  ) {
    id
    name
    description
    region
    country
    price
  }
}
    `;
export type GetShippingOptionsForCountryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShippingOptionsForCountryQuery, GetShippingOptionsForCountryQueryVariables>, 'query'> & ({ variables: GetShippingOptionsForCountryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetShippingOptionsForCountryComponent = (props: GetShippingOptionsForCountryComponentProps) => (
      <ApolloReactComponents.Query<GetShippingOptionsForCountryQuery, GetShippingOptionsForCountryQueryVariables> query={GetShippingOptionsForCountryDocument} {...props} />
    );
    
export type GetShippingOptionsForCountryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetShippingOptionsForCountryQuery, GetShippingOptionsForCountryQueryVariables>
    } & TChildProps;
export function withGetShippingOptionsForCountry<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetShippingOptionsForCountryQuery,
  GetShippingOptionsForCountryQueryVariables,
  GetShippingOptionsForCountryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetShippingOptionsForCountryQuery, GetShippingOptionsForCountryQueryVariables, GetShippingOptionsForCountryProps<TChildProps, TDataName>>(GetShippingOptionsForCountryDocument, {
      alias: 'getShippingOptionsForCountry',
      ...operationOptions
    });
};

/**
 * __useGetShippingOptionsForCountryQuery__
 *
 * To run a query within a React component, call `useGetShippingOptionsForCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingOptionsForCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingOptionsForCountryQuery({
 *   variables: {
 *      country: // value for 'country'
 *      shippableItems: // value for 'shippableItems'
 *   },
 * });
 */
export function useGetShippingOptionsForCountryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetShippingOptionsForCountryQuery, GetShippingOptionsForCountryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetShippingOptionsForCountryQuery, GetShippingOptionsForCountryQueryVariables>(GetShippingOptionsForCountryDocument, baseOptions);
      }
export function useGetShippingOptionsForCountryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShippingOptionsForCountryQuery, GetShippingOptionsForCountryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetShippingOptionsForCountryQuery, GetShippingOptionsForCountryQueryVariables>(GetShippingOptionsForCountryDocument, baseOptions);
        }
export type GetShippingOptionsForCountryQueryHookResult = ReturnType<typeof useGetShippingOptionsForCountryQuery>;
export type GetShippingOptionsForCountryLazyQueryHookResult = ReturnType<typeof useGetShippingOptionsForCountryLazyQuery>;
export type GetShippingOptionsForCountryQueryResult = ApolloReactCommon.QueryResult<GetShippingOptionsForCountryQuery, GetShippingOptionsForCountryQueryVariables>;
export const SearchTagsDocument = gql`
    query SearchTags($search: String) {
  tags(where: {text: {_ilike: $search}}) {
    id
    text
  }
}
    `;
export type SearchTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchTagsQuery, SearchTagsQueryVariables>, 'query'>;

    export const SearchTagsComponent = (props: SearchTagsComponentProps) => (
      <ApolloReactComponents.Query<SearchTagsQuery, SearchTagsQueryVariables> query={SearchTagsDocument} {...props} />
    );
    
export type SearchTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchTagsQuery, SearchTagsQueryVariables>
    } & TChildProps;
export function withSearchTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchTagsQuery,
  SearchTagsQueryVariables,
  SearchTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchTagsQuery, SearchTagsQueryVariables, SearchTagsProps<TChildProps, TDataName>>(SearchTagsDocument, {
      alias: 'searchTags',
      ...operationOptions
    });
};

/**
 * __useSearchTagsQuery__
 *
 * To run a query within a React component, call `useSearchTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTagsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, baseOptions);
      }
export function useSearchTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, baseOptions);
        }
export type SearchTagsQueryHookResult = ReturnType<typeof useSearchTagsQuery>;
export type SearchTagsLazyQueryHookResult = ReturnType<typeof useSearchTagsLazyQuery>;
export type SearchTagsQueryResult = ApolloReactCommon.QueryResult<SearchTagsQuery, SearchTagsQueryVariables>;
export const AddTagDocument = gql`
    mutation AddTag($text: String) {
  insert_tags_one(object: {text: $text}) {
    text
    id
  }
}
    `;
export type AddTagMutationFn = ApolloReactCommon.MutationFunction<AddTagMutation, AddTagMutationVariables>;
export type AddTagComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddTagMutation, AddTagMutationVariables>, 'mutation'>;

    export const AddTagComponent = (props: AddTagComponentProps) => (
      <ApolloReactComponents.Mutation<AddTagMutation, AddTagMutationVariables> mutation={AddTagDocument} {...props} />
    );
    
export type AddTagProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddTagMutation, AddTagMutationVariables>
    } & TChildProps;
export function withAddTag<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddTagMutation,
  AddTagMutationVariables,
  AddTagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddTagMutation, AddTagMutationVariables, AddTagProps<TChildProps, TDataName>>(AddTagDocument, {
      alias: 'addTag',
      ...operationOptions
    });
};

/**
 * __useAddTagMutation__
 *
 * To run a mutation, you first call `useAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagMutation, { data, loading, error }] = useAddTagMutation({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAddTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTagMutation, AddTagMutationVariables>) {
        return ApolloReactHooks.useMutation<AddTagMutation, AddTagMutationVariables>(AddTagDocument, baseOptions);
      }
export type AddTagMutationHookResult = ReturnType<typeof useAddTagMutation>;
export type AddTagMutationResult = ApolloReactCommon.MutationResult<AddTagMutation>;
export type AddTagMutationOptions = ApolloReactCommon.BaseMutationOptions<AddTagMutation, AddTagMutationVariables>;
export const ToggleActivateSubscriptionDocument = gql`
    mutation ToggleActivateSubscription($id: uuid!, $date: date, $active: Boolean) {
  update_subscription_object_by_pk(
    pk_columns: {id: $id}
    _set: {is_active: $active, date_activated: $date}
  ) {
    id
  }
}
    `;
export type ToggleActivateSubscriptionMutationFn = ApolloReactCommon.MutationFunction<ToggleActivateSubscriptionMutation, ToggleActivateSubscriptionMutationVariables>;
export type ToggleActivateSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ToggleActivateSubscriptionMutation, ToggleActivateSubscriptionMutationVariables>, 'mutation'>;

    export const ToggleActivateSubscriptionComponent = (props: ToggleActivateSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<ToggleActivateSubscriptionMutation, ToggleActivateSubscriptionMutationVariables> mutation={ToggleActivateSubscriptionDocument} {...props} />
    );
    
export type ToggleActivateSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ToggleActivateSubscriptionMutation, ToggleActivateSubscriptionMutationVariables>
    } & TChildProps;
export function withToggleActivateSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ToggleActivateSubscriptionMutation,
  ToggleActivateSubscriptionMutationVariables,
  ToggleActivateSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ToggleActivateSubscriptionMutation, ToggleActivateSubscriptionMutationVariables, ToggleActivateSubscriptionProps<TChildProps, TDataName>>(ToggleActivateSubscriptionDocument, {
      alias: 'toggleActivateSubscription',
      ...operationOptions
    });
};

/**
 * __useToggleActivateSubscriptionMutation__
 *
 * To run a mutation, you first call `useToggleActivateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleActivateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleActivateSubscriptionMutation, { data, loading, error }] = useToggleActivateSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useToggleActivateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleActivateSubscriptionMutation, ToggleActivateSubscriptionMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleActivateSubscriptionMutation, ToggleActivateSubscriptionMutationVariables>(ToggleActivateSubscriptionDocument, baseOptions);
      }
export type ToggleActivateSubscriptionMutationHookResult = ReturnType<typeof useToggleActivateSubscriptionMutation>;
export type ToggleActivateSubscriptionMutationResult = ApolloReactCommon.MutationResult<ToggleActivateSubscriptionMutation>;
export type ToggleActivateSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleActivateSubscriptionMutation, ToggleActivateSubscriptionMutationVariables>;
export const CreateAddressForSubDocument = gql`
    mutation CreateAddressForSub($address: addresses_insert_input!) {
  insert_addresses_one(object: $address) {
    id
    name
    line_1
    line_2
    line_3
    region
    city
    code
    country_code
    phone_number
    contact_email
  }
}
    `;
export type CreateAddressForSubMutationFn = ApolloReactCommon.MutationFunction<CreateAddressForSubMutation, CreateAddressForSubMutationVariables>;
export type CreateAddressForSubComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAddressForSubMutation, CreateAddressForSubMutationVariables>, 'mutation'>;

    export const CreateAddressForSubComponent = (props: CreateAddressForSubComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAddressForSubMutation, CreateAddressForSubMutationVariables> mutation={CreateAddressForSubDocument} {...props} />
    );
    
export type CreateAddressForSubProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateAddressForSubMutation, CreateAddressForSubMutationVariables>
    } & TChildProps;
export function withCreateAddressForSub<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateAddressForSubMutation,
  CreateAddressForSubMutationVariables,
  CreateAddressForSubProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateAddressForSubMutation, CreateAddressForSubMutationVariables, CreateAddressForSubProps<TChildProps, TDataName>>(CreateAddressForSubDocument, {
      alias: 'createAddressForSub',
      ...operationOptions
    });
};

/**
 * __useCreateAddressForSubMutation__
 *
 * To run a mutation, you first call `useCreateAddressForSubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressForSubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressForSubMutation, { data, loading, error }] = useCreateAddressForSubMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useCreateAddressForSubMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAddressForSubMutation, CreateAddressForSubMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAddressForSubMutation, CreateAddressForSubMutationVariables>(CreateAddressForSubDocument, baseOptions);
      }
export type CreateAddressForSubMutationHookResult = ReturnType<typeof useCreateAddressForSubMutation>;
export type CreateAddressForSubMutationResult = ApolloReactCommon.MutationResult<CreateAddressForSubMutation>;
export type CreateAddressForSubMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAddressForSubMutation, CreateAddressForSubMutationVariables>;
export const GetAddressForSubManagementDocument = gql`
    query GetAddressForSubManagement($id: uuid!) {
  subscription_object_by_pk(id: $id) {
    address {
      id
      name
      line_1
      line_2
      line_3
      region
      city
      code
      country_code
      phone_number
      contact_email
    }
  }
}
    `;
export type GetAddressForSubManagementComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAddressForSubManagementQuery, GetAddressForSubManagementQueryVariables>, 'query'> & ({ variables: GetAddressForSubManagementQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAddressForSubManagementComponent = (props: GetAddressForSubManagementComponentProps) => (
      <ApolloReactComponents.Query<GetAddressForSubManagementQuery, GetAddressForSubManagementQueryVariables> query={GetAddressForSubManagementDocument} {...props} />
    );
    
export type GetAddressForSubManagementProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAddressForSubManagementQuery, GetAddressForSubManagementQueryVariables>
    } & TChildProps;
export function withGetAddressForSubManagement<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAddressForSubManagementQuery,
  GetAddressForSubManagementQueryVariables,
  GetAddressForSubManagementProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAddressForSubManagementQuery, GetAddressForSubManagementQueryVariables, GetAddressForSubManagementProps<TChildProps, TDataName>>(GetAddressForSubManagementDocument, {
      alias: 'getAddressForSubManagement',
      ...operationOptions
    });
};

/**
 * __useGetAddressForSubManagementQuery__
 *
 * To run a query within a React component, call `useGetAddressForSubManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressForSubManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressForSubManagementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAddressForSubManagementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAddressForSubManagementQuery, GetAddressForSubManagementQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAddressForSubManagementQuery, GetAddressForSubManagementQueryVariables>(GetAddressForSubManagementDocument, baseOptions);
      }
export function useGetAddressForSubManagementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAddressForSubManagementQuery, GetAddressForSubManagementQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAddressForSubManagementQuery, GetAddressForSubManagementQueryVariables>(GetAddressForSubManagementDocument, baseOptions);
        }
export type GetAddressForSubManagementQueryHookResult = ReturnType<typeof useGetAddressForSubManagementQuery>;
export type GetAddressForSubManagementLazyQueryHookResult = ReturnType<typeof useGetAddressForSubManagementLazyQuery>;
export type GetAddressForSubManagementQueryResult = ApolloReactCommon.QueryResult<GetAddressForSubManagementQuery, GetAddressForSubManagementQueryVariables>;
export const GetSubForManagementPageDocument = gql`
    query GetSubForManagementPage($id: String!, $password: String!) {
  subscription_object(
    where: {_and: [{short_id: {_eq: $id}}, {password: {_eq: $password}}]}
  ) {
    id
    is_active
    recipient
    remaining_credits
    date_activated
    message
    stripe_sub_id
    dispatches {
      created_at
    }
    subscription {
      id
      title
      description
      price
    }
  }
  unstructured_data_by_pk(title: "sub_how_to") {
    data
  }
}
    `;
export type GetSubForManagementPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubForManagementPageQuery, GetSubForManagementPageQueryVariables>, 'query'> & ({ variables: GetSubForManagementPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubForManagementPageComponent = (props: GetSubForManagementPageComponentProps) => (
      <ApolloReactComponents.Query<GetSubForManagementPageQuery, GetSubForManagementPageQueryVariables> query={GetSubForManagementPageDocument} {...props} />
    );
    
export type GetSubForManagementPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubForManagementPageQuery, GetSubForManagementPageQueryVariables>
    } & TChildProps;
export function withGetSubForManagementPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubForManagementPageQuery,
  GetSubForManagementPageQueryVariables,
  GetSubForManagementPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubForManagementPageQuery, GetSubForManagementPageQueryVariables, GetSubForManagementPageProps<TChildProps, TDataName>>(GetSubForManagementPageDocument, {
      alias: 'getSubForManagementPage',
      ...operationOptions
    });
};

/**
 * __useGetSubForManagementPageQuery__
 *
 * To run a query within a React component, call `useGetSubForManagementPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubForManagementPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubForManagementPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetSubForManagementPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubForManagementPageQuery, GetSubForManagementPageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubForManagementPageQuery, GetSubForManagementPageQueryVariables>(GetSubForManagementPageDocument, baseOptions);
      }
export function useGetSubForManagementPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubForManagementPageQuery, GetSubForManagementPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubForManagementPageQuery, GetSubForManagementPageQueryVariables>(GetSubForManagementPageDocument, baseOptions);
        }
export type GetSubForManagementPageQueryHookResult = ReturnType<typeof useGetSubForManagementPageQuery>;
export type GetSubForManagementPageLazyQueryHookResult = ReturnType<typeof useGetSubForManagementPageLazyQuery>;
export type GetSubForManagementPageQueryResult = ApolloReactCommon.QueryResult<GetSubForManagementPageQuery, GetSubForManagementPageQueryVariables>;
export const InsertAddressForSubManagementDocument = gql`
    mutation InsertAddressForSubManagement($id: uuid!, $address_id: uuid!) {
  update_subscription_object_by_pk(
    pk_columns: {id: $id}
    _set: {address_id: $address_id}
  ) {
    id
    address_id
  }
}
    `;
export type InsertAddressForSubManagementMutationFn = ApolloReactCommon.MutationFunction<InsertAddressForSubManagementMutation, InsertAddressForSubManagementMutationVariables>;
export type InsertAddressForSubManagementComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertAddressForSubManagementMutation, InsertAddressForSubManagementMutationVariables>, 'mutation'>;

    export const InsertAddressForSubManagementComponent = (props: InsertAddressForSubManagementComponentProps) => (
      <ApolloReactComponents.Mutation<InsertAddressForSubManagementMutation, InsertAddressForSubManagementMutationVariables> mutation={InsertAddressForSubManagementDocument} {...props} />
    );
    
export type InsertAddressForSubManagementProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertAddressForSubManagementMutation, InsertAddressForSubManagementMutationVariables>
    } & TChildProps;
export function withInsertAddressForSubManagement<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertAddressForSubManagementMutation,
  InsertAddressForSubManagementMutationVariables,
  InsertAddressForSubManagementProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertAddressForSubManagementMutation, InsertAddressForSubManagementMutationVariables, InsertAddressForSubManagementProps<TChildProps, TDataName>>(InsertAddressForSubManagementDocument, {
      alias: 'insertAddressForSubManagement',
      ...operationOptions
    });
};

/**
 * __useInsertAddressForSubManagementMutation__
 *
 * To run a mutation, you first call `useInsertAddressForSubManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAddressForSubManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAddressForSubManagementMutation, { data, loading, error }] = useInsertAddressForSubManagementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address_id: // value for 'address_id'
 *   },
 * });
 */
export function useInsertAddressForSubManagementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertAddressForSubManagementMutation, InsertAddressForSubManagementMutationVariables>) {
        return ApolloReactHooks.useMutation<InsertAddressForSubManagementMutation, InsertAddressForSubManagementMutationVariables>(InsertAddressForSubManagementDocument, baseOptions);
      }
export type InsertAddressForSubManagementMutationHookResult = ReturnType<typeof useInsertAddressForSubManagementMutation>;
export type InsertAddressForSubManagementMutationResult = ApolloReactCommon.MutationResult<InsertAddressForSubManagementMutation>;
export type InsertAddressForSubManagementMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertAddressForSubManagementMutation, InsertAddressForSubManagementMutationVariables>;
export const UpdateAddressForSubManagementDocument = gql`
    mutation UpdateAddressForSubManagement($address_id: uuid!, $addressObject: addresses_set_input) {
  update_addresses_by_pk(pk_columns: {id: $address_id}, _set: $addressObject) {
    id
    name
    line_1
    line_2
    line_3
    region
    city
    code
    country_code
    phone_number
    contact_email
  }
}
    `;
export type UpdateAddressForSubManagementMutationFn = ApolloReactCommon.MutationFunction<UpdateAddressForSubManagementMutation, UpdateAddressForSubManagementMutationVariables>;
export type UpdateAddressForSubManagementComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAddressForSubManagementMutation, UpdateAddressForSubManagementMutationVariables>, 'mutation'>;

    export const UpdateAddressForSubManagementComponent = (props: UpdateAddressForSubManagementComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAddressForSubManagementMutation, UpdateAddressForSubManagementMutationVariables> mutation={UpdateAddressForSubManagementDocument} {...props} />
    );
    
export type UpdateAddressForSubManagementProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateAddressForSubManagementMutation, UpdateAddressForSubManagementMutationVariables>
    } & TChildProps;
export function withUpdateAddressForSubManagement<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAddressForSubManagementMutation,
  UpdateAddressForSubManagementMutationVariables,
  UpdateAddressForSubManagementProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAddressForSubManagementMutation, UpdateAddressForSubManagementMutationVariables, UpdateAddressForSubManagementProps<TChildProps, TDataName>>(UpdateAddressForSubManagementDocument, {
      alias: 'updateAddressForSubManagement',
      ...operationOptions
    });
};

/**
 * __useUpdateAddressForSubManagementMutation__
 *
 * To run a mutation, you first call `useUpdateAddressForSubManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressForSubManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressForSubManagementMutation, { data, loading, error }] = useUpdateAddressForSubManagementMutation({
 *   variables: {
 *      address_id: // value for 'address_id'
 *      addressObject: // value for 'addressObject'
 *   },
 * });
 */
export function useUpdateAddressForSubManagementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAddressForSubManagementMutation, UpdateAddressForSubManagementMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAddressForSubManagementMutation, UpdateAddressForSubManagementMutationVariables>(UpdateAddressForSubManagementDocument, baseOptions);
      }
export type UpdateAddressForSubManagementMutationHookResult = ReturnType<typeof useUpdateAddressForSubManagementMutation>;
export type UpdateAddressForSubManagementMutationResult = ApolloReactCommon.MutationResult<UpdateAddressForSubManagementMutation>;
export type UpdateAddressForSubManagementMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAddressForSubManagementMutation, UpdateAddressForSubManagementMutationVariables>;
export const GetAllProductsForShopDocument = gql`
    query GetAllProductsForShop {
  products(order_by: {created_at: asc}, where: {is_deleted: {_eq: false}}) {
    ...ProductCardData
  }
}
    ${ProductCardDataFragmentDoc}`;
export type GetAllProductsForShopComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllProductsForShopQuery, GetAllProductsForShopQueryVariables>, 'query'>;

    export const GetAllProductsForShopComponent = (props: GetAllProductsForShopComponentProps) => (
      <ApolloReactComponents.Query<GetAllProductsForShopQuery, GetAllProductsForShopQueryVariables> query={GetAllProductsForShopDocument} {...props} />
    );
    
export type GetAllProductsForShopProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllProductsForShopQuery, GetAllProductsForShopQueryVariables>
    } & TChildProps;
export function withGetAllProductsForShop<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllProductsForShopQuery,
  GetAllProductsForShopQueryVariables,
  GetAllProductsForShopProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllProductsForShopQuery, GetAllProductsForShopQueryVariables, GetAllProductsForShopProps<TChildProps, TDataName>>(GetAllProductsForShopDocument, {
      alias: 'getAllProductsForShop',
      ...operationOptions
    });
};

/**
 * __useGetAllProductsForShopQuery__
 *
 * To run a query within a React component, call `useGetAllProductsForShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsForShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsForShopQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProductsForShopQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllProductsForShopQuery, GetAllProductsForShopQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllProductsForShopQuery, GetAllProductsForShopQueryVariables>(GetAllProductsForShopDocument, baseOptions);
      }
export function useGetAllProductsForShopLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllProductsForShopQuery, GetAllProductsForShopQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllProductsForShopQuery, GetAllProductsForShopQueryVariables>(GetAllProductsForShopDocument, baseOptions);
        }
export type GetAllProductsForShopQueryHookResult = ReturnType<typeof useGetAllProductsForShopQuery>;
export type GetAllProductsForShopLazyQueryHookResult = ReturnType<typeof useGetAllProductsForShopLazyQuery>;
export type GetAllProductsForShopQueryResult = ApolloReactCommon.QueryResult<GetAllProductsForShopQuery, GetAllProductsForShopQueryVariables>;
export const GetAllSubsForShopDocument = gql`
    query GetAllSubsForShop {
  subscriptions(where: {is_active: {_eq: true}}, order_by: {title: desc}) {
    ...SubCardData
  }
}
    ${SubCardDataFragmentDoc}`;
export type GetAllSubsForShopComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllSubsForShopQuery, GetAllSubsForShopQueryVariables>, 'query'>;

    export const GetAllSubsForShopComponent = (props: GetAllSubsForShopComponentProps) => (
      <ApolloReactComponents.Query<GetAllSubsForShopQuery, GetAllSubsForShopQueryVariables> query={GetAllSubsForShopDocument} {...props} />
    );
    
export type GetAllSubsForShopProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllSubsForShopQuery, GetAllSubsForShopQueryVariables>
    } & TChildProps;
export function withGetAllSubsForShop<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllSubsForShopQuery,
  GetAllSubsForShopQueryVariables,
  GetAllSubsForShopProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllSubsForShopQuery, GetAllSubsForShopQueryVariables, GetAllSubsForShopProps<TChildProps, TDataName>>(GetAllSubsForShopDocument, {
      alias: 'getAllSubsForShop',
      ...operationOptions
    });
};

/**
 * __useGetAllSubsForShopQuery__
 *
 * To run a query within a React component, call `useGetAllSubsForShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubsForShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSubsForShopQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSubsForShopQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllSubsForShopQuery, GetAllSubsForShopQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllSubsForShopQuery, GetAllSubsForShopQueryVariables>(GetAllSubsForShopDocument, baseOptions);
      }
export function useGetAllSubsForShopLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllSubsForShopQuery, GetAllSubsForShopQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllSubsForShopQuery, GetAllSubsForShopQueryVariables>(GetAllSubsForShopDocument, baseOptions);
        }
export type GetAllSubsForShopQueryHookResult = ReturnType<typeof useGetAllSubsForShopQuery>;
export type GetAllSubsForShopLazyQueryHookResult = ReturnType<typeof useGetAllSubsForShopLazyQuery>;
export type GetAllSubsForShopQueryResult = ApolloReactCommon.QueryResult<GetAllSubsForShopQuery, GetAllSubsForShopQueryVariables>;
export const GetPifAndVoucherDocument = gql`
    query GetPifAndVoucher {
  pif: unstructured_data_by_pk(title: "pif") {
    data
  }
  vouchers: unstructured_data_by_pk(title: "vouchers") {
    data
  }
}
    `;
export type GetPifAndVoucherComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPifAndVoucherQuery, GetPifAndVoucherQueryVariables>, 'query'>;

    export const GetPifAndVoucherComponent = (props: GetPifAndVoucherComponentProps) => (
      <ApolloReactComponents.Query<GetPifAndVoucherQuery, GetPifAndVoucherQueryVariables> query={GetPifAndVoucherDocument} {...props} />
    );
    
export type GetPifAndVoucherProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPifAndVoucherQuery, GetPifAndVoucherQueryVariables>
    } & TChildProps;
export function withGetPifAndVoucher<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPifAndVoucherQuery,
  GetPifAndVoucherQueryVariables,
  GetPifAndVoucherProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPifAndVoucherQuery, GetPifAndVoucherQueryVariables, GetPifAndVoucherProps<TChildProps, TDataName>>(GetPifAndVoucherDocument, {
      alias: 'getPifAndVoucher',
      ...operationOptions
    });
};

/**
 * __useGetPifAndVoucherQuery__
 *
 * To run a query within a React component, call `useGetPifAndVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPifAndVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPifAndVoucherQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPifAndVoucherQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPifAndVoucherQuery, GetPifAndVoucherQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPifAndVoucherQuery, GetPifAndVoucherQueryVariables>(GetPifAndVoucherDocument, baseOptions);
      }
export function useGetPifAndVoucherLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPifAndVoucherQuery, GetPifAndVoucherQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPifAndVoucherQuery, GetPifAndVoucherQueryVariables>(GetPifAndVoucherDocument, baseOptions);
        }
export type GetPifAndVoucherQueryHookResult = ReturnType<typeof useGetPifAndVoucherQuery>;
export type GetPifAndVoucherLazyQueryHookResult = ReturnType<typeof useGetPifAndVoucherLazyQuery>;
export type GetPifAndVoucherQueryResult = ApolloReactCommon.QueryResult<GetPifAndVoucherQuery, GetPifAndVoucherQueryVariables>;
export const GetSubscriptionDocument = gql`
    query GetSubscription($slug: String!) {
  subscriptions(where: {_and: [{slug: {_eq: $slug}}, {is_active: {_eq: true}}]}) {
    id
    slug
    title
    description
    image
    price
  }
  unstructured_data_by_pk(title: "sub_how_to") {
    data
  }
}
    `;
export type GetSubscriptionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>, 'query'> & ({ variables: GetSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubscriptionComponent = (props: GetSubscriptionComponentProps) => (
      <ApolloReactComponents.Query<GetSubscriptionQuery, GetSubscriptionQueryVariables> query={GetSubscriptionDocument} {...props} />
    );
    
export type GetSubscriptionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubscriptionQuery, GetSubscriptionQueryVariables>
    } & TChildProps;
export function withGetSubscription<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubscriptionQuery,
  GetSubscriptionQueryVariables,
  GetSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubscriptionQuery, GetSubscriptionQueryVariables, GetSubscriptionProps<TChildProps, TDataName>>(GetSubscriptionDocument, {
      alias: 'getSubscription',
      ...operationOptions
    });
};

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, baseOptions);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, baseOptions);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionQueryResult = ApolloReactCommon.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const GetBooksellersAndPostsDocument = gql`
    query GetBooksellersAndPosts {
  booksellers(order_by: {name: desc}) {
    id
    name
    avatar
    video_url
    about
    posts(limit: 4, order_by: {created_at: desc}) {
      ...PostCardData
    }
  }
}
    ${PostCardDataFragmentDoc}`;
export type GetBooksellersAndPostsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBooksellersAndPostsQuery, GetBooksellersAndPostsQueryVariables>, 'query'>;

    export const GetBooksellersAndPostsComponent = (props: GetBooksellersAndPostsComponentProps) => (
      <ApolloReactComponents.Query<GetBooksellersAndPostsQuery, GetBooksellersAndPostsQueryVariables> query={GetBooksellersAndPostsDocument} {...props} />
    );
    
export type GetBooksellersAndPostsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBooksellersAndPostsQuery, GetBooksellersAndPostsQueryVariables>
    } & TChildProps;
export function withGetBooksellersAndPosts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBooksellersAndPostsQuery,
  GetBooksellersAndPostsQueryVariables,
  GetBooksellersAndPostsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBooksellersAndPostsQuery, GetBooksellersAndPostsQueryVariables, GetBooksellersAndPostsProps<TChildProps, TDataName>>(GetBooksellersAndPostsDocument, {
      alias: 'getBooksellersAndPosts',
      ...operationOptions
    });
};

/**
 * __useGetBooksellersAndPostsQuery__
 *
 * To run a query within a React component, call `useGetBooksellersAndPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBooksellersAndPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBooksellersAndPostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBooksellersAndPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBooksellersAndPostsQuery, GetBooksellersAndPostsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBooksellersAndPostsQuery, GetBooksellersAndPostsQueryVariables>(GetBooksellersAndPostsDocument, baseOptions);
      }
export function useGetBooksellersAndPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBooksellersAndPostsQuery, GetBooksellersAndPostsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBooksellersAndPostsQuery, GetBooksellersAndPostsQueryVariables>(GetBooksellersAndPostsDocument, baseOptions);
        }
export type GetBooksellersAndPostsQueryHookResult = ReturnType<typeof useGetBooksellersAndPostsQuery>;
export type GetBooksellersAndPostsLazyQueryHookResult = ReturnType<typeof useGetBooksellersAndPostsLazyQuery>;
export type GetBooksellersAndPostsQueryResult = ApolloReactCommon.QueryResult<GetBooksellersAndPostsQuery, GetBooksellersAndPostsQueryVariables>;
export const GetAccountDetailsDocument = gql`
    query GetAccountDetails($id: uuid!) {
  accounts_by_pk(id: $id) {
    email
    display_name
    phone_number
    addresses {
      id
      name
      contact_email
      phone_number
      line_1
      line_2
      line_3
      region
      city
      code
      country {
        code
        name
      }
    }
    primary_address {
      id
    }
  }
}
    `;
export type GetAccountDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>, 'query'> & ({ variables: GetAccountDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAccountDetailsComponent = (props: GetAccountDetailsComponentProps) => (
      <ApolloReactComponents.Query<GetAccountDetailsQuery, GetAccountDetailsQueryVariables> query={GetAccountDetailsDocument} {...props} />
    );
    
export type GetAccountDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>
    } & TChildProps;
export function withGetAccountDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAccountDetailsQuery,
  GetAccountDetailsQueryVariables,
  GetAccountDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAccountDetailsQuery, GetAccountDetailsQueryVariables, GetAccountDetailsProps<TChildProps, TDataName>>(GetAccountDetailsDocument, {
      alias: 'getAccountDetails',
      ...operationOptions
    });
};

/**
 * __useGetAccountDetailsQuery__
 *
 * To run a query within a React component, call `useGetAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, baseOptions);
      }
export function useGetAccountDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, baseOptions);
        }
export type GetAccountDetailsQueryHookResult = ReturnType<typeof useGetAccountDetailsQuery>;
export type GetAccountDetailsLazyQueryHookResult = ReturnType<typeof useGetAccountDetailsLazyQuery>;
export type GetAccountDetailsQueryResult = ApolloReactCommon.QueryResult<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>;
export const UpdateEmailDocument = gql`
    mutation UpdateEmail($id: uuid!, $email: String!) {
  update_accounts_by_pk(pk_columns: {id: $id}, _set: {email: $email}) {
    id
  }
}
    `;
export type UpdateEmailMutationFn = ApolloReactCommon.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;
export type UpdateEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateEmailMutation, UpdateEmailMutationVariables>, 'mutation'>;

    export const UpdateEmailComponent = (props: UpdateEmailComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateEmailMutation, UpdateEmailMutationVariables> mutation={UpdateEmailDocument} {...props} />
    );
    
export type UpdateEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>
    } & TChildProps;
export function withUpdateEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEmailMutation,
  UpdateEmailMutationVariables,
  UpdateEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEmailMutation, UpdateEmailMutationVariables, UpdateEmailProps<TChildProps, TDataName>>(UpdateEmailDocument, {
      alias: 'updateEmail',
      ...operationOptions
    });
};

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, baseOptions);
      }
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = ApolloReactCommon.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdateDisplayNameDocument = gql`
    mutation UpdateDisplayName($id: uuid!, $name: String!) {
  update_accounts_by_pk(pk_columns: {id: $id}, _set: {display_name: $name}) {
    id
  }
}
    `;
export type UpdateDisplayNameMutationFn = ApolloReactCommon.MutationFunction<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>;
export type UpdateDisplayNameComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>, 'mutation'>;

    export const UpdateDisplayNameComponent = (props: UpdateDisplayNameComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables> mutation={UpdateDisplayNameDocument} {...props} />
    );
    
export type UpdateDisplayNameProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>
    } & TChildProps;
export function withUpdateDisplayName<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateDisplayNameMutation,
  UpdateDisplayNameMutationVariables,
  UpdateDisplayNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables, UpdateDisplayNameProps<TChildProps, TDataName>>(UpdateDisplayNameDocument, {
      alias: 'updateDisplayName',
      ...operationOptions
    });
};

/**
 * __useUpdateDisplayNameMutation__
 *
 * To run a mutation, you first call `useUpdateDisplayNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisplayNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisplayNameMutation, { data, loading, error }] = useUpdateDisplayNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateDisplayNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>(UpdateDisplayNameDocument, baseOptions);
      }
export type UpdateDisplayNameMutationHookResult = ReturnType<typeof useUpdateDisplayNameMutation>;
export type UpdateDisplayNameMutationResult = ApolloReactCommon.MutationResult<UpdateDisplayNameMutation>;
export type UpdateDisplayNameMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>;
export const UpdatePrimaryAddressDocument = gql`
    mutation UpdatePrimaryAddress($id: uuid!, $primaryAddress: uuid!) {
  update_accounts_by_pk(
    pk_columns: {id: $id}
    _set: {primary_address_id: $primaryAddress}
  ) {
    id
  }
}
    `;
export type UpdatePrimaryAddressMutationFn = ApolloReactCommon.MutationFunction<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables>;
export type UpdatePrimaryAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables>, 'mutation'>;

    export const UpdatePrimaryAddressComponent = (props: UpdatePrimaryAddressComponentProps) => (
      <ApolloReactComponents.Mutation<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables> mutation={UpdatePrimaryAddressDocument} {...props} />
    );
    
export type UpdatePrimaryAddressProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables>
    } & TChildProps;
export function withUpdatePrimaryAddress<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdatePrimaryAddressMutation,
  UpdatePrimaryAddressMutationVariables,
  UpdatePrimaryAddressProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables, UpdatePrimaryAddressProps<TChildProps, TDataName>>(UpdatePrimaryAddressDocument, {
      alias: 'updatePrimaryAddress',
      ...operationOptions
    });
};

/**
 * __useUpdatePrimaryAddressMutation__
 *
 * To run a mutation, you first call `useUpdatePrimaryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrimaryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrimaryAddressMutation, { data, loading, error }] = useUpdatePrimaryAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      primaryAddress: // value for 'primaryAddress'
 *   },
 * });
 */
export function useUpdatePrimaryAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables>(UpdatePrimaryAddressDocument, baseOptions);
      }
export type UpdatePrimaryAddressMutationHookResult = ReturnType<typeof useUpdatePrimaryAddressMutation>;
export type UpdatePrimaryAddressMutationResult = ApolloReactCommon.MutationResult<UpdatePrimaryAddressMutation>;
export type UpdatePrimaryAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePrimaryAddressMutation, UpdatePrimaryAddressMutationVariables>;
export const AddNewAddressDocument = gql`
    mutation AddNewAddress($address: addresses_insert_input!) {
  insert_addresses_one(object: $address) {
    id
  }
}
    `;
export type AddNewAddressMutationFn = ApolloReactCommon.MutationFunction<AddNewAddressMutation, AddNewAddressMutationVariables>;
export type AddNewAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddNewAddressMutation, AddNewAddressMutationVariables>, 'mutation'>;

    export const AddNewAddressComponent = (props: AddNewAddressComponentProps) => (
      <ApolloReactComponents.Mutation<AddNewAddressMutation, AddNewAddressMutationVariables> mutation={AddNewAddressDocument} {...props} />
    );
    
export type AddNewAddressProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddNewAddressMutation, AddNewAddressMutationVariables>
    } & TChildProps;
export function withAddNewAddress<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddNewAddressMutation,
  AddNewAddressMutationVariables,
  AddNewAddressProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddNewAddressMutation, AddNewAddressMutationVariables, AddNewAddressProps<TChildProps, TDataName>>(AddNewAddressDocument, {
      alias: 'addNewAddress',
      ...operationOptions
    });
};

/**
 * __useAddNewAddressMutation__
 *
 * To run a mutation, you first call `useAddNewAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewAddressMutation, { data, loading, error }] = useAddNewAddressMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useAddNewAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNewAddressMutation, AddNewAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<AddNewAddressMutation, AddNewAddressMutationVariables>(AddNewAddressDocument, baseOptions);
      }
export type AddNewAddressMutationHookResult = ReturnType<typeof useAddNewAddressMutation>;
export type AddNewAddressMutationResult = ApolloReactCommon.MutationResult<AddNewAddressMutation>;
export type AddNewAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<AddNewAddressMutation, AddNewAddressMutationVariables>;
export const UnlinkAddressDocument = gql`
    mutation UnlinkAddress($id: uuid!) {
  update_addresses_by_pk(pk_columns: {id: $id}, _set: {account_id: null}) {
    id
  }
}
    `;
export type UnlinkAddressMutationFn = ApolloReactCommon.MutationFunction<UnlinkAddressMutation, UnlinkAddressMutationVariables>;
export type UnlinkAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnlinkAddressMutation, UnlinkAddressMutationVariables>, 'mutation'>;

    export const UnlinkAddressComponent = (props: UnlinkAddressComponentProps) => (
      <ApolloReactComponents.Mutation<UnlinkAddressMutation, UnlinkAddressMutationVariables> mutation={UnlinkAddressDocument} {...props} />
    );
    
export type UnlinkAddressProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UnlinkAddressMutation, UnlinkAddressMutationVariables>
    } & TChildProps;
export function withUnlinkAddress<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnlinkAddressMutation,
  UnlinkAddressMutationVariables,
  UnlinkAddressProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UnlinkAddressMutation, UnlinkAddressMutationVariables, UnlinkAddressProps<TChildProps, TDataName>>(UnlinkAddressDocument, {
      alias: 'unlinkAddress',
      ...operationOptions
    });
};

/**
 * __useUnlinkAddressMutation__
 *
 * To run a mutation, you first call `useUnlinkAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkAddressMutation, { data, loading, error }] = useUnlinkAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlinkAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlinkAddressMutation, UnlinkAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<UnlinkAddressMutation, UnlinkAddressMutationVariables>(UnlinkAddressDocument, baseOptions);
      }
export type UnlinkAddressMutationHookResult = ReturnType<typeof useUnlinkAddressMutation>;
export type UnlinkAddressMutationResult = ApolloReactCommon.MutationResult<UnlinkAddressMutation>;
export type UnlinkAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlinkAddressMutation, UnlinkAddressMutationVariables>;
export const GetBookDocument = gql`
    query GetBook($isbn: bigint!) {
  books_by_pk(isbn: $isbn) {
    isbn
    title
    author
    description
    price
    stock
    track_stock
    image
    attributes
    discount_value
    is_discounted
    is_unlisted
    category_books {
      category {
        name
        slug
      }
    }
    tag_books {
      tag {
        id
        text
      }
    }
  }
}
    `;
export type GetBookComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBookQuery, GetBookQueryVariables>, 'query'> & ({ variables: GetBookQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetBookComponent = (props: GetBookComponentProps) => (
      <ApolloReactComponents.Query<GetBookQuery, GetBookQueryVariables> query={GetBookDocument} {...props} />
    );
    
export type GetBookProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBookQuery, GetBookQueryVariables>
    } & TChildProps;
export function withGetBook<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBookQuery,
  GetBookQueryVariables,
  GetBookProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBookQuery, GetBookQueryVariables, GetBookProps<TChildProps, TDataName>>(GetBookDocument, {
      alias: 'getBook',
      ...operationOptions
    });
};

/**
 * __useGetBookQuery__
 *
 * To run a query within a React component, call `useGetBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookQuery({
 *   variables: {
 *      isbn: // value for 'isbn'
 *   },
 * });
 */
export function useGetBookQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookQuery, GetBookQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookQuery, GetBookQueryVariables>(GetBookDocument, baseOptions);
      }
export function useGetBookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookQuery, GetBookQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookQuery, GetBookQueryVariables>(GetBookDocument, baseOptions);
        }
export type GetBookQueryHookResult = ReturnType<typeof useGetBookQuery>;
export type GetBookLazyQueryHookResult = ReturnType<typeof useGetBookLazyQuery>;
export type GetBookQueryResult = ApolloReactCommon.QueryResult<GetBookQuery, GetBookQueryVariables>;
export const UpdateBookDocument = gql`
    mutation UpdateBook($isbn: bigint!, $data: books_set_input!, $tags: [tag_book_insert_input!]!, $categories: [category_book_insert_input!]!) {
  update_books_by_pk(pk_columns: {isbn: $isbn}, _set: $data) {
    isbn
  }
  delete_tag_book(where: {book_isbn: {_eq: $isbn}}) {
    affected_rows
  }
  insert_tag_book(objects: $tags) {
    affected_rows
  }
  delete_category_book(where: {book_isbn: {_eq: $isbn}}) {
    affected_rows
  }
  insert_category_book(objects: $categories) {
    affected_rows
  }
}
    `;
export type UpdateBookMutationFn = ApolloReactCommon.MutationFunction<UpdateBookMutation, UpdateBookMutationVariables>;
export type UpdateBookComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateBookMutation, UpdateBookMutationVariables>, 'mutation'>;

    export const UpdateBookComponent = (props: UpdateBookComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateBookMutation, UpdateBookMutationVariables> mutation={UpdateBookDocument} {...props} />
    );
    
export type UpdateBookProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateBookMutation, UpdateBookMutationVariables>
    } & TChildProps;
export function withUpdateBook<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateBookMutation,
  UpdateBookMutationVariables,
  UpdateBookProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateBookMutation, UpdateBookMutationVariables, UpdateBookProps<TChildProps, TDataName>>(UpdateBookDocument, {
      alias: 'updateBook',
      ...operationOptions
    });
};

/**
 * __useUpdateBookMutation__
 *
 * To run a mutation, you first call `useUpdateBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookMutation, { data, loading, error }] = useUpdateBookMutation({
 *   variables: {
 *      isbn: // value for 'isbn'
 *      data: // value for 'data'
 *      tags: // value for 'tags'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useUpdateBookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBookMutation, UpdateBookMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBookMutation, UpdateBookMutationVariables>(UpdateBookDocument, baseOptions);
      }
export type UpdateBookMutationHookResult = ReturnType<typeof useUpdateBookMutation>;
export type UpdateBookMutationResult = ApolloReactCommon.MutationResult<UpdateBookMutation>;
export type UpdateBookMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBookMutation, UpdateBookMutationVariables>;
export const UnlistBookDocument = gql`
    mutation UnlistBook($isbn: bigint!, $unlist: Boolean) {
  update_books_by_pk(pk_columns: {isbn: $isbn}, _set: {is_unlisted: $unlist}) {
    isbn
  }
}
    `;
export type UnlistBookMutationFn = ApolloReactCommon.MutationFunction<UnlistBookMutation, UnlistBookMutationVariables>;
export type UnlistBookComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnlistBookMutation, UnlistBookMutationVariables>, 'mutation'>;

    export const UnlistBookComponent = (props: UnlistBookComponentProps) => (
      <ApolloReactComponents.Mutation<UnlistBookMutation, UnlistBookMutationVariables> mutation={UnlistBookDocument} {...props} />
    );
    
export type UnlistBookProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UnlistBookMutation, UnlistBookMutationVariables>
    } & TChildProps;
export function withUnlistBook<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnlistBookMutation,
  UnlistBookMutationVariables,
  UnlistBookProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UnlistBookMutation, UnlistBookMutationVariables, UnlistBookProps<TChildProps, TDataName>>(UnlistBookDocument, {
      alias: 'unlistBook',
      ...operationOptions
    });
};

/**
 * __useUnlistBookMutation__
 *
 * To run a mutation, you first call `useUnlistBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlistBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlistBookMutation, { data, loading, error }] = useUnlistBookMutation({
 *   variables: {
 *      isbn: // value for 'isbn'
 *      unlist: // value for 'unlist'
 *   },
 * });
 */
export function useUnlistBookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlistBookMutation, UnlistBookMutationVariables>) {
        return ApolloReactHooks.useMutation<UnlistBookMutation, UnlistBookMutationVariables>(UnlistBookDocument, baseOptions);
      }
export type UnlistBookMutationHookResult = ReturnType<typeof useUnlistBookMutation>;
export type UnlistBookMutationResult = ApolloReactCommon.MutationResult<UnlistBookMutation>;
export type UnlistBookMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlistBookMutation, UnlistBookMutationVariables>;
export const GetAllBooksForAdminPanelDocument = gql`
    query GetAllBooksForAdminPanel($limit: Int, $offset: Int, $orderBy: [books_order_by!], $conditions: books_bool_exp) {
  books_aggregate(where: $conditions) {
    aggregate {
      count
    }
  }
  books(limit: $limit, offset: $offset, order_by: $orderBy, where: $conditions) {
    isbn
    title
    author
    stock
    price
    created_at
    is_unlisted
    track_stock
  }
}
    `;
export type GetAllBooksForAdminPanelComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllBooksForAdminPanelQuery, GetAllBooksForAdminPanelQueryVariables>, 'query'>;

    export const GetAllBooksForAdminPanelComponent = (props: GetAllBooksForAdminPanelComponentProps) => (
      <ApolloReactComponents.Query<GetAllBooksForAdminPanelQuery, GetAllBooksForAdminPanelQueryVariables> query={GetAllBooksForAdminPanelDocument} {...props} />
    );
    
export type GetAllBooksForAdminPanelProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllBooksForAdminPanelQuery, GetAllBooksForAdminPanelQueryVariables>
    } & TChildProps;
export function withGetAllBooksForAdminPanel<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllBooksForAdminPanelQuery,
  GetAllBooksForAdminPanelQueryVariables,
  GetAllBooksForAdminPanelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllBooksForAdminPanelQuery, GetAllBooksForAdminPanelQueryVariables, GetAllBooksForAdminPanelProps<TChildProps, TDataName>>(GetAllBooksForAdminPanelDocument, {
      alias: 'getAllBooksForAdminPanel',
      ...operationOptions
    });
};

/**
 * __useGetAllBooksForAdminPanelQuery__
 *
 * To run a query within a React component, call `useGetAllBooksForAdminPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBooksForAdminPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBooksForAdminPanelQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useGetAllBooksForAdminPanelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllBooksForAdminPanelQuery, GetAllBooksForAdminPanelQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllBooksForAdminPanelQuery, GetAllBooksForAdminPanelQueryVariables>(GetAllBooksForAdminPanelDocument, baseOptions);
      }
export function useGetAllBooksForAdminPanelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllBooksForAdminPanelQuery, GetAllBooksForAdminPanelQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllBooksForAdminPanelQuery, GetAllBooksForAdminPanelQueryVariables>(GetAllBooksForAdminPanelDocument, baseOptions);
        }
export type GetAllBooksForAdminPanelQueryHookResult = ReturnType<typeof useGetAllBooksForAdminPanelQuery>;
export type GetAllBooksForAdminPanelLazyQueryHookResult = ReturnType<typeof useGetAllBooksForAdminPanelLazyQuery>;
export type GetAllBooksForAdminPanelQueryResult = ApolloReactCommon.QueryResult<GetAllBooksForAdminPanelQuery, GetAllBooksForAdminPanelQueryVariables>;
export const InsertNewBookDocument = gql`
    mutation InsertNewBook($data: books_insert_input!) {
  insert_books_one(object: $data) {
    isbn
  }
}
    `;
export type InsertNewBookMutationFn = ApolloReactCommon.MutationFunction<InsertNewBookMutation, InsertNewBookMutationVariables>;
export type InsertNewBookComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertNewBookMutation, InsertNewBookMutationVariables>, 'mutation'>;

    export const InsertNewBookComponent = (props: InsertNewBookComponentProps) => (
      <ApolloReactComponents.Mutation<InsertNewBookMutation, InsertNewBookMutationVariables> mutation={InsertNewBookDocument} {...props} />
    );
    
export type InsertNewBookProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertNewBookMutation, InsertNewBookMutationVariables>
    } & TChildProps;
export function withInsertNewBook<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertNewBookMutation,
  InsertNewBookMutationVariables,
  InsertNewBookProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertNewBookMutation, InsertNewBookMutationVariables, InsertNewBookProps<TChildProps, TDataName>>(InsertNewBookDocument, {
      alias: 'insertNewBook',
      ...operationOptions
    });
};

/**
 * __useInsertNewBookMutation__
 *
 * To run a mutation, you first call `useInsertNewBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewBookMutation, { data, loading, error }] = useInsertNewBookMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInsertNewBookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertNewBookMutation, InsertNewBookMutationVariables>) {
        return ApolloReactHooks.useMutation<InsertNewBookMutation, InsertNewBookMutationVariables>(InsertNewBookDocument, baseOptions);
      }
export type InsertNewBookMutationHookResult = ReturnType<typeof useInsertNewBookMutation>;
export type InsertNewBookMutationResult = ApolloReactCommon.MutationResult<InsertNewBookMutation>;
export type InsertNewBookMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertNewBookMutation, InsertNewBookMutationVariables>;
export const GetCategoryForAdminDocument = gql`
    query GetCategoryForAdmin($slug: String!) {
  categories(where: {slug: {_eq: $slug}}) {
    name
    description
    slug
    category_books {
      book {
        title
        isbn
        author
      }
    }
    rankedBooks: category_books(
      where: {rank_order: {_is_null: false}}
      order_by: {rank_order: asc}
    ) {
      book {
        title
        isbn
        author
      }
    }
  }
}
    `;
export type GetCategoryForAdminComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCategoryForAdminQuery, GetCategoryForAdminQueryVariables>, 'query'> & ({ variables: GetCategoryForAdminQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCategoryForAdminComponent = (props: GetCategoryForAdminComponentProps) => (
      <ApolloReactComponents.Query<GetCategoryForAdminQuery, GetCategoryForAdminQueryVariables> query={GetCategoryForAdminDocument} {...props} />
    );
    
export type GetCategoryForAdminProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCategoryForAdminQuery, GetCategoryForAdminQueryVariables>
    } & TChildProps;
export function withGetCategoryForAdmin<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCategoryForAdminQuery,
  GetCategoryForAdminQueryVariables,
  GetCategoryForAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCategoryForAdminQuery, GetCategoryForAdminQueryVariables, GetCategoryForAdminProps<TChildProps, TDataName>>(GetCategoryForAdminDocument, {
      alias: 'getCategoryForAdmin',
      ...operationOptions
    });
};

/**
 * __useGetCategoryForAdminQuery__
 *
 * To run a query within a React component, call `useGetCategoryForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryForAdminQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCategoryForAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCategoryForAdminQuery, GetCategoryForAdminQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCategoryForAdminQuery, GetCategoryForAdminQueryVariables>(GetCategoryForAdminDocument, baseOptions);
      }
export function useGetCategoryForAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCategoryForAdminQuery, GetCategoryForAdminQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCategoryForAdminQuery, GetCategoryForAdminQueryVariables>(GetCategoryForAdminDocument, baseOptions);
        }
export type GetCategoryForAdminQueryHookResult = ReturnType<typeof useGetCategoryForAdminQuery>;
export type GetCategoryForAdminLazyQueryHookResult = ReturnType<typeof useGetCategoryForAdminLazyQuery>;
export type GetCategoryForAdminQueryResult = ApolloReactCommon.QueryResult<GetCategoryForAdminQuery, GetCategoryForAdminQueryVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($data: categories_set_input, $name: String!) {
  update_categories_by_pk(pk_columns: {name: $name}, _set: $data) {
    name
  }
}
    `;
export type UpdateCategoryMutationFn = ApolloReactCommon.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export type UpdateCategoryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>, 'mutation'>;

    export const UpdateCategoryComponent = (props: UpdateCategoryComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateCategoryMutation, UpdateCategoryMutationVariables> mutation={UpdateCategoryDocument} {...props} />
    );
    
export type UpdateCategoryProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>
    } & TChildProps;
export function withUpdateCategory<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCategoryMutation,
  UpdateCategoryMutationVariables,
  UpdateCategoryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCategoryMutation, UpdateCategoryMutationVariables, UpdateCategoryProps<TChildProps, TDataName>>(UpdateCategoryDocument, {
      alias: 'updateCategory',
      ...operationOptions
    });
};

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, baseOptions);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = ApolloReactCommon.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const UpdateCategoryBooksDocument = gql`
    mutation UpdateCategoryBooks($books: [category_book_insert_input!]!, $name: String!) {
  delete_category_book(where: {category_name: {_eq: $name}}) {
    affected_rows
  }
  insert_category_book(objects: $books) {
    affected_rows
  }
}
    `;
export type UpdateCategoryBooksMutationFn = ApolloReactCommon.MutationFunction<UpdateCategoryBooksMutation, UpdateCategoryBooksMutationVariables>;
export type UpdateCategoryBooksComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCategoryBooksMutation, UpdateCategoryBooksMutationVariables>, 'mutation'>;

    export const UpdateCategoryBooksComponent = (props: UpdateCategoryBooksComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateCategoryBooksMutation, UpdateCategoryBooksMutationVariables> mutation={UpdateCategoryBooksDocument} {...props} />
    );
    
export type UpdateCategoryBooksProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCategoryBooksMutation, UpdateCategoryBooksMutationVariables>
    } & TChildProps;
export function withUpdateCategoryBooks<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCategoryBooksMutation,
  UpdateCategoryBooksMutationVariables,
  UpdateCategoryBooksProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCategoryBooksMutation, UpdateCategoryBooksMutationVariables, UpdateCategoryBooksProps<TChildProps, TDataName>>(UpdateCategoryBooksDocument, {
      alias: 'updateCategoryBooks',
      ...operationOptions
    });
};

/**
 * __useUpdateCategoryBooksMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryBooksMutation, { data, loading, error }] = useUpdateCategoryBooksMutation({
 *   variables: {
 *      books: // value for 'books'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCategoryBooksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCategoryBooksMutation, UpdateCategoryBooksMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCategoryBooksMutation, UpdateCategoryBooksMutationVariables>(UpdateCategoryBooksDocument, baseOptions);
      }
export type UpdateCategoryBooksMutationHookResult = ReturnType<typeof useUpdateCategoryBooksMutation>;
export type UpdateCategoryBooksMutationResult = ApolloReactCommon.MutationResult<UpdateCategoryBooksMutation>;
export type UpdateCategoryBooksMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCategoryBooksMutation, UpdateCategoryBooksMutationVariables>;
export const CmsGetAllCategoriesDocument = gql`
    query CmsGetAllCategories {
  categories(order_by: {name: asc}) {
    name
    slug
    category_books_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;
export type CmsGetAllCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CmsGetAllCategoriesQuery, CmsGetAllCategoriesQueryVariables>, 'query'>;

    export const CmsGetAllCategoriesComponent = (props: CmsGetAllCategoriesComponentProps) => (
      <ApolloReactComponents.Query<CmsGetAllCategoriesQuery, CmsGetAllCategoriesQueryVariables> query={CmsGetAllCategoriesDocument} {...props} />
    );
    
export type CmsGetAllCategoriesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CmsGetAllCategoriesQuery, CmsGetAllCategoriesQueryVariables>
    } & TChildProps;
export function withCmsGetAllCategories<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CmsGetAllCategoriesQuery,
  CmsGetAllCategoriesQueryVariables,
  CmsGetAllCategoriesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CmsGetAllCategoriesQuery, CmsGetAllCategoriesQueryVariables, CmsGetAllCategoriesProps<TChildProps, TDataName>>(CmsGetAllCategoriesDocument, {
      alias: 'cmsGetAllCategories',
      ...operationOptions
    });
};

/**
 * __useCmsGetAllCategoriesQuery__
 *
 * To run a query within a React component, call `useCmsGetAllCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsGetAllCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsGetAllCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCmsGetAllCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CmsGetAllCategoriesQuery, CmsGetAllCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<CmsGetAllCategoriesQuery, CmsGetAllCategoriesQueryVariables>(CmsGetAllCategoriesDocument, baseOptions);
      }
export function useCmsGetAllCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CmsGetAllCategoriesQuery, CmsGetAllCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CmsGetAllCategoriesQuery, CmsGetAllCategoriesQueryVariables>(CmsGetAllCategoriesDocument, baseOptions);
        }
export type CmsGetAllCategoriesQueryHookResult = ReturnType<typeof useCmsGetAllCategoriesQuery>;
export type CmsGetAllCategoriesLazyQueryHookResult = ReturnType<typeof useCmsGetAllCategoriesLazyQuery>;
export type CmsGetAllCategoriesQueryResult = ApolloReactCommon.QueryResult<CmsGetAllCategoriesQuery, CmsGetAllCategoriesQueryVariables>;
export const GetDiscountDetailsDocument = gql`
    query GetDiscountDetails($code: String!) {
  discounts_by_pk(code: $code) {
    code
    discount_value
    created_at
    discount_value
    is_active
    is_fixed_amount
    limit_uses
    total_uses
    discounted_books {
      book {
        isbn
        title
        author
      }
    }
  }
}
    `;
export type GetDiscountDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDiscountDetailsQuery, GetDiscountDetailsQueryVariables>, 'query'> & ({ variables: GetDiscountDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDiscountDetailsComponent = (props: GetDiscountDetailsComponentProps) => (
      <ApolloReactComponents.Query<GetDiscountDetailsQuery, GetDiscountDetailsQueryVariables> query={GetDiscountDetailsDocument} {...props} />
    );
    
export type GetDiscountDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDiscountDetailsQuery, GetDiscountDetailsQueryVariables>
    } & TChildProps;
export function withGetDiscountDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDiscountDetailsQuery,
  GetDiscountDetailsQueryVariables,
  GetDiscountDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDiscountDetailsQuery, GetDiscountDetailsQueryVariables, GetDiscountDetailsProps<TChildProps, TDataName>>(GetDiscountDetailsDocument, {
      alias: 'getDiscountDetails',
      ...operationOptions
    });
};

/**
 * __useGetDiscountDetailsQuery__
 *
 * To run a query within a React component, call `useGetDiscountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountDetailsQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetDiscountDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDiscountDetailsQuery, GetDiscountDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDiscountDetailsQuery, GetDiscountDetailsQueryVariables>(GetDiscountDetailsDocument, baseOptions);
      }
export function useGetDiscountDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDiscountDetailsQuery, GetDiscountDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDiscountDetailsQuery, GetDiscountDetailsQueryVariables>(GetDiscountDetailsDocument, baseOptions);
        }
export type GetDiscountDetailsQueryHookResult = ReturnType<typeof useGetDiscountDetailsQuery>;
export type GetDiscountDetailsLazyQueryHookResult = ReturnType<typeof useGetDiscountDetailsLazyQuery>;
export type GetDiscountDetailsQueryResult = ApolloReactCommon.QueryResult<GetDiscountDetailsQuery, GetDiscountDetailsQueryVariables>;
export const UpdateDiscountDetailsDocument = gql`
    mutation UpdateDiscountDetails($code: String!, $data: discounts_set_input, $books: [book_discount_insert_input!]!) {
  update_discounts_by_pk(pk_columns: {code: $code}, _set: $data) {
    code
  }
  delete_book_discount(where: {discount_id: {_eq: $code}}) {
    affected_rows
  }
  insert_book_discount(objects: $books) {
    affected_rows
  }
}
    `;
export type UpdateDiscountDetailsMutationFn = ApolloReactCommon.MutationFunction<UpdateDiscountDetailsMutation, UpdateDiscountDetailsMutationVariables>;
export type UpdateDiscountDetailsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateDiscountDetailsMutation, UpdateDiscountDetailsMutationVariables>, 'mutation'>;

    export const UpdateDiscountDetailsComponent = (props: UpdateDiscountDetailsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateDiscountDetailsMutation, UpdateDiscountDetailsMutationVariables> mutation={UpdateDiscountDetailsDocument} {...props} />
    );
    
export type UpdateDiscountDetailsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateDiscountDetailsMutation, UpdateDiscountDetailsMutationVariables>
    } & TChildProps;
export function withUpdateDiscountDetails<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateDiscountDetailsMutation,
  UpdateDiscountDetailsMutationVariables,
  UpdateDiscountDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateDiscountDetailsMutation, UpdateDiscountDetailsMutationVariables, UpdateDiscountDetailsProps<TChildProps, TDataName>>(UpdateDiscountDetailsDocument, {
      alias: 'updateDiscountDetails',
      ...operationOptions
    });
};

/**
 * __useUpdateDiscountDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountDetailsMutation, { data, loading, error }] = useUpdateDiscountDetailsMutation({
 *   variables: {
 *      code: // value for 'code'
 *      data: // value for 'data'
 *      books: // value for 'books'
 *   },
 * });
 */
export function useUpdateDiscountDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDiscountDetailsMutation, UpdateDiscountDetailsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDiscountDetailsMutation, UpdateDiscountDetailsMutationVariables>(UpdateDiscountDetailsDocument, baseOptions);
      }
export type UpdateDiscountDetailsMutationHookResult = ReturnType<typeof useUpdateDiscountDetailsMutation>;
export type UpdateDiscountDetailsMutationResult = ApolloReactCommon.MutationResult<UpdateDiscountDetailsMutation>;
export type UpdateDiscountDetailsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDiscountDetailsMutation, UpdateDiscountDetailsMutationVariables>;
export const GetDiscountCodesDocument = gql`
    query GetDiscountCodes($limit: Int, $offset: Int, $conditions: discounts_bool_exp) {
  discounts_aggregate(where: $conditions) {
    aggregate {
      count
    }
  }
  discounts(
    limit: $limit
    offset: $offset
    where: $conditions
    order_by: {created_at: desc}
  ) {
    code
    discount_value
    is_fixed_amount
    created_at
    is_active
    orders_aggregate(where: {status: {_neq: draft}}) {
      aggregate {
        count
      }
    }
  }
}
    `;
export type GetDiscountCodesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>, 'query'>;

    export const GetDiscountCodesComponent = (props: GetDiscountCodesComponentProps) => (
      <ApolloReactComponents.Query<GetDiscountCodesQuery, GetDiscountCodesQueryVariables> query={GetDiscountCodesDocument} {...props} />
    );
    
export type GetDiscountCodesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>
    } & TChildProps;
export function withGetDiscountCodes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDiscountCodesQuery,
  GetDiscountCodesQueryVariables,
  GetDiscountCodesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDiscountCodesQuery, GetDiscountCodesQueryVariables, GetDiscountCodesProps<TChildProps, TDataName>>(GetDiscountCodesDocument, {
      alias: 'getDiscountCodes',
      ...operationOptions
    });
};

/**
 * __useGetDiscountCodesQuery__
 *
 * To run a query within a React component, call `useGetDiscountCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountCodesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useGetDiscountCodesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>(GetDiscountCodesDocument, baseOptions);
      }
export function useGetDiscountCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>(GetDiscountCodesDocument, baseOptions);
        }
export type GetDiscountCodesQueryHookResult = ReturnType<typeof useGetDiscountCodesQuery>;
export type GetDiscountCodesLazyQueryHookResult = ReturnType<typeof useGetDiscountCodesLazyQuery>;
export type GetDiscountCodesQueryResult = ApolloReactCommon.QueryResult<GetDiscountCodesQuery, GetDiscountCodesQueryVariables>;
export const ToggleCodeEnabledDocument = gql`
    mutation ToggleCodeEnabled($code: String!, $isActive: Boolean!) {
  update_discounts_by_pk(pk_columns: {code: $code}, _set: {is_active: $isActive}) {
    code
  }
}
    `;
export type ToggleCodeEnabledMutationFn = ApolloReactCommon.MutationFunction<ToggleCodeEnabledMutation, ToggleCodeEnabledMutationVariables>;
export type ToggleCodeEnabledComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ToggleCodeEnabledMutation, ToggleCodeEnabledMutationVariables>, 'mutation'>;

    export const ToggleCodeEnabledComponent = (props: ToggleCodeEnabledComponentProps) => (
      <ApolloReactComponents.Mutation<ToggleCodeEnabledMutation, ToggleCodeEnabledMutationVariables> mutation={ToggleCodeEnabledDocument} {...props} />
    );
    
export type ToggleCodeEnabledProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ToggleCodeEnabledMutation, ToggleCodeEnabledMutationVariables>
    } & TChildProps;
export function withToggleCodeEnabled<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ToggleCodeEnabledMutation,
  ToggleCodeEnabledMutationVariables,
  ToggleCodeEnabledProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ToggleCodeEnabledMutation, ToggleCodeEnabledMutationVariables, ToggleCodeEnabledProps<TChildProps, TDataName>>(ToggleCodeEnabledDocument, {
      alias: 'toggleCodeEnabled',
      ...operationOptions
    });
};

/**
 * __useToggleCodeEnabledMutation__
 *
 * To run a mutation, you first call `useToggleCodeEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCodeEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCodeEnabledMutation, { data, loading, error }] = useToggleCodeEnabledMutation({
 *   variables: {
 *      code: // value for 'code'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useToggleCodeEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleCodeEnabledMutation, ToggleCodeEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleCodeEnabledMutation, ToggleCodeEnabledMutationVariables>(ToggleCodeEnabledDocument, baseOptions);
      }
export type ToggleCodeEnabledMutationHookResult = ReturnType<typeof useToggleCodeEnabledMutation>;
export type ToggleCodeEnabledMutationResult = ApolloReactCommon.MutationResult<ToggleCodeEnabledMutation>;
export type ToggleCodeEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleCodeEnabledMutation, ToggleCodeEnabledMutationVariables>;
export const CreateNewDiscountDocument = gql`
    mutation CreateNewDiscount($data: discounts_insert_input!) {
  insert_discounts_one(object: $data) {
    code
  }
}
    `;
export type CreateNewDiscountMutationFn = ApolloReactCommon.MutationFunction<CreateNewDiscountMutation, CreateNewDiscountMutationVariables>;
export type CreateNewDiscountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateNewDiscountMutation, CreateNewDiscountMutationVariables>, 'mutation'>;

    export const CreateNewDiscountComponent = (props: CreateNewDiscountComponentProps) => (
      <ApolloReactComponents.Mutation<CreateNewDiscountMutation, CreateNewDiscountMutationVariables> mutation={CreateNewDiscountDocument} {...props} />
    );
    
export type CreateNewDiscountProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateNewDiscountMutation, CreateNewDiscountMutationVariables>
    } & TChildProps;
export function withCreateNewDiscount<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateNewDiscountMutation,
  CreateNewDiscountMutationVariables,
  CreateNewDiscountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateNewDiscountMutation, CreateNewDiscountMutationVariables, CreateNewDiscountProps<TChildProps, TDataName>>(CreateNewDiscountDocument, {
      alias: 'createNewDiscount',
      ...operationOptions
    });
};

/**
 * __useCreateNewDiscountMutation__
 *
 * To run a mutation, you first call `useCreateNewDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewDiscountMutation, { data, loading, error }] = useCreateNewDiscountMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNewDiscountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNewDiscountMutation, CreateNewDiscountMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateNewDiscountMutation, CreateNewDiscountMutationVariables>(CreateNewDiscountDocument, baseOptions);
      }
export type CreateNewDiscountMutationHookResult = ReturnType<typeof useCreateNewDiscountMutation>;
export type CreateNewDiscountMutationResult = ApolloReactCommon.MutationResult<CreateNewDiscountMutation>;
export type CreateNewDiscountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNewDiscountMutation, CreateNewDiscountMutationVariables>;
export const GetEventForAdminDocument = gql`
    query GetEventForAdmin($slug: String!) {
  events(where: {slug: {_eq: $slug}}) {
    title
    id
    slug
    notes
    description
    start_time
    end_time
    speakers
    image
    video
    location
    video_conf_location
    is_cancelled
    event_books {
      book {
        title
        isbn
        author
      }
    }
    category_events {
      category {
        name
      }
    }
    festival {
      id
      title
      start_time
    }
    price
    seats
    free_seats
    is_festival
    is_online_only
    is_in_person_only
    is_book_club
    attendees(
      where: {_and: [{_or: [{voucher_id: {_is_null: true}}, {voucher: {order: {status: {_nin: [draft, cancelled]}}}}, {_and: [{voucher_id: {_is_null: false}}, {voucher: {order_id: {_is_null: true}}}]}]}, {_or: [{order_book_id: {_is_null: true}}, {order_book: {order: {status: {_nin: [draft, cancelled]}}}}]}, {is_attending: {_eq: true}}]}
    ) {
      id
      address {
        name
        contact_email
      }
      is_online_viewer
      is_free_attendee
      voucher {
        remaining_amount
        id
      }
      order_book {
        id
      }
    }
  }
  event_tickets(
    where: {_and: [{event: {slug: {_eq: $slug}}}, {_or: [{voucher_id: {_is_null: true}}, {voucher: {order: {status: {_nin: [draft, cancelled]}}}}, {_and: [{voucher_id: {_is_null: false}}, {voucher: {order_id: {_is_null: true}}}]}]}, {_or: [{order_book_id: {_is_null: true}}, {order_book: {order: {status: {_nin: [draft, cancelled]}}}}]}, {is_attending: {_eq: true}}]}
  ) {
    is_free_attendee
    is_online_viewer
    order_book_id
    voucher_id
  }
}
    `;
export type GetEventForAdminComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetEventForAdminQuery, GetEventForAdminQueryVariables>, 'query'> & ({ variables: GetEventForAdminQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetEventForAdminComponent = (props: GetEventForAdminComponentProps) => (
      <ApolloReactComponents.Query<GetEventForAdminQuery, GetEventForAdminQueryVariables> query={GetEventForAdminDocument} {...props} />
    );
    
export type GetEventForAdminProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventForAdminQuery, GetEventForAdminQueryVariables>
    } & TChildProps;
export function withGetEventForAdmin<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventForAdminQuery,
  GetEventForAdminQueryVariables,
  GetEventForAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventForAdminQuery, GetEventForAdminQueryVariables, GetEventForAdminProps<TChildProps, TDataName>>(GetEventForAdminDocument, {
      alias: 'getEventForAdmin',
      ...operationOptions
    });
};

/**
 * __useGetEventForAdminQuery__
 *
 * To run a query within a React component, call `useGetEventForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForAdminQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetEventForAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventForAdminQuery, GetEventForAdminQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventForAdminQuery, GetEventForAdminQueryVariables>(GetEventForAdminDocument, baseOptions);
      }
export function useGetEventForAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventForAdminQuery, GetEventForAdminQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventForAdminQuery, GetEventForAdminQueryVariables>(GetEventForAdminDocument, baseOptions);
        }
export type GetEventForAdminQueryHookResult = ReturnType<typeof useGetEventForAdminQuery>;
export type GetEventForAdminLazyQueryHookResult = ReturnType<typeof useGetEventForAdminLazyQuery>;
export type GetEventForAdminQueryResult = ApolloReactCommon.QueryResult<GetEventForAdminQuery, GetEventForAdminQueryVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($data: events_set_input, $id: uuid!, $books: [event_book_insert_input!]!, $categories: [category_event_insert_input!]!) {
  update_events_by_pk(pk_columns: {id: $id}, _set: $data) {
    slug
  }
  delete_event_book(where: {event_id: {_eq: $id}}) {
    affected_rows
  }
  insert_event_book(objects: $books) {
    affected_rows
  }
  delete_category_event(where: {event_id: {_eq: $id}}) {
    affected_rows
  }
  insert_category_event(objects: $categories) {
    affected_rows
  }
}
    `;
export type UpdateEventMutationFn = ApolloReactCommon.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;
export type UpdateEventComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateEventMutation, UpdateEventMutationVariables>, 'mutation'>;

    export const UpdateEventComponent = (props: UpdateEventComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateEventMutation, UpdateEventMutationVariables> mutation={UpdateEventDocument} {...props} />
    );
    
export type UpdateEventProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>
    } & TChildProps;
export function withUpdateEvent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEventMutation,
  UpdateEventMutationVariables,
  UpdateEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEventMutation, UpdateEventMutationVariables, UpdateEventProps<TChildProps, TDataName>>(UpdateEventDocument, {
      alias: 'updateEvent',
      ...operationOptions
    });
};

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      books: // value for 'books'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, baseOptions);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = ApolloReactCommon.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateEventCancelledDocument = gql`
    mutation UpdateEventCancelled($cancelled: Boolean, $id: uuid!) {
  update_events_by_pk(pk_columns: {id: $id}, _set: {is_cancelled: $cancelled}) {
    id
  }
}
    `;
export type UpdateEventCancelledMutationFn = ApolloReactCommon.MutationFunction<UpdateEventCancelledMutation, UpdateEventCancelledMutationVariables>;
export type UpdateEventCancelledComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateEventCancelledMutation, UpdateEventCancelledMutationVariables>, 'mutation'>;

    export const UpdateEventCancelledComponent = (props: UpdateEventCancelledComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateEventCancelledMutation, UpdateEventCancelledMutationVariables> mutation={UpdateEventCancelledDocument} {...props} />
    );
    
export type UpdateEventCancelledProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEventCancelledMutation, UpdateEventCancelledMutationVariables>
    } & TChildProps;
export function withUpdateEventCancelled<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEventCancelledMutation,
  UpdateEventCancelledMutationVariables,
  UpdateEventCancelledProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEventCancelledMutation, UpdateEventCancelledMutationVariables, UpdateEventCancelledProps<TChildProps, TDataName>>(UpdateEventCancelledDocument, {
      alias: 'updateEventCancelled',
      ...operationOptions
    });
};

/**
 * __useUpdateEventCancelledMutation__
 *
 * To run a mutation, you first call `useUpdateEventCancelledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventCancelledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventCancelledMutation, { data, loading, error }] = useUpdateEventCancelledMutation({
 *   variables: {
 *      cancelled: // value for 'cancelled'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateEventCancelledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventCancelledMutation, UpdateEventCancelledMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventCancelledMutation, UpdateEventCancelledMutationVariables>(UpdateEventCancelledDocument, baseOptions);
      }
export type UpdateEventCancelledMutationHookResult = ReturnType<typeof useUpdateEventCancelledMutation>;
export type UpdateEventCancelledMutationResult = ApolloReactCommon.MutationResult<UpdateEventCancelledMutation>;
export type UpdateEventCancelledMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEventCancelledMutation, UpdateEventCancelledMutationVariables>;
export const UpdateEventNoteDocument = gql`
    mutation updateEventNote($eventId: uuid!, $note: String) {
  update_events_by_pk(pk_columns: {id: $eventId}, _set: {notes: $note}) {
    id
    notes
  }
}
    `;
export type UpdateEventNoteMutationFn = ApolloReactCommon.MutationFunction<UpdateEventNoteMutation, UpdateEventNoteMutationVariables>;
export type UpdateEventNoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateEventNoteMutation, UpdateEventNoteMutationVariables>, 'mutation'>;

    export const UpdateEventNoteComponent = (props: UpdateEventNoteComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateEventNoteMutation, UpdateEventNoteMutationVariables> mutation={UpdateEventNoteDocument} {...props} />
    );
    
export type UpdateEventNoteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEventNoteMutation, UpdateEventNoteMutationVariables>
    } & TChildProps;
export function withUpdateEventNote<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEventNoteMutation,
  UpdateEventNoteMutationVariables,
  UpdateEventNoteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEventNoteMutation, UpdateEventNoteMutationVariables, UpdateEventNoteProps<TChildProps, TDataName>>(UpdateEventNoteDocument, {
      alias: 'updateEventNote',
      ...operationOptions
    });
};

/**
 * __useUpdateEventNoteMutation__
 *
 * To run a mutation, you first call `useUpdateEventNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventNoteMutation, { data, loading, error }] = useUpdateEventNoteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateEventNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventNoteMutation, UpdateEventNoteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEventNoteMutation, UpdateEventNoteMutationVariables>(UpdateEventNoteDocument, baseOptions);
      }
export type UpdateEventNoteMutationHookResult = ReturnType<typeof useUpdateEventNoteMutation>;
export type UpdateEventNoteMutationResult = ApolloReactCommon.MutationResult<UpdateEventNoteMutation>;
export type UpdateEventNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEventNoteMutation, UpdateEventNoteMutationVariables>;
export const GetEventsForAdminPanelDocument = gql`
    query GetEventsForAdminPanel($limit: Int, $offset: Int, $conditions: events_bool_exp) {
  events_aggregate(where: $conditions) {
    aggregate {
      count
    }
  }
  events(
    limit: $limit
    offset: $offset
    where: $conditions
    order_by: [{start_time: desc}]
  ) {
    id
    start_time
    end_time
    title
    slug
    is_festival
    festival_id
    is_book_club
    attendees_aggregate(
      where: {_and: [{_or: [{voucher_id: {_is_null: true}}, {voucher: {order: {status: {_nin: [draft, cancelled]}}}}]}, {_or: [{order_book_id: {_is_null: true}}, {order_book: {order: {status: {_nin: [draft, cancelled]}}}}]}, {is_attending: {_eq: true}}]}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;
export type GetEventsForAdminPanelComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetEventsForAdminPanelQuery, GetEventsForAdminPanelQueryVariables>, 'query'>;

    export const GetEventsForAdminPanelComponent = (props: GetEventsForAdminPanelComponentProps) => (
      <ApolloReactComponents.Query<GetEventsForAdminPanelQuery, GetEventsForAdminPanelQueryVariables> query={GetEventsForAdminPanelDocument} {...props} />
    );
    
export type GetEventsForAdminPanelProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventsForAdminPanelQuery, GetEventsForAdminPanelQueryVariables>
    } & TChildProps;
export function withGetEventsForAdminPanel<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventsForAdminPanelQuery,
  GetEventsForAdminPanelQueryVariables,
  GetEventsForAdminPanelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventsForAdminPanelQuery, GetEventsForAdminPanelQueryVariables, GetEventsForAdminPanelProps<TChildProps, TDataName>>(GetEventsForAdminPanelDocument, {
      alias: 'getEventsForAdminPanel',
      ...operationOptions
    });
};

/**
 * __useGetEventsForAdminPanelQuery__
 *
 * To run a query within a React component, call `useGetEventsForAdminPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsForAdminPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsForAdminPanelQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useGetEventsForAdminPanelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventsForAdminPanelQuery, GetEventsForAdminPanelQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventsForAdminPanelQuery, GetEventsForAdminPanelQueryVariables>(GetEventsForAdminPanelDocument, baseOptions);
      }
export function useGetEventsForAdminPanelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventsForAdminPanelQuery, GetEventsForAdminPanelQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventsForAdminPanelQuery, GetEventsForAdminPanelQueryVariables>(GetEventsForAdminPanelDocument, baseOptions);
        }
export type GetEventsForAdminPanelQueryHookResult = ReturnType<typeof useGetEventsForAdminPanelQuery>;
export type GetEventsForAdminPanelLazyQueryHookResult = ReturnType<typeof useGetEventsForAdminPanelLazyQuery>;
export type GetEventsForAdminPanelQueryResult = ApolloReactCommon.QueryResult<GetEventsForAdminPanelQuery, GetEventsForAdminPanelQueryVariables>;
export const InsertNewEventDocument = gql`
    mutation InsertNewEvent($data: events_insert_input!) {
  insert_events_one(object: $data) {
    slug
  }
}
    `;
export type InsertNewEventMutationFn = ApolloReactCommon.MutationFunction<InsertNewEventMutation, InsertNewEventMutationVariables>;
export type InsertNewEventComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertNewEventMutation, InsertNewEventMutationVariables>, 'mutation'>;

    export const InsertNewEventComponent = (props: InsertNewEventComponentProps) => (
      <ApolloReactComponents.Mutation<InsertNewEventMutation, InsertNewEventMutationVariables> mutation={InsertNewEventDocument} {...props} />
    );
    
export type InsertNewEventProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertNewEventMutation, InsertNewEventMutationVariables>
    } & TChildProps;
export function withInsertNewEvent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertNewEventMutation,
  InsertNewEventMutationVariables,
  InsertNewEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertNewEventMutation, InsertNewEventMutationVariables, InsertNewEventProps<TChildProps, TDataName>>(InsertNewEventDocument, {
      alias: 'insertNewEvent',
      ...operationOptions
    });
};

/**
 * __useInsertNewEventMutation__
 *
 * To run a mutation, you first call `useInsertNewEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewEventMutation, { data, loading, error }] = useInsertNewEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInsertNewEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertNewEventMutation, InsertNewEventMutationVariables>) {
        return ApolloReactHooks.useMutation<InsertNewEventMutation, InsertNewEventMutationVariables>(InsertNewEventDocument, baseOptions);
      }
export type InsertNewEventMutationHookResult = ReturnType<typeof useInsertNewEventMutation>;
export type InsertNewEventMutationResult = ApolloReactCommon.MutationResult<InsertNewEventMutation>;
export type InsertNewEventMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertNewEventMutation, InsertNewEventMutationVariables>;
export const GetOrderForAdminDocument = gql`
    query GetOrderForAdmin($id: Int!) {
  orders_by_pk(id: $id) {
    id
    status
    wrapping
    pick_up
    date_created
    date_ready
    date_fulfilled
    notes
    stripe_payment_id
    custom_line_price
    custom_line_title
    custom_line_status
    custom_shipping_price
    customer_note
    refunds {
      id
      amount
      created_at
    }
    address {
      id
      name
      contact_email
      phone_number
      line_1
      line_2
      line_3
      region
      city
      code
      country {
        name
      }
    }
    shipping_option {
      id
      name
      description
      price
    }
    order_books(order_by: {book: {title: asc}}) {
      price
      quantity
      discount
      status
      book {
        image
        isbn
        title
        author
      }
      event_tickets {
        event {
          title
        }
      }
    }
    order_products(order_by: {product: {title: asc}}) {
      price
      quantity
      discount
      status
      product {
        image
        id
        title
      }
    }
    subscription_objects {
      id
      recipient
      subscription {
        id
        title
        price
      }
      subscription_draft_object {
        id
        credits
      }
    }
    vouchers {
      id
      initial_amount
    }
    pif_donations {
      amount
      id
    }
    order_vouchers_for_discount {
      voucher_id
      amount_discounted
    }
    refunds {
      created_at
      amount
    }
    discount {
      code
      is_fixed_amount
      discount_value
      discounted_books {
        book_isbn
      }
    }
    refunds_aggregate {
      aggregate {
        sum {
          amount
        }
      }
    }
  }
}
    `;
export type GetOrderForAdminComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOrderForAdminQuery, GetOrderForAdminQueryVariables>, 'query'> & ({ variables: GetOrderForAdminQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetOrderForAdminComponent = (props: GetOrderForAdminComponentProps) => (
      <ApolloReactComponents.Query<GetOrderForAdminQuery, GetOrderForAdminQueryVariables> query={GetOrderForAdminDocument} {...props} />
    );
    
export type GetOrderForAdminProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetOrderForAdminQuery, GetOrderForAdminQueryVariables>
    } & TChildProps;
export function withGetOrderForAdmin<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOrderForAdminQuery,
  GetOrderForAdminQueryVariables,
  GetOrderForAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetOrderForAdminQuery, GetOrderForAdminQueryVariables, GetOrderForAdminProps<TChildProps, TDataName>>(GetOrderForAdminDocument, {
      alias: 'getOrderForAdmin',
      ...operationOptions
    });
};

/**
 * __useGetOrderForAdminQuery__
 *
 * To run a query within a React component, call `useGetOrderForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderForAdminQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderForAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrderForAdminQuery, GetOrderForAdminQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOrderForAdminQuery, GetOrderForAdminQueryVariables>(GetOrderForAdminDocument, baseOptions);
      }
export function useGetOrderForAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderForAdminQuery, GetOrderForAdminQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOrderForAdminQuery, GetOrderForAdminQueryVariables>(GetOrderForAdminDocument, baseOptions);
        }
export type GetOrderForAdminQueryHookResult = ReturnType<typeof useGetOrderForAdminQuery>;
export type GetOrderForAdminLazyQueryHookResult = ReturnType<typeof useGetOrderForAdminLazyQuery>;
export type GetOrderForAdminQueryResult = ApolloReactCommon.QueryResult<GetOrderForAdminQuery, GetOrderForAdminQueryVariables>;
export const UpdateOrderBookStatusDocument = gql`
    mutation UpdateOrderBookStatus($isbn: bigint!, $orderId: Int!, $status: order_item_status_enum, $orderStatus: order_status_enum) {
  update_order_book_by_pk(
    pk_columns: {order_id: $orderId, book_isbn: $isbn}
    _set: {status: $status}
  ) {
    order_id
    book_isbn
  }
  update_orders_by_pk(pk_columns: {id: $orderId}, _set: {status: $orderStatus}) {
    id
  }
}
    `;
export type UpdateOrderBookStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateOrderBookStatusMutation, UpdateOrderBookStatusMutationVariables>;
export type UpdateOrderBookStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrderBookStatusMutation, UpdateOrderBookStatusMutationVariables>, 'mutation'>;

    export const UpdateOrderBookStatusComponent = (props: UpdateOrderBookStatusComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrderBookStatusMutation, UpdateOrderBookStatusMutationVariables> mutation={UpdateOrderBookStatusDocument} {...props} />
    );
    
export type UpdateOrderBookStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrderBookStatusMutation, UpdateOrderBookStatusMutationVariables>
    } & TChildProps;
export function withUpdateOrderBookStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrderBookStatusMutation,
  UpdateOrderBookStatusMutationVariables,
  UpdateOrderBookStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrderBookStatusMutation, UpdateOrderBookStatusMutationVariables, UpdateOrderBookStatusProps<TChildProps, TDataName>>(UpdateOrderBookStatusDocument, {
      alias: 'updateOrderBookStatus',
      ...operationOptions
    });
};

/**
 * __useUpdateOrderBookStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderBookStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderBookStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderBookStatusMutation, { data, loading, error }] = useUpdateOrderBookStatusMutation({
 *   variables: {
 *      isbn: // value for 'isbn'
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *      orderStatus: // value for 'orderStatus'
 *   },
 * });
 */
export function useUpdateOrderBookStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderBookStatusMutation, UpdateOrderBookStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOrderBookStatusMutation, UpdateOrderBookStatusMutationVariables>(UpdateOrderBookStatusDocument, baseOptions);
      }
export type UpdateOrderBookStatusMutationHookResult = ReturnType<typeof useUpdateOrderBookStatusMutation>;
export type UpdateOrderBookStatusMutationResult = ApolloReactCommon.MutationResult<UpdateOrderBookStatusMutation>;
export type UpdateOrderBookStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrderBookStatusMutation, UpdateOrderBookStatusMutationVariables>;
export const UpdateOrderProductStatusDocument = gql`
    mutation UpdateOrderProductStatus($prodId: uuid!, $orderId: Int!, $status: order_item_status_enum, $orderStatus: order_status_enum) {
  update_order_product_by_pk(
    pk_columns: {order_id: $orderId, product_id: $prodId}
    _set: {status: $status}
  ) {
    order_id
    product_id
  }
  update_orders_by_pk(pk_columns: {id: $orderId}, _set: {status: $orderStatus}) {
    id
  }
}
    `;
export type UpdateOrderProductStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateOrderProductStatusMutation, UpdateOrderProductStatusMutationVariables>;
export type UpdateOrderProductStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrderProductStatusMutation, UpdateOrderProductStatusMutationVariables>, 'mutation'>;

    export const UpdateOrderProductStatusComponent = (props: UpdateOrderProductStatusComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrderProductStatusMutation, UpdateOrderProductStatusMutationVariables> mutation={UpdateOrderProductStatusDocument} {...props} />
    );
    
export type UpdateOrderProductStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrderProductStatusMutation, UpdateOrderProductStatusMutationVariables>
    } & TChildProps;
export function withUpdateOrderProductStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrderProductStatusMutation,
  UpdateOrderProductStatusMutationVariables,
  UpdateOrderProductStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrderProductStatusMutation, UpdateOrderProductStatusMutationVariables, UpdateOrderProductStatusProps<TChildProps, TDataName>>(UpdateOrderProductStatusDocument, {
      alias: 'updateOrderProductStatus',
      ...operationOptions
    });
};

/**
 * __useUpdateOrderProductStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderProductStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderProductStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderProductStatusMutation, { data, loading, error }] = useUpdateOrderProductStatusMutation({
 *   variables: {
 *      prodId: // value for 'prodId'
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *      orderStatus: // value for 'orderStatus'
 *   },
 * });
 */
export function useUpdateOrderProductStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderProductStatusMutation, UpdateOrderProductStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOrderProductStatusMutation, UpdateOrderProductStatusMutationVariables>(UpdateOrderProductStatusDocument, baseOptions);
      }
export type UpdateOrderProductStatusMutationHookResult = ReturnType<typeof useUpdateOrderProductStatusMutation>;
export type UpdateOrderProductStatusMutationResult = ApolloReactCommon.MutationResult<UpdateOrderProductStatusMutation>;
export type UpdateOrderProductStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrderProductStatusMutation, UpdateOrderProductStatusMutationVariables>;
export const UpdateOrderCustomItemStatusDocument = gql`
    mutation UpdateOrderCustomItemStatus($orderId: Int!, $status: order_item_status_enum, $orderStatus: order_status_enum) {
  update_orders_by_pk(
    pk_columns: {id: $orderId}
    _set: {custom_line_status: $status, status: $orderStatus}
  ) {
    id
  }
}
    `;
export type UpdateOrderCustomItemStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateOrderCustomItemStatusMutation, UpdateOrderCustomItemStatusMutationVariables>;
export type UpdateOrderCustomItemStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrderCustomItemStatusMutation, UpdateOrderCustomItemStatusMutationVariables>, 'mutation'>;

    export const UpdateOrderCustomItemStatusComponent = (props: UpdateOrderCustomItemStatusComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrderCustomItemStatusMutation, UpdateOrderCustomItemStatusMutationVariables> mutation={UpdateOrderCustomItemStatusDocument} {...props} />
    );
    
export type UpdateOrderCustomItemStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrderCustomItemStatusMutation, UpdateOrderCustomItemStatusMutationVariables>
    } & TChildProps;
export function withUpdateOrderCustomItemStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrderCustomItemStatusMutation,
  UpdateOrderCustomItemStatusMutationVariables,
  UpdateOrderCustomItemStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrderCustomItemStatusMutation, UpdateOrderCustomItemStatusMutationVariables, UpdateOrderCustomItemStatusProps<TChildProps, TDataName>>(UpdateOrderCustomItemStatusDocument, {
      alias: 'updateOrderCustomItemStatus',
      ...operationOptions
    });
};

/**
 * __useUpdateOrderCustomItemStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderCustomItemStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderCustomItemStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderCustomItemStatusMutation, { data, loading, error }] = useUpdateOrderCustomItemStatusMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *      orderStatus: // value for 'orderStatus'
 *   },
 * });
 */
export function useUpdateOrderCustomItemStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderCustomItemStatusMutation, UpdateOrderCustomItemStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOrderCustomItemStatusMutation, UpdateOrderCustomItemStatusMutationVariables>(UpdateOrderCustomItemStatusDocument, baseOptions);
      }
export type UpdateOrderCustomItemStatusMutationHookResult = ReturnType<typeof useUpdateOrderCustomItemStatusMutation>;
export type UpdateOrderCustomItemStatusMutationResult = ApolloReactCommon.MutationResult<UpdateOrderCustomItemStatusMutation>;
export type UpdateOrderCustomItemStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrderCustomItemStatusMutation, UpdateOrderCustomItemStatusMutationVariables>;
export const UpdateOrderStatusDocument = gql`
    mutation UpdateOrderStatus($orderId: Int!, $orderStatus: order_status_enum, $itemStatus: order_item_status_enum = fulfilled, $prodIds: [uuid!] = [], $isbns: [bigint!] = [], $date: timestamptz = null, $note: String) {
  update_orders_by_pk(
    pk_columns: {id: $orderId}
    _set: {status: $orderStatus, date_fulfilled: $date, notes: $note}
  ) {
    id
  }
  update_order_product(
    where: {_and: [{order_id: {_eq: $orderId}}, {product_id: {_in: $prodIds}}]}
    _set: {status: $itemStatus}
  ) {
    affected_rows
  }
  update_order_book(
    where: {_and: [{order_id: {_eq: $orderId}}, {book_isbn: {_in: $isbns}}]}
    _set: {status: $itemStatus}
  ) {
    affected_rows
  }
}
    `;
export type UpdateOrderStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;
export type UpdateOrderStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>, 'mutation'>;

    export const UpdateOrderStatusComponent = (props: UpdateOrderStatusComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables> mutation={UpdateOrderStatusDocument} {...props} />
    );
    
export type UpdateOrderStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>
    } & TChildProps;
export function withUpdateOrderStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrderStatusMutation,
  UpdateOrderStatusMutationVariables,
  UpdateOrderStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables, UpdateOrderStatusProps<TChildProps, TDataName>>(UpdateOrderStatusDocument, {
      alias: 'updateOrderStatus',
      ...operationOptions
    });
};

/**
 * __useUpdateOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderStatusMutation, { data, loading, error }] = useUpdateOrderStatusMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      orderStatus: // value for 'orderStatus'
 *      itemStatus: // value for 'itemStatus'
 *      prodIds: // value for 'prodIds'
 *      isbns: // value for 'isbns'
 *      date: // value for 'date'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateOrderStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>(UpdateOrderStatusDocument, baseOptions);
      }
export type UpdateOrderStatusMutationHookResult = ReturnType<typeof useUpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationResult = ApolloReactCommon.MutationResult<UpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;
export const UpdateOrderNoteDocument = gql`
    mutation UpdateOrderNote($orderId: Int!, $note: String) {
  update_orders_by_pk(pk_columns: {id: $orderId}, _set: {notes: $note}) {
    id
    notes
  }
}
    `;
export type UpdateOrderNoteMutationFn = ApolloReactCommon.MutationFunction<UpdateOrderNoteMutation, UpdateOrderNoteMutationVariables>;
export type UpdateOrderNoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrderNoteMutation, UpdateOrderNoteMutationVariables>, 'mutation'>;

    export const UpdateOrderNoteComponent = (props: UpdateOrderNoteComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrderNoteMutation, UpdateOrderNoteMutationVariables> mutation={UpdateOrderNoteDocument} {...props} />
    );
    
export type UpdateOrderNoteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrderNoteMutation, UpdateOrderNoteMutationVariables>
    } & TChildProps;
export function withUpdateOrderNote<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrderNoteMutation,
  UpdateOrderNoteMutationVariables,
  UpdateOrderNoteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrderNoteMutation, UpdateOrderNoteMutationVariables, UpdateOrderNoteProps<TChildProps, TDataName>>(UpdateOrderNoteDocument, {
      alias: 'updateOrderNote',
      ...operationOptions
    });
};

/**
 * __useUpdateOrderNoteMutation__
 *
 * To run a mutation, you first call `useUpdateOrderNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderNoteMutation, { data, loading, error }] = useUpdateOrderNoteMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateOrderNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderNoteMutation, UpdateOrderNoteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOrderNoteMutation, UpdateOrderNoteMutationVariables>(UpdateOrderNoteDocument, baseOptions);
      }
export type UpdateOrderNoteMutationHookResult = ReturnType<typeof useUpdateOrderNoteMutation>;
export type UpdateOrderNoteMutationResult = ApolloReactCommon.MutationResult<UpdateOrderNoteMutation>;
export type UpdateOrderNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrderNoteMutation, UpdateOrderNoteMutationVariables>;
export const GetOrdersForAdminPanelDocument = gql`
    query GetOrdersForAdminPanel($limit: Int, $offset: Int, $conditions: orders_bool_exp, $orderBy: [orders_order_by!]) {
  orders_aggregate(where: $conditions) {
    aggregate {
      count
    }
  }
  orders(limit: $limit, offset: $offset, order_by: $orderBy, where: $conditions) {
    id
    date_created
    status
    custom_line_price
    shipping_option {
      name
      price
    }
    address {
      name
    }
    order_books_aggregate {
      aggregate {
        count
      }
    }
    order_books {
      price
      discount
      quantity
      book_isbn
    }
    subscription_objects {
      id
      subscription {
        id
        price
      }
      subscription_draft_object {
        credits
      }
    }
    order_products {
      price
      discount
      quantity
    }
    vouchers {
      initial_amount
    }
    pif_donations {
      amount
    }
    discount {
      discount_value
      is_fixed_amount
      discounted_books {
        book_isbn
      }
    }
    subscription_objects_aggregate {
      aggregate {
        count
      }
    }
    order_vouchers_for_discount {
      voucher_id
      amount_discounted
    }
    order_books_aggregate {
      aggregate {
        count
      }
    }
    order_products_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;
export type GetOrdersForAdminPanelComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOrdersForAdminPanelQuery, GetOrdersForAdminPanelQueryVariables>, 'query'>;

    export const GetOrdersForAdminPanelComponent = (props: GetOrdersForAdminPanelComponentProps) => (
      <ApolloReactComponents.Query<GetOrdersForAdminPanelQuery, GetOrdersForAdminPanelQueryVariables> query={GetOrdersForAdminPanelDocument} {...props} />
    );
    
export type GetOrdersForAdminPanelProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetOrdersForAdminPanelQuery, GetOrdersForAdminPanelQueryVariables>
    } & TChildProps;
export function withGetOrdersForAdminPanel<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOrdersForAdminPanelQuery,
  GetOrdersForAdminPanelQueryVariables,
  GetOrdersForAdminPanelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetOrdersForAdminPanelQuery, GetOrdersForAdminPanelQueryVariables, GetOrdersForAdminPanelProps<TChildProps, TDataName>>(GetOrdersForAdminPanelDocument, {
      alias: 'getOrdersForAdminPanel',
      ...operationOptions
    });
};

/**
 * __useGetOrdersForAdminPanelQuery__
 *
 * To run a query within a React component, call `useGetOrdersForAdminPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersForAdminPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersForAdminPanelQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      conditions: // value for 'conditions'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetOrdersForAdminPanelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrdersForAdminPanelQuery, GetOrdersForAdminPanelQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOrdersForAdminPanelQuery, GetOrdersForAdminPanelQueryVariables>(GetOrdersForAdminPanelDocument, baseOptions);
      }
export function useGetOrdersForAdminPanelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrdersForAdminPanelQuery, GetOrdersForAdminPanelQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOrdersForAdminPanelQuery, GetOrdersForAdminPanelQueryVariables>(GetOrdersForAdminPanelDocument, baseOptions);
        }
export type GetOrdersForAdminPanelQueryHookResult = ReturnType<typeof useGetOrdersForAdminPanelQuery>;
export type GetOrdersForAdminPanelLazyQueryHookResult = ReturnType<typeof useGetOrdersForAdminPanelLazyQuery>;
export type GetOrdersForAdminPanelQueryResult = ApolloReactCommon.QueryResult<GetOrdersForAdminPanelQuery, GetOrdersForAdminPanelQueryVariables>;
export const GetPageContentDocument = gql`
    query GetPageContent($title: String!) {
  pages_by_pk(title: $title) {
    title
    content
  }
}
    `;
export type GetPageContentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPageContentQuery, GetPageContentQueryVariables>, 'query'> & ({ variables: GetPageContentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPageContentComponent = (props: GetPageContentComponentProps) => (
      <ApolloReactComponents.Query<GetPageContentQuery, GetPageContentQueryVariables> query={GetPageContentDocument} {...props} />
    );
    
export type GetPageContentProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPageContentQuery, GetPageContentQueryVariables>
    } & TChildProps;
export function withGetPageContent<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPageContentQuery,
  GetPageContentQueryVariables,
  GetPageContentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPageContentQuery, GetPageContentQueryVariables, GetPageContentProps<TChildProps, TDataName>>(GetPageContentDocument, {
      alias: 'getPageContent',
      ...operationOptions
    });
};

/**
 * __useGetPageContentQuery__
 *
 * To run a query within a React component, call `useGetPageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageContentQuery({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useGetPageContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPageContentQuery, GetPageContentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPageContentQuery, GetPageContentQueryVariables>(GetPageContentDocument, baseOptions);
      }
export function useGetPageContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPageContentQuery, GetPageContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPageContentQuery, GetPageContentQueryVariables>(GetPageContentDocument, baseOptions);
        }
export type GetPageContentQueryHookResult = ReturnType<typeof useGetPageContentQuery>;
export type GetPageContentLazyQueryHookResult = ReturnType<typeof useGetPageContentLazyQuery>;
export type GetPageContentQueryResult = ApolloReactCommon.QueryResult<GetPageContentQuery, GetPageContentQueryVariables>;
export const UpdatePageDocument = gql`
    mutation UpdatePage($title: String!, $content: jsonb) {
  update_pages_by_pk(pk_columns: {title: $title}, _set: {content: $content}) {
    title
    content
  }
}
    `;
export type UpdatePageMutationFn = ApolloReactCommon.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>;
export type UpdatePageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdatePageMutation, UpdatePageMutationVariables>, 'mutation'>;

    export const UpdatePageComponent = (props: UpdatePageComponentProps) => (
      <ApolloReactComponents.Mutation<UpdatePageMutation, UpdatePageMutationVariables> mutation={UpdatePageDocument} {...props} />
    );
    
export type UpdatePageProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>
    } & TChildProps;
export function withUpdatePage<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdatePageMutation,
  UpdatePageMutationVariables,
  UpdatePageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdatePageMutation, UpdatePageMutationVariables, UpdatePageProps<TChildProps, TDataName>>(UpdatePageDocument, {
      alias: 'updatePage',
      ...operationOptions
    });
};

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      title: // value for 'title'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageDocument, baseOptions);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationResult = ApolloReactCommon.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const GetAllPagesDocument = gql`
    query GetAllPages {
  pages {
    title
  }
}
    `;
export type GetAllPagesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllPagesQuery, GetAllPagesQueryVariables>, 'query'>;

    export const GetAllPagesComponent = (props: GetAllPagesComponentProps) => (
      <ApolloReactComponents.Query<GetAllPagesQuery, GetAllPagesQueryVariables> query={GetAllPagesDocument} {...props} />
    );
    
export type GetAllPagesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllPagesQuery, GetAllPagesQueryVariables>
    } & TChildProps;
export function withGetAllPages<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllPagesQuery,
  GetAllPagesQueryVariables,
  GetAllPagesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllPagesQuery, GetAllPagesQueryVariables, GetAllPagesProps<TChildProps, TDataName>>(GetAllPagesDocument, {
      alias: 'getAllPages',
      ...operationOptions
    });
};

/**
 * __useGetAllPagesQuery__
 *
 * To run a query within a React component, call `useGetAllPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllPagesQuery, GetAllPagesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllPagesQuery, GetAllPagesQueryVariables>(GetAllPagesDocument, baseOptions);
      }
export function useGetAllPagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllPagesQuery, GetAllPagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllPagesQuery, GetAllPagesQueryVariables>(GetAllPagesDocument, baseOptions);
        }
export type GetAllPagesQueryHookResult = ReturnType<typeof useGetAllPagesQuery>;
export type GetAllPagesLazyQueryHookResult = ReturnType<typeof useGetAllPagesLazyQuery>;
export type GetAllPagesQueryResult = ApolloReactCommon.QueryResult<GetAllPagesQuery, GetAllPagesQueryVariables>;
export const GetPostForAdminDocument = gql`
    query GetPostForAdmin($slug: String!) {
  posts(where: {slug: {_eq: $slug}}) {
    id
    title
    created_at
    slug
    author {
      id
      name
    }
    category_posts {
      category {
        name
        slug
      }
    }
    post_books(order_by: {rank_order: asc}) {
      book {
        ...BookCardData
      }
    }
    image
    content
    type
  }
}
    ${BookCardDataFragmentDoc}`;
export type GetPostForAdminComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPostForAdminQuery, GetPostForAdminQueryVariables>, 'query'> & ({ variables: GetPostForAdminQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPostForAdminComponent = (props: GetPostForAdminComponentProps) => (
      <ApolloReactComponents.Query<GetPostForAdminQuery, GetPostForAdminQueryVariables> query={GetPostForAdminDocument} {...props} />
    );
    
export type GetPostForAdminProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPostForAdminQuery, GetPostForAdminQueryVariables>
    } & TChildProps;
export function withGetPostForAdmin<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPostForAdminQuery,
  GetPostForAdminQueryVariables,
  GetPostForAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPostForAdminQuery, GetPostForAdminQueryVariables, GetPostForAdminProps<TChildProps, TDataName>>(GetPostForAdminDocument, {
      alias: 'getPostForAdmin',
      ...operationOptions
    });
};

/**
 * __useGetPostForAdminQuery__
 *
 * To run a query within a React component, call `useGetPostForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostForAdminQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetPostForAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostForAdminQuery, GetPostForAdminQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPostForAdminQuery, GetPostForAdminQueryVariables>(GetPostForAdminDocument, baseOptions);
      }
export function useGetPostForAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostForAdminQuery, GetPostForAdminQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPostForAdminQuery, GetPostForAdminQueryVariables>(GetPostForAdminDocument, baseOptions);
        }
export type GetPostForAdminQueryHookResult = ReturnType<typeof useGetPostForAdminQuery>;
export type GetPostForAdminLazyQueryHookResult = ReturnType<typeof useGetPostForAdminLazyQuery>;
export type GetPostForAdminQueryResult = ApolloReactCommon.QueryResult<GetPostForAdminQuery, GetPostForAdminQueryVariables>;
export const UpdatePostDocument = gql`
    mutation UpdatePost($data: posts_set_input!, $id: uuid!, $categories: [category_post_insert_input!]!, $books: [post_book_insert_input!]!) {
  update_posts_by_pk(pk_columns: {id: $id}, _set: $data) {
    id
  }
  delete_category_post(where: {post_id: {_eq: $id}}) {
    affected_rows
  }
  delete_post_book(where: {post_id: {_eq: $id}}) {
    affected_rows
  }
  insert_category_post(objects: $categories) {
    affected_rows
  }
  insert_post_book(objects: $books) {
    affected_rows
  }
}
    `;
export type UpdatePostMutationFn = ApolloReactCommon.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;
export type UpdatePostComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdatePostMutation, UpdatePostMutationVariables>, 'mutation'>;

    export const UpdatePostComponent = (props: UpdatePostComponentProps) => (
      <ApolloReactComponents.Mutation<UpdatePostMutation, UpdatePostMutationVariables> mutation={UpdatePostDocument} {...props} />
    );
    
export type UpdatePostProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>
    } & TChildProps;
export function withUpdatePost<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdatePostMutation,
  UpdatePostMutationVariables,
  UpdatePostProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdatePostMutation, UpdatePostMutationVariables, UpdatePostProps<TChildProps, TDataName>>(UpdatePostDocument, {
      alias: 'updatePost',
      ...operationOptions
    });
};

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      categories: // value for 'categories'
 *      books: // value for 'books'
 *   },
 * });
 */
export function useUpdatePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, baseOptions);
      }
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = ApolloReactCommon.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const DeletePostDocument = gql`
    mutation DeletePost($id: uuid!) {
  delete_posts_by_pk(id: $id) {
    id
  }
}
    `;
export type DeletePostMutationFn = ApolloReactCommon.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;
export type DeletePostComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeletePostMutation, DeletePostMutationVariables>, 'mutation'>;

    export const DeletePostComponent = (props: DeletePostComponentProps) => (
      <ApolloReactComponents.Mutation<DeletePostMutation, DeletePostMutationVariables> mutation={DeletePostDocument} {...props} />
    );
    
export type DeletePostProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeletePostMutation, DeletePostMutationVariables>
    } & TChildProps;
export function withDeletePost<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeletePostMutation,
  DeletePostMutationVariables,
  DeletePostProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeletePostMutation, DeletePostMutationVariables, DeletePostProps<TChildProps, TDataName>>(DeletePostDocument, {
      alias: 'deletePost',
      ...operationOptions
    });
};

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, baseOptions);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = ApolloReactCommon.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const GetPostsForAdminPanelDocument = gql`
    query GetPostsForAdminPanel($limit: Int, $offset: Int, $type: [String!], $search: String) {
  posts_aggregate(
    where: {_and: [{type: {_in: $type}}, {title: {_ilike: $search}}]}
  ) {
    aggregate {
      count
    }
  }
  posts(
    order_by: [{created_at: desc}]
    limit: $limit
    offset: $offset
    where: {_and: [{type: {_in: $type}}, {title: {_ilike: $search}}]}
  ) {
    id
    title
    type
    slug
    author {
      name
    }
    created_at
  }
}
    `;
export type GetPostsForAdminPanelComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPostsForAdminPanelQuery, GetPostsForAdminPanelQueryVariables>, 'query'>;

    export const GetPostsForAdminPanelComponent = (props: GetPostsForAdminPanelComponentProps) => (
      <ApolloReactComponents.Query<GetPostsForAdminPanelQuery, GetPostsForAdminPanelQueryVariables> query={GetPostsForAdminPanelDocument} {...props} />
    );
    
export type GetPostsForAdminPanelProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPostsForAdminPanelQuery, GetPostsForAdminPanelQueryVariables>
    } & TChildProps;
export function withGetPostsForAdminPanel<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPostsForAdminPanelQuery,
  GetPostsForAdminPanelQueryVariables,
  GetPostsForAdminPanelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPostsForAdminPanelQuery, GetPostsForAdminPanelQueryVariables, GetPostsForAdminPanelProps<TChildProps, TDataName>>(GetPostsForAdminPanelDocument, {
      alias: 'getPostsForAdminPanel',
      ...operationOptions
    });
};

/**
 * __useGetPostsForAdminPanelQuery__
 *
 * To run a query within a React component, call `useGetPostsForAdminPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsForAdminPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsForAdminPanelQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      type: // value for 'type'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPostsForAdminPanelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostsForAdminPanelQuery, GetPostsForAdminPanelQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPostsForAdminPanelQuery, GetPostsForAdminPanelQueryVariables>(GetPostsForAdminPanelDocument, baseOptions);
      }
export function useGetPostsForAdminPanelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostsForAdminPanelQuery, GetPostsForAdminPanelQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPostsForAdminPanelQuery, GetPostsForAdminPanelQueryVariables>(GetPostsForAdminPanelDocument, baseOptions);
        }
export type GetPostsForAdminPanelQueryHookResult = ReturnType<typeof useGetPostsForAdminPanelQuery>;
export type GetPostsForAdminPanelLazyQueryHookResult = ReturnType<typeof useGetPostsForAdminPanelLazyQuery>;
export type GetPostsForAdminPanelQueryResult = ApolloReactCommon.QueryResult<GetPostsForAdminPanelQuery, GetPostsForAdminPanelQueryVariables>;
export const SavePostDocument = gql`
    mutation SavePost($data: posts_insert_input!) {
  insert_posts_one(object: $data) {
    slug
  }
}
    `;
export type SavePostMutationFn = ApolloReactCommon.MutationFunction<SavePostMutation, SavePostMutationVariables>;
export type SavePostComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SavePostMutation, SavePostMutationVariables>, 'mutation'>;

    export const SavePostComponent = (props: SavePostComponentProps) => (
      <ApolloReactComponents.Mutation<SavePostMutation, SavePostMutationVariables> mutation={SavePostDocument} {...props} />
    );
    
export type SavePostProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SavePostMutation, SavePostMutationVariables>
    } & TChildProps;
export function withSavePost<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SavePostMutation,
  SavePostMutationVariables,
  SavePostProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SavePostMutation, SavePostMutationVariables, SavePostProps<TChildProps, TDataName>>(SavePostDocument, {
      alias: 'savePost',
      ...operationOptions
    });
};

/**
 * __useSavePostMutation__
 *
 * To run a mutation, you first call `useSavePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostMutation, { data, loading, error }] = useSavePostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSavePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePostMutation, SavePostMutationVariables>) {
        return ApolloReactHooks.useMutation<SavePostMutation, SavePostMutationVariables>(SavePostDocument, baseOptions);
      }
export type SavePostMutationHookResult = ReturnType<typeof useSavePostMutation>;
export type SavePostMutationResult = ApolloReactCommon.MutationResult<SavePostMutation>;
export type SavePostMutationOptions = ApolloReactCommon.BaseMutationOptions<SavePostMutation, SavePostMutationVariables>;
export const GetProductForAdminDocument = gql`
    query GetProductForAdmin($id: uuid!) {
  products_by_pk(id: $id) {
    id
    title
    slug
    description
    image
    stock
    price
    duration_length
    duration_length_type
    is_discounted
    is_deleted
    discount_value
  }
}
    `;
export type GetProductForAdminComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductForAdminQuery, GetProductForAdminQueryVariables>, 'query'> & ({ variables: GetProductForAdminQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProductForAdminComponent = (props: GetProductForAdminComponentProps) => (
      <ApolloReactComponents.Query<GetProductForAdminQuery, GetProductForAdminQueryVariables> query={GetProductForAdminDocument} {...props} />
    );
    
export type GetProductForAdminProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductForAdminQuery, GetProductForAdminQueryVariables>
    } & TChildProps;
export function withGetProductForAdmin<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductForAdminQuery,
  GetProductForAdminQueryVariables,
  GetProductForAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductForAdminQuery, GetProductForAdminQueryVariables, GetProductForAdminProps<TChildProps, TDataName>>(GetProductForAdminDocument, {
      alias: 'getProductForAdmin',
      ...operationOptions
    });
};

/**
 * __useGetProductForAdminQuery__
 *
 * To run a query within a React component, call `useGetProductForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductForAdminQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductForAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductForAdminQuery, GetProductForAdminQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductForAdminQuery, GetProductForAdminQueryVariables>(GetProductForAdminDocument, baseOptions);
      }
export function useGetProductForAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductForAdminQuery, GetProductForAdminQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductForAdminQuery, GetProductForAdminQueryVariables>(GetProductForAdminDocument, baseOptions);
        }
export type GetProductForAdminQueryHookResult = ReturnType<typeof useGetProductForAdminQuery>;
export type GetProductForAdminLazyQueryHookResult = ReturnType<typeof useGetProductForAdminLazyQuery>;
export type GetProductForAdminQueryResult = ApolloReactCommon.QueryResult<GetProductForAdminQuery, GetProductForAdminQueryVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($data: products_set_input!, $id: uuid!) {
  update_products_by_pk(pk_columns: {id: $id}, _set: $data) {
    id
  }
}
    `;
export type UpdateProductMutationFn = ApolloReactCommon.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;
export type UpdateProductComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateProductMutation, UpdateProductMutationVariables>, 'mutation'>;

    export const UpdateProductComponent = (props: UpdateProductComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateProductMutation, UpdateProductMutationVariables> mutation={UpdateProductDocument} {...props} />
    );
    
export type UpdateProductProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>
    } & TChildProps;
export function withUpdateProduct<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateProductMutation,
  UpdateProductMutationVariables,
  UpdateProductProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateProductMutation, UpdateProductMutationVariables, UpdateProductProps<TChildProps, TDataName>>(UpdateProductDocument, {
      alias: 'updateProduct',
      ...operationOptions
    });
};

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, baseOptions);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = ApolloReactCommon.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation DeleteProduct($id: uuid!, $shouldUnlist: Boolean!) {
  update_products_by_pk(pk_columns: {id: $id}, _set: {is_deleted: $shouldUnlist}) {
    id
  }
}
    `;
export type DeleteProductMutationFn = ApolloReactCommon.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;
export type DeleteProductComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteProductMutation, DeleteProductMutationVariables>, 'mutation'>;

    export const DeleteProductComponent = (props: DeleteProductComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteProductMutation, DeleteProductMutationVariables> mutation={DeleteProductDocument} {...props} />
    );
    
export type DeleteProductProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>
    } & TChildProps;
export function withDeleteProduct<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteProductMutation,
  DeleteProductMutationVariables,
  DeleteProductProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteProductMutation, DeleteProductMutationVariables, DeleteProductProps<TChildProps, TDataName>>(DeleteProductDocument, {
      alias: 'deleteProduct',
      ...operationOptions
    });
};

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      shouldUnlist: // value for 'shouldUnlist'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, baseOptions);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = ApolloReactCommon.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const GetAllProductsDocument = gql`
    query GetAllProducts($limit: Int, $offset: Int, $conditions: products_bool_exp) {
  products_aggregate(where: $conditions) {
    aggregate {
      count
    }
  }
  products(limit: $limit, offset: $offset, where: $conditions) {
    id
    title
    price
    stock
  }
}
    `;
export type GetAllProductsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllProductsQuery, GetAllProductsQueryVariables>, 'query'>;

    export const GetAllProductsComponent = (props: GetAllProductsComponentProps) => (
      <ApolloReactComponents.Query<GetAllProductsQuery, GetAllProductsQueryVariables> query={GetAllProductsDocument} {...props} />
    );
    
export type GetAllProductsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllProductsQuery, GetAllProductsQueryVariables>
    } & TChildProps;
export function withGetAllProducts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllProductsQuery,
  GetAllProductsQueryVariables,
  GetAllProductsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllProductsQuery, GetAllProductsQueryVariables, GetAllProductsProps<TChildProps, TDataName>>(GetAllProductsDocument, {
      alias: 'getAllProducts',
      ...operationOptions
    });
};

/**
 * __useGetAllProductsQuery__
 *
 * To run a query within a React component, call `useGetAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useGetAllProductsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, baseOptions);
      }
export function useGetAllProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, baseOptions);
        }
export type GetAllProductsQueryHookResult = ReturnType<typeof useGetAllProductsQuery>;
export type GetAllProductsLazyQueryHookResult = ReturnType<typeof useGetAllProductsLazyQuery>;
export type GetAllProductsQueryResult = ApolloReactCommon.QueryResult<GetAllProductsQuery, GetAllProductsQueryVariables>;
export const InsertNewProductDocument = gql`
    mutation InsertNewProduct($data: products_insert_input!) {
  insert_products_one(object: $data) {
    title
    id
    price
  }
}
    `;
export type InsertNewProductMutationFn = ApolloReactCommon.MutationFunction<InsertNewProductMutation, InsertNewProductMutationVariables>;
export type InsertNewProductComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertNewProductMutation, InsertNewProductMutationVariables>, 'mutation'>;

    export const InsertNewProductComponent = (props: InsertNewProductComponentProps) => (
      <ApolloReactComponents.Mutation<InsertNewProductMutation, InsertNewProductMutationVariables> mutation={InsertNewProductDocument} {...props} />
    );
    
export type InsertNewProductProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertNewProductMutation, InsertNewProductMutationVariables>
    } & TChildProps;
export function withInsertNewProduct<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertNewProductMutation,
  InsertNewProductMutationVariables,
  InsertNewProductProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertNewProductMutation, InsertNewProductMutationVariables, InsertNewProductProps<TChildProps, TDataName>>(InsertNewProductDocument, {
      alias: 'insertNewProduct',
      ...operationOptions
    });
};

/**
 * __useInsertNewProductMutation__
 *
 * To run a mutation, you first call `useInsertNewProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewProductMutation, { data, loading, error }] = useInsertNewProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInsertNewProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertNewProductMutation, InsertNewProductMutationVariables>) {
        return ApolloReactHooks.useMutation<InsertNewProductMutation, InsertNewProductMutationVariables>(InsertNewProductDocument, baseOptions);
      }
export type InsertNewProductMutationHookResult = ReturnType<typeof useInsertNewProductMutation>;
export type InsertNewProductMutationResult = ApolloReactCommon.MutationResult<InsertNewProductMutation>;
export type InsertNewProductMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertNewProductMutation, InsertNewProductMutationVariables>;
export const GetTagsDocument = gql`
    query GetTags($search: String, $limit: Int, $offset: Int, $orderBy: [tags_order_by!]) {
  tags_aggregate(where: {text: {_ilike: $search}}) {
    aggregate {
      count
    }
  }
  tags(
    where: {text: {_ilike: $search}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    id
    tag_books_aggregate {
      aggregate {
        count
      }
    }
    text
  }
}
    `;
export type GetTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTagsQuery, GetTagsQueryVariables>, 'query'>;

    export const GetTagsComponent = (props: GetTagsComponentProps) => (
      <ApolloReactComponents.Query<GetTagsQuery, GetTagsQueryVariables> query={GetTagsDocument} {...props} />
    );
    
export type GetTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTagsQuery, GetTagsQueryVariables>
    } & TChildProps;
export function withGetTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTagsQuery,
  GetTagsQueryVariables,
  GetTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTagsQuery, GetTagsQueryVariables, GetTagsProps<TChildProps, TDataName>>(GetTagsDocument, {
      alias: 'getTags',
      ...operationOptions
    });
};

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, baseOptions);
      }
export function useGetTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, baseOptions);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = ApolloReactCommon.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetVoucherDocument = gql`
    query GetVoucher($id: String!) {
  vouchers_by_pk(id: $id) {
    created_at
    id
    recipient
    initial_amount
    remaining_amount
    updated_at
    order_id
    event_tickets {
      is_online_viewer
      event {
        title
        slug
      }
    }
  }
}
    `;
export type GetVoucherComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetVoucherQuery, GetVoucherQueryVariables>, 'query'> & ({ variables: GetVoucherQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetVoucherComponent = (props: GetVoucherComponentProps) => (
      <ApolloReactComponents.Query<GetVoucherQuery, GetVoucherQueryVariables> query={GetVoucherDocument} {...props} />
    );
    
export type GetVoucherProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetVoucherQuery, GetVoucherQueryVariables>
    } & TChildProps;
export function withGetVoucher<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetVoucherQuery,
  GetVoucherQueryVariables,
  GetVoucherProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetVoucherQuery, GetVoucherQueryVariables, GetVoucherProps<TChildProps, TDataName>>(GetVoucherDocument, {
      alias: 'getVoucher',
      ...operationOptions
    });
};

/**
 * __useGetVoucherQuery__
 *
 * To run a query within a React component, call `useGetVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoucherQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVoucherQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVoucherQuery, GetVoucherQueryVariables>) {
        return ApolloReactHooks.useQuery<GetVoucherQuery, GetVoucherQueryVariables>(GetVoucherDocument, baseOptions);
      }
export function useGetVoucherLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVoucherQuery, GetVoucherQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetVoucherQuery, GetVoucherQueryVariables>(GetVoucherDocument, baseOptions);
        }
export type GetVoucherQueryHookResult = ReturnType<typeof useGetVoucherQuery>;
export type GetVoucherLazyQueryHookResult = ReturnType<typeof useGetVoucherLazyQuery>;
export type GetVoucherQueryResult = ApolloReactCommon.QueryResult<GetVoucherQuery, GetVoucherQueryVariables>;
export const UpdateVoucherDocument = gql`
    mutation UpdateVoucher($data: vouchers_set_input!, $id: String!) {
  update_vouchers_by_pk(pk_columns: {id: $id}, _set: $data) {
    id
  }
}
    `;
export type UpdateVoucherMutationFn = ApolloReactCommon.MutationFunction<UpdateVoucherMutation, UpdateVoucherMutationVariables>;
export type UpdateVoucherComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateVoucherMutation, UpdateVoucherMutationVariables>, 'mutation'>;

    export const UpdateVoucherComponent = (props: UpdateVoucherComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateVoucherMutation, UpdateVoucherMutationVariables> mutation={UpdateVoucherDocument} {...props} />
    );
    
export type UpdateVoucherProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateVoucherMutation, UpdateVoucherMutationVariables>
    } & TChildProps;
export function withUpdateVoucher<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateVoucherMutation,
  UpdateVoucherMutationVariables,
  UpdateVoucherProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateVoucherMutation, UpdateVoucherMutationVariables, UpdateVoucherProps<TChildProps, TDataName>>(UpdateVoucherDocument, {
      alias: 'updateVoucher',
      ...operationOptions
    });
};

/**
 * __useUpdateVoucherMutation__
 *
 * To run a mutation, you first call `useUpdateVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoucherMutation, { data, loading, error }] = useUpdateVoucherMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateVoucherMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateVoucherMutation, UpdateVoucherMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateVoucherMutation, UpdateVoucherMutationVariables>(UpdateVoucherDocument, baseOptions);
      }
export type UpdateVoucherMutationHookResult = ReturnType<typeof useUpdateVoucherMutation>;
export type UpdateVoucherMutationResult = ApolloReactCommon.MutationResult<UpdateVoucherMutation>;
export type UpdateVoucherMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateVoucherMutation, UpdateVoucherMutationVariables>;
export const GetVouchersDocument = gql`
    query GetVouchers($limit: Int, $offset: Int, $conditions: vouchers_bool_exp!) {
  vouchers_aggregate(
    where: {_and: [$conditions, {_or: [{order: {status: {_neq: draft}}}, {order_id: {_is_null: true}}]}]}
  ) {
    aggregate {
      count
    }
  }
  vouchers(
    limit: $limit
    offset: $offset
    where: {_and: [$conditions, {_or: [{order: {status: {_neq: draft}}}, {order_id: {_is_null: true}}]}]}
    order_by: {created_at: desc}
  ) {
    id
    recipient
    initial_amount
    remaining_amount
    created_at
  }
}
    `;
export type GetVouchersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetVouchersQuery, GetVouchersQueryVariables>, 'query'> & ({ variables: GetVouchersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetVouchersComponent = (props: GetVouchersComponentProps) => (
      <ApolloReactComponents.Query<GetVouchersQuery, GetVouchersQueryVariables> query={GetVouchersDocument} {...props} />
    );
    
export type GetVouchersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetVouchersQuery, GetVouchersQueryVariables>
    } & TChildProps;
export function withGetVouchers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetVouchersQuery,
  GetVouchersQueryVariables,
  GetVouchersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetVouchersQuery, GetVouchersQueryVariables, GetVouchersProps<TChildProps, TDataName>>(GetVouchersDocument, {
      alias: 'getVouchers',
      ...operationOptions
    });
};

/**
 * __useGetVouchersQuery__
 *
 * To run a query within a React component, call `useGetVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVouchersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useGetVouchersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVouchersQuery, GetVouchersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetVouchersQuery, GetVouchersQueryVariables>(GetVouchersDocument, baseOptions);
      }
export function useGetVouchersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVouchersQuery, GetVouchersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetVouchersQuery, GetVouchersQueryVariables>(GetVouchersDocument, baseOptions);
        }
export type GetVouchersQueryHookResult = ReturnType<typeof useGetVouchersQuery>;
export type GetVouchersLazyQueryHookResult = ReturnType<typeof useGetVouchersLazyQuery>;
export type GetVouchersQueryResult = ApolloReactCommon.QueryResult<GetVouchersQuery, GetVouchersQueryVariables>;
export const InsertNewVoucherDocument = gql`
    mutation InsertNewVoucher($data: vouchers_insert_input!) {
  insert_vouchers_one(object: $data) {
    id
  }
}
    `;
export type InsertNewVoucherMutationFn = ApolloReactCommon.MutationFunction<InsertNewVoucherMutation, InsertNewVoucherMutationVariables>;
export type InsertNewVoucherComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertNewVoucherMutation, InsertNewVoucherMutationVariables>, 'mutation'>;

    export const InsertNewVoucherComponent = (props: InsertNewVoucherComponentProps) => (
      <ApolloReactComponents.Mutation<InsertNewVoucherMutation, InsertNewVoucherMutationVariables> mutation={InsertNewVoucherDocument} {...props} />
    );
    
export type InsertNewVoucherProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertNewVoucherMutation, InsertNewVoucherMutationVariables>
    } & TChildProps;
export function withInsertNewVoucher<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertNewVoucherMutation,
  InsertNewVoucherMutationVariables,
  InsertNewVoucherProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertNewVoucherMutation, InsertNewVoucherMutationVariables, InsertNewVoucherProps<TChildProps, TDataName>>(InsertNewVoucherDocument, {
      alias: 'insertNewVoucher',
      ...operationOptions
    });
};

/**
 * __useInsertNewVoucherMutation__
 *
 * To run a mutation, you first call `useInsertNewVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewVoucherMutation, { data, loading, error }] = useInsertNewVoucherMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInsertNewVoucherMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertNewVoucherMutation, InsertNewVoucherMutationVariables>) {
        return ApolloReactHooks.useMutation<InsertNewVoucherMutation, InsertNewVoucherMutationVariables>(InsertNewVoucherDocument, baseOptions);
      }
export type InsertNewVoucherMutationHookResult = ReturnType<typeof useInsertNewVoucherMutation>;
export type InsertNewVoucherMutationResult = ApolloReactCommon.MutationResult<InsertNewVoucherMutation>;
export type InsertNewVoucherMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertNewVoucherMutation, InsertNewVoucherMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($id: uuid!, $password: String!) {
  update_accounts_by_pk(pk_columns: {id: $id}, _set: {password: $password}) {
    id
  }
}
    `;
export type ChangePasswordMutationFn = ApolloReactCommon.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;
export type ChangePasswordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ChangePasswordMutation, ChangePasswordMutationVariables>, 'mutation'>;

    export const ChangePasswordComponent = (props: ChangePasswordComponentProps) => (
      <ApolloReactComponents.Mutation<ChangePasswordMutation, ChangePasswordMutationVariables> mutation={ChangePasswordDocument} {...props} />
    );
    
export type ChangePasswordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>
    } & TChildProps;
export function withChangePassword<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ChangePasswordMutation,
  ChangePasswordMutationVariables,
  ChangePasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ChangePasswordMutation, ChangePasswordMutationVariables, ChangePasswordProps<TChildProps, TDataName>>(ChangePasswordDocument, {
      alias: 'changePassword',
      ...operationOptions
    });
};

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, baseOptions);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = ApolloReactCommon.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const VerifyPasswordDocument = gql`
    query VerifyPassword($id: uuid!) {
  accounts_by_pk(id: $id) {
    password
  }
}
    `;
export type VerifyPasswordComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<VerifyPasswordQuery, VerifyPasswordQueryVariables>, 'query'> & ({ variables: VerifyPasswordQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const VerifyPasswordComponent = (props: VerifyPasswordComponentProps) => (
      <ApolloReactComponents.Query<VerifyPasswordQuery, VerifyPasswordQueryVariables> query={VerifyPasswordDocument} {...props} />
    );
    
export type VerifyPasswordProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<VerifyPasswordQuery, VerifyPasswordQueryVariables>
    } & TChildProps;
export function withVerifyPassword<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  VerifyPasswordQuery,
  VerifyPasswordQueryVariables,
  VerifyPasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, VerifyPasswordQuery, VerifyPasswordQueryVariables, VerifyPasswordProps<TChildProps, TDataName>>(VerifyPasswordDocument, {
      alias: 'verifyPassword',
      ...operationOptions
    });
};

/**
 * __useVerifyPasswordQuery__
 *
 * To run a query within a React component, call `useVerifyPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyPasswordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifyPasswordQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VerifyPasswordQuery, VerifyPasswordQueryVariables>) {
        return ApolloReactHooks.useQuery<VerifyPasswordQuery, VerifyPasswordQueryVariables>(VerifyPasswordDocument, baseOptions);
      }
export function useVerifyPasswordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VerifyPasswordQuery, VerifyPasswordQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VerifyPasswordQuery, VerifyPasswordQueryVariables>(VerifyPasswordDocument, baseOptions);
        }
export type VerifyPasswordQueryHookResult = ReturnType<typeof useVerifyPasswordQuery>;
export type VerifyPasswordLazyQueryHookResult = ReturnType<typeof useVerifyPasswordLazyQuery>;
export type VerifyPasswordQueryResult = ApolloReactCommon.QueryResult<VerifyPasswordQuery, VerifyPasswordQueryVariables>;
export const GetExistingRefreshTokenDocument = gql`
    query GetExistingRefreshToken($id: uuid!) {
  refresh_tokens_by_pk(id: $id) {
    id
    expires_at
    account {
      id
      email
      display_name
      role
    }
  }
}
    `;
export type GetExistingRefreshTokenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetExistingRefreshTokenQuery, GetExistingRefreshTokenQueryVariables>, 'query'> & ({ variables: GetExistingRefreshTokenQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetExistingRefreshTokenComponent = (props: GetExistingRefreshTokenComponentProps) => (
      <ApolloReactComponents.Query<GetExistingRefreshTokenQuery, GetExistingRefreshTokenQueryVariables> query={GetExistingRefreshTokenDocument} {...props} />
    );
    
export type GetExistingRefreshTokenProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetExistingRefreshTokenQuery, GetExistingRefreshTokenQueryVariables>
    } & TChildProps;
export function withGetExistingRefreshToken<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetExistingRefreshTokenQuery,
  GetExistingRefreshTokenQueryVariables,
  GetExistingRefreshTokenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetExistingRefreshTokenQuery, GetExistingRefreshTokenQueryVariables, GetExistingRefreshTokenProps<TChildProps, TDataName>>(GetExistingRefreshTokenDocument, {
      alias: 'getExistingRefreshToken',
      ...operationOptions
    });
};

/**
 * __useGetExistingRefreshTokenQuery__
 *
 * To run a query within a React component, call `useGetExistingRefreshTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingRefreshTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingRefreshTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExistingRefreshTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExistingRefreshTokenQuery, GetExistingRefreshTokenQueryVariables>) {
        return ApolloReactHooks.useQuery<GetExistingRefreshTokenQuery, GetExistingRefreshTokenQueryVariables>(GetExistingRefreshTokenDocument, baseOptions);
      }
export function useGetExistingRefreshTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExistingRefreshTokenQuery, GetExistingRefreshTokenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetExistingRefreshTokenQuery, GetExistingRefreshTokenQueryVariables>(GetExistingRefreshTokenDocument, baseOptions);
        }
export type GetExistingRefreshTokenQueryHookResult = ReturnType<typeof useGetExistingRefreshTokenQuery>;
export type GetExistingRefreshTokenLazyQueryHookResult = ReturnType<typeof useGetExistingRefreshTokenLazyQuery>;
export type GetExistingRefreshTokenQueryResult = ApolloReactCommon.QueryResult<GetExistingRefreshTokenQuery, GetExistingRefreshTokenQueryVariables>;
export const ReplaceExistingRefreshTokenDocument = gql`
    mutation ReplaceExistingRefreshToken($oldToken: uuid!, $accountId: uuid!, $expiresAt: timestamptz) {
  delete_refresh_tokens_by_pk(id: $oldToken) {
    id
  }
  insert_refresh_tokens_one(
    object: {expires_at: $expiresAt, account_id: $accountId}
  ) {
    id
    expires_at
  }
}
    `;
export type ReplaceExistingRefreshTokenMutationFn = ApolloReactCommon.MutationFunction<ReplaceExistingRefreshTokenMutation, ReplaceExistingRefreshTokenMutationVariables>;
export type ReplaceExistingRefreshTokenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ReplaceExistingRefreshTokenMutation, ReplaceExistingRefreshTokenMutationVariables>, 'mutation'>;

    export const ReplaceExistingRefreshTokenComponent = (props: ReplaceExistingRefreshTokenComponentProps) => (
      <ApolloReactComponents.Mutation<ReplaceExistingRefreshTokenMutation, ReplaceExistingRefreshTokenMutationVariables> mutation={ReplaceExistingRefreshTokenDocument} {...props} />
    );
    
export type ReplaceExistingRefreshTokenProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ReplaceExistingRefreshTokenMutation, ReplaceExistingRefreshTokenMutationVariables>
    } & TChildProps;
export function withReplaceExistingRefreshToken<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReplaceExistingRefreshTokenMutation,
  ReplaceExistingRefreshTokenMutationVariables,
  ReplaceExistingRefreshTokenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ReplaceExistingRefreshTokenMutation, ReplaceExistingRefreshTokenMutationVariables, ReplaceExistingRefreshTokenProps<TChildProps, TDataName>>(ReplaceExistingRefreshTokenDocument, {
      alias: 'replaceExistingRefreshToken',
      ...operationOptions
    });
};

/**
 * __useReplaceExistingRefreshTokenMutation__
 *
 * To run a mutation, you first call `useReplaceExistingRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceExistingRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceExistingRefreshTokenMutation, { data, loading, error }] = useReplaceExistingRefreshTokenMutation({
 *   variables: {
 *      oldToken: // value for 'oldToken'
 *      accountId: // value for 'accountId'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useReplaceExistingRefreshTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReplaceExistingRefreshTokenMutation, ReplaceExistingRefreshTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<ReplaceExistingRefreshTokenMutation, ReplaceExistingRefreshTokenMutationVariables>(ReplaceExistingRefreshTokenDocument, baseOptions);
      }
export type ReplaceExistingRefreshTokenMutationHookResult = ReturnType<typeof useReplaceExistingRefreshTokenMutation>;
export type ReplaceExistingRefreshTokenMutationResult = ApolloReactCommon.MutationResult<ReplaceExistingRefreshTokenMutation>;
export type ReplaceExistingRefreshTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<ReplaceExistingRefreshTokenMutation, ReplaceExistingRefreshTokenMutationVariables>;
export const GetAccountWithPasswordDocument = gql`
    query GetAccountWithPassword($email: String) {
  accounts(where: {email: {_eq: $email}}) {
    id
    password
    display_name
    role
    email
    email_verified
  }
}
    `;
export type GetAccountWithPasswordComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAccountWithPasswordQuery, GetAccountWithPasswordQueryVariables>, 'query'>;

    export const GetAccountWithPasswordComponent = (props: GetAccountWithPasswordComponentProps) => (
      <ApolloReactComponents.Query<GetAccountWithPasswordQuery, GetAccountWithPasswordQueryVariables> query={GetAccountWithPasswordDocument} {...props} />
    );
    
export type GetAccountWithPasswordProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAccountWithPasswordQuery, GetAccountWithPasswordQueryVariables>
    } & TChildProps;
export function withGetAccountWithPassword<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAccountWithPasswordQuery,
  GetAccountWithPasswordQueryVariables,
  GetAccountWithPasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAccountWithPasswordQuery, GetAccountWithPasswordQueryVariables, GetAccountWithPasswordProps<TChildProps, TDataName>>(GetAccountWithPasswordDocument, {
      alias: 'getAccountWithPassword',
      ...operationOptions
    });
};

/**
 * __useGetAccountWithPasswordQuery__
 *
 * To run a query within a React component, call `useGetAccountWithPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountWithPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountWithPasswordQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetAccountWithPasswordQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountWithPasswordQuery, GetAccountWithPasswordQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAccountWithPasswordQuery, GetAccountWithPasswordQueryVariables>(GetAccountWithPasswordDocument, baseOptions);
      }
export function useGetAccountWithPasswordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountWithPasswordQuery, GetAccountWithPasswordQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAccountWithPasswordQuery, GetAccountWithPasswordQueryVariables>(GetAccountWithPasswordDocument, baseOptions);
        }
export type GetAccountWithPasswordQueryHookResult = ReturnType<typeof useGetAccountWithPasswordQuery>;
export type GetAccountWithPasswordLazyQueryHookResult = ReturnType<typeof useGetAccountWithPasswordLazyQuery>;
export type GetAccountWithPasswordQueryResult = ApolloReactCommon.QueryResult<GetAccountWithPasswordQuery, GetAccountWithPasswordQueryVariables>;
export const NewRefreshTokenDocument = gql`
    mutation NewRefreshToken($id: uuid!, $expiresAt: timestamptz) {
  insert_refresh_tokens_one(object: {expires_at: $expiresAt, account_id: $id}) {
    id
    expires_at
  }
}
    `;
export type NewRefreshTokenMutationFn = ApolloReactCommon.MutationFunction<NewRefreshTokenMutation, NewRefreshTokenMutationVariables>;
export type NewRefreshTokenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<NewRefreshTokenMutation, NewRefreshTokenMutationVariables>, 'mutation'>;

    export const NewRefreshTokenComponent = (props: NewRefreshTokenComponentProps) => (
      <ApolloReactComponents.Mutation<NewRefreshTokenMutation, NewRefreshTokenMutationVariables> mutation={NewRefreshTokenDocument} {...props} />
    );
    
export type NewRefreshTokenProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<NewRefreshTokenMutation, NewRefreshTokenMutationVariables>
    } & TChildProps;
export function withNewRefreshToken<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NewRefreshTokenMutation,
  NewRefreshTokenMutationVariables,
  NewRefreshTokenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, NewRefreshTokenMutation, NewRefreshTokenMutationVariables, NewRefreshTokenProps<TChildProps, TDataName>>(NewRefreshTokenDocument, {
      alias: 'newRefreshToken',
      ...operationOptions
    });
};

/**
 * __useNewRefreshTokenMutation__
 *
 * To run a mutation, you first call `useNewRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newRefreshTokenMutation, { data, loading, error }] = useNewRefreshTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useNewRefreshTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NewRefreshTokenMutation, NewRefreshTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<NewRefreshTokenMutation, NewRefreshTokenMutationVariables>(NewRefreshTokenDocument, baseOptions);
      }
export type NewRefreshTokenMutationHookResult = ReturnType<typeof useNewRefreshTokenMutation>;
export type NewRefreshTokenMutationResult = ApolloReactCommon.MutationResult<NewRefreshTokenMutation>;
export type NewRefreshTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<NewRefreshTokenMutation, NewRefreshTokenMutationVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($password: String!, $email: String!, $display_name: String!) {
  insert_accounts_one(
    object: {password: $password, email: $email, display_name: $display_name}
  ) {
    id
    display_name
    email
    role
  }
}
    `;
export type CreateAccountMutationFn = ApolloReactCommon.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;
export type CreateAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAccountMutation, CreateAccountMutationVariables>, 'mutation'>;

    export const CreateAccountComponent = (props: CreateAccountComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAccountMutation, CreateAccountMutationVariables> mutation={CreateAccountDocument} {...props} />
    );
    
export type CreateAccountProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>
    } & TChildProps;
export function withCreateAccount<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateAccountMutation,
  CreateAccountMutationVariables,
  CreateAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateAccountMutation, CreateAccountMutationVariables, CreateAccountProps<TChildProps, TDataName>>(CreateAccountDocument, {
      alias: 'createAccount',
      ...operationOptions
    });
};

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      password: // value for 'password'
 *      email: // value for 'email'
 *      display_name: // value for 'display_name'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, baseOptions);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = ApolloReactCommon.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const GetPreflightPasswordDocument = gql`
    query GetPreflightPassword {
  unstructured_data_by_pk(title: "preflight") {
    password: data(path: "$.password")
  }
}
    `;
export type GetPreflightPasswordComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPreflightPasswordQuery, GetPreflightPasswordQueryVariables>, 'query'>;

    export const GetPreflightPasswordComponent = (props: GetPreflightPasswordComponentProps) => (
      <ApolloReactComponents.Query<GetPreflightPasswordQuery, GetPreflightPasswordQueryVariables> query={GetPreflightPasswordDocument} {...props} />
    );
    
export type GetPreflightPasswordProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPreflightPasswordQuery, GetPreflightPasswordQueryVariables>
    } & TChildProps;
export function withGetPreflightPassword<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPreflightPasswordQuery,
  GetPreflightPasswordQueryVariables,
  GetPreflightPasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPreflightPasswordQuery, GetPreflightPasswordQueryVariables, GetPreflightPasswordProps<TChildProps, TDataName>>(GetPreflightPasswordDocument, {
      alias: 'getPreflightPassword',
      ...operationOptions
    });
};

/**
 * __useGetPreflightPasswordQuery__
 *
 * To run a query within a React component, call `useGetPreflightPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreflightPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreflightPasswordQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreflightPasswordQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPreflightPasswordQuery, GetPreflightPasswordQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPreflightPasswordQuery, GetPreflightPasswordQueryVariables>(GetPreflightPasswordDocument, baseOptions);
      }
export function useGetPreflightPasswordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPreflightPasswordQuery, GetPreflightPasswordQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPreflightPasswordQuery, GetPreflightPasswordQueryVariables>(GetPreflightPasswordDocument, baseOptions);
        }
export type GetPreflightPasswordQueryHookResult = ReturnType<typeof useGetPreflightPasswordQuery>;
export type GetPreflightPasswordLazyQueryHookResult = ReturnType<typeof useGetPreflightPasswordLazyQuery>;
export type GetPreflightPasswordQueryResult = ApolloReactCommon.QueryResult<GetPreflightPasswordQuery, GetPreflightPasswordQueryVariables>;
export const GetRemainingTicketsDocument = gql`
    query GetRemainingTickets($event_id: uuid!) {
  events_by_pk(id: $event_id) {
    seats
    free_seats
    total_attendees: attendees_aggregate(
      where: {_and: [{is_online_viewer: {_eq: false}}]}
    ) {
      aggregate {
        count
      }
    }
    free_attendees: attendees_aggregate(
      where: {_and: [{is_online_viewer: {_eq: false}}, {is_free_attendee: {_eq: true}}]}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;
export type GetRemainingTicketsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRemainingTicketsQuery, GetRemainingTicketsQueryVariables>, 'query'> & ({ variables: GetRemainingTicketsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRemainingTicketsComponent = (props: GetRemainingTicketsComponentProps) => (
      <ApolloReactComponents.Query<GetRemainingTicketsQuery, GetRemainingTicketsQueryVariables> query={GetRemainingTicketsDocument} {...props} />
    );
    
export type GetRemainingTicketsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRemainingTicketsQuery, GetRemainingTicketsQueryVariables>
    } & TChildProps;
export function withGetRemainingTickets<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRemainingTicketsQuery,
  GetRemainingTicketsQueryVariables,
  GetRemainingTicketsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRemainingTicketsQuery, GetRemainingTicketsQueryVariables, GetRemainingTicketsProps<TChildProps, TDataName>>(GetRemainingTicketsDocument, {
      alias: 'getRemainingTickets',
      ...operationOptions
    });
};

/**
 * __useGetRemainingTicketsQuery__
 *
 * To run a query within a React component, call `useGetRemainingTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemainingTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemainingTicketsQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetRemainingTicketsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRemainingTicketsQuery, GetRemainingTicketsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRemainingTicketsQuery, GetRemainingTicketsQueryVariables>(GetRemainingTicketsDocument, baseOptions);
      }
export function useGetRemainingTicketsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRemainingTicketsQuery, GetRemainingTicketsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRemainingTicketsQuery, GetRemainingTicketsQueryVariables>(GetRemainingTicketsDocument, baseOptions);
        }
export type GetRemainingTicketsQueryHookResult = ReturnType<typeof useGetRemainingTicketsQuery>;
export type GetRemainingTicketsLazyQueryHookResult = ReturnType<typeof useGetRemainingTicketsLazyQuery>;
export type GetRemainingTicketsQueryResult = ApolloReactCommon.QueryResult<GetRemainingTicketsQuery, GetRemainingTicketsQueryVariables>;
export const InsertManualOrderDocument = gql`
    mutation InsertManualOrder($data: orders_insert_input!) {
  insert_orders_one(object: $data) {
    id
    status
    address {
      name
      contact_email
      country {
        name
      }
    }
    shipping_option {
      name
      price
      country
    }
    order_books {
      price
      discount
      quantity
      book {
        isbn
        title
        author
      }
    }
    order_products {
      price
      discount
      quantity
      product {
        id
        title
      }
    }
    vouchers {
      id
      initial_amount
      recipient
    }
    pif_donations {
      amount
    }
    custom_line_price
    custom_line_title
    custom_line_status
    custom_shipping_price
    custom_shipping_title
  }
}
    `;
export type InsertManualOrderMutationFn = ApolloReactCommon.MutationFunction<InsertManualOrderMutation, InsertManualOrderMutationVariables>;
export type InsertManualOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertManualOrderMutation, InsertManualOrderMutationVariables>, 'mutation'>;

    export const InsertManualOrderComponent = (props: InsertManualOrderComponentProps) => (
      <ApolloReactComponents.Mutation<InsertManualOrderMutation, InsertManualOrderMutationVariables> mutation={InsertManualOrderDocument} {...props} />
    );
    
export type InsertManualOrderProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertManualOrderMutation, InsertManualOrderMutationVariables>
    } & TChildProps;
export function withInsertManualOrder<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertManualOrderMutation,
  InsertManualOrderMutationVariables,
  InsertManualOrderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertManualOrderMutation, InsertManualOrderMutationVariables, InsertManualOrderProps<TChildProps, TDataName>>(InsertManualOrderDocument, {
      alias: 'insertManualOrder',
      ...operationOptions
    });
};

/**
 * __useInsertManualOrderMutation__
 *
 * To run a mutation, you first call `useInsertManualOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertManualOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertManualOrderMutation, { data, loading, error }] = useInsertManualOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInsertManualOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertManualOrderMutation, InsertManualOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<InsertManualOrderMutation, InsertManualOrderMutationVariables>(InsertManualOrderDocument, baseOptions);
      }
export type InsertManualOrderMutationHookResult = ReturnType<typeof useInsertManualOrderMutation>;
export type InsertManualOrderMutationResult = ApolloReactCommon.MutationResult<InsertManualOrderMutation>;
export type InsertManualOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertManualOrderMutation, InsertManualOrderMutationVariables>;
export const MarkOrderInvoiceSentDocument = gql`
    mutation MarkOrderInvoiceSent($id: Int!, $invoice: String!) {
  update_orders_by_pk(
    pk_columns: {id: $id}
    _set: {status: invoice_sent, stripe_payment_id: $invoice}
  ) {
    id
    status
  }
}
    `;
export type MarkOrderInvoiceSentMutationFn = ApolloReactCommon.MutationFunction<MarkOrderInvoiceSentMutation, MarkOrderInvoiceSentMutationVariables>;
export type MarkOrderInvoiceSentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MarkOrderInvoiceSentMutation, MarkOrderInvoiceSentMutationVariables>, 'mutation'>;

    export const MarkOrderInvoiceSentComponent = (props: MarkOrderInvoiceSentComponentProps) => (
      <ApolloReactComponents.Mutation<MarkOrderInvoiceSentMutation, MarkOrderInvoiceSentMutationVariables> mutation={MarkOrderInvoiceSentDocument} {...props} />
    );
    
export type MarkOrderInvoiceSentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MarkOrderInvoiceSentMutation, MarkOrderInvoiceSentMutationVariables>
    } & TChildProps;
export function withMarkOrderInvoiceSent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MarkOrderInvoiceSentMutation,
  MarkOrderInvoiceSentMutationVariables,
  MarkOrderInvoiceSentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MarkOrderInvoiceSentMutation, MarkOrderInvoiceSentMutationVariables, MarkOrderInvoiceSentProps<TChildProps, TDataName>>(MarkOrderInvoiceSentDocument, {
      alias: 'markOrderInvoiceSent',
      ...operationOptions
    });
};

/**
 * __useMarkOrderInvoiceSentMutation__
 *
 * To run a mutation, you first call `useMarkOrderInvoiceSentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOrderInvoiceSentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOrderInvoiceSentMutation, { data, loading, error }] = useMarkOrderInvoiceSentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      invoice: // value for 'invoice'
 *   },
 * });
 */
export function useMarkOrderInvoiceSentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkOrderInvoiceSentMutation, MarkOrderInvoiceSentMutationVariables>) {
        return ApolloReactHooks.useMutation<MarkOrderInvoiceSentMutation, MarkOrderInvoiceSentMutationVariables>(MarkOrderInvoiceSentDocument, baseOptions);
      }
export type MarkOrderInvoiceSentMutationHookResult = ReturnType<typeof useMarkOrderInvoiceSentMutation>;
export type MarkOrderInvoiceSentMutationResult = ApolloReactCommon.MutationResult<MarkOrderInvoiceSentMutation>;
export type MarkOrderInvoiceSentMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkOrderInvoiceSentMutation, MarkOrderInvoiceSentMutationVariables>;
export const InsertRefundDocument = gql`
    mutation InsertRefund($orderId: Int!, $amount: Int!, $status: order_status_enum) {
  insert_refunds_one(object: {amount: $amount, order_id: $orderId}) {
    id
  }
  update_orders_by_pk(pk_columns: {id: $orderId}, _set: {status: $status}) {
    id
  }
}
    `;
export type InsertRefundMutationFn = ApolloReactCommon.MutationFunction<InsertRefundMutation, InsertRefundMutationVariables>;
export type InsertRefundComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertRefundMutation, InsertRefundMutationVariables>, 'mutation'>;

    export const InsertRefundComponent = (props: InsertRefundComponentProps) => (
      <ApolloReactComponents.Mutation<InsertRefundMutation, InsertRefundMutationVariables> mutation={InsertRefundDocument} {...props} />
    );
    
export type InsertRefundProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertRefundMutation, InsertRefundMutationVariables>
    } & TChildProps;
export function withInsertRefund<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertRefundMutation,
  InsertRefundMutationVariables,
  InsertRefundProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertRefundMutation, InsertRefundMutationVariables, InsertRefundProps<TChildProps, TDataName>>(InsertRefundDocument, {
      alias: 'insertRefund',
      ...operationOptions
    });
};

/**
 * __useInsertRefundMutation__
 *
 * To run a mutation, you first call `useInsertRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRefundMutation, { data, loading, error }] = useInsertRefundMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      amount: // value for 'amount'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useInsertRefundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertRefundMutation, InsertRefundMutationVariables>) {
        return ApolloReactHooks.useMutation<InsertRefundMutation, InsertRefundMutationVariables>(InsertRefundDocument, baseOptions);
      }
export type InsertRefundMutationHookResult = ReturnType<typeof useInsertRefundMutation>;
export type InsertRefundMutationResult = ApolloReactCommon.MutationResult<InsertRefundMutation>;
export type InsertRefundMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertRefundMutation, InsertRefundMutationVariables>;
export const SubscriptionCheckoutGetSubDocument = gql`
    query SubscriptionCheckoutGetSub($subId: uuid!) {
  subscriptions_by_pk(id: $subId) {
    id
    description
    title
    price
  }
}
    `;
export type SubscriptionCheckoutGetSubComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SubscriptionCheckoutGetSubQuery, SubscriptionCheckoutGetSubQueryVariables>, 'query'> & ({ variables: SubscriptionCheckoutGetSubQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SubscriptionCheckoutGetSubComponent = (props: SubscriptionCheckoutGetSubComponentProps) => (
      <ApolloReactComponents.Query<SubscriptionCheckoutGetSubQuery, SubscriptionCheckoutGetSubQueryVariables> query={SubscriptionCheckoutGetSubDocument} {...props} />
    );
    
export type SubscriptionCheckoutGetSubProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SubscriptionCheckoutGetSubQuery, SubscriptionCheckoutGetSubQueryVariables>
    } & TChildProps;
export function withSubscriptionCheckoutGetSub<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubscriptionCheckoutGetSubQuery,
  SubscriptionCheckoutGetSubQueryVariables,
  SubscriptionCheckoutGetSubProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SubscriptionCheckoutGetSubQuery, SubscriptionCheckoutGetSubQueryVariables, SubscriptionCheckoutGetSubProps<TChildProps, TDataName>>(SubscriptionCheckoutGetSubDocument, {
      alias: 'subscriptionCheckoutGetSub',
      ...operationOptions
    });
};

/**
 * __useSubscriptionCheckoutGetSubQuery__
 *
 * To run a query within a React component, call `useSubscriptionCheckoutGetSubQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCheckoutGetSubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionCheckoutGetSubQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useSubscriptionCheckoutGetSubQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionCheckoutGetSubQuery, SubscriptionCheckoutGetSubQueryVariables>) {
        return ApolloReactHooks.useQuery<SubscriptionCheckoutGetSubQuery, SubscriptionCheckoutGetSubQueryVariables>(SubscriptionCheckoutGetSubDocument, baseOptions);
      }
export function useSubscriptionCheckoutGetSubLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionCheckoutGetSubQuery, SubscriptionCheckoutGetSubQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SubscriptionCheckoutGetSubQuery, SubscriptionCheckoutGetSubQueryVariables>(SubscriptionCheckoutGetSubDocument, baseOptions);
        }
export type SubscriptionCheckoutGetSubQueryHookResult = ReturnType<typeof useSubscriptionCheckoutGetSubQuery>;
export type SubscriptionCheckoutGetSubLazyQueryHookResult = ReturnType<typeof useSubscriptionCheckoutGetSubLazyQuery>;
export type SubscriptionCheckoutGetSubQueryResult = ApolloReactCommon.QueryResult<SubscriptionCheckoutGetSubQuery, SubscriptionCheckoutGetSubQueryVariables>;
export const CreateDraftSubscriptionObjectDocument = gql`
    mutation CreateDraftSubscriptionObject($data: subscription_draft_object_insert_input!) {
  insert_subscription_draft_object_one(object: $data) {
    id
  }
}
    `;
export type CreateDraftSubscriptionObjectMutationFn = ApolloReactCommon.MutationFunction<CreateDraftSubscriptionObjectMutation, CreateDraftSubscriptionObjectMutationVariables>;
export type CreateDraftSubscriptionObjectComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDraftSubscriptionObjectMutation, CreateDraftSubscriptionObjectMutationVariables>, 'mutation'>;

    export const CreateDraftSubscriptionObjectComponent = (props: CreateDraftSubscriptionObjectComponentProps) => (
      <ApolloReactComponents.Mutation<CreateDraftSubscriptionObjectMutation, CreateDraftSubscriptionObjectMutationVariables> mutation={CreateDraftSubscriptionObjectDocument} {...props} />
    );
    
export type CreateDraftSubscriptionObjectProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateDraftSubscriptionObjectMutation, CreateDraftSubscriptionObjectMutationVariables>
    } & TChildProps;
export function withCreateDraftSubscriptionObject<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateDraftSubscriptionObjectMutation,
  CreateDraftSubscriptionObjectMutationVariables,
  CreateDraftSubscriptionObjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateDraftSubscriptionObjectMutation, CreateDraftSubscriptionObjectMutationVariables, CreateDraftSubscriptionObjectProps<TChildProps, TDataName>>(CreateDraftSubscriptionObjectDocument, {
      alias: 'createDraftSubscriptionObject',
      ...operationOptions
    });
};

/**
 * __useCreateDraftSubscriptionObjectMutation__
 *
 * To run a mutation, you first call `useCreateDraftSubscriptionObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftSubscriptionObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftSubscriptionObjectMutation, { data, loading, error }] = useCreateDraftSubscriptionObjectMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDraftSubscriptionObjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDraftSubscriptionObjectMutation, CreateDraftSubscriptionObjectMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDraftSubscriptionObjectMutation, CreateDraftSubscriptionObjectMutationVariables>(CreateDraftSubscriptionObjectDocument, baseOptions);
      }
export type CreateDraftSubscriptionObjectMutationHookResult = ReturnType<typeof useCreateDraftSubscriptionObjectMutation>;
export type CreateDraftSubscriptionObjectMutationResult = ApolloReactCommon.MutationResult<CreateDraftSubscriptionObjectMutation>;
export type CreateDraftSubscriptionObjectMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDraftSubscriptionObjectMutation, CreateDraftSubscriptionObjectMutationVariables>;
export const GetSubscriptionObjectActiveStatusDocument = gql`
    query GetSubscriptionObjectActiveStatus($sub_obj_id: uuid!) {
  subscription_object_by_pk(id: $sub_obj_id) {
    id
    stripe_sub_id
    is_active
  }
}
    `;
export type GetSubscriptionObjectActiveStatusComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubscriptionObjectActiveStatusQuery, GetSubscriptionObjectActiveStatusQueryVariables>, 'query'> & ({ variables: GetSubscriptionObjectActiveStatusQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubscriptionObjectActiveStatusComponent = (props: GetSubscriptionObjectActiveStatusComponentProps) => (
      <ApolloReactComponents.Query<GetSubscriptionObjectActiveStatusQuery, GetSubscriptionObjectActiveStatusQueryVariables> query={GetSubscriptionObjectActiveStatusDocument} {...props} />
    );
    
export type GetSubscriptionObjectActiveStatusProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubscriptionObjectActiveStatusQuery, GetSubscriptionObjectActiveStatusQueryVariables>
    } & TChildProps;
export function withGetSubscriptionObjectActiveStatus<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubscriptionObjectActiveStatusQuery,
  GetSubscriptionObjectActiveStatusQueryVariables,
  GetSubscriptionObjectActiveStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubscriptionObjectActiveStatusQuery, GetSubscriptionObjectActiveStatusQueryVariables, GetSubscriptionObjectActiveStatusProps<TChildProps, TDataName>>(GetSubscriptionObjectActiveStatusDocument, {
      alias: 'getSubscriptionObjectActiveStatus',
      ...operationOptions
    });
};

/**
 * __useGetSubscriptionObjectActiveStatusQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionObjectActiveStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionObjectActiveStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionObjectActiveStatusQuery({
 *   variables: {
 *      sub_obj_id: // value for 'sub_obj_id'
 *   },
 * });
 */
export function useGetSubscriptionObjectActiveStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubscriptionObjectActiveStatusQuery, GetSubscriptionObjectActiveStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubscriptionObjectActiveStatusQuery, GetSubscriptionObjectActiveStatusQueryVariables>(GetSubscriptionObjectActiveStatusDocument, baseOptions);
      }
export function useGetSubscriptionObjectActiveStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubscriptionObjectActiveStatusQuery, GetSubscriptionObjectActiveStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubscriptionObjectActiveStatusQuery, GetSubscriptionObjectActiveStatusQueryVariables>(GetSubscriptionObjectActiveStatusDocument, baseOptions);
        }
export type GetSubscriptionObjectActiveStatusQueryHookResult = ReturnType<typeof useGetSubscriptionObjectActiveStatusQuery>;
export type GetSubscriptionObjectActiveStatusLazyQueryHookResult = ReturnType<typeof useGetSubscriptionObjectActiveStatusLazyQuery>;
export type GetSubscriptionObjectActiveStatusQueryResult = ApolloReactCommon.QueryResult<GetSubscriptionObjectActiveStatusQuery, GetSubscriptionObjectActiveStatusQueryVariables>;
export const BatchInsertBooksDocument = gql`
    mutation BatchInsertBooks($books: [books_insert_input!]!) {
  insert_books(
    objects: $books
    on_conflict: {constraint: books_pkey, update_columns: [stock, price]}
  ) {
    affected_rows
  }
}
    `;
export type BatchInsertBooksMutationFn = ApolloReactCommon.MutationFunction<BatchInsertBooksMutation, BatchInsertBooksMutationVariables>;
export type BatchInsertBooksComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BatchInsertBooksMutation, BatchInsertBooksMutationVariables>, 'mutation'>;

    export const BatchInsertBooksComponent = (props: BatchInsertBooksComponentProps) => (
      <ApolloReactComponents.Mutation<BatchInsertBooksMutation, BatchInsertBooksMutationVariables> mutation={BatchInsertBooksDocument} {...props} />
    );
    
export type BatchInsertBooksProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<BatchInsertBooksMutation, BatchInsertBooksMutationVariables>
    } & TChildProps;
export function withBatchInsertBooks<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BatchInsertBooksMutation,
  BatchInsertBooksMutationVariables,
  BatchInsertBooksProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, BatchInsertBooksMutation, BatchInsertBooksMutationVariables, BatchInsertBooksProps<TChildProps, TDataName>>(BatchInsertBooksDocument, {
      alias: 'batchInsertBooks',
      ...operationOptions
    });
};

/**
 * __useBatchInsertBooksMutation__
 *
 * To run a mutation, you first call `useBatchInsertBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchInsertBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchInsertBooksMutation, { data, loading, error }] = useBatchInsertBooksMutation({
 *   variables: {
 *      books: // value for 'books'
 *   },
 * });
 */
export function useBatchInsertBooksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchInsertBooksMutation, BatchInsertBooksMutationVariables>) {
        return ApolloReactHooks.useMutation<BatchInsertBooksMutation, BatchInsertBooksMutationVariables>(BatchInsertBooksDocument, baseOptions);
      }
export type BatchInsertBooksMutationHookResult = ReturnType<typeof useBatchInsertBooksMutation>;
export type BatchInsertBooksMutationResult = ApolloReactCommon.MutationResult<BatchInsertBooksMutation>;
export type BatchInsertBooksMutationOptions = ApolloReactCommon.BaseMutationOptions<BatchInsertBooksMutation, BatchInsertBooksMutationVariables>;
export const GetDiscountDocument = gql`
    query GetDiscount($code: String!) {
  discounts_by_pk(code: $code) {
    code
    discount_value
    is_active
    is_fixed_amount
    limit_uses
    orders_aggregate {
      aggregate {
        count
      }
    }
    discounted_books {
      book_isbn
    }
  }
}
    `;
export type GetDiscountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDiscountQuery, GetDiscountQueryVariables>, 'query'> & ({ variables: GetDiscountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDiscountComponent = (props: GetDiscountComponentProps) => (
      <ApolloReactComponents.Query<GetDiscountQuery, GetDiscountQueryVariables> query={GetDiscountDocument} {...props} />
    );
    
export type GetDiscountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDiscountQuery, GetDiscountQueryVariables>
    } & TChildProps;
export function withGetDiscount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDiscountQuery,
  GetDiscountQueryVariables,
  GetDiscountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDiscountQuery, GetDiscountQueryVariables, GetDiscountProps<TChildProps, TDataName>>(GetDiscountDocument, {
      alias: 'getDiscount',
      ...operationOptions
    });
};

/**
 * __useGetDiscountQuery__
 *
 * To run a query within a React component, call `useGetDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetDiscountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, baseOptions);
      }
export function useGetDiscountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, baseOptions);
        }
export type GetDiscountQueryHookResult = ReturnType<typeof useGetDiscountQuery>;
export type GetDiscountLazyQueryHookResult = ReturnType<typeof useGetDiscountLazyQuery>;
export type GetDiscountQueryResult = ApolloReactCommon.QueryResult<GetDiscountQuery, GetDiscountQueryVariables>;
export const ValidateVoucherDocument = gql`
    query ValidateVoucher($id: String!) {
  vouchers_by_pk(id: $id) {
    id
    initial_amount
    remaining_amount
    order {
      status
    }
    event_tickets {
      event {
        event_books {
          book {
            ...BookCardData
          }
        }
      }
    }
  }
}
    ${BookCardDataFragmentDoc}`;
export type ValidateVoucherComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ValidateVoucherQuery, ValidateVoucherQueryVariables>, 'query'> & ({ variables: ValidateVoucherQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ValidateVoucherComponent = (props: ValidateVoucherComponentProps) => (
      <ApolloReactComponents.Query<ValidateVoucherQuery, ValidateVoucherQueryVariables> query={ValidateVoucherDocument} {...props} />
    );
    
export type ValidateVoucherProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ValidateVoucherQuery, ValidateVoucherQueryVariables>
    } & TChildProps;
export function withValidateVoucher<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ValidateVoucherQuery,
  ValidateVoucherQueryVariables,
  ValidateVoucherProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ValidateVoucherQuery, ValidateVoucherQueryVariables, ValidateVoucherProps<TChildProps, TDataName>>(ValidateVoucherDocument, {
      alias: 'validateVoucher',
      ...operationOptions
    });
};

/**
 * __useValidateVoucherQuery__
 *
 * To run a query within a React component, call `useValidateVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateVoucherQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidateVoucherQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ValidateVoucherQuery, ValidateVoucherQueryVariables>) {
        return ApolloReactHooks.useQuery<ValidateVoucherQuery, ValidateVoucherQueryVariables>(ValidateVoucherDocument, baseOptions);
      }
export function useValidateVoucherLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateVoucherQuery, ValidateVoucherQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ValidateVoucherQuery, ValidateVoucherQueryVariables>(ValidateVoucherDocument, baseOptions);
        }
export type ValidateVoucherQueryHookResult = ReturnType<typeof useValidateVoucherQuery>;
export type ValidateVoucherLazyQueryHookResult = ReturnType<typeof useValidateVoucherLazyQuery>;
export type ValidateVoucherQueryResult = ApolloReactCommon.QueryResult<ValidateVoucherQuery, ValidateVoucherQueryVariables>;
export const GetBookBasedReccomendationsDocument = gql`
    query GetBookBasedReccomendations($isbn: bigint!, $categories: [String!] = [], $tags: [Int!] = [], $offset: Int!) {
  books_by_pk(isbn: $isbn) {
    is_unlisted
    price
    post_books {
      post {
        ...PostCardData
      }
    }
  }
  books(
    limit: 4
    offset: $offset
    order_by: [{order_books_aggregate: {sum: {quantity: desc}}}]
    where: {_and: [{_or: [{category_books: {category_name: {_in: $categories}}}, {tag_books: {tag_id: {_in: $tags}}}]}, {is_unlisted: {_eq: false}}, {_or: [{stock: {_gt: 0}}, {track_stock: {_eq: false}}]}, {isbn: {_neq: $isbn}}]}
  ) {
    ...BookCardData
  }
  event_book(
    where: {_and: [{book_isbn: {_eq: $isbn}}, {event: {is_cancelled: {_eq: false}}}]}
    distinct_on: event_id
  ) {
    event {
      ...EventCardData
    }
  }
}
    ${PostCardDataFragmentDoc}
${BookCardDataFragmentDoc}
${EventCardDataFragmentDoc}`;
export type GetBookBasedReccomendationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBookBasedReccomendationsQuery, GetBookBasedReccomendationsQueryVariables>, 'query'> & ({ variables: GetBookBasedReccomendationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetBookBasedReccomendationsComponent = (props: GetBookBasedReccomendationsComponentProps) => (
      <ApolloReactComponents.Query<GetBookBasedReccomendationsQuery, GetBookBasedReccomendationsQueryVariables> query={GetBookBasedReccomendationsDocument} {...props} />
    );
    
export type GetBookBasedReccomendationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBookBasedReccomendationsQuery, GetBookBasedReccomendationsQueryVariables>
    } & TChildProps;
export function withGetBookBasedReccomendations<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBookBasedReccomendationsQuery,
  GetBookBasedReccomendationsQueryVariables,
  GetBookBasedReccomendationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBookBasedReccomendationsQuery, GetBookBasedReccomendationsQueryVariables, GetBookBasedReccomendationsProps<TChildProps, TDataName>>(GetBookBasedReccomendationsDocument, {
      alias: 'getBookBasedReccomendations',
      ...operationOptions
    });
};

/**
 * __useGetBookBasedReccomendationsQuery__
 *
 * To run a query within a React component, call `useGetBookBasedReccomendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookBasedReccomendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookBasedReccomendationsQuery({
 *   variables: {
 *      isbn: // value for 'isbn'
 *      categories: // value for 'categories'
 *      tags: // value for 'tags'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetBookBasedReccomendationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBookBasedReccomendationsQuery, GetBookBasedReccomendationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBookBasedReccomendationsQuery, GetBookBasedReccomendationsQueryVariables>(GetBookBasedReccomendationsDocument, baseOptions);
      }
export function useGetBookBasedReccomendationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookBasedReccomendationsQuery, GetBookBasedReccomendationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBookBasedReccomendationsQuery, GetBookBasedReccomendationsQueryVariables>(GetBookBasedReccomendationsDocument, baseOptions);
        }
export type GetBookBasedReccomendationsQueryHookResult = ReturnType<typeof useGetBookBasedReccomendationsQuery>;
export type GetBookBasedReccomendationsLazyQueryHookResult = ReturnType<typeof useGetBookBasedReccomendationsLazyQuery>;
export type GetBookBasedReccomendationsQueryResult = ApolloReactCommon.QueryResult<GetBookBasedReccomendationsQuery, GetBookBasedReccomendationsQueryVariables>;
export const GetAllCategoriesDocument = gql`
    query GetAllCategories {
  categories(
    order_by: [{name: asc}]
    where: {_or: [{category_events: {}}, {category_posts: {}}, {category_books: {}}]}
  ) {
    name
    slug
  }
}
    `;
export type GetAllCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>, 'query'>;

    export const GetAllCategoriesComponent = (props: GetAllCategoriesComponentProps) => (
      <ApolloReactComponents.Query<GetAllCategoriesQuery, GetAllCategoriesQueryVariables> query={GetAllCategoriesDocument} {...props} />
    );
    
export type GetAllCategoriesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>
    } & TChildProps;
export function withGetAllCategories<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllCategoriesQuery,
  GetAllCategoriesQueryVariables,
  GetAllCategoriesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllCategoriesQuery, GetAllCategoriesQueryVariables, GetAllCategoriesProps<TChildProps, TDataName>>(GetAllCategoriesDocument, {
      alias: 'getAllCategories',
      ...operationOptions
    });
};

/**
 * __useGetAllCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>(GetAllCategoriesDocument, baseOptions);
      }
export function useGetAllCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>(GetAllCategoriesDocument, baseOptions);
        }
export type GetAllCategoriesQueryHookResult = ReturnType<typeof useGetAllCategoriesQuery>;
export type GetAllCategoriesLazyQueryHookResult = ReturnType<typeof useGetAllCategoriesLazyQuery>;
export type GetAllCategoriesQueryResult = ApolloReactCommon.QueryResult<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>;
export const GetBrowsePageContentDocument = gql`
    query GetBrowsePageContent($today: timestamp, $categorySlug: String_comparison_exp, $tagFilters: books_bool_exp!, $booksOrderBy: [books_order_by!], $bookLimit: Int, $postLimit: Int, $eventLimit: Int, $offset: Int) {
  pages_by_pk(title: "browse") {
    content
  }
  categories(where: {slug: $categorySlug}) {
    description
  }
  books(
    where: {_and: [{category_books: {category: {slug: $categorySlug}}}, {is_unlisted: {_eq: false}}, $tagFilters]}
    order_by: $booksOrderBy
    limit: $bookLimit
    offset: $offset
  ) {
    ...BookCardData
  }
  books_aggregate(
    where: {_and: [{category_books: {category: {slug: $categorySlug}}}, $tagFilters]}
  ) {
    aggregate {
      count
    }
  }
  events(
    where: {_and: [{category_events: {category: {slug: $categorySlug}}}, {start_time: {_gte: $today}}]}
    order_by: {start_time: asc}
    limit: $eventLimit
    offset: $offset
  ) {
    ...EventCardData
  }
  events_aggregate(
    where: {_and: [{category_events: {category: {slug: $categorySlug}}}, {start_time: {_gte: $today}}]}
  ) {
    aggregate {
      count
    }
  }
  posts(
    where: {category_posts: {category: {slug: $categorySlug}}}
    order_by: {created_at: desc}
    limit: $postLimit
    offset: $offset
  ) {
    ...PostCardData
  }
  posts_aggregate(where: {category_posts: {category: {slug: $categorySlug}}}) {
    aggregate {
      count
    }
  }
}
    ${BookCardDataFragmentDoc}
${EventCardDataFragmentDoc}
${PostCardDataFragmentDoc}`;
export type GetBrowsePageContentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBrowsePageContentQuery, GetBrowsePageContentQueryVariables>, 'query'> & ({ variables: GetBrowsePageContentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetBrowsePageContentComponent = (props: GetBrowsePageContentComponentProps) => (
      <ApolloReactComponents.Query<GetBrowsePageContentQuery, GetBrowsePageContentQueryVariables> query={GetBrowsePageContentDocument} {...props} />
    );
    
export type GetBrowsePageContentProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBrowsePageContentQuery, GetBrowsePageContentQueryVariables>
    } & TChildProps;
export function withGetBrowsePageContent<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBrowsePageContentQuery,
  GetBrowsePageContentQueryVariables,
  GetBrowsePageContentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBrowsePageContentQuery, GetBrowsePageContentQueryVariables, GetBrowsePageContentProps<TChildProps, TDataName>>(GetBrowsePageContentDocument, {
      alias: 'getBrowsePageContent',
      ...operationOptions
    });
};

/**
 * __useGetBrowsePageContentQuery__
 *
 * To run a query within a React component, call `useGetBrowsePageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrowsePageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrowsePageContentQuery({
 *   variables: {
 *      today: // value for 'today'
 *      categorySlug: // value for 'categorySlug'
 *      tagFilters: // value for 'tagFilters'
 *      booksOrderBy: // value for 'booksOrderBy'
 *      bookLimit: // value for 'bookLimit'
 *      postLimit: // value for 'postLimit'
 *      eventLimit: // value for 'eventLimit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetBrowsePageContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBrowsePageContentQuery, GetBrowsePageContentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBrowsePageContentQuery, GetBrowsePageContentQueryVariables>(GetBrowsePageContentDocument, baseOptions);
      }
export function useGetBrowsePageContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBrowsePageContentQuery, GetBrowsePageContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBrowsePageContentQuery, GetBrowsePageContentQueryVariables>(GetBrowsePageContentDocument, baseOptions);
        }
export type GetBrowsePageContentQueryHookResult = ReturnType<typeof useGetBrowsePageContentQuery>;
export type GetBrowsePageContentLazyQueryHookResult = ReturnType<typeof useGetBrowsePageContentLazyQuery>;
export type GetBrowsePageContentQueryResult = ApolloReactCommon.QueryResult<GetBrowsePageContentQuery, GetBrowsePageContentQueryVariables>;
export const GetEventDocument = gql`
    query GetEvent($slug: String) {
  events(where: {_and: [{slug: {_eq: $slug}}, {is_cancelled: {_eq: false}}]}) {
    title
    slug
    id
    video
    start_time
    end_time
    location
    speakers
    seats
    price
    location
    is_festival
    is_online_only
    is_in_person_only
    is_book_club
    image
    free_seats
    enable_comments
    category_events {
      category {
        name
      }
    }
    event_books {
      book {
        ...BookCardData
      }
    }
    festival {
      ...EventCardData
      description
    }
    events(order_by: {start_time: asc}) {
      ...EventCardData
    }
    description
  }
}
    ${BookCardDataFragmentDoc}
${EventCardDataFragmentDoc}`;
export type GetEventComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetEventQuery, GetEventQueryVariables>, 'query'>;

    export const GetEventComponent = (props: GetEventComponentProps) => (
      <ApolloReactComponents.Query<GetEventQuery, GetEventQueryVariables> query={GetEventDocument} {...props} />
    );
    
export type GetEventProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventQuery, GetEventQueryVariables>
    } & TChildProps;
export function withGetEvent<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventQuery,
  GetEventQueryVariables,
  GetEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventQuery, GetEventQueryVariables, GetEventProps<TChildProps, TDataName>>(GetEventDocument, {
      alias: 'getEvent',
      ...operationOptions
    });
};

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, baseOptions);
      }
export function useGetEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, baseOptions);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = ApolloReactCommon.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const GetEventConfLocationDocument = gql`
    query GetEventConfLocation($id: uuid!) {
  events_by_pk(id: $id) {
    id
    video_conf_location
  }
}
    `;
export type GetEventConfLocationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetEventConfLocationQuery, GetEventConfLocationQueryVariables>, 'query'> & ({ variables: GetEventConfLocationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetEventConfLocationComponent = (props: GetEventConfLocationComponentProps) => (
      <ApolloReactComponents.Query<GetEventConfLocationQuery, GetEventConfLocationQueryVariables> query={GetEventConfLocationDocument} {...props} />
    );
    
export type GetEventConfLocationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEventConfLocationQuery, GetEventConfLocationQueryVariables>
    } & TChildProps;
export function withGetEventConfLocation<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEventConfLocationQuery,
  GetEventConfLocationQueryVariables,
  GetEventConfLocationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEventConfLocationQuery, GetEventConfLocationQueryVariables, GetEventConfLocationProps<TChildProps, TDataName>>(GetEventConfLocationDocument, {
      alias: 'getEventConfLocation',
      ...operationOptions
    });
};

/**
 * __useGetEventConfLocationQuery__
 *
 * To run a query within a React component, call `useGetEventConfLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventConfLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventConfLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventConfLocationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventConfLocationQuery, GetEventConfLocationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetEventConfLocationQuery, GetEventConfLocationQueryVariables>(GetEventConfLocationDocument, baseOptions);
      }
export function useGetEventConfLocationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventConfLocationQuery, GetEventConfLocationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetEventConfLocationQuery, GetEventConfLocationQueryVariables>(GetEventConfLocationDocument, baseOptions);
        }
export type GetEventConfLocationQueryHookResult = ReturnType<typeof useGetEventConfLocationQuery>;
export type GetEventConfLocationLazyQueryHookResult = ReturnType<typeof useGetEventConfLocationLazyQuery>;
export type GetEventConfLocationQueryResult = ApolloReactCommon.QueryResult<GetEventConfLocationQuery, GetEventConfLocationQueryVariables>;
export const GetAllUpcomingEventsDocument = gql`
    query GetAllUpcomingEvents($today: timestamp) {
  events(
    where: {_and: [{end_time: {_gte: $today}}, {is_cancelled: {_eq: false}}]}
    order_by: {start_time: asc}
  ) {
    event_books(limit: 1) {
      book {
        ...BookCardData
      }
    }
    end_time
    is_festival
    events {
      slug
      title
    }
    festival {
      event_books(limit: 1) {
        book {
          ...BookCardData
        }
      }
      end_time
      is_festival
      events {
        slug
        title
      }
      ...EventCardData
    }
    ...EventCardData
  }
}
    ${BookCardDataFragmentDoc}
${EventCardDataFragmentDoc}`;
export type GetAllUpcomingEventsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllUpcomingEventsQuery, GetAllUpcomingEventsQueryVariables>, 'query'>;

    export const GetAllUpcomingEventsComponent = (props: GetAllUpcomingEventsComponentProps) => (
      <ApolloReactComponents.Query<GetAllUpcomingEventsQuery, GetAllUpcomingEventsQueryVariables> query={GetAllUpcomingEventsDocument} {...props} />
    );
    
export type GetAllUpcomingEventsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllUpcomingEventsQuery, GetAllUpcomingEventsQueryVariables>
    } & TChildProps;
export function withGetAllUpcomingEvents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllUpcomingEventsQuery,
  GetAllUpcomingEventsQueryVariables,
  GetAllUpcomingEventsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllUpcomingEventsQuery, GetAllUpcomingEventsQueryVariables, GetAllUpcomingEventsProps<TChildProps, TDataName>>(GetAllUpcomingEventsDocument, {
      alias: 'getAllUpcomingEvents',
      ...operationOptions
    });
};

/**
 * __useGetAllUpcomingEventsQuery__
 *
 * To run a query within a React component, call `useGetAllUpcomingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUpcomingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUpcomingEventsQuery({
 *   variables: {
 *      today: // value for 'today'
 *   },
 * });
 */
export function useGetAllUpcomingEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllUpcomingEventsQuery, GetAllUpcomingEventsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllUpcomingEventsQuery, GetAllUpcomingEventsQueryVariables>(GetAllUpcomingEventsDocument, baseOptions);
      }
export function useGetAllUpcomingEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllUpcomingEventsQuery, GetAllUpcomingEventsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllUpcomingEventsQuery, GetAllUpcomingEventsQueryVariables>(GetAllUpcomingEventsDocument, baseOptions);
        }
export type GetAllUpcomingEventsQueryHookResult = ReturnType<typeof useGetAllUpcomingEventsQuery>;
export type GetAllUpcomingEventsLazyQueryHookResult = ReturnType<typeof useGetAllUpcomingEventsLazyQuery>;
export type GetAllUpcomingEventsQueryResult = ApolloReactCommon.QueryResult<GetAllUpcomingEventsQuery, GetAllUpcomingEventsQueryVariables>;
export const GetPastEventsDocument = gql`
    query GetPastEvents($today: timestamp) {
  events(
    where: {_and: [{end_time: {_lte: $today}}, {is_cancelled: {_eq: false}}]}
    order_by: {start_time: desc}
  ) {
    ...EventCardData
  }
}
    ${EventCardDataFragmentDoc}`;
export type GetPastEventsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPastEventsQuery, GetPastEventsQueryVariables>, 'query'>;

    export const GetPastEventsComponent = (props: GetPastEventsComponentProps) => (
      <ApolloReactComponents.Query<GetPastEventsQuery, GetPastEventsQueryVariables> query={GetPastEventsDocument} {...props} />
    );
    
export type GetPastEventsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPastEventsQuery, GetPastEventsQueryVariables>
    } & TChildProps;
export function withGetPastEvents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPastEventsQuery,
  GetPastEventsQueryVariables,
  GetPastEventsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPastEventsQuery, GetPastEventsQueryVariables, GetPastEventsProps<TChildProps, TDataName>>(GetPastEventsDocument, {
      alias: 'getPastEvents',
      ...operationOptions
    });
};

/**
 * __useGetPastEventsQuery__
 *
 * To run a query within a React component, call `useGetPastEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastEventsQuery({
 *   variables: {
 *      today: // value for 'today'
 *   },
 * });
 */
export function useGetPastEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPastEventsQuery, GetPastEventsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPastEventsQuery, GetPastEventsQueryVariables>(GetPastEventsDocument, baseOptions);
      }
export function useGetPastEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPastEventsQuery, GetPastEventsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPastEventsQuery, GetPastEventsQueryVariables>(GetPastEventsDocument, baseOptions);
        }
export type GetPastEventsQueryHookResult = ReturnType<typeof useGetPastEventsQuery>;
export type GetPastEventsLazyQueryHookResult = ReturnType<typeof useGetPastEventsLazyQuery>;
export type GetPastEventsQueryResult = ApolloReactCommon.QueryResult<GetPastEventsQuery, GetPastEventsQueryVariables>;
export const GetPreflightDataDocument = gql`
    query GetPreflightData {
  unstructured_data_by_pk(title: "preflight") {
    jitsiLink: data(path: "$.jitsiLink")
    videoStream: data(path: "$.videoStream")
  }
}
    `;
export type GetPreflightDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPreflightDataQuery, GetPreflightDataQueryVariables>, 'query'>;

    export const GetPreflightDataComponent = (props: GetPreflightDataComponentProps) => (
      <ApolloReactComponents.Query<GetPreflightDataQuery, GetPreflightDataQueryVariables> query={GetPreflightDataDocument} {...props} />
    );
    
export type GetPreflightDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPreflightDataQuery, GetPreflightDataQueryVariables>
    } & TChildProps;
export function withGetPreflightData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPreflightDataQuery,
  GetPreflightDataQueryVariables,
  GetPreflightDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPreflightDataQuery, GetPreflightDataQueryVariables, GetPreflightDataProps<TChildProps, TDataName>>(GetPreflightDataDocument, {
      alias: 'getPreflightData',
      ...operationOptions
    });
};

/**
 * __useGetPreflightDataQuery__
 *
 * To run a query within a React component, call `useGetPreflightDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreflightDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreflightDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreflightDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPreflightDataQuery, GetPreflightDataQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPreflightDataQuery, GetPreflightDataQueryVariables>(GetPreflightDataDocument, baseOptions);
      }
export function useGetPreflightDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPreflightDataQuery, GetPreflightDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPreflightDataQuery, GetPreflightDataQueryVariables>(GetPreflightDataDocument, baseOptions);
        }
export type GetPreflightDataQueryHookResult = ReturnType<typeof useGetPreflightDataQuery>;
export type GetPreflightDataLazyQueryHookResult = ReturnType<typeof useGetPreflightDataLazyQuery>;
export type GetPreflightDataQueryResult = ApolloReactCommon.QueryResult<GetPreflightDataQuery, GetPreflightDataQueryVariables>;
export const UpdatePreflightDataDocument = gql`
    mutation UpdatePreflightData($data: jsonb) {
  deleteJitsi: update_unstructured_data_by_pk(
    pk_columns: {title: "preflight"}
    _delete_key: {data: "jitsiLink"}
  ) {
    data
  }
  deleteVideo: update_unstructured_data_by_pk(
    pk_columns: {title: "preflight"}
    _delete_key: {data: "videoStream"}
  ) {
    data
  }
  update_unstructured_data_by_pk(
    pk_columns: {title: "preflight"}
    _append: {data: $data}
  ) {
    data
  }
}
    `;
export type UpdatePreflightDataMutationFn = ApolloReactCommon.MutationFunction<UpdatePreflightDataMutation, UpdatePreflightDataMutationVariables>;
export type UpdatePreflightDataComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdatePreflightDataMutation, UpdatePreflightDataMutationVariables>, 'mutation'>;

    export const UpdatePreflightDataComponent = (props: UpdatePreflightDataComponentProps) => (
      <ApolloReactComponents.Mutation<UpdatePreflightDataMutation, UpdatePreflightDataMutationVariables> mutation={UpdatePreflightDataDocument} {...props} />
    );
    
export type UpdatePreflightDataProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdatePreflightDataMutation, UpdatePreflightDataMutationVariables>
    } & TChildProps;
export function withUpdatePreflightData<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdatePreflightDataMutation,
  UpdatePreflightDataMutationVariables,
  UpdatePreflightDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdatePreflightDataMutation, UpdatePreflightDataMutationVariables, UpdatePreflightDataProps<TChildProps, TDataName>>(UpdatePreflightDataDocument, {
      alias: 'updatePreflightData',
      ...operationOptions
    });
};

/**
 * __useUpdatePreflightDataMutation__
 *
 * To run a mutation, you first call `useUpdatePreflightDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreflightDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreflightDataMutation, { data, loading, error }] = useUpdatePreflightDataMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePreflightDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePreflightDataMutation, UpdatePreflightDataMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePreflightDataMutation, UpdatePreflightDataMutationVariables>(UpdatePreflightDataDocument, baseOptions);
      }
export type UpdatePreflightDataMutationHookResult = ReturnType<typeof useUpdatePreflightDataMutation>;
export type UpdatePreflightDataMutationResult = ApolloReactCommon.MutationResult<UpdatePreflightDataMutation>;
export type UpdatePreflightDataMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePreflightDataMutation, UpdatePreflightDataMutationVariables>;
export const HomePageContentDocument = gql`
    query HomePageContent($books: [bigint!], $now: timestamp, $posts: [uuid!], $events: [uuid!]) {
  books(where: {isbn: {_in: $books}}, limit: 8) {
    ...BookCardData
  }
  posts(where: {id: {_in: $posts}}, limit: 4, order_by: {created_at: desc}) {
    ...PostCardData
  }
  upcomingEvents: events(
    where: {_and: [{end_time: {_gte: $now}}, {is_cancelled: {_eq: false}}]}
    limit: 2
    order_by: {start_time: asc}
  ) {
    ...EventCardData
  }
  pastEvents: events(
    where: {_and: [{id: {_in: $events}}, {is_cancelled: {_eq: false}}]}
    limit: 1
  ) {
    ...EventCardData
  }
}
    ${BookCardDataFragmentDoc}
${PostCardDataFragmentDoc}
${EventCardDataFragmentDoc}`;
export type HomePageContentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HomePageContentQuery, HomePageContentQueryVariables>, 'query'>;

    export const HomePageContentComponent = (props: HomePageContentComponentProps) => (
      <ApolloReactComponents.Query<HomePageContentQuery, HomePageContentQueryVariables> query={HomePageContentDocument} {...props} />
    );
    
export type HomePageContentProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<HomePageContentQuery, HomePageContentQueryVariables>
    } & TChildProps;
export function withHomePageContent<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HomePageContentQuery,
  HomePageContentQueryVariables,
  HomePageContentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, HomePageContentQuery, HomePageContentQueryVariables, HomePageContentProps<TChildProps, TDataName>>(HomePageContentDocument, {
      alias: 'homePageContent',
      ...operationOptions
    });
};

/**
 * __useHomePageContentQuery__
 *
 * To run a query within a React component, call `useHomePageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageContentQuery({
 *   variables: {
 *      books: // value for 'books'
 *      now: // value for 'now'
 *      posts: // value for 'posts'
 *      events: // value for 'events'
 *   },
 * });
 */
export function useHomePageContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HomePageContentQuery, HomePageContentQueryVariables>) {
        return ApolloReactHooks.useQuery<HomePageContentQuery, HomePageContentQueryVariables>(HomePageContentDocument, baseOptions);
      }
export function useHomePageContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomePageContentQuery, HomePageContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HomePageContentQuery, HomePageContentQueryVariables>(HomePageContentDocument, baseOptions);
        }
export type HomePageContentQueryHookResult = ReturnType<typeof useHomePageContentQuery>;
export type HomePageContentLazyQueryHookResult = ReturnType<typeof useHomePageContentLazyQuery>;
export type HomePageContentQueryResult = ApolloReactCommon.QueryResult<HomePageContentQuery, HomePageContentQueryVariables>;
export const GetPostDocument = gql`
    query GetPost($slug: String!) {
  posts(where: {_and: [{slug: {_eq: $slug}}]}) {
    id
    title
    created_at
    slug
    author {
      id
      name
    }
    category_posts {
      category {
        name
        slug
      }
    }
    post_books(
      order_by: {rank_order: asc}
      where: {book: {is_unlisted: {_eq: false}}}
    ) {
      book {
        ...BookCardData
      }
    }
    image
    content
    type
  }
}
    ${BookCardDataFragmentDoc}`;
export type GetPostComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPostQuery, GetPostQueryVariables>, 'query'> & ({ variables: GetPostQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPostComponent = (props: GetPostComponentProps) => (
      <ApolloReactComponents.Query<GetPostQuery, GetPostQueryVariables> query={GetPostDocument} {...props} />
    );
    
export type GetPostProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPostQuery, GetPostQueryVariables>
    } & TChildProps;
export function withGetPost<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPostQuery,
  GetPostQueryVariables,
  GetPostProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPostQuery, GetPostQueryVariables, GetPostProps<TChildProps, TDataName>>(GetPostDocument, {
      alias: 'getPost',
      ...operationOptions
    });
};

/**
 * __useGetPostQuery__
 *
 * To run a query within a React component, call `useGetPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetPostQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, baseOptions);
      }
export function useGetPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, baseOptions);
        }
export type GetPostQueryHookResult = ReturnType<typeof useGetPostQuery>;
export type GetPostLazyQueryHookResult = ReturnType<typeof useGetPostLazyQuery>;
export type GetPostQueryResult = ApolloReactCommon.QueryResult<GetPostQuery, GetPostQueryVariables>;
export const GetFiveRecentPostsDocument = gql`
    query GetFiveRecentPosts {
  posts(limit: 5, order_by: {created_at: desc}) {
    slug
    title
    type
    created_at
    author {
      name
    }
  }
}
    `;
export type GetFiveRecentPostsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFiveRecentPostsQuery, GetFiveRecentPostsQueryVariables>, 'query'>;

    export const GetFiveRecentPostsComponent = (props: GetFiveRecentPostsComponentProps) => (
      <ApolloReactComponents.Query<GetFiveRecentPostsQuery, GetFiveRecentPostsQueryVariables> query={GetFiveRecentPostsDocument} {...props} />
    );
    
export type GetFiveRecentPostsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFiveRecentPostsQuery, GetFiveRecentPostsQueryVariables>
    } & TChildProps;
export function withGetFiveRecentPosts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFiveRecentPostsQuery,
  GetFiveRecentPostsQueryVariables,
  GetFiveRecentPostsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFiveRecentPostsQuery, GetFiveRecentPostsQueryVariables, GetFiveRecentPostsProps<TChildProps, TDataName>>(GetFiveRecentPostsDocument, {
      alias: 'getFiveRecentPosts',
      ...operationOptions
    });
};

/**
 * __useGetFiveRecentPostsQuery__
 *
 * To run a query within a React component, call `useGetFiveRecentPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiveRecentPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiveRecentPostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFiveRecentPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFiveRecentPostsQuery, GetFiveRecentPostsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFiveRecentPostsQuery, GetFiveRecentPostsQueryVariables>(GetFiveRecentPostsDocument, baseOptions);
      }
export function useGetFiveRecentPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFiveRecentPostsQuery, GetFiveRecentPostsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFiveRecentPostsQuery, GetFiveRecentPostsQueryVariables>(GetFiveRecentPostsDocument, baseOptions);
        }
export type GetFiveRecentPostsQueryHookResult = ReturnType<typeof useGetFiveRecentPostsQuery>;
export type GetFiveRecentPostsLazyQueryHookResult = ReturnType<typeof useGetFiveRecentPostsLazyQuery>;
export type GetFiveRecentPostsQueryResult = ApolloReactCommon.QueryResult<GetFiveRecentPostsQuery, GetFiveRecentPostsQueryVariables>;
export const GetLinkedBooksDocument = gql`
    query GetLinkedBooks($isbns: [bigint!]!) {
  books(where: {_and: [{isbn: {_in: $isbns}}, {is_unlisted: {_eq: false}}]}) {
    ...BookCardData
  }
}
    ${BookCardDataFragmentDoc}`;
export type GetLinkedBooksComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetLinkedBooksQuery, GetLinkedBooksQueryVariables>, 'query'> & ({ variables: GetLinkedBooksQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetLinkedBooksComponent = (props: GetLinkedBooksComponentProps) => (
      <ApolloReactComponents.Query<GetLinkedBooksQuery, GetLinkedBooksQueryVariables> query={GetLinkedBooksDocument} {...props} />
    );
    
export type GetLinkedBooksProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetLinkedBooksQuery, GetLinkedBooksQueryVariables>
    } & TChildProps;
export function withGetLinkedBooks<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetLinkedBooksQuery,
  GetLinkedBooksQueryVariables,
  GetLinkedBooksProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetLinkedBooksQuery, GetLinkedBooksQueryVariables, GetLinkedBooksProps<TChildProps, TDataName>>(GetLinkedBooksDocument, {
      alias: 'getLinkedBooks',
      ...operationOptions
    });
};

/**
 * __useGetLinkedBooksQuery__
 *
 * To run a query within a React component, call `useGetLinkedBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedBooksQuery({
 *   variables: {
 *      isbns: // value for 'isbns'
 *   },
 * });
 */
export function useGetLinkedBooksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLinkedBooksQuery, GetLinkedBooksQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLinkedBooksQuery, GetLinkedBooksQueryVariables>(GetLinkedBooksDocument, baseOptions);
      }
export function useGetLinkedBooksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLinkedBooksQuery, GetLinkedBooksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLinkedBooksQuery, GetLinkedBooksQueryVariables>(GetLinkedBooksDocument, baseOptions);
        }
export type GetLinkedBooksQueryHookResult = ReturnType<typeof useGetLinkedBooksQuery>;
export type GetLinkedBooksLazyQueryHookResult = ReturnType<typeof useGetLinkedBooksLazyQuery>;
export type GetLinkedBooksQueryResult = ApolloReactCommon.QueryResult<GetLinkedBooksQuery, GetLinkedBooksQueryVariables>;
export const GetAllArticlesDocument = gql`
    query GetAllArticles($filters: posts_bool_exp, $offset: Int!, $limit: Int) {
  posts(
    where: $filters
    limit: $limit
    offset: $offset
    order_by: {created_at: desc}
  ) {
    ...PostCardData
  }
  posts_aggregate(where: $filters) {
    aggregate {
      count
    }
  }
}
    ${PostCardDataFragmentDoc}`;
export type GetAllArticlesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllArticlesQuery, GetAllArticlesQueryVariables>, 'query'> & ({ variables: GetAllArticlesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAllArticlesComponent = (props: GetAllArticlesComponentProps) => (
      <ApolloReactComponents.Query<GetAllArticlesQuery, GetAllArticlesQueryVariables> query={GetAllArticlesDocument} {...props} />
    );
    
export type GetAllArticlesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllArticlesQuery, GetAllArticlesQueryVariables>
    } & TChildProps;
export function withGetAllArticles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllArticlesQuery,
  GetAllArticlesQueryVariables,
  GetAllArticlesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllArticlesQuery, GetAllArticlesQueryVariables, GetAllArticlesProps<TChildProps, TDataName>>(GetAllArticlesDocument, {
      alias: 'getAllArticles',
      ...operationOptions
    });
};

/**
 * __useGetAllArticlesQuery__
 *
 * To run a query within a React component, call `useGetAllArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllArticlesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllArticlesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllArticlesQuery, GetAllArticlesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllArticlesQuery, GetAllArticlesQueryVariables>(GetAllArticlesDocument, baseOptions);
      }
export function useGetAllArticlesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllArticlesQuery, GetAllArticlesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllArticlesQuery, GetAllArticlesQueryVariables>(GetAllArticlesDocument, baseOptions);
        }
export type GetAllArticlesQueryHookResult = ReturnType<typeof useGetAllArticlesQuery>;
export type GetAllArticlesLazyQueryHookResult = ReturnType<typeof useGetAllArticlesLazyQuery>;
export type GetAllArticlesQueryResult = ApolloReactCommon.QueryResult<GetAllArticlesQuery, GetAllArticlesQueryVariables>;
export const SiteSearchDocument = gql`
    query SiteSearch($search: String!, $bookLimit: Int!, $postLimit: Int!, $eventLimit: Int!, $productLimit: Int!, $subLimit: Int!, $offset: Int!) {
  search_books_aggregate(args: {search: $search}) {
    aggregate {
      count
    }
  }
  search_books(
    args: {search: $search}
    where: {_and: [{is_unlisted: {_eq: false}}]}
    limit: $bookLimit
    offset: $offset
  ) {
    ...BookCardData
  }
  search_posts_aggregate(args: {search: $search}) {
    aggregate {
      count
    }
  }
  search_posts(args: {search: $search}, limit: $postLimit, offset: $offset) {
    ...PostCardData
  }
  search_events_aggregate(args: {search: $search}) {
    aggregate {
      count
    }
  }
  search_events(args: {search: $search}, limit: $eventLimit, offset: $offset) {
    ...EventCardData
  }
  search_products_aggregate(
    args: {search: $search}
    where: {is_deleted: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
  search_products(
    args: {search: $search}
    where: {is_deleted: {_eq: false}}
    limit: $productLimit
    offset: $offset
  ) {
    ...ProductCardData
  }
  search_subscriptions_aggregate(
    args: {search: $search}
    where: {is_active: {_eq: true}}
    limit: $subLimit
    offset: $offset
  ) {
    aggregate {
      count
    }
  }
  search_subscriptions(
    args: {search: $search}
    where: {is_active: {_eq: true}}
    limit: $subLimit
    offset: $offset
  ) {
    ...SubCardData
  }
}
    ${BookCardDataFragmentDoc}
${PostCardDataFragmentDoc}
${EventCardDataFragmentDoc}
${ProductCardDataFragmentDoc}
${SubCardDataFragmentDoc}`;
export type SiteSearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SiteSearchQuery, SiteSearchQueryVariables>, 'query'> & ({ variables: SiteSearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SiteSearchComponent = (props: SiteSearchComponentProps) => (
      <ApolloReactComponents.Query<SiteSearchQuery, SiteSearchQueryVariables> query={SiteSearchDocument} {...props} />
    );
    
export type SiteSearchProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SiteSearchQuery, SiteSearchQueryVariables>
    } & TChildProps;
export function withSiteSearch<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SiteSearchQuery,
  SiteSearchQueryVariables,
  SiteSearchProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SiteSearchQuery, SiteSearchQueryVariables, SiteSearchProps<TChildProps, TDataName>>(SiteSearchDocument, {
      alias: 'siteSearch',
      ...operationOptions
    });
};

/**
 * __useSiteSearchQuery__
 *
 * To run a query within a React component, call `useSiteSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      bookLimit: // value for 'bookLimit'
 *      postLimit: // value for 'postLimit'
 *      eventLimit: // value for 'eventLimit'
 *      productLimit: // value for 'productLimit'
 *      subLimit: // value for 'subLimit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSiteSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SiteSearchQuery, SiteSearchQueryVariables>) {
        return ApolloReactHooks.useQuery<SiteSearchQuery, SiteSearchQueryVariables>(SiteSearchDocument, baseOptions);
      }
export function useSiteSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteSearchQuery, SiteSearchQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SiteSearchQuery, SiteSearchQueryVariables>(SiteSearchDocument, baseOptions);
        }
export type SiteSearchQueryHookResult = ReturnType<typeof useSiteSearchQuery>;
export type SiteSearchLazyQueryHookResult = ReturnType<typeof useSiteSearchLazyQuery>;
export type SiteSearchQueryResult = ApolloReactCommon.QueryResult<SiteSearchQuery, SiteSearchQueryVariables>;
export const LogNoResultSearchDocument = gql`
    mutation LogNoResultSearch($text: String!) {
  insert_empty_searches_one(object: {string: $text}) {
    id
  }
}
    `;
export type LogNoResultSearchMutationFn = ApolloReactCommon.MutationFunction<LogNoResultSearchMutation, LogNoResultSearchMutationVariables>;
export type LogNoResultSearchComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<LogNoResultSearchMutation, LogNoResultSearchMutationVariables>, 'mutation'>;

    export const LogNoResultSearchComponent = (props: LogNoResultSearchComponentProps) => (
      <ApolloReactComponents.Mutation<LogNoResultSearchMutation, LogNoResultSearchMutationVariables> mutation={LogNoResultSearchDocument} {...props} />
    );
    
export type LogNoResultSearchProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<LogNoResultSearchMutation, LogNoResultSearchMutationVariables>
    } & TChildProps;
export function withLogNoResultSearch<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LogNoResultSearchMutation,
  LogNoResultSearchMutationVariables,
  LogNoResultSearchProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, LogNoResultSearchMutation, LogNoResultSearchMutationVariables, LogNoResultSearchProps<TChildProps, TDataName>>(LogNoResultSearchDocument, {
      alias: 'logNoResultSearch',
      ...operationOptions
    });
};

/**
 * __useLogNoResultSearchMutation__
 *
 * To run a mutation, you first call `useLogNoResultSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogNoResultSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logNoResultSearchMutation, { data, loading, error }] = useLogNoResultSearchMutation({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useLogNoResultSearchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogNoResultSearchMutation, LogNoResultSearchMutationVariables>) {
        return ApolloReactHooks.useMutation<LogNoResultSearchMutation, LogNoResultSearchMutationVariables>(LogNoResultSearchDocument, baseOptions);
      }
export type LogNoResultSearchMutationHookResult = ReturnType<typeof useLogNoResultSearchMutation>;
export type LogNoResultSearchMutationResult = ApolloReactCommon.MutationResult<LogNoResultSearchMutation>;
export type LogNoResultSearchMutationOptions = ApolloReactCommon.BaseMutationOptions<LogNoResultSearchMutation, LogNoResultSearchMutationVariables>;
export const GetProductDocument = gql`
    query GetProduct($slug: String!) {
  products(where: {_and: [{slug: {_eq: $slug}}, {is_deleted: {_eq: false}}]}) {
    description
    ...ProductCardData
  }
}
    ${ProductCardDataFragmentDoc}`;
export type GetProductComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductQuery, GetProductQueryVariables>, 'query'> & ({ variables: GetProductQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProductComponent = (props: GetProductComponentProps) => (
      <ApolloReactComponents.Query<GetProductQuery, GetProductQueryVariables> query={GetProductDocument} {...props} />
    );
    
export type GetProductProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetProductQuery, GetProductQueryVariables>
    } & TChildProps;
export function withGetProduct<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetProductQuery,
  GetProductQueryVariables,
  GetProductProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetProductQuery, GetProductQueryVariables, GetProductProps<TChildProps, TDataName>>(GetProductDocument, {
      alias: 'getProduct',
      ...operationOptions
    });
};

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, baseOptions);
      }
export function useGetProductLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, baseOptions);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = ApolloReactCommon.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const AddCreditToSubObjectDocument = gql`
    mutation AddCreditToSubObject($subObjectId: uuid!) {
  insert_subscription_object_credit_one(
    object: {subscription_object_id: $subObjectId}
  ) {
    id
  }
}
    `;
export type AddCreditToSubObjectMutationFn = ApolloReactCommon.MutationFunction<AddCreditToSubObjectMutation, AddCreditToSubObjectMutationVariables>;
export type AddCreditToSubObjectComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddCreditToSubObjectMutation, AddCreditToSubObjectMutationVariables>, 'mutation'>;

    export const AddCreditToSubObjectComponent = (props: AddCreditToSubObjectComponentProps) => (
      <ApolloReactComponents.Mutation<AddCreditToSubObjectMutation, AddCreditToSubObjectMutationVariables> mutation={AddCreditToSubObjectDocument} {...props} />
    );
    
export type AddCreditToSubObjectProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddCreditToSubObjectMutation, AddCreditToSubObjectMutationVariables>
    } & TChildProps;
export function withAddCreditToSubObject<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddCreditToSubObjectMutation,
  AddCreditToSubObjectMutationVariables,
  AddCreditToSubObjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddCreditToSubObjectMutation, AddCreditToSubObjectMutationVariables, AddCreditToSubObjectProps<TChildProps, TDataName>>(AddCreditToSubObjectDocument, {
      alias: 'addCreditToSubObject',
      ...operationOptions
    });
};

/**
 * __useAddCreditToSubObjectMutation__
 *
 * To run a mutation, you first call `useAddCreditToSubObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreditToSubObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreditToSubObjectMutation, { data, loading, error }] = useAddCreditToSubObjectMutation({
 *   variables: {
 *      subObjectId: // value for 'subObjectId'
 *   },
 * });
 */
export function useAddCreditToSubObjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddCreditToSubObjectMutation, AddCreditToSubObjectMutationVariables>) {
        return ApolloReactHooks.useMutation<AddCreditToSubObjectMutation, AddCreditToSubObjectMutationVariables>(AddCreditToSubObjectDocument, baseOptions);
      }
export type AddCreditToSubObjectMutationHookResult = ReturnType<typeof useAddCreditToSubObjectMutation>;
export type AddCreditToSubObjectMutationResult = ApolloReactCommon.MutationResult<AddCreditToSubObjectMutation>;
export type AddCreditToSubObjectMutationOptions = ApolloReactCommon.BaseMutationOptions<AddCreditToSubObjectMutation, AddCreditToSubObjectMutationVariables>;
export const CreateDraftSubObjectsDocument = gql`
    mutation CreateDraftSubObjects($objects: [subscription_draft_object_insert_input!]!) {
  insert_subscription_draft_object(objects: $objects) {
    returning {
      credits
      id
      recipient
      subscription {
        id
        price
        title
      }
    }
  }
}
    `;
export type CreateDraftSubObjectsMutationFn = ApolloReactCommon.MutationFunction<CreateDraftSubObjectsMutation, CreateDraftSubObjectsMutationVariables>;
export type CreateDraftSubObjectsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDraftSubObjectsMutation, CreateDraftSubObjectsMutationVariables>, 'mutation'>;

    export const CreateDraftSubObjectsComponent = (props: CreateDraftSubObjectsComponentProps) => (
      <ApolloReactComponents.Mutation<CreateDraftSubObjectsMutation, CreateDraftSubObjectsMutationVariables> mutation={CreateDraftSubObjectsDocument} {...props} />
    );
    
export type CreateDraftSubObjectsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateDraftSubObjectsMutation, CreateDraftSubObjectsMutationVariables>
    } & TChildProps;
export function withCreateDraftSubObjects<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateDraftSubObjectsMutation,
  CreateDraftSubObjectsMutationVariables,
  CreateDraftSubObjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateDraftSubObjectsMutation, CreateDraftSubObjectsMutationVariables, CreateDraftSubObjectsProps<TChildProps, TDataName>>(CreateDraftSubObjectsDocument, {
      alias: 'createDraftSubObjects',
      ...operationOptions
    });
};

/**
 * __useCreateDraftSubObjectsMutation__
 *
 * To run a mutation, you first call `useCreateDraftSubObjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftSubObjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftSubObjectsMutation, { data, loading, error }] = useCreateDraftSubObjectsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useCreateDraftSubObjectsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDraftSubObjectsMutation, CreateDraftSubObjectsMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDraftSubObjectsMutation, CreateDraftSubObjectsMutationVariables>(CreateDraftSubObjectsDocument, baseOptions);
      }
export type CreateDraftSubObjectsMutationHookResult = ReturnType<typeof useCreateDraftSubObjectsMutation>;
export type CreateDraftSubObjectsMutationResult = ApolloReactCommon.MutationResult<CreateDraftSubObjectsMutation>;
export type CreateDraftSubObjectsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDraftSubObjectsMutation, CreateDraftSubObjectsMutationVariables>;
export const CreateSubscriptionObjectDocument = gql`
    mutation CreateSubscriptionObject($data: subscription_object_insert_input!) {
  insert_subscription_object_one(object: $data) {
    id
    account_id
    address_id
    account_id
    subscription_id
    short_id
    password
    recipient
    subscription {
      title
      price
    }
  }
}
    `;
export type CreateSubscriptionObjectMutationFn = ApolloReactCommon.MutationFunction<CreateSubscriptionObjectMutation, CreateSubscriptionObjectMutationVariables>;
export type CreateSubscriptionObjectComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSubscriptionObjectMutation, CreateSubscriptionObjectMutationVariables>, 'mutation'>;

    export const CreateSubscriptionObjectComponent = (props: CreateSubscriptionObjectComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSubscriptionObjectMutation, CreateSubscriptionObjectMutationVariables> mutation={CreateSubscriptionObjectDocument} {...props} />
    );
    
export type CreateSubscriptionObjectProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateSubscriptionObjectMutation, CreateSubscriptionObjectMutationVariables>
    } & TChildProps;
export function withCreateSubscriptionObject<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSubscriptionObjectMutation,
  CreateSubscriptionObjectMutationVariables,
  CreateSubscriptionObjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSubscriptionObjectMutation, CreateSubscriptionObjectMutationVariables, CreateSubscriptionObjectProps<TChildProps, TDataName>>(CreateSubscriptionObjectDocument, {
      alias: 'createSubscriptionObject',
      ...operationOptions
    });
};

/**
 * __useCreateSubscriptionObjectMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionObjectMutation, { data, loading, error }] = useCreateSubscriptionObjectMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSubscriptionObjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSubscriptionObjectMutation, CreateSubscriptionObjectMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSubscriptionObjectMutation, CreateSubscriptionObjectMutationVariables>(CreateSubscriptionObjectDocument, baseOptions);
      }
export type CreateSubscriptionObjectMutationHookResult = ReturnType<typeof useCreateSubscriptionObjectMutation>;
export type CreateSubscriptionObjectMutationResult = ApolloReactCommon.MutationResult<CreateSubscriptionObjectMutation>;
export type CreateSubscriptionObjectMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSubscriptionObjectMutation, CreateSubscriptionObjectMutationVariables>;
export const GetDraftSubscriptionObjectDocument = gql`
    query GetDraftSubscriptionObject($id: uuid!) {
  subscription_draft_object_by_pk(id: $id) {
    id
    account_id
    address_id
    address {
      name
      contact_email
    }
    subscription_id
    recipient
  }
}
    `;
export type GetDraftSubscriptionObjectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDraftSubscriptionObjectQuery, GetDraftSubscriptionObjectQueryVariables>, 'query'> & ({ variables: GetDraftSubscriptionObjectQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDraftSubscriptionObjectComponent = (props: GetDraftSubscriptionObjectComponentProps) => (
      <ApolloReactComponents.Query<GetDraftSubscriptionObjectQuery, GetDraftSubscriptionObjectQueryVariables> query={GetDraftSubscriptionObjectDocument} {...props} />
    );
    
export type GetDraftSubscriptionObjectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDraftSubscriptionObjectQuery, GetDraftSubscriptionObjectQueryVariables>
    } & TChildProps;
export function withGetDraftSubscriptionObject<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDraftSubscriptionObjectQuery,
  GetDraftSubscriptionObjectQueryVariables,
  GetDraftSubscriptionObjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDraftSubscriptionObjectQuery, GetDraftSubscriptionObjectQueryVariables, GetDraftSubscriptionObjectProps<TChildProps, TDataName>>(GetDraftSubscriptionObjectDocument, {
      alias: 'getDraftSubscriptionObject',
      ...operationOptions
    });
};

/**
 * __useGetDraftSubscriptionObjectQuery__
 *
 * To run a query within a React component, call `useGetDraftSubscriptionObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftSubscriptionObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftSubscriptionObjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDraftSubscriptionObjectQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDraftSubscriptionObjectQuery, GetDraftSubscriptionObjectQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDraftSubscriptionObjectQuery, GetDraftSubscriptionObjectQueryVariables>(GetDraftSubscriptionObjectDocument, baseOptions);
      }
export function useGetDraftSubscriptionObjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDraftSubscriptionObjectQuery, GetDraftSubscriptionObjectQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDraftSubscriptionObjectQuery, GetDraftSubscriptionObjectQueryVariables>(GetDraftSubscriptionObjectDocument, baseOptions);
        }
export type GetDraftSubscriptionObjectQueryHookResult = ReturnType<typeof useGetDraftSubscriptionObjectQuery>;
export type GetDraftSubscriptionObjectLazyQueryHookResult = ReturnType<typeof useGetDraftSubscriptionObjectLazyQuery>;
export type GetDraftSubscriptionObjectQueryResult = ApolloReactCommon.QueryResult<GetDraftSubscriptionObjectQuery, GetDraftSubscriptionObjectQueryVariables>;
export const GetOrderForIdempotencyCheckDocument = gql`
    query GetOrderForIdempotencyCheck($id: Int!) {
  orders_by_pk(id: $id) {
    id
    status
    stripe_payment_id
    custom_line_title
    order_books_aggregate {
      aggregate {
        count
      }
    }
    order_products_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;
export type GetOrderForIdempotencyCheckComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOrderForIdempotencyCheckQuery, GetOrderForIdempotencyCheckQueryVariables>, 'query'> & ({ variables: GetOrderForIdempotencyCheckQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetOrderForIdempotencyCheckComponent = (props: GetOrderForIdempotencyCheckComponentProps) => (
      <ApolloReactComponents.Query<GetOrderForIdempotencyCheckQuery, GetOrderForIdempotencyCheckQueryVariables> query={GetOrderForIdempotencyCheckDocument} {...props} />
    );
    
export type GetOrderForIdempotencyCheckProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetOrderForIdempotencyCheckQuery, GetOrderForIdempotencyCheckQueryVariables>
    } & TChildProps;
export function withGetOrderForIdempotencyCheck<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOrderForIdempotencyCheckQuery,
  GetOrderForIdempotencyCheckQueryVariables,
  GetOrderForIdempotencyCheckProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetOrderForIdempotencyCheckQuery, GetOrderForIdempotencyCheckQueryVariables, GetOrderForIdempotencyCheckProps<TChildProps, TDataName>>(GetOrderForIdempotencyCheckDocument, {
      alias: 'getOrderForIdempotencyCheck',
      ...operationOptions
    });
};

/**
 * __useGetOrderForIdempotencyCheckQuery__
 *
 * To run a query within a React component, call `useGetOrderForIdempotencyCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderForIdempotencyCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderForIdempotencyCheckQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderForIdempotencyCheckQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrderForIdempotencyCheckQuery, GetOrderForIdempotencyCheckQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOrderForIdempotencyCheckQuery, GetOrderForIdempotencyCheckQueryVariables>(GetOrderForIdempotencyCheckDocument, baseOptions);
      }
export function useGetOrderForIdempotencyCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderForIdempotencyCheckQuery, GetOrderForIdempotencyCheckQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOrderForIdempotencyCheckQuery, GetOrderForIdempotencyCheckQueryVariables>(GetOrderForIdempotencyCheckDocument, baseOptions);
        }
export type GetOrderForIdempotencyCheckQueryHookResult = ReturnType<typeof useGetOrderForIdempotencyCheckQuery>;
export type GetOrderForIdempotencyCheckLazyQueryHookResult = ReturnType<typeof useGetOrderForIdempotencyCheckLazyQuery>;
export type GetOrderForIdempotencyCheckQueryResult = ApolloReactCommon.QueryResult<GetOrderForIdempotencyCheckQuery, GetOrderForIdempotencyCheckQueryVariables>;
export const GetSubscriptionObjectByStripeSubIdDocument = gql`
    query GetSubscriptionObjectByStripeSubId($stripeSubId: String!) {
  subscription_object(where: {stripe_sub_id: {_eq: $stripeSubId}}) {
    id
  }
}
    `;
export type GetSubscriptionObjectByStripeSubIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubscriptionObjectByStripeSubIdQuery, GetSubscriptionObjectByStripeSubIdQueryVariables>, 'query'> & ({ variables: GetSubscriptionObjectByStripeSubIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubscriptionObjectByStripeSubIdComponent = (props: GetSubscriptionObjectByStripeSubIdComponentProps) => (
      <ApolloReactComponents.Query<GetSubscriptionObjectByStripeSubIdQuery, GetSubscriptionObjectByStripeSubIdQueryVariables> query={GetSubscriptionObjectByStripeSubIdDocument} {...props} />
    );
    
export type GetSubscriptionObjectByStripeSubIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSubscriptionObjectByStripeSubIdQuery, GetSubscriptionObjectByStripeSubIdQueryVariables>
    } & TChildProps;
export function withGetSubscriptionObjectByStripeSubId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSubscriptionObjectByStripeSubIdQuery,
  GetSubscriptionObjectByStripeSubIdQueryVariables,
  GetSubscriptionObjectByStripeSubIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSubscriptionObjectByStripeSubIdQuery, GetSubscriptionObjectByStripeSubIdQueryVariables, GetSubscriptionObjectByStripeSubIdProps<TChildProps, TDataName>>(GetSubscriptionObjectByStripeSubIdDocument, {
      alias: 'getSubscriptionObjectByStripeSubId',
      ...operationOptions
    });
};

/**
 * __useGetSubscriptionObjectByStripeSubIdQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionObjectByStripeSubIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionObjectByStripeSubIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionObjectByStripeSubIdQuery({
 *   variables: {
 *      stripeSubId: // value for 'stripeSubId'
 *   },
 * });
 */
export function useGetSubscriptionObjectByStripeSubIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubscriptionObjectByStripeSubIdQuery, GetSubscriptionObjectByStripeSubIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubscriptionObjectByStripeSubIdQuery, GetSubscriptionObjectByStripeSubIdQueryVariables>(GetSubscriptionObjectByStripeSubIdDocument, baseOptions);
      }
export function useGetSubscriptionObjectByStripeSubIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubscriptionObjectByStripeSubIdQuery, GetSubscriptionObjectByStripeSubIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubscriptionObjectByStripeSubIdQuery, GetSubscriptionObjectByStripeSubIdQueryVariables>(GetSubscriptionObjectByStripeSubIdDocument, baseOptions);
        }
export type GetSubscriptionObjectByStripeSubIdQueryHookResult = ReturnType<typeof useGetSubscriptionObjectByStripeSubIdQuery>;
export type GetSubscriptionObjectByStripeSubIdLazyQueryHookResult = ReturnType<typeof useGetSubscriptionObjectByStripeSubIdLazyQuery>;
export type GetSubscriptionObjectByStripeSubIdQueryResult = ApolloReactCommon.QueryResult<GetSubscriptionObjectByStripeSubIdQuery, GetSubscriptionObjectByStripeSubIdQueryVariables>;
export const UpdateAccountStripeCustomerIdDocument = gql`
    mutation UpdateAccountStripeCustomerId($stripe_customer_id: String!, $id: uuid!) {
  update_accounts_by_pk(
    pk_columns: {id: $id}
    _set: {stripe_customer_id: $stripe_customer_id}
  ) {
    id
  }
}
    `;
export type UpdateAccountStripeCustomerIdMutationFn = ApolloReactCommon.MutationFunction<UpdateAccountStripeCustomerIdMutation, UpdateAccountStripeCustomerIdMutationVariables>;
export type UpdateAccountStripeCustomerIdComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAccountStripeCustomerIdMutation, UpdateAccountStripeCustomerIdMutationVariables>, 'mutation'>;

    export const UpdateAccountStripeCustomerIdComponent = (props: UpdateAccountStripeCustomerIdComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAccountStripeCustomerIdMutation, UpdateAccountStripeCustomerIdMutationVariables> mutation={UpdateAccountStripeCustomerIdDocument} {...props} />
    );
    
export type UpdateAccountStripeCustomerIdProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateAccountStripeCustomerIdMutation, UpdateAccountStripeCustomerIdMutationVariables>
    } & TChildProps;
export function withUpdateAccountStripeCustomerId<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAccountStripeCustomerIdMutation,
  UpdateAccountStripeCustomerIdMutationVariables,
  UpdateAccountStripeCustomerIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAccountStripeCustomerIdMutation, UpdateAccountStripeCustomerIdMutationVariables, UpdateAccountStripeCustomerIdProps<TChildProps, TDataName>>(UpdateAccountStripeCustomerIdDocument, {
      alias: 'updateAccountStripeCustomerId',
      ...operationOptions
    });
};

/**
 * __useUpdateAccountStripeCustomerIdMutation__
 *
 * To run a mutation, you first call `useUpdateAccountStripeCustomerIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountStripeCustomerIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountStripeCustomerIdMutation, { data, loading, error }] = useUpdateAccountStripeCustomerIdMutation({
 *   variables: {
 *      stripe_customer_id: // value for 'stripe_customer_id'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAccountStripeCustomerIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccountStripeCustomerIdMutation, UpdateAccountStripeCustomerIdMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAccountStripeCustomerIdMutation, UpdateAccountStripeCustomerIdMutationVariables>(UpdateAccountStripeCustomerIdDocument, baseOptions);
      }
export type UpdateAccountStripeCustomerIdMutationHookResult = ReturnType<typeof useUpdateAccountStripeCustomerIdMutation>;
export type UpdateAccountStripeCustomerIdMutationResult = ApolloReactCommon.MutationResult<UpdateAccountStripeCustomerIdMutation>;
export type UpdateAccountStripeCustomerIdMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccountStripeCustomerIdMutation, UpdateAccountStripeCustomerIdMutationVariables>;
export const UpdateOrderStatusAndStripeIdDocument = gql`
    mutation UpdateOrderStatusAndStripeId($id: Int!, $status: order_status_enum, $stripe_payment_id: String) {
  update_orders_by_pk(
    pk_columns: {id: $id}
    _set: {status: $status, stripe_payment_id: $stripe_payment_id}
  ) {
    id
    account_id
    custom_line_price
    custom_line_title
    address {
      contact_email
      name
      account_id
    }
    shipping_option {
      name
      price
    }
    pif_donations {
      amount
    }
    wrapping
    order_books {
      book_isbn
      quantity
      price
      discount
      event_tickets {
        address {
          contact_email
          name
        }
        is_free_attendee
        is_online_viewer
        order_book_id
        event {
          title
          start_time
          location
          image
          slug
          is_book_club
          event_books {
            book {
              title
              author
              isbn
            }
          }
        }
      }
      book {
        title
        author
        stock
      }
    }
    order_products {
      price
      quantity
      discount
      product {
        title
      }
    }
    order_subscription_objects {
      id
      subscription_object {
        password
        short_id
        id
      }
      subscription_draft_object {
        id
        credits
        recipient
        subscription_id
        subscription_object {
          password
          short_id
          id
        }
        subscription {
          title
          price
        }
        message
      }
    }
    vouchers {
      id
      recipient
      initial_amount
      message
      event_tickets {
        address {
          contact_email
          name
        }
        voucher {
          id
          initial_amount
        }
        is_free_attendee
        is_online_viewer
        order_book_id
        event {
          is_book_club
          title
          start_time
          location
          image
          slug
          event_books {
            book {
              title
              author
              isbn
            }
          }
        }
      }
    }
    order_vouchers_for_discount {
      amount_discounted
      voucher {
        remaining_amount
      }
      voucher_id
    }
    event_tickets {
      id
      is_online_viewer
      is_free_attendee
      address {
        contact_email
        name
      }
      event {
        id
        title
        start_time
        image
        is_book_club
        slug
        event_books {
          book {
            isbn
            author
            title
          }
        }
      }
    }
  }
}
    `;
export type UpdateOrderStatusAndStripeIdMutationFn = ApolloReactCommon.MutationFunction<UpdateOrderStatusAndStripeIdMutation, UpdateOrderStatusAndStripeIdMutationVariables>;
export type UpdateOrderStatusAndStripeIdComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrderStatusAndStripeIdMutation, UpdateOrderStatusAndStripeIdMutationVariables>, 'mutation'>;

    export const UpdateOrderStatusAndStripeIdComponent = (props: UpdateOrderStatusAndStripeIdComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrderStatusAndStripeIdMutation, UpdateOrderStatusAndStripeIdMutationVariables> mutation={UpdateOrderStatusAndStripeIdDocument} {...props} />
    );
    
export type UpdateOrderStatusAndStripeIdProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrderStatusAndStripeIdMutation, UpdateOrderStatusAndStripeIdMutationVariables>
    } & TChildProps;
export function withUpdateOrderStatusAndStripeId<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrderStatusAndStripeIdMutation,
  UpdateOrderStatusAndStripeIdMutationVariables,
  UpdateOrderStatusAndStripeIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrderStatusAndStripeIdMutation, UpdateOrderStatusAndStripeIdMutationVariables, UpdateOrderStatusAndStripeIdProps<TChildProps, TDataName>>(UpdateOrderStatusAndStripeIdDocument, {
      alias: 'updateOrderStatusAndStripeId',
      ...operationOptions
    });
};

/**
 * __useUpdateOrderStatusAndStripeIdMutation__
 *
 * To run a mutation, you first call `useUpdateOrderStatusAndStripeIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderStatusAndStripeIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderStatusAndStripeIdMutation, { data, loading, error }] = useUpdateOrderStatusAndStripeIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      stripe_payment_id: // value for 'stripe_payment_id'
 *   },
 * });
 */
export function useUpdateOrderStatusAndStripeIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderStatusAndStripeIdMutation, UpdateOrderStatusAndStripeIdMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateOrderStatusAndStripeIdMutation, UpdateOrderStatusAndStripeIdMutationVariables>(UpdateOrderStatusAndStripeIdDocument, baseOptions);
      }
export type UpdateOrderStatusAndStripeIdMutationHookResult = ReturnType<typeof useUpdateOrderStatusAndStripeIdMutation>;
export type UpdateOrderStatusAndStripeIdMutationResult = ApolloReactCommon.MutationResult<UpdateOrderStatusAndStripeIdMutation>;
export type UpdateOrderStatusAndStripeIdMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrderStatusAndStripeIdMutation, UpdateOrderStatusAndStripeIdMutationVariables>;
export const UpdateStockDocument = gql`
    mutation UpdateStock($isbn: bigint!, $stockChange: Int) {
  update_books_by_pk(pk_columns: {isbn: $isbn}, _inc: {stock: $stockChange}) {
    isbn
  }
}
    `;
export type UpdateStockMutationFn = ApolloReactCommon.MutationFunction<UpdateStockMutation, UpdateStockMutationVariables>;
export type UpdateStockComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateStockMutation, UpdateStockMutationVariables>, 'mutation'>;

    export const UpdateStockComponent = (props: UpdateStockComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateStockMutation, UpdateStockMutationVariables> mutation={UpdateStockDocument} {...props} />
    );
    
export type UpdateStockProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateStockMutation, UpdateStockMutationVariables>
    } & TChildProps;
export function withUpdateStock<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateStockMutation,
  UpdateStockMutationVariables,
  UpdateStockProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateStockMutation, UpdateStockMutationVariables, UpdateStockProps<TChildProps, TDataName>>(UpdateStockDocument, {
      alias: 'updateStock',
      ...operationOptions
    });
};

/**
 * __useUpdateStockMutation__
 *
 * To run a mutation, you first call `useUpdateStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockMutation, { data, loading, error }] = useUpdateStockMutation({
 *   variables: {
 *      isbn: // value for 'isbn'
 *      stockChange: // value for 'stockChange'
 *   },
 * });
 */
export function useUpdateStockMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStockMutation, UpdateStockMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateStockMutation, UpdateStockMutationVariables>(UpdateStockDocument, baseOptions);
      }
export type UpdateStockMutationHookResult = ReturnType<typeof useUpdateStockMutation>;
export type UpdateStockMutationResult = ApolloReactCommon.MutationResult<UpdateStockMutation>;
export type UpdateStockMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateStockMutation, UpdateStockMutationVariables>;
export const InsertNewAddressDocument = gql`
    mutation InsertNewAddress($data: addresses_insert_input!) {
  insert_addresses_one(object: $data) {
    id
    name
    contact_email
  }
}
    `;
export type InsertNewAddressMutationFn = ApolloReactCommon.MutationFunction<InsertNewAddressMutation, InsertNewAddressMutationVariables>;
export type InsertNewAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertNewAddressMutation, InsertNewAddressMutationVariables>, 'mutation'>;

    export const InsertNewAddressComponent = (props: InsertNewAddressComponentProps) => (
      <ApolloReactComponents.Mutation<InsertNewAddressMutation, InsertNewAddressMutationVariables> mutation={InsertNewAddressDocument} {...props} />
    );
    
export type InsertNewAddressProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertNewAddressMutation, InsertNewAddressMutationVariables>
    } & TChildProps;
export function withInsertNewAddress<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertNewAddressMutation,
  InsertNewAddressMutationVariables,
  InsertNewAddressProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertNewAddressMutation, InsertNewAddressMutationVariables, InsertNewAddressProps<TChildProps, TDataName>>(InsertNewAddressDocument, {
      alias: 'insertNewAddress',
      ...operationOptions
    });
};

/**
 * __useInsertNewAddressMutation__
 *
 * To run a mutation, you first call `useInsertNewAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewAddressMutation, { data, loading, error }] = useInsertNewAddressMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInsertNewAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertNewAddressMutation, InsertNewAddressMutationVariables>) {
        return ApolloReactHooks.useMutation<InsertNewAddressMutation, InsertNewAddressMutationVariables>(InsertNewAddressDocument, baseOptions);
      }
export type InsertNewAddressMutationHookResult = ReturnType<typeof useInsertNewAddressMutation>;
export type InsertNewAddressMutationResult = ApolloReactCommon.MutationResult<InsertNewAddressMutation>;
export type InsertNewAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertNewAddressMutation, InsertNewAddressMutationVariables>;
export const CreateNewOrderDocument = gql`
    mutation CreateNewOrder($data: orders_insert_input!) {
  insert_orders_one(object: $data) {
    id
    pick_up
    wrapping
    custom_line_title
    shipping_option {
      id
      price
      name
      country
      region
    }
    order_books {
      book {
        isbn
        title
      }
      price
      discount
      quantity
      event_tickets {
        event {
          title
        }
      }
    }
    order_products {
      order_id
      product_id
      product {
        id
        title
      }
      price
      discount
      quantity
    }
    order_subscription_objects {
      id
      subscription_draft_object {
        id
        credits
        recipient
        message
        subscription {
          id
          price
          title
        }
      }
    }
    vouchers {
      initial_amount
      event_tickets {
        event {
          title
        }
      }
    }
    gift_wrap
    pif_donations {
      amount
    }
    order_vouchers_for_discount {
      amount_discounted
      voucher_id
    }
    address {
      id
      account {
        id
        stripe_customer_id
      }
    }
    order_books_aggregate {
      aggregate {
        count
      }
    }
    order_products_aggregate {
      aggregate {
        count
      }
    }
    order_subscription_objects_aggregate {
      aggregate {
        count
      }
    }
    discount {
      is_fixed_amount
      discount_value
      discounted_books {
        book_isbn
      }
    }
  }
}
    `;
export type CreateNewOrderMutationFn = ApolloReactCommon.MutationFunction<CreateNewOrderMutation, CreateNewOrderMutationVariables>;
export type CreateNewOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateNewOrderMutation, CreateNewOrderMutationVariables>, 'mutation'>;

    export const CreateNewOrderComponent = (props: CreateNewOrderComponentProps) => (
      <ApolloReactComponents.Mutation<CreateNewOrderMutation, CreateNewOrderMutationVariables> mutation={CreateNewOrderDocument} {...props} />
    );
    
export type CreateNewOrderProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateNewOrderMutation, CreateNewOrderMutationVariables>
    } & TChildProps;
export function withCreateNewOrder<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateNewOrderMutation,
  CreateNewOrderMutationVariables,
  CreateNewOrderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateNewOrderMutation, CreateNewOrderMutationVariables, CreateNewOrderProps<TChildProps, TDataName>>(CreateNewOrderDocument, {
      alias: 'createNewOrder',
      ...operationOptions
    });
};

/**
 * __useCreateNewOrderMutation__
 *
 * To run a mutation, you first call `useCreateNewOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewOrderMutation, { data, loading, error }] = useCreateNewOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNewOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNewOrderMutation, CreateNewOrderMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateNewOrderMutation, CreateNewOrderMutationVariables>(CreateNewOrderDocument, baseOptions);
      }
export type CreateNewOrderMutationHookResult = ReturnType<typeof useCreateNewOrderMutation>;
export type CreateNewOrderMutationResult = ApolloReactCommon.MutationResult<CreateNewOrderMutation>;
export type CreateNewOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNewOrderMutation, CreateNewOrderMutationVariables>;
export const ValidateAddressDocument = gql`
    query ValidateAddress($id: uuid!) {
  addresses_by_pk(id: $id) {
    id
    name
    contact_email
    account {
      id
      stripe_customer_id
    }
  }
}
    `;
export type ValidateAddressComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ValidateAddressQuery, ValidateAddressQueryVariables>, 'query'> & ({ variables: ValidateAddressQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ValidateAddressComponent = (props: ValidateAddressComponentProps) => (
      <ApolloReactComponents.Query<ValidateAddressQuery, ValidateAddressQueryVariables> query={ValidateAddressDocument} {...props} />
    );
    
export type ValidateAddressProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ValidateAddressQuery, ValidateAddressQueryVariables>
    } & TChildProps;
export function withValidateAddress<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ValidateAddressQuery,
  ValidateAddressQueryVariables,
  ValidateAddressProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ValidateAddressQuery, ValidateAddressQueryVariables, ValidateAddressProps<TChildProps, TDataName>>(ValidateAddressDocument, {
      alias: 'validateAddress',
      ...operationOptions
    });
};

/**
 * __useValidateAddressQuery__
 *
 * To run a query within a React component, call `useValidateAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidateAddressQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ValidateAddressQuery, ValidateAddressQueryVariables>) {
        return ApolloReactHooks.useQuery<ValidateAddressQuery, ValidateAddressQueryVariables>(ValidateAddressDocument, baseOptions);
      }
export function useValidateAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateAddressQuery, ValidateAddressQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ValidateAddressQuery, ValidateAddressQueryVariables>(ValidateAddressDocument, baseOptions);
        }
export type ValidateAddressQueryHookResult = ReturnType<typeof useValidateAddressQuery>;
export type ValidateAddressLazyQueryHookResult = ReturnType<typeof useValidateAddressLazyQuery>;
export type ValidateAddressQueryResult = ApolloReactCommon.QueryResult<ValidateAddressQuery, ValidateAddressQueryVariables>;
export const ValidateBasketDocument = gql`
    query ValidateBasket($isbns: [bigint!], $addressId: uuid!, $productIds: [uuid!], $eventIds: [uuid!], $shippingId: uuid!, $vouchers: [String!], $discountCodes: [String!], $subIds: [uuid!]) {
  products(where: {_and: [{id: {_in: $productIds}}, {is_deleted: {_eq: false}}]}) {
    id
    title
    price
    stock
    is_discounted
    discount_value
  }
  subscriptions(where: {id: {_in: $subIds}}) {
    id
    price
    is_active
  }
  books(where: {isbn: {_in: $isbns}}) {
    isbn
    title
    author
    price
    is_discounted
    discount_value
    stock
    is_unlisted
    track_stock
  }
  addresses_by_pk(id: $addressId) {
    id
    contact_email
  }
  shipping_options_by_pk(id: $shippingId) {
    id
    name
    price
    from
    to
    country
    region
  }
  events(where: {id: {_in: $eventIds}}) {
    id
    title
    seats
    free_seats
    price
    event_books(limit: 1) {
      book {
        isbn
        price
        is_discounted
        discount_value
        stock
      }
    }
    free_attendees: attendees_aggregate(where: {is_free_attendee: {_eq: true}}) {
      aggregate {
        count
      }
    }
    online_attendees: attendees_aggregate(where: {is_online_viewer: {_eq: true}}) {
      aggregate {
        count
      }
    }
    paid_attendees: attendees_aggregate(
      where: {_or: [{voucher_id: {_is_null: false}}, {order_book_id: {_is_null: false}}]}
    ) {
      aggregate {
        count
      }
    }
  }
  vouchers(where: {id: {_in: $vouchers}}) {
    id
    remaining_amount
  }
  discounts(where: {code: {_in: $discountCodes}}) {
    code
    is_active
    limit_uses
    discounted_books {
      book_isbn
    }
    orders_aggregate {
      aggregate {
        count
      }
    }
    is_fixed_amount
    discount_value
  }
}
    `;
export type ValidateBasketComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ValidateBasketQuery, ValidateBasketQueryVariables>, 'query'> & ({ variables: ValidateBasketQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ValidateBasketComponent = (props: ValidateBasketComponentProps) => (
      <ApolloReactComponents.Query<ValidateBasketQuery, ValidateBasketQueryVariables> query={ValidateBasketDocument} {...props} />
    );
    
export type ValidateBasketProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ValidateBasketQuery, ValidateBasketQueryVariables>
    } & TChildProps;
export function withValidateBasket<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ValidateBasketQuery,
  ValidateBasketQueryVariables,
  ValidateBasketProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ValidateBasketQuery, ValidateBasketQueryVariables, ValidateBasketProps<TChildProps, TDataName>>(ValidateBasketDocument, {
      alias: 'validateBasket',
      ...operationOptions
    });
};

/**
 * __useValidateBasketQuery__
 *
 * To run a query within a React component, call `useValidateBasketQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBasketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBasketQuery({
 *   variables: {
 *      isbns: // value for 'isbns'
 *      addressId: // value for 'addressId'
 *      productIds: // value for 'productIds'
 *      eventIds: // value for 'eventIds'
 *      shippingId: // value for 'shippingId'
 *      vouchers: // value for 'vouchers'
 *      discountCodes: // value for 'discountCodes'
 *      subIds: // value for 'subIds'
 *   },
 * });
 */
export function useValidateBasketQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ValidateBasketQuery, ValidateBasketQueryVariables>) {
        return ApolloReactHooks.useQuery<ValidateBasketQuery, ValidateBasketQueryVariables>(ValidateBasketDocument, baseOptions);
      }
export function useValidateBasketLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateBasketQuery, ValidateBasketQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ValidateBasketQuery, ValidateBasketQueryVariables>(ValidateBasketDocument, baseOptions);
        }
export type ValidateBasketQueryHookResult = ReturnType<typeof useValidateBasketQuery>;
export type ValidateBasketLazyQueryHookResult = ReturnType<typeof useValidateBasketLazyQuery>;
export type ValidateBasketQueryResult = ApolloReactCommon.QueryResult<ValidateBasketQuery, ValidateBasketQueryVariables>;
export const GetAllEventTicketsDocument = gql`
    query GetAllEventTickets($id: uuid!) {
  events_by_pk(id: $id) {
    title
    speakers
    image
    start_time
    end_time
    slug
    location
    event_books {
      book {
        title
        author
        isbn
      }
    }
    attendees {
      address {
        contact_email
        name
      }
      is_free_attendee
      is_online_viewer
      order_book_id
      voucher_id
    }
  }
}
    `;
export type GetAllEventTicketsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllEventTicketsQuery, GetAllEventTicketsQueryVariables>, 'query'> & ({ variables: GetAllEventTicketsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAllEventTicketsComponent = (props: GetAllEventTicketsComponentProps) => (
      <ApolloReactComponents.Query<GetAllEventTicketsQuery, GetAllEventTicketsQueryVariables> query={GetAllEventTicketsDocument} {...props} />
    );
    
export type GetAllEventTicketsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllEventTicketsQuery, GetAllEventTicketsQueryVariables>
    } & TChildProps;
export function withGetAllEventTickets<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllEventTicketsQuery,
  GetAllEventTicketsQueryVariables,
  GetAllEventTicketsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllEventTicketsQuery, GetAllEventTicketsQueryVariables, GetAllEventTicketsProps<TChildProps, TDataName>>(GetAllEventTicketsDocument, {
      alias: 'getAllEventTickets',
      ...operationOptions
    });
};

/**
 * __useGetAllEventTicketsQuery__
 *
 * To run a query within a React component, call `useGetAllEventTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEventTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEventTicketsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllEventTicketsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllEventTicketsQuery, GetAllEventTicketsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllEventTicketsQuery, GetAllEventTicketsQueryVariables>(GetAllEventTicketsDocument, baseOptions);
      }
export function useGetAllEventTicketsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllEventTicketsQuery, GetAllEventTicketsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllEventTicketsQuery, GetAllEventTicketsQueryVariables>(GetAllEventTicketsDocument, baseOptions);
        }
export type GetAllEventTicketsQueryHookResult = ReturnType<typeof useGetAllEventTicketsQuery>;
export type GetAllEventTicketsLazyQueryHookResult = ReturnType<typeof useGetAllEventTicketsLazyQuery>;
export type GetAllEventTicketsQueryResult = ApolloReactCommon.QueryResult<GetAllEventTicketsQuery, GetAllEventTicketsQueryVariables>;